import { ɵɵdefineComponent, ɵɵdirectiveInject, ElementRef, ɵɵallocHostVars, ɵɵattribute, ɵɵprojectionDef, ɵɵprojection, ɵsetClassMetadata, Component, ViewEncapsulation, ChangeDetectionStrategy, HostBinding, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵnamespaceSVG, ɵɵelementStart, ɵɵelement, ɵɵelementEnd, ɵɵtemplate, ɵɵnextContext, ɵɵselect, ɵɵproperty, ɵɵtext, ɵɵtextInterpolate, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadViewQuery, ViewChild, Input, ɵɵstyling, ɵɵclassMap, ɵɵstylingApply, ɵɵtextInterpolate1, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, EventEmitter, ChangeDetectorRef, ViewChildren, Output, ɵɵpropertyInterpolate, ɵɵdefineInjectable, Injectable, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵreference, TemplateRef, Renderer2, ViewContainerRef, ɵɵtemplateRefExtractor, ɵɵpipe, ɵɵstyleProp, ɵɵpureFunction2, ɵɵpipeBind1, PLATFORM_ID, ɵɵresolveWindow, Inject, HostListener, ɵɵinject, ComponentFactoryResolver, ApplicationRef, Injector, ɵɵdefineDirective, Directive, InjectionToken, SecurityContext, NgZone, ɵɵsanitizeHtml, ɵɵupdateSyntheticHostBinding, ɵɵnamespaceHTML, ɵɵpipeBind2, ɵɵtextInterpolate2, ɵɵpureFunction1, ɵɵsanitizeUrl, ɵɵpipeBind3, Optional, ɵɵelementHostAttrs, ɵɵNgOnChangesFeature, ɵɵstaticViewQuery, ɵɵclassProp, ɵɵcontentQuery, ɵɵloadContentQuery, ɵɵProvidersFeature, forwardRef, ContentChildren, ɵɵdefinePipe, Pipe, ɵɵresolveDocument, ContentChild, Self, ɵɵelementContainer, ɵɵsetComponentScope, CUSTOM_ELEMENTS_SCHEMA, ɵɵclassMapInterpolate1, ɵɵsanitizeResourceUrl, ɵɵpropertyInterpolate1 } from '@angular/core';
import { CommonModule, NgIf, NgForOf, NgSwitch, NgSwitchCase, NgClass, isPlatformBrowser, DOCUMENT, AsyncPipe, I18nPluralPipe, SlicePipe, DecimalPipe, NgStyle, TitleCasePipe, NgTemplateOutlet, UpperCasePipe, NgComponentOutlet, NgSwitchDefault, NgPlural, NgPluralCase, LowerCasePipe, JsonPipe, PercentPipe, CurrencyPipe, DatePipe, I18nSelectPipe, KeyValuePipe } from '@angular/common';
import { NgControl, FormControl, DefaultValueAccessor, NgControlStatus, FormControlDirective, NG_VALUE_ACCESSOR, NgModel, FormsModule, ReactiveFormsModule, Validators, FormBuilder, ɵangular_packages_forms_forms_z, NgControlStatusGroup, FormGroupDirective, FormControlName, NgSelectOption, ɵangular_packages_forms_forms_y, NumberValueAccessor, RangeValueAccessor, CheckboxControlValueAccessor, SelectControlValueAccessor, SelectMultipleControlValueAccessor, RadioControlValueAccessor, RequiredValidator, MinLengthValidator, MaxLengthValidator, PatternValidator, CheckboxRequiredValidator, EmailValidator, NgModelGroup, NgForm, NgFormSelectorWarning, FormGroupName, FormArrayName } from '@angular/forms';
import { PopoverDirective, PopoverConfig as PopoverConfig$1, PopoverModule } from 'ngx-bootstrap/popover';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { BehaviorSubject, Subject, Subscription, combineLatest, timer, EMPTY, of, throwError, fromEvent, ReplaySubject } from 'rxjs';
import { OverlayScrollbarsComponent, OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { trigger, state, style, transition, animate, query, stagger } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SkltnComponent, SkltnBoneDirective, NgxSkltnModule } from 'ngx-skltn';
import { filter, debounce, switchMap, tap, delay, finalize, takeUntil, map, debounceTime, catchError, share, distinctUntilChanged } from 'rxjs/operators';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Router, RouterLinkWithHref, RouterModule, RouterLinkActive } from '@angular/router';
import { SubSink } from 'subsink';
import { OverlayConfig, Overlay as Overlay$2, OverlayModule } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortalDirective, PortalModule } from '@angular/cdk/portal';
import OverlayScrollbars from 'overlayscrollbars';
import ___default, { merge } from 'lodash';
import { Constants } from 'ag-grid-community';
import 'ag-grid-enterprise';
import get from 'lodash/get';
import omit from 'lodash/omit';
import { isNullOrUndefined } from 'util';
import { BsDaterangepickerInlineDirective, BsDatepickerDirective, BsDaterangepickerDirective, BsDatepickerModule, BsDatepickerContainerComponent, BsDatepickerInlineContainerComponent, BsDatepickerInlineDirective, BsDatepickerInputDirective, BsDaterangepickerContainerComponent, BsDaterangepickerInlineContainerComponent, BsDaterangepickerInputDirective } from 'ngx-bootstrap/datepicker';
import { positionElements } from 'ngx-bootstrap/positioning';
import debounce$1 from 'lodash/debounce';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import '@radiance-design-software/web-components/components/web-icon-button';
import { SortableComponent, SortableModule } from 'ngx-bootstrap/sortable';
import { ObservableStore } from '@codewithdan/observable-store';
import uniqueId from 'lodash/uniqueId';

const _c0 = ["lib-btn", ""];
const _c1 = ["*"];
const BUTTON_HOST_ATTRIBUTES = [
    "primary",
    "secondary",
    "tertiary",
    "white",
    "link",
    "small",
    "disabled"
];
class ButtonComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.isDisabled = null;
        for (const attr of BUTTON_HOST_ATTRIBUTES) {
            if (this._hasHostAttributes(attr)) {
                this._getHostElement().classList.add(`btn--${attr}`);
                // attribute 'link' to be used with <a> only (does not display on Safari when used on <button>)
                if (attr === "link" && elementRef.nativeElement.nodeName !== "A") {
                    console.warn("button with attribute 'link' can only be used with <a> in order to display properly on Safari.");
                    console.warn(elementRef.nativeElement);
                }
            }
        }
        elementRef.nativeElement.classList.add("btn");
    }
    get disabled() {
        return (!this.isDisabled) && (this.isDisabled === "disabled");
    }
    /**
     * Setter for disabled input. This component can be based on <button> or <a>.
     * Since <a> does not have `disabled` property, we can't use direct host mapping.
     */
    set disabled(val) {
        if (val) {
            this.isDisabled = "disabled";
            this._getHostElement().classList.add(`btn--disabled`);
        }
        else {
            this.isDisabled = null; // this will remove the disabled attr
            this._getHostElement().classList.remove(`btn--disabled`);
        }
    }
    ngOnInit() { }
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
    _hasHostAttributes(...attributes) {
        return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
    }
}
/** @nocollapse */ ButtonComponent.ngComponentDef = ɵɵdefineComponent({ type: ButtonComponent, selectors: [["button", "lib-btn", ""], ["a", "lib-btn", ""]], factory: function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(ɵɵdirectiveInject(ElementRef)); }, hostBindings: function ButtonComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(1);
    } if (rf & 2) {
        ɵɵattribute("disabled", ctx.isDisabled);
    } }, inputs: { disabled: "disabled", size: "size" }, exportAs: ["libButton"], attrs: _c0, ngContentSelectors: _c1, consts: 1, vars: 0, template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵprojection(0);
    } }, styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.btn{background-color:#f0eff0;border:0;border-radius:50px;cursor:pointer;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;padding:8px 24px;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn:focus{box-shadow:none;outline:#7e8bf3 solid 4px}.btn:disabled{cursor:not-allowed;opacity:.4}.btn--secondary{background:0 0;color:#4e60ee;border:1px solid #4e60ee}.btn--secondary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);border-color:transparent;color:#fff}.btn--secondary:hover:disabled{color:#4e60ee}.btn--secondary:active:not(:disabled){background:#4e60ee;border-color:transparent;color:#fff}.btn--secondary.btn--small{font-size:14px;padding:5px 19px}.btn--secondary.btn--disabled{opacity:.4}.btn--disabled{cursor:not-allowed}.btn--primary{background:linear-gradient(8.68deg,#225de6 -4.27%,#a664fd 116.09%);color:#fff}.btn--primary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn--primary:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn--primary.btn--small{padding:5px 19px}.btn--primary.btn--disabled{opacity:.4}.btn--white{background:#fff;padding:7px 24px}.btn--white.btn--small{padding:5px 19px}.btn--white.btn--disabled{opacity:.4}.btn--tertiary{background:0 0;border:1px solid transparent;color:#4e60ee}.btn--tertiary:hover:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee}.btn--tertiary:active:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee;box-shadow:inset 0 0 0 1px #4e60ee}.btn--tertiary:focus:not(:disabled){border-color:#4e60ee}.btn--tertiary.btn--small{font-size:14px}.btn--tertiary.btn--disabled{opacity:.4}.btn--link,.btn--link:not([href]){background:0 0;color:#4e60ee!important}.btn--link:hover:not(:disabled),.btn--link:not([href]):hover:not(:disabled){background:0 0;color:#4e60ee;text-decoration:underline}.btn--link:active,.btn--link:not([href]):active{background:0 0}.btn--link.btn--small,.btn--link:not([href]).btn--small{font-size:14px}.btn--link.btn--disabled,.btn--link:not([href]).btn--disabled{opacity:.4}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: `button[lib-btn], a[lib-btn]`,
                templateUrl: "./button.component.html",
                styleUrls: ["./button.component.scss"],
                // tslint:disable-next-line: no-inputs-metadata-property
                inputs: ["disabled", "size"],
                exportAs: "libButton",
                // tslint:disable-next-line: no-host-metadata-property
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ElementRef }]; }, { isDisabled: [{
            type: HostBinding,
            args: ["attr.disabled"]
        }] });

class ButtonModule {
}
/** @nocollapse */ ButtonModule.ngModuleDef = ɵɵdefineNgModule({ type: ButtonModule });
/** @nocollapse */ ButtonModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ButtonModule_Factory(t) { return new (t || ButtonModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ButtonModule, { declarations: [ButtonComponent], imports: [CommonModule], exports: [ButtonComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ButtonComponent],
                exports: [ButtonComponent]
            }]
    }], null, null);

const _c0$1 = ["svgElement"];
const _c1$1 = ["lib-icon-btn", ""];
const _c2 = ["xmlns", "http://www.w3.org/2000/svg", "class", "btn--action__icon", 4, "ngIf"];
const _c3 = ["class", "btn--icon__badge", 4, "ngIf"];
const _c4 = ["xmlns", "http://www.w3.org/2000/svg", 1, "btn--action__icon"];
const _c5 = ["svgElement", ""];
const _c6 = ["id", "launch-gradient", "gradientUnits", "userSpaceOnUse", "x1", "5.4", "y1", "24.6", "x2", "24.2", "y2", "5.8"];
const _c7 = ["offset", "0", 2, "stop-color", "#4A7CFF"];
const _c8 = ["offset", "1", 2, "stop-color", "#743FFF"];
const _c9 = [4, "ngIf"];
const _c10 = ["fill", "url(#launch-gradient)", 4, "ngIf"];
const _c11 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M14.0948 3.5187C14.2901 3.32344 14.6067 3.32344 14.8019 3.5187L19.712 8.42883C19.9073 8.62409 19.9073 8.94068 19.712 9.13594C19.5168 9.3312 19.2002 9.3312 19.0049 9.13594L14.0948 4.22581C13.8995 4.03054 13.8995 3.71396 14.0948 3.5187Z", "fill", "#4E60EE"];
const _c12 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.88174 5.98386C7.00196 3.86364 10.1264 3.36361 12.7203 4.48102C12.9739 4.59028 13.0909 4.88444 12.9817 5.13805C12.8724 5.39166 12.5783 5.50868 12.3246 5.39943C10.0943 4.4386 7.40979 4.87002 5.58884 6.69097C5.3116 6.96822 5.0696 7.26856 4.85707 7.58559L7.4058 10.1343C7.60106 10.3296 7.60106 10.6462 7.4058 10.8414C7.21053 11.0367 6.89395 11.0367 6.69869 10.8414L3.86802 8.01074C3.70673 7.84946 3.67504 7.59947 3.79097 7.40305C4.08659 6.90218 4.44428 6.42132 4.88174 5.98386Z", "fill", "#4E60EE"];
const _c13 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M18.0962 10.2272C18.349 10.1161 18.644 10.2309 18.7552 10.4837C19.9004 13.0877 19.3997 16.2355 17.2672 18.368C16.8297 18.8055 16.3489 19.1631 15.8471 19.4598C15.6507 19.5759 15.4005 19.5443 15.2391 19.3829L12.3963 16.5402C12.2011 16.3449 12.2011 16.0283 12.3963 15.8331C12.5916 15.6378 12.9082 15.6378 13.1034 15.8331L15.6641 18.3937C15.982 18.1805 16.2827 17.9383 16.5601 17.6609C18.3929 15.828 18.8237 13.1234 17.8398 10.8862C17.7287 10.6334 17.8435 10.3384 18.0962 10.2272Z", "fill", "#4E60EE"];
const _c14 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M21.3544 1.89719C21.4546 1.99788 21.5072 2.13645 21.4992 2.27828C21.1739 8.00764 18.4674 11.9158 15.8508 14.3824C14.5441 15.6142 13.2581 16.4886 12.2976 17.0558C11.817 17.3397 11.4169 17.5472 11.1348 17.6846C10.9938 17.7533 10.8822 17.8045 10.8047 17.839C10.766 17.8563 10.7358 17.8693 10.7147 17.8783L10.69 17.8888L10.6829 17.8917L10.6807 17.8926L10.68 17.8929C10.6797 17.8931 10.6794 17.8932 10.4902 17.4303L10.6794 17.8932C10.493 17.9694 10.2791 17.9263 10.1367 17.7839L5.46604 13.1133C5.32439 12.9716 5.28096 12.7591 5.35567 12.5733L5.81959 12.7597C5.35567 12.5733 5.35577 12.573 5.35589 12.5727L5.3562 12.5719L5.3571 12.5697L5.36002 12.5626L5.37035 12.5377C5.37924 12.5165 5.39218 12.4862 5.40925 12.4473C5.44339 12.3694 5.49411 12.2573 5.5622 12.1156C5.69834 11.8322 5.90415 11.4302 6.18608 10.9475C6.74952 9.98298 7.61948 8.69207 8.84857 7.38186C11.3099 4.75801 15.2193 2.05107 20.9739 1.75062C21.1158 1.74321 21.2541 1.79651 21.3544 1.89719ZM6.41594 12.649L10.5995 16.8325C10.6298 16.818 10.6623 16.8024 10.6969 16.7856C10.9575 16.6586 11.3339 16.4636 11.7891 16.1948C12.7004 15.6567 13.9233 14.8252 15.1649 13.6547C17.5576 11.3991 20.0139 7.89252 20.4601 2.78742C15.3331 3.21189 11.8272 5.66827 9.57789 8.06602C8.41073 9.31022 7.58388 10.5372 7.04956 11.4519C6.78261 11.9089 6.58931 12.2869 6.46356 12.5486C6.44643 12.5843 6.43057 12.6177 6.41594 12.649Z", "fill", "#4E60EE"];
const _c15 = ["d", "M6.9846 19.6865C6.03984 20.6312 2.24988 21.0002 2.24988 21.0002C2.24988 21.0002 2.61883 17.2102 3.5636 16.2655C4.50837 15.3207 6.03984 15.3207 6.9846 16.2655C7.92937 17.2102 7.92937 18.7417 6.9846 19.6865Z", "fill", "#4E60EE"];
const _c16 = ["d", "M13.1371 11.3226C13.8052 11.3226 14.3467 10.781 14.3467 10.1129C14.3467 9.44486 13.8052 8.90326 13.1371 8.90326C12.469 8.90326 11.9274 9.44486 11.9274 10.1129C11.9274 10.781 12.469 11.3226 13.1371 11.3226Z", "fill", "#4E60EE"];
function IconButtonComponent__svg_svg_0__svg_g_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g");
    ɵɵelement(1, "path", _c11);
    ɵɵelement(2, "path", _c12);
    ɵɵelement(3, "path", _c13);
    ɵɵelement(4, "path", _c14);
    ɵɵelement(5, "path", _c15);
    ɵɵelement(6, "path", _c16);
    ɵɵelementEnd();
} }
const _c17 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M13.8461 1.5C14.1223 1.5 14.3461 1.72386 14.3461 2V8.16667H20C20.2761 8.16667 20.5 8.39052 20.5 8.66667C20.5 8.94281 20.2761 9.16667 20 9.16667H13.8461C13.57 9.16667 13.3461 8.94281 13.3461 8.66667V2C13.3461 1.72386 13.57 1.5 13.8461 1.5Z", "fill", "#4E60EE"];
const _c18 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M3.5 2C3.5 1.72386 3.72386 1.5 4 1.5H13.8462C13.9857 1.5 14.1189 1.55832 14.2136 1.66086L20.3674 8.32753C20.4527 8.41989 20.5 8.54097 20.5 8.66667V22C20.5 22.2761 20.2761 22.5 20 22.5H4C3.72386 22.5 3.5 22.2761 3.5 22V2ZM4.5 2.5V21.5H19.5V8.86216L13.6272 2.5H4.5Z", "fill", "#4E60EE"];
function IconButtonComponent__svg_svg_0__svg_g_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g");
    ɵɵelement(1, "path", _c17);
    ɵɵelement(2, "path", _c18);
    ɵɵelementEnd();
} }
const _c19 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M18.2306 1.5C18.5067 1.5 18.7306 1.72386 18.7306 2H18.2306H17.7306C17.7306 1.72386 17.9544 1.5 18.2306 1.5ZM15.5791 12C17.587 13.763 18.7306 17.0993 18.7306 20.6667V21.9996C18.7306 22.2757 18.5067 22.5 18.2306 22.5C17.9544 22.5 17.7306 22.2761 17.7306 22V20.6667C17.7306 16.9531 16.4303 13.7573 14.4846 12.4112C14.3496 12.3178 14.269 12.1641 14.269 12C14.269 11.8359 14.3496 11.6822 14.4846 11.5888C16.4303 10.2427 17.7306 7.04687 17.7306 3.33333V2H18.2306H18.7306V3.33333C18.7306 6.90067 17.587 10.237 15.5791 12Z", "fill", "#4E60EE"];
const _c20 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M5.76904 1.5C6.04519 1.5 6.26904 1.72386 6.26904 2H5.76904H5.26904C5.26904 1.72386 5.4929 1.5 5.76904 1.5ZM8.42054 12C6.41266 10.237 5.26904 6.90067 5.26904 3.33333V2H5.76904H6.26904V3.33333C6.26904 7.04687 7.56928 10.2427 9.51506 11.5888C9.65003 11.6822 9.73058 11.8359 9.73058 12C9.73058 12.1641 9.65003 12.3178 9.51506 12.4112C7.56928 13.7573 6.26904 16.9531 6.26904 20.6667V21.9996C6.26904 22.2757 6.04519 22.5 5.76904 22.5C5.4929 22.5 5.26904 22.2761 5.26904 22V20.6667C5.26904 17.0993 6.41266 13.763 8.42054 12Z", "fill", "#4E60EE"];
const _c21 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2.5 2C2.5 1.72386 2.72386 1.5 3 1.5H21C21.2761 1.5 21.5 1.72386 21.5 2C21.5 2.27614 21.2761 2.5 21 2.5H3C2.72386 2.5 2.5 2.27614 2.5 2Z", "fill", "#4E60EE"];
const _c22 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2.5 21.9999C2.5 21.7238 2.72386 21.4999 3 21.4999H21C21.2761 21.4999 21.5 21.7238 21.5 21.9999C21.5 22.2761 21.2761 22.4999 21 22.4999H3C2.72386 22.4999 2.5 22.2761 2.5 21.9999Z", "fill", "#4E60EE"];
function IconButtonComponent__svg_svg_0__svg_g_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g");
    ɵɵelement(1, "path", _c19);
    ɵɵelement(2, "path", _c20);
    ɵɵelement(3, "path", _c21);
    ɵɵelement(4, "path", _c22);
    ɵɵelementEnd();
} }
const _c23 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2 4.5C2 4.22386 2.22386 4 2.5 4H5.5C5.77614 4 6 4.22386 6 4.5C6 4.77614 5.77614 5 5.5 5H3V20H21V14.5C21 14.2239 21.2239 14 21.5 14C21.7761 14 22 14.2239 22 14.5V20.5C22 20.7761 21.7761 21 21.5 21H2.5C2.22386 21 2 20.7761 2 20.5V4.5Z", "fill", "#4E60EE"];
const _c24 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M15.2934 0.0446916C15.472 -0.0363767 15.6816 -0.0054713 15.8293 0.12372L23.8293 7.12372C23.9378 7.21866 24 7.35583 24 7.50001C24 7.64419 23.9378 7.78135 23.8293 7.8763L15.8293 14.8763C15.6816 15.0055 15.472 15.0364 15.2934 14.9553C15.1147 14.8743 15 14.6962 15 14.5V11.0047C12.6742 11.0495 11.1235 11.4114 9.9519 12.0081C8.70215 12.6445 7.83224 13.5734 6.89808 14.8025C6.76821 14.9734 6.54377 15.0424 6.34038 14.9738C6.13698 14.9053 6 14.7146 6 14.5C6 10.3834 6.96479 7.7184 8.70956 6.09631C10.338 4.58233 12.553 4.06542 15 4.00596V0.500008C15 0.30382 15.1147 0.12576 15.2934 0.0446916ZM16 1.60189V4.50001C16 4.77615 15.7761 5.00001 15.5 5.00001C12.9445 5.00001 10.8517 5.47017 9.39044 6.8287C8.12194 8.00801 7.24857 9.93355 7.04532 13.0466C7.74086 12.2771 8.51045 11.6199 9.4981 11.117C10.9445 10.3804 12.8068 10 15.5 10C15.7761 10 16 10.2239 16 10.5V13.3981L22.7407 7.50001L16 1.60189Z", "fill", "#4E60EE"];
function IconButtonComponent__svg_svg_0__svg_g_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g");
    ɵɵelement(1, "path", _c23);
    ɵɵelement(2, "path", _c24);
    ɵɵelementEnd();
} }
const _c25 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4 7.5C4.27614 7.5 4.5 7.72386 4.5 8V18.8889C4.5 20.4067 5.53901 21.5 6.66667 21.5H17.3333C18.461 21.5 19.5 20.4067 19.5 18.8889V8C19.5 7.72386 19.7239 7.5 20 7.5C20.2761 7.5 20.5 7.72386 20.5 8V18.8889C20.5 20.8088 19.1523 22.5 17.3333 22.5H6.66667C4.84766 22.5 3.5 20.8088 3.5 18.8889V8C3.5 7.72386 3.72386 7.5 4 7.5Z", "fill", "#4E60EE"];
const _c26 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12 9.5C12.2761 9.5 12.5 9.72386 12.5 10V18C12.5 18.2761 12.2761 18.5 12 18.5C11.7238 18.5 11.5 18.2761 11.5 18V10C11.5 9.72386 11.7238 9.5 12 9.5Z", "fill", "#4E60EE"];
const _c27 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M16 9.5C16.2762 9.5 16.5 9.72386 16.5 10V18C16.5 18.2761 16.2762 18.5 16 18.5C15.7239 18.5 15.5 18.2761 15.5 18V10C15.5 9.72386 15.7239 9.5 16 9.5Z", "fill", "#4E60EE"];
const _c28 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M7.99991 9.5C8.27605 9.5 8.49991 9.72386 8.49991 10V18C8.49991 18.2761 8.27605 18.5 7.99991 18.5C7.72377 18.5 7.49991 18.2761 7.49991 18V10C7.49991 9.72386 7.72377 9.5 7.99991 9.5Z", "fill", "#4E60EE"];
const _c29 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2.5 5C2.5 4.72386 2.72386 4.5 3 4.5H21C21.2761 4.5 21.5 4.72386 21.5 5C21.5 5.27614 21.2761 5.5 21 5.5H3C2.72386 5.5 2.5 5.27614 2.5 5Z", "fill", "#4E60EE"];
const _c30 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M8.92853 2C8.92853 1.72386 9.15239 1.5 9.42853 1.5H14.5714C14.8475 1.5 15.0714 1.72386 15.0714 2V5C15.0714 5.27614 14.8475 5.5 14.5714 5.5C14.2952 5.5 14.0714 5.27614 14.0714 5V2.5H9.92853V5C9.92853 5.27614 9.70467 5.5 9.42853 5.5C9.15239 5.5 8.92853 5.27614 8.92853 5V2Z", "fill", "#4E60EE"];
function IconButtonComponent__svg_svg_0__svg_g_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g");
    ɵɵelement(1, "path", _c25);
    ɵɵelement(2, "path", _c26);
    ɵɵelement(3, "path", _c27);
    ɵɵelement(4, "path", _c28);
    ɵɵelement(5, "path", _c29);
    ɵɵelement(6, "path", _c30);
    ɵɵelementEnd();
} }
const _c31 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12 2.79974C6.77612 2.79974 2.5 7.07586 2.5 12.2997C2.5 12.5758 2.27614 12.7997 2 12.7997C1.72386 12.7997 1.5 12.5758 1.5 12.2997C1.5 6.52358 6.22384 1.79974 12 1.79974C16.0912 1.79974 19.6661 4.10896 21.3498 7.58158C21.4703 7.83006 21.3665 8.12915 21.118 8.24962C20.8696 8.3701 20.5705 8.26633 20.45 8.01785C18.9337 4.8905 15.7086 2.79974 12 2.79974Z", "fill", "#4E60EE"];
const _c32 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M21.9999 11.7997C22.276 11.7997 22.4999 12.0236 22.4999 12.2997C22.4999 18.0759 17.776 22.7997 11.9999 22.7997C7.90863 22.7997 4.33375 20.4905 2.65006 17.0179C2.52959 16.7694 2.63335 16.4703 2.88183 16.3498C3.13031 16.2293 3.4294 16.3331 3.54987 16.5816C5.06617 19.7089 8.29126 21.7997 11.9999 21.7997C17.2238 21.7997 21.4999 17.5236 21.4999 12.2997C21.4999 12.0236 21.7237 11.7997 21.9999 11.7997Z", "fill", "#4E60EE"];
const _c33 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M21.8671 1.50453C22.1407 1.54164 22.3325 1.79354 22.2954 2.06718L21.4954 7.96715C21.4583 8.24036 21.2071 8.43202 20.9338 8.39558L14.9339 7.59559C14.6601 7.55909 14.4678 7.30761 14.5043 7.03389C14.5408 6.76017 14.7923 6.56786 15.066 6.60436L20.5715 7.33842L21.3044 1.93282C21.3415 1.65918 21.5934 1.46743 21.8671 1.50453Z", "fill", "#4E60EE"];
const _c34 = ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2.50478 16.6329C2.54183 16.3597 2.79304 16.1681 3.06633 16.2045L9.0663 17.0045C9.34002 17.041 9.53233 17.2925 9.49583 17.5662C9.45934 17.8399 9.20786 18.0322 8.93414 17.9957L3.42868 17.2617L2.69572 22.6673C2.65862 22.9409 2.40671 23.1327 2.13307 23.0956C1.85943 23.0585 1.66768 22.8066 1.70479 22.5329L2.50478 16.6329Z", "fill", "#4E60EE"];
function IconButtonComponent__svg_svg_0__svg_g_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g");
    ɵɵelement(1, "path", _c31);
    ɵɵelement(2, "path", _c32);
    ɵɵelement(3, "path", _c33);
    ɵɵelement(4, "path", _c34);
    ɵɵelementEnd();
} }
const _c35 = ["fill", "url(#launch-gradient)"];
const _c36 = ["d", "M12.1,20.3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2l2.1-2.1l2.1,2.1c0.1,0.1,0.3,0.2,0.5,0.2\n      c0.2,0,0.3-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-0.9L16,17.4l2.1-2.1c0.3-0.3,0.3-0.7,0-0.9c-0.3-0.2-0.7-0.3-0.9,0L15,16.6l-2.1-2.1\n      c-0.3-0.3-0.7-0.3-0.9,0c-0.2,0.3-0.3,0.7,0,0.9l2.1,2.1l-2.1,2.1C11.8,19.8,11.8,20.1,12.1,20.3z"];
const _c37 = ["d", "M21.8,10.6c-0.3,0-0.6,0.3-0.6,0.6v11.2c0,0.7-0.5,1.3-1.3,1.3H10c-0.7,0-1.3-0.5-1.3-1.3V11.2\n      c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.7,0.3-0.7,0.6v11.2c0,1.4,1.1,2.5,2.5,2.5h10c1.4,0,2.5-1.1,2.5-2.5V11.2\n      C22.4,10.9,22.2,10.6,21.8,10.6z"];
const _c38 = ["d", "M23.7,8.1h-5V5.6c0-0.3-0.3-0.6-0.6-0.6h-6.2c-0.3,0-0.6,0.3-0.6,0.6v2.5h-5C6,8.1,5.7,8.4,5.7,8.7\n      S6,9.3,6.3,9.3h17.4c0.3,0,0.6-0.3,0.6-0.6S24,8.1,23.7,8.1z M12.5,6.3h5v1.9h-5C12.5,8.1,12.5,6.3,12.5,6.3z"];
function IconButtonComponent__svg_svg_0__svg_g_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "g", _c35);
    ɵɵelement(1, "path", _c36);
    ɵɵelement(2, "path", _c37);
    ɵɵelement(3, "path", _c38);
    ɵɵelementEnd();
} }
function IconButtonComponent__svg_svg_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c4, _c5);
    ɵɵelementStart(2, "linearGradient", _c6);
    ɵɵelement(3, "stop", _c7);
    ɵɵelement(4, "stop", _c8);
    ɵɵelementEnd();
    ɵɵtemplate(5, IconButtonComponent__svg_svg_0__svg_g_5_Template, 7, 0, "g", _c9);
    ɵɵtemplate(6, IconButtonComponent__svg_svg_0__svg_g_6_Template, 3, 0, "g", _c9);
    ɵɵtemplate(7, IconButtonComponent__svg_svg_0__svg_g_7_Template, 5, 0, "g", _c9);
    ɵɵtemplate(8, IconButtonComponent__svg_svg_0__svg_g_8_Template, 3, 0, "g", _c9);
    ɵɵtemplate(9, IconButtonComponent__svg_svg_0__svg_g_9_Template, 7, 0, "g", _c9);
    ɵɵtemplate(10, IconButtonComponent__svg_svg_0__svg_g_10_Template, 5, 0, "g", _c9);
    ɵɵtemplate(11, IconButtonComponent__svg_svg_0__svg_g_11_Template, 4, 0, "g", _c10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r258 = ɵɵnextContext();
    ɵɵselect(5);
    ɵɵproperty("ngIf", ctx_r258.type === "launch");
    ɵɵselect(6);
    ɵɵproperty("ngIf", ctx_r258.type === "file");
    ɵɵselect(7);
    ɵɵproperty("ngIf", ctx_r258.type === "status");
    ɵɵselect(8);
    ɵɵproperty("ngIf", ctx_r258.type === "share");
    ɵɵselect(9);
    ɵɵproperty("ngIf", ctx_r258.type === "bin");
    ɵɵselect(10);
    ɵɵproperty("ngIf", ctx_r258.type === "refresh");
    ɵɵselect(11);
    ɵɵproperty("ngIf", ctx_r258.type === "delete-forever");
} }
const _c39 = [1, "btn--icon__badge"];
function IconButtonComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c39);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r259 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r259.badge);
} }
const _c40 = ["*"];
const BUTTON_HOST_ATTRIBUTES$1 = ["action", "icon", "disabled"];
class IconButtonComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.type = "";
        this.iconType = "";
        this.badge = "";
        this.isActionButton = this._hasHostAttributes("type");
        for (const attr of BUTTON_HOST_ATTRIBUTES$1) {
            if (this._hasHostAttributes(attr)) {
                this._getHostElement().classList.add(`btn--${attr}`);
            }
        }
        // if (this.isActionButton) {
        //   elementRef.nativeElement.classList.add("btn");
        // }
    }
    ngOnInit() {
        if (!this.isActionButton) {
            this.elementRef.nativeElement.classList.add(`btn--icon--${this.iconType}`);
        }
    }
    ngAfterViewInit() {
        // Change the viewbox settings since this is an older icon and not radiance
        if (this.type === 'delete-forever') {
            this.svgElement.nativeElement.setAttribute('viewBox', '0 0 30 30');
        }
        else if (this.type !== '') {
            this.svgElement.nativeElement.setAttribute('viewBox', '0 0 24 24');
        }
    }
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
    _hasHostAttributes(...attributes) {
        return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
    }
}
/** @nocollapse */ IconButtonComponent.ngComponentDef = ɵɵdefineComponent({ type: IconButtonComponent, selectors: [["button", "lib-icon-btn", ""], ["a", "lib-icon-btn", ""]], factory: function IconButtonComponent_Factory(t) { return new (t || IconButtonComponent)(ɵɵdirectiveInject(ElementRef)); }, viewQuery: function IconButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.svgElement = _t.first);
    } }, hostBindings: function IconButtonComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(1);
    } if (rf & 2) {
        ɵɵattribute("disabled", ctx.disabled);
    } }, inputs: { disabled: "disabled", type: "type", iconType: "iconType", badge: "badge" }, exportAs: ["libIconButton"], attrs: _c1$1, ngContentSelectors: _c40, consts: 3, vars: 2, template: function IconButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, IconButtonComponent__svg_svg_0_Template, 12, 7, "svg", _c2);
        ɵɵprojection(1);
        ɵɵtemplate(2, IconButtonComponent_span_2_Template, 2, 1, "span", _c3);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.type !== "");
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.badge);
    } }, directives: [NgIf], styles: [".btn--action{box-sizing:border-box;position:relative;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;cursor:pointer;border-radius:50px;height:36px;width:36px;background:0 0;border:1px solid transparent;opacity:1;box-shadow:none;padding:0}.btn--action:hover{border-color:#4e60ee}.btn--action:focus:not(:active){border-color:#4e60ee;outline:#7e8bf3 solid 4px}.btn--action:active{border-color:#4e60ee;border-width:2px;box-shadow:none;outline:0}.btn--action[disabled]{pointer-events:none;opacity:.65;cursor:not-allowed;border-color:transparent}.btn--action__icon{height:24px;pointer-events:none;position:relative;width:24px;z-index:20}.btn--icon{-webkit-box-align:center;align-items:center;background:0 0;border:0;cursor:pointer;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;margin:0;min-width:40px;outline:0;padding:0;text-align:center;overflow:visible;position:relative}.btn--icon--search-glass{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/radiance/search.svg);background-repeat:no-repeat;background-position:center;background-size:60%}.btn--icon--hamburger-menu{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/bars-light.svg);background-repeat:no-repeat;background-position:center}.btn--icon--kebab-white{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/more-kebab-white.svg);background-repeat:no-repeat;background-position:center;background-size:40px}.btn--icon--notification-bell{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/radiance/notification-bell.svg);background-repeat:no-repeat;background-position:center;background-size:60%}.btn--icon--help-circle{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/radiance/question-circle.svg);background-repeat:no-repeat;background-position:center;background-size:60%}.btn--icon--trash{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/radiance/trash.svg);background-repeat:no-repeat;background-position:center;background-size:60%}.btn--icon--waffle{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/radiance/waffle-menu.svg);background-repeat:no-repeat;background-position:center}.btn--icon--user{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/radiance/profile.svg);background-repeat:no-repeat;background-position:center}.btn--icon--close-small{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/close-small.svg);background-repeat:no-repeat;background-position:center}.btn--icon--more{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/more.svg);background-repeat:no-repeat;background-position:center}.btn--icon--ellipsis{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/ellipsis.svg);background-repeat:no-repeat;background-position:center}.btn--icon--list{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/view-list.svg);background-repeat:no-repeat;background-position:center}.btn--icon--list--active{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/viewlist-gradient.svg);background-repeat:no-repeat;background-position:center}.btn--icon__badge{position:absolute;text-align:center;background:#e2bebe;border:1px solid #fff;left:20px;top:4px;height:17px;font-size:12px;line-height:16.8px;border-radius:100px;z-index:30;padding:0 5px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(IconButtonComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: `button[lib-icon-btn], a[lib-icon-btn]`,
                templateUrl: "./icon-button.component.html",
                styleUrls: ["./icon-button.component.scss"],
                // tslint:disable-next-line: no-inputs-metadata-property
                inputs: ["disabled", "type"],
                exportAs: "libIconButton",
                // tslint:disable-next-line: no-host-metadata-property
                host: {
                    "[attr.disabled]": "disabled"
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ElementRef }]; }, { svgElement: [{
            type: ViewChild,
            args: ["svgElement", { static: false }]
        }], type: [{
            type: Input
        }], iconType: [{
            type: Input
        }], badge: [{
            type: Input
        }] });

class IconButtonModule {
}
/** @nocollapse */ IconButtonModule.ngModuleDef = ɵɵdefineNgModule({ type: IconButtonModule });
/** @nocollapse */ IconButtonModule.ngInjectorDef = ɵɵdefineInjector({ factory: function IconButtonModule_Factory(t) { return new (t || IconButtonModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(IconButtonModule, { declarations: [IconButtonComponent], imports: [CommonModule], exports: [IconButtonComponent] });
/*@__PURE__*/ ɵsetClassMetadata(IconButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [IconButtonComponent],
                exports: [IconButtonComponent]
            }]
    }], null, null);

const _c0$2 = ["inputRef"];
const _c1$2 = [3, "class", 4, "ngIf"];
const _c2$1 = [3, "type", "checked", "disabled", "required", "name"];
const _c3$1 = ["inputRef", ""];
const _c4$1 = ["class", "required", 4, "ngIf"];
const _c5$1 = [1, "required"];
function RadioCheckboxComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c5$1);
    ɵɵtext(1, "*");
    ɵɵelementEnd();
} }
function RadioCheckboxComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵtemplate(2, RadioCheckboxComponent_label_1_span_2_Template, 2, 0, "span", _c4$1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r268 = ɵɵnextContext();
    ɵɵclassMap(ctx_r268.type + "__header-label");
    ɵɵstylingApply();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r268.headerLabel, "");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r268.required);
} }
function RadioCheckboxComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r270 = ɵɵnextContext();
    ɵɵclassMap(ctx_r270.type + "__validation-text");
    ɵɵstylingApply();
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r270.helper);
} }
const _c6$1 = ["*"];
class RadioCheckboxComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.type = "checkbox";
        this.checked = false;
        this.disabled = false;
        this.required = false;
        this.headerLabel = "";
        this.helper = null;
        this.name = null;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        const movedAttrs = [];
        const { attributes } = this.elementRef.nativeElement;
        for (const attr of attributes) {
            if (attr.name.indexOf("_ng") === 0 ||
                attr.name.indexOf("ng-") === 0 ||
                attr.name === "headerlabel" ||
                attr.name === "helper") {
                continue;
            }
            this.inputRef.nativeElement.setAttribute(attr.name, attr.value);
            movedAttrs.push(attr.name);
        }
        for (const attr of movedAttrs) {
            this.elementRef.nativeElement.removeAttribute(attr);
        }
    }
}
/** @nocollapse */ RadioCheckboxComponent.ngComponentDef = ɵɵdefineComponent({ type: RadioCheckboxComponent, selectors: [["lib-radio-checkbox"]], factory: function RadioCheckboxComponent_Factory(t) { return new (t || RadioCheckboxComponent)(ɵɵdirectiveInject(ElementRef)); }, viewQuery: function RadioCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.inputRef = _t.first);
    } }, inputs: { type: "type", checked: "checked", disabled: "disabled", required: "required", headerLabel: "headerLabel", helper: "helper", name: "name" }, exportAs: ["libRadioCheckbox"], ngContentSelectors: _c6$1, consts: 7, vars: 10, template: function RadioCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div");
        ɵɵstyling();
        ɵɵtemplate(1, RadioCheckboxComponent_label_1_Template, 3, 3, "label", _c1$2);
        ɵɵelementStart(2, "input", _c2$1, _c3$1);
        ɵɵstyling();
        ɵɵelementEnd();
        ɵɵelementStart(4, "label");
        ɵɵstyling();
        ɵɵprojection(5);
        ɵɵelementEnd();
        ɵɵtemplate(6, RadioCheckboxComponent_span_6_Template, 2, 2, "span", _c1$2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMap(ctx.type);
        ɵɵstylingApply();
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.headerLabel);
        ɵɵselect(2);
        ɵɵclassMap(ctx.type + "__input");
        ɵɵstylingApply();
        ɵɵproperty("type", ctx.type)("checked", ctx.checked)("disabled", ctx.disabled)("required", ctx.required)("name", ctx.name);
        ɵɵselect(4);
        ɵɵclassMap(ctx.type + "__label");
        ɵɵstylingApply();
        ɵɵselect(6);
        ɵɵproperty("ngIf", ctx.helper);
    } }, directives: [NgIf], styles: [".ag-input-wrapper__label,.ag-selection-checkbox__label,.checkbox__label,.radio__label,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}.ag-input-wrapper__input:checked~.checkbox__label,.ag-input-wrapper__input:not([disabled]):hover~.checkbox__label,.ag-input-wrapper__input:not([disabled]):hover~.radio__label,.ag-input-wrapper__label--checked,.ag-input-wrapper__label:hover,.ag-selection-checkbox__input:checked~.checkbox__label,.ag-selection-checkbox__input:not([disabled]):hover~.checkbox__label,.ag-selection-checkbox__input:not([disabled]):hover~.radio__label,.ag-selection-checkbox__label--checked,.ag-selection-checkbox__label:hover,.checkbox__input:checked~.checkbox__label,.checkbox__input:not([disabled]):hover~.checkbox__label,.checkbox__input:not([disabled]):hover~.radio__label,.checkbox__label--checked,.checkbox__label:hover,.radio__input:checked~.checkbox__label,.radio__input:checked~.radio__label,.radio__input:hover+.radio__label,.radio__input:not([disabled]):hover~.checkbox__label,.radio__input:not([disabled]):hover~.radio__label,.radio__label--checked,.radio__label:hover{font-weight:500}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.ag-input-wrapper__label,.ag-selection-checkbox__label,.checkbox__label,.radio__label{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.ag-input-wrapper,.ag-selection-checkbox,.checkbox,.radio{cursor:pointer;display:block;line-height:1.43!important;overflow:visible!important;position:relative;white-space:normal}.ag-input-wrapper__label,.ag-selection-checkbox__label,.checkbox__label,.radio__label{color:#322d32;display:inline-block;min-width:1.4rem;min-height:1rem;text-indent:3.1rem;margin:0;position:relative}.ag-input-wrapper__label:hover,.ag-selection-checkbox__label:hover,.checkbox__label:hover,.radio__label:hover{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.ag-input-wrapper__label::after,.ag-input-wrapper__label::before,.ag-selection-checkbox__label::after,.ag-selection-checkbox__label::before,.checkbox__label::after,.checkbox__label::before,.radio__label::after,.radio__label::before{content:\"\";display:block;position:absolute;border-radius:.2rem}.ag-input-wrapper__label::before,.ag-selection-checkbox__label::before,.checkbox__label::before,.radio__label::before{background:#fff;height:1.2rem;left:.3rem;margin:.1rem;top:.3rem;width:1.2rem;z-index:1}.ag-input-wrapper__label::after,.ag-selection-checkbox__label::after,.checkbox__label::after,.radio__label::after{background-image:-webkit-gradient(linear,left top,left bottom,from(#d1cfd1),to(#928d91));background-image:linear-gradient(to bottom,#d1cfd1 0,#928d91 100%);height:1.4rem;left:0;margin:.3rem;top:0;width:1.4rem}.ag-input-wrapper__input,.ag-selection-checkbox__input,.checkbox__input,.radio__input{cursor:pointer;height:100%;left:0;opacity:0;margin:0;min-width:1rem;padding:0;position:absolute;top:0;width:100%;z-index:10}.ag-input-wrapper__input:not([disabled]):hover~.checkbox__label,.ag-input-wrapper__input:not([disabled]):hover~.radio__label,.ag-selection-checkbox__input:not([disabled]):hover~.checkbox__label,.ag-selection-checkbox__input:not([disabled]):hover~.radio__label,.checkbox__input:not([disabled]):hover~.checkbox__label,.checkbox__input:not([disabled]):hover~.radio__label,.radio__input:not([disabled]):hover~.checkbox__label,.radio__input:not([disabled]):hover~.radio__label{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.ag-input-wrapper__input[disabled],.ag-selection-checkbox__input[disabled],.checkbox__input[disabled],.radio__input[disabled]{cursor:not-allowed}.ag-input-wrapper__input[disabled]~.checkbox__label,.ag-input-wrapper__input[disabled]~.radio__label,.ag-selection-checkbox__input[disabled]~.checkbox__label,.ag-selection-checkbox__input[disabled]~.radio__label,.checkbox__input[disabled]~.checkbox__label,.checkbox__input[disabled]~.radio__label,.radio__input[disabled]~.checkbox__label,.radio__input[disabled]~.radio__label{color:#d1cfd1}.ag-input-wrapper__input[disabled]~.checkbox__label::after,.ag-input-wrapper__input[disabled]~.radio__label::after,.ag-selection-checkbox__input[disabled]~.checkbox__label::after,.ag-selection-checkbox__input[disabled]~.radio__label::after,.checkbox__input[disabled]~.checkbox__label::after,.checkbox__input[disabled]~.radio__label::after,.radio__input[disabled]~.checkbox__label::after,.radio__input[disabled]~.radio__label::after{opacity:.4}.ag-input-wrapper__input:checked~.checkbox__label::before,.ag-input-wrapper__label--checked::before,.ag-selection-checkbox__input:checked~.checkbox__label::before,.ag-selection-checkbox__label--checked::before,.checkbox__input:checked~.checkbox__label::before,.checkbox__label--checked::before,.radio__input:checked~.checkbox__label::before,.radio__label--checked::before{background:0;left:.6rem;top:.3rem;width:.6rem;height:1rem;border:solid #fff;border-width:0 2px 2px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ag-input-wrapper__input:checked~.checkbox__label::after,.ag-input-wrapper__label--checked::after,.ag-selection-checkbox__input:checked~.checkbox__label::after,.ag-selection-checkbox__label--checked::after,.checkbox__input:checked~.checkbox__label::after,.checkbox__label--checked::after,.radio__input:checked~.checkbox__label::after,.radio__label--checked::after{background-image:linear-gradient(45deg,#5487fd 0,#a664fd 121%)}.ag-input-wrapper__header-label,.ag-selection-checkbox__header-label,.checkbox__header-label,.radio__header-label{display:block;position:relative;margin-bottom:1.1rem;color:#322d32;font-weight:300;font-size:1.6rem;letter-spacing:.04rem;line-height:1.5}.ag-input-wrapper__header-label .required,.ag-selection-checkbox__header-label .required,.checkbox__header-label .required,.radio__header-label .required{color:#656066;font-size:1.9rem;font-weight:700;margin-left:.8rem;position:absolute;top:.1rem}.ag-input-wrapper__validation-text,.ag-selection-checkbox__validation-text,.checkbox__validation-text,.radio__validation-text{color:#bf4252;display:block;font-size:1.2rem;letter-spacing:.04rem;margin-top:.1rem;padding:0 3.2rem}.radio__input:checked~.radio__label::before,.radio__label--checked::before{background:#fff;left:.6rem;top:.6rem;width:.6rem;height:.6rem}.radio__input:checked~.radio__label::after,.radio__label--checked::after{background-image:linear-gradient(45deg,#5487fd 0,#a664fd 121%)}.radio__label:hover{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.radio__label::after,.radio__label::before{border-radius:.7rem}.radio__input:hover+.radio__label{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(RadioCheckboxComponent, [{
        type: Component,
        args: [{
                selector: "lib-radio-checkbox",
                templateUrl: "./radio-checkbox.component.html",
                styleUrls: ["./radio-checkbox.component.scss"],
                exportAs: "libRadioCheckbox",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: ElementRef }]; }, { type: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], headerLabel: [{
            type: Input
        }], helper: [{
            type: Input
        }], name: [{
            type: Input
        }], inputRef: [{
            type: ViewChild,
            args: ["inputRef", { static: false }]
        }] });

class RadioCheckboxModule {
}
/** @nocollapse */ RadioCheckboxModule.ngModuleDef = ɵɵdefineNgModule({ type: RadioCheckboxModule });
/** @nocollapse */ RadioCheckboxModule.ngInjectorDef = ɵɵdefineInjector({ factory: function RadioCheckboxModule_Factory(t) { return new (t || RadioCheckboxModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(RadioCheckboxModule, { declarations: [RadioCheckboxComponent], imports: [CommonModule], exports: [RadioCheckboxComponent] });
/*@__PURE__*/ ɵsetClassMetadata(RadioCheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [RadioCheckboxComponent],
                imports: [CommonModule],
                exports: [RadioCheckboxComponent]
            }]
    }], null, null);

const _c0$3 = [3, "class", 4, "ngIf"];
const _c1$3 = ["class", "form-check", 4, "ngFor", "ngForOf"];
const _c2$2 = ["class", "required", 4, "ngIf"];
const _c3$2 = [1, "required"];
function RadioCheckboxListComponent_label_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c3$2);
    ɵɵtext(1, "*");
    ɵɵelementEnd();
} }
function RadioCheckboxListComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵtemplate(2, RadioCheckboxListComponent_label_0_span_2_Template, 2, 0, "span", _c2$2);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r272 = ɵɵnextContext();
    ɵɵclassMap(ctx_r272.type + "__header-label");
    ɵɵstylingApply();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r272.headerLabel, "");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r272.required);
} }
const _c4$2 = [1, "form-check"];
const _c5$2 = [3, "checked", "disabled", "required", "type", "name", "change"];
function RadioCheckboxListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r279 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c4$2);
    ɵɵelementStart(1, "lib-radio-checkbox", _c5$2);
    ɵɵlistener("change", function RadioCheckboxListComponent_div_2_Template_lib_radio_checkbox_change_1_listener($event) { ɵɵrestoreView(_r279); const i_r277 = ctx.index; const ctx_r278 = ɵɵnextContext(); return ctx_r278.onCheckboxChange(i_r277, $event); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const val_r276 = ctx.$implicit;
    const ctx_r273 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("checked", ctx_r273.valueSelected(val_r276))("disabled", ctx_r273.disabled)("required", ctx_r273.required)("type", ctx_r273.type)("name", ctx_r273.name);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", val_r276[ctx_r273.labelProperty], " ");
} }
function RadioCheckboxListComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r274 = ɵɵnextContext();
    ɵɵclassMap(ctx_r274.type + "__validation-text");
    ɵɵstylingApply();
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r274.errorMessage);
} }
class RadioCheckboxListComponent {
    constructor(cd, control) {
        this.cd = cd;
        this.control = control;
        this.isValueSelected = false;
        this.type = "checkbox";
        this.name = "__radioCheckboxGroupName__";
        this.valueProperty = "value";
        this.labelProperty = "label";
        this.errorMessage = "This is required";
        this.selectionChanged = new EventEmitter();
        this.onChange = () => { };
        this.onTouch = () => { };
        this.control.valueAccessor = this;
    }
    set options(value) {
        if (this._options && this._options !== value) {
            this.selectedOptions = this.type === "checkbox" ? [] : this.selectedOptions;
        }
        this._options = value;
    }
    get options() {
        return this._options;
    }
    set value(val) {
        if (!this.disabled && val) {
            this.selectedOptions = val;
            this.onSelectionChange();
        }
    }
    get value() {
        return this.selectedOptions;
    }
    // set value programmatically
    writeValue(value) {
        // Somehow WriteValue is called before ngInit
        // Using timeout to fix
        // https://github.com/angular/angular/issues/29218
        setTimeout(() => {
            if (!this.disabled) {
                // In case for radio button value is passed in as array, need to change it to a single value
                // Or for checkbox value is passed in as single value, need to change it to an array
                if (this.type === "checkbox" && value && !Array.isArray(value)) {
                    this.selectedOptions = [value];
                }
                else if (this.type === "radio" && value && Array.isArray(value)) {
                    if ((value.length > 0) && (this.required)) {
                        this.selectedOptions = value[0];
                    }
                    else {
                        this.selectedOptions = null;
                    }
                }
                else {
                    this.selectedOptions = value;
                }
                this.onSelectionChange(false);
            }
        }, 0);
    }
    // On UI element value changes,
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // On Touch
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    // Update disabled/enabled status
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        setTimeout(() => {
            if (this.cd && !this.cd.destroyed) {
                this.cd.detectChanges();
            }
        });
    }
    // Triggers when selection changes
    onCheckboxChange(index, $event) {
        const updatedSelectedOptions = this.getUpdateSelection(index, $event);
        // Check if any function needs to be executed before change
        if (this.onBeforeChange) {
            this.onBeforeChange({ newValue: updatedSelectedOptions, oldValue: this.selectedOptions }).subscribe((result = false) => {
                if (result) {
                    // Proceed with testing
                    this.updateSelection(updatedSelectedOptions);
                }
                else {
                    this.radioCheckboxList.forEach((x, idx) => {
                        // restore checked status
                        x.inputRef.nativeElement.checked = this.valueSelected(this.options[idx]);
                    });
                }
            });
        }
        else {
            this.updateSelection(updatedSelectedOptions);
        }
    }
    getUpdateSelection(index, $event) {
        let selectedOptions = this.selectedOptions;
        if ($event.target && index > -1 && index < this.options.length) {
            const val = this.options[index][this.valueProperty];
            if (this.type === "radio") {
                // For radio button, can only select one item
                selectedOptions = val;
            }
            else {
                // For checkbox, need to update the selected list
                if ($event.target.checked && !this.valueSelected(val)) {
                    // Add into selected option
                    if (selectedOptions) {
                        selectedOptions.push(val);
                    }
                    else {
                        selectedOptions = [val];
                    }
                }
                else if (!$event.target.checked && selectedOptions) {
                    // Remove selected option from list upon unselect
                    const idx = selectedOptions.indexOf(val);
                    if (idx > -1) {
                        selectedOptions.splice(idx, 1);
                    }
                }
            }
        }
        return selectedOptions;
    }
    updateSelection(updatedSelection) {
        this.selectedOptions = updatedSelection;
        this.onSelectionChange();
    }
    // Generally triggers necessary functions programatically when value changes
    onSelectionChange(callOnChange = true) {
        if (callOnChange) {
            this.onChange(this.selectedOptions);
        }
        this.isValueSelected = (this.type === "checkbox") ? (this.selectedOptions && this.selectedOptions.length > 0) : true;
        this.selectionChanged.emit(this.selectedOptions);
        setTimeout(() => {
            if (this.cd && !this.cd.destroyed) {
                this.cd.detectChanges();
            }
        });
    }
    // Check if value in selection
    valueSelected(value) {
        if (this.selectedOptions && value && value[this.valueProperty]) {
            if (this.type === "checkbox") {
                // check checkbox value if value found in selected array
                return this.selectedOptions.indexOf(value[this.valueProperty]) !== -1;
            }
            else {
                // check radio only if value matches selected option
                return value[this.valueProperty] === this.selectedOptions;
            }
        }
    }
    ngOnInit() {
    }
}
/** @nocollapse */ RadioCheckboxListComponent.ngComponentDef = ɵɵdefineComponent({ type: RadioCheckboxListComponent, selectors: [["lib-radio-checkbox-list"]], factory: function RadioCheckboxListComponent_Factory(t) { return new (t || RadioCheckboxListComponent)(ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(NgControl)); }, viewQuery: function RadioCheckboxListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(RadioCheckboxComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.radioCheckboxList = _t);
    } }, inputs: { options: "options", headerLabel: "headerLabel", type: "type", name: "name", valueProperty: "valueProperty", labelProperty: "labelProperty", disabled: "disabled", required: "required", errorMessage: "errorMessage", onBeforeChange: "onBeforeChange" }, outputs: { selectionChanged: "selectionChanged" }, exportAs: ["libRadioCheckboxList"], consts: 4, vars: 3, template: function RadioCheckboxListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, RadioCheckboxListComponent_label_0_Template, 3, 3, "label", _c0$3);
        ɵɵelementStart(1, "fieldset");
        ɵɵtemplate(2, RadioCheckboxListComponent_div_2_Template, 3, 6, "div", _c1$3);
        ɵɵtemplate(3, RadioCheckboxListComponent_span_3_Template, 2, 2, "span", _c0$3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.headerLabel);
        ɵɵselect(2);
        ɵɵproperty("ngForOf", ctx._options);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.required && ctx.control.dirty && !ctx.isValueSelected);
    } }, directives: [NgIf, NgForOf, RadioCheckboxComponent], styles: [""], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(RadioCheckboxListComponent, [{
        type: Component,
        args: [{
                selector: "lib-radio-checkbox-list",
                templateUrl: "./radio-checkbox-list.component.html",
                styleUrls: ["./radio-checkbox-list.component.scss"],
                exportAs: "libRadioCheckboxList",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ChangeDetectorRef }, { type: NgControl }]; }, { options: [{
            type: Input
        }], headerLabel: [{
            type: Input
        }], type: [{
            type: Input
        }], name: [{
            type: Input
        }], valueProperty: [{
            type: Input
        }], labelProperty: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], onBeforeChange: [{
            type: Input
        }], radioCheckboxList: [{
            type: ViewChildren,
            args: [RadioCheckboxComponent]
        }], selectionChanged: [{
            type: Output
        }] });

class RadioCheckboxListModule {
}
/** @nocollapse */ RadioCheckboxListModule.ngModuleDef = ɵɵdefineNgModule({ type: RadioCheckboxListModule });
/** @nocollapse */ RadioCheckboxListModule.ngInjectorDef = ɵɵdefineInjector({ factory: function RadioCheckboxListModule_Factory(t) { return new (t || RadioCheckboxListModule)(); }, imports: [[CommonModule, RadioCheckboxModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(RadioCheckboxListModule, { declarations: [RadioCheckboxListComponent], imports: [CommonModule, RadioCheckboxModule], exports: [RadioCheckboxListComponent] });
/*@__PURE__*/ ɵsetClassMetadata(RadioCheckboxListModule, [{
        type: NgModule,
        args: [{
                declarations: [RadioCheckboxListComponent],
                imports: [CommonModule, RadioCheckboxModule],
                exports: [RadioCheckboxListComponent],
            }]
    }], null, null);

const _c0$4 = ["popoverTrigger"];
const _c1$4 = ["container", "body", 1, "lib-popover__custom-trigger", 3, "placement", "containerClass", "adaptivePosition", "outsideClick", "popover", "onShown", "onHidden"];
const _c2$3 = ["popoverTrigger", "bs-popover"];
const _c3$3 = ["*"];
class PopoverCustomTriggerComponent {
    constructor() {
        this.popoverPlacement = "top";
        this.popoverSize = "medium";
        this.adaptivePosition = true;
        this.shown = new EventEmitter();
        this.hidden = new EventEmitter();
    }
    onShown() {
        if (this.shown) {
            this.shown.emit();
        }
    }
    onHidden() {
        if (this.hidden) {
            this.hidden.emit();
        }
    }
    show() {
        this.popoverTrigger.show();
    }
    hide() {
        this.popoverTrigger.hide();
    }
    toggle() {
        this.popoverTrigger.toggle();
    }
}
/** @nocollapse */ PopoverCustomTriggerComponent.ngComponentDef = ɵɵdefineComponent({ type: PopoverCustomTriggerComponent, selectors: [["lib-popover-custom-trigger"]], factory: function PopoverCustomTriggerComponent_Factory(t) { return new (t || PopoverCustomTriggerComponent)(); }, viewQuery: function PopoverCustomTriggerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$4, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.popoverTrigger = _t.first);
    } }, inputs: { popoverTitle: "popoverTitle", popoverPlacement: "popoverPlacement", popoverSize: "popoverSize", containerClass: "containerClass", popoverContent: "popoverContent", adaptivePosition: "adaptivePosition" }, outputs: { shown: "shown", hidden: "hidden" }, ngContentSelectors: _c3$3, consts: 3, vars: 5, template: function PopoverCustomTriggerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "span", _c1$4, _c2$3);
        ɵɵlistener("onShown", function PopoverCustomTriggerComponent_Template_span_onShown_0_listener($event) { return ctx.onShown(); });
        ɵɵlistener("onHidden", function PopoverCustomTriggerComponent_Template_span_onHidden_0_listener($event) { return ctx.onHidden(); });
        ɵɵprojection(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵpropertyInterpolate("containerClass", ctx.containerClass);
        ɵɵproperty("placement", ctx.popoverPlacement)("adaptivePosition", ctx.adaptivePosition)("outsideClick", true)("popover", ctx.popoverContent);
    } }, directives: [PopoverDirective], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(PopoverCustomTriggerComponent, [{
        type: Component,
        args: [{
                selector: "lib-popover-custom-trigger",
                templateUrl: "./popover-custom.component.html"
            }]
    }], function () { return []; }, { popoverTitle: [{
            type: Input
        }], popoverPlacement: [{
            type: Input
        }], popoverSize: [{
            type: Input
        }], containerClass: [{
            type: Input
        }], popoverContent: [{
            type: Input
        }], adaptivePosition: [{
            type: Input
        }], shown: [{
            type: Output
        }], hidden: [{
            type: Output
        }], popoverTrigger: [{
            type: ViewChild,
            args: ["popoverTrigger", { static: false }]
        }] });

/**
 * Configuration service for the Popover directive.
 * You can inject this service, typically in your root component, and customize
 * the values of its properties in order to provide default values for all the
 * popovers used in the application.
 */
class PopoverConfig {
}
/** @nocollapse */ PopoverConfig.ngInjectableDef = ɵɵdefineInjectable({ token: PopoverConfig, factory: function PopoverConfig_Factory(t) { return new (t || PopoverConfig)(); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(PopoverConfig, [{
        type: Injectable
    }], null, null);

const _c0$5 = ["popoverContent"];
const _c1$5 = ["popoverButton"];
const _c2$4 = ["popoverContentWrapper"];
const _c3$4 = [3, "ngSwitch"];
const _c4$3 = [4, "ngSwitchCase"];
const _c5$3 = ["popoverContent", ""];
const _c6$2 = ["type", "button", "container", "body", 1, "lib-popover__ellipsis-button", 3, "placement", "containerClass", "triggers", "adaptivePosition", "outsideClick", "popover", "onShown", "onHidden"];
const _c7$1 = ["popoverButton", ""];
function LibPopoverComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r291 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "button", _c6$2, _c7$1);
    ɵɵlistener("onShown", function LibPopoverComponent_ng_container_1_Template_button_onShown_1_listener($event) { ɵɵrestoreView(_r291); const ctx_r290 = ɵɵnextContext(); return ctx_r290.onShown(); });
    ɵɵlistener("onHidden", function LibPopoverComponent_ng_container_1_Template_button_onHidden_1_listener($event) { ɵɵrestoreView(_r291); const ctx_r292 = ɵɵnextContext(); return ctx_r292.onHidden(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r281 = ɵɵnextContext();
    const _r287 = ɵɵreference(8);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("containerClass", ctx_r281.containerClass);
    ɵɵproperty("placement", ctx_r281.popoverPlacement)("triggers", ctx_r281.popoverTriggerEvents)("adaptivePosition", ctx_r281.adaptivePosition)("outsideClick", true)("popover", _r287);
} }
const _c8$1 = ["type", "button", "container", "body", 1, "lib-popover__info-button", 3, "placement", "containerClass", "triggers", "adaptivePosition", "outsideClick", "popover", "onShown", "onHidden"];
function LibPopoverComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r295 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "button", _c8$1, _c7$1);
    ɵɵlistener("onShown", function LibPopoverComponent_ng_container_2_Template_button_onShown_1_listener($event) { ɵɵrestoreView(_r295); const ctx_r294 = ɵɵnextContext(); return ctx_r294.onShown(); });
    ɵɵlistener("onHidden", function LibPopoverComponent_ng_container_2_Template_button_onHidden_1_listener($event) { ɵɵrestoreView(_r295); const ctx_r296 = ɵɵnextContext(); return ctx_r296.onHidden(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r282 = ɵɵnextContext();
    const _r287 = ɵɵreference(8);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("containerClass", ctx_r282.containerClass);
    ɵɵproperty("placement", ctx_r282.popoverPlacement)("triggers", ctx_r282.popoverTriggerEvents)("adaptivePosition", ctx_r282.adaptivePosition)("outsideClick", true)("popover", _r287);
} }
const _c9$1 = ["type", "button", "container", "body", 1, "lib-popover__error-button", 3, "placement", "containerClass", "triggers", "adaptivePosition", "outsideClick", "popover", "onShown", "onHidden"];
function LibPopoverComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r299 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "button", _c9$1, _c7$1);
    ɵɵlistener("onShown", function LibPopoverComponent_ng_container_3_Template_button_onShown_1_listener($event) { ɵɵrestoreView(_r299); const ctx_r298 = ɵɵnextContext(); return ctx_r298.onShown(); });
    ɵɵlistener("onHidden", function LibPopoverComponent_ng_container_3_Template_button_onHidden_1_listener($event) { ɵɵrestoreView(_r299); const ctx_r300 = ɵɵnextContext(); return ctx_r300.onHidden(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r283 = ɵɵnextContext();
    const _r287 = ɵɵreference(8);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("containerClass", ctx_r283.containerClass);
    ɵɵproperty("placement", ctx_r283.popoverPlacement)("triggers", ctx_r283.popoverTriggerEvents)("adaptivePosition", ctx_r283.adaptivePosition)("outsideClick", true)("popover", _r287);
} }
const _c10$1 = ["type", "button", "container", "body", 1, "lib-popover__file-error-button", 3, "placement", "containerClass", "triggers", "adaptivePosition", "outsideClick", "popover", "onShown", "onHidden"];
function LibPopoverComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r303 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "button", _c10$1, _c7$1);
    ɵɵlistener("onShown", function LibPopoverComponent_ng_container_4_Template_button_onShown_1_listener($event) { ɵɵrestoreView(_r303); const ctx_r302 = ɵɵnextContext(); return ctx_r302.onShown(); });
    ɵɵlistener("onHidden", function LibPopoverComponent_ng_container_4_Template_button_onHidden_1_listener($event) { ɵɵrestoreView(_r303); const ctx_r304 = ɵɵnextContext(); return ctx_r304.onHidden(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r284 = ɵɵnextContext();
    const _r287 = ɵɵreference(8);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("containerClass", ctx_r284.containerClass);
    ɵɵproperty("placement", ctx_r284.popoverPlacement)("triggers", ctx_r284.popoverTriggerEvents)("adaptivePosition", ctx_r284.adaptivePosition)("outsideClick", true)("popover", _r287);
} }
const _c11$1 = ["type", "button", "container", "body", 1, "lib-popover__text-button", 3, "placement", "containerClass", "ngClass", "adaptivePosition", "outsideClick", "triggers", "popover", "onShown", "onHidden"];
function LibPopoverComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r307 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "button", _c11$1, _c7$1);
    ɵɵlistener("onShown", function LibPopoverComponent_ng_container_5_Template_button_onShown_1_listener($event) { ɵɵrestoreView(_r307); const ctx_r306 = ɵɵnextContext(); return ctx_r306.onShown(); });
    ɵɵlistener("onHidden", function LibPopoverComponent_ng_container_5_Template_button_onHidden_1_listener($event) { ɵɵrestoreView(_r307); const ctx_r308 = ɵɵnextContext(); return ctx_r308.onHidden(); });
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r285 = ɵɵnextContext();
    const _r287 = ɵɵreference(8);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("containerClass", ctx_r285.containerClass);
    ɵɵproperty("placement", ctx_r285.popoverPlacement)("ngClass", ctx_r285.popoverButtonClass)("adaptivePosition", ctx_r285.adaptivePosition)("outsideClick", true)("triggers", ctx_r285.popoverTriggerEvents)("popover", _r287);
    ɵɵselect(3);
    ɵɵtextInterpolate1("", ctx_r285.popoverLabel, " ");
} }
const _c12$1 = ["type", "button", "container", "body", 1, "lib-popover__ellipsis-button", 3, "placement", "containerClass", "adaptivePosition", "outsideClick", "triggers", "popover", "onShown", "onHidden"];
function LibPopoverComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r311 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "button", _c12$1, _c7$1);
    ɵɵlistener("onShown", function LibPopoverComponent_ng_container_6_Template_button_onShown_1_listener($event) { ɵɵrestoreView(_r311); const ctx_r310 = ɵɵnextContext(); return ctx_r310.onShown(); });
    ɵɵlistener("onHidden", function LibPopoverComponent_ng_container_6_Template_button_onHidden_1_listener($event) { ɵɵrestoreView(_r311); const ctx_r312 = ɵɵnextContext(); return ctx_r312.onHidden(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r286 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵpropertyInterpolate("containerClass", ctx_r286.containerClass);
    ɵɵproperty("placement", ctx_r286.popoverPlacement)("adaptivePosition", ctx_r286.adaptivePosition)("outsideClick", true)("triggers", ctx_r286.popoverTriggerEvents)("popover", ctx_r286.popoverAsyncContent);
} }
const _c13$1 = [1, "lib-popover__header", 3, "hidden"];
const _c14$1 = ["popoverContentWrapper", ""];
function LibPopoverComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h4", _c13$1);
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵelementStart(2, "div", null, _c14$1);
    ɵɵprojection(4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r288 = ɵɵnextContext();
    ɵɵproperty("hidden", !ctx_r288.popoverTitle);
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r288.popoverTitle);
} }
const _c15$1 = ["*"];
// such override allows to keep some initial values
function getPopoverConfig() {
    return Object.assign(new PopoverConfig$1(), PopoverConfig);
}
class LibPopoverComponent {
    constructor(_config, _elementRef, _renderer, _viewContainerRef, _componentLoaderFactory) {
        this._config = _config;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._viewContainerRef = _viewContainerRef;
        this._componentLoaderFactory = _componentLoaderFactory;
        /**
         * Type of template to use for popopver trigger: ellipsis, text, info, or a custom trigger
         */
        this.popoverType = "text";
        /**
         * Placement of a popover. Accepts: "top", "bottom", "left", "right". Defaults to top if not set
         */
        this.popoverPlacement = "top";
        /**
         * Size of a popover. Accepts: "small", "medium", "large", "auto". Defaults to medium if not set
         */
        this.popoverSize = "medium";
        /**
         * sets disable adaptive position
         */
        this.adaptivePosition = true;
        /**
         * sets style for data table tooltip cell
         */
        this.dataTableTooltipStyle = false;
        /**
         * overwrite spacing for data table tooltip cell
         */
        this.dataTableTooltipNoSpacing = false;
        /**
         * Emits an event when the popover is shown
         */
        this.shown = new EventEmitter();
        /**
         * Emits an event when the popover is hidden
         */
        this.hidden = new EventEmitter();
        this.bodyTag = document.getElementsByTagName("body")[0];
        this.containerClass = "lib-popover";
        this.popoverButtonClass = "";
        this._popoverTrigger = this._componentLoaderFactory
            .createLoader(this._elementRef, this._viewContainerRef, this._renderer)
            .provide({ provide: PopoverConfig$1, useValue: this._config });
    }
    ngOnInit() {
        // Add css class for data table cell tooltip style
        if (this.dataTableTooltipStyle) {
            this.containerClass = `lib-popover__datatable_tooltip ${this.containerClass}`;
        }
        // Add the size class if set and not auto. Auto will use the starting max-width instead so not needed to set a class.
        if (this.popoverSize && this.popoverSize !== "auto") {
            this.containerClass += ` ${this.containerClass}--${this.popoverSize}`;
        }
        // Overwrite config triggers when provided as input
        this.popoverTriggerEvents = this.popoverTriggerEvents || this._config.triggers;
        // If there is a custom button to display, attach it to the view and bind inputs
        if (this._isCustomTrigger()) {
            this._popoverTrigger
                .attach(PopoverCustomTriggerComponent)
                .to(this._viewContainerRef.element)
                .show({
                content: this.popoverType,
                context: this.popoverContext,
                popoverTitle: this.popoverTitle,
                popoverPlacement: this.popoverPlacement,
                popoverSize: this.popoverSize,
                popoverContent: this.popoverAsyncContent,
                adaptivePosition: this.adaptivePosition,
                shown: this.onShown(),
                hidden: this.onHidden(),
                containerClass: this.containerClass
            });
        }
        // Compute ngClass for popover button
        if (this.dataTableTooltipStyle) {
            let popoverButtonClass = "lib-popover__datatable_tooltip-button";
            if (this.dataTableTooltipNoSpacing) {
                popoverButtonClass += "-nospace";
            }
            this.popoverButtonClass = popoverButtonClass;
        }
    }
    ngOnDestroy() {
        // Destroy any custom trigger components
        this._popoverTrigger.dispose();
        this.bodyTag.removeAttribute("style");
    }
    /**
     * Passed into the ngx-popover. Emits an event when the popover is shown
     */
    onShown() {
        if (this.shown) {
            this.shown.emit();
        }
    }
    /**
     * Passed into the ngx-popover. Emits an event when the popover is hidden
     */
    onHidden() {
        this.hidden.emit();
    }
    /**
     * Opens an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    show() {
        if (this._isCustomTrigger()) {
            this._popoverTrigger.instance.show();
        }
        else {
            this.popoverButton.show();
        }
    }
    /**
     * Closes an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    hide() {
        if (this._isCustomTrigger()) {
            this._popoverTrigger.instance.hide();
        }
        else {
            this.popoverButton.hide();
        }
    }
    /**
     * Toggles an element’s popover. This is considered a “manual” triggering of
     * the popover.
     */
    toggle() {
        if (this._isCustomTrigger()) {
            this._popoverTrigger.instance.toggle();
        }
        else {
            this.popoverButton.toggle();
        }
    }
    _isCustomTrigger() {
        return this.popoverType instanceof TemplateRef;
    }
}
/** @nocollapse */ LibPopoverComponent.ngComponentDef = ɵɵdefineComponent({ type: LibPopoverComponent, selectors: [["lib-popover"]], factory: function LibPopoverComponent_Factory(t) { return new (t || LibPopoverComponent)(ɵɵdirectiveInject(PopoverConfig$1), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(ComponentLoaderFactory)); }, viewQuery: function LibPopoverComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$5, true);
        ɵɵviewQuery(_c1$5, true);
        ɵɵviewQuery(_c2$4, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.popoverContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.popoverButton = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.ngContent = _t.first);
    } }, inputs: { popoverType: "popoverType", popoverAsyncContent: "popoverAsyncContent", popoverLabel: "popoverLabel", popoverTitle: "popoverTitle", popoverPlacement: "popoverPlacement", popoverSize: "popoverSize", popoverTriggerEvents: "popoverTriggerEvents", popoverContext: "popoverContext", adaptivePosition: "adaptivePosition", dataTableTooltipStyle: "dataTableTooltipStyle", dataTableTooltipNoSpacing: "dataTableTooltipNoSpacing" }, outputs: { shown: "shown", hidden: "hidden" }, ngContentSelectors: _c15$1, consts: 9, vars: 7, template: function LibPopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "span", _c3$4);
        ɵɵtemplate(1, LibPopoverComponent_ng_container_1_Template, 3, 6, "ng-container", _c4$3);
        ɵɵtemplate(2, LibPopoverComponent_ng_container_2_Template, 3, 6, "ng-container", _c4$3);
        ɵɵtemplate(3, LibPopoverComponent_ng_container_3_Template, 3, 6, "ng-container", _c4$3);
        ɵɵtemplate(4, LibPopoverComponent_ng_container_4_Template, 3, 6, "ng-container", _c4$3);
        ɵɵtemplate(5, LibPopoverComponent_ng_container_5_Template, 4, 8, "ng-container", _c4$3);
        ɵɵtemplate(6, LibPopoverComponent_ng_container_6_Template, 3, 6, "ng-container", _c4$3);
        ɵɵelementEnd();
        ɵɵtemplate(7, LibPopoverComponent_ng_template_7_Template, 5, 2, "ng-template", null, _c5$3, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵɵproperty("ngSwitch", ctx.popoverType);
        ɵɵselect(1);
        ɵɵproperty("ngSwitchCase", "ellipsis");
        ɵɵselect(2);
        ɵɵproperty("ngSwitchCase", "info");
        ɵɵselect(3);
        ɵɵproperty("ngSwitchCase", "error");
        ɵɵselect(4);
        ɵɵproperty("ngSwitchCase", "fileError");
        ɵɵselect(5);
        ɵɵproperty("ngSwitchCase", "text");
        ɵɵselect(6);
        ɵɵproperty("ngSwitchCase", "async");
    } }, directives: [NgSwitch, NgSwitchCase, PopoverDirective, NgClass], styles: [".lib-popover .popover-content a:link,.lib-popover__text-button:hover{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent}.lib-popover .popover-content,.lib-popover__header,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--popover-position-override:inherit}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.lib-popover .popover-content,.lib-popover__header{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.lib-popover__header{font-weight:300}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}lib-popover-config{display:inline}.lib-popover{z-index:4000;-webkit-animation:150ms ease-in-out show-popover;animation:150ms ease-in-out show-popover;border:0;border-radius:0;max-width:86rem;-webkit-transform:var(--popover-position-override);transform:var(--popover-position-override)}.lib-popover__ellipsis-button{background-color:transparent;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/ellipsis.svg);background-repeat:no-repeat;border:none;cursor:pointer;display:inline-block;height:2rem;padding:0;vertical-align:middle;width:2rem}.lib-popover__ellipsis-button:hover:not(.lib-popover__ellipsis-button--disabled){-webkit-transform:scale(1.2);transform:scale(1.2)}.lib-popover__ellipsis-button:active,.lib-popover__ellipsis-button:active:focus,.lib-popover__ellipsis-button:focus{outline:0}.lib-popover__info-button{background-color:transparent;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/help.svg);background-repeat:no-repeat;border:none;cursor:pointer;display:inline-block;height:2rem;padding:0;vertical-align:middle;width:2rem}.lib-popover__info-button:active,.lib-popover__info-button:active:focus,.lib-popover__info-button:focus{outline:0}.lib-popover__error-button{background-color:transparent;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/alert-red.svg);background-repeat:no-repeat;border:none;cursor:pointer;display:inline-block;height:2rem;padding:0;vertical-align:middle;width:2rem}.lib-popover__error-button:active,.lib-popover__error-button:active:focus,.lib-popover__error-button:focus{outline:0}.lib-popover__file-error-button{background-color:transparent;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/missing-pair.svg);background-repeat:no-repeat;border:none;cursor:pointer;display:inline-block;height:2rem;padding:0;vertical-align:middle;width:2rem}.lib-popover__file-error-button:active,.lib-popover__file-error-button:active:focus,.lib-popover__file-error-button:focus{outline:0}.lib-popover__text-button{background:0 0;border:0;color:inherit;display:inline;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;padding:0;text-decoration:underline}.lib-popover__text-button:active,.lib-popover__text-button:active:focus,.lib-popover__text-button:focus{outline:0}.lib-popover__datatable_tooltip-button,.lib-popover__datatable_tooltip-button-nospace{text-decoration:none;cursor:default!important;text-overflow:ellipsis;overflow:hidden;max-width:100%;text-align:inherit}.lib-popover__datatable_tooltip-button-nospace:hover,.lib-popover__datatable_tooltip-button:hover{background:0 0;-webkit-text-fill-color:unset;color:#322d32}.lib-popover__datatable_tooltip-button{padding:1rem .5rem 1rem 1.5rem;margin-left:1rem}.lib-popover__datatable_tooltip-button-nospace{margin:0;padding:0}.lib-popover__datatable_tooltip.left>.popover-arrow,.lib-popover__datatable_tooltip.right>.popover-arrow{margin-top:-5px!important}.lib-popover .popover-content{background-color:#fff;border:0;border-radius:0;box-shadow:0 0 3rem -.5rem rgba(145,141,145,.6);max-height:32rem;max-width:94vw;overflow-x:auto;padding:1.7rem 2.2rem}.lib-popover .popover-content p:not(:last-of-type){margin-bottom:1.2rem}.lib-popover .popover-arrow{width:2rem;height:1rem;margin:0!important}.lib-popover .popover-arrow::before{border-top-color:rgba(145,141,145,.6);-webkit-filter:blur(3rem);filter:blur(3rem)}.lib-popover__header{color:#322d32;margin:0}.lib-popover--small .popover-content{max-width:20rem}.lib-popover--medium .popover-content{max-width:30rem}.lib-popover--large .popover-content{max-width:40rem}.lib-popover--extra-large .popover-content{width:80rem}.lib-popover.top{margin-bottom:1rem}.lib-popover.top>.popover-arrow{bottom:-1rem}.lib-popover.top>.popover-arrow::after,.lib-popover.top>.popover-arrow::before{border-width:1rem 1rem 0}.lib-popover.right{margin-left:1rem}.lib-popover.right>.popover-arrow{height:2rem;left:-1rem;width:1rem}.lib-popover.right>.popover-arrow::after,.lib-popover.right>.popover-arrow::before{border-width:1rem 1rem 1rem 0}.lib-popover.bottom{margin-top:1rem}.lib-popover.bottom>.popover-arrow{top:-1rem}.lib-popover.bottom>.popover-arrow::after,.lib-popover.bottom>.popover-arrow::before{border-width:0 1rem 1rem}.lib-popover.left{margin-right:1rem}.lib-popover.left>.popover-arrow{height:2rem;right:-1rem;width:1rem}.lib-popover.left>.popover-arrow::after,.lib-popover.left>.popover-arrow::before{border-width:1rem 0 1rem 1rem}@-webkit-keyframes show-popover{0%{opacity:0}100%{opacity:1}}@keyframes show-popover{0%{opacity:0}100%{opacity:1}}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(LibPopoverComponent, [{
        type: Component,
        args: [{
                selector: "lib-popover",
                templateUrl: "./popover.component.html",
                styleUrls: ["./popover.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: PopoverConfig$1 }, { type: ElementRef }, { type: Renderer2 }, { type: ViewContainerRef }, { type: ComponentLoaderFactory }]; }, { popoverType: [{
            type: Input
        }], popoverAsyncContent: [{
            type: Input
        }], popoverLabel: [{
            type: Input
        }], popoverTitle: [{
            type: Input
        }], popoverPlacement: [{
            type: Input
        }], popoverSize: [{
            type: Input
        }], popoverTriggerEvents: [{
            type: Input
        }], popoverContext: [{
            type: Input
        }], adaptivePosition: [{
            type: Input
        }], dataTableTooltipStyle: [{
            type: Input
        }], dataTableTooltipNoSpacing: [{
            type: Input
        }], shown: [{
            type: Output
        }], hidden: [{
            type: Output
        }], popoverContent: [{
            type: ViewChild,
            args: ["popoverContent", { static: false }]
        }], popoverButton: [{
            type: ViewChild,
            args: ["popoverButton", { static: false }]
        }], ngContent: [{
            type: ViewChild,
            args: ["popoverContentWrapper", { static: false }]
        }] });

class LibPopoverModule {
}
/** @nocollapse */ LibPopoverModule.ngModuleDef = ɵɵdefineNgModule({ type: LibPopoverModule });
/** @nocollapse */ LibPopoverModule.ngInjectorDef = ɵɵdefineInjector({ factory: function LibPopoverModule_Factory(t) { return new (t || LibPopoverModule)(); }, providers: [{ provide: PopoverConfig, useFactory: getPopoverConfig }], imports: [[
            CommonModule,
            PopoverModule.forRoot(),
            ButtonModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(LibPopoverModule, { declarations: [LibPopoverComponent,
        PopoverCustomTriggerComponent], imports: [CommonModule, PopoverModule, ButtonModule], exports: [LibPopoverComponent,
        PopoverCustomTriggerComponent] });
/*@__PURE__*/ ɵsetClassMetadata(LibPopoverModule, [{
        type: NgModule,
        args: [{
                entryComponents: [
                    PopoverCustomTriggerComponent
                ],
                declarations: [
                    LibPopoverComponent,
                    PopoverCustomTriggerComponent
                ],
                imports: [
                    CommonModule,
                    PopoverModule.forRoot(),
                    ButtonModule
                ],
                exports: [
                    LibPopoverComponent,
                    PopoverCustomTriggerComponent
                ],
                providers: [{ provide: PopoverConfig, useFactory: getPopoverConfig }]
            }]
    }], null, null);

const NgxSmartModalConfig = {
    bodyClassOpen: 'dialog-open',
    prefixEvent: 'ngx-smart-modal.'
};

const _c0$6 = ["nsmContent"];
const _c1$6 = ["nsmDialog"];
const _c2$5 = ["nsmOverlay"];
const _c3$5 = [3, "z-index", "ngClass", "mousedown", 4, "ngIf"];
const _c4$4 = [3, "ngClass", "mousedown"];
const _c5$4 = ["nsmOverlay", ""];
const _c6$3 = [3, "ngClass"];
const _c7$2 = ["nsmDialog", ""];
const _c8$2 = ["data-cy", "ngxsmart-modal-container", 1, "modal-dialog__container"];
const _c9$2 = ["nsmContent", ""];
const _c10$2 = [1, "modal-dialog__container--inner"];
const _c11$2 = ["type", "button", "aria-label", "Close", "class", "modal-dialog-btn-close", "data-cy", "ngxsmart-modal-cancel", 3, "click", 4, "ngIf"];
const _c12$2 = [1, "modal-dialog__header"];
const _c13$2 = ["data-cy", "ngxsmart-modal-header", 1, "modal-dialog__title"];
const _c14$2 = [1, "modal-dialog__content", "os-host-flexbox"];
const _c15$2 = [1, "modal-dialog__footer"];
const _c16$1 = ["class", "modal-dialog__footer--item-new-button", 4, "ngIf"];
const _c17$1 = ["class", "modal-dialog__footer--item", 4, "ngIf"];
const _c18$1 = ["type", "button", "aria-label", "Close", "data-cy", "ngxsmart-modal-cancel", 1, "modal-dialog-btn-close", 3, "click"];
const _c19$1 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20"];
const _c20$1 = ["d", "M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z", "fill", "#656066"];
function NgxSmartModalComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r323 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c18$1);
    ɵɵlistener("click", function NgxSmartModalComponent_div_0_button_8_Template_button_click_0_listener($event) { ɵɵrestoreView(_r323); const ctx_r322 = ɵɵnextContext(2); return ctx_r322.close(); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c19$1);
    ɵɵelement(2, "path", _c20$1);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c21$1 = [1, "modal-dialog__footer--item-new-button"];
const _c22$1 = ["href", "javascript:void(0)", "data-cy", "ngxsmart-modal-new", 1, "btn", "btn--link", 3, "click"];
function NgxSmartModalComponent_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r325 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c21$1);
    ɵɵelementStart(1, "a", _c22$1);
    ɵɵlistener("click", function NgxSmartModalComponent_div_0_div_15_Template_a_click_1_listener($event) { ɵɵrestoreView(_r325); const ctx_r324 = ɵɵnextContext(2); return ctx_r324.newAction(); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r319 = ɵɵnextContext(2);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r319.newButtonText, " ");
} }
const _c23$1 = [1, "modal-dialog__footer--item"];
const _c24$1 = ["data-cy", "ngxsmart-modal-close", 1, "btn", "btn--secondary", 3, "disabled", "click"];
function NgxSmartModalComponent_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r327 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c23$1);
    ɵɵelementStart(1, "button", _c24$1);
    ɵɵlistener("click", function NgxSmartModalComponent_div_0_div_16_Template_button_click_1_listener($event) { ɵɵrestoreView(_r327); const ctx_r326 = ɵɵnextContext(2); return ctx_r326.close(); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r320 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("disabled", ctx_r320.disableCloseButton);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r320.closeButtonText, " ");
} }
const _c25$1 = ["data-cy", "ngxsmart-modal-confirm", 1, "btn", "btn--primary", 3, "disabled", "click"];
function NgxSmartModalComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r329 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c23$1);
    ɵɵelementStart(1, "button", _c25$1);
    ɵɵlistener("click", function NgxSmartModalComponent_div_0_div_17_Template_button_click_1_listener($event) { ɵɵrestoreView(_r329); const ctx_r328 = ɵɵnextContext(2); return ctx_r328.confirm(); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r321 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("disabled", ctx_r321.disableConfirmButton);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r321.confirmButtonText, " ");
} }
const _c26$1 = function (a0, a2) { return { transparent: a0, overlay: true, "modal-dialog-overlay-open": a2 }; };
const _c27$1 = function (a2, a3) { return ["modal-dialog-centered", "modal-dialog", a2, a3]; };
function NgxSmartModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r331 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c4$4, _c5$4);
    ɵɵstyling();
    ɵɵlistener("mousedown", function NgxSmartModalComponent_div_0_Template_div_mousedown_0_listener($event) { ɵɵrestoreView(_r331); const ctx_r330 = ɵɵnextContext(); return ctx_r330.dismiss($event); });
    ɵɵelementStart(2, "div", _c6$3, _c7$2);
    ɵɵstyling();
    ɵɵpipe(4, "async");
    ɵɵelementStart(5, "div", _c8$2, _c9$2);
    ɵɵelementStart(7, "div", _c10$2);
    ɵɵtemplate(8, NgxSmartModalComponent_div_0_button_8_Template, 3, 0, "button", _c11$2);
    ɵɵelementStart(9, "div", _c12$2);
    ɵɵelementStart(10, "h4", _c13$2);
    ɵɵtext(11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "overlay-scrollbars", _c14$2);
    ɵɵprojection(13);
    ɵɵelementEnd();
    ɵɵelementStart(14, "div", _c15$2);
    ɵɵtemplate(15, NgxSmartModalComponent_div_0_div_15_Template, 3, 1, "div", _c16$1);
    ɵɵtemplate(16, NgxSmartModalComponent_div_0_div_16_Template, 3, 2, "div", _c17$1);
    ɵɵtemplate(17, NgxSmartModalComponent_div_0_div_17_Template, 3, 2, "div", _c17$1);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r314 = ɵɵnextContext();
    ɵɵstyleProp("z-index", ctx_r314.visible ? ctx_r314.layerPosition - 1 : 0 - 1);
    ɵɵstylingApply();
    ɵɵproperty("ngClass", ɵɵpureFunction2(15, _c26$1, !ctx_r314.backdrop, ctx_r314.openedClass));
    ɵɵselect(2);
    ɵɵstyleProp("z-index", ctx_r314.visible ? ctx_r314.layerPosition : 0 - 1);
    ɵɵstylingApply();
    ɵɵproperty("ngClass", ɵɵpureFunction2(18, _c27$1, ɵɵpipeBind1(4, 13, ctx_r314.customClass$), ctx_r314.openedClass ? "modal-dialog-open" : "modal-dialog-close"));
    ɵɵattribute("aria-hidden", ctx_r314.openedClass ? false : true)("aria-label", ctx_r314.ariaLabel)("aria-labelledby", ctx_r314.ariaLabelledBy)("aria-describedby", ctx_r314.ariaDescribedBy);
    ɵɵselect(8);
    ɵɵproperty("ngIf", ctx_r314.closable);
    ɵɵselect(11);
    ɵɵtextInterpolate(ctx_r314.title);
    ɵɵselect(15);
    ɵɵproperty("ngIf", ctx_r314.showNewButton);
    ɵɵselect(16);
    ɵɵproperty("ngIf", ctx_r314.showCloseButton);
    ɵɵselect(17);
    ɵɵproperty("ngIf", ctx_r314.showConfirmButton);
} }
const _c28$1 = ["*"];
class NgxSmartModalComponent {
    constructor(
    // tslint:disable-next-line: variable-name
    _renderer, 
    // tslint:disable-next-line: variable-name
    _changeDetectorRef, 
    // tslint:disable-next-line: variable-name
    _document, 
    // tslint:disable-next-line: variable-name
    _platformId) {
        this._renderer = _renderer;
        this._changeDetectorRef = _changeDetectorRef;
        this._document = _document;
        this._platformId = _platformId;
        this.closable = true;
        this.closeButtonText = "Close";
        this.showCloseButton = true;
        this.confirmButtonText = "Confirm";
        this.showConfirmButton = true;
        this.disableConfirmButton = false;
        this.disableCloseButton = false;
        this.showNewButton = false;
        this.newButtonText = "";
        this.title = "";
        this.escapable = true;
        this.dismissible = true;
        this.identifier = "";
        this.customClass = "modal-dialog-centered";
        this.visible = false;
        this.backdrop = true;
        this.force = true;
        this.hideDelay = 500;
        this.autostart = false;
        this.target = "";
        this.ariaLabel = null;
        this.ariaLabelledBy = null;
        this.ariaDescribedBy = null;
        this.visibleChange = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onNew = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onConfirm = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onClose = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onCloseFinished = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onDismiss = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onDismissFinished = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onAnyCloseEvent = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onAnyCloseEventFinished = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onOpen = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onOpenFinished = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onEscape = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onDataAdded = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onDataRemoved = new EventEmitter();
        this.layerPosition = 2000;
        this.overlayVisible = false;
        this.openedClass = false;
        this.createFrom = "html";
        this.customClass$ = new BehaviorSubject('');
    }
    ngOnInit() {
        if (!this.identifier || !this.identifier.length) {
            throw new Error("identifier field isn’t set. Please set one before calling <ngx-smart-modal> in a template.");
        }
        this._sendEvent("create");
        this.customClass$.next(this.customClass);
    }
    ngOnDestroy() {
        this._sendEvent("delete");
    }
    /**
     * Open the modal instance
     *
     * @param top open the modal top of all other
     * @returns the modal component
     */
    open(top) {
        // detaches change detection from main page
        // this._changeDetectorRef.detach();
        this._sendEvent("open", { top });
        return this;
    }
    /**
     * Click New button inside modal
     *
     * @returns the modal component
     */
    newAction() {
        this._sendEvent("new");
        return this;
    }
    /**
     * Click confirm button inside modal
     *
     * @returns the modal component
     */
    confirm() {
        this._sendEvent("confirm");
        return this;
    }
    /**
     * Close the modal instance
     *
     * @returns the modal component
     */
    close() {
        // this._changeDetectorRef.reattach();
        this._sendEvent("close");
        return this;
    }
    /**
     * Dismiss the modal instance
     *
     * @param e the event sent by the browser
     * @returns the modal component
     */
    dismiss(e) {
        if (!this.dismissible || !e.target.classList.contains("overlay")) {
            return this;
        }
        this._sendEvent("dismiss");
        return this;
    }
    /**
     * Toggle visibility of the modal instance
     *
     * @param top open the modal top of all other
     * @returns the modal component
     */
    toggle(top) {
        this._sendEvent("toggle", { top });
        return this;
    }
    /**
     * Add a custom class to the modal instance
     *
     * @param className the class to add
     * @returns the modal component
     */
    addCustomClass(className) {
        if (!this.customClass.length) {
            this.customClass = className;
        }
        else {
            this.customClass += " " + className;
        }
        // update class dynamically in template
        this.customClass$.next(this.customClass);
        return this;
    }
    /**
     * Remove a custom class to the modal instance
     *
     * @param className the class to remove
     * @returns the modal component
     */
    removeCustomClass(className) {
        if (className) {
            this.customClass = this.customClass.replace(className, "").trim();
        }
        else {
            this.customClass = "";
        }
        return this;
    }
    /**
     * Returns the visibility state of the modal instance
     */
    isVisible() {
        return this.visible;
    }
    /**
     * Checks if data is attached to the modal instance
     */
    hasData() {
        return this._data !== undefined;
    }
    /**
     * Attach data to the modal instance
     *
     * @param data the data to attach
     * @param force override potentially attached data
     * @returns the modal component
     */
    setData(data, force) {
        if (!this.hasData() || (this.hasData() && force)) {
            this._data = data;
            this.onDataAdded.emit(this._data);
            this.markForCheck();
        }
        return this;
    }
    /**
     * Retrieve the data attached to the modal instance
     */
    getData() {
        return this._data;
    }
    /**
     * Remove the data attached to the modal instance
     *
     * @returns the modal component
     */
    removeData() {
        this._data = undefined;
        this.onDataRemoved.emit(true);
        this.markForCheck();
        return this;
    }
    /**
     * Add body class modal opened
     *
     * @returns the modal component
     */
    addBodyClass() {
        this._renderer.addClass(this._document.body, NgxSmartModalConfig.bodyClassOpen);
        return this;
    }
    /**
     * Add body class modal opened
     *
     * @returns the modal component
     */
    removeBodyClass() {
        this._renderer.removeClass(this._document.body, NgxSmartModalConfig.bodyClassOpen);
        return this;
    }
    markForCheck() {
        try {
            this._changeDetectorRef.detectChanges();
        }
        catch (e) { }
        this._changeDetectorRef.markForCheck();
    }
    /**
     * Listens for window resize event and recalculates modal instance position if it is element-relative
     */
    targetPlacement() {
        if (!this.isBrowser ||
            !this.nsmDialog.length ||
            !this.nsmContent.length ||
            !this.nsmOverlay.length ||
            !this.target) {
            return false;
        }
        const targetElement = this._document.querySelector(this.target);
        if (!targetElement) {
            return false;
        }
        const targetElementRect = targetElement.getBoundingClientRect();
        const bodyRect = this.nsmOverlay.first.nativeElement.getBoundingClientRect();
        const nsmContentRect = this.nsmContent.first.nativeElement.getBoundingClientRect();
        const nsmDialogRect = this.nsmDialog.first.nativeElement.getBoundingClientRect();
        const marginLeft = parseInt(getComputedStyle(this.nsmContent.first.nativeElement).marginLeft, 10);
        const marginTop = parseInt(getComputedStyle(this.nsmContent.first.nativeElement).marginTop, 10);
        let offsetTop = targetElementRect.top -
            nsmDialogRect.top -
            (nsmContentRect.height - targetElementRect.height) / 2;
        let offsetLeft = targetElementRect.left -
            nsmDialogRect.left -
            (nsmContentRect.width - targetElementRect.width) / 2;
        if (offsetLeft + nsmDialogRect.left + nsmContentRect.width + marginLeft * 2 >
            bodyRect.width) {
            offsetLeft =
                bodyRect.width -
                    (nsmDialogRect.left + nsmContentRect.width) -
                    marginLeft * 2;
        }
        else if (offsetLeft + nsmDialogRect.left < 0) {
            offsetLeft = -nsmDialogRect.left;
        }
        if (offsetTop + nsmDialogRect.top + nsmContentRect.height + marginTop >
            bodyRect.height) {
            offsetTop =
                bodyRect.height -
                    (nsmDialogRect.top + nsmContentRect.height) -
                    marginTop;
        }
        this._renderer.setStyle(this.nsmContent.first.nativeElement, "top", (offsetTop < 0 ? 0 : offsetTop) + "px");
        this._renderer.setStyle(this.nsmContent.first.nativeElement, "left", offsetLeft + "px");
    }
    _sendEvent(name, extraData) {
        if (!this.isBrowser) {
            return false;
        }
        const data = {
            extraData,
            instance: { id: this.identifier, modal: this }
        };
        const event = new CustomEvent(NgxSmartModalConfig.prefixEvent + name, {
            detail: data
        });
        return window.dispatchEvent(event);
    }
    /**
     * Is current platform browser
     */
    get isBrowser() {
        return isPlatformBrowser(this._platformId);
    }
}
/** @nocollapse */ NgxSmartModalComponent.ngComponentDef = ɵɵdefineComponent({ type: NgxSmartModalComponent, selectors: [["ngx-smart-modal"]], factory: function NgxSmartModalComponent_Factory(t) { return new (t || NgxSmartModalComponent)(ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(DOCUMENT), ɵɵdirectiveInject(PLATFORM_ID)); }, viewQuery: function NgxSmartModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$6, true);
        ɵɵviewQuery(_c1$6, true);
        ɵɵviewQuery(_c2$5, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.nsmContent = _t);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.nsmDialog = _t);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.nsmOverlay = _t);
    } }, hostBindings: function NgxSmartModalComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("resize", function NgxSmartModalComponent_resize_HostBindingHandler($event) { return ctx.targetPlacement(); }, false, ɵɵresolveWindow);
    } }, inputs: { closable: "closable", closeButtonText: "closeButtonText", showCloseButton: "showCloseButton", confirmButtonText: "confirmButtonText", showConfirmButton: "showConfirmButton", disableConfirmButton: "disableConfirmButton", disableCloseButton: "disableCloseButton", showNewButton: "showNewButton", newButtonText: "newButtonText", title: "title", escapable: "escapable", dismissible: "dismissible", identifier: "identifier", customClass: "customClass", visible: "visible", backdrop: "backdrop", force: "force", hideDelay: "hideDelay", autostart: "autostart", target: "target", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy", ariaDescribedBy: "ariaDescribedBy" }, outputs: { visibleChange: "visibleChange", onNew: "onNew", onConfirm: "onConfirm", onClose: "onClose", onCloseFinished: "onCloseFinished", onDismiss: "onDismiss", onDismissFinished: "onDismissFinished", onAnyCloseEvent: "onAnyCloseEvent", onAnyCloseEventFinished: "onAnyCloseEventFinished", onOpen: "onOpen", onOpenFinished: "onOpenFinished", onEscape: "onEscape", onDataAdded: "onDataAdded", onDataRemoved: "onDataRemoved" }, ngContentSelectors: _c28$1, consts: 1, vars: 1, template: function NgxSmartModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, NgxSmartModalComponent_div_0_Template, 18, 21, "div", _c3$5);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.overlayVisible);
    } }, directives: [NgIf, NgClass, OverlayScrollbarsComponent], pipes: [AsyncPipe], styles: [".modal-dialog,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.btn{background-color:#f0eff0;border:0;border-radius:50px;cursor:pointer;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;padding:8px 24px;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn:focus{box-shadow:none;outline:#7e8bf3 solid 4px}.btn:disabled{cursor:not-allowed;opacity:.4}.btn--secondary{background:0 0;color:#4e60ee;border:1px solid #4e60ee}.btn--secondary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);border-color:transparent;color:#fff}.btn--secondary:hover:disabled{color:#4e60ee}.btn--secondary:active:not(:disabled){background:#4e60ee;border-color:transparent;color:#fff}.btn--secondary.btn--small{font-size:14px;padding:5px 19px}.btn--secondary.btn--disabled{opacity:.4}.btn--disabled{cursor:not-allowed}.btn--primary{background:linear-gradient(8.68deg,#225de6 -4.27%,#a664fd 116.09%);color:#fff}.btn--primary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn--primary:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn--primary.btn--small{padding:5px 19px}.btn--primary.btn--disabled{opacity:.4}.btn--white{background:#fff;padding:7px 24px}.btn--white.btn--small{padding:5px 19px}.btn--white.btn--disabled{opacity:.4}.btn--tertiary{background:0 0;border:1px solid transparent;color:#4e60ee}.btn--tertiary:hover:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee}.btn--tertiary:active:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee;box-shadow:inset 0 0 0 1px #4e60ee}.btn--tertiary:focus:not(:disabled){border-color:#4e60ee}.btn--tertiary.btn--small{font-size:14px}.btn--tertiary.btn--disabled{opacity:.4}.btn--link,.btn--link:not([href]){background:0 0;color:#4e60ee!important}.btn--link:hover:not(:disabled),.btn--link:not([href]):hover:not(:disabled){background:0 0;color:#4e60ee;text-decoration:underline}.btn--link:active,.btn--link:not([href]):active{background:0 0}.btn--link.btn--small,.btn--link:not([href]).btn--small{font-size:14px}.btn--link.btn--disabled,.btn--link:not([href]).btn--disabled{opacity:.4}body.dialog-open{overflow:hidden}.modal-dialog-btn-close{background:0;border:0;cursor:pointer;position:absolute;right:2.1rem;top:2.4rem;z-index:1}.modal-dialog-btn-close svg{width:20px;height:20px}.overlay{position:fixed;top:0;bottom:0;left:0;right:0;overflow-x:hidden;overflow-y:auto;-webkit-transition:background-color .5s;transition:background-color .5s;background-color:transparent;z-index:999}.overlay.modal-dialog-overlay-open{background-color:rgba(255,255,255,.5)}.overlay.transparent{background-color:transparent}.modal-dialog{position:relative;opacity:1;visibility:visible;min-height:20rem;width:100%;max-width:62rem;margin:0 auto;pointer-events:none;outline:0}.modal-dialog-wide{max-width:123rem}.modal-dialog__container{position:relative;width:100%}.modal-dialog__container:before{content:\"\";display:block;position:absolute;top:0;right:0;left:0;bottom:0;width:100%;z-index:-1;opacity:.43;-webkit-filter:blur(29px);filter:blur(29px);background-image:radial-gradient(circle at 50% 100%,rgba(255,86,124,.5),rgba(255,86,124,0) 47%),radial-gradient(circle at 100% 100%,#a664fd,rgba(166,100,253,0) 70%),radial-gradient(circle at 0 100%,#5487fd,rgba(60,116,246,0) 69%)}.modal-dialog__container--inner{position:relative;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;pointer-events:auto;background-color:#f9f9f9;outline:#fff solid 1px;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);box-shadow:0 2px 30px 0 rgba(0,0,0,.08);margin:1.8rem 1.6rem;width:100%;padding:2.2rem 3rem 2rem}.modal-dialog__header{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;position:relative}.modal-dialog__title{font-weight:300;font-size:2rem;letter-spacing:.03rem;line-height:1.7;margin:0}.modal-dialog__content{position:relative;-webkit-box-flex:1;flex:1 1 auto;margin-top:2.8rem;margin-right:-.4rem;max-height:calc(100vh - 22rem);padding-right:2.6rem;overflow-x:hidden;overflow-y:auto}.modal-dialog__footer{position:relative;display:-webkit-box;display:flex;justify-content:space-around;-webkit-box-align:center;align-items:center;align-content:center;padding-bottom:1rem;padding-top:2rem}.modal-dialog__footer--item{padding:0 1.5rem}.modal-dialog__footer--item-new-button{position:absolute;left:1rem;top:2rem}.modal-dialog__footer .btn--primary{min-width:187px}.modal-dialog__footer .btn.btn--primary:disabled{cursor:not-allowed;color:#d1cfd1;background-image:-webkit-gradient(linear,left top,left bottom,from(#f0eff0));background-image:linear-gradient(#f0eff0);box-shadow:unset}.modal-dialog.modal-dialog-close{opacity:0}.modal-dialog.modal-dialog-centered{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;min-height:calc(100% - (1.75rem * 2))}.modal-dialog-[class*=modal-dialog-dialog-animation-]{-webkit-transition:opacity .5s,-webkit-transform .5s ease-in-out;transition:transform .5s ease-in-out,opacity .5s,-webkit-transform .5s ease-in-out}.modal-dialog-animation-ltr{-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}.modal-dialog-animation-ltr.modal-dialog-open{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.modal-dialog-animation-ltr.modal-dialog-close{-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}.modal-dialog-animation-rtl{-webkit-transform:translate3d(50%,0,0);transform:translate3d(50%,0,0)}.modal-dialog-animation-rtl.modal-dialog-open{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.modal-dialog-animation-rtl.modal-dialog-close{-webkit-transform:translate3d(50%,0,0);transform:translate3d(50%,0,0)}.modal-dialog-animation-ttb{-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.modal-dialog-animation-ttb.modal-dialog-open{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.modal-dialog-animation-ttb.modal-dialog-close{-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.modal-dialog-animation-btt{-webkit-transform:translate3d(0,50%,0);transform:translate3d(0,50%,0)}.modal-dialog-animation-btt.modal-dialog-open{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.modal-dialog-animation-btt.modal-dialog-close{-webkit-transform:translate3d(0,50%,0);transform:translate3d(0,50%,0)}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(NgxSmartModalComponent, [{
        type: Component,
        args: [{
                selector: "ngx-smart-modal",
                templateUrl: "./ngx-smart-modal.component.html",
                styleUrls: ["./ngx-smart-modal.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: Renderer2 }, { type: ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { closable: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], showCloseButton: [{
            type: Input
        }], confirmButtonText: [{
            type: Input
        }], showConfirmButton: [{
            type: Input
        }], disableConfirmButton: [{
            type: Input
        }], disableCloseButton: [{
            type: Input
        }], showNewButton: [{
            type: Input
        }], newButtonText: [{
            type: Input
        }], title: [{
            type: Input
        }], escapable: [{
            type: Input
        }], dismissible: [{
            type: Input
        }], identifier: [{
            type: Input
        }], customClass: [{
            type: Input
        }], visible: [{
            type: Input
        }], backdrop: [{
            type: Input
        }], force: [{
            type: Input
        }], hideDelay: [{
            type: Input
        }], autostart: [{
            type: Input
        }], target: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], ariaDescribedBy: [{
            type: Input
        }], visibleChange: [{
            type: Output
        }], onNew: [{
            type: Output
        }], onConfirm: [{
            type: Output
        }], onClose: [{
            type: Output
        }], onCloseFinished: [{
            type: Output
        }], onDismiss: [{
            type: Output
        }], onDismissFinished: [{
            type: Output
        }], onAnyCloseEvent: [{
            type: Output
        }], onAnyCloseEventFinished: [{
            type: Output
        }], onOpen: [{
            type: Output
        }], onOpenFinished: [{
            type: Output
        }], onEscape: [{
            type: Output
        }], onDataAdded: [{
            type: Output
        }], onDataRemoved: [{
            type: Output
        }], nsmContent: [{
            type: ViewChildren,
            args: ["nsmContent"]
        }], nsmDialog: [{
            type: ViewChildren,
            args: ["nsmDialog"]
        }], nsmOverlay: [{
            type: ViewChildren,
            args: ["nsmOverlay"]
        }], targetPlacement: [{
            type: HostListener,
            args: ["window:resize"]
        }] });

class NgxSmartModalStackService {
    constructor() {
        this._modalStack = [];
    }
    /**
     * Add a new modal instance. This step is essential and allows to retrieve any modal at any time.
     * It stores an object that contains the given modal identifier and the modal itself directly in the `modalStack`.
     *
     * @param modalInstance The object that contains the given modal identifier and the modal itself.
     * @param force Optional parameter that forces the overriding of modal instance if it already exists.
     * @returns nothing special.
     */
    addModal(modalInstance, force) {
        if (force) {
            const i = this._modalStack.findIndex((o) => o.id === modalInstance.id);
            if (i > -1) {
                this._modalStack[i].modal = modalInstance.modal;
            }
            else {
                this._modalStack.push(modalInstance);
            }
            return;
        }
        this._modalStack.push(modalInstance);
    }
    /**
     * Retrieve a modal instance by its identifier.
     *
     * @param id The modal identifier used at creation time.
     */
    getModal(id) {
        const i = this._modalStack.find((o) => o.id === id);
        if (i !== undefined) {
            return i.modal;
        }
        else {
            throw new Error(`Cannot find modal with identifier ${id}`);
        }
    }
    /**
     * Retrieve all the created modals.
     *
     * @returns an array that contains all modal instances.
     */
    getModalStack() {
        return this._modalStack;
    }
    /**
     * Retrieve all the opened modals. It looks for all modal instances with their `visible` property set to `true`.
     *
     * @returns an array that contains all the opened modals.
     */
    getOpenedModals() {
        return this._modalStack.filter((o) => o.modal.visible);
    }
    /**
     * Retrieve the opened modal with highest z-index.
     *
     * @returns the opened modal with highest z-index.
     */
    getTopOpenedModal() {
        if (!this.getOpenedModals().length) {
            throw new Error("No modal is opened");
        }
        return this.getOpenedModals()
            .map((o) => o.modal)
            .reduce((highest, item) => item.layerPosition > highest.layerPosition ? item : highest, this.getOpenedModals()[0].modal);
    }
    /**
     * Get the higher `z-index` value between all the modal instances. It iterates over the `ModalStack` array and
     * calculates a higher value (it takes the highest index value between all the modal instances and adds 1).
     * Use it to make a modal appear foreground.
     *
     * @returns a higher index from all the existing modal instances.
     */
    getHigherIndex() {
        return (Math.max(...this._modalStack.map(o => o.modal.layerPosition), 1041) + 1);
    }
    /**
     * It gives the number of modal instances. It's helpful to know if the modal stack is empty or not.
     *
     * @returns the number of modal instances.
     */
    getModalStackCount() {
        return this._modalStack.length;
    }
    /**
     * Remove a modal instance from the modal stack.
     *
     * @param id The modal identifier.
     * @returns the removed modal instance.
     */
    removeModal(id) {
        const i = this._modalStack.findIndex((o) => o.id === id);
        if (i > -1) {
            this._modalStack.splice(i, 1);
        }
    }
}
/** @nocollapse */ NgxSmartModalStackService.ngInjectableDef = ɵɵdefineInjectable({ token: NgxSmartModalStackService, factory: function NgxSmartModalStackService_Factory(t) { return new (t || NgxSmartModalStackService)(); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(NgxSmartModalStackService, [{
        type: Injectable
    }], function () { return []; }, null);

class NgxSmartModalService {
    constructor(_componentFactoryResolver, _appRef, _injector, _document, _modalStack, _platformId) {
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
        this._injector = _injector;
        this._document = _document;
        this._modalStack = _modalStack;
        this._platformId = _platformId;
        /**
         * Close the latest opened modal if escape key event is emitted
         * @param event The Keyboard Event
         */
        this._escapeKeyboardEvent = (event) => {
            if (event.key === "Escape") {
                try {
                    const modal = this.getTopOpenedModal();
                    if (!modal.escapable) {
                        return false;
                    }
                    modal.onEscape.emit(modal);
                    this.closeLatestModal();
                    return true;
                }
                catch (e) {
                    return false;
                }
            }
            return false;
        };
        /**
         * While modal is open, the focus stay on it
         * @param event The Keyboar dEvent
         */
        this._trapFocusModal = (event) => {
            if (event.key === "Tab") {
                try {
                    const modal = this.getTopOpenedModal();
                    if (!modal.nsmDialog.first.nativeElement.contains(document.activeElement)) {
                        event.preventDefault();
                        event.stopPropagation();
                        modal.nsmDialog.first.nativeElement.focus();
                    }
                    return true;
                }
                catch (e) {
                    return false;
                }
            }
            return false;
        };
        this._addEvents();
    }
    /**
     * Add a new modal instance. This step is essential and allows to retrieve any modal at any time.
     * It stores an object that contains the given modal identifier and the modal itself directly in the `modalStack`.
     *
     * @param modalInstance The object that contains the given modal identifier and the modal itself.
     * @param force Optional parameter that forces the overriding of modal instance if it already exists.
     * @returns nothing special.
     */
    addModal(modalInstance, force) {
        this._modalStack.addModal(modalInstance, force);
    }
    /**
     * Retrieve a modal instance by its identifier.
     *
     * @param id The modal identifier used at creation time.
     */
    getModal(id) {
        return this._modalStack.getModal(id);
    }
    /**
     * Alias of `getModal` to retrieve a modal instance by its identifier.
     *
     * @param id The modal identifier used at creation time.
     */
    get(id) {
        return this.getModal(id);
    }
    /**
     * Open a given modal
     *
     * @param id The modal identifier used at creation time.
     * @param force Tell the modal to open top of all other opened modals
     */
    open(id, force = false) {
        return this._openModal(this.get(id), force);
    }
    /**
     * Close a given modal
     *
     * @param id The modal identifier used at creation time.
     */
    close(id) {
        return this._closeModal(this.get(id));
    }
    /**
     * Close all opened modals
     */
    closeAll() {
        this.getOpenedModals().forEach((instance) => {
            this._closeModal(instance.modal);
        });
    }
    /**
     * Toggles a given modal
     * If the retrieved modal is opened it closes it, else it opens it.
     *
     * @param id The modal identifier used at creation time.
     * @param force Tell the modal to open top of all other opened modals
     */
    toggle(id, force = false) {
        return this._toggleModal(this.get(id), force);
    }
    /**
     * Retrieve all the created modals.
     *
     * @returns an array that contains all modal instances.
     */
    getModalStack() {
        return this._modalStack.getModalStack();
    }
    /**
     * Retrieve all the opened modals. It looks for all modal instances with their `visible` property set to `true`.
     *
     * @returns an array that contains all the opened modals.
     */
    getOpenedModals() {
        return this._modalStack.getOpenedModals();
    }
    /**
     * Retrieve the opened modal with highest z-index.
     *
     * @returns the opened modal with highest z-index.
     */
    getTopOpenedModal() {
        return this._modalStack.getTopOpenedModal();
    }
    /**
     * Get the higher `z-index` value between all the modal instances. It iterates over the `ModalStack` array and
     * calculates a higher value (it takes the highest index value between all the modal instances and adds 1).
     * Use it to make a modal appear foreground.
     *
     * @returns a higher index from all the existing modal instances.
     */
    getHigherIndex() {
        return this._modalStack.getHigherIndex();
    }
    /**
     * It gives the number of modal instances. It's helpful to know if the modal stack is empty or not.
     *
     * @returns the number of modal instances.
     */
    getModalStackCount() {
        return this._modalStack.getModalStackCount();
    }
    /**
     * Remove a modal instance from the modal stack.
     *
     * @param id The modal identifier.
     * @returns the removed modal instance.
     */
    removeModal(id) {
        this._modalStack.removeModal(id);
    }
    /**
     * Associate data to an identified modal. If the modal isn't already associated to some data, it creates a new
     * entry in the `modalData` array with its `id` and the given `data`. If the modal already has data, it rewrites
     * them with the new ones. Finally if no modal found it returns an error message in the console and false value
     * as method output.
     *
     * @param data The data you want to associate to the modal.
     * @param id The modal identifier.
     * @param force If true, overrides the previous stored data if there was.
     * @returns true if the given modal exists and the process has been tried, either false.
     */
    setModalData(data, id, force) {
        let i;
        if ((i = this.get(id))) {
            i.setData(data, force);
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Retrieve modal data by its identifier.
     *
     * @param id The modal identifier used at creation time.
     * @returns the associated modal data.
     */
    getModalData(id) {
        let i;
        if ((i = this.get(id))) {
            return i.getData();
        }
        return null;
    }
    /**
     * Reset the data attached to a given modal.
     *
     * @param id The modal identifier used at creation time.
     * @returns the removed data or false if modal doesn't exist.
     */
    resetModalData(id) {
        if (!!this._modalStack.getModalStack().find((o) => o.id === id)) {
            const removed = this.getModal(id).getData();
            this.getModal(id).removeData();
            return removed;
        }
        else {
            return false;
        }
    }
    /**
     * Close the latest opened modal if it has been declared as escapable
     * Using a debounce system because one or more modals could be listening
     * escape key press event.
     */
    closeLatestModal() {
        this.getTopOpenedModal().close();
    }
    /**
     * Create dynamic NgxSmartModalComponent
     * @param id The modal identifier used at creation time.
     * @param content The modal content ( string, templateRef or Component )
     */
    create(id, content, options = {}) {
        try {
            return this.getModal(id);
        }
        catch (e) {
            const componentFactory = this._componentFactoryResolver.resolveComponentFactory(NgxSmartModalComponent);
            const ngContent = this._resolveNgContent(content);
            const componentRef = componentFactory.create(this._injector, ngContent);
            componentRef.instance.identifier = id;
            componentRef.instance.createFrom = "service";
            if (typeof options.closable === "boolean") {
                componentRef.instance.closable = options.closable;
            }
            if (typeof options.escapable === "boolean") {
                componentRef.instance.escapable = options.escapable;
            }
            if (typeof options.dismissible === "boolean") {
                componentRef.instance.dismissible = options.dismissible;
            }
            if (typeof options.customClass === "string") {
                componentRef.instance.customClass = options.customClass;
            }
            if (typeof options.backdrop === "boolean") {
                componentRef.instance.backdrop = options.backdrop;
            }
            if (typeof options.force === "boolean") {
                componentRef.instance.force = options.force;
            }
            if (typeof options.hideDelay === "number") {
                componentRef.instance.hideDelay = options.hideDelay;
            }
            if (typeof options.autostart === "boolean") {
                componentRef.instance.autostart = options.autostart;
            }
            if (typeof options.target === "string") {
                componentRef.instance.target = options.target;
            }
            if (typeof options.ariaLabel === "string") {
                componentRef.instance.ariaLabel = options.ariaLabel;
            }
            if (typeof options.ariaLabelledBy === "string") {
                componentRef.instance.ariaLabelledBy = options.ariaLabelledBy;
            }
            if (typeof options.ariaDescribedBy === "string") {
                componentRef.instance.ariaDescribedBy = options.ariaDescribedBy;
            }
            this._appRef.attachView(componentRef.hostView);
            const domElem = componentRef.hostView
                .rootNodes[0];
            this._document.body.appendChild(domElem);
            return componentRef.instance;
        }
    }
    _addEvents() {
        if (!this.isBrowser) {
            return false;
        }
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "create", ((e) => {
            this._initModal(e.detail.instance);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "delete", ((e) => {
            this._deleteModal(e.detail.instance);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "open", ((e) => {
            this._openModal(e.detail.instance.modal, e.detail.top);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "toggle", ((e) => {
            this._toggleModal(e.detail.instance.modal, e.detail.top);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "close", ((e) => {
            this._closeModal(e.detail.instance.modal);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "confirm", ((e) => {
            this._confirmClicked(e.detail.instance.modal);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "new", ((e) => {
            this._newClicked(e.detail.instance.modal);
        }));
        window.addEventListener(NgxSmartModalConfig.prefixEvent + "dismiss", ((e) => {
            this._dismissModal(e.detail.instance.modal);
        }));
        window.addEventListener("keyup", this._escapeKeyboardEvent);
        return true;
    }
    _initModal(modalInstance) {
        modalInstance.modal.layerPosition += this.getModalStackCount();
        this.addModal(modalInstance, modalInstance.modal.force);
        if (modalInstance.modal.autostart) {
            this.open(modalInstance.id);
        }
    }
    _openModal(modal, top) {
        if (modal.visible) {
            return false;
        }
        this.lastElementFocused = document.activeElement;
        if (modal.escapable) {
            window.addEventListener("keyup", this._escapeKeyboardEvent);
        }
        if (modal.backdrop) {
            window.addEventListener("keydown", this._trapFocusModal);
        }
        if (top) {
            modal.layerPosition = this.getHigherIndex();
        }
        modal.addBodyClass();
        modal.overlayVisible = true;
        modal.visible = true;
        modal.onOpen.emit(modal);
        modal.markForCheck();
        setTimeout(() => {
            modal.openedClass = true;
            if (modal.target) {
                modal.targetPlacement();
            }
            modal.nsmDialog.first.nativeElement.setAttribute("role", "dialog");
            modal.nsmDialog.first.nativeElement.setAttribute("tabIndex", "-1");
            modal.nsmDialog.first.nativeElement.setAttribute("aria-modal", "true");
            modal.nsmDialog.first.nativeElement.focus();
            modal.markForCheck();
            modal.onOpenFinished.emit(modal);
        });
        return true;
    }
    _toggleModal(modal, top) {
        if (modal.visible) {
            return this._closeModal(modal);
        }
        else {
            return this._openModal(modal, top);
        }
    }
    _confirmClicked(modal) {
        modal.onConfirm.emit(modal);
        return true;
    }
    _newClicked(modal) {
        modal.onNew.emit(modal);
        return true;
    }
    _closeModal(modal) {
        if (!modal.openedClass) {
            return false;
        }
        modal.openedClass = false;
        modal.onClose.emit(modal);
        modal.onAnyCloseEvent.emit(modal);
        if (this.getOpenedModals().length < 2) {
            modal.removeBodyClass();
            window.removeEventListener("keyup", this._escapeKeyboardEvent);
            window.removeEventListener("keydown", this._trapFocusModal);
        }
        setTimeout(() => {
            modal.visibleChange.emit(modal.visible);
            modal.visible = false;
            modal.overlayVisible = false;
            modal.nsmDialog.first.nativeElement.removeAttribute("tabIndex");
            modal.markForCheck();
            modal.onCloseFinished.emit(modal);
            modal.onAnyCloseEventFinished.emit(modal);
            this.lastElementFocused.focus();
        }, modal.hideDelay);
        return true;
    }
    _dismissModal(modal) {
        if (!modal.openedClass) {
            return false;
        }
        modal.openedClass = false;
        modal.onDismiss.emit(modal);
        modal.onAnyCloseEvent.emit(modal);
        if (this.getOpenedModals().length < 2) {
            modal.removeBodyClass();
        }
        setTimeout(() => {
            modal.visible = false;
            modal.visibleChange.emit(modal.visible);
            modal.overlayVisible = false;
            modal.markForCheck();
            modal.onDismissFinished.emit(modal);
            modal.onAnyCloseEventFinished.emit(modal);
        }, modal.hideDelay);
        return true;
    }
    _deleteModal(modalInstance) {
        this.removeModal(modalInstance.id);
        if (!this.getModalStack().length) {
            modalInstance.modal.removeBodyClass();
        }
    }
    /**
     * Resolve content according to the types
     * @param content The modal content ( string, templateRef or Component )
     */
    _resolveNgContent(content) {
        if (typeof content === "string") {
            const element = this._document.createTextNode(content);
            return [[element]];
        }
        if (content instanceof TemplateRef) {
            const viewRef = content.createEmbeddedView(null);
            return [viewRef.rootNodes];
        }
        const factory = this._componentFactoryResolver.resolveComponentFactory(content);
        const componentRef = factory.create(this._injector);
        return [
            [componentRef.location.nativeElement],
            [this._document.createTextNode("")]
        ];
    }
    /**
     * Is current platform browser
     */
    get isBrowser() {
        return isPlatformBrowser(this._platformId);
    }
}
/** @nocollapse */ NgxSmartModalService.ngInjectableDef = ɵɵdefineInjectable({ token: NgxSmartModalService, factory: function NgxSmartModalService_Factory(t) { return new (t || NgxSmartModalService)(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(Injector), ɵɵinject(DOCUMENT), ɵɵinject(NgxSmartModalStackService), ɵɵinject(PLATFORM_ID)); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(NgxSmartModalService, [{
        type: Injectable
    }], function () { return [{ type: ComponentFactoryResolver }, { type: ApplicationRef }, { type: Injector }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: NgxSmartModalStackService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null);

class NgxSmartModalModule {
    constructor(serivce) {
        this.serivce = serivce;
    }
    /**
     * Use in AppModule: new instance of NgxSmartModal.
     */
    static forRoot() {
        return {
            ngModule: NgxSmartModalModule,
            providers: [NgxSmartModalService, NgxSmartModalStackService]
        };
    }
    /**
     * Use in features modules with lazy loading: new instance of NgxSmartModal.
     */
    static forChild() {
        return {
            ngModule: NgxSmartModalModule,
            providers: [NgxSmartModalService, NgxSmartModalStackService]
        };
    }
}
/** @nocollapse */ NgxSmartModalModule.ngModuleDef = ɵɵdefineNgModule({ type: NgxSmartModalModule });
/** @nocollapse */ NgxSmartModalModule.ngInjectorDef = ɵɵdefineInjector({ factory: function NgxSmartModalModule_Factory(t) { return new (t || NgxSmartModalModule)(ɵɵinject(NgxSmartModalService)); }, imports: [[CommonModule, OverlayscrollbarsModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(NgxSmartModalModule, { declarations: [NgxSmartModalComponent], imports: [CommonModule, OverlayscrollbarsModule], exports: [NgxSmartModalComponent] });
/*@__PURE__*/ ɵsetClassMetadata(NgxSmartModalModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxSmartModalComponent],
                entryComponents: [NgxSmartModalComponent],
                exports: [NgxSmartModalComponent],
                imports: [CommonModule, OverlayscrollbarsModule]
            }]
    }], function () { return [{ type: NgxSmartModalService }]; }, null);

class ToastContainerDirective {
    constructor(el) {
        this.el = el;
    }
    getContainerElement() {
        return this.el.nativeElement;
    }
}
/** @nocollapse */ ToastContainerDirective.ngDirectiveDef = ɵɵdefineDirective({ type: ToastContainerDirective, selectors: [["", "toastContainer", ""]], factory: function ToastContainerDirective_Factory(t) { return new (t || ToastContainerDirective)(ɵɵdirectiveInject(ElementRef)); }, exportAs: ["toastContainer"] });
/*@__PURE__*/ ɵsetClassMetadata(ToastContainerDirective, [{
        type: Directive,
        args: [{
                selector: "[toastContainer]",
                exportAs: "toastContainer"
            }]
    }], function () { return [{ type: ElementRef }]; }, null);
class ToastContainerModule {
}
/** @nocollapse */ ToastContainerModule.ngModuleDef = ɵɵdefineNgModule({ type: ToastContainerModule });
/** @nocollapse */ ToastContainerModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastContainerModule_Factory(t) { return new (t || ToastContainerModule)(); } });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastContainerModule, { declarations: [ToastContainerDirective], exports: [ToastContainerDirective] });
/*@__PURE__*/ ɵsetClassMetadata(ToastContainerModule, [{
        type: NgModule,
        args: [{
                declarations: [ToastContainerDirective],
                exports: [ToastContainerDirective]
            }]
    }], null, null);

/**
 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
 */
class ComponentPortal {
    constructor(component, injector) {
        this.component = component;
        this.injector = injector;
    }
    /** Attach this portal to a host. */
    attach(host, newestOnTop) {
        this._attachedHost = host;
        return host.attach(this, newestOnTop);
    }
    /** Detach this portal from its host */
    detach() {
        const host = this._attachedHost;
        if (host) {
            this._attachedHost = undefined;
            return host.detach();
        }
    }
    /** Whether this portal is attached to a host. */
    get isAttached() {
        return this._attachedHost != null;
    }
    /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     */
    setAttachedHost(host) {
        this._attachedHost = host;
    }
}
/**
 * Partial implementation of PortalHost that only deals with attaching a
 * ComponentPortal
 */
class BasePortalHost {
    attach(portal, newestOnTop) {
        this._attachedPortal = portal;
        return this.attachComponentPortal(portal, newestOnTop);
    }
    detach() {
        if (this._attachedPortal) {
            this._attachedPortal.setAttachedHost();
        }
        this._attachedPortal = undefined;
        if (this._disposeFn) {
            this._disposeFn();
            this._disposeFn = undefined;
        }
    }
    setDisposeFn(fn) {
        this._disposeFn = fn;
    }
}

/**
 * Everything a toast needs to launch
 */
class ToastPackage {
    constructor(toastId, config, message, title, toastType, toastRef) {
        this.toastId = toastId;
        this.config = config;
        this.message = message;
        this.title = title;
        this.toastType = toastType;
        this.toastRef = toastRef;
        this._onTap = new Subject();
        this._onAction = new Subject();
        this.toastRef.afterClosed().subscribe(() => {
            this._onAction.complete();
            this._onTap.complete();
        });
    }
    /** Fired on click */
    triggerTap() {
        this._onTap.next();
        if (this.config.tapToDismiss) {
            this._onTap.complete();
        }
    }
    onTap() {
        return this._onTap.asObservable();
    }
    /** available for use in custom toast */
    triggerAction(action) {
        this._onAction.next(action);
    }
    onAction() {
        return this._onAction.asObservable();
    }
}
const DefaultNoComponentGlobalConfig = {
    maxOpened: 0,
    autoDismiss: false,
    newestOnTop: true,
    preventDuplicates: false,
    countDuplicates: false,
    resetTimeoutOnDuplicate: false,
    iconClasses: {
        error: "lib-toast__error",
        fileError: "lib-toast__file-error",
        info: "lib-toast__info",
        success: "lib-toast__success",
        warning: "lib-toast__warning"
    },
    // Individual
    closeButton: true,
    disableTimeOut: false,
    timeOut: 5000,
    extendedTimeOut: 1000,
    enableHtml: true,
    progressBar: false,
    toastClass: "lib-toast__toast",
    positionClass: "toast-bottom-right",
    titleClass: "lib-toast__title",
    messageClass: "lib-toast__message",
    easing: "ease-in",
    easeTime: 300,
    tapToDismiss: false,
    onActivateTick: false,
    progressAnimation: "decreasing"
};
const TOAST_CONFIG = new InjectionToken("ToastConfig");

/**
 * Reference to a toast opened via the Toastr service.
 */
class ToastRef {
    constructor(_overlayRef) {
        this._overlayRef = _overlayRef;
        /** Count of duplicates of this toast */
        this.duplicatesCount = 0;
        /** Subject for notifying the user that the toast has finished closing. */
        this._afterClosed = new Subject();
        /** triggered when toast is activated */
        this._activate = new Subject();
        /** notifies the toast that it should close before the timeout */
        this._manualClose = new Subject();
        /** notifies the toast that it should reset the timeouts */
        this._resetTimeout = new Subject();
        /** notifies the toast that it should count a duplicate toast */
        this._countDuplicate = new Subject();
    }
    manualClose() {
        this._manualClose.next();
        this._manualClose.complete();
    }
    manualClosed() {
        return this._manualClose.asObservable();
    }
    timeoutReset() {
        return this._resetTimeout.asObservable();
    }
    countDuplicate() {
        return this._countDuplicate.asObservable();
    }
    /**
     * Close the toast.
     */
    close() {
        this._overlayRef.detach();
        this._afterClosed.next();
        this._manualClose.next();
        this._afterClosed.complete();
        this._manualClose.complete();
        this._activate.complete();
        this._resetTimeout.complete();
        this._countDuplicate.complete();
    }
    /** Gets an observable that is notified when the toast is finished closing. */
    afterClosed() {
        return this._afterClosed.asObservable();
    }
    isInactive() {
        return this._activate.isStopped;
    }
    activate() {
        this._activate.next();
        this._activate.complete();
    }
    /** Gets an observable that is notified when the toast has started opening. */
    afterActivate() {
        return this._activate.asObservable();
    }
    /** Reset the toast timouts and count duplicates */
    onDuplicate(resetTimeout, countDuplicate) {
        if (resetTimeout) {
            this._resetTimeout.next();
        }
        if (countDuplicate) {
            this._countDuplicate.next(++this.duplicatesCount);
        }
    }
}
/** Custom injector type specifically for instantiating components with a toast. */
class ToastInjector {
    constructor(_toastPackage, _parentInjector) {
        this._toastPackage = _toastPackage;
        this._parentInjector = _parentInjector;
    }
    get(token, notFoundValue, flags) {
        if (token === ToastPackage) {
            return this._toastPackage;
        }
        return this._parentInjector.get(token, notFoundValue, flags);
    }
}

/**
 * A PortalHost for attaching portals to an arbitrary DOM element outside of the Angular
 * application context.
 *
 * This is the only part of the portal core that directly touches the DOM.
 */
class DomPortalHost extends BasePortalHost {
    constructor(_hostDomElement, _componentFactoryResolver, _appRef) {
        super();
        this._hostDomElement = _hostDomElement;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
    }
    /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @param portal Portal to be attached
     */
    attachComponentPortal(portal, newestOnTop) {
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        let componentRef;
        // If the portal specifies a ViewContainerRef, we will use that as the attachment point
        // for the component (in terms of Angular's component tree, not rendering).
        // When the ViewContainerRef is missing, we use the factory to create the component directly
        // and then manually attach the ChangeDetector for that component to the application (which
        // happens automatically when using a ViewContainer).
        componentRef = componentFactory.create(portal.injector);
        // When creating a component outside of a ViewContainer, we need to manually register
        // its ChangeDetector with the application. This API is unfortunately not yet published
        // in Angular core. The change detector must also be deregistered when the component
        // is destroyed to prevent memory leaks.
        this._appRef.attachView(componentRef.hostView);
        this.setDisposeFn(() => {
            this._appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        });
        // At this point the component has been instantiated, so we move it to the location in the DOM
        // where we want it to be rendered.
        if (newestOnTop) {
            this._hostDomElement.insertBefore(this._getComponentRootNode(componentRef), this._hostDomElement.firstChild);
        }
        else {
            this._hostDomElement.appendChild(this._getComponentRootNode(componentRef));
        }
        return componentRef;
    }
    /** Gets the root HTMLElement for an instantiated component. */
    _getComponentRootNode(componentRef) {
        return componentRef.hostView.rootNodes[0];
    }
}

/**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */
class OverlayRef {
    constructor(_portalHost) {
        this._portalHost = _portalHost;
    }
    attach(portal, newestOnTop = true) {
        return this._portalHost.attach(portal, newestOnTop);
    }
    /**
     * Detaches an overlay from a portal.
     * @returns Resolves when the overlay has been detached.
     */
    detach() {
        return this._portalHost.detach();
    }
}

/** Container inside which all toasts will render. */
class OverlayContainer {
    constructor(_document) {
        this._document = _document;
    }
    ngOnDestroy() {
        if (this._containerElement && this._containerElement.parentNode) {
            this._containerElement.parentNode.removeChild(this._containerElement);
        }
    }
    /**
     * This method returns the overlay container element. It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @returns the container element
     */
    getContainerElement() {
        if (!this._containerElement) {
            this._createContainer();
        }
        return this._containerElement;
    }
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     */
    _createContainer() {
        const container = this._document.createElement('div');
        container.classList.add('overlay-container');
        this._document.body.appendChild(container);
        this._containerElement = container;
    }
}
/** @nocollapse */ OverlayContainer.ngInjectableDef = ɵɵdefineInjectable({ token: OverlayContainer, factory: function OverlayContainer_Factory(t) { return new (t || OverlayContainer)(ɵɵinject(DOCUMENT)); }, providedIn: 'root' });
/*@__PURE__*/ ɵsetClassMetadata(OverlayContainer, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null);

/**
 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
 * used as a low-level building building block for other components. Dialogs, menus,
 * selects, etc. can all be built using overlays. The service should primarily be used by authors
 * of re-usable components rather than developers building end-user applications.
 *
 * An overlay *is* a PortalHost, so any kind of Portal can be loaded into one.
 */
class Overlay {
    constructor(_overlayContainer, _componentFactoryResolver, _appRef, _document) {
        this._overlayContainer = _overlayContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
        this._document = _document;
        // Namespace panes by overlay container
        this._paneElements = new Map();
    }
    /**
     * Creates an overlay.
     * @returns A reference to the created overlay.
     */
    create(positionClass, overlayContainer) {
        // get existing pane if possible
        return this._createOverlayRef(this.getPaneElement(positionClass, overlayContainer));
    }
    getPaneElement(positionClass = "", overlayContainer) {
        if (!this._paneElements.get(overlayContainer)) {
            this._paneElements.set(overlayContainer, {});
        }
        if (!this._paneElements.get(overlayContainer)[positionClass]) {
            this._paneElements.get(overlayContainer)[positionClass] = this._createPaneElement(positionClass, overlayContainer);
        }
        return this._paneElements.get(overlayContainer)[positionClass];
    }
    /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @returns Newly-created pane element
     */
    _createPaneElement(positionClass, overlayContainer) {
        const pane = this._document.createElement("div");
        pane.id = "lib-toast-container";
        pane.classList.add(positionClass);
        pane.classList.add("lib-toast__container");
        if (!overlayContainer) {
            this._overlayContainer.getContainerElement().appendChild(pane);
        }
        else {
            overlayContainer.getContainerElement().appendChild(pane);
        }
        return pane;
    }
    /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param pane The DOM element to turn into a portal host.
     * @returns A portal host for the given DOM element.
     */
    _createPortalHost(pane) {
        return new DomPortalHost(pane, this._componentFactoryResolver, this._appRef);
    }
    /**
     * Creates an OverlayRef for an overlay in the given DOM element.
     * @param pane DOM element for the overlay
     */
    _createOverlayRef(pane) {
        return new OverlayRef(this._createPortalHost(pane));
    }
}
/** @nocollapse */ Overlay.ngInjectableDef = ɵɵdefineInjectable({ token: Overlay, factory: function Overlay_Factory(t) { return new (t || Overlay)(ɵɵinject(OverlayContainer), ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(DOCUMENT)); }, providedIn: "root" });
/*@__PURE__*/ ɵsetClassMetadata(Overlay, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: OverlayContainer }, { type: ComponentFactoryResolver }, { type: ApplicationRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null);

class ToastrService {
    constructor(token, overlay, _injector, sanitizer, ngZone) {
        this.overlay = overlay;
        this._injector = _injector;
        this.sanitizer = sanitizer;
        this.ngZone = ngZone;
        this.currentlyActive = 0;
        this.toasts = [];
        this.index = 0;
        this.toastrConfig = Object.assign({}, token.default, token.config);
        if (token.config.iconClasses) {
            this.toastrConfig.iconClasses = Object.assign({}, token.default.iconClasses, token.config.iconClasses);
        }
    }
    /** show toast */
    show(message, title, override = {}, type = "") {
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show successful toast */
    success(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.success || "";
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show error toast */
    error(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.error || "";
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show error toast */
    fileError(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.fileError || "";
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show info toast */
    info(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.info || "";
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show warning toast */
    warning(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.warning || "";
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /**
     * Remove all or a single toast by id
     */
    clear(toastId) {
        // Call every toastRef manualClose function
        for (const toast of this.toasts) {
            if (toastId !== undefined) {
                if (toast.toastId === toastId) {
                    toast.toastRef.manualClose();
                    return;
                }
            }
            else {
                toast.toastRef.manualClose();
            }
        }
    }
    /**
     * Remove and destroy a single toast by id
     */
    remove(toastId) {
        const found = this._findToast(toastId);
        if (!found) {
            return false;
        }
        found.activeToast.toastRef.close();
        this.toasts.splice(found.index, 1);
        this.currentlyActive = this.currentlyActive - 1;
        if (!this.toastrConfig.maxOpened || !this.toasts.length) {
            return false;
        }
        if (this.currentlyActive < this.toastrConfig.maxOpened &&
            this.toasts[this.currentlyActive]) {
            const p = this.toasts[this.currentlyActive].toastRef;
            if (!p.isInactive()) {
                this.currentlyActive = this.currentlyActive + 1;
                p.activate();
            }
        }
        return true;
    }
    /**
     * Determines if toast message is already shown
     */
    findDuplicate(message, resetOnDuplicate, countDuplicates) {
        for (const toast of this.toasts) {
            if (toast.message === message) {
                toast.toastRef.onDuplicate(resetOnDuplicate, countDuplicates);
                return toast;
            }
        }
        return null;
    }
    /** create a clone of global config and apply individual settings */
    applyConfig(override = {}) {
        return Object.assign({}, this.toastrConfig, override);
    }
    /**
     * Find toast object by id
     */
    _findToast(toastId) {
        for (let i = 0; i < this.toasts.length; i++) {
            if (this.toasts[i].toastId === toastId) {
                return { index: i, activeToast: this.toasts[i] };
            }
        }
        return null;
    }
    /**
     * Determines the need to run inside angular's zone then builds the toast
     */
    _preBuildNotification(toastType, message, title, config) {
        if (config.onActivateTick) {
            return this.ngZone.run(() => this._buildNotification(toastType, message, title, config));
        }
        return this._buildNotification(toastType, message, title, config);
    }
    /**
     * Creates and attaches toast data to component
     * returns the active toast, or in case preventDuplicates is enabled the original/non-duplicate active toast.
     */
    _buildNotification(toastType, message, title, config) {
        if (!config.toastComponent) {
            throw new Error("toastComponent required");
        }
        // max opened and auto dismiss = true
        // if timeout = 0 resetting it would result in setting this.hideTime = Date.now(). Hence, we only want to reset timeout if there is
        // a timeout at all
        const duplicate = this.findDuplicate(message, this.toastrConfig.resetTimeoutOnDuplicate && config.timeOut > 0, this.toastrConfig.countDuplicates);
        if (message && this.toastrConfig.preventDuplicates && duplicate !== null) {
            return duplicate;
        }
        this.previousToastMessage = message;
        let keepInactive = false;
        if (this.toastrConfig.maxOpened &&
            this.currentlyActive >= this.toastrConfig.maxOpened) {
            keepInactive = true;
            if (this.toastrConfig.autoDismiss) {
                this.clear(this.toasts[0].toastId);
            }
        }
        const overlayRef = this.overlay.create(config.positionClass, this.overlayContainer);
        this.index = this.index + 1;
        let sanitizedMessage = message;
        if (message && config.enableHtml) {
            sanitizedMessage = this.sanitizer.sanitize(SecurityContext.HTML, message);
        }
        const toastRef = new ToastRef(overlayRef);
        const toastPackage = new ToastPackage(this.index, config, sanitizedMessage, title, toastType, toastRef);
        const toastInjector = new ToastInjector(toastPackage, this._injector);
        const component = new ComponentPortal(config.toastComponent, toastInjector);
        const portal = overlayRef.attach(component, this.toastrConfig.newestOnTop);
        toastRef.componentInstance = portal._component;
        const ins = {
            toastId: this.index,
            message: message || "",
            toastRef,
            onShown: toastRef.afterActivate(),
            onHidden: toastRef.afterClosed(),
            onTap: toastPackage.onTap(),
            onAction: toastPackage.onAction(),
            portal
        };
        if (!keepInactive) {
            setTimeout(() => {
                ins.toastRef.activate();
                this.currentlyActive = this.currentlyActive + 1;
            });
        }
        this.toasts.push(ins);
        return ins;
    }
}
/** @nocollapse */ ToastrService.ngInjectableDef = ɵɵdefineInjectable({ token: ToastrService, factory: function ToastrService_Factory(t) { return new (t || ToastrService)(ɵɵinject(TOAST_CONFIG), ɵɵinject(Overlay), ɵɵinject(Injector), ɵɵinject(DomSanitizer), ɵɵinject(NgZone)); }, providedIn: "root" });
/*@__PURE__*/ ɵsetClassMetadata(ToastrService, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TOAST_CONFIG]
            }] }, { type: Overlay }, { type: Injector }, { type: DomSanitizer }, { type: NgZone }]; }, null);

const _c0$7 = ["lib-toast-component", ""];
const _c1$7 = [1, "lib-toast__content"];
const _c2$6 = [3, "class", 4, "ngIf"];
const _c3$6 = ["role", "alertdialog", "aria-live", "polite", 3, "class", "innerHTML", 4, "ngIf"];
const _c4$5 = ["role", "alertdialog", "aria-live", "polite", 3, "class", 4, "ngIf"];
const _c5$5 = [4, "ngIf"];
const _c6$4 = ["class", "lib-toast__close-button", "aria-label", "Close", 3, "click", 4, "ngIf"];
function ToastComponent_h4_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r337 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵtextInterpolate1("[", ctx_r337.duplicatesCount + 1, "]");
} }
function ToastComponent_h4_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h4");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵtemplate(2, ToastComponent_h4_1_ng_container_2_Template, 2, 1, "ng-container", _c5$5);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r332 = ɵɵnextContext();
    ɵɵclassMap(ctx_r332.options.titleClass);
    ɵɵstylingApply();
    ɵɵattribute("aria-label", ctx_r332.title);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r332.title, " ");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r332.duplicatesCount);
} }
const _c7$3 = ["role", "alertdialog", "aria-live", "polite", 3, "innerHTML"];
function ToastComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c7$3);
    ɵɵstyling();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r333 = ɵɵnextContext();
    ɵɵclassMap(ctx_r333.options.messageClass);
    ɵɵstylingApply();
    ɵɵproperty("innerHTML", ctx_r333.message, ɵɵsanitizeHtml);
} }
const _c8$3 = ["role", "alertdialog", "aria-live", "polite"];
function ToastComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c8$3);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r334 = ɵɵnextContext();
    ɵɵclassMap(ctx_r334.options.messageClass);
    ɵɵstylingApply();
    ɵɵattribute("aria-label", ctx_r334.message);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r334.message, " ");
} }
const _c9$3 = [1, "lib-toast__progress"];
function ToastComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c9$3);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r335 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵstyleProp("width", ctx_r335.width + "%");
    ɵɵstylingApply();
} }
const _c10$3 = ["aria-label", "Close", 1, "lib-toast__close-button", 3, "click"];
function ToastComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r339 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c10$3);
    ɵɵlistener("click", function ToastComponent_button_5_Template_button_click_0_listener($event) { ɵɵrestoreView(_r339); const ctx_r338 = ɵɵnextContext(); return ctx_r338.remove(); });
    ɵɵelementEnd();
} }
class ToastComponent {
    constructor(toastrService, toastPackage, ngZone) {
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
        this.ngZone = ngZone;
        /** width of progress bar */
        this.width = -1;
        /** a combination of toast type and options.toastClass */
        this.toastClasses = "";
        /** controls animation */
        this.state = {
            value: "inactive",
            params: {
                easeTime: this.toastPackage.config.easeTime,
                easing: "ease-in"
            }
        };
        this.message = toastPackage.message;
        this.title = toastPackage.title;
        this.options = toastPackage.config;
        this.originalTimeout = toastPackage.config.timeOut;
        this.toastClasses = `${toastPackage.toastType} ${toastPackage.config.toastClass}`;
        this.sub = toastPackage.toastRef.afterActivate().subscribe(() => {
            this.activateToast();
        });
        this.sub1 = toastPackage.toastRef.manualClosed().subscribe(() => {
            this.remove();
        });
        this.sub2 = toastPackage.toastRef.timeoutReset().subscribe(() => {
            this.resetTimeout();
        });
        this.sub3 = toastPackage.toastRef.countDuplicate().subscribe(count => {
            this.duplicatesCount = count;
        });
    }
    /** hides component when waiting to be displayed */
    get displayStyle() {
        if (this.state.value === "inactive") {
            return "none";
        }
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.sub1.unsubscribe();
        this.sub2.unsubscribe();
        this.sub3.unsubscribe();
        clearInterval(this.intervalId);
        clearTimeout(this.timeout);
    }
    /**
     * activates toast and sets timeout
     */
    activateToast() {
        this.state = Object.assign({}, this.state, { value: "active" });
        if (!(this.options.disableTimeOut === true ||
            this.options.disableTimeOut === "timeOut") &&
            this.options.timeOut) {
            this.outsideTimeout(() => this.remove(), this.options.timeOut);
            this.hideTime = new Date().getTime() + this.options.timeOut;
            if (this.options.progressBar) {
                this.outsideInterval(() => this.updateProgress(), 10);
            }
        }
    }
    /**
     * updates progress bar width
     */
    updateProgress() {
        if (this.width === 0 || this.width === 100 || !this.options.timeOut) {
            return;
        }
        const now = new Date().getTime();
        const remaining = this.hideTime - now;
        this.width = (remaining / this.options.timeOut) * 100;
        if (this.options.progressAnimation === "increasing") {
            this.width = 100 - this.width;
        }
        if (this.width <= 0) {
            this.width = 0;
        }
        if (this.width >= 100) {
            this.width = 100;
        }
    }
    resetTimeout() {
        clearTimeout(this.timeout);
        clearInterval(this.intervalId);
        this.state = Object.assign({}, this.state, { value: "active" });
        this.outsideTimeout(() => this.remove(), this.originalTimeout);
        this.options.timeOut = this.originalTimeout;
        this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
        this.width = -1;
        if (this.options.progressBar) {
            this.outsideInterval(() => this.updateProgress(), 10);
        }
    }
    /**
     * tells toastrService to remove this toast after animation time
     */
    remove() {
        if (this.state.value === "removed") {
            return;
        }
        clearTimeout(this.timeout);
        this.state = Object.assign({}, this.state, { value: "removed" });
        this.outsideTimeout(() => this.toastrService.remove(this.toastPackage.toastId), +this.toastPackage.config.easeTime);
    }
    tapToast() {
        if (this.state.value === "removed") {
            return;
        }
        this.toastPackage.triggerTap();
        if (this.options.tapToDismiss) {
            this.remove();
        }
    }
    stickAround() {
        if (this.state.value === "removed") {
            return;
        }
        clearTimeout(this.timeout);
        this.options.timeOut = 0;
        this.hideTime = 0;
        // disable progressBar
        clearInterval(this.intervalId);
        this.width = 0;
    }
    delayedHideToast() {
        if (this.options.disableTimeOut === true ||
            this.options.disableTimeOut === "extendedTimeOut" ||
            this.options.extendedTimeOut === 0 ||
            this.state.value === "removed") {
            return;
        }
        this.outsideTimeout(() => this.remove(), this.options.extendedTimeOut);
        this.options.timeOut = this.options.extendedTimeOut;
        this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
        this.width = -1;
        if (this.options.progressBar) {
            this.outsideInterval(() => this.updateProgress(), 10);
        }
    }
    outsideTimeout(func, timeout) {
        if (this.ngZone) {
            this.ngZone.runOutsideAngular(() => (this.timeout = setTimeout(() => this.runInsideAngular(func), timeout)));
        }
        else {
            this.timeout = setTimeout(() => func(), timeout);
        }
    }
    outsideInterval(func, timeout) {
        if (this.ngZone) {
            this.ngZone.runOutsideAngular(() => (this.intervalId = setInterval(() => this.runInsideAngular(func), timeout)));
        }
        else {
            this.intervalId = setInterval(() => func(), timeout);
        }
    }
    runInsideAngular(func) {
        if (this.ngZone) {
            this.ngZone.run(() => func());
        }
        else {
            func();
        }
    }
}
/** @nocollapse */ ToastComponent.ngComponentDef = ɵɵdefineComponent({ type: ToastComponent, selectors: [["", "lib-toast-component", ""]], factory: function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵɵdirectiveInject(ToastrService), ɵɵdirectiveInject(ToastPackage), ɵɵdirectiveInject(NgZone)); }, hostBindings: function ToastComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(3);
        ɵɵlistener("click", function ToastComponent_click_HostBindingHandler($event) { return ctx.tapToast(); });
        ɵɵlistener("mouseenter", function ToastComponent_mouseenter_HostBindingHandler($event) { return ctx.stickAround(); });
        ɵɵlistener("mouseleave", function ToastComponent_mouseleave_HostBindingHandler($event) { return ctx.delayedHideToast(); });
        ɵɵstyling();
    } if (rf & 2) {
        ɵɵupdateSyntheticHostBinding("@flyInOut", ctx.state);
        ɵɵclassMap(ctx.toastClasses);
        ɵɵstyleProp("display", ctx.displayStyle);
        ɵɵstylingApply();
    } }, attrs: _c0$7, consts: 6, vars: 5, template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$7);
        ɵɵtemplate(1, ToastComponent_h4_1_Template, 3, 4, "h4", _c2$6);
        ɵɵtemplate(2, ToastComponent_div_2_Template, 1, 2, "div", _c3$6);
        ɵɵtemplate(3, ToastComponent_div_3_Template, 2, 3, "div", _c4$5);
        ɵɵtemplate(4, ToastComponent_div_4_Template, 2, 1, "div", _c5$5);
        ɵɵelementEnd();
        ɵɵtemplate(5, ToastComponent_button_5_Template, 1, 0, "button", _c6$4);
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.title);
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.message && ctx.options.enableHtml);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.message && !ctx.options.enableHtml);
        ɵɵselect(4);
        ɵɵproperty("ngIf", ctx.options.progressBar);
        ɵɵselect(5);
        ɵɵproperty("ngIf", ctx.options.closeButton);
    } }, directives: [NgIf], styles: [".lib-toast__message a:link{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent;cursor:pointer}.lib-toast__message,.lib-toast__message a:link,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.lib-toast__message,.lib-toast__message a:link{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286;width:22.4rem;word-wrap:break-word}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.lib-toast__container{bottom:4rem;pointer-events:none;position:fixed;right:10.5rem;z-index:999999}@media (max-width:1279px){.lib-toast{bottom:2rem;right:2rem}}.lib-toast__title{font-weight:700}.lib-toast__toast{-webkit-box-align:center;align-items:center;border-radius:0;background-color:#fff;color:#322d32;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;padding:2.4rem 1.3rem 2.4rem 4.6rem;pointer-events:auto;position:relative;max-width:31.6rem;min-width:31.6rem}.lib-toast__toast:not(:last-of-type){margin-bottom:1.6rem}.lib-toast__toast:before{content:\"\";display:block;position:absolute;top:0;right:0;left:0;bottom:0;opacity:1;z-index:-1;background:#fff}.lib-toast__toast:after{content:\"\";position:absolute;top:0;right:0;left:0;bottom:0;opacity:.43;width:100%;z-index:-2;-webkit-filter:blur(2rem);filter:blur(2rem);background-image:radial-gradient(50% 100% at 50% 100%,rgba(255,86,124,.15) 50%,rgba(255,86,124,0) 100%),radial-gradient(50% 100% at bottom right,#a664fd 0,rgba(166,100,253,0) 100%),radial-gradient(50% 100% at bottom left,#5487fd 0,rgba(60,116,246,0) 100%),-webkit-gradient(linear,left top,left bottom,from(#ffa1b5),to(#ffba9f));background-image:radial-gradient(50% 100% at 50% 100%,rgba(255,86,124,.15) 50%,rgba(255,86,124,0) 100%),radial-gradient(50% 100% at bottom right,#a664fd 0,rgba(166,100,253,0) 100%),radial-gradient(50% 100% at bottom left,#5487fd 0,rgba(60,116,246,0) 100%),linear-gradient(180deg,#ffa1b5 0,#ffba9f 100%)}.lib-toast__message:before{content:\"\";display:block;position:absolute;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M10 17.5c-4.136 0-7.5-3.364-7.5-7.5S5.864 2.5 10 2.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zm0-14c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zm0 9a1 1 0 110 2 1 1 0 010-2zm.5-2V6a.5.5 0 00-1 0v4.5a.5.5 0 001 0z' fill='%23656066'/%3E%3C/svg%3E\");background-position:1.3rem center;background-repeat:no-repeat;background-size:2rem;bottom:0;left:0;top:0;opacity:1;width:4.6rem}.lib-toast__success .lib-toast__message:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M8.9 15.5c-.1 0-.3-.1-.4-.1l-4-4c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l3.6 3.6 5.8-7.6c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-6.1 8c-.1.1-.3.2-.4.2z' fill='%23656066'/%3E%3C/svg%3E\")}.lib-toast__file-error .lib-toast__message:before{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/missing-pair.svg)}.lib-toast__message a:link:hover{text-decoration:underline}.lib-toast__close-button{background-color:transparent;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3ClinearGradient id='toast-msg-gradient' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%235487fd' /%3E%3Cstop offset='100%25' stop-color='%23a664fd' /%3E%3C/linearGradient%3E%3Cpath class='icon-color' d='M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z' fill='%23656066'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:center;border:0;height:2rem;width:2rem}.lib-toast__close-button:hover{outline:0;cursor:pointer;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3ClinearGradient id='toast-msg-gradient' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%235487fd' /%3E%3Cstop offset='100%25' stop-color='%23a664fd' /%3E%3C/linearGradient%3E%3Cpath fill='url(%23toast-msg-gradient) %237723e6' class='icon-color' d='M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z' /%3E%3C/svg%3E\");opacity:1;-webkit-transform:scale(1.2);transform:scale(1.2)}.lib-toast__progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}"], encapsulation: 2, data: { animation: [
            trigger("flyInOut", [
                state("inactive", style({ opacity: 0 })),
                state("active", style({ opacity: 1 })),
                state("removed", style({ opacity: 0 })),
                transition("inactive => active", animate("{{ easeTime }}ms {{ easing }}")),
                transition("active => removed", animate("{{ easeTime }}ms {{ easing }}"))
            ])
        ] }, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{
                selector: "[lib-toast-component]",
                templateUrl: "./toastr.component.html",
                styleUrls: ["./toastr.component.scss"],
                animations: [
                    trigger("flyInOut", [
                        state("inactive", style({ opacity: 0 })),
                        state("active", style({ opacity: 1 })),
                        state("removed", style({ opacity: 0 })),
                        transition("inactive => active", animate("{{ easeTime }}ms {{ easing }}")),
                        transition("active => removed", animate("{{ easeTime }}ms {{ easing }}"))
                    ])
                ],
                preserveWhitespaces: false,
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ToastrService }, { type: ToastPackage }, { type: NgZone }]; }, { toastClasses: [{
            type: HostBinding,
            args: ["class"]
        }], state: [{
            type: HostBinding,
            args: ["@flyInOut"]
        }], displayStyle: [{
            type: HostBinding,
            args: ["style.display"]
        }], tapToast: [{
            type: HostListener,
            args: ["click"]
        }], stickAround: [{
            type: HostListener,
            args: ["mouseenter"]
        }], delayedHideToast: [{
            type: HostListener,
            args: ["mouseleave"]
        }] });

const DefaultGlobalConfig = Object.assign({}, DefaultNoComponentGlobalConfig, { toastComponent: ToastComponent });
class ToastrModule {
    static forRoot(config = {}) {
        return {
            ngModule: ToastrModule,
            providers: [
                {
                    provide: TOAST_CONFIG,
                    useValue: {
                        default: DefaultGlobalConfig,
                        config
                    }
                }
            ]
        };
    }
}
/** @nocollapse */ ToastrModule.ngModuleDef = ɵɵdefineNgModule({ type: ToastrModule });
/** @nocollapse */ ToastrModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastrModule_Factory(t) { return new (t || ToastrModule)(); }, imports: [[CommonModule, BrowserAnimationsModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastrModule, { declarations: [ToastComponent], imports: [CommonModule, BrowserAnimationsModule], exports: [ToastComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ToastrModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BrowserAnimationsModule],
                declarations: [ToastComponent],
                exports: [ToastComponent],
                entryComponents: [ToastComponent]
            }]
    }], null, null);
class ToastrComponentlessModule {
    static forRoot(config = {}) {
        return {
            ngModule: ToastrModule,
            providers: [
                {
                    provide: TOAST_CONFIG,
                    useValue: {
                        default: DefaultNoComponentGlobalConfig,
                        config
                    }
                }
            ]
        };
    }
}
/** @nocollapse */ ToastrComponentlessModule.ngModuleDef = ɵɵdefineNgModule({ type: ToastrComponentlessModule });
/** @nocollapse */ ToastrComponentlessModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastrComponentlessModule_Factory(t) { return new (t || ToastrComponentlessModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastrComponentlessModule, { imports: [CommonModule] });
/*@__PURE__*/ ɵsetClassMetadata(ToastrComponentlessModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule]
            }]
    }], null, null);

const _c0$8 = ["lib-toast-component", ""];
const _c1$8 = ["class", "toast-close-button", "aria-label", "Close", 3, "click", 4, "ngIf"];
const _c2$7 = [3, "class", 4, "ngIf"];
const _c3$7 = ["role", "alert", "aria-live", "polite", 3, "class", "innerHTML", 4, "ngIf"];
const _c4$6 = ["role", "alert", "aria-live", "polite", 3, "class", 4, "ngIf"];
const _c5$6 = [4, "ngIf"];
const _c6$5 = ["aria-label", "Close", 1, "toast-close-button", 3, "click"];
const _c7$4 = ["aria-hidden", "true"];
function ToastNoAnimation_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r346 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c6$5);
    ɵɵlistener("click", function ToastNoAnimation_button_0_Template_button_click_0_listener($event) { ɵɵrestoreView(_r346); const ctx_r345 = ɵɵnextContext(); return ctx_r345.remove(); });
    ɵɵelementStart(1, "span", _c7$4);
    ɵɵtext(2, "\u00D7");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function ToastNoAnimation_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r347 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵtextInterpolate1("[", ctx_r347.duplicatesCount + 1, "]");
} }
function ToastNoAnimation_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵtemplate(2, ToastNoAnimation_div_1_ng_container_2_Template, 2, 1, "ng-container", _c5$6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r341 = ɵɵnextContext();
    ɵɵclassMap(ctx_r341.options.titleClass);
    ɵɵstylingApply();
    ɵɵattribute("aria-label", ctx_r341.title);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r341.title, " ");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r341.duplicatesCount);
} }
const _c8$4 = ["role", "alert", "aria-live", "polite", 3, "innerHTML"];
function ToastNoAnimation_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c8$4);
    ɵɵstyling();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r342 = ɵɵnextContext();
    ɵɵclassMap(ctx_r342.options.messageClass);
    ɵɵstylingApply();
    ɵɵproperty("innerHTML", ctx_r342.message, ɵɵsanitizeHtml);
} }
const _c9$4 = ["role", "alert", "aria-live", "polite"];
function ToastNoAnimation_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c9$4);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r343 = ɵɵnextContext();
    ɵɵclassMap(ctx_r343.options.messageClass);
    ɵɵstylingApply();
    ɵɵattribute("aria-label", ctx_r343.message);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r343.message, " ");
} }
const _c10$4 = [1, "toast-progress"];
function ToastNoAnimation_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c10$4);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r344 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵstyleProp("width", ctx_r344.width + "%");
    ɵɵstylingApply();
} }
class ToastNoAnimation {
    constructor(toastrService, toastPackage, appRef) {
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
        this.appRef = appRef;
        /** width of progress bar */
        this.width = -1;
        /** a combination of toast type and options.toastClass */
        this.toastClasses = "";
        /** controls animation */
        this.state = "inactive";
        this.message = toastPackage.message;
        this.title = toastPackage.title;
        this.options = toastPackage.config;
        this.originalTimeout = toastPackage.config.timeOut;
        this.toastClasses = `${toastPackage.toastType} ${toastPackage.config.toastClass}`;
        this.sub = toastPackage.toastRef.afterActivate().subscribe(() => {
            this.activateToast();
        });
        this.sub1 = toastPackage.toastRef.manualClosed().subscribe(() => {
            this.remove();
        });
        this.sub2 = toastPackage.toastRef.timeoutReset().subscribe(() => {
            this.resetTimeout();
        });
        this.sub3 = toastPackage.toastRef.countDuplicate().subscribe(count => {
            this.duplicatesCount = count;
        });
    }
    /** hides component when waiting to be displayed */
    get displayStyle() {
        if (this.state === "inactive") {
            return "none";
        }
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.sub1.unsubscribe();
        this.sub2.unsubscribe();
        this.sub3.unsubscribe();
        clearInterval(this.intervalId);
        clearTimeout(this.timeout);
    }
    /**
     * activates toast and sets timeout
     */
    activateToast() {
        this.state = "active";
        if (!(this.options.disableTimeOut === true ||
            this.options.disableTimeOut === "timeOut") &&
            this.options.timeOut) {
            this.timeout = setTimeout(() => {
                this.remove();
            }, this.options.timeOut);
            this.hideTime = new Date().getTime() + this.options.timeOut;
            if (this.options.progressBar) {
                this.intervalId = setInterval(() => this.updateProgress(), 10);
            }
        }
        if (this.options.onActivateTick) {
            this.appRef.tick();
        }
    }
    /**
     * updates progress bar width
     */
    updateProgress() {
        if (this.width === 0 || this.width === 100 || !this.options.timeOut) {
            return;
        }
        const now = new Date().getTime();
        const remaining = this.hideTime - now;
        this.width = (remaining / this.options.timeOut) * 100;
        if (this.options.progressAnimation === "increasing") {
            this.width = 100 - this.width;
        }
        if (this.width <= 0) {
            this.width = 0;
        }
        if (this.width >= 100) {
            this.width = 100;
        }
    }
    resetTimeout() {
        clearTimeout(this.timeout);
        clearInterval(this.intervalId);
        this.state = "active";
        this.options.timeOut = this.originalTimeout;
        this.timeout = setTimeout(() => this.remove(), this.originalTimeout);
        this.hideTime = new Date().getTime() + (this.originalTimeout || 0);
        this.width = -1;
        if (this.options.progressBar) {
            this.intervalId = setInterval(() => this.updateProgress(), 10);
        }
    }
    /**
     * tells toastrService to remove this toast after animation time
     */
    remove() {
        if (this.state === "removed") {
            return;
        }
        clearTimeout(this.timeout);
        this.state = "removed";
        this.timeout = setTimeout(() => this.toastrService.remove(this.toastPackage.toastId));
    }
    tapToast() {
        if (this.state === "removed") {
            return;
        }
        this.toastPackage.triggerTap();
        if (this.options.tapToDismiss) {
            this.remove();
        }
    }
    stickAround() {
        if (this.state === "removed") {
            return;
        }
        clearTimeout(this.timeout);
        this.options.timeOut = 0;
        this.hideTime = 0;
        // disable progressBar
        clearInterval(this.intervalId);
        this.width = 0;
    }
    delayedHideToast() {
        if (this.options.disableTimeOut === true ||
            this.options.disableTimeOut === "extendedTimeOut" ||
            this.options.extendedTimeOut === 0 ||
            this.state === "removed") {
            return;
        }
        this.timeout = setTimeout(() => this.remove(), this.options.extendedTimeOut);
        this.options.timeOut = this.options.extendedTimeOut;
        this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
        this.width = -1;
        if (this.options.progressBar) {
            this.intervalId = setInterval(() => this.updateProgress(), 10);
        }
    }
}
/** @nocollapse */ ToastNoAnimation.ngComponentDef = ɵɵdefineComponent({ type: ToastNoAnimation, selectors: [["", "lib-toast-component", ""]], factory: function ToastNoAnimation_Factory(t) { return new (t || ToastNoAnimation)(ɵɵdirectiveInject(ToastrService), ɵɵdirectiveInject(ToastPackage), ɵɵdirectiveInject(ApplicationRef)); }, hostBindings: function ToastNoAnimation_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(2);
        ɵɵlistener("click", function ToastNoAnimation_click_HostBindingHandler($event) { return ctx.tapToast(); });
        ɵɵlistener("mouseenter", function ToastNoAnimation_mouseenter_HostBindingHandler($event) { return ctx.stickAround(); });
        ɵɵlistener("mouseleave", function ToastNoAnimation_mouseleave_HostBindingHandler($event) { return ctx.delayedHideToast(); });
        ɵɵstyling();
    } if (rf & 2) {
        ɵɵclassMap(ctx.toastClasses);
        ɵɵstyleProp("display", ctx.displayStyle);
        ɵɵstylingApply();
    } }, attrs: _c0$8, consts: 5, vars: 5, template: function ToastNoAnimation_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ToastNoAnimation_button_0_Template, 3, 0, "button", _c1$8);
        ɵɵtemplate(1, ToastNoAnimation_div_1_Template, 3, 4, "div", _c2$7);
        ɵɵtemplate(2, ToastNoAnimation_div_2_Template, 1, 2, "div", _c3$7);
        ɵɵtemplate(3, ToastNoAnimation_div_3_Template, 2, 3, "div", _c4$6);
        ɵɵtemplate(4, ToastNoAnimation_div_4_Template, 2, 1, "div", _c5$6);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.options.closeButton);
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.title);
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.message && ctx.options.enableHtml);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.message && !ctx.options.enableHtml);
        ɵɵselect(4);
        ɵɵproperty("ngIf", ctx.options.progressBar);
    } }, directives: [NgIf], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(ToastNoAnimation, [{
        type: Component,
        args: [{
                selector: "[lib-toast-component]",
                template: `
    <button
      *ngIf="options.closeButton"
      (click)="remove()"
      class="toast-close-button"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
      {{ title }}
      <ng-container *ngIf="duplicatesCount"
        >[{{ duplicatesCount + 1 }}]</ng-container
      >
    </div>
    <div
      *ngIf="message && options.enableHtml"
      role="alert"
      aria-live="polite"
      [class]="options.messageClass"
      [innerHTML]="message"
    ></div>
    <div
      *ngIf="message && !options.enableHtml"
      role="alert"
      aria-live="polite"
      [class]="options.messageClass"
      [attr.aria-label]="message"
    >
      {{ message }}
    </div>
    <div *ngIf="options.progressBar">
      <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
  `
            }]
    }], function () { return [{ type: ToastrService }, { type: ToastPackage }, { type: ApplicationRef }]; }, { toastClasses: [{
            type: HostBinding,
            args: ["class"]
        }], displayStyle: [{
            type: HostBinding,
            args: ["style.display"]
        }], tapToast: [{
            type: HostListener,
            args: ["click"]
        }], stickAround: [{
            type: HostListener,
            args: ["mouseenter"]
        }], delayedHideToast: [{
            type: HostListener,
            args: ["mouseleave"]
        }] });
const DefaultNoAnimationsGlobalConfig = Object.assign({}, DefaultNoComponentGlobalConfig, { toastComponent: ToastNoAnimation });
class ToastNoAnimationModule {
    static forRoot(config = {}) {
        return {
            ngModule: ToastNoAnimationModule,
            providers: [
                {
                    provide: TOAST_CONFIG,
                    useValue: {
                        default: DefaultNoAnimationsGlobalConfig,
                        config
                    }
                }
            ]
        };
    }
}
/** @nocollapse */ ToastNoAnimationModule.ngModuleDef = ɵɵdefineNgModule({ type: ToastNoAnimationModule });
/** @nocollapse */ ToastNoAnimationModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastNoAnimationModule_Factory(t) { return new (t || ToastNoAnimationModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastNoAnimationModule, { declarations: [ToastNoAnimation], imports: [CommonModule], exports: [ToastNoAnimation] });
/*@__PURE__*/ ɵsetClassMetadata(ToastNoAnimationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ToastNoAnimation],
                exports: [ToastNoAnimation],
                entryComponents: [ToastNoAnimation]
            }]
    }], null, null);

/**
 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
 */
class ComponentPortal$1 {
    constructor(component, injector) {
        this.component = component;
        this.injector = injector;
    }
    /** Attach this portal to a host. */
    attach(host, newestOnTop) {
        this._attachedHost = host;
        return host.attach(this, newestOnTop);
    }
    /** Detach this portal from its host */
    detach() {
        const host = this._attachedHost;
        if (host) {
            this._attachedHost = undefined;
            return host.detach();
        }
    }
    /** Whether this portal is attached to a host. */
    get isAttached() {
        return this._attachedHost != null;
    }
    /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     */
    setAttachedHost(host) {
        this._attachedHost = host;
    }
}
/**
 * Partial implementation of PortalHost that only deals with attaching a
 * ComponentPortal
 */
class BasePortalHost$1 {
    attach(portal, newestOnTop) {
        this._attachedPortal = portal;
        return this.attachComponentPortal(portal, newestOnTop);
    }
    detach() {
        if (this._attachedPortal) {
            this._attachedPortal.setAttachedHost();
        }
        this._attachedPortal = undefined;
        if (this._disposeFn) {
            this._disposeFn();
            this._disposeFn = undefined;
        }
    }
    setDisposeFn(fn) {
        this._disposeFn = fn;
    }
}

/**
 * Everything a toast needs to launch
 */
class ToastPackage$1 {
    constructor(toastId, config, message, title, toastType, toastRef) {
        this.toastId = toastId;
        this.config = config;
        this.message = message;
        this.title = title;
        this.toastType = toastType;
        this.toastRef = toastRef;
        this._onTap = new Subject();
        this._onAction = new Subject();
        this.toastRef.afterClosed().subscribe(() => {
            this._onAction.complete();
            this._onTap.complete();
        });
    }
    /** Fired on click */
    triggerTap() {
        this._onTap.next();
        if (this.config.tapToDismiss) {
            this._onTap.complete();
        }
    }
    onTap() {
        return this._onTap.asObservable();
    }
    /** available for use in custom toast */
    triggerAction(action) {
        this._onAction.next(action);
    }
    onAction() {
        return this._onAction.asObservable();
    }
}
const DefaultNoComponentGlobalConfig$1 = {
    maxOpened: 0,
    autoDismiss: false,
    newestOnTop: true,
    preventDuplicates: false,
    countDuplicates: false,
    resetTimeoutOnDuplicate: false,
    iconClasses: {},
    // Individual
    closeButton: true,
    disableTimeOut: true,
    timeOut: 500,
    extendedTimeOut: 1000,
    enableHtml: true,
    progressBar: false,
    toastClass: "ngx-toastr",
    positionClass: "toast-top-center",
    titleClass: "toast-title",
    messageClass: "toast-message",
    easing: "ease-in",
    easeTime: 300,
    tapToDismiss: false,
    onActivateTick: false,
    progressAnimation: "decreasing"
};
const TOAST_CONFIG$1 = new InjectionToken("ToastConfig");

/**
 * Reference to a toast opened via the Toastr service.
 */
class ToastRef$1 {
    constructor(_overlayRef) {
        this._overlayRef = _overlayRef;
        /** Count of duplicates of this toast */
        this.duplicatesCount = 0;
        /** Subject for notifying the user that the toast has finished closing. */
        this._afterClosed = new Subject();
        /** triggered when toast is activated */
        this._activate = new Subject();
        /** notifies the toast that it should close before the timeout */
        this._manualClose = new Subject();
        /** notifies the toast that it should reset the timeouts */
        this._resetTimeout = new Subject();
        /** notifies the toast that it should count a duplicate toast */
        this._countDuplicate = new Subject();
    }
    manualClose() {
        this._manualClose.next();
        this._manualClose.complete();
    }
    manualClosed() {
        return this._manualClose.asObservable();
    }
    timeoutReset() {
        return this._resetTimeout.asObservable();
    }
    countDuplicate() {
        return this._countDuplicate.asObservable();
    }
    /**
     * Close the toast.
     */
    close() {
        this._overlayRef.detach();
        this._afterClosed.next();
        this._manualClose.next();
        this._afterClosed.complete();
        this._manualClose.complete();
        this._activate.complete();
        this._resetTimeout.complete();
        this._countDuplicate.complete();
    }
    /** Gets an observable that is notified when the toast is finished closing. */
    afterClosed() {
        return this._afterClosed.asObservable();
    }
    isInactive() {
        return this._activate.isStopped;
    }
    activate() {
        this._activate.next();
        this._activate.complete();
    }
    /** Gets an observable that is notified when the toast has started opening. */
    afterActivate() {
        return this._activate.asObservable();
    }
    /** Reset the toast timouts and count duplicates */
    onDuplicate(resetTimeout, countDuplicate) {
        if (resetTimeout) {
            this._resetTimeout.next();
        }
        if (countDuplicate) {
            this._countDuplicate.next(++this.duplicatesCount);
        }
    }
}
/** Custom injector type specifically for instantiating components with a toast. */
class ToastInjector$1 {
    constructor(_toastPackage, _parentInjector) {
        this._toastPackage = _toastPackage;
        this._parentInjector = _parentInjector;
    }
    get(token, notFoundValue, flags) {
        if (token === ToastPackage$1) {
            return this._toastPackage;
        }
        return this._parentInjector.get(token, notFoundValue, flags);
    }
}

/**
 * A PortalHost for attaching portals to an arbitrary DOM element outside of the Angular
 * application context.
 *
 * This is the only part of the portal core that directly touches the DOM.
 */
class DomPortalHost$1 extends BasePortalHost$1 {
    constructor(_hostDomElement, _componentFactoryResolver, _appRef) {
        super();
        this._hostDomElement = _hostDomElement;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
    }
    /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @param portal Portal to be attached
     */
    attachComponentPortal(portal, newestOnTop) {
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        let componentRef;
        // If the portal specifies a ViewContainerRef, we will use that as the attachment point
        // for the component (in terms of Angular's component tree, not rendering).
        // When the ViewContainerRef is missing, we use the factory to create the component directly
        // and then manually attach the ChangeDetector for that component to the application (which
        // happens automatically when using a ViewContainer).
        componentRef = componentFactory.create(portal.injector);
        // When creating a component outside of a ViewContainer, we need to manually register
        // its ChangeDetector with the application. This API is unfortunately not yet published
        // in Angular core. The change detector must also be deregistered when the component
        // is destroyed to prevent memory leaks.
        this._appRef.attachView(componentRef.hostView);
        this.setDisposeFn(() => {
            this._appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        });
        // At this point the component has been instantiated, so we move it to the location in the DOM
        // where we want it to be rendered.
        if (newestOnTop) {
            this._hostDomElement.insertBefore(this._getComponentRootNode(componentRef), this._hostDomElement.firstChild);
        }
        else {
            this._hostDomElement.appendChild(this._getComponentRootNode(componentRef));
        }
        return componentRef;
    }
    /** Gets the root HTMLElement for an instantiated component. */
    _getComponentRootNode(componentRef) {
        return componentRef.hostView.rootNodes[0];
    }
}

/**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */
class OverlayRef$1 {
    constructor(_portalHost) {
        this._portalHost = _portalHost;
    }
    attach(portal, newestOnTop = true) {
        return this._portalHost.attach(portal, newestOnTop);
    }
    /**
     * Detaches an overlay from a portal.
     * @returns Resolves when the overlay has been detached.
     */
    detach() {
        return this._portalHost.detach();
    }
}

/** Container inside which all toasts will render. */
class OverlayContainer$1 {
    constructor(_document) {
        this._document = _document;
    }
    ngOnDestroy() {
        if (this._containerElement && this._containerElement.parentNode) {
            this._containerElement.parentNode.removeChild(this._containerElement);
        }
    }
    /**
     * This method returns the overlay container element. It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @returns the container element
     */
    getContainerElement() {
        if (!this._containerElement) {
            this._createContainer();
        }
        return this._containerElement;
    }
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     */
    _createContainer() {
        const container = this._document.createElement('div');
        container.classList.add('overlay-container');
        this._document.body.appendChild(container);
        this._containerElement = container;
    }
}
/** @nocollapse */ OverlayContainer$1.ngInjectableDef = ɵɵdefineInjectable({ token: OverlayContainer$1, factory: function OverlayContainer_Factory(t) { return new (t || OverlayContainer$1)(ɵɵinject(DOCUMENT)); }, providedIn: 'root' });
/*@__PURE__*/ ɵsetClassMetadata(OverlayContainer$1, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null);

/**
 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
 * used as a low-level building building block for other components. Dialogs, menus,
 * selects, etc. can all be built using overlays. The service should primarily be used by authors
 * of re-usable components rather than developers building end-user applications.
 *
 * An overlay *is* a PortalHost, so any kind of Portal can be loaded into one.
 */
class Overlay$1 {
    constructor(_overlayContainer, _componentFactoryResolver, _appRef, _document) {
        this._overlayContainer = _overlayContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
        this._document = _document;
        // Namespace panes by overlay container
        this._paneElements = new Map();
    }
    /**
     * Creates an overlay.
     * @returns A reference to the created overlay.
     */
    create(positionClass, overlayContainer) {
        // get existing pane if possible
        return this._createOverlayRef(this.getPaneElement(positionClass, overlayContainer));
    }
    getPaneElement(positionClass = '', overlayContainer) {
        if (!this._paneElements.get(overlayContainer)) {
            this._paneElements.set(overlayContainer, {});
        }
        if (!this._paneElements.get(overlayContainer)[positionClass]) {
            this._paneElements.get(overlayContainer)[positionClass] = this._createPaneElement(positionClass, overlayContainer);
        }
        return this._paneElements.get(overlayContainer)[positionClass];
    }
    /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @returns Newly-created pane element
     */
    _createPaneElement(positionClass, overlayContainer) {
        const pane = this._document.createElement('div');
        pane.id = 'banner-notification'; // 'toast-container';
        pane.classList.add(positionClass);
        pane.classList.add('toast-container');
        pane.classList.add('banner-notification');
        if (!overlayContainer) {
            this._overlayContainer.getContainerElement().appendChild(pane);
        }
        else {
            overlayContainer.getContainerElement().appendChild(pane);
        }
        return pane;
    }
    /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param pane The DOM element to turn into a portal host.
     * @returns A portal host for the given DOM element.
     */
    _createPortalHost(pane) {
        return new DomPortalHost$1(pane, this._componentFactoryResolver, this._appRef);
    }
    /**
     * Creates an OverlayRef for an overlay in the given DOM element.
     * @param pane DOM element for the overlay
     */
    _createOverlayRef(pane) {
        return new OverlayRef$1(this._createPortalHost(pane));
    }
}
/** @nocollapse */ Overlay$1.ngInjectableDef = ɵɵdefineInjectable({ token: Overlay$1, factory: function Overlay_Factory(t) { return new (t || Overlay$1)(ɵɵinject(OverlayContainer$1), ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(DOCUMENT)); }, providedIn: 'root' });
/*@__PURE__*/ ɵsetClassMetadata(Overlay$1, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: OverlayContainer$1 }, { type: ComponentFactoryResolver }, { type: ApplicationRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null);

class ToastrService$1 {
    constructor(token, overlay, _injector, sanitizer, ngZone) {
        this.overlay = overlay;
        this._injector = _injector;
        this.sanitizer = sanitizer;
        this.ngZone = ngZone;
        this.currentlyActive = 0;
        this.toasts = [];
        this.index = 0;
        this.toastrConfig = Object.assign({}, token.default, token.config);
        if (token.config.iconClasses) {
            this.toastrConfig.iconClasses = Object.assign({}, token.default.iconClasses, token.config.iconClasses);
        }
    }
    /** show toast */
    show(message, title, override = {}, type = '') {
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show successful toast */
    success(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.success || '';
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show error toast */
    error(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.error || '';
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show info toast */
    info(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.info || '';
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /** show warning toast */
    warning(message, title, override = {}) {
        const type = this.toastrConfig.iconClasses.warning || '';
        return this._preBuildNotification(type, message, title, this.applyConfig(override));
    }
    /**
     * Remove all or a single toast by id
     */
    clear(toastId) {
        // Call every toastRef manualClose function
        for (const toast of this.toasts) {
            if (toastId !== undefined) {
                if (toast.toastId === toastId) {
                    toast.toastRef.manualClose();
                    return;
                }
            }
            else {
                toast.toastRef.manualClose();
            }
        }
    }
    /**
     * Remove and destroy a single toast by id
     */
    remove(toastId) {
        const found = this._findToast(toastId);
        if (!found) {
            return false;
        }
        found.activeToast.toastRef.close();
        this.toasts.splice(found.index, 1);
        this.currentlyActive = this.currentlyActive - 1;
        if (!this.toastrConfig.maxOpened || !this.toasts.length) {
            return false;
        }
        if (this.currentlyActive < this.toastrConfig.maxOpened &&
            this.toasts[this.currentlyActive]) {
            const p = this.toasts[this.currentlyActive].toastRef;
            if (!p.isInactive()) {
                this.currentlyActive = this.currentlyActive + 1;
                p.activate();
            }
        }
        return true;
    }
    /**
     * Determines if toast message is already shown
     */
    findDuplicate(message, resetOnDuplicate, countDuplicates) {
        for (const toast of this.toasts) {
            if (toast.message === message) {
                toast.toastRef.onDuplicate(resetOnDuplicate, countDuplicates);
                return toast;
            }
        }
        return null;
    }
    /** create a clone of global config and apply individual settings */
    applyConfig(override = {}) {
        return Object.assign({}, this.toastrConfig, override);
    }
    /**
     * Find toast object by id
     */
    _findToast(toastId) {
        for (let i = 0; i < this.toasts.length; i++) {
            if (this.toasts[i].toastId === toastId) {
                return { index: i, activeToast: this.toasts[i] };
            }
        }
        return null;
    }
    /**
     * Determines the need to run inside angular's zone then builds the toast
     */
    _preBuildNotification(toastType, message, title, config) {
        if (config.onActivateTick) {
            return this.ngZone.run(() => this._buildNotification(toastType, message, title, config));
        }
        return this._buildNotification(toastType, message, title, config);
    }
    /**
     * Creates and attaches toast data to component
     * returns the active toast, or in case preventDuplicates is enabled the original/non-duplicate active toast.
     */
    _buildNotification(toastType, message, title, config) {
        if (!config.toastComponent) {
            throw new Error('toastComponent required');
        }
        // max opened and auto dismiss = true
        // if timeout = 0 resetting it would result in setting this.hideTime = Date.now(). Hence, we only want to reset timeout if there is
        // a timeout at all
        const duplicate = this.findDuplicate(message, this.toastrConfig.resetTimeoutOnDuplicate && config.timeOut > 0, this.toastrConfig.countDuplicates);
        if (message && this.toastrConfig.preventDuplicates && duplicate !== null) {
            return duplicate;
        }
        this.previousToastMessage = message;
        let keepInactive = false;
        if (this.toastrConfig.maxOpened &&
            this.currentlyActive >= this.toastrConfig.maxOpened) {
            keepInactive = true;
            if (this.toastrConfig.autoDismiss) {
                this.clear(this.toasts[0].toastId);
            }
        }
        const overlayRef = this.overlay.create(config.positionClass, this.overlayContainer);
        this.index = this.index + 1;
        let sanitizedMessage = message;
        if (message && config.enableHtml) {
            sanitizedMessage = this.sanitizer.sanitize(SecurityContext.HTML, message);
        }
        const toastRef = new ToastRef$1(overlayRef);
        const toastPackage = new ToastPackage$1(this.index, config, sanitizedMessage, title, toastType, toastRef);
        const toastInjector = new ToastInjector$1(toastPackage, this._injector);
        const component = new ComponentPortal$1(config.toastComponent, toastInjector);
        const portal = overlayRef.attach(component, this.toastrConfig.newestOnTop);
        toastRef.componentInstance = portal._component;
        const ins = {
            toastId: this.index,
            message: message || '',
            toastRef,
            onShown: toastRef.afterActivate(),
            onHidden: toastRef.afterClosed(),
            onTap: toastPackage.onTap(),
            onAction: toastPackage.onAction(),
            portal
        };
        if (!keepInactive) {
            ins.toastRef.activate();
            this.currentlyActive = this.currentlyActive + 1;
        }
        this.toasts.push(ins);
        return ins;
    }
}
/** @nocollapse */ ToastrService$1.ngInjectableDef = ɵɵdefineInjectable({ token: ToastrService$1, factory: function ToastrService_Factory(t) { return new (t || ToastrService$1)(ɵɵinject(TOAST_CONFIG$1), ɵɵinject(Overlay$1), ɵɵinject(Injector), ɵɵinject(DomSanitizer), ɵɵinject(NgZone)); }, providedIn: 'root' });
/*@__PURE__*/ ɵsetClassMetadata(ToastrService$1, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TOAST_CONFIG$1]
            }] }, { type: Overlay$1 }, { type: Injector }, { type: DomSanitizer }, { type: NgZone }]; }, null);

const _c0$9 = ["toast-component", ""];
const _c1$9 = [3, "class", 4, "ngIf"];
const _c2$8 = ["role", "alertdialog", "aria-live", "polite", 3, "class", "innerHTML", 4, "ngIf"];
const _c3$8 = ["role", "alertdialog", "aria-live", "polite", 3, "class", 4, "ngIf"];
const _c4$7 = [4, "ngIf"];
const _c5$7 = ["class", "toast-close-button", "aria-label", "Close", 3, "click", 4, "ngIf"];
function Toast_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r353 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵtextInterpolate1("[", ctx_r353.duplicatesCount + 1, "]");
} }
function Toast_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵtemplate(2, Toast_div_0_ng_container_2_Template, 2, 1, "ng-container", _c4$7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r348 = ɵɵnextContext();
    ɵɵclassMap(ctx_r348.options.titleClass);
    ɵɵstylingApply();
    ɵɵattribute("aria-label", ctx_r348.title);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r348.title, " ");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r348.duplicatesCount);
} }
const _c6$6 = ["role", "alertdialog", "aria-live", "polite", 3, "innerHTML"];
function Toast_h4_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h4", _c6$6);
    ɵɵstyling();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r349 = ɵɵnextContext();
    ɵɵclassMap(ctx_r349.options.messageClass);
    ɵɵstylingApply();
    ɵɵproperty("innerHTML", ctx_r349.message, ɵɵsanitizeHtml);
} }
const _c7$5 = ["role", "alertdialog", "aria-live", "polite"];
function Toast_h4_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h4", _c7$5);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r350 = ɵɵnextContext();
    ɵɵclassMap(ctx_r350.options.messageClass);
    ɵɵstylingApply();
    ɵɵattribute("aria-label", ctx_r350.message);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r350.message, "\n");
} }
const _c8$5 = [1, "toast-progress"];
function Toast_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c8$5);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r351 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵstyleProp("width", ctx_r351.width + "%");
    ɵɵstylingApply();
} }
const _c9$5 = ["aria-label", "Close", 1, "toast-close-button", 3, "click"];
function Toast_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r355 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c9$5);
    ɵɵlistener("click", function Toast_button_4_Template_button_click_0_listener($event) { ɵɵrestoreView(_r355); const ctx_r354 = ɵɵnextContext(); return ctx_r354.remove(); });
    ɵɵelementEnd();
} }
class Toast {
    constructor(toastrService, toastPackage, ngZone) {
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
        this.ngZone = ngZone;
        /** width of progress bar */
        this.width = -1;
        /** a combination of toast type and options.toastClass */
        this.toastClasses = "";
        /** controls animation */
        this.state = {
            value: "inactive",
            params: {
                easeTime: this.toastPackage.config.easeTime,
                easing: "ease-in"
            }
        };
        this.message = toastPackage.message;
        this.title = toastPackage.title;
        this.options = toastPackage.config;
        this.originalTimeout = toastPackage.config.timeOut;
        this.toastClasses = `${toastPackage.toastType} ${toastPackage.config.toastClass}`;
        this.sub = toastPackage.toastRef.afterActivate().subscribe(() => {
            this.activateToast();
        });
        this.sub1 = toastPackage.toastRef.manualClosed().subscribe(() => {
            this.remove();
        });
        this.sub2 = toastPackage.toastRef.timeoutReset().subscribe(() => {
            this.resetTimeout();
        });
        this.sub3 = toastPackage.toastRef.countDuplicate().subscribe(count => {
            this.duplicatesCount = count;
        });
    }
    /** hides component when waiting to be displayed */
    get displayStyle() {
        if (this.state.value === "inactive") {
            return "none";
        }
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.sub1.unsubscribe();
        this.sub2.unsubscribe();
        this.sub3.unsubscribe();
        clearInterval(this.intervalId);
        clearTimeout(this.timeout);
    }
    /**
     * activates toast and sets timeout
     */
    activateToast() {
        this.state = Object.assign({}, this.state, { value: "active" });
        if (!(this.options.disableTimeOut === true ||
            this.options.disableTimeOut === "timeOut") &&
            this.options.timeOut) {
            this.outsideTimeout(() => this.remove(), this.options.timeOut);
            this.hideTime = new Date().getTime() + this.options.timeOut;
            if (this.options.progressBar) {
                this.outsideInterval(() => this.updateProgress(), 10);
            }
        }
    }
    /**
     * updates progress bar width
     */
    updateProgress() {
        if (this.width === 0 || this.width === 100 || !this.options.timeOut) {
            return;
        }
        const now = new Date().getTime();
        const remaining = this.hideTime - now;
        this.width = (remaining / this.options.timeOut) * 100;
        if (this.options.progressAnimation === "increasing") {
            this.width = 100 - this.width;
        }
        if (this.width <= 0) {
            this.width = 0;
        }
        if (this.width >= 100) {
            this.width = 100;
        }
    }
    resetTimeout() {
        clearTimeout(this.timeout);
        clearInterval(this.intervalId);
        this.state = Object.assign({}, this.state, { value: "active" });
        this.outsideTimeout(() => this.remove(), this.originalTimeout);
        this.options.timeOut = this.originalTimeout;
        this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
        this.width = -1;
        if (this.options.progressBar) {
            this.outsideInterval(() => this.updateProgress(), 10);
        }
    }
    /**
     * tells toastrService to remove this toast after animation time
     */
    remove() {
        if (this.state.value === "removed") {
            return;
        }
        clearTimeout(this.timeout);
        this.state = Object.assign({}, this.state, { value: "removed" });
        this.outsideTimeout(() => this.toastrService.remove(this.toastPackage.toastId), +this.toastPackage.config.easeTime);
    }
    tapToast() {
        if (this.state.value === "removed") {
            return;
        }
        this.toastPackage.triggerTap();
        if (this.options.tapToDismiss) {
            this.remove();
        }
    }
    stickAround() {
        if (this.state.value === "removed") {
            return;
        }
        clearTimeout(this.timeout);
        this.options.timeOut = 0;
        this.hideTime = 0;
        // disable progressBar
        clearInterval(this.intervalId);
        this.width = 0;
    }
    delayedHideToast() {
        if (this.options.disableTimeOut === true ||
            this.options.disableTimeOut === "extendedTimeOut" ||
            this.options.extendedTimeOut === 0 ||
            this.state.value === "removed") {
            return;
        }
        this.outsideTimeout(() => this.remove(), this.options.extendedTimeOut);
        this.options.timeOut = this.options.extendedTimeOut;
        this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
        this.width = -1;
        if (this.options.progressBar) {
            this.outsideInterval(() => this.updateProgress(), 10);
        }
    }
    outsideTimeout(func, timeout) {
        if (this.ngZone) {
            this.ngZone.runOutsideAngular(() => (this.timeout = setTimeout(() => this.runInsideAngular(func), timeout)));
        }
        else {
            this.timeout = setTimeout(() => func(), timeout);
        }
    }
    outsideInterval(func, timeout) {
        if (this.ngZone) {
            this.ngZone.runOutsideAngular(() => (this.intervalId = setInterval(() => this.runInsideAngular(func), timeout)));
        }
        else {
            this.intervalId = setInterval(() => func(), timeout);
        }
    }
    runInsideAngular(func) {
        if (this.ngZone) {
            this.ngZone.run(() => func());
        }
        else {
            func();
        }
    }
}
/** @nocollapse */ Toast.ngComponentDef = ɵɵdefineComponent({ type: Toast, selectors: [["", "toast-component", ""], ["", "banner-component", ""]], factory: function Toast_Factory(t) { return new (t || Toast)(ɵɵdirectiveInject(ToastrService$1), ɵɵdirectiveInject(ToastPackage$1), ɵɵdirectiveInject(NgZone)); }, hostBindings: function Toast_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(3);
        ɵɵlistener("click", function Toast_click_HostBindingHandler($event) { return ctx.tapToast(); });
        ɵɵlistener("mouseenter", function Toast_mouseenter_HostBindingHandler($event) { return ctx.stickAround(); });
        ɵɵlistener("mouseleave", function Toast_mouseleave_HostBindingHandler($event) { return ctx.delayedHideToast(); });
        ɵɵstyling();
    } if (rf & 2) {
        ɵɵupdateSyntheticHostBinding("@flyInOut", ctx.state);
        ɵɵclassMap(ctx.toastClasses);
        ɵɵstyleProp("display", ctx.displayStyle);
        ɵɵstylingApply();
    } }, attrs: _c0$9, consts: 5, vars: 5, template: function Toast_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, Toast_div_0_Template, 3, 4, "div", _c1$9);
        ɵɵtemplate(1, Toast_h4_1_Template, 1, 2, "h4", _c2$8);
        ɵɵtemplate(2, Toast_h4_2_Template, 2, 3, "h4", _c3$8);
        ɵɵtemplate(3, Toast_div_3_Template, 2, 1, "div", _c4$7);
        ɵɵtemplate(4, Toast_button_4_Template, 1, 0, "button", _c5$7);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.title);
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.message && ctx.options.enableHtml);
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.message && !ctx.options.enableHtml);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.options.progressBar);
        ɵɵselect(4);
        ɵɵproperty("ngIf", ctx.options.closeButton);
    } }, directives: [NgIf], styles: [".banner-notification .toast-center-center{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.banner-notification .toast-top-center{top:0;right:0;width:100%}.banner-notification .toast-bottom-center{bottom:0;right:0;width:100%}.banner-notification .toast-top-full-width{top:0;right:0;width:100%}.banner-notification .toast-bottom-full-width{bottom:0;right:0;width:100%}.banner-notification .toast-top-left{top:12px;left:12px}.banner-notification .toast-top-right{top:12px;right:12px}.banner-notification .toast-bottom-right{right:12px;bottom:12px}.banner-notification .toast-bottom-left{bottom:12px;left:12px}.banner-notification .toast-title{font-weight:700}.banner-notification .toast-message{word-wrap:break-word}.banner-notification .toast-message a,.banner-notification .toast-message label{color:#fff}.banner-notification .toast-message a:hover{color:#ccc;text-decoration:none}.banner-notification .toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;text-shadow:0 1px 0 #fff}.banner-notification .toast-close-button:focus,.banner-notification .toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}.banner-notification button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0}.banner-notification{pointer-events:none;position:fixed;z-index:999999}.banner-notification *{box-sizing:border-box}.banner-notification .ngx-toastr{position:relative;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;background-position:15px center;background-repeat:no-repeat;background-size:20px;box-shadow:0 0 12px #999;color:#fff;background-color:#030303;pointer-events:auto}.banner-notification .ngx-toastr:hover{box-shadow:0 0 12px #000;opacity:1;cursor:pointer}.banner-notification .toast-info{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='512' height='512'%3E%3Cpath fill='rgb(255,255,255)' d='M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z'/%3E%3C/svg%3E\")}.banner-notification .toast-error{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='512' height='512'%3E%3Cpath fill='rgb(255,255,255)' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z'/%3E%3C/svg%3E\")}.banner-notification .toast-success{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='512' height='512'%3E%3Cpath fill='rgb(255,255,255)' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'/%3E%3C/svg%3E\");background-color:#51a351}.banner-notification.toast-bottom-center .ngx-toastr,.banner-notification.toast-top-center .ngx-toastr{width:300px;margin-left:auto;margin-right:auto}.banner-notification.toast-bottom-full-width .ngx-toastr,.banner-notification.toast-top-full-width .ngx-toastr{width:96%;margin-left:auto;margin-right:auto}.banner-notification .toast-error{background-color:#bd362f}.banner-notification .toast-info{background-color:#2f96b4}.banner-notification .toast-warning{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512' width='576' height='512'%3E%3Cpath fill='rgb(255,255,255)' d='M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z'/%3E%3C/svg%3E\");background-color:#f89406}.banner-notification .toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}@media all and (max-width:240px){.banner-notification .ngx-toastr.div{padding:8px 8px 8px 50px;width:11em}.banner-notification .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){.banner-notification .ngx-toastr.div{padding:8px 8px 8px 50px;width:18em}.banner-notification .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){.banner-notification .ngx-toastr.div{padding:15px 15px 15px 50px;width:25em}}", "body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}.banner-notification .toast-message strong,.banner-notification__link{font-weight:500}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.banner-notifications-container{position:relative;text-align:center}.banner-notification{display:inline-block;min-width:240px;position:static}.banner-notification [toast-component]{display:-webkit-box;display:flex}.banner-notification .ngx-toastr{color:#656066;display:block;box-shadow:0 10px 20px 0 rgba(0,0,0,.1);background-color:rgba(255,255,255,.96);position:relative;font-size:14px;margin-bottom:3px;overflow:visible;padding:13px 63px;text-align:center;width:auto}.banner-notification .ngx-toastr:hover{box-shadow:0 10px 20px 0 rgba(0,0,0,.1)}.banner-notification .toast-error,.banner-notification .toast-info,.banner-notification .toast-success,.banner-notification .toast-warning{background-color:#fff}.banner-notification .toast-error,.banner-notification .toast-info{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M10 17.5c-4.136 0-7.5-3.364-7.5-7.5S5.864 2.5 10 2.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zm0-14c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zm0 9a1 1 0 110 2 1 1 0 010-2zm.5-2V6a.5.5 0 00-1 0v4.5a.5.5 0 001 0z' fill='%23656066'/%3E%3C/svg%3E\")}.banner-notification .toast-success{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M8.9 15.5c-.1 0-.3-.1-.4-.1l-4-4c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l3.6 3.6 5.8-7.6c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-6.1 8c-.1.1-.3.2-.4.2z' fill='%23656066'/%3E%3C/svg%3E\")}.banner-notification .toast-warning{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M10 17.5c-4.136 0-7.5-3.364-7.5-7.5S5.864 2.5 10 2.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5zm0-14c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zm0 9a1 1 0 110 2 1 1 0 010-2zm.5-2V6a.5.5 0 00-1 0v4.5a.5.5 0 001 0z' fill='%23656066'/%3E%3C/svg%3E\")}.banner-notification .toast-message{color:#464247;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;margin:0}.banner-notification .toast-message strong{margin-right:6px}.banner-notification .toast-message a,.banner-notification .toast-message label{color:#656066}.banner-notification .toast-message a:hover,.banner-notification .toast-message label:hover{color:inherit;text-decoration:underline}.banner-notification button.toast-close-button{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3ClinearGradient id='toast-msg-gradient' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%235487fd' /%3E%3Cstop offset='100%25' stop-color='%23a664fd' /%3E%3C/linearGradient%3E%3Cpath class='icon-color' d='M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z' fill='%23656066'/%3E%3C/svg%3E\");background-position:center;background-repeat:no-repeat;background-size:20px;height:44px;margin-top:-22px;position:absolute;right:0;top:50%;width:44px}.banner-notification button.toast-close-button:hover{outline:0;cursor:pointer;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3ClinearGradient id='toast-msg-gradient' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%235487fd' /%3E%3Cstop offset='100%25' stop-color='%23a664fd' /%3E%3C/linearGradient%3E%3Cpath fill='url(%23toast-msg-gradient) %237723e6' class='icon-color' d='M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z' /%3E%3C/svg%3E\");opacity:1}.banner-notification button.toast-close-button span{display:none}.banner-notification__link{color:#4e60ee;margin-left:6px;text-transform:uppercase;white-space:nowrap}.banner-notification.toast-bottom-center .ngx-toastr,.banner-notification.toast-top-center .ngx-toastr{width:auto}"], encapsulation: 2, data: { animation: [
            trigger("flyInOut", [
                state("inactive", style({ opacity: 0 })),
                state("active", style({ opacity: 1 })),
                state("removed", style({ opacity: 0 })),
                transition("inactive => active", animate("{{ easeTime }}ms {{ easing }}")),
                transition("active => removed", animate("{{ easeTime }}ms {{ easing }}"))
            ])
        ] }, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(Toast, [{
        type: Component,
        args: [{
                selector: "[toast-component], [banner-component]",
                templateUrl: "./toastr.component.html",
                styleUrls: [
                    "./toastr.component.scss",
                    "../banner-notifications.scss"
                ],
                animations: [
                    trigger("flyInOut", [
                        state("inactive", style({ opacity: 0 })),
                        state("active", style({ opacity: 1 })),
                        state("removed", style({ opacity: 0 })),
                        transition("inactive => active", animate("{{ easeTime }}ms {{ easing }}")),
                        transition("active => removed", animate("{{ easeTime }}ms {{ easing }}"))
                    ])
                ],
                preserveWhitespaces: false,
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ToastrService$1 }, { type: ToastPackage$1 }, { type: NgZone }]; }, { toastClasses: [{
            type: HostBinding,
            args: ["class"]
        }], state: [{
            type: HostBinding,
            args: ["@flyInOut"]
        }], displayStyle: [{
            type: HostBinding,
            args: ["style.display"]
        }], tapToast: [{
            type: HostListener,
            args: ["click"]
        }], stickAround: [{
            type: HostListener,
            args: ["mouseenter"]
        }], delayedHideToast: [{
            type: HostListener,
            args: ["mouseleave"]
        }] });

const DefaultGlobalConfig$1 = Object.assign({}, DefaultNoComponentGlobalConfig$1, { toastComponent: Toast });
class ToastrModule$1 {
    static forRoot(config = {}) {
        return {
            ngModule: ToastrModule$1,
            providers: [
                {
                    provide: TOAST_CONFIG$1,
                    useValue: {
                        default: DefaultGlobalConfig$1,
                        config,
                    },
                },
            ],
        };
    }
}
/** @nocollapse */ ToastrModule$1.ngModuleDef = ɵɵdefineNgModule({ type: ToastrModule$1 });
/** @nocollapse */ ToastrModule$1.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastrModule_Factory(t) { return new (t || ToastrModule$1)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastrModule$1, { declarations: [Toast], imports: [CommonModule], exports: [Toast] });
/*@__PURE__*/ ɵsetClassMetadata(ToastrModule$1, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [Toast],
                exports: [Toast],
                entryComponents: [Toast],
            }]
    }], null, null);
class ToastrComponentlessModule$1 {
    static forRoot(config = {}) {
        return {
            ngModule: ToastrModule$1,
            providers: [
                {
                    provide: TOAST_CONFIG$1,
                    useValue: {
                        default: DefaultNoComponentGlobalConfig$1,
                        config,
                    },
                },
            ],
        };
    }
}
/** @nocollapse */ ToastrComponentlessModule$1.ngModuleDef = ɵɵdefineNgModule({ type: ToastrComponentlessModule$1 });
/** @nocollapse */ ToastrComponentlessModule$1.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastrComponentlessModule_Factory(t) { return new (t || ToastrComponentlessModule$1)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastrComponentlessModule$1, { imports: [CommonModule] });
/*@__PURE__*/ ɵsetClassMetadata(ToastrComponentlessModule$1, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
            }]
    }], null, null);

class ToastContainerDirective$1 {
    constructor(el) {
        this.el = el;
    }
    getContainerElement() {
        return this.el.nativeElement;
    }
}
/** @nocollapse */ ToastContainerDirective$1.ngDirectiveDef = ɵɵdefineDirective({ type: ToastContainerDirective$1, selectors: [["", "toastContainer", ""], ["", "bannerNotificationsContainer", ""]], factory: function ToastContainerDirective_Factory(t) { return new (t || ToastContainerDirective$1)(ɵɵdirectiveInject(ElementRef)); }, exportAs: ["toastContainer"] });
/*@__PURE__*/ ɵsetClassMetadata(ToastContainerDirective$1, [{
        type: Directive,
        args: [{
                selector: '[toastContainer], [bannerNotificationsContainer]',
                exportAs: 'toastContainer',
            }]
    }], function () { return [{ type: ElementRef }]; }, null);
class ToastContainerModule$1 {
}
/** @nocollapse */ ToastContainerModule$1.ngModuleDef = ɵɵdefineNgModule({ type: ToastContainerModule$1 });
/** @nocollapse */ ToastContainerModule$1.ngInjectorDef = ɵɵdefineInjector({ factory: function ToastContainerModule_Factory(t) { return new (t || ToastContainerModule$1)(); } });
/*@__PURE__*/ ɵɵsetNgModuleScope(ToastContainerModule$1, { declarations: [ToastContainerDirective$1], exports: [ToastContainerDirective$1] });
/*@__PURE__*/ ɵsetClassMetadata(ToastContainerModule$1, [{
        type: NgModule,
        args: [{
                declarations: [ToastContainerDirective$1],
                exports: [ToastContainerDirective$1],
            }]
    }], null, null);

var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["ALL"] = "item";
    NotificationTypeEnum["RUN"] = "run";
    NotificationTypeEnum["ANALYSIS"] = "analysis";
    NotificationTypeEnum["BIOSAMPLE"] = "biosample";
})(NotificationTypeEnum || (NotificationTypeEnum = {}));
const NotificationTypeEnumMapping = {
    all: {
        "=0": "items",
        "=1": "item",
        "other": "items"
    },
    run: {
        "=0": "runs",
        "=1": "run",
        "other": "runs"
    },
    analysis: {
        "=0": "analyses",
        "=1": "analysis",
        "other": "analyses"
    },
    biosample: {
        "=0": "biosamples",
        "=1": "biosample",
        "other": "biosamples"
    }
};

function fadeIn(selector = ":enter", duration = "600ms ease-out") {
    return [
        transition("* => *", [
            query(selector, [
                style({ opacity: 0, transform: "translateY(-5px)" }),
                stagger("60ms", [
                    animate(duration, style({
                        opacity: 1,
                        transform: "translateY(0px)"
                    }))
                ])
            ], { optional: true })
        ])
    ];
}
function fadeOut(selector = ":leave", duration = 300) {
    return [
        transition("* => *", [
            query(selector, [
                style({ opacity: 1 }),
                stagger("30ms", [
                    animate(duration, style({
                        opacity: 0
                    }))
                ])
            ], { optional: true })
        ])
    ];
}

const _c0$a = [3, "ngSwitch"];
const _c1$a = [4, "ngSwitchCase"];
const _c2$9 = ["class", "lib-skltn__text-wraper", 4, "ngSwitchCase"];
const _c3$9 = ["skltn-bone", "", "type", "circle", 1, "lib-skltn__circle"];
function SkeletonComponent_skltn_root_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "skltn-root");
    ɵɵelement(1, "div", _c3$9);
    ɵɵelementEnd();
} }
const _c4$8 = ["skltn-bone", "", 1, "lib-skltn__rect"];
function SkeletonComponent_skltn_root_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "skltn-root");
    ɵɵelement(1, "div", _c4$8);
    ɵɵelementEnd();
} }
const _c5$8 = [1, "lib-skltn__text-wraper"];
const _c6$7 = ["skltn-bone", "", 3, "ngClass", 4, "ngFor", "ngForOf"];
const _c7$6 = ["skltn-bone", "", 3, "ngClass"];
function SkeletonComponent_skltn_root_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", _c7$6);
} if (rf & 2) {
    const first_r394 = ctx.first;
    const last_r395 = ctx.last;
    ɵɵproperty("ngClass", last_r395 ? first_r394 === last_r395 ? "lib-skltn__text" : "lib-skltn__text__last-child" : "lib-skltn__text");
} }
function SkeletonComponent_skltn_root_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "skltn-root", _c5$8);
    ɵɵtemplate(1, SkeletonComponent_skltn_root_3_div_1_Template, 1, 1, "div", _c6$7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r390 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r390.lines);
} }
const _c8$6 = ["skltn-bone", "", "type", "path", 1, "lib-skltn__bar-chart", 3, "pathWidth", "pathHeight"];
const _c9$6 = ["boneTemp", ""];
const _c10$5 = ["width", "100%", "height", "100%", "viewBox", "0 0 461 250", "xmlns", "http://www.w3.org/2000/svg"];
const _c11$3 = ["x", "36", "y", "111", "width", "85", "height", "103"];
const _c12$3 = ["x", "358", "y", "53", "width", "85", "height", "161"];
const _c13$3 = ["x", "197", "y", "17", "width", "85", "height", "197"];
const _c14$3 = ["d", "M12 0H0V250H12H461V238H12V0Z"];
function SkeletonComponent_skltn_root_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c10$5);
    ɵɵelement(1, "rect", _c11$3);
    ɵɵelement(2, "rect", _c12$3);
    ɵɵelement(3, "rect", _c13$3);
    ɵɵelement(4, "path", _c14$3);
    ɵɵelementEnd();
} }
function SkeletonComponent_skltn_root_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "skltn-root");
    ɵɵelementStart(1, "div", _c8$6);
    ɵɵtemplate(2, SkeletonComponent_skltn_root_4_ng_template_2_Template, 5, 0, "ng-template", null, _c9$6, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("pathWidth", 575)("pathHeight", 350);
} }
class SkeletonComponent {
    constructor() { }
    set lines(value) {
        this._lines = Array.apply(null, { length: value }).map(Number.call, Number);
    }
    get lines() {
        return this._lines || [0, 1];
    }
}
/** @nocollapse */ SkeletonComponent.ngComponentDef = ɵɵdefineComponent({ type: SkeletonComponent, selectors: [["lib-skeleton"]], factory: function SkeletonComponent_Factory(t) { return new (t || SkeletonComponent)(); }, inputs: { type: "type", lines: "lines" }, consts: 5, vars: 5, template: function SkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainerStart(0, _c0$a);
        ɵɵtemplate(1, SkeletonComponent_skltn_root_1_Template, 2, 0, "skltn-root", _c1$a);
        ɵɵtemplate(2, SkeletonComponent_skltn_root_2_Template, 2, 0, "skltn-root", _c1$a);
        ɵɵtemplate(3, SkeletonComponent_skltn_root_3_Template, 2, 1, "skltn-root", _c2$9);
        ɵɵtemplate(4, SkeletonComponent_skltn_root_4_Template, 4, 2, "skltn-root", _c1$a);
        ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵɵproperty("ngSwitch", ctx.type);
        ɵɵselect(1);
        ɵɵproperty("ngSwitchCase", "circle");
        ɵɵselect(2);
        ɵɵproperty("ngSwitchCase", "rect");
        ɵɵselect(3);
        ɵɵproperty("ngSwitchCase", "text");
        ɵɵselect(4);
        ɵɵproperty("ngSwitchCase", "bar-chart");
    } }, directives: [NgSwitch, NgSwitchCase, SkltnComponent, SkltnBoneDirective, NgForOf, NgClass], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.lib-skltn__circle[_ngcontent-%COMP%]{height:6rem;width:6rem}.lib-skltn__rect[_ngcontent-%COMP%]{height:1.2rem}.lib-skltn__bar-chart[_ngcontent-%COMP%]{height:35rem;width:57.5rem;margin-top:1.6rem}.lib-skltn__text-wraper[_ngcontent-%COMP%]   .lib-skltn__text[_ngcontent-%COMP%], .lib-skltn__text-wraper[_ngcontent-%COMP%]   .lib-skltn__text__last-child[_ngcontent-%COMP%]{height:1.2rem;margin-bottom:1.6rem}.lib-skltn__text-wraper[_ngcontent-%COMP%]   .lib-skltn__text__last-child[_ngcontent-%COMP%]{width:80%}"] });
/*@__PURE__*/ ɵsetClassMetadata(SkeletonComponent, [{
        type: Component,
        args: [{
                selector: "lib-skeleton",
                templateUrl: "./skeleton.component.html",
                styleUrls: ["./skeleton.component.scss"]
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], lines: [{
            type: Input,
            args: ["lines"]
        }] });

const _c0$b = ["data-cy", "notification-spotlight", 1, "spotlight-notification"];
const _c1$b = [4, "ngIf", "ngIfElse"];
const _c2$a = ["loading", ""];
const _c3$a = ["width", "0", "height", "0"];
const _c4$9 = ["id", "gradient", "gradientUnits", "objectBoundingBox", "x1", "0", "y1", "1", "x2", "1", "y2", "1"];
const _c5$9 = ["stop-color", "#FF85A4"];
const _c6$8 = ["offset", "100%", "stop-color", "#AA69FF"];
const _c7$7 = ["data-cy", "notification-header", 1, "spotlight-notification__header"];
const _c8$7 = [1, "spotlight-notification__header-text"];
const _c9$7 = ["class", "spotlight-notification__card", 4, "ngFor", "ngForOf"];
const _c10$6 = ["class", "spotlight-notification__footer", "data-cy", "notification-show-more", 3, "click", 4, "ngIf"];
const _c11$4 = [1, "spotlight-notification__card"];
const _c12$4 = [1, "spotlight-notification__card__title", "spotlight-notification__card__title-link", 3, "title"];
const _c13$4 = ["data-cy", "notification-card-link", 1, "spotlight-notification__card__link", 3, "ngClass", "href"];
const _c14$4 = ["data-cy", "notification-title-status", 1, "spotlight-notification__card__title", "spotlight-notification__card__title--status", 3, "title"];
const _c15$3 = ["data-cy", "notification-description", 1, "spotlight-notification__card__sub-title", "spotlight-notification__card__sub-title--description", 3, "title"];
const _c16$2 = ["data-cy", "notification-date", 1, "spotlight-notification__card__sub-title", "spotlight-notification__card__title--date", 3, "title"];
const _c17$2 = ["class", "spotlight-notification__card__time-elapsed-container", 4, "ngIf"];
const _c18$2 = ["class", "spotlight-notification__card__actions", 4, "ngIf"];
const _c19$2 = ["class", "spotlight-notification__card__chart-container", "data-cy", "notification-run-chart", 4, "ngIf"];
const _c20$2 = ["class", "spotlight-notification__card__actions spotlight-notification__card__actions--hidden", 4, "ngIf"];
const _c21$2 = [1, "spotlight-notification__card__time-elapsed-container"];
const _c22$2 = [1, "spotlight-notification__card__time-elapsed"];
const _c23$2 = ["data-cy", "notification-analysis-timeelaspsed", 1, "data-list__time-elap"];
const _c24$2 = [1, "data-list__time-elap-item"];
const _c25$2 = [1, "data-list__time-label"];
const _c26$2 = [1, "data-list__time-amt"];
const _c27$2 = [1, "data-list__value-small"];
function NotificationCardComponent_ng_container_1_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c21$2);
    ɵɵelementStart(1, "div", _c22$2);
    ɵɵelementStart(2, "div", _c23$2);
    ɵɵelementStart(3, "div", _c24$2);
    ɵɵelementStart(4, "span", _c25$2);
    ɵɵtext(5, "HRS");
    ɵɵelementEnd();
    ɵɵelementStart(6, "span", _c26$2);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", _c24$2);
    ɵɵelementStart(9, "span", _c25$2);
    ɵɵtext(10, "\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(11, "span", _c26$2);
    ɵɵtext(12, ":");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(13, "div", _c24$2);
    ɵɵelementStart(14, "span", _c25$2);
    ɵɵtext(15, "MIN");
    ɵɵelementEnd();
    ɵɵelementStart(16, "span", _c26$2);
    ɵɵtext(17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(18, "div", _c24$2);
    ɵɵelementStart(19, "span", _c25$2);
    ɵɵtext(20, "\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(21, "span", _c26$2);
    ɵɵtext(22, ":");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(23, "div", _c24$2);
    ɵɵelementStart(24, "span", _c25$2);
    ɵɵtext(25, "SEC");
    ɵɵelementEnd();
    ɵɵelementStart(26, "span", _c26$2);
    ɵɵtext(27);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(28, "p", _c27$2);
    ɵɵtext(29, "TIME ELAPSED");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r361 = ɵɵnextContext().$implicit;
    ɵɵselect(7);
    ɵɵtextInterpolate(card_r361.time.hours);
    ɵɵselect(17);
    ɵɵtextInterpolate(card_r361.time.minutes);
    ɵɵselect(27);
    ɵɵtextInterpolate(card_r361.time.seconds);
} }
const _c28$2 = [1, "spotlight-notification__card__actions"];
const _c29$1 = ["data-cy", "notification-invite-decline", 1, "btn", "btn--tertiary", "mr-1", 3, "click"];
const _c30$1 = ["data-cy", "notification-invite-accept", 1, "btn", "btn--secondary", "ml-1", 3, "click"];
function NotificationCardComponent_ng_container_1_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r370 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c28$2);
    ɵɵelementStart(1, "button", _c29$1);
    ɵɵlistener("click", function NotificationCardComponent_ng_container_1_div_4_div_11_Template_button_click_1_listener($event) { ɵɵrestoreView(_r370); const ctx_r369 = ɵɵnextContext(); const card_r361 = ctx_r369.$implicit; const i_r362 = ctx_r369.index; const ctx_r368 = ɵɵnextContext(2); return ctx_r368.notificationProcessed("decline", card_r361, i_r362); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "button", _c30$1);
    ɵɵlistener("click", function NotificationCardComponent_ng_container_1_div_4_div_11_Template_button_click_3_listener($event) { ɵɵrestoreView(_r370); const ctx_r372 = ɵɵnextContext(); const card_r361 = ctx_r372.$implicit; const i_r362 = ctx_r372.index; const ctx_r371 = ɵɵnextContext(2); return ctx_r371.notificationProcessed("confirm", card_r361, i_r362); });
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r361 = ɵɵnextContext().$implicit;
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", card_r361.decline.title, " ");
    ɵɵselect(4);
    ɵɵtextInterpolate1(" ", card_r361.confirm.title, " ");
} }
const _c31$1 = ["data-cy", "notification-run-chart", 1, "spotlight-notification__card__chart-container"];
const _c32$1 = [1, "spotlight-notification__card__chart"];
const _c33$1 = ["data-cy", "notification-run-chart-pfpc", 1, "spotlight-notification__card__chart--percent"];
const _c34$1 = [1, "spotlight-notification__card__chart--title"];
const _c35$1 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 200 200", 1, "spotlight-notification__card__chart--gauge"];
const _c36$1 = ["stroke", "#d6d5d6", "d", "M41 149.5a77 77 0 1 1 117.93 0", "fill", "none", 1, "bg"];
const _c37$1 = ["stroke", "#5487FD", "d", "M41 149.5a77 77 0 1 1 117.93 0", "fill", "none", "stroke-dasharray", "350"];
const _c38$1 = ["data-cy", "notification-run-chart-qpc", 1, "spotlight-notification__card__chart--percent"];
function NotificationCardComponent_ng_container_1_div_4_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c31$1);
    ɵɵelementStart(1, "div", _c32$1);
    ɵɵelementStart(2, "span", _c33$1);
    ɵɵtext(3);
    ɵɵpipe(4, "number");
    ɵɵelementEnd();
    ɵɵelementStart(5, "span", _c34$1);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵnamespaceSVG();
    ɵɵelementStart(7, "svg", _c35$1);
    ɵɵelement(8, "path", _c36$1);
    ɵɵelementStart(9, "path", _c37$1);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelementStart(10, "div", _c32$1);
    ɵɵelementStart(11, "span", _c38$1);
    ɵɵtext(12);
    ɵɵpipe(13, "number");
    ɵɵelementEnd();
    ɵɵelementStart(14, "span", _c34$1);
    ɵɵtext(15);
    ɵɵelementEnd();
    ɵɵnamespaceSVG();
    ɵɵelementStart(16, "svg", _c35$1);
    ɵɵelement(17, "path", _c36$1);
    ɵɵelementStart(18, "path", _c37$1);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r361 = ɵɵnextContext().$implicit;
    const ctx_r365 = ɵɵnextContext(2);
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(4, 8, card_r361.chartPf.percent, "2.2-2"), " ");
    ɵɵselect(6);
    ɵɵtextInterpolate2(" ", card_r361.chartPf.label, " ", card_r361.chartPf.title, " ");
    ɵɵselect(9);
    ɵɵstyleProp("stroke-dashoffset", ctx_r365.setCirclePercent(card_r361.chartPf.percent));
    ɵɵstylingApply();
    ɵɵselect(12);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(13, 11, card_r361.chartQ.percent, "2.2-2"), " ");
    ɵɵselect(15);
    ɵɵtextInterpolate2(" ", card_r361.chartQ.label, " ", card_r361.chartQ.title, " ");
    ɵɵselect(18);
    ɵɵstyleProp("stroke-dashoffset", ctx_r365.setCirclePercent(card_r361.chartQ.percent));
    ɵɵstylingApply();
} }
const _c39$1 = [1, "spotlight-notification__card__actions", "spotlight-notification__card__actions--hidden"];
const _c40$1 = ["data-cy", "notification-run-analysis-dismiss", 1, "btn", "btn--tertiary", 3, "click"];
function NotificationCardComponent_ng_container_1_div_4_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r377 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c39$1);
    ɵɵelementStart(1, "button", _c40$1);
    ɵɵlistener("click", function NotificationCardComponent_ng_container_1_div_4_div_13_Template_button_click_1_listener($event) { ɵɵrestoreView(_r377); const ctx_r376 = ɵɵnextContext(); const card_r361 = ctx_r376.$implicit; const i_r362 = ctx_r376.index; const ctx_r375 = ɵɵnextContext(2); return ctx_r375.notificationProcessed("dismiss", card_r361, i_r362); });
    ɵɵtext(2, " Dismiss ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c41 = function (a0) { return { "u-link-not-clickable": a0 }; };
function NotificationCardComponent_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c11$4);
    ɵɵelementStart(1, "h2", _c12$4);
    ɵɵelementStart(2, "a", _c13$4);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "h2", _c14$4);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "h6", _c15$3);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementStart(8, "h6", _c16$2);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵtemplate(10, NotificationCardComponent_ng_container_1_div_4_div_10_Template, 30, 3, "div", _c17$2);
    ɵɵtemplate(11, NotificationCardComponent_ng_container_1_div_4_div_11_Template, 5, 2, "div", _c18$2);
    ɵɵtemplate(12, NotificationCardComponent_ng_container_1_div_4_div_12_Template, 19, 14, "div", _c19$2);
    ɵɵtemplate(13, NotificationCardComponent_ng_container_1_div_4_div_13_Template, 3, 0, "div", _c20$2);
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r361 = ctx.$implicit;
    ɵɵproperty("@fadeIn", card_r361);
    ɵɵattribute("data-cy", "notification-type-" + card_r361.type);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("title", card_r361.projectTitle);
    ɵɵselect(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(16, _c41, card_r361.projectLink == "" || card_r361.projectLink == "#"))("href", card_r361.projectLink, ɵɵsanitizeUrl);
    ɵɵselect(3);
    ɵɵtextInterpolate1("", card_r361.projectTitle, " ");
    ɵɵselect(4);
    ɵɵpropertyInterpolate("title", card_r361.title);
    ɵɵselect(5);
    ɵɵtextInterpolate1(" ", card_r361.title, " ");
    ɵɵselect(6);
    ɵɵpropertyInterpolate("title", card_r361.projectDescription);
    ɵɵselect(7);
    ɵɵtextInterpolate1(" ", card_r361.projectDescription, " ");
    ɵɵselect(8);
    ɵɵpropertyInterpolate("title", card_r361.date);
    ɵɵselect(9);
    ɵɵtextInterpolate1(" ", card_r361.date, " ");
    ɵɵselect(10);
    ɵɵproperty("ngIf", card_r361.type === "analysis");
    ɵɵselect(11);
    ɵɵproperty("ngIf", card_r361.type === "general");
    ɵɵselect(12);
    ɵɵproperty("ngIf", card_r361.type === "run");
    ɵɵselect(13);
    ɵɵproperty("ngIf", card_r361.type === "run" || card_r361.type === "analysis");
} }
const _c42 = ["data-cy", "notification-show-more", 1, "spotlight-notification__footer", 3, "click"];
const _c43 = [1, "spotlight-notification__footer--show-more", "btn", "btn--link", "btn--simple"];
function NotificationCardComponent_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r379 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c42);
    ɵɵlistener("click", function NotificationCardComponent_ng_container_1_div_6_Template_div_click_0_listener($event) { ɵɵrestoreView(_r379); const ctx_r378 = ɵɵnextContext(2); return ctx_r378.showMore(); });
    ɵɵelementStart(1, "span", _c43);
    ɵɵtext(2, " Show more ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function NotificationCardComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", _c7$7);
    ɵɵelementStart(2, "h1", _c8$7);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(4, NotificationCardComponent_ng_container_1_div_4_Template, 14, 18, "div", _c9$7);
    ɵɵpipe(5, "slice");
    ɵɵtemplate(6, NotificationCardComponent_ng_container_1_div_6_Template, 3, 0, "div", _c10$6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r356 = ɵɵnextContext();
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", ctx_r356.headerMessage, " ");
    ɵɵselect(4);
    ɵɵproperty("ngForOf", ɵɵpipeBind3(5, 3, ctx_r356.data.cards, 0, ctx_r356.showCards));
    ɵɵselect(6);
    ɵɵproperty("ngIf", (ctx_r356.data == null ? null : ctx_r356.data.cards == null ? null : ctx_r356.data.cards.length) > ctx_r356.showCards);
} }
const _c44 = [4, "ngIf"];
const _c45 = [1, "spotlight-notification__header"];
const _c46 = [1, "spotlight-notification__header--loader"];
const _c47 = [1, "skltn-card__body"];
const _c48 = [1, "skltn-card__line"];
const _c49 = ["type", "rect", 3, "lines"];
const _c50 = [1, "spotlight-notification__card__title-link"];
const _c51 = [1, "spotlight-notification__card--loading-content", "spotlight-notification__card__title", "spotlight-notification__card__title--status"];
const _c52 = [1, "spotlight-notification__card__sub-title", "spotlight-notification__card__sub-title--description"];
const _c53 = [1, "spotlight-notification__card--loading-content", "spotlight-notification__card__sub-title", "spotlight-notification__card__title--date"];
function NotificationCardComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", _c45);
    ɵɵelementStart(2, "div", _c46);
    ɵɵelementStart(3, "div", _c47);
    ɵɵelementStart(4, "div", _c48);
    ɵɵelement(5, "lib-skeleton", _c49);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", _c11$4);
    ɵɵelementStart(7, "h2", _c50);
    ɵɵelementStart(8, "div", _c47);
    ɵɵelementStart(9, "div", _c48);
    ɵɵelement(10, "lib-skeleton", _c49);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "h2", _c51);
    ɵɵelementStart(12, "div", _c47);
    ɵɵelementStart(13, "div", _c48);
    ɵɵelement(14, "lib-skeleton", _c49);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(15, "h6", _c52);
    ɵɵelementStart(16, "div", _c47);
    ɵɵelementStart(17, "div", _c48);
    ɵɵelement(18, "lib-skeleton", _c49);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(19, "h6", _c53);
    ɵɵelementStart(20, "div", _c47);
    ɵɵelementStart(21, "div", _c48);
    ɵɵelement(22, "lib-skeleton", _c49);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵselect(5);
    ɵɵproperty("lines", 1);
    ɵɵselect(10);
    ɵɵproperty("lines", 1);
    ɵɵselect(14);
    ɵɵproperty("lines", 1);
    ɵɵselect(18);
    ɵɵproperty("lines", 1);
    ɵɵselect(22);
    ɵɵproperty("lines", 1);
} }
function NotificationCardComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, NotificationCardComponent_ng_template_2_ng_container_0_Template, 23, 5, "ng-container", _c44);
} if (rf & 2) {
    const ctx_r358 = ɵɵnextContext();
    ɵɵproperty("ngIf", ctx_r358.isLoading);
} }
class NotificationCardComponent {
    constructor(_i18nPluralPipe) {
        this._i18nPluralPipe = _i18nPluralPipe;
        // ────────────────────────────────────────────────────────────────────────────────
        // Inputs / Outputs
        // ────────────────────────────────────────────────────────────────────────────────
        this.defaultNoOfCardsToShow = 3;
        this.showCards = this.defaultNoOfCardsToShow;
        this.isLoading = false;
        this.isExpanded = false;
        this.cardProcessed = new EventEmitter();
        this.showMoreClicked = new EventEmitter();
        this.deletedCards = [];
        this.numShowedCards = 3;
        this.notificationTypeEnumMapping = {
            item: {
                "=0": "items",
                "=1": "item",
                "other": "items"
            },
            run: {
                "=0": "runs",
                "=1": "run",
                "other": "runs"
            },
            analysis: {
                "=0": "analyses",
                "=1": "analysis",
                "other": "analyses"
            },
            biosample: {
                "=0": "biosamples",
                "=1": "biosample",
                "other": "biosamples"
            }
        };
    }
    get data() {
        return this._data;
    }
    /*
    bellow will get called when ever the notification card data is
    passed in by the parent component
    */
    set data(data) {
        this._data = data;
        if (!this.isExpanded) {
            this.showCards = this.defaultNoOfCardsToShow;
        }
        if (this._data !== null) {
            this.setHeaderMessage(this._data.type);
        }
    }
    ngOnInit() { }
    setCirclePercent(value) {
        const svgLength = 350;
        const actualLength = svgLength * ((100 - value) / 100);
        return actualLength;
    }
    showMore() {
        this.isExpanded = true;
        this.numShowedCards = this.numShowedCards + this.defaultNoOfCardsToShow;
        this.showCards = this.data.cards.length > this.numShowedCards ? this.numShowedCards : this.data.cards.length;
        this.showMoreClicked.emit(this.showCards);
    }
    notificationProcessed(action, card, index) {
        this.cardProcessed.emit({
            action,
            card,
            index
        });
    }
    removeCardByIndex(indexToDelete) {
        this.data.cards = this.data.cards.filter((card, index) => {
            if (indexToDelete === index) {
                this.deletedCards.push(card);
                return false;
            }
            return true;
        });
        this.setHeaderMessage(this.data.type);
    }
    setHeaderMessage(notificationType) {
        if (this.data.title && this.data.title !== "") {
            this.headerMessage = this.data.title;
            return;
        }
        if (!notificationType) {
            notificationType = NotificationTypeEnum.ALL;
        }
        const typePlural = this._i18nPluralPipe.transform(this.data.cards.length, this.notificationTypeEnumMapping[notificationType]);
        switch (notificationType) {
            case NotificationTypeEnum.ALL:
                if (this.data.cards.length === 0) {
                    this.headerMessage = `Everything is looking good so far today. Check back later for any incoming ${typePlural}.`;
                }
                else if (this.data.cards.length === 1) {
                    this.headerMessage = `This ${typePlural} requires your attention`;
                }
                else if (this.data.cards.length > 3) {
                    this.headerMessage = `These ${this.data.cards.length} ${typePlural} require your attention`;
                }
                else {
                    this.headerMessage = `These ${typePlural} require your attention`;
                }
                break;
            default:
                if (this.data.cards.length === 0) {
                    this.headerMessage = `There are no urgent actions. Well done. Return in a few hours to check incoming ${typePlural}.`;
                }
                else if (this.data.cards.length === 1) {
                    this.headerMessage = `This ${typePlural} requires your attention`;
                }
                else if (this.data.cards.length > 3) {
                    this.headerMessage = `These ${this.data.cards.length} ${typePlural} require your attention`;
                }
                else {
                    this.headerMessage = `These ${typePlural} require your attention`;
                }
                break;
        }
    }
}
/** @nocollapse */ NotificationCardComponent.ngComponentDef = ɵɵdefineComponent({ type: NotificationCardComponent, selectors: [["lib-notification-card"]], factory: function NotificationCardComponent_Factory(t) { return new (t || NotificationCardComponent)(ɵɵdirectiveInject(I18nPluralPipe)); }, inputs: { defaultNoOfCardsToShow: "defaultNoOfCardsToShow", isLoading: "isLoading", isExpanded: "isExpanded", data: "data" }, outputs: { cardProcessed: "cardProcessed", showMoreClicked: "showMoreClicked" }, consts: 9, vars: 2, template: function NotificationCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$b);
        ɵɵtemplate(1, NotificationCardComponent_ng_container_1_Template, 7, 7, "ng-container", _c1$b);
        ɵɵtemplate(2, NotificationCardComponent_ng_template_2_Template, 1, 1, "ng-template", null, _c2$a, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵnamespaceSVG();
        ɵɵelementStart(4, "svg", _c3$a);
        ɵɵelementStart(5, "defs");
        ɵɵelementStart(6, "linearGradient", _c4$9);
        ɵɵelement(7, "stop", _c5$9);
        ɵɵelement(8, "stop", _c6$8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r357 = ɵɵreference(3);
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.isLoading)("ngIfElse", _r357);
    } }, directives: [NgIf, NgForOf, NgClass, SkeletonComponent], pipes: [SlicePipe, DecimalPipe], styles: [".data-list{display:block;box-shadow:0 10px 20px 0 rgba(0,0,0,.1);background-color:#fff;position:relative}.data-list--names{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.data-list__title{font-size:26px;font-weight:300;line-height:1.31;letter-spacing:.1875px;color:#322d32;margin:0}.data-list__value{font-size:26px;line-height:1.31;color:#322d32;margin:0;font-weight:400}.data-list__value-small{font-size:12px;letter-spacing:.75px;line-height:1.17;color:#656066;margin:5px 0}.data-list__content{padding:50px 15px 50px 35px;display:-webkit-box;display:flex}.data-list__row{width:100%}.data-list__col-left .data-list__row{padding:8px 0 42px}.data-list__col-right .data-list__row{padding-bottom:30px}.data-list__col-left{-webkit-box-flex:70%;flex:70%;display:-webkit-box;display:flex;font-size:2.6em;border-right:1px solid #f0eff0;flex-wrap:wrap}.data-list__col-right{-webkit-box-flex:30%;flex:30%;display:-webkit-box;display:flex;font-size:16px;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:15px 10px 10px 30px}.data-list__col-right-title{font-size:16px;font-weight:300;line-height:1.31;letter-spacing:.1875px;color:#322d32;margin:0}.data-list__list{max-width:142px;font-size:16px;line-height:1.75;color:#322d32;list-style-type:none;padding-left:0;margin:3px 30px 0 0}.data-list__list-item{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.data-list__time-elap{display:-webkit-box;display:flex;margin:0 2px}.data-list__time-elap-item{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center}.data-list__time-label{color:#787679;font-size:12px;line-height:1.17;letter-spacing:.75px;padding-bottom:1.25px}.data-list__time-amt{color:#312d32;line-height:1.15;letter-spacing:.325px;padding:0 3.125px}.data-list__link{text-decoration:none;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;line-height:1.31;letter-spacing:.2px}.data-list__filesize{margin:14px 0 0 17px}.data-list__filesize .data-list__value-small{padding:0 52.8px}.data-list__session-type{padding:0 8px}.data-list__delivery-status{padding:0 17px}.spotlight-notification__card__chart--label,.spotlight-notification__card__chart--percent,.spotlight-notification__card__chart--title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.spotlight-notification__card__chart--percent{font-weight:400;letter-spacing:.4px;line-height:1.5}.spotlight-notification__card__chart--label,.spotlight-notification__card__chart--title{font-weight:400;font-size:12px;letter-spacing:.34px;line-height:1.1666666667}.spotlight-notification__card__sub-title,.spotlight-notification__card__title{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.btn{background-color:#f0eff0;border:0;border-radius:50px;cursor:pointer;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;padding:8px 24px;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn:focus{box-shadow:none;outline:#7e8bf3 solid 4px}.btn:disabled{cursor:not-allowed;opacity:.4}.btn--secondary{background:0 0;color:#4e60ee;border:1px solid #4e60ee}.btn--secondary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);border-color:transparent;color:#fff}.btn--secondary:hover:disabled{color:#4e60ee}.btn--secondary:active:not(:disabled){background:#4e60ee;border-color:transparent;color:#fff}.btn--secondary.btn--small{font-size:14px;padding:5px 19px}.btn--secondary.btn--disabled{opacity:.4}.btn--disabled{cursor:not-allowed}.btn--primary{background:linear-gradient(8.68deg,#225de6 -4.27%,#a664fd 116.09%);color:#fff}.btn--primary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn--primary:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn--primary.btn--small{padding:5px 19px}.btn--primary.btn--disabled{opacity:.4}.btn--white{background:#fff;padding:7px 24px}.btn--white.btn--small{padding:5px 19px}.btn--white.btn--disabled{opacity:.4}.btn--tertiary{background:0 0;border:1px solid transparent;color:#4e60ee}.btn--tertiary:hover:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee}.btn--tertiary:active:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee;box-shadow:inset 0 0 0 1px #4e60ee}.btn--tertiary:focus:not(:disabled){border-color:#4e60ee}.btn--tertiary.btn--small{font-size:14px}.btn--tertiary.btn--disabled{opacity:.4}.btn--link,.btn--link:not([href]){background:0 0;color:#4e60ee!important}.btn--link:hover:not(:disabled),.btn--link:not([href]):hover:not(:disabled){background:0 0;color:#4e60ee;text-decoration:underline}.btn--link:active,.btn--link:not([href]):active{background:0 0}.btn--link.btn--small,.btn--link:not([href]).btn--small{font-size:14px}.btn--link.btn--disabled,.btn--link:not([href]).btn--disabled{opacity:.4}.data-list__time-amt{font-size:20px}.data-list__value-small{padding:0}.spotlight-notification{position:relative}.spotlight-notification .spotlight-notification__card,.spotlight-notification .spotlight-notification__footer,.spotlight-notification .spotlight-notification__header{background:#fff;display:-ms-grid;display:grid;grid-column-gap:30px;-ms-grid-columns:71px 71px (1fr)[8] 71px 71px;grid-template-columns:71px 71px repeat(8,1fr) 71px 71px;padding:13px 65px;position:relative;z-index:10}.spotlight-notification .spotlight-notification__card:not(:last-child),.spotlight-notification .spotlight-notification__footer:not(:last-child),.spotlight-notification .spotlight-notification__header:not(:last-child){margin-bottom:3px}.spotlight-notification::after{background:#000;bottom:-10px;content:\"\";-webkit-filter:blur(20px);filter:blur(20px);position:absolute;top:10px;right:0;left:0;z-index:1;opacity:.1}.spotlight-notification__header{background:#fff;display:-webkit-box!important;display:flex!important;-webkit-box-pack:center;justify-content:center;padding-left:24px;padding-right:24px;text-align:center;-webkit-box-align:center;align-items:center}.spotlight-notification__header--loader{min-width:300px;width:40%}.spotlight-notification__header .skltn-card__line{padding:11px 0!important}.spotlight-notification__header-text{color:#312d32;font-size:24px;font-weight:300;line-height:1.3;margin:0;text-align:center}@media (max-width:833px){.spotlight-notification__header{padding:20px 24px!important}.spotlight-notification__header--loader{min-width:200px}.spotlight-notification__header-text{font-size:20px;letter-spacing:4px;line-height:1.5}}.spotlight-notification__card{grid-template-areas:\"status status link link link link link link link link data data\" \"date date description description description description description description description description . .\";-webkit-box-align:center;align-items:center;margin-bottom:10px;padding-bottom:32px!important;padding-top:32px!important}@media (max-width:1279px){.spotlight-notification__card{display:block!important;padding:28px 32px 29px!important}}.spotlight-notification__card:hover .spotlight-notification__card__actions--hidden{visibility:visible;opacity:1}.spotlight-notification__card:hover .spotlight-notification__card__chart,.spotlight-notification__card:hover .spotlight-notification__card__time-elapsed{visibility:hidden;opacity:0}.spotlight-notification__card__status{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-ms-grid-column:1;-ms-grid-column-span:2;grid-column:1/span 2;-webkit-box-pack:center;justify-content:center}.spotlight-notification__card__info{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-ms-grid-column:3;-ms-grid-column-span:8;grid-column:3/span 8;-webkit-box-pack:center;justify-content:center}.spotlight-notification__card__actions{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-ms-grid-column:11;-ms-grid-column-span:2;grid-column:11/span 2;height:30px;-webkit-box-pack:center;justify-content:center;position:relative;right:7px;top:13px}@media (min-width:834px) and (max-width:1279px){.spotlight-notification__card__actions{position:absolute;right:24px;top:46px;width:210px}}@media (max-width:833px){.spotlight-notification__card{padding:20px 24px!important}.spotlight-notification__card__actions{margin:27px auto 21px;top:inherit}}.spotlight-notification__card__actions .btn{padding-left:14px;padding-right:14px}.spotlight-notification__card__actions .btn:nth-child(2){margin-left:7px!important}.spotlight-notification__card__actions--hidden{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-ms-grid-column:11;-ms-grid-column-span:2;grid-column:11/span 2;-webkit-box-pack:center;justify-content:center;opacity:0;position:absolute;top:44px;-webkit-transition:visibility linear .2s,opacity .2s ease-in-out;transition:visibility linear .2s,opacity .2s ease-in-out;visibility:hidden;width:100%}@media (min-width:834px) and (max-width:1279px){.spotlight-notification__card__actions--hidden{width:210px}}@media (max-width:833px){.spotlight-notification__card__actions--hidden{bottom:30px;top:inherit}}.spotlight-notification__card__chart{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:30px;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;position:relative;width:106px}.spotlight-notification__card__chart:first-child{left:-10px}.spotlight-notification__card__chart-container{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-ms-grid-column:11;-ms-grid-column-span:2;grid-column:11/span 2;-webkit-box-pack:center;justify-content:center;position:relative;top:6px;-webkit-transition:visibility linear .33s,opacity .33s linear;transition:visibility linear .33s,opacity .33s linear}@media (max-width:1279px){.spotlight-notification__card__chart-container{height:auto;position:absolute;right:36px;top:43px;width:172px}}@media (max-width:833px){.spotlight-notification__card__chart-container{height:52px;margin:27px auto 17px;position:static}}.spotlight-notification__card__chart--gauge{position:absolute;top:-32px;width:106px}.spotlight-notification__card__chart svg path{will-change:auto;stroke-width:5px;stroke-miterlimit:round;-webkit-transition:stroke-dashoffset 850ms ease-in-out;transition:stroke-dashoffset 850ms ease-in-out}.spotlight-notification__card__chart--percent{color:#312d32;font-size:18px;position:relative;top:7px}.spotlight-notification__card__chart--title{color:#5b575b;position:relative;top:21px}.spotlight-notification__card__chart--label{color:#c1c0c2;position:absolute;top:35px}.spotlight-notification__card__time-elapsed{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-transition:visibility linear .2s,opacity .2s ease-in-out;transition:visibility linear .2s,opacity .2s ease-in-out}.spotlight-notification__card__time-elapsed-container{-ms-grid-column:11;-ms-grid-column-span:2;grid-column:11/span 2;position:absolute;right:4px;width:100%}@media (min-width:834px) and (max-width:1279px){.spotlight-notification__card__time-elapsed-container{right:21px;top:36px;width:210px}.spotlight-notification__card__title--status{max-width:150px}}@media (max-width:833px){.spotlight-notification__card__time-elapsed-container{margin:20px auto 9px;position:static}}.spotlight-notification__card__title{color:#5b575b;font-size:24px;font-weight:300;line-height:1.3;margin:0}.spotlight-notification__card__title-link{-ms-grid-row:1;-ms-grid-column:3;-ms-grid-column-span:8;grid-area:link}@media (max-width:1279px){.spotlight-notification__card__title-link{display:block;width:68%}}@media (max-width:833px){.spotlight-notification__card__title-link{font-size:16px;letter-spacing:4px;line-height:1.5;width:auto}}.spotlight-notification__card__title-link .skltn-card__line{width:90%}.spotlight-notification__card__title--status{-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:2;color:#312d32;font-size:24px;font-weight:300;line-height:1.3;grid-area:status}.spotlight-notification__card__title--status.spotlight-notification__card--loading-content{min-width:140px}.spotlight-notification__card__title--date{-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:2;grid-area:date}.spotlight-notification__card__title--date.spotlight-notification__card--loading-content{min-width:130px}@media (max-width:833px){.spotlight-notification__card__title--status{width:52%}.spotlight-notification__card__title--status .skltn-card__line{width:70%}.spotlight-notification__card__title--date.spotlight-notification__card--loading-content{min-width:inherit;width:35%}}.spotlight-notification__card__title--date .skltn-card__line{width:80%}@media (max-width:1279px){.spotlight-notification__card__title--status{display:inline-block;font-size:16px;line-height:1.5;margin-right:16px}.spotlight-notification__card__title--date{display:inline-block}.spotlight-notification__card__sub-title--description{display:none}}@media (max-width:833px){.spotlight-notification__card__title--date{float:right;text-align:right;width:41%}.spotlight-notification__card__title--date .skltn-card__line{float:right;width:60%}}.spotlight-notification__card__sub-title{color:#5b575b;font-size:14px;letter-spacing:0;line-height:1.43}.spotlight-notification__card__sub-title--description{-ms-grid-row:2;-ms-grid-column:3;-ms-grid-column-span:8;grid-area:description;width:45%}.spotlight-notification__card__link{color:#4e60ee}.spotlight-notification__footer{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;padding:10px 35px!important}.spotlight-notification__footer--show-more{-ms-grid-column:1;-ms-grid-column-span:12;grid-column:1/span 12}.spotlight-notification .skltn-card__line{padding:8px 0 7px}"], encapsulation: 2, data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] }, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(NotificationCardComponent, [{
        type: Component,
        args: [{
                selector: "lib-notification-card",
                templateUrl: "./notification-card.component.html",
                styleUrls: ["./notification-card.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: I18nPluralPipe }]; }, { defaultNoOfCardsToShow: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], isExpanded: [{
            type: Input
        }], cardProcessed: [{
            type: Output
        }], showMoreClicked: [{
            type: Output
        }], data: [{
            type: Input,
            args: ["data"]
        }] });

class ProgressRef {
    constructor(customConfig, _onDestroyCallback) {
        this._onDestroyCallback = _onDestroyCallback;
        // Progress start source event (used to cancel finalizing delays)
        this._started = new Subject();
        // Progress start event: stream that emits only when it hasn"t already started
        this.started = this._started.pipe(filter(() => !this.isStarted));
        // Progress ended source event
        this._completed = new Subject();
        // Progress start event: stream that emits only when it has already started
        this.completed = this._completed.pipe(filter(() => this.isStarted));
        // Stream that increments and updates the progress state
        this._trickling = new Subject();
        // Stream that combines "_trickling" and "config" streams
        this._worker = Subscription.EMPTY;
        this._state = new BehaviorSubject({ active: false, value: 0 });
        this._config = new BehaviorSubject(customConfig);
        this.state = this._state.asObservable();
        this.config = this._state.asObservable();
        this._worker = combineLatest(this._trickling, this._config).pipe(debounce(([start, config]) => timer(start ? config.debounceTime : 0)), switchMap(([start, config]) => start ? this.onTrickling(config) : this.onComplete(config))).subscribe();
    }
    // Get current progress state
    get currState() {
        return this._state.value;
    }
    // Check if progress has started
    get isStarted() {
        return this.currState.active;
    }
    /**
     * Start the progress
     */
    start() {
        this._started.next();
        this._trickling.next(true);
    }
    /**
     * Complete the progress
     */
    complete() {
        this._trickling.next(false);
    }
    /**
     * Increment the progress
     */
    inc(amount) {
        const n = this.currState.value;
        if (!this.isStarted) {
            this.start();
        }
        else {
            if (typeof amount !== "number") {
                amount = this._config.value.trickleFunc(n);
            }
            this.set(n + amount);
        }
    }
    /**
     * Set the progress
     */
    set(n) {
        this.setState({ value: this.clamp(n), active: true });
    }
    /**
     * Set config
     */
    setConfig(config) {
        this._config.next(Object.assign({}, this._config.value, config));
    }
    /**
     * Destroy progress reference
     */
    destroy() {
        this._worker.unsubscribe();
        this._trickling.complete();
        this._state.complete();
        this._config.complete();
        this._started.complete();
        this._completed.complete();
        this._onDestroyCallback();
    }
    /**
     * Set progress state
     */
    setState(state) {
        this._state.next(Object.assign({}, this.currState, state));
    }
    /**
     * Clamps a value to be between min and max
     */
    clamp(n) {
        return Math.max(this._config.value.min, Math.min(this._config.value.max, n));
    }
    /**
     * Keeps incrementing the progress
     */
    onTrickling(config) {
        if (!this.isStarted) {
            this.set(this._config.value.min);
        }
        return timer(0, config.trickleSpeed).pipe(tap(() => this.inc()));
    }
    /**
     * Completes then resets the progress
     */
    onComplete(config) {
        this._completed.next();
        return !this.isStarted ? EMPTY : of({}).pipe(
        // Complete the progress
        tap(() => this.setState({ value: 100 })), 
        // Deactivate the progress after a tiny delay
        delay(config.speed * 1.7), tap(() => this.setState({ active: false })), 
        // Use a tiny delay before resetting
        delay(config.speed), 
        // Force the progress to reset even it got cancelled
        finalize(() => this.setState({ value: 0 })), 
        // Cancel any of the finalizing delays if the progress has started again
        takeUntil(this._started));
    }
}

const PROGRESS_CONFIG = new InjectionToken("IProgressConfig");

const defaultConfig = {
    min: 8,
    max: 100,
    speed: 200,
    debounceTime: 0,
    trickleSpeed: 300,
    fixed: false,
    meteor: false,
    thick: false,
    spinner: false,
    loader: true,
    ease: "linear",
    color: "#C1D4FF",
    direction: "ltr+",
    spinnerPosition: "right",
    trickleFunc: (n) => {
        if (n >= 0 && n < 20) {
            return 10;
        }
        if (n >= 20 && n < 50) {
            return 4;
        }
        if (n >= 50 && n < 80) {
            return 2;
        }
        if (n >= 80 && n < 99) {
            return 0.5;
        }
        return 0;
    }
};
class ProgressService {
    constructor(config) {
        // Store progress bar instances
        this._instances = new Map();
        this.config = config ? Object.assign({}, defaultConfig, config) : defaultConfig;
    }
    /**
     * Get or Create progress bar by ID
     */
    ref(id = "root", config) {
        if (this._instances.has(id)) {
            // Get ProgressRef instance
            const progressRef = this._instances.get(id);
            if (config) {
                progressRef.setConfig(Object.assign({}, this.config, config));
            }
            return progressRef;
        }
        else {
            // Create new ProgressRef instance
            const progressRef = new ProgressRef(Object.assign({}, this.config, config), this.deleteInstance(id));
            return this._instances.set(id, progressRef).get(id);
        }
    }
    /**
     * Destroy all progress bar instances
     */
    destroyAll() {
        this._instances.forEach((ref) => ref.destroy());
    }
    /**
     * A destroyer function for each progress bar instance
     */
    deleteInstance(id) {
        return () => {
            this._instances.delete(id);
        };
    }
}
/** @nocollapse */ ProgressService.ngInjectableDef = ɵɵdefineInjectable({ token: ProgressService, factory: function ProgressService_Factory(t) { return new (t || ProgressService)(ɵɵinject(PROGRESS_CONFIG, 8)); }, providedIn: "root" });
/*@__PURE__*/ ɵsetClassMetadata(ProgressService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [PROGRESS_CONFIG]
            }] }]; }, null);

const _c0$c = ["role", "progressbar"];
const _c1$c = [4, "ngIf"];
const _c2$b = [1, "lib-progress-bar", 3, "ngClass"];
const _c3$b = ["class", "lib-bar-placeholder", 4, "ngIf"];
const _c4$a = ["class", "lib-spinner", 4, "ngIf"];
const _c5$a = ["class", "lib-spinner__overlay", 4, "ngIf"];
const _c6$9 = [1, "lib-bar-placeholder"];
const _c7$8 = [1, "lib-bar"];
const _c8$8 = ["class", "lib-meteor", 3, "boxShadow", 4, "ngIf"];
const _c9$8 = [1, "lib-meteor"];
function ProgressComponent_ng_container_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c9$8);
    ɵɵstyling();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r386 = ɵɵnextContext(3);
    ɵɵstyleProp("box-shadow", "0 0 10px " + ctx_r386.color + ", 0 0 5px " + ctx_r386.color);
    ɵɵstylingApply();
} }
function ProgressComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c6$9);
    ɵɵelementStart(1, "div", _c7$8);
    ɵɵstyling();
    ɵɵtemplate(2, ProgressComponent_ng_container_0_div_2_div_2_Template, 1, 1, "div", _c8$8);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const state_r382 = ɵɵnextContext().$implicit;
    const ctx_r383 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵstyleProp("transform", state_r382.transform);
    ɵɵstyleProp("background-color", ctx_r383.color);
    ɵɵstyleProp("transition", state_r382.active ? "all " + ctx_r383.speed + "ms " + ctx_r383.ease : "none");
    ɵɵstylingApply();
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r383.meteor);
} }
const _c10$7 = [1, "lib-spinner"];
const _c11$5 = [1, "lib-spinner-icon"];
function ProgressComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c10$7);
    ɵɵelementStart(1, "div", _c11$5);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r384 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵstyleProp("border-top-color", ctx_r384.color);
    ɵɵstyleProp("border-left-color", ctx_r384.color);
    ɵɵstylingApply();
} }
const _c12$5 = [1, "lib-spinner__overlay"];
function ProgressComponent_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", _c12$5);
} }
const _c13$5 = function (a0) { return { "lib-progress-bar--has-spinner": a0 }; };
function ProgressComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", _c2$b);
    ɵɵstyling();
    ɵɵtemplate(2, ProgressComponent_ng_container_0_div_2_Template, 3, 4, "div", _c3$b);
    ɵɵtemplate(3, ProgressComponent_ng_container_0_div_3_Template, 2, 2, "div", _c4$a);
    ɵɵelementEnd();
    ɵɵtemplate(4, ProgressComponent_ng_container_0_div_4_Template, 1, 0, "div", _c5$a);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const state_r382 = ctx.$implicit;
    const ctx_r381 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵstyleProp("transition", "opacity " + ctx_r381.speed + "ms " + ctx_r381.ease);
    ɵɵstylingApply();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c13$5, ctx_r381.spinner));
    ɵɵattribute("active", state_r382.active);
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r381.loader);
    ɵɵselect(3);
    ɵɵproperty("ngIf", ctx_r381.spinner);
    ɵɵselect(4);
    ɵɵproperty("ngIf", ctx_r381.hasOverlay);
} }
class ProgressComponent {
    constructor(_ngProgress) {
        this._ngProgress = _ngProgress;
        this._started = Subscription.EMPTY;
        this._completed = Subscription.EMPTY;
        /** Creates a new instance if id is not already exists */
        this.id = "root";
        this.overlay = false;
        /** Initializes inputs from the global config */
        this.min = this._ngProgress.config.min;
        this.max = this._ngProgress.config.max;
        this.ease = this._ngProgress.config.ease;
        this.color = this._ngProgress.config.color;
        this.speed = this._ngProgress.config.speed;
        this.thick = this._ngProgress.config.thick;
        this.fixed = this._ngProgress.config.fixed;
        this.meteor = this._ngProgress.config.meteor;
        this.loader = this._ngProgress.config.loader;
        this.spinner = this._ngProgress.config.spinner;
        this.trickleSpeed = this._ngProgress.config.trickleSpeed;
        this.debounceTime = this._ngProgress.config.debounceTime;
        this.trickleFunc = this._ngProgress.config
            .trickleFunc;
        this.spinnerPosition = this._ngProgress
            .config.spinnerPosition;
        this.direction = this._ngProgress
            .config.direction;
        this.progressBarContainer = this._ngProgress
            .config.progressBarContainer;
        this.started = new EventEmitter();
        this.completed = new EventEmitter();
        this.hasOverlay = false;
    }
    get isStarted() {
        return this.progressRef.isStarted;
    }
    ngOnChanges() {
        if (this.progressRef instanceof ProgressRef) {
            // Update progress bar config when inputs change
            this.progressRef.setConfig({
                max: this.max > 0 && this.max <= 100 ? this.max : 100,
                min: this.min < 100 && this.min >= 0 ? this.min : 0,
                speed: this.speed,
                trickleSpeed: this.trickleSpeed,
                trickleFunc: this.trickleFunc,
                debounceTime: this.debounceTime,
            });
        }
    }
    ngOnInit() {
        this.hasOverlay = this.spinner && this.overlay;
        // Get progress bar service instance
        this.progressRef = this._ngProgress.ref(this.id, {
            max: this.max,
            min: this.min,
            speed: this.speed,
            trickleSpeed: this.trickleSpeed,
            debounceTime: this.debounceTime,
        });
        // Subscribe to progress state
        this.state$ = this.progressRef.state.pipe(map((state) => ({
            active: state.active,
            transform: `translate3d(${state.value}%,0,0)`,
        })));
        // Subscribes to started and completed events on demand
        if (this.started.observers.length) {
            this._started = this.progressRef.started.subscribe(() => this.started.emit());
        }
        if (this.completed.observers.length) {
            this._completed = this.progressRef.completed.subscribe(() => this.completed.emit());
        }
    }
    ngOnDestroy() {
        this._started.unsubscribe();
        this._completed.unsubscribe();
        if (this.progressRef instanceof ProgressRef) {
            this.progressRef.destroy();
        }
    }
    start() {
        setTimeout(() => this.progressRef.start(), 100);
    }
    complete() {
        // Time to complete shortened since there's a css animation to play to disappear
        setTimeout(() => this.progressRef.complete(), 100);
    }
    inc(n) {
        this.progressRef.inc(n);
    }
    set(n) {
        this.progressRef.set(n);
    }
}
/** @nocollapse */ ProgressComponent.ngComponentDef = ɵɵdefineComponent({ type: ProgressComponent, selectors: [["lib-progress"]], factory: function ProgressComponent_Factory(t) { return new (t || ProgressComponent)(ɵɵdirectiveInject(ProgressService)); }, hostBindings: function ProgressComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(5);
        ɵɵelementHostAttrs(_c0$c);
    } if (rf & 2) {
        ɵɵattribute("spinnerPosition", ctx.spinnerPosition)("progressBarContainer", ctx.progressBarContainer)("dir", ctx.direction)("thick", ctx.thick)("fixed", ctx.fixed);
    } }, inputs: { id: "id", overlay: "overlay", min: "min", max: "max", ease: "ease", color: "color", speed: "speed", thick: "thick", fixed: "fixed", meteor: "meteor", loader: "loader", spinner: "spinner", trickleSpeed: "trickleSpeed", debounceTime: "debounceTime", trickleFunc: "trickleFunc", spinnerPosition: "spinnerPosition", direction: "direction", progressBarContainer: "progressBarContainer" }, outputs: { started: "started", completed: "completed" }, features: [ɵɵNgOnChangesFeature()], consts: 2, vars: 3, template: function ProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ProgressComponent_ng_container_0_Template, 5, 8, "ng-container", _c1$c);
        ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵɵproperty("ngIf", ɵɵpipeBind1(1, 1, ctx.state$));
    } }, directives: [NgIf, NgClass], pipes: [AsyncPipe], styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}lib-progress{z-index:999999;pointer-events:none}lib-progress[fixed=true] .lib-progress-bar,lib-progress[fixed=true] .lib-spinner{position:fixed}lib-progress[fixed=true] .lib-spinner{top:15px}lib-progress[fixed=true][spinnerPosition=left] .lib-spinner{left:15px}lib-progress[fixed=true][spinnerPosition=right] .lib-spinner{right:15px}lib-progress[fixed=true][spinnerPosition=center] .lib-spinner{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}lib-progress[fixed=true][spinnerPosition=center] .lib-progress-bar{top:50%;-webkit-transform:translateY(-25%);transform:translateY(-25%)}lib-progress[fixed=true][spinnerPosition=center][progressBarContainer=modal] .lib-progress-bar{top:0!important;height:100vh;-webkit-transform:none!important;transform:none!important}lib-progress[thick=true] .lib-spinner-icon{width:24px;height:24px;border-width:3px}lib-progress[thick=true] .lib-bar-placeholder{height:3px!important}lib-progress[dir=\"ltr+\"] .lib-meteor,lib-progress[dir=ltr-] .lib-meteor{-webkit-transform:rotate(3deg);transform:rotate(3deg)}lib-progress[dir=\"ltr+\"][thick=true] .lib-meteor,lib-progress[dir=ltr-][thick=true] .lib-meteor{-webkit-transform:rotate(4deg);transform:rotate(4deg)}lib-progress[dir=\"ltr+\"] .lib-bar,lib-progress[dir=\"rtl+\"] .lib-bar{margin-left:-100%}lib-progress[dir=\"ltr+\"] .lib-meteor,lib-progress[dir=\"rtl+\"] .lib-meteor{right:0}lib-progress[dir=\"ltr+\"] .lib-meteor,lib-progress[dir=rtl-] .lib-meteor{top:-3px}lib-progress[dir=\"ltr+\"][thick=true] .lib-meteor,lib-progress[dir=rtl-][thick=true] .lib-meteor{top:-4px}lib-progress[dir=\"rtl+\"] .lib-meteor,lib-progress[dir=ltr-] .lib-meteor{bottom:-3px}lib-progress[dir=\"rtl+\"][thick=true] .lib-meteor,lib-progress[dir=ltr-][thick=true] .lib-meteor{bottom:-4px}lib-progress[dir=\"rtl+\"] .lib-bar-placeholder,lib-progress[dir=ltr-] .lib-bar-placeholder{-webkit-transform:rotate(180deg);transform:rotate(180deg)}lib-progress[dir=\"rtl+\"] .lib-spinner-icon,lib-progress[dir=ltr-] .lib-spinner-icon{animation-direction:reverse}lib-progress[dir=\"rtl+\"] .lib-meteor,lib-progress[dir=rtl-] .lib-meteor{-webkit-transform:rotate(-3deg);transform:rotate(-3deg)}lib-progress[dir=\"rtl+\"][thick=true] .lib-meteor,lib-progress[dir=rtl-][thick=true] .lib-meteor{-webkit-transform:rotate(-4deg);transform:rotate(-4deg)}lib-progress[spinnerPosition=left] .lib-spinner{left:10px}lib-progress[spinnerPosition=right] .lib-spinner{right:10px}lib-progress[spinnerPosition=center] .lib-spinner{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.lib-progress-bar{position:relative;z-index:999999;top:0;left:0;width:100%;zoom:1;opacity:0}.lib-progress-bar[active=true]{opacity:1;-webkit-transition:none;transition:none}.lib-progress-bar--has-spinner[active=true]{height:100%}.lib-bar-placeholder{background:#f0eff0;position:absolute;overflow:hidden;height:2px;width:100%}.lib-bar{background-image:linear-gradient(250deg,#aa69ff 9%,#ff85a4 100%);width:100%;height:100%;-webkit-transform:translate(-100%,0,0);transform:translate(-100%,0,0)}.lib-meteor{display:block;position:absolute;width:100px;height:100%;opacity:1}.lib-spinner{position:absolute;display:block;z-index:1031;top:10px}.lib-spinner__overlay{background-color:rgba(255,255,255,.9);pointer-events:all;position:absolute;bottom:0;left:0;right:0;top:0}.lib-spinner-icon{width:70px;height:70px;border-radius:50%;position:relative;z-index:2}.lib-spinner-icon::after{-webkit-animation:2s linear infinite spinner-animation;animation:2s linear infinite spinner-animation;background-image:linear-gradient(250deg,#d3b2ff 2%,#b2c9ff 63%);border-radius:50%;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%;z-index:2}.lib-spinner-icon::before{-webkit-animation:2s linear infinite shadow-animation;animation:2s linear infinite shadow-animation;background:#000050;border-radius:50%;content:\"\";-webkit-filter:blur(2rem);filter:blur(2rem);height:100%;left:0;position:absolute;top:.4rem;width:100%;z-index:1}@-webkit-keyframes spinner-animation{0%{-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0)}50%{-webkit-transform:scale(1.1) rotate(180deg);transform:scale(1.1) rotate(180deg)}100%{-webkit-transform:scale(1) rotate(360deg);transform:scale(1) rotate(360deg)}}@keyframes spinner-animation{0%{-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0)}50%{-webkit-transform:scale(1.1) rotate(180deg);transform:scale(1.1) rotate(180deg)}100%{-webkit-transform:scale(1) rotate(360deg);transform:scale(1) rotate(360deg)}}@-webkit-keyframes shadow-animation{0%,100%{-webkit-transform:scale(.65);transform:scale(.65)}50%{-webkit-transform:scale(.8);transform:scale(.8)}}@keyframes shadow-animation{0%,100%{-webkit-transform:scale(.65);transform:scale(.65)}50%{-webkit-transform:scale(.8);transform:scale(.8)}}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(ProgressComponent, [{
        type: Component,
        args: [{
                selector: "lib-progress",
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    role: "progressbar",
                    "[attr.spinnerPosition]": "spinnerPosition",
                    "[attr.progressBarContainer]": "progressBarContainer",
                    "[attr.dir]": "direction",
                    "[attr.thick]": "thick",
                    "[attr.fixed]": "fixed",
                },
                templateUrl: "./progress.component.html",
                styleUrls: ["./progress.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: ProgressService }]; }, { id: [{
            type: Input
        }], overlay: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], ease: [{
            type: Input
        }], color: [{
            type: Input
        }], speed: [{
            type: Input
        }], thick: [{
            type: Input
        }], fixed: [{
            type: Input
        }], meteor: [{
            type: Input
        }], loader: [{
            type: Input
        }], spinner: [{
            type: Input
        }], trickleSpeed: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], trickleFunc: [{
            type: Input
        }], spinnerPosition: [{
            type: Input
        }], direction: [{
            type: Input
        }], progressBarContainer: [{
            type: Input
        }], started: [{
            type: Output
        }], completed: [{
            type: Output
        }] });

class ProgressModule {
    static withConfig(config) {
        return {
            ngModule: ProgressModule,
            providers: [
                { provide: PROGRESS_CONFIG, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ ProgressModule.ngModuleDef = ɵɵdefineNgModule({ type: ProgressModule });
/** @nocollapse */ ProgressModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ProgressModule_Factory(t) { return new (t || ProgressModule)(); }, providers: [ProgressService], imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ProgressModule, { declarations: [ProgressComponent], imports: [CommonModule], exports: [ProgressComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ProgressModule, [{
        type: NgModule,
        args: [{
                declarations: [ProgressComponent],
                providers: [ProgressService],
                exports: [ProgressComponent],
                imports: [CommonModule]
            }]
    }], null, null);

const PROGRESS_HTTP_CONFIG = new InjectionToken("ProgressHttpConfig");

class HttpProgressInterceptor {
    constructor(ngProgress, config) {
        this._inProgressCount = 0;
        this._config = {
            id: "root",
            silentApis: []
        };
        this._config = config ? Object.assign({}, this._config, config) : this._config;
        this._progressRef = ngProgress.ref(this._config.id);
    }
    intercept(req, next) {
        // Ignore by request headers
        if (req.headers.has("ignoreProgressBar")) {
            return next.handle(req.clone({ headers: req.headers.delete("ignoreProgressBar") }));
        }
        // Ignore silent api requests
        if (this.checkUrl(req)) {
            return next.handle(req);
        }
        this._inProgressCount++;
        if (!this._progressRef.isStarted) {
            this._progressRef.start();
        }
        return next.handle(req).pipe(finalize(() => {
            this._inProgressCount--;
            if (this._inProgressCount === 0) {
                this._progressRef.complete();
            }
        }));
    }
    /**
     * Check if request is silent.
     * @param req request
     */
    checkUrl(req) {
        const url = req.url.toLowerCase();
        const found = this._config.silentApis.find((u) => url.startsWith(u));
        return !!found;
    }
}
/** @nocollapse */ HttpProgressInterceptor.ngInjectableDef = ɵɵdefineInjectable({ token: HttpProgressInterceptor, factory: function HttpProgressInterceptor_Factory(t) { return new (t || HttpProgressInterceptor)(ɵɵinject(ProgressService), ɵɵinject(PROGRESS_HTTP_CONFIG, 8)); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(HttpProgressInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ProgressService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [PROGRESS_HTTP_CONFIG]
            }] }]; }, null);

class HttpProgressModule {
    static withConfig(config) {
        return {
            ngModule: HttpProgressModule,
            providers: [
                { provide: PROGRESS_HTTP_CONFIG, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ HttpProgressModule.ngModuleDef = ɵɵdefineNgModule({ type: HttpProgressModule });
/** @nocollapse */ HttpProgressModule.ngInjectorDef = ɵɵdefineInjector({ factory: function HttpProgressModule_Factory(t) { return new (t || HttpProgressModule)(); }, providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpProgressInterceptor, multi: true }
    ] });
/*@__PURE__*/ ɵsetClassMetadata(HttpProgressModule, [{
        type: NgModule,
        args: [{
                providers: [
                    { provide: HTTP_INTERCEPTORS, useClass: HttpProgressInterceptor, multi: true }
                ]
            }]
    }], null, null);

const PROGRESS_ROUTER_CONFIG = new InjectionToken("ProgressRouterConfig");

/**
 * Check if a router event type exists in an array of router event types
 * @param routerEvent
 * @param events
 */
function eventExists(routerEvent, events) {
    let res = false;
    events.map((event) => res = res || routerEvent instanceof event);
    return res;
}
class ProgressRouter {
    constructor(progress, router, config) {
        this._config = {
            id: "root",
            delay: 0,
            startEvents: [NavigationStart],
            completeEvents: [NavigationEnd, NavigationCancel, NavigationError]
        };
        this._config = config ? Object.assign({}, this._config, config) : this._config;
        const progressRef = progress.ref(this._config.id);
        const startProgress = of({}).pipe(tap(() => progressRef.start()));
        const completeProgress = of({}).pipe(delay(this._config.delay), tap(() => progressRef.complete()));
        const filterEvents = [...this._config.startEvents, ...this._config.completeEvents];
        router.events.pipe(filter((event) => eventExists(event, filterEvents)), switchMap((event) => eventExists(event, this._config.startEvents) ? startProgress : completeProgress)).subscribe();
    }
}
/** @nocollapse */ ProgressRouter.ngInjectableDef = ɵɵdefineInjectable({ token: ProgressRouter, factory: function ProgressRouter_Factory(t) { return new (t || ProgressRouter)(ɵɵinject(ProgressService), ɵɵinject(Router), ɵɵinject(PROGRESS_ROUTER_CONFIG, 8)); }, providedIn: "root" });
/*@__PURE__*/ ɵsetClassMetadata(ProgressRouter, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ProgressService }, { type: Router }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [PROGRESS_ROUTER_CONFIG]
            }] }]; }, null);

class RouterProgressModule {
    // Inject the service to activate it
    constructor(progressRouter) {
    }
    static withConfig(config) {
        return {
            ngModule: RouterProgressModule,
            providers: [
                { provide: PROGRESS_ROUTER_CONFIG, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ RouterProgressModule.ngModuleDef = ɵɵdefineNgModule({ type: RouterProgressModule });
/** @nocollapse */ RouterProgressModule.ngInjectorDef = ɵɵdefineInjector({ factory: function RouterProgressModule_Factory(t) { return new (t || RouterProgressModule)(ɵɵinject(ProgressRouter)); } });
/*@__PURE__*/ ɵsetClassMetadata(RouterProgressModule, [{
        type: NgModule,
        args: [{}]
    }], function () { return [{ type: ProgressRouter }]; }, null);

const skltnConfig = {
    rectRadius: 0,
    flareWidth: "200%",
    bgFill: "#C1D4FF",
    flareFill: "#FFC1D0",
    delay: 0,
    duration: 2000,
    timing: "linear",
};
class SkeletonModule {
}
/** @nocollapse */ SkeletonModule.ngModuleDef = ɵɵdefineNgModule({ type: SkeletonModule });
/** @nocollapse */ SkeletonModule.ngInjectorDef = ɵɵdefineInjector({ factory: function SkeletonModule_Factory(t) { return new (t || SkeletonModule)(); }, imports: [[
            CommonModule,
            NgxSkltnModule.forRoot(skltnConfig),
        ],
        NgxSkltnModule] });
/*@__PURE__*/ ɵɵsetNgModuleScope(SkeletonModule, { declarations: [SkeletonComponent], imports: [CommonModule, NgxSkltnModule], exports: [SkeletonComponent, NgxSkltnModule] });
/*@__PURE__*/ ɵsetClassMetadata(SkeletonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgxSkltnModule.forRoot(skltnConfig),
                ],
                declarations: [SkeletonComponent],
                exports: [SkeletonComponent, NgxSkltnModule]
            }]
    }], null, null);

class ProgressIndicatorsModule {
}
/** @nocollapse */ ProgressIndicatorsModule.ngModuleDef = ɵɵdefineNgModule({ type: ProgressIndicatorsModule });
/** @nocollapse */ ProgressIndicatorsModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ProgressIndicatorsModule_Factory(t) { return new (t || ProgressIndicatorsModule)(); }, imports: [[
            CommonModule,
            SkeletonModule,
            ProgressModule,
            HttpProgressModule,
            RouterProgressModule
        ],
        SkeletonModule, ProgressModule, HttpProgressModule, RouterProgressModule] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ProgressIndicatorsModule, { imports: [CommonModule,
        SkeletonModule,
        ProgressModule,
        HttpProgressModule,
        RouterProgressModule], exports: [SkeletonModule, ProgressModule, HttpProgressModule, RouterProgressModule] });
/*@__PURE__*/ ɵsetClassMetadata(ProgressIndicatorsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SkeletonModule,
                    ProgressModule,
                    HttpProgressModule,
                    RouterProgressModule
                ],
                exports: [SkeletonModule, ProgressModule, HttpProgressModule, RouterProgressModule]
            }]
    }], null, null);

class NotificationCardModule {
}
/** @nocollapse */ NotificationCardModule.ngModuleDef = ɵɵdefineNgModule({ type: NotificationCardModule });
/** @nocollapse */ NotificationCardModule.ngInjectorDef = ɵɵdefineInjector({ factory: function NotificationCardModule_Factory(t) { return new (t || NotificationCardModule)(); }, providers: [I18nPluralPipe], imports: [[CommonModule,
            ProgressIndicatorsModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(NotificationCardModule, { declarations: [NotificationCardComponent], imports: [CommonModule,
        ProgressIndicatorsModule], exports: [NotificationCardComponent] });
/*@__PURE__*/ ɵsetClassMetadata(NotificationCardModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule,
                    ProgressIndicatorsModule
                ],
                declarations: [NotificationCardComponent],
                exports: [NotificationCardComponent],
                providers: [I18nPluralPipe]
            }]
    }], null, null);

const _c0$d = ["cdk-portal", ""];
function DropdownComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵprojection(0);
} }
const _c1$d = ["*"];
class DropdownComponent {
    constructor(overlay, ref) {
        this.overlay = overlay;
        this.ref = ref;
        this._defaultConfig = {
            maxHeight: 256,
            height: "100%",
            hasBackdrop: true,
            backdropClass: "cdk-overlay-transparent-backdrop"
        };
        this._config = Object.assign({}, this._defaultConfig);
        this.startPosition = "bottom";
        this.showing = false;
        this.openSubDropdown = null; // can store reference to currently opened subdropdown, if any
    }
    get config() {
        return this._config;
    }
    set config(data) {
        Object.assign(this._config, this._defaultConfig, data);
    }
    show() {
        this.overlayRef = this.overlay.create(this.getOverlayConfig());
        this.overlayRef.attach(this.contentTemplate);
        this.osInstance = OverlayScrollbars(this.overlayRef.hostElement.querySelector(".scroll-area"), {});
        // Apply custom class to the overlay bounding box. Useful for creating css overrides for specific cases
        if (this.customClass) {
            this.getOverlayRef().hostElement.classList.add(this.customClass);
        }
        this.syncWidth();
        this.overlayRef.backdropClick().subscribe(() => this.hide());
        this.showing = true;
        this.ref.markForCheck();
    }
    hide() {
        if (!this.showing) {
            return;
        }
        this.overlayRef.detach();
        this.showing = false;
        this.ref.markForCheck();
    }
    onWinResize() {
        this.syncWidth();
    }
    getOverlayRef() {
        return this.overlayRef;
    }
    getOverlayConfig() {
        const positions = this.positions
            ? this.positions
            : [
                {
                    originX: "center",
                    originY: this.startPosition,
                    overlayX: "center",
                    overlayY: "top"
                },
                {
                    originX: "center",
                    originY: "top",
                    overlayX: "center",
                    overlayY: "bottom"
                }
            ];
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.reference)
            .withPush(false)
            .withPositions(positions);
        // block() causes flicker in Safari and generally bad user experience as the page scroll is blocked while the dropdown is shown.
        // reposition() is less performant but behaves much nicer.
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        return new OverlayConfig(Object.assign({ positionStrategy,
            scrollStrategy, hasBackdrop: true }, this.config));
    }
    syncWidth() {
        if (!this.overlayRef) {
            return;
        }
        const refRect = this.reference.getBoundingClientRect();
        this.overlayRef.updateSize({ width: refRect.width });
    }
    ngOnDestroy() {
        if (this.osInstance && this.osInstance.destroy) {
            this.osInstance.destroy();
        }
    }
}
/** @nocollapse */ DropdownComponent.ngComponentDef = ɵɵdefineComponent({ type: DropdownComponent, selectors: [["lib-dropdown"]], factory: function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵɵdirectiveInject(Overlay$2), ɵɵdirectiveInject(ChangeDetectorRef)); }, viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(CdkPortal, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.contentTemplate = _t.first);
    } }, hostBindings: function DropdownComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("resize", function DropdownComponent_resize_HostBindingHandler($event) { return ctx.onWinResize(); }, false, ɵɵresolveWindow);
    } }, inputs: { config: "config", startPosition: "startPosition", positions: "positions", customClass: "customClass", reference: "reference" }, exportAs: ["libDropdown"], ngContentSelectors: _c1$d, consts: 1, vars: 0, template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, DropdownComponent_ng_template_0_Template, 1, 0, "ng-template", _c0$d);
    } }, directives: [TemplatePortalDirective], styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.os-theme-dark>.os-scrollbar-vertical{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark>.os-scrollbar>.os-scrollbar-track{background:#f0eff0}.os-theme-dark .os-scrollbar-handle{background:#656066;width:.2rem}.drop-down{width:100%;box-shadow:0 2rem 2rem 0 rgba(0,0,0,.2);display:block;overflow:hidden;background-color:#fff}.drop-down-content__ul{margin:0;padding:2rem 1rem}.drop-down .active-option{font-weight:500}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: "lib-dropdown",
                templateUrl: "./dropdown.component.html",
                styleUrls: ["./dropdown.component.scss"],
                encapsulation: ViewEncapsulation.None,
                exportAs: "libDropdown"
            }]
    }], function () { return [{ type: Overlay$2 }, { type: ChangeDetectorRef }]; }, { config: [{
            type: Input,
            args: ["config"]
        }], startPosition: [{
            type: Input
        }], positions: [{
            type: Input
        }], customClass: [{
            type: Input
        }], reference: [{
            type: Input
        }], contentTemplate: [{
            type: ViewChild,
            args: [CdkPortal, { static: true }]
        }], onWinResize: [{
            type: HostListener,
            args: ["window:resize"]
        }] });

function _window() {
    return window;
}
class WindowRef {
    get nativeWindow() {
        return _window();
    }
}
/** @nocollapse */ WindowRef.ngInjectableDef = ɵɵdefineInjectable({ token: WindowRef, factory: function WindowRef_Factory(t) { return new (t || WindowRef)(); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(WindowRef, [{
        type: Injectable
    }], null, null);

const _c0$e = ["search_widget_spinner"];
const _c1$e = ["searchBar"];
const _c2$c = [1, "search-widget", 3, "ngClass"];
const _c3$c = ["data-cy", "search-overlay", 1, "search-widget__overlay", 3, "ngStyle", "click"];
const _c4$b = ["data-cy", "search-wrapper", 1, "search-widget__wrapper"];
const _c5$b = [1, "search-widget__bar"];
const _c6$a = ["id", "search-bar", "type", "text", "placeholder", "Search...", "data-cy", "search-bar", 3, "formControl"];
const _c7$9 = ["searchBar", ""];
const _c8$9 = ["type", "button", "data-cy", "search-close", 1, "close", 3, "click"];
const _c9$9 = [1, "search-widget__results", 3, "ngClass"];
const _c10$8 = [3, "id", "loader", "spinner", "spinnerPosition"];
const _c11$6 = ["search_widget_spinner", ""];
const _c12$6 = ["class", "search-widget__no-results", 4, "ngIf"];
const _c13$6 = ["class", "search-widget__results__list", "data-cy", "search-results-list", 4, "ngIf"];
const _c14$5 = [1, "search-widget__no-results"];
function SearchWidgetComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c14$5);
    ɵɵtext(1, "No results");
    ɵɵelementEnd();
} }
const _c15$4 = ["data-cy", "search-results-list", 1, "search-widget__results__list"];
const _c16$3 = ["class", "search-widget__results__list-item", "data-cy", "search-result-item", 3, "ngClass", 4, "ngFor", "ngForOf"];
const _c17$3 = ["data-cy", "search-result-item", 1, "search-widget__results__list-item", 3, "ngClass"];
const _c18$3 = ["href", "javascript:void(0)", "data-cy", "search-result-link", 1, "search-widget__results__link", 3, "mouseover", "mouseout", "click"];
const _c19$3 = [1, "search-widget__results__result-category"];
const _c20$3 = function (a0) { return { "search-widget__results__list-item--selected": a0 }; };
function SearchWidgetComponent_ul_11_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r407 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c17$3);
    ɵɵelementStart(1, "a", _c18$3);
    ɵɵlistener("mouseover", function SearchWidgetComponent_ul_11_li_1_Template_a_mouseover_1_listener($event) { ɵɵrestoreView(_r407); const i_r405 = ctx.index; const ctx_r406 = ɵɵnextContext(2); return ctx_r406.hoverStatus(true, i_r405); });
    ɵɵlistener("mouseout", function SearchWidgetComponent_ul_11_li_1_Template_a_mouseout_1_listener($event) { ɵɵrestoreView(_r407); const i_r405 = ctx.index; const ctx_r408 = ɵɵnextContext(2); return ctx_r408.hoverStatus(false, i_r405); });
    ɵɵlistener("click", function SearchWidgetComponent_ul_11_li_1_Template_a_click_1_listener($event) { ɵɵrestoreView(_r407); const result_r404 = ctx.$implicit; const ctx_r409 = ɵɵnextContext(2); return ctx_r409.selectChoice(result_r404); });
    ɵɵtext(2);
    ɵɵelementStart(3, "span", _c19$3);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const result_r404 = ctx.$implicit;
    const i_r405 = ctx.index;
    const ctx_r403 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c20$3, i_r405 === ctx_r403.selectedSearchResultIndex && !ctx_r403.hoverItemSelected));
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", result_r404.value, " in ");
    ɵɵselect(4);
    ɵɵtextInterpolate(result_r404.label);
} }
function SearchWidgetComponent_ul_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ul", _c15$4);
    ɵɵtemplate(1, SearchWidgetComponent_ul_11_li_1_Template, 5, 5, "li", _c16$3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r402 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r402.searchResults);
} }
const _c21$3 = function (a0) { return { "search-widget-hidden": a0 }; };
const _c22$3 = function (a0) { return { "top": a0 }; };
const _c23$3 = function (a0, a1) { return { "search-widget-hidden": a0, active: a1 }; };
var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["UP_ARROW"] = 38] = "UP_ARROW";
    KEY_CODE[KEY_CODE["DOWN_ARROW"] = 40] = "DOWN_ARROW";
    KEY_CODE[KEY_CODE["ENTER"] = 13] = "ENTER";
    KEY_CODE[KEY_CODE["ESCAPE"] = 27] = "ESCAPE";
})(KEY_CODE || (KEY_CODE = {}));
class SearchWidgetComponent {
    constructor(renderer, document) {
        this.renderer = renderer;
        this.document = document;
        this.subs = new SubSink();
        this.search = new FormControl("");
        // tslint:disable-next-line: no-output-on-prefix
        this.onHide = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onSelect = new EventEmitter();
        this.searchWidgetOpenClass = "search-widget-open";
    }
    onKeyDown(evt) {
        switch (evt.keyCode) {
            case KEY_CODE.ESCAPE:
                this.closeWidget();
                break;
            case KEY_CODE.ENTER:
                if (this.search.value === null || this.searchResults === null || this.searchResults.length === 0) {
                    break;
                }
                if (this.selectedSearchResultIndex === null) {
                    this.selectedSearchResultIndex = 0;
                }
                this.selectChoice(this.searchResults[this.selectedSearchResultIndex]);
                break;
            case KEY_CODE.UP_ARROW:
                if (this.selectedSearchResultIndex !== null && this.selectedSearchResultIndex > 0) {
                    this.selectedSearchResultIndex--;
                }
                break;
            case KEY_CODE.DOWN_ARROW:
                if (this.selectedSearchResultIndex === null) {
                    this.selectedSearchResultIndex = 0;
                }
                else if (this.selectedSearchResultIndex < this.searchResults.length - 1) {
                    this.selectedSearchResultIndex++;
                }
                break;
        }
    }
    closeWidget() {
        this.isActive = "";
        this.hideResults();
        this.resetSelection();
        this.onHide.emit("com.search.hide");
    }
    selectChoice(selectedData) {
        this.onSelect.emit(selectedData);
        if (this.closeOnSelect) {
            this.closeWidget();
        }
    }
    hideResults() {
        this.searchResults.length = 0;
        this.isResultsVisible = "";
        this.spinner.complete();
        return true;
    }
    ngOnInit() {
        this.isStaticDataSet = !this.requester;
        if (!this.resultsMapper) {
            this.resultsMapper = (initData) => {
                return {
                    label: initData.label,
                    value: this.search.value,
                    action: initData.action
                };
            };
        }
        this.searchResults = [];
        this.resetSelection();
        this.onValueChanges();
    }
    ngOnChanges(changes) {
        if (changes['isActive'].currentValue === "active" || changes['isActive'].currentValue === 'true') {
            this.setSearchFocus();
            this.addBodyClass();
        }
        else {
            this.removeBodyClass();
        }
    }
    setSearchFocus() {
        setTimeout(() => this.searchBarRef.nativeElement.focus());
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    onValueChanges() {
        this.subs.sink = this.search.valueChanges
            .pipe(tap(() => {
            this.hideResults();
        }), debounceTime(300))
            .subscribe(val => {
            this.getResults(val);
        });
    }
    hoverStatus(isHoverOn, currentHoverItem) {
        this.hoverItemSelected = isHoverOn;
        if (isHoverOn) {
            if (this.selectedSearchResultIndex !== null) {
                this.previouslySelectedSearchResultIndex = this.selectedSearchResultIndex;
            }
            this.selectedSearchResultIndex = currentHoverItem;
        }
        else if (!isHoverOn) {
            this.selectedSearchResultIndex = this.previouslySelectedSearchResultIndex;
        }
    }
    getResults(searchString) {
        if (!searchString) {
            return;
        }
        this.resetSelection();
        this.isResultsVisible = "active";
        if (this.isStaticDataSet) {
            this.searchResults = this.searchAreas.map((item) => {
                return this.resultsMapper(item);
            });
            return;
        }
        this.isRequestSent = "requesting";
        this.subs.sink = this.requester(searchString).subscribe((data) => {
            this.searchResults = data.map((item) => {
                this.isRequestSent = "";
                return this.resultsMapper(item, searchString);
            });
        });
    }
    resetSelection() {
        this.selectedSearchResultIndex = null;
        this.previouslySelectedSearchResultIndex = null;
        this.hoverItemSelected = false;
    }
    addBodyClass() {
        this.renderer.addClass(this.document.body, this.searchWidgetOpenClass);
    }
    removeBodyClass() {
        this.renderer.removeClass(this.document.body, this.searchWidgetOpenClass);
    }
}
/** @nocollapse */ SearchWidgetComponent.ngComponentDef = ɵɵdefineComponent({ type: SearchWidgetComponent, selectors: [["lib-search-widget"]], factory: function SearchWidgetComponent_Factory(t) { return new (t || SearchWidgetComponent)(ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(DOCUMENT)); }, viewQuery: function SearchWidgetComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$e, true);
        ɵɵstaticViewQuery(_c1$e, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.spinner = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.searchBarRef = _t.first);
    } }, hostBindings: function SearchWidgetComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("keydown", function SearchWidgetComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { searchAreas: "searchAreas", width: "width", overlayTop: "overlayTop", isActive: "isActive", closeOnSelect: "closeOnSelect", resultsMapper: "resultsMapper", requester: "requester" }, outputs: { onHide: "onHide", onSelect: "onSelect" }, features: [ɵɵNgOnChangesFeature()], consts: 12, vars: 17, template: function SearchWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c2$c);
        ɵɵelementStart(1, "div", _c3$c);
        ɵɵlistener("click", function SearchWidgetComponent_Template_div_click_1_listener($event) { return ctx.closeWidget(); });
        ɵɵelementEnd();
        ɵɵelementStart(2, "div", _c4$b);
        ɵɵelementStart(3, "div", _c5$b);
        ɵɵelement(4, "input", _c6$a, _c7$9);
        ɵɵelementStart(6, "button", _c8$9);
        ɵɵlistener("click", function SearchWidgetComponent_Template_button_click_6_listener($event) { return ctx.closeWidget(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", _c9$9);
        ɵɵelement(8, "lib-progress", _c10$8, _c11$6);
        ɵɵtemplate(10, SearchWidgetComponent_div_10_Template, 2, 0, "div", _c12$6);
        ɵɵtemplate(11, SearchWidgetComponent_ul_11_Template, 2, 1, "ul", _c13$6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c21$3, ctx.isActive === "false" || ctx.isActive === ""));
        ɵɵselect(1);
        ɵɵproperty("ngStyle", ɵɵpureFunction1(12, _c22$3, ctx.overlayTop));
        ɵɵselect(4);
        ɵɵproperty("formControl", ctx.search);
        ɵɵselect(7);
        ɵɵproperty("ngClass", ɵɵpureFunction2(14, _c23$3, !ctx.isResultsVisible, !!ctx.isRequestSent));
        ɵɵselect(8);
        ɵɵproperty("id", "search_widget_spinner")("loader", false)("spinner", true)("spinnerPosition", "center");
        ɵɵselect(10);
        ɵɵproperty("ngIf", ctx.searchResults.length && 1 > ctx.searchResults.length);
        ɵɵselect(11);
        ɵɵproperty("ngIf", ctx.searchResults.length && 0 < ctx.searchResults.length);
    } }, directives: [NgClass, NgStyle, DefaultValueAccessor, NgControlStatus, FormControlDirective, ProgressComponent, NgIf, NgForOf], styles: [".search-widget__results__link:hover,.search-widget__results__list-item--selected .search-widget__results__link{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent}.search-widget__results__link,.search-widget__results__result-category,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.search-widget__results__link,.search-widget__results__result-category{font-weight:400;font-size:16px;letter-spacing:.4px;line-height:1.5}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.search-widget-hidden{display:none!important;visibility:hidden!important}.search-widget{width:100%;position:absolute;top:0;left:0;right:0;z-index:15}.search-widget:active,.search-widget:focus{outline:0}.search-widget::before{content:\"\";display:block;position:absolute;top:0;right:0;left:0;bottom:0;width:100%;z-index:15;opacity:.43;-webkit-filter:blur(2.9rem);filter:blur(2.9rem);background-image:radial-gradient(circle at 50% 100%,rgba(255,86,124,.5),rgba(255,86,124,0) 47%),radial-gradient(circle at 100% 100%,#a664fd,rgba(166,100,253,0) 70%),radial-gradient(circle at 0 100%,#5487fd,rgba(60,116,246,0) 69%)}.search-widget__overlay{position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(255,255,255,.9);z-index:10}.search-widget__wrapper{background:#f9f9f9;border-bottom:1px solid #fff;box-shadow:0 .2rem 3rem 0 rgba(0,0,0,.08);width:100%;position:relative;z-index:15;display:-ms-grid;display:grid;-ms-grid-columns:([col-start] 1fr)[14];grid-template-columns:repeat(14,[col-start] 1fr)}@media (max-width:833px){.search-widget__wrapper{display:block}}@media (min-width:1680px){.search-widget__wrapper{display:block}.search-widget__bar{margin-left:auto;margin-right:auto;width:143.5rem}}.search-widget__bar{display:-webkit-box;display:flex;position:relative;grid-column:col-start 2/span 12;padding:1.8rem 3rem}.search-widget__bar input{padding-left:3.4rem;background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/search.svg) left center/2.8rem no-repeat;outline:0;border:0;-webkit-box-flex:1;flex-grow:1}.search-widget__results{grid-column:col-start 2/span 12;min-height:3rem;padding:0 3rem}@media (min-width:1680px){.search-widget__results{margin-left:auto;margin-right:auto;width:143.5rem}}.search-widget__results__list{list-style:none;padding:0 0 .5rem 3.3rem;position:relative;top:-.4rem}.search-widget__results__list::before{border-top:1px solid #918d91;content:\"\";position:absolute;top:-2.4rem;width:97%}.search-widget__results__list-item{margin:3rem 0}.search-widget__results__list-item:first-of-type{margin-top:1.5rem}.search-widget__results__list-item:last-of-type{margin-bottom:1.5rem}.search-widget__results.active{min-height:15rem}.search-widget__results__link{color:#322d32;cursor:pointer;text-decoration:none}.search-widget__results__result-category{font-weight:700;margin-left:.2rem}.search-widget .close{width:2.4rem;height:2.4rem;background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/cross.svg) center center/2rem no-repeat;cursor:pointer;position:relative;right:0}body.search-widget-open{overflow:hidden}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(SearchWidgetComponent, [{
        type: Component,
        args: [{
                selector: "lib-search-widget",
                templateUrl: "./search-widget.component.html",
                styleUrls: ["./search-widget.component.scss"],
                // This component interacts with the body element to add/remove class when the widget is opened or closed.
                // Search Widget's styles are inside the 'search-widget' class selector. So, using none should be OK.
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { searchAreas: [{
            type: Input
        }], width: [{
            type: Input
        }], overlayTop: [{
            type: Input
        }], isActive: [{
            type: Input
        }], closeOnSelect: [{
            type: Input
        }], resultsMapper: [{
            type: Input
        }], requester: [{
            type: Input
        }], onHide: [{
            type: Output
        }], onSelect: [{
            type: Output
        }], spinner: [{
            type: ViewChild,
            args: ["search_widget_spinner", { static: true }]
        }], searchBarRef: [{
            type: ViewChild,
            args: ["searchBar", { static: true }]
        }], onKeyDown: [{
            type: HostListener,
            args: ["keydown", ["$event"]]
        }] });

const _c0$f = ["accountDropdownMenu"];
const _c1$f = ["mobileNavDropdownMenu"];
const _c2$d = ["utilityDropdownMenu"];
const _c3$d = ["notificationsDropdownMenu"];
const _c4$c = ["utilityNotificationsDropdownMenu"];
const _c5$c = ["applicationsLoadSpinner"];
const _c6$b = ["searchWidget"];
const _c7$a = [1, "universal-navbar", 3, "ngClass"];
const _c8$a = [3, "resultsMapper", "requester", "searchAreas", "isActive", "closeOnSelect", "width", "overlayTop", "onSelect", "onHide"];
const _c9$a = ["searchWidget", ""];
const _c10$9 = [1, "universal-navbar__container"];
const _c11$7 = [1, "universal-navbar__top"];
const _c12$7 = ["aria-label", "Illumina Home", "href", "javascript:void(0)", 1, "universal-navbar__logo-link", 3, "click"];
const _c13$7 = [1, "universal-navbar__logo"];
const _c14$6 = ["href", "javascript:void(0)", "class", "universal-navbar__top__product-name", "data-cy", "navbar-productname", 3, "click", 4, "ngIf"];
const _c15$5 = [1, "universal-navbar__inline-list"];
const _c16$4 = [1, "universal-navbar__list-item", "universal-navbar__list-item--workgroup", 3, "ngClass"];
const _c17$4 = ["id", "user-dropdown", 1, "universal-navbar__list-item__dropdown"];
const _c18$4 = ["accDropdownMenu", ""];
const _c19$4 = ["aria-label", "Open user Menu", "lib-icon-btn", "", "icon", "", "iconType", "user", 1, "universal-navbar__icon", "universal-navbar__icon--workgroup", 3, "click"];
const _c20$4 = ["class", "universal-navbar__icon--workgroup-name", 4, "ngIf"];
const _c21$4 = ["class", "account-dropdown__email", "style", "display: none", 4, "ngIf"];
const _c22$4 = [3, "reference", "startPosition", "config"];
const _c23$4 = ["accountDropdownMenu", ""];
const _c24$3 = [1, "drop-down", "drop-down-account"];
const _c25$3 = ["class", "drop-down-title text-center", 4, "ngIf"];
const _c26$3 = [1, "drop-down-content"];
const _c27$3 = ["class", "drop-down__workgroup-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"];
const _c28$3 = ["class", "drop-down-menu", 4, "ngIf"];
const _c29$2 = [1, "universal-navbar__list-item", "universal-navbar__list-item--icon", "universal-navbar__list-item--applications", 3, "ngClass"];
const _c30$2 = [1, "application-button-wrapper", "text-right"];
const _c31$2 = ["threeColumnMenu", ""];
const _c32$2 = ["aria-label", "Open list of products", "lib-icon-btn", "", "icon", "", "iconType", "waffle", 1, "universal-navbar__icon", "universal-navbar__icon--application", 3, "click"];
const _c33$2 = ["customClass", "product-switcher__overlay", 3, "reference", "startPosition", "positions", "config"];
const _c34$2 = ["threeColumnMenuLayer", ""];
const _c35$2 = [1, "drop-down", "product-switcher"];
const _c36$2 = [3, "id", "loader", "spinner", "spinnerPosition"];
const _c37$2 = ["applicationsLoadSpinner", ""];
const _c38$2 = [1, "product-switcher__content"];
const _c39$2 = ["class", "product-switcher__content__column", 4, "ngFor", "ngForOf"];
const _c40$2 = ["class", "product-switcher__actions", 4, "ngIf"];
const _c41$1 = [1, "universal-navbar__bottom"];
const _c42$1 = ["class", "universal-navbar__mobile-menu", "id", "mobile-menu", 3, "ngClass", 4, "ngIf"];
const _c43$1 = [1, "universal-navbar__bottom__search"];
const _c44$1 = ["lib-icon-btn", "", "icon", "", "iconType", "search-glass", "aria-label", "Search BaseSpace", "data-cy", "navbar-search-action", 3, "click"];
const _c45$1 = [1, "universal-navbar__page-title"];
const _c46$1 = ["class", "universal-navbar__navigation", 4, "ngIf"];
const _c47$1 = [1, "universal-navbar__inline-list", "universal-navbar__inline-list--utility-links"];
const _c48$1 = ["class", "universal-navbar__list-item universal-navbar__list-item--icon", 3, "ngClass", 4, "ngIf"];
const _c49$1 = [1, "universal-navbar__list-item", "universal-navbar__list-item--icon"];
const _c50$1 = ["aria-label", "Trash", "lib-icon-btn", "", "icon", "", "iconType", "trash", 3, "badge", "click"];
const _c51$1 = ["aria-label", "Help", "lib-icon-btn", "", "icon", "", "iconType", "help-circle", 1, "walkeme-trigger--panel", 3, "click"];
const _c52$1 = ["id", "mobile-menu", 1, "universal-navbar__inline-list", "universal-navbar__mobile-utility-menu", 3, "ngClass"];
const _c53$1 = ["utilityMenuBtn", ""];
const _c54 = ["aria-label", "Utility Menu", "aria-hidden", "true", "lib-icon-btn", "", "icon", "", "iconType", "kebab-white", 1, "universal-navbar__icon", "universal-navbar__mobile-utility-menu-btn", 3, "click"];
const _c55 = [3, "reference", "startPosition", "positions", "config"];
const _c56 = ["utilityDropdownMenu", ""];
const _c57 = [1, "drop-down", "universal-navbar__mobile-utility-menu--drop-down"];
const _c58 = [1, "drop-down-content__ul"];
const _c59 = [4, "ngIf"];
const _c60 = ["title", "Help", "href", "javsacript:void(0)", 1, "universal-navbar__mobile-menu__link", "walkeme-trigger--panel", 3, "click"];
const _c61 = ["title", "Trash", "href", "javsacript:void(0)", 1, "universal-navbar__mobile-menu__link", 3, "click"];
const _c62 = ["utilityNotificationsDropdownMenuRef", ""];
const _c63 = ["utilityNotificationsDropdownMenu", ""];
const _c64 = [1, "drop-down", "notifications-menu", "notifications-menu__mobile-top"];
const _c65 = [1, "notifications-menu__title"];
const _c66 = [1, "notifications-menu__content"];
const _c67 = ["class", "notifications-menu__content__item", 4, "ngIf"];
const _c68 = ["class", "notifications-menu__content__item", 4, "ngFor", "ngForOf"];
const _c69 = ["href", "javascript:void(0)", "data-cy", "navbar-productname", 1, "universal-navbar__top__product-name", 3, "click"];
function UniversalNavbarComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r436 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c69);
    ɵɵlistener("click", function UniversalNavbarComponent_a_7_Template_a_click_0_listener($event) { ɵɵrestoreView(_r436); const ctx_r435 = ɵɵnextContext(); return ctx_r435.openLink(ctx_r435.titleLink, ctx_r435.titleLinkNewWindow); });
    ɵɵtext(1);
    ɵɵpipe(2, "titlecase");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r411 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, ctx_r411.title));
} }
const _c70 = [1, "universal-navbar__icon--workgroup-name"];
function UniversalNavbarComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c70);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const currentUser_r437 = ctx.ngIf;
    ɵɵselect(1);
    ɵɵtextInterpolate(currentUser_r437.Name);
} }
const _c71 = [1, "account-dropdown__email", 2, "display", "none"];
function UniversalNavbarComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c71);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const currentUser_r438 = ctx.ngIf;
    ɵɵselect(1);
    ɵɵtextInterpolate(currentUser_r438 == null ? null : currentUser_r438.LoggedInUser.Email);
} }
const _c72 = [1, "drop-down-title", "text-center"];
function UniversalNavbarComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c72);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const currentUser_r439 = ctx.ngIf;
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", currentUser_r439.Name, " ");
} }
const _c73 = ["type", "text", 3, "lines"];
const _c74 = {};
function UniversalNavbarComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c72);
    ɵɵelement(1, "lib-skeleton", _c73);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵproperty("@fadeIn", _c74);
    ɵɵselect(1);
    ɵɵproperty("lines", 1);
} }
const _c75 = [1, "drop-down__workgroup-item", 3, "ngClass", "click"];
const _c76 = ["class", "drop-down__workgroup-item__clamp", 4, "ngIf"];
const _c77 = [1, "drop-down__workgroup-item__clamp"];
function UniversalNavbarComponent_li_27_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c77);
    ɵɵelement(1, "lib-skeleton", _c73);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("lines", 1);
} }
function UniversalNavbarComponent_li_27_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c77);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r441 = ɵɵnextContext().$implicit;
    ɵɵselect(1);
    ɵɵtextInterpolate(option_r441.Name);
} }
const _c78 = function (a0, a1) { return { "active-option": a0, "no-content": a1 }; };
function UniversalNavbarComponent_li_27_Template(rf, ctx) { if (rf & 1) {
    const _r447 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c75);
    ɵɵlistener("click", function UniversalNavbarComponent_li_27_Template_li_click_0_listener($event) { ɵɵrestoreView(_r447); const option_r441 = ctx.$implicit; const ctx_r446 = ɵɵnextContext(); return ctx_r446.workgroupSelected(option_r441); });
    ɵɵpipe(1, "async");
    ɵɵtemplate(2, UniversalNavbarComponent_li_27_div_2_Template, 2, 1, "div", _c76);
    ɵɵpipe(3, "async");
    ɵɵtemplate(4, UniversalNavbarComponent_li_27_span_4_Template, 2, 1, "span", _c76);
    ɵɵpipe(5, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r441 = ctx.$implicit;
    const ctx_r418 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction2(11, _c78, option_r441.Active, ɵɵpipeBind1(1, 5, ctx_r418.userDataLoading$)))("@fadeIn", option_r441);
    ɵɵattribute("aria-label", "Switch to " + option_r441.Name + " workgroup");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ɵɵpipeBind1(3, 7, ctx_r418.userDataLoading$));
    ɵɵselect(4);
    ɵɵproperty("ngIf", !ɵɵpipeBind1(5, 9, ctx_r418.userDataLoading$));
} }
const _c79 = [1, "drop-down-menu"];
const _c80 = [4, "ngFor", "ngForOf"];
const _c81 = ["lib-btn", "", "link", "", "class", "font-weight-normal", 4, "ngIf"];
const _c82 = ["href", "javascript:void(0)", "lib-btn", "", "secondary", "", "signOut", "", "class", "font-weight-normal", 3, "click", 4, "ngIf"];
const _c83 = ["lib-btn", "", "link", "", 1, "font-weight-normal"];
function UniversalNavbarComponent_div_29_li_2_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", _c83);
    ɵɵtext(1);
    ɵɵpipe(2, "titlecase");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r449 = ɵɵnextContext().$implicit;
    ɵɵattribute("href", item_r449.url, ɵɵsanitizeUrl)("target", item_r449.inNew === true ? "_blank" : "_self");
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 3, item_r449.title), " ");
} }
const _c84 = ["href", "javascript:void(0)", "lib-btn", "", "secondary", "", "signOut", "", 1, "font-weight-normal", 3, "click"];
function UniversalNavbarComponent_div_29_li_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r455 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c84);
    ɵɵlistener("click", function UniversalNavbarComponent_div_29_li_2_a_2_Template_a_click_0_listener($event) { ɵɵrestoreView(_r455); const item_r449 = ɵɵnextContext().$implicit; const ctx_r453 = ɵɵnextContext(2); return ctx_r453.signOutClick(item_r449); });
    ɵɵtext(1);
    ɵɵpipe(2, "titlecase");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r449 = ɵɵnextContext().$implicit;
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, item_r449.title), " ");
} }
function UniversalNavbarComponent_div_29_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li");
    ɵɵtemplate(1, UniversalNavbarComponent_div_29_li_2_a_1_Template, 3, 5, "a", _c81);
    ɵɵtemplate(2, UniversalNavbarComponent_div_29_li_2_a_2_Template, 3, 3, "a", _c82);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r449 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", item_r449.type === "link");
    ɵɵselect(2);
    ɵɵproperty("ngIf", item_r449.type === "signout");
} }
function UniversalNavbarComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c79);
    ɵɵelementStart(1, "ul");
    ɵɵtemplate(2, UniversalNavbarComponent_div_29_li_2_Template, 3, 2, "li", _c80);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r419 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵproperty("ngForOf", ctx_r419.profileLinks);
} }
const _c85 = [1, "product-switcher__content__column"];
const _c86 = [1, "product-switcher__content__title"];
const _c87 = ["class", "product-switcher__content__item", 4, "ngFor", "ngForOf"];
const _c88 = [1, "product-switcher__content__item"];
const _c89 = ["role", "menuitem", 1, "product-switcher__content__item-link"];
function UniversalNavbarComponent_div_40_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c88);
    ɵɵelementStart(1, "a", _c89);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r460 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵattribute("target", item_r460.inNew === true ? "_blank" : "_self")("href", item_r460.url, ɵɵsanitizeUrl);
    ɵɵselect(2);
    ɵɵtextInterpolate(item_r460.title);
} }
function UniversalNavbarComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c85);
    ɵɵelementStart(1, "h5", _c86);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, UniversalNavbarComponent_div_40_div_3_Template, 3, 3, "div", _c87);
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r457 = ctx.$implicit;
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", option_r457.title, " ");
    ɵɵselect(3);
    ɵɵproperty("ngForOf", option_r457.data);
} }
const _c90 = [1, "product-switcher__actions"];
const _c91 = ["role", "menuitem", 1, "product-switcher__actions__link", 3, "title"];
function UniversalNavbarComponent_section_42_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "section", _c90);
    ɵɵelementStart(1, "a", _c91);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r424 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵpropertyInterpolate("title", ctx_r424.applicationLinkBottom.title);
    ɵɵattribute("target", ctx_r424.applicationLinkBottom.inNew === true ? "_blank" : "_self")("href", ctx_r424.applicationLinkBottom.url, ɵɵsanitizeUrl);
    ɵɵselect(2);
    ɵɵtextInterpolate(ctx_r424.applicationLinkBottom.title);
} }
const _c92 = ["id", "mobile-menu", 1, "universal-navbar__mobile-menu", 3, "ngClass"];
const _c93 = ["mobileNavMenuBtn", ""];
const _c94 = ["aria-hidden", "true", "aria-label", "Open Main Menu", "lib-icon-btn", "", "icon", "", "iconType", "hamburger-menu", 1, "universal-navbar__icon", "universal-navbar__mobile-menu-btn", 3, "click"];
const _c95 = [3, "reference", "startPosition", "config", "positions"];
const _c96 = ["mobileNavDropdownMenu", ""];
const _c97 = [1, "drop-down", "universal-navbar__mobile-menu--drop-down"];
const _c98 = ["href", "javsacript:void(0)", 1, "universal-navbar__mobile-menu__link", 3, "ngClass", "routerLink", "click"];
const _c99 = function (a0, a1) { return { "active-option": a0, "universal-navbar__navigation__link--disabled": a1 }; };
function UniversalNavbarComponent_div_44_li_8_Template(rf, ctx) { if (rf & 1) {
    const _r466 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li");
    ɵɵelementStart(1, "a", _c98);
    ɵɵlistener("click", function UniversalNavbarComponent_div_44_li_8_Template_a_click_1_listener($event) { ɵɵrestoreView(_r466); const link_r464 = ctx.$implicit; const ctx_r465 = ɵɵnextContext(2); return ctx_r465.setActive(link_r464.url); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const link_r464 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(4, _c99, link_r464.active, link_r464.disabled))("routerLink", link_r464.url);
    ɵɵattribute("title", link_r464.title);
    ɵɵselect(2);
    ɵɵtextInterpolate(link_r464.title);
} }
const _c100 = function (a0) { return { "universal-navbar__mobile-menu--active": a0 }; };
const _c101 = { minHeight: "200px", height: "320px", width: "220px", minWidth: "220px" };
function UniversalNavbarComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    const _r468 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c92, _c93);
    ɵɵelementStart(2, "button", _c94);
    ɵɵlistener("click", function UniversalNavbarComponent_div_44_Template_button_click_2_listener($event) { ɵɵrestoreView(_r468); const _r462 = ɵɵreference(4); const ctx_r467 = ɵɵnextContext(); return ctx_r467.toggleActionButton("isMobileMenuOpen", "mobileNavMenuOpen", [_r462]); });
    ɵɵelementEnd();
    ɵɵelementStart(3, "lib-dropdown", _c95, _c96);
    ɵɵelementStart(5, "overlay-scrollbars", _c97);
    ɵɵelementStart(6, "div", _c26$3);
    ɵɵelementStart(7, "ul", _c58);
    ɵɵtemplate(8, UniversalNavbarComponent_div_44_li_8_Template, 3, 7, "li", _c80);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const _r461 = ɵɵreference(1);
    const _r462 = ɵɵreference(4);
    const ctx_r425 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c100, _r462.showing));
    ɵɵselect(3);
    ɵɵproperty("reference", _r461)("startPosition", "bottom")("config", _c101)("positions", ctx_r425.mobileNavMenuPosition);
    ɵɵselect(8);
    ɵɵproperty("ngForOf", ctx_r425.links);
} }
const _c102 = [1, "universal-navbar__navigation"];
const _c103 = ["class", "universal-navbar__navigation__link", "href", "javsacript:void(0)", 3, "ngClass", "routerLink", "click", 4, "ngFor", "ngForOf"];
const _c104 = ["href", "javsacript:void(0)", 1, "universal-navbar__navigation__link", 3, "ngClass", "routerLink", "click"];
const _c105 = function (a0, a1) { return { "universal-navbar__navigation__link--selected": a0, "universal-navbar__navigation__link--disabled": a1 }; };
function UniversalNavbarComponent_div_49_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r472 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c104);
    ɵɵlistener("click", function UniversalNavbarComponent_div_49_a_1_Template_a_click_0_listener($event) { ɵɵrestoreView(_r472); const link_r470 = ctx.$implicit; const ctx_r471 = ɵɵnextContext(2); return ctx_r471.setActive(link_r470.url); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const link_r470 = ctx.$implicit;
    ɵɵproperty("ngClass", ɵɵpureFunction2(4, _c105, link_r470.active, link_r470.disabled))("routerLink", link_r470.url);
    ɵɵattribute("title", link_r470.title);
    ɵɵselect(1);
    ɵɵtextInterpolate(link_r470.title);
} }
function UniversalNavbarComponent_div_49_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c102);
    ɵɵtemplate(1, UniversalNavbarComponent_div_49_a_1_Template, 2, 7, "a", _c103);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r426 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r426.links);
} }
const _c106 = [1, "universal-navbar__list-item", "universal-navbar__list-item--icon", 3, "ngClass"];
const _c107 = ["notificationsDropdownMenuRef", ""];
const _c108 = ["aria-label", "Notifications", "lib-icon-btn", "", "icon", "", "iconType", "notification-bell", 1, "notifications-dropdown-button", 3, "click"];
const _c109 = ["notificationsDropdownMenu", ""];
const _c110 = [1, "drop-down", "notifications-menu"];
const _c111 = [1, "notifications-menu__content__item"];
const _c112 = ["data-cy", "notification-alertNotificationsMessage", 1, "notifications-menu__card__description", 3, "title"];
function UniversalNavbarComponent_li_51_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c111);
    ɵɵelementStart(1, "h5", _c112);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r475 = ɵɵnextContext(2);
    ɵɵproperty("@fadeIn", _c74);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("title", ctx_r475.alertNotificationsMessage);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r475.alertNotificationsMessage, " ");
} }
const _c113 = ["class", "notifications-menu__card__loader", 4, "ngIf"];
const _c114 = ["class", "notifications-menu__card", 4, "ngIf"];
const _c115 = [1, "notifications-menu__card__loader"];
const _c116 = ["type", "text", 1, "notifications-menu__card__loader-title", 3, "lines"];
const _c117 = ["type", "text", 1, "notifications-menu__card__loader-description", 3, "lines"];
function UniversalNavbarComponent_li_51_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c115);
    ɵɵelement(1, "lib-skeleton", _c116);
    ɵɵelement(2, "lib-skeleton", _c117);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("lines", 1);
    ɵɵselect(2);
    ɵɵproperty("lines", 1);
} }
const _c118 = [1, "notifications-menu__card"];
const _c119 = [1, "notifications-menu__card__content"];
const _c120 = ["data-cy", "notification-title", 1, "notifications-menu__card__title", 3, "title"];
const _c121 = ["data-cy", "notification-date", 1, "notifications-menu__card__date", 3, "title"];
const _c122 = ["data-cy", "notification-description", 1, "notifications-menu__card__description", 3, "title"];
const _c123 = ["href", "javascript:void(0)", "data-cy", "notification-card-link", 1, "notifications-menu__card__link", 3, "ngClass", "routerLink"];
const _c124 = [1, "notifications-menu__card__actions"];
const _c125 = ["type", "button", "aria-label", "Close", "class", "notifications-menu__card__actions-close-btn", 3, "click", 4, "ngIf"];
const _c126 = ["type", "button", "aria-label", "Close", 1, "notifications-menu__card__actions-close-btn", 3, "click"];
const _c127 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "notifications-menu__card__actions-close-icon"];
const _c128 = ["d", "M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z", "fill", "#656066"];
function UniversalNavbarComponent_li_51_div_11_div_3_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r485 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c126);
    ɵɵlistener("click", function UniversalNavbarComponent_li_51_div_11_div_3_button_11_Template_button_click_0_listener($event) { ɵɵrestoreView(_r485); const i_r479 = ɵɵnextContext(2).index; const ctx_r483 = ɵɵnextContext(2); return ctx_r483.removeAlert(i_r479); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c127);
    ɵɵelement(2, "path", _c128);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c129 = function (a0) { return { "u-link-not-clickable": a0 }; };
function UniversalNavbarComponent_li_51_div_11_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c118);
    ɵɵelementStart(1, "div", _c119);
    ɵɵelementStart(2, "h5", _c120);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "h5", _c121);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "h5", _c122);
    ɵɵtext(7);
    ɵɵelementStart(8, "a", _c123);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", _c124);
    ɵɵtemplate(11, UniversalNavbarComponent_li_51_div_11_div_3_button_11_Template, 3, 0, "button", _c125);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const notification_r477 = ɵɵnextContext().$implicit;
    ɵɵselect(2);
    ɵɵpropertyInterpolate("title", notification_r477.title);
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", notification_r477.title, " ");
    ɵɵselect(4);
    ɵɵpropertyInterpolate("title", notification_r477.date);
    ɵɵselect(5);
    ɵɵtextInterpolate1(" ", notification_r477.date, " ");
    ɵɵselect(6);
    ɵɵpropertyInterpolate("title", notification_r477.description);
    ɵɵselect(7);
    ɵɵtextInterpolate1(" ", notification_r477.description, ". ");
    ɵɵselect(8);
    ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c129, notification_r477.route == "" || notification_r477.route == "#"))("routerLink", notification_r477.route);
    ɵɵselect(9);
    ɵɵtextInterpolate1(" ", notification_r477.name, " ");
    ɵɵselect(11);
    ɵɵproperty("ngIf", notification_r477.dismissible);
} }
function UniversalNavbarComponent_li_51_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c111);
    ɵɵtemplate(1, UniversalNavbarComponent_li_51_div_11_div_1_Template, 3, 2, "div", _c113);
    ɵɵpipe(2, "async");
    ɵɵtemplate(3, UniversalNavbarComponent_li_51_div_11_div_3_Template, 12, 12, "div", _c114);
    ɵɵpipe(4, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r476 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 2, ctx_r476.userAlertNotificationsLoading$));
    ɵɵselect(3);
    ɵɵproperty("ngIf", !ɵɵpipeBind1(4, 4, ctx_r476.userAlertNotificationsLoading$));
} }
const _c130 = function (a0) { return { "universal-navbar__list-item--active": a0 }; };
const _c131 = { maxHeight: "400px", height: "auto", width: "350px", panelClass: "notifications-dropdown" };
function UniversalNavbarComponent_li_51_Template(rf, ctx) { if (rf & 1) {
    const _r488 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c106);
    ɵɵelementStart(1, "div", null, _c107);
    ɵɵelementStart(3, "button", _c108);
    ɵɵlistener("click", function UniversalNavbarComponent_li_51_Template_button_click_3_listener($event) { ɵɵrestoreView(_r488); const _r474 = ɵɵreference(5); const ctx_r487 = ɵɵnextContext(); return ctx_r487.toggleActionButton("isNotificationsOpen", "notificationsOpen", [_r474]); });
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-dropdown", _c22$4, _c109);
    ɵɵelementStart(6, "div", _c110);
    ɵɵelementStart(7, "div", _c65);
    ɵɵtext(8, "Notifications");
    ɵɵelementEnd();
    ɵɵelementStart(9, "overlay-scrollbars", _c66);
    ɵɵtemplate(10, UniversalNavbarComponent_li_51_div_10_Template, 3, 3, "div", _c67);
    ɵɵtemplate(11, UniversalNavbarComponent_li_51_div_11_Template, 5, 6, "div", _c68);
    ɵɵpipe(12, "async");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const _r473 = ɵɵreference(2);
    const _r474 = ɵɵreference(5);
    const ctx_r427 = ɵɵnextContext();
    var tmp_5_0 = null;
    const currVal_5 = (tmp_5_0 = ɵɵpipeBind1(12, 6, ctx_r427.alertNotifications$)) == null ? null : tmp_5_0.alertCards;
    ɵɵproperty("ngClass", ɵɵpureFunction1(8, _c130, _r474.showing));
    ɵɵselect(4);
    ɵɵproperty("reference", _r473)("startPosition", "bottom")("config", _c131);
    ɵɵselect(10);
    ɵɵproperty("ngIf", ctx_r427.alertNotificationsMessage);
    ɵɵselect(11);
    ɵɵproperty("ngForOf", currVal_5);
} }
const _c132 = ["title", "Notifications", 1, "universal-navbar__mobile-menu__link", 3, "click"];
function UniversalNavbarComponent_li_64_Template(rf, ctx) { if (rf & 1) {
    const _r490 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li");
    ɵɵelementStart(1, "a", _c132);
    ɵɵlistener("click", function UniversalNavbarComponent_li_64_Template_a_click_1_listener($event) { ɵɵrestoreView(_r490); const ctx_r489 = ɵɵnextContext(); const _r432 = ɵɵreference(74); const _r429 = ɵɵreference(60); return ctx_r489.toggleActionButtonWithParent("isNotificationsOpen", "notificationsOpen", [_r432], _r429); });
    ɵɵtext(2, " Notifications");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function UniversalNavbarComponent_div_79_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c111);
    ɵɵelementStart(1, "h5", _c112);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r433 = ɵɵnextContext();
    ɵɵproperty("@fadeIn", _c74);
    ɵɵselect(1);
    ɵɵpropertyInterpolate("title", ctx_r433.alertNotificationsMessage);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r433.alertNotificationsMessage, " ");
} }
function UniversalNavbarComponent_div_80_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c115);
    ɵɵelement(1, "lib-skeleton", _c116);
    ɵɵelement(2, "lib-skeleton", _c117);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("lines", 1);
    ɵɵselect(2);
    ɵɵproperty("lines", 1);
} }
function UniversalNavbarComponent_div_80_div_3_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r499 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c126);
    ɵɵlistener("click", function UniversalNavbarComponent_div_80_div_3_button_11_Template_button_click_0_listener($event) { ɵɵrestoreView(_r499); const i_r493 = ɵɵnextContext(2).index; const ctx_r497 = ɵɵnextContext(); return ctx_r497.removeAlert(i_r493); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c127);
    ɵɵelement(2, "path", _c128);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function UniversalNavbarComponent_div_80_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c118);
    ɵɵelementStart(1, "div", _c119);
    ɵɵelementStart(2, "h5", _c120);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "h5", _c121);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "h5", _c122);
    ɵɵtext(7);
    ɵɵelementStart(8, "a", _c123);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", _c124);
    ɵɵtemplate(11, UniversalNavbarComponent_div_80_div_3_button_11_Template, 3, 0, "button", _c125);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const notification_r491 = ɵɵnextContext().$implicit;
    ɵɵselect(2);
    ɵɵpropertyInterpolate("title", notification_r491.title);
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", notification_r491.title, " ");
    ɵɵselect(4);
    ɵɵpropertyInterpolate("title", notification_r491.date);
    ɵɵselect(5);
    ɵɵtextInterpolate1(" ", notification_r491.date, " ");
    ɵɵselect(6);
    ɵɵpropertyInterpolate("title", notification_r491.description);
    ɵɵselect(7);
    ɵɵtextInterpolate1(" ", notification_r491.description, ". ");
    ɵɵselect(8);
    ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c129, notification_r491.route == "" || notification_r491.route == "#"))("routerLink", notification_r491.route);
    ɵɵselect(9);
    ɵɵtextInterpolate1(" ", notification_r491.name, " ");
    ɵɵselect(11);
    ɵɵproperty("ngIf", notification_r491.dismissible);
} }
function UniversalNavbarComponent_div_80_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c111);
    ɵɵtemplate(1, UniversalNavbarComponent_div_80_div_1_Template, 3, 2, "div", _c113);
    ɵɵpipe(2, "async");
    ɵɵtemplate(3, UniversalNavbarComponent_div_80_div_3_Template, 12, 12, "div", _c114);
    ɵɵpipe(4, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r434 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 2, ctx_r434.userAlertNotificationsLoading$));
    ɵɵselect(3);
    ɵɵproperty("ngIf", !ɵɵpipeBind1(4, 4, ctx_r434.userAlertNotificationsLoading$));
} }
const _c133 = function (a0) { return { "universal-navbar--transparent": a0 }; };
const _c134 = { maxHeight: "auto", height: "auto", panelClass: "applications-menu" };
const _c135 = function (a0) { return { "universal-navbar__mobile-utility-menu--active": a0 }; };
const _c136 = { height: "160px", width: "220px", minWidth: "220px" };
class UniversalNavbarComponent {
    // ────────────────────────────────────────────────────────────────────────────────
    constructor(winRef, _elementRef) {
        this.winRef = winRef;
        this._elementRef = _elementRef;
        this.showNotifications = false;
        this._transparent = null;
        this._links = null;
        this.userDataLoadingSubject = new BehaviorSubject(true);
        this.userDataLoading$ = this.userDataLoadingSubject.asObservable();
        this.userAlertNotificationsLoadingSubject = new BehaviorSubject(true);
        this.userAlertNotificationsLoading$ = this.userAlertNotificationsLoadingSubject.asObservable();
        this.workGroupOpen = new EventEmitter();
        this.mobileNavMenuOpen = new EventEmitter();
        this.utilityMenuOpen = new EventEmitter();
        this.searchOpen = new EventEmitter();
        this.applicationsOpen = new EventEmitter();
        this.notificationsOpen = new EventEmitter();
        this.helpOpen = new EventEmitter();
        this.trashOpen = new EventEmitter();
        this.workGroupSelected = new EventEmitter();
        this.signOutClicked = new EventEmitter();
        this.isWorkGroupOpen = false;
        this.isApplicationOpen = false;
        this.isMobileMenuOpen = false;
        this.isUtiltiyMenuOpen = false;
        this.isHelpOpen = false;
        this.isSearchOpen = false;
        this.isNotificationsOpen = false;
        this.isTrashOpen = false;
        this.pageTitle = "";
        this.userDropDownOpen = false;
        this.applicationDropDownOpen = false;
        this.desktopApplicationsMenuPosition = [
            {
                originX: "end",
                originY: "top",
                overlayX: "end",
                overlayY: "top"
            },
            {
                originX: "end",
                originY: "top",
                overlayX: "end",
                overlayY: "top"
            }
        ];
        this.mobileNavMenuPosition = [
            {
                originX: "start",
                originY: "bottom",
                overlayX: "start",
                overlayY: "top"
            },
            {
                originX: "start",
                originY: "bottom",
                overlayX: "start",
                overlayY: "bottom"
            }
        ];
        this.mobileUtilityMenuPosition = [
            {
                originX: "end",
                originY: "bottom",
                overlayX: "end",
                overlayY: "top"
            },
            {
                originX: "end",
                originY: "bottom",
                overlayX: "end",
                overlayY: "bottom"
            }
        ];
        this.userMenuConfig = {
            maxHeight: '435px',
            height: '435px',
            width: '220px',
            minWidth: '220px',
            panelClass: 'universal-navbar__user-menu-pane'
        };
        // Set up the behavior subject with some seed data to show in skeleton loader.
        this.workGroupDataSubject = new BehaviorSubject(this.getPlaceHolderWorkgroupData());
        this.workGroups$ = this.workGroupDataSubject.asObservable();
        this.applicationsSubject = new BehaviorSubject(this.getPlaceHolderApplicationData());
        this.applications$ = this.applicationsSubject.asObservable();
        // subscription
        this.alertNotificationsSubject$ = new BehaviorSubject(this.getPlaceHolderAlertNotificationData());
        this.alertNotifications$ = this.alertNotificationsSubject$.asObservable();
        this.subs = new SubSink();
        this.dropDownConfig = {};
        this.onSelectSearchAction = new EventEmitter();
        // ────────────────────────────────────────────────────────────────────────────────
        this.notificationDeleted = new EventEmitter();
    }
    get transparent() { return this._transparent; }
    set transparent(value) {
        this._transparent = value;
    }
    get links() { return this._links; }
    set links(value) {
        this._links = value;
        if (this.links && this.links.length > 0) {
            this.setPageTile();
        }
    }
    onSelectAction(selectedData) {
        this.onSelectSearchAction.emit(selectedData);
    }
    ngOnInit() {
        this.userApplicationsLoading$ = this.userApplicationsService.loading$;
        this.setProfileLinkMenuHeight();
        // Use Combine latest to gather both user and workgroup state changes.
        // Necessary to know which is the currently selected user.
        // The service supplies the list of workgroups and the currently active user
        // This logic determines which is active to a 'check icon' on the currently active workgroup/personal context
        this.subs.sink = combineLatest(this.userService.stateChanged, this.userWorkgroupService.stateChanged).subscribe({
            next: ([userState, userWorkGroupState]) => {
                if (userState != null &&
                    userState.currentUser != null &&
                    userWorkGroupState != null &&
                    userWorkGroupState.currentUserWorkgroups != null) {
                    userWorkGroupState.currentUserWorkgroups.Items.forEach(userOrWorkgroup => {
                        userOrWorkgroup.Active =
                            userOrWorkgroup.Id === userState.currentUser.Id;
                    });
                    this.currentUser$ = of(userState.currentUser);
                    this.workGroupDataSubject.next(userWorkGroupState.currentUserWorkgroups.Items);
                    this.userDataLoadingSubject.next(false);
                    // for this to actually wor, we'll have to make the userMenuConfig a behaviorSubject,
                    // and pass it into the dropdown component as an observable. would require some work in the dropdown
                    this.setProfileLinkMenuHeight();
                }
            }
        });
        this.userApplicationsLoading$.pipe(filter(value => value != null)).subscribe({
            next: (isLoading) => {
                if (isLoading) {
                    this.applicationsLoadSpinner.start();
                }
            }
        });
        this.subs.sink = this.userApplicationsService.stateChanged.pipe(filter(state => state != null && state.currentUserApplications != null)).subscribe({
            next: (userApplicationsState) => {
                this.applicationsLoadSpinner.complete();
                setTimeout(() => this.applicationsSubject.next(userApplicationsState.currentUserApplications), 700);
            }
        });
        this.subs.sink = this.userAlertNotificationService.stateChanged.pipe(filter(state => state != null && state.currentUserAlertNotifications != null)).subscribe({
            next: (userAlertNotifications) => {
                setTimeout(() => {
                    this.notifications = userAlertNotifications.currentUserAlertNotifications;
                    this.setAlertNotificationsMessage();
                    this.alertNotificationsSubject$.next(userAlertNotifications.currentUserAlertNotifications);
                }, 700);
                this.userAlertNotificationsLoadingSubject.next(false);
            }
        });
    }
    openLink(url, newWindow = false) {
        if (url == null) {
            return;
        }
        if (newWindow) {
            this.winRef.nativeWindow.open(url);
            return;
        }
        this.winRef.nativeWindow.location.href = url;
    }
    toggleActionButton(updateState, emitState, dropDowns) {
        const emitButtonState = {};
        this[updateState] = this[updateState] ? false : true;
        emitButtonState[emitState] = this[updateState];
        this[emitState].emit(emitButtonState);
        if (dropDowns !== undefined) {
            for (const dropDown of dropDowns) {
                this.dropdownToggle(dropDown);
            }
        }
    }
    toggleActionButtonWithParent(updateState, emitState, dropDowns, parent) {
        const emitButtonState = {};
        this[updateState] = this[updateState] ? false : true;
        emitButtonState[emitState] = this[updateState];
        this[emitState].emit(emitButtonState);
        if (!parent) {
            if (dropDowns !== undefined) {
                for (const dropDown of dropDowns) {
                    this.dropdownToggle(dropDown);
                }
            }
            return;
        }
        if (parent.showing) {
            parent.hide();
        }
        // And then show the clicked items's dropdown
        if (dropDowns !== undefined) {
            for (const dropDown of dropDowns) {
                console.log(dropDown);
                this.dropdownToggle(dropDown);
            }
        }
    }
    setPageTile() {
        for (const link of this.links) {
            if (link.active) {
                this.pageTitle = link.title;
            }
        }
    }
    /**
     * Actions on link item click.
     * @param url link url of clicked item
     */
    setActive(url) {
        for (const link of this.links) {
            link.active = false;
            const baseUrl = "/" + url.split("/")[1];
            if (baseUrl === link.url) {
                link.active = true;
                this.pageTitle = link.title;
            }
        }
        // In mobile-mode, items are listed in dropdown. Close dropdown on-click
        if (this.mobileNavMenuBtn && this.mobileNavMenuBtn.showing) {
            this.mobileNavMenuBtn.hide();
        }
    }
    dropdownToggle(dropdown) {
        if (dropdown.showing) {
            dropdown.hide();
        }
        else {
            dropdown.show();
        }
    }
    /**
     * Handles the workgroup selection event
     * @param selectedOption The selected option
     */
    workgroupSelected(selectedOption) {
        this.userDataLoadingSubject.next(true);
        this.workGroupSelected.emit(selectedOption);
        // After the selection event is emitted, toggle the drop down
        // Component is subscribed to changes in user/workgroup state.
        this.dropdownToggle(this.accDropdownMenu);
    }
    /**
     * Hanldes sign out click event
     * @param profileLink The profile link
     */
    signOutClick(profileLink) {
        this.dropdownToggle(this.accDropdownMenu);
        this.signOutClicked.emit(profileLink);
    }
    // ────────────────────────────────────────────────────────────────────────────────
    // Notifications
    removeAlert(index) {
        this.notificationDeleted.emit(this.notifications.alertCards[index]);
        this.notifications.alertCards.splice(index, 1);
        this.setAlertNotificationsMessage();
        this.alertNotificationsSubject$.next(this.notifications);
    }
    onHideSearch(event) {
        this.isSearchOpen = false;
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /**
     * Set alert notifications error message.
     */
    setAlertNotificationsMessage() {
        this.alertNotificationsMessage = '';
        if (this.notifications.alertCards.length === 0) {
            this.alertNotificationsMessage = "There are no notifications to display";
        }
    }
    /**
     * Gets the default workgroup data for the skeleton loader.
     */
    getPlaceHolderWorkgroupData() {
        // Controls the number of 'Skeleton loader' lines that appear while the workgroup
        // data loads in the background.
        const numWorkGroups = 2;
        return Array.from(new Array(numWorkGroups), (x, i) => ({ Id: "", DomainName: "", IsCollaborative: false, Name: "" }));
    }
    /**
     * Gets the default application data for the skeleton loader.
     * (Controls the number of lines that appear in the skelton loader)
     */
    getPlaceHolderApplicationData() {
        // Controls the number of 'Skeleton loader' lines that appear while the application
        // data loads in the background.
        const numApplicationsInColumn = 3;
        return [
            {
                title: "",
                data: Array.from(new Array(numApplicationsInColumn), (x, i) => ({ id: "", title: "", url: "", inNew: true }))
            },
            {
                title: "",
                data: Array.from(new Array(numApplicationsInColumn), (x, i) => ({ id: "", title: "", url: "", inNew: true }))
            },
            {
                title: "",
                data: Array.from(new Array(numApplicationsInColumn), (x, i) => ({ id: "", title: "", url: "", inNew: true }))
            }
        ];
    }
    getPlaceHolderAlertNotificationData() {
        // Controls the number of 'Skeleton loader' lines that appear while the alert notifications
        // data loads in the background.
        const numAlerts = 5;
        return {
            title: "",
            alertCards: Array.from(new Array(numAlerts), (x, i) => ({ id: "", type: "", title: "", dismissible: false }))
        };
    }
    setProfileLinkMenuHeight() {
        if (this.profileLinks && this.profileLinks.length > 4) {
            // this will work for 5 items, basically
            this.userMenuConfig.height = '440px';
            this.userMenuConfig.maxHeight = '440px';
            // consider adjusting the calc'd height from 50% to 62% if needed
        }
    }
}
/** @nocollapse */ UniversalNavbarComponent.ngComponentDef = ɵɵdefineComponent({ type: UniversalNavbarComponent, selectors: [["lib-universal-navbar"]], factory: function UniversalNavbarComponent_Factory(t) { return new (t || UniversalNavbarComponent)(ɵɵdirectiveInject(WindowRef), ɵɵdirectiveInject(ElementRef)); }, viewQuery: function UniversalNavbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(DropdownComponent, true);
        ɵɵstaticViewQuery(DropdownComponent, true);
        ɵɵviewQuery(_c0$f, true);
        ɵɵviewQuery(_c1$f, true);
        ɵɵstaticViewQuery(_c2$d, true);
        ɵɵstaticViewQuery(_c3$d, true);
        ɵɵstaticViewQuery(_c4$c, true);
        ɵɵstaticViewQuery(_c5$c, true);
        ɵɵstaticViewQuery(_c6$b, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dropdown = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dropDownMenu = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.accDropdownMenu = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.mobileNavMenuBtn = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.utilityMenuBtn = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.notificationsDropdownMenu = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.utilityNotificationsDropdownMenu = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.applicationsLoadSpinner = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.searchWidget = _t.first);
    } }, inputs: { logoUrl: "logoUrl", title: "title", titleLink: "titleLink", logoLinkNewWindow: "logoLinkNewWindow", titleLinkNewWindow: "titleLinkNewWindow", firstColumnData: "firstColumnData", secondColumnData: "secondColumnData", thirdColumnData: "thirdColumnData", applicationLinkBottom: "applicationLinkBottom", profileLinks: "profileLinks", showNotifications: "showNotifications", trashBadge: "trashBadge", transparent: "transparent", links: "links", actions: "actions", userService: "userService", userWorkgroupService: "userWorkgroupService", userApplicationsService: "userApplicationsService", userAlertNotificationService: "userAlertNotificationService", searchWidgetConfig: "searchWidgetConfig" }, outputs: { workGroupOpen: "workGroupOpen", mobileNavMenuOpen: "mobileNavMenuOpen", utilityMenuOpen: "utilityMenuOpen", searchOpen: "searchOpen", applicationsOpen: "applicationsOpen", notificationsOpen: "notificationsOpen", helpOpen: "helpOpen", trashOpen: "trashOpen", workGroupSelected: "workGroupSelected", signOutClicked: "signOutClicked", onSelectSearchAction: "onSelectSearchAction", notificationDeleted: "notificationDeleted" }, consts: 82, vars: 71, template: function UniversalNavbarComponent_Template(rf, ctx) { if (rf & 1) {
        const _r501 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "div", _c7$a);
        ɵɵelementStart(1, "lib-search-widget", _c8$a, _c9$a);
        ɵɵlistener("onSelect", function UniversalNavbarComponent_Template_lib_search_widget_onSelect_1_listener($event) { return ctx.onSelectAction($event); });
        ɵɵlistener("onHide", function UniversalNavbarComponent_Template_lib_search_widget_onHide_1_listener($event) { return ctx.onHideSearch($event); });
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", _c10$9);
        ɵɵelementStart(4, "section", _c11$7);
        ɵɵelementStart(5, "a", _c12$7);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_a_click_5_listener($event) { return ctx.openLink(ctx.logoUrl, ctx.logoLinkNewWindow); });
        ɵɵelement(6, "div", _c13$7);
        ɵɵelementEnd();
        ɵɵtemplate(7, UniversalNavbarComponent_a_7_Template, 3, 3, "a", _c14$6);
        ɵɵelementStart(8, "ul", _c15$5);
        ɵɵelementStart(9, "li", _c16$4);
        ɵɵelementStart(10, "div", _c17$4, _c18$4);
        ɵɵelementStart(12, "button", _c19$4);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_button_click_12_listener($event) { ɵɵrestoreView(_r501); const _r415 = ɵɵreference(18); return ctx.toggleActionButton("isWorkGroupOpen", "workGroupOpen", [_r415]); });
        ɵɵtemplate(13, UniversalNavbarComponent_span_13_Template, 2, 1, "span", _c20$4);
        ɵɵpipe(14, "async");
        ɵɵtemplate(15, UniversalNavbarComponent_span_15_Template, 2, 1, "span", _c21$4);
        ɵɵpipe(16, "async");
        ɵɵelementEnd();
        ɵɵelementStart(17, "lib-dropdown", _c22$4, _c23$4);
        ɵɵelementStart(19, "div", _c24$3);
        ɵɵtemplate(20, UniversalNavbarComponent_div_20_Template, 2, 1, "div", _c25$3);
        ɵɵpipe(21, "async");
        ɵɵpipe(22, "async");
        ɵɵtemplate(23, UniversalNavbarComponent_div_23_Template, 2, 2, "div", _c25$3);
        ɵɵpipe(24, "async");
        ɵɵelementStart(25, "overlay-scrollbars", _c26$3);
        ɵɵelementStart(26, "ul");
        ɵɵtemplate(27, UniversalNavbarComponent_li_27_Template, 6, 14, "li", _c27$3);
        ɵɵpipe(28, "async");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(29, UniversalNavbarComponent_div_29_Template, 3, 1, "div", _c28$3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(30, "li", _c29$2);
        ɵɵelementStart(31, "div", _c30$2, _c31$2);
        ɵɵelementStart(33, "button", _c32$2);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_button_click_33_listener($event) { ɵɵrestoreView(_r501); const _r421 = ɵɵreference(35); return ctx.toggleActionButton("isApplicationOpen", "applicationsOpen", [_r421]); });
        ɵɵelementEnd();
        ɵɵelementStart(34, "lib-dropdown", _c33$2, _c34$2);
        ɵɵelementStart(36, "div", _c35$2);
        ɵɵelement(37, "lib-progress", _c36$2, _c37$2);
        ɵɵelementStart(39, "section", _c38$2);
        ɵɵtemplate(40, UniversalNavbarComponent_div_40_Template, 4, 2, "div", _c39$2);
        ɵɵpipe(41, "async");
        ɵɵelementEnd();
        ɵɵtemplate(42, UniversalNavbarComponent_section_42_Template, 3, 4, "section", _c40$2);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(43, "section", _c41$1);
        ɵɵtemplate(44, UniversalNavbarComponent_div_44_Template, 9, 8, "div", _c42$1);
        ɵɵelementStart(45, "div", _c43$1);
        ɵɵelementStart(46, "button", _c44$1);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_button_click_46_listener($event) { return ctx.toggleActionButton("isSearchOpen", "searchOpen"); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(47, "h3", _c45$1);
        ɵɵtext(48);
        ɵɵelementEnd();
        ɵɵtemplate(49, UniversalNavbarComponent_div_49_Template, 2, 1, "div", _c46$1);
        ɵɵelementStart(50, "ul", _c47$1);
        ɵɵtemplate(51, UniversalNavbarComponent_li_51_Template, 13, 10, "li", _c48$1);
        ɵɵelementStart(52, "li", _c49$1);
        ɵɵelementStart(53, "button", _c50$1);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_button_click_53_listener($event) { return ctx.toggleActionButton("isTrashOpen", "trashOpen"); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(54, "li", _c49$1);
        ɵɵelementStart(55, "button", _c51$1);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_button_click_55_listener($event) { return ctx.toggleActionButton("isHelpOpen", "helpOpen"); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(56, "div", _c52$1, _c53$1);
        ɵɵelementStart(58, "button", _c54);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_button_click_58_listener($event) { ɵɵrestoreView(_r501); const _r429 = ɵɵreference(60); return ctx.toggleActionButton("isUtiltiyMenuOpen", "utilityMenuOpen", [_r429]); });
        ɵɵelementEnd();
        ɵɵelementStart(59, "lib-dropdown", _c55, _c56);
        ɵɵelementStart(61, "overlay-scrollbars", _c57);
        ɵɵelementStart(62, "div", _c26$3);
        ɵɵelementStart(63, "ul", _c58);
        ɵɵtemplate(64, UniversalNavbarComponent_li_64_Template, 3, 0, "li", _c59);
        ɵɵelementStart(65, "li");
        ɵɵelementStart(66, "a", _c60);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_a_click_66_listener($event) { ɵɵrestoreView(_r501); const _r429 = ɵɵreference(60); return ctx.toggleActionButton("isHelpOpen", "helpOpen", [_r429]); });
        ɵɵtext(67, "Help");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(68, "li");
        ɵɵelementStart(69, "a", _c61);
        ɵɵlistener("click", function UniversalNavbarComponent_Template_a_click_69_listener($event) { ɵɵrestoreView(_r501); const _r429 = ɵɵreference(60); return ctx.toggleActionButton("isTrashOpen", "trashOpen", [_r429]); });
        ɵɵtext(70, "Trash");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(71, "div", null, _c62);
        ɵɵelementStart(73, "lib-dropdown", _c55, _c63);
        ɵɵelementStart(75, "div", _c64);
        ɵɵelementStart(76, "div", _c65);
        ɵɵtext(77, "Notifications");
        ɵɵelementEnd();
        ɵɵelementStart(78, "overlay-scrollbars", _c66);
        ɵɵtemplate(79, UniversalNavbarComponent_div_79_Template, 3, 3, "div", _c67);
        ɵɵtemplate(80, UniversalNavbarComponent_div_80_Template, 5, 6, "div", _c68);
        ɵɵpipe(81, "async");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r412 = ɵɵreference(11);
        const _r415 = ɵɵreference(18);
        const _r420 = ɵɵreference(32);
        const _r421 = ɵɵreference(35);
        const _r428 = ɵɵreference(57);
        const _r429 = ɵɵreference(60);
        const _r431 = ɵɵreference(72);
        var tmp_46_0 = null;
        const currVal_46 = (tmp_46_0 = ɵɵpipeBind1(81, 61, ctx.alertNotifications$)) == null ? null : tmp_46_0.alertCards;
        ɵɵproperty("ngClass", ɵɵpureFunction1(63, _c133, ctx.transparent));
        ɵɵselect(1);
        ɵɵpropertyInterpolate("closeOnSelect", ctx.searchWidgetConfig.closeOnSelect);
        ɵɵpropertyInterpolate("width", ctx.searchWidgetConfig.width);
        ɵɵpropertyInterpolate("overlayTop", ctx.searchWidgetConfig.overlayTop);
        ɵɵproperty("resultsMapper", ctx.searchWidgetConfig.resultsMapper)("requester", ctx.searchWidgetConfig.requester)("searchAreas", ctx.searchWidgetConfig.searchAreas)("isActive", ctx.isSearchOpen ? "true" : "false");
        ɵɵselect(7);
        ɵɵproperty("ngIf", ctx.title);
        ɵɵselect(9);
        ɵɵproperty("ngClass", ɵɵpureFunction1(65, _c130, _r415.showing));
        ɵɵselect(13);
        ɵɵproperty("ngIf", ɵɵpipeBind1(14, 47, ctx.currentUser$));
        ɵɵselect(15);
        ɵɵproperty("ngIf", ɵɵpipeBind1(16, 49, ctx.currentUser$));
        ɵɵselect(17);
        ɵɵproperty("reference", _r412)("startPosition", "bottom")("config", ctx.userMenuConfig);
        ɵɵselect(20);
        ɵɵproperty("ngIf", ɵɵpipeBind1(21, 51, !ɵɵpipeBind1(22, 53, ctx.userDataLoading$) && ctx.currentUser$));
        ɵɵselect(23);
        ɵɵproperty("ngIf", ɵɵpipeBind1(24, 55, ctx.userDataLoading$));
        ɵɵselect(27);
        ɵɵproperty("ngForOf", ɵɵpipeBind1(28, 57, ctx.workGroups$));
        ɵɵselect(29);
        ɵɵproperty("ngIf", ctx.profileLinks);
        ɵɵselect(30);
        ɵɵproperty("ngClass", ɵɵpureFunction1(67, _c130, _r421.showing));
        ɵɵselect(34);
        ɵɵproperty("reference", _r420)("startPosition", "bottom")("positions", ctx.desktopApplicationsMenuPosition)("config", _c134);
        ɵɵselect(37);
        ɵɵproperty("id", "spinner")("loader", false)("spinner", true)("spinnerPosition", "center");
        ɵɵselect(40);
        ɵɵproperty("ngForOf", ɵɵpipeBind1(41, 59, ctx.applications$));
        ɵɵselect(42);
        ɵɵproperty("ngIf", ctx.applicationLinkBottom);
        ɵɵselect(44);
        ɵɵproperty("ngIf", ctx.links);
        ɵɵselect(48);
        ɵɵtextInterpolate(ctx.pageTitle);
        ɵɵselect(49);
        ɵɵproperty("ngIf", ctx.links);
        ɵɵselect(51);
        ɵɵproperty("ngIf", ctx.showNotifications);
        ɵɵselect(53);
        ɵɵproperty("badge", ctx.trashBadge);
        ɵɵselect(56);
        ɵɵproperty("ngClass", ɵɵpureFunction1(69, _c135, _r429.showing));
        ɵɵselect(59);
        ɵɵproperty("reference", _r428)("startPosition", "bottom")("positions", ctx.mobileUtilityMenuPosition)("config", _c136);
        ɵɵselect(64);
        ɵɵproperty("ngIf", ctx.showNotifications);
        ɵɵselect(73);
        ɵɵproperty("reference", _r431)("startPosition", "bottom")("positions", ctx.mobileUtilityMenuPosition)("config", _c131);
        ɵɵselect(79);
        ɵɵproperty("ngIf", ctx.alertNotificationsMessage);
        ɵɵselect(80);
        ɵɵproperty("ngForOf", currVal_46);
    } }, directives: [NgClass, SearchWidgetComponent, NgIf, IconButtonComponent, DropdownComponent, OverlayScrollbarsComponent, NgForOf, ProgressComponent, SkeletonComponent, ButtonComponent, RouterLinkWithHref], pipes: [AsyncPipe, TitleCasePipe], styles: [".drop-down-notifications .drop-down-title,.drop-down-notifications-list li,.product-switcher__actions__link,.product-switcher__content__item-link,.product-switcher__content__title,.universal-navbar__page-title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.drop-down-notifications .drop-down-title,.drop-down-notifications-list li,.product-switcher__actions__link,.product-switcher__content__item-link,.product-switcher__content__title,.universal-navbar__page-title{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.drop-down-notifications .drop-down-title,.universal-navbar__page-title{font-weight:500}.product-switcher__content__item{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.universal-navbar{display:block;-ms-grid-columns:([col-start] 1fr)[14];grid-template-columns:repeat(14,[col-start] 1fr);grid-gap:30px;background-image:radial-gradient(139% 130.62% at -2.04% 2.39%,#6284f8 0,#5276eb 23%,#5276eb 57%,#d2a1c5 100%);background-size:100% 385px;background-position:61% -170px;height:96px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;z-index:1}.universal-navbar--transparent{background:0 0}@media (max-width:833px){.universal-navbar{display:block}}.universal-navbar lib-search-widget{position:absolute;top:53px;left:0;grid-column:col-start/span 14;width:100%}.universal-navbar::before{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/images/line-shadow@2x.png) center 48px/contain no-repeat;content:\"\";position:absolute;left:0;pointer-events:none;right:0;height:100%;z-index:11}.universal-navbar__container{color:#fff;padding:0 24px;position:relative;z-index:10}.universal-navbar__logo{width:86px;height:25px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/images/illumina-logo-white.svg);background-repeat:no-repeat;background-position:0 0}.universal-navbar__top{display:-webkit-box;display:flex;width:100%;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;position:relative;height:48px}.universal-navbar__top__product-name{color:#fff;-webkit-box-flex:1;flex-grow:1;font-size:18px;font-weight:400;line-height:1.3;position:relative;text-align:center;text-decoration:none;top:0;-webkit-transition:opacity 150ms ease-in-out;transition:opacity 150ms ease-in-out;opacity:.9}.universal-navbar__top__product-name:hover{color:inherit;text-decoration:none;opacity:1}.universal-navbar__logo-link{left:2px;position:absolute;top:16px;z-index:1}.universal-navbar__bottom{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:48px;-webkit-box-pack:justify;justify-content:space-between;position:relative;width:100%}.universal-navbar__bottom__search{-webkit-box-align:center;align-items:center;border-radius:20px;background:0 0;display:-webkit-box;display:flex;height:40px;left:-9px;position:absolute;top:9px;-webkit-transition:.2s ease-in-out;transition:.2s ease-in-out;width:40px}.universal-navbar__bottom__search:hover{background:rgba(255,255,255,.2)}.universal-navbar__inline-list{list-style-type:none;margin:0;padding:0;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}@media (max-width:833px){.universal-navbar__top__product-name{opacity:0!important;pointer-events:none}.universal-navbar__inline-list--utility-links{opacity:0;pointer-events:none;z-index:-1}}.universal-navbar__top .universal-navbar__inline-list{right:-8px;top:10px;position:absolute}.universal-navbar__bottom .universal-navbar__inline-list{right:-7px;top:8px;position:absolute}.universal-navbar__list-item{-webkit-box-align:center;align-items:center;border-radius:20px;background:0 0;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;margin:0 0 0 6px;min-width:40px}.universal-navbar__list-item--icon{width:40px}.universal-navbar__list-item:not(:last-child){margin-right:6px}.universal-navbar__list-item:hover{background:rgba(255,255,255,.2)}.universal-navbar__list-item--active{background:rgba(255,255,255,.2);border-radius:20px}.universal-navbar__list-item--workgroup{position:relative;top:-1px}@media (max-width:1279px){.universal-navbar__bottom__search{left:42px}.universal-navbar__list-item--workgroup .universal-navbar__list-item__dropdown{width:40px;height:40px;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;padding:0}}@media (min-width:1280px){.universal-navbar__list-item--applications{margin-left:3px}}.universal-navbar__list-item .universal-navbar__icon--workgroup{color:#fff;font-size:1.6rem;letter-spacing:.04rem;line-height:1.5;padding:0 29px 0 6px;background-position:right;background-size:24px;outline:0}.universal-navbar__list-item__dropdown{padding:0 9px 0 15px}.universal-navbar__mobile-menu{-webkit-box-align:center;align-items:center;border-radius:50%;background:0 0;display:-webkit-box;display:flex;height:40px;left:-9px;opacity:0;pointer-events:none;position:absolute;top:9px;-webkit-transition:opacity 150ms ease-in-out;transition:opacity 150ms ease-in-out;width:40px}.universal-navbar__mobile-menu--active,.universal-navbar__mobile-menu:hover{background:rgba(255,255,255,.2)}@media (max-width:1279px){.universal-navbar__list-item__dropdown{padding:0}.universal-navbar__mobile-menu{opacity:1;pointer-events:all;-webkit-transition:opacity 150ms ease-in-out .1s;transition:opacity 150ms ease-in-out .1s}}.universal-navbar__mobile-menu-btn{background-size:20px!important}.universal-navbar__mobile-menu--drop-down{position:relative;top:10px}.universal-navbar__mobile-menu__link{display:block;padding:10px 20px;height:40px;line-height:2rem;color:#322d32;background-color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.universal-navbar__mobile-menu__link.active,.universal-navbar__mobile-menu__link.selected,.universal-navbar__mobile-menu__link:hover{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;outline:0;background-color:#fff;font-weight:400}.universal-navbar__mobile-menu__link.disabled{color:#93a1aa;cursor:auto}.universal-navbar__mobile-menu__link.disabled:focus,.universal-navbar__mobile-menu__link.disabled:hover{outline:0;background-color:#fff}@media screen and (-ms-high-contrast:active){.universal-navbar__mobile-menu__link.disabled:focus,.universal-navbar__mobile-menu__link.disabled:hover{background-color:#fff}}.universal-navbar__mobile-menu .notifications-dropdown .notifications-dropdown-button{display:inline-block;margin-left:62px}.universal-navbar__icon{-webkit-box-align:center;align-items:center;background:0 0;border:0;cursor:pointer;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;margin:0;min-width:40px;outline:0;padding:0;text-align:center;width:40px}.universal-navbar__icon--application{-webkit-transform:scale(.8);transform:scale(.8)}.universal-navbar__icon--workgroup{width:inherit}@media (max-width:1279px){.universal-navbar__icon--workgroup{background-position:center!important;height:40px;padding:0!important;width:40px}}.universal-navbar__icon--workgroup-name{line-height:1.4;padding-right:7px;display:inline-block;max-width:15rem;white-space:nowrap;text-overflow:ellipsis;text-shadow:0 0 3px rgba(0,0,0,.36);overflow:hidden}@media (max-width:1279px){.universal-navbar__icon--workgroup-name{display:none}}.universal-navbar__page-title{display:none;color:#fff;-webkit-box-flex:1;flex-grow:1;-webkit-box-pack:center;justify-content:center}.universal-navbar__navigation{display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;-webkit-box-pack:center;justify-content:center;padding-top:7px}.universal-navbar__navigation__link{color:#fff;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;font-size:16px;-webkit-box-pack:center;justify-content:center;letter-spacing:normal;line-height:1.4;padding:19px 18px;position:relative;text-align:center;text-decoration:none;text-shadow:0 0 3px rgba(0,0,0,.36);z-index:10}.universal-navbar__navigation__link::before{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/images/universal-navbar-hover@2x.png) center top/contain no-repeat;content:\"\";height:26rem;left:50%;opacity:0;pointer-events:none;position:absolute;top:2px;-webkit-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:.2s ease-in-out;transition:.2s ease-in-out;width:11.8rem;z-index:1}.universal-navbar__navigation__link::after{display:block;font-weight:700;content:attr(title);height:0;overflow:hidden;visibility:hidden}.universal-navbar__navigation__link:hover{font-weight:700;opacity:1;text-decoration:none;color:inherit}.universal-navbar__navigation__link:hover::before{opacity:1}.universal-navbar__navigation__link--selected{font-weight:600;opacity:1}.universal-navbar__navigation__link--disabled{color:currentColor;pointer-events:none;cursor:not-allowed;opacity:.5;text-decoration:none}@media (max-width:1279px){.universal-navbar__navigation{display:none}.universal-navbar__page-title{display:-webkit-box;display:flex}}.universal-navbar__mobile-utility-menu{border-radius:50%;opacity:0;pointer-events:none;-webkit-transition:opacity 150ms ease-in-out;transition:opacity 150ms ease-in-out}.universal-navbar__mobile-utility-menu--active,.universal-navbar__mobile-utility-menu:hover{background:rgba(255,255,255,.2)}.universal-navbar__mobile-utility-menu--drop-down{top:11px}.drop-down-wrapper-persist{margin-top:-10px}.drop-down-wrapper{text-align:center;height:32px;background-color:transparent;position:relative;z-index:1001}.drop-down-wrapper button{position:relative;z-index:1001}.drop-down-content ul{list-style:none;text-align:left}.drop-down__workgroup-item{font-size:1.4rem;letter-spacing:.04rem;line-height:1.4285714286}.drop-down__workgroup-item__clamp{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;word-break:break-all}.drop-down.relative{position:relative;height:100%;width:100%}.drop-down.relative .drop-down-user-name{text-align:center;padding-top:10px}.drop-down.relative .drop-down-content{margin-top:18px;height:calc(50% - 55px);font-size:1.3rem}.drop-down.relative .drop-down-menu{width:100%;position:absolute;bottom:0;background:#fff}.drop-down.relative .drop-down-menu ul{padding-top:2px;padding-left:0;margin:2px 10px 0;list-style:none;text-align:left;border-top-style:solid;border-top-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#d1cfd1,#d1cfd1)}.drop-down.relative .drop-down-menu ul li:last-child{margin:10px 0;text-align:center}@media (min-width:834px){.product-switcher{min-width:60rem}}@media (max-width:833px){.universal-navbar__mobile-utility-menu{opacity:1;pointer-events:all}.product-switcher__overlay{right:0!important;width:100%!important}}.product-switcher__content{border-bottom:1px solid #d8d8d8;display:-ms-grid;display:grid;grid-gap:3rem;-ms-grid-columns:([col-start] 1fr)[3];grid-template-columns:repeat(3,[col-start] 1fr);overflow:hidden;overflow-y:auto;padding:2.1rem 3rem 1.5rem}.product-switcher__content__column{max-width:21rem}@media (max-width:834px){.universal-navbar__user-menu-pane{margin-right:32px}.product-switcher__content{display:block;max-height:60vh}.product-switcher__content__column{margin-bottom:30px}}.product-switcher__content__title{margin-bottom:10px}.product-switcher__content__item{padding:8px 0}.product-switcher__content__item-link{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.product-switcher__actions{padding:18px 30px;text-align:right}@media (max-width:834px){.product-switcher__actions{text-align:left}}.product-switcher__actions__link{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.drop-down-account{position:relative;height:100%;width:100%}.drop-down-account .drop-down-title{font-weight:700;white-space:nowrap;max-width:23rem;overflow:hidden;padding:10px 37px;text-overflow:ellipsis}.drop-down-account .drop-down-no-title{overflow:hidden;padding:10px 0 0 35px}.drop-down-account .drop-down-content{margin-top:0;height:calc(49% - 39px)}.drop-down-account .drop-down-content ul{padding-left:24px;list-style:none;text-align:left}.drop-down-account .drop-down-content ul li{padding-top:8px;padding-bottom:8px;position:relative;text-overflow:ellipsis;overflow:hidden;max-width:80%;cursor:pointer}.drop-down-account .drop-down-content ul li.active-option{font-weight:700}.drop-down-account .drop-down-content ul li.active-option:before{color:#656066;font-weight:400;content:\"L\";-webkit-transform:scaleX(-1) rotate(-39deg);transform:scaleX(-1) rotate(-39deg);position:absolute;left:-20px;display:inline-block;top:7px}.drop-down-account .drop-down-content ul li.no-content{padding-bottom:1px!important}.drop-down-account .drop-down-menu{width:100%;position:absolute;bottom:0;background:#fff;height:calc(44% - 1px)}.drop-down-account .drop-down-menu ul{padding-left:0;list-style:none;text-align:left;border-top-style:solid;border-top-width:1px;border-image-slice:1 0 0 0;border-image-source:linear-gradient(83deg,#d1cfd1,#d1cfd1)}.drop-down-account .drop-down-menu ul li:first-child{margin-top:5px}.drop-down-account .drop-down-menu ul li:last-child{margin-top:8px;margin-bottom:22px;padding-left:0;text-align:center}.drop-down-account .drop-down-menu ul li:last-child a,.drop-down-account .drop-down-menu ul li:last-child button{padding-left:42px;padding-right:42px}.drop-down-account .drop-down-menu ul li a:focus,.drop-down-account .drop-down-menu ul li a:hover,.drop-down-account .drop-down-menu ul li button:focus,.drop-down-account .drop-down-menu ul li button:hover{outline:0;box-shadow:none}.drop-down-notifications{margin-top:5px;top:6px;position:relative}.drop-down-notifications .drop-down-title{border-bottom:1px solid #d1cfd1;padding:15px 30px 13px}.drop-down-notifications .drop-down-content{margin-top:4px}.drop-down-notifications-list{max-height:335px;margin-left:-40px}.drop-down-notifications-list li{border-bottom:1px solid #d1cfd1;display:-webkit-box;display:flex;max-width:91%;padding:16px 0 23px 30px;position:relative;overflow:hidden}.drop-down-notifications-list li:last-of-type{border-bottom:0}.drop-down-notifications-list-close{background:0 0;border:0;outline:0}.drop-down-notifications-list-close:focus{outline:0}.drop-down-notifications-list-close svg{width:20px;height:20px}.applications-menu{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;flex-direction:row-reverse;margin-top:43px}@media (max-width:833px){.applications-menu{width:100%!important}}.three-column{min-width:600px}.three-column .three-column__actions{border-top-style:solid;border-top-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#d1cfd1,#d1cfd1)}.notifications-dropdown{width:38.6rem!important;text-align:center}", ".notifications-menu__card__link{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent;white-space:break-all}.notifications-menu__card__date,.notifications-menu__card__description,.notifications-menu__card__title,.notifications-menu__content__item,.notifications-menu__title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.notifications-menu__card__description,.notifications-menu__card__title,.notifications-menu__content__item,.notifications-menu__title{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.notifications-menu__card__date{font-size:12px;letter-spacing:.34px;line-height:1.1666666667}.notifications-menu__card__title,.notifications-menu__title{font-weight:500}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.notifications-menu{margin-top:.5rem;top:.6rem;position:relative}.notifications-menu__mobile-top{top:3.2rem}.notifications-menu__title{border-bottom:1px solid #d1cfd1;padding:1.5rem 3rem 1.3rem;text-align:left}.notifications-menu__content{max-height:33.5rem}.notifications-menu__content__item{border-bottom:1px solid #d1cfd1;display:-webkit-box;display:flex;max-width:91%;min-height:9.5rem;padding:1.8rem 0 2rem 3rem;position:relative;overflow:hidden}.notifications-menu__content__item:first-of-type{padding-top:1.6rem}.notifications-menu__content__item:last-of-type{border-bottom:0}.notifications-menu__card{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;width:100%}.notifications-menu__card__content{text-align:left;max-width:90%}.notifications-menu__card__loader{margin-bottom:-.6rem;margin-top:1.2rem;width:100%}.notifications-menu__card__loader-title{display:block;width:40%}.notifications-menu__card__loader-description{display:block;width:80%}.notifications-menu__card__title{letter-spacing:-.2px;margin-bottom:.2rem}.notifications-menu__card__date{font-weight:300;color:#656066;letter-spacing:-.2px;margin-bottom:.2rem}.notifications-menu__card__description{letter-spacing:-.1px}.notifications-menu__card__actions{position:relative;right:-.9rem}.notifications-menu__card__actions-close-btn{background:0 0;border:0;outline:0}.notifications-menu__card__actions-close-btn:focus{outline:0}.notifications-menu__card__actions-close-icon{width:2rem;height:2rem}"], encapsulation: 2, data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] } });
/*@__PURE__*/ ɵsetClassMetadata(UniversalNavbarComponent, [{
        type: Component,
        args: [{
                selector: "lib-universal-navbar",
                templateUrl: "./universal-navbar.component.html",
                styleUrls: [
                    "./universal-navbar.component.scss",
                    "./notifications-menu.scss"
                ],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: WindowRef }, { type: ElementRef }]; }, { logoUrl: [{
            type: Input
        }], title: [{
            type: Input
        }], titleLink: [{
            type: Input
        }], logoLinkNewWindow: [{
            type: Input
        }], titleLinkNewWindow: [{
            type: Input
        }], firstColumnData: [{
            type: Input
        }], secondColumnData: [{
            type: Input
        }], thirdColumnData: [{
            type: Input
        }], applicationLinkBottom: [{
            type: Input
        }], profileLinks: [{
            type: Input
        }], showNotifications: [{
            type: Input
        }], trashBadge: [{
            type: Input
        }], transparent: [{
            type: Input
        }], links: [{
            type: Input
        }], actions: [{
            type: Input
        }], userService: [{
            type: Input
        }], userWorkgroupService: [{
            type: Input
        }], userApplicationsService: [{
            type: Input
        }], userAlertNotificationService: [{
            type: Input
        }], workGroupOpen: [{
            type: Output
        }], mobileNavMenuOpen: [{
            type: Output
        }], utilityMenuOpen: [{
            type: Output
        }], searchOpen: [{
            type: Output
        }], applicationsOpen: [{
            type: Output
        }], notificationsOpen: [{
            type: Output
        }], helpOpen: [{
            type: Output
        }], trashOpen: [{
            type: Output
        }], workGroupSelected: [{
            type: Output
        }], signOutClicked: [{
            type: Output
        }], dropdown: [{
            type: ViewChild,
            args: [DropdownComponent, { static: true }]
        }], dropDownMenu: [{
            type: ViewChild,
            args: [DropdownComponent, { static: true }]
        }], accDropdownMenu: [{
            type: ViewChild,
            args: ["accountDropdownMenu", { static: false }]
        }], mobileNavMenuBtn: [{
            type: ViewChild,
            args: ["mobileNavDropdownMenu", { static: false }]
        }], utilityMenuBtn: [{
            type: ViewChild,
            args: ["utilityDropdownMenu", { static: true }]
        }], notificationsDropdownMenu: [{
            type: ViewChild,
            args: ["notificationsDropdownMenu", { static: true }]
        }], utilityNotificationsDropdownMenu: [{
            type: ViewChild,
            args: ["utilityNotificationsDropdownMenu", { static: true }]
        }], applicationsLoadSpinner: [{
            type: ViewChild,
            args: ["applicationsLoadSpinner", { static: true }]
        }], searchWidget: [{
            type: ViewChild,
            args: ["searchWidget", { static: true }]
        }], searchWidgetConfig: [{
            type: Input
        }], onSelectSearchAction: [{
            type: Output
        }], notificationDeleted: [{
            type: Output
        }] });

class DropdownService {
    register(select) {
        this.select = select;
    }
    getSelect() {
        return this.select;
    }
}
/** @nocollapse */ DropdownService.ngInjectableDef = ɵɵdefineInjectable({ token: DropdownService, factory: function DropdownService_Factory(t) { return new (t || DropdownService)(); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(DropdownService, [{
        type: Injectable
    }], null, null);

class OptionComponent {
    constructor(dropdownService, el) {
        this.dropdownService = dropdownService;
        this.el = el;
        this.active = false;
        this.select = this.dropdownService.getSelect();
    }
    get selected() {
        return this.select.selectedOption === this;
    }
    getLabel() {
        return this.label;
    }
    setActiveStyles() {
        this.active = true;
    }
    setInactiveStyles() {
        this.active = false;
    }
    onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.select.selectOption(this);
    }
}
/** @nocollapse */ OptionComponent.ngComponentDef = ɵɵdefineComponent({ type: OptionComponent, selectors: [["lib-option"]], factory: function OptionComponent_Factory(t) { return new (t || OptionComponent)(ɵɵdirectiveInject(DropdownService), ɵɵdirectiveInject(ElementRef)); }, hostBindings: function OptionComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵallocHostVars(2);
        ɵɵlistener("click", function OptionComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
        ɵɵstyling();
    } if (rf & 2) {
        ɵɵclassProp("selected", ctx.selected);
        ɵɵclassProp("active", ctx.active);
        ɵɵstylingApply();
    } }, inputs: { label: "label", value: "value" }, consts: 1, vars: 1, template: function OptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtext(0);
    } if (rf & 2) {
        ɵɵtextInterpolate1("", ctx.label, "\n");
    } }, styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]{box-sizing:border-box;display:block;padding:1rem 2rem;height:4rem;line-height:2rem;color:#322d32;background-color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.active[_nghost-%COMP%], .selected[_nghost-%COMP%], [_nghost-%COMP%]:hover{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;outline:0;background-color:#fff;font-weight:400}.disabled[_nghost-%COMP%]{color:#93a1aa;cursor:auto}.disabled[_nghost-%COMP%]:focus, .disabled[_nghost-%COMP%]:hover{outline:0;background-color:#fff}@media screen and (-ms-high-contrast:active){.disabled[_nghost-%COMP%]:focus, .disabled[_nghost-%COMP%]:hover{background-color:#fff}}.grayOption[_nghost-%COMP%]:focus, .grayOption[_nghost-%COMP%]:hover{color:#322d32;-webkit-text-fill-color:#322d32;font-weight:700}.grayOption.selected[_nghost-%COMP%]{color:#322d32;-webkit-text-fill-color:#322d32;font-weight:700}"] });
/*@__PURE__*/ ɵsetClassMetadata(OptionComponent, [{
        type: Component,
        args: [{
                selector: 'lib-option',
                templateUrl: "./option.component.html",
                styleUrls: ['./option.component.scss'],
            }]
    }], function () { return [{ type: DropdownService }, { type: ElementRef }]; }, { label: [{
            type: Input
        }], value: [{
            type: Input
        }], selected: [{
            type: HostBinding,
            args: ['class.selected']
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] });

const _c0$g = ["input"];
const _c1$g = [1, "input-wrapper", "select"];
const _c2$e = [1, "input", "select__content", 3, "ngClass"];
const _c3$e = ["dropreference", ""];
const _c4$d = [1, "select__label-text"];
const _c5$d = ["autocomplete", "off", 1, "select__input-text", 3, "placeholder", "disabled", "readonly", "ngModel", "ngClass", "click", "keydown", "blur", "ngModelChange"];
const _c6$c = ["input", ""];
const _c7$b = ["class", "select__dropdown-arrow", 3, "ngClass", "click", 4, "ngIf"];
const _c8$b = [3, "reference", "startPosition", "positions", "config"];
const _c9$b = ["dropdownComp", ""];
const _c10$a = [1, "select__dropdown-options-container", "drop-down", 3, "ngClass"];
const _c11$8 = [1, "select__dropdown-arrow", 3, "ngClass", "click"];
const _c12$8 = function (a0, a1) { return { down: a0, up: a1 }; };
function SelectComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r507 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", _c11$8);
    ɵɵlistener("click", function SelectComponent_span_7_Template_span_click_0_listener($event) { ɵɵrestoreView(_r507); const ctx_r506 = ɵɵnextContext(); return ctx_r506.onDropMenuIconClick($event); });
    ɵɵelement(1, "i");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r504 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction2(1, _c12$8, !(ctx_r504.dropdown && ctx_r504.dropdown.showing), ctx_r504.dropdown && ctx_r504.dropdown.showing));
} }
const _c13$8 = function (a0) { return { "autocomplete-mode": a0 }; };
const _c14$7 = { originX: "center", originY: "bottom", overlayX: "center", overlayY: "top" };
const _c15$6 = [_c14$7];
const _c16$5 = { maxHeight: "24rem", height: "auto" };
const _c17$5 = function (a0) { return { "chooser-appearance-options": a0 }; };
const _c18$5 = ["*"];
const CLASS_MAP = {
    select: ""
};
class SelectComponent {
    constructor(dropdownService, elementRef, _cdr) {
        this.dropdownService = dropdownService;
        this.elementRef = elementRef;
        this._cdr = _cdr;
        // tslint:disable-next-line: no-output-on-prefix
        this.onBlur = new EventEmitter();
        this.change = new EventEmitter();
        this.autocompleteMode = false;
        this.required = false;
        this.disabled = false;
        this.contentClass = "";
        this.defaultHighlightFirst = true;
        this.defaultContentClass = "input select__content";
        this.currentActiveIndex = -1;
        this.onChangeFn = (_) => { };
        this.onTouchedFn = () => { };
        this.dropdownService.register(this);
        this.inputRef = elementRef;
        const type = this.inputRef.nativeElement.type;
        this.inputRef.nativeElement.classList.add(CLASS_MAP[type]);
    }
    get displayText() {
        return this._displayText;
    }
    set displayText(v) {
        if (v !== this._displayText) {
            this._displayText = v;
            this.onChangeFn(v);
        }
    }
    ngOnInit() {
        this.contentClass =
            this.contentClass === ""
                ? this.defaultContentClass
                : `${this.defaultContentClass} ${this.contentClass}`;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.selectedOption = this.options
                .toArray()
                .find(option => option.value === this.selected);
            this.displayText = this.selectedOption ? this.selectedOption.label : "";
            // Display text change is not getting reflected because of 
            // ChangeDetection is set to OnPush in one of the ancestor component.
            // So detecting changes manually.
            this._cdr.detectChanges();
        });
    }
    showDropdown() {
        this.input.nativeElement.focus();
        this.dropdown.show();
        if (!this.options.length) {
            return;
        }
        if (this.currentActiveItem) {
            this.currentActiveItem.setInactiveStyles();
        }
        this.currentActiveItem = null;
        let index = this.defaultHighlightFirst ? 0 : -1;
        if (this.selectedOption) {
            index = this.getNavigableOptions().indexOf(this.selectedOption);
        }
        if (this.defaultHighlightFirst || index > -1) {
            this.setActive(index);
        }
        this.currentActiveIndex = index;
        this.scrollToOption();
    }
    hideDropdown() {
        this.dropdown.hide();
    }
    onDropMenuIconClick(event) {
        event.stopPropagation();
        setTimeout(() => {
            this.showDropdown();
        }, 10);
    }
    onKeyDown(event) {
        if ([
            " ",
            "Enter",
            "ArrowDown",
            "Down",
            "ArrowUp",
            "Up",
            "ArrowRight",
            "Right",
            "ArrowLeft",
            "Left"
        ].includes(event.key)) {
            if (!this.dropdown.showing) {
                this.showDropdown();
                return;
            }
            if (!this.options.length) {
                event.preventDefault();
                return;
            }
        }
        if (event.key === "Escape" || event.key === "Esc") {
            this.dropdown.showing && this.hideDropdown();
        }
        else if (event.key === "ArrowDown" ||
            event.key === "Down" ||
            event.key === "ArrowRight" ||
            event.key === "Right") {
            this.moveNext();
            event.preventDefault();
        }
        else if (event.key === "ArrowUp" ||
            event.key === "Up" ||
            event.key === "ArrowLeft" ||
            event.key === "Left") {
            this.movePrevious();
            event.preventDefault();
        }
        else if (event.key === "PageUp" ||
            event.key === "PageDown" ||
            event.key === "Tab") {
            this.dropdown.showing && event.preventDefault();
        }
        else if (event.key === "Enter" || event.key === " ") {
            this.selectOption(this.getCurrentActiveItem());
            event.preventDefault();
        }
    }
    selectOption(option, triggerOnChange = true) {
        this.selected = option.value;
        this.selectedOption = option;
        this.displayText = this.selectedOption ? this.selectedOption.label : "";
        this.hideDropdown();
        if (triggerOnChange) {
            this.onChange();
        }
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        if (value) {
            this.selected = value;
        }
    }
    onTouched($event) {
        this.onTouchedFn();
        this.onBlur.emit($event);
    }
    onChange() {
        this.onChangeFn(this.autocompleteMode ? this.displayText : this.selected);
        this.change.emit({ option: this.selectedOption });
    }
    moveNext() {
        const options = this.getNavigableOptions();
        this.setInActive(this.currentActiveIndex);
        this.currentActiveIndex++;
        if (this.currentActiveIndex >= options.length) {
            this.currentActiveIndex = 0;
        }
        this.setActive(this.currentActiveIndex);
        this.scrollToOption();
    }
    movePrevious() {
        const options = this.getNavigableOptions();
        this.setInActive(this.currentActiveIndex);
        this.currentActiveIndex--;
        if (this.currentActiveIndex < 0) {
            this.currentActiveIndex = options.length - 1;
        }
        this.setActive(this.currentActiveIndex);
        this.scrollToOption();
    }
    scrollToOption() {
        const target = this.getNavigableOptions()[this.currentActiveIndex || 0].el.nativeElement;
        target.scrollIntoView({ behavior: "auto", block: "nearest", inline: "nearest" });
    }
    setInActive(index) {
        if (index === -1) {
            return;
        }
        this.getNavigableOptions()[index].setInactiveStyles();
    }
    setActive(index) {
        const option = this.getNavigableOptions()[index];
        this.currentActiveItem = option;
        option.setActiveStyles();
    }
    getCurrentActiveItem() {
        const options = this.getNavigableOptions();
        return options[this.currentActiveIndex];
    }
    getNavigableOptions() {
        return this.options.toArray();
    }
}
/** @nocollapse */ SelectComponent.ngComponentDef = ɵɵdefineComponent({ type: SelectComponent, selectors: [["lib-select"], ["lib-autocomplete"]], factory: function SelectComponent_Factory(t) { return new (t || SelectComponent)(ɵɵdirectiveInject(DropdownService), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(ChangeDetectorRef)); }, contentQueries: function SelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, OptionComponent, false);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadContentQuery())) && (ctx.options = _t);
    } }, viewQuery: function SelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$g, true);
        ɵɵstaticViewQuery(DropdownComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.input = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dropdown = _t.first);
    } }, inputs: { autocompleteMode: "autocompleteMode", selectLabel: "selectLabel", label: "label", placeholder: "placeholder", selected: "selected", required: "required", disabled: "disabled", contentClass: "contentClass", defaultHighlightFirst: "defaultHighlightFirst" }, outputs: { onBlur: "onBlur", change: "change" }, features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SelectComponent),
                multi: true
            },
            DropdownService
        ])], ngContentSelectors: _c18$5, consts: 12, vars: 18, template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", _c1$g);
        ɵɵelementStart(1, "div", _c2$e, _c3$e);
        ɵɵstyling();
        ɵɵelementStart(3, "label", _c4$d);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "input", _c5$d, _c6$c);
        ɵɵlistener("click", function SelectComponent_Template_input_click_5_listener($event) { return ctx.showDropdown(); });
        ɵɵlistener("keydown", function SelectComponent_Template_input_keydown_5_listener($event) { return ctx.onKeyDown($event); });
        ɵɵlistener("blur", function SelectComponent_Template_input_blur_5_listener($event) { return ctx.onTouched($event); });
        ɵɵlistener("ngModelChange", function SelectComponent_Template_input_ngModelChange_5_listener($event) { return ctx.selectLabel || (ctx.displayText = $event); });
        ɵɵelementEnd();
        ɵɵtemplate(7, SelectComponent_span_7_Template, 2, 4, "span", _c7$b);
        ɵɵelementStart(8, "lib-dropdown", _c8$b, _c9$b);
        ɵɵelementStart(10, "overlay-scrollbars", _c10$a);
        ɵɵprojection(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r502 = ɵɵreference(2);
        ɵɵselect(1);
        ɵɵclassProp("required", ctx.required);
        ɵɵstylingApply();
        ɵɵproperty("ngClass", ctx.contentClass);
        ɵɵselect(4);
        ɵɵtextInterpolate(ctx.label);
        ɵɵselect(5);
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵɵproperty("disabled", ctx.disabled)("readonly", !ctx.autocompleteMode)("ngModel", ctx.selectLabel || ctx.displayText)("ngClass", ɵɵpureFunction1(14, _c13$8, ctx.autocompleteMode));
        ɵɵselect(7);
        ɵɵproperty("ngIf", !ctx.autocompleteMode);
        ɵɵselect(8);
        ɵɵproperty("reference", _r502)("startPosition", "bottom")("positions", _c15$6)("config", _c16$5);
        ɵɵselect(10);
        ɵɵproperty("ngClass", ɵɵpureFunction1(16, _c17$5, ctx.contentClass));
    } }, directives: [NgClass, DefaultValueAccessor, NgControlStatus, NgModel, NgIf, DropdownComponent, OverlayScrollbarsComponent], styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.select__content{cursor:pointer;position:relative;margin:0;outline:0;background:0 0;border:1px solid #949595;border-radius:4px;box-sizing:border-box;text-align:left;width:100%}.select__content.no-border{border:0}.select__content.no-border .select__input-text{background-color:transparent;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.select__content.pagesize-controller{width:auto}.select__content.pagesize-controller label{margin-bottom:0}.select__content.pagesize-controller .select__input-text{display:inline-block;max-width:80px;text-align:right;font-size:16px;font-weight:700;-webkit-text-fill-color:#322d32}.select__content.pagesize-controller .select__dropdown-arrow{top:8px}.select__content:hover,.select__content:hover .down i,.select__content:hover .up i{border-color:#4e60ee}.select__input-text{background:#fff;border-radius:4px;box-sizing:border-box;width:100%;font-size:16px;letter-spacing:0;line-height:1.38;border:none;text-overflow:ellipsis;white-space:normal;overflow:hidden;color:#464247;padding:4px 38px 4px 9px;outline:0;cursor:pointer}.select__input-text::-webkit-input-placeholder{color:#787679}.select__input-text::-moz-placeholder{color:#787679}.select__input-text:-ms-input-placeholder{color:#787679}.select__input-text::-ms-input-placeholder{color:#787679}.select__input-text::placeholder{color:#787679}.select__input-text:hover{color:#4e60ee}.select__input-text:disabled{cursor:default;color:#93a1aa}.select__input-text:disabled+.select__input-text__dropdown-arrow{color:#93a1aa}.select__input-text.autocomplete-mode{padding-right:14px}.select__dropdown-arrow{-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;display:-webkit-box;display:flex;position:absolute;color:inherit;right:4px;bottom:0;cursor:pointer;top:2px;height:20px;width:20px}.select__dropdown-arrow i{border-style:solid;border-color:#5b575b;border-width:0 1px 1px 0;display:inline-block;padding:3.5px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.select__content.required label:after{color:red;content:\"*\";left:5px;bottom:5px;position:absolute;content:\"\";top:0;right:0;width:25px;height:25px;border:6px solid transparent;z-index:9999}.select__dropdown-options-container{min-width:140px}.cdk-overlay-container{z-index:2048!important}.chooser-appearance{border:0}.chooser-appearance .select__input-text{background-color:transparent;margin-top:1px;font-weight:700;max-width:80px}.chooser-appearance-options{height:-webkit-max-content;height:-moz-max-content;height:max-content;max-height:240px}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{
                selector: "lib-select, lib-autocomplete",
                templateUrl: "./select.component.html",
                styleUrls: ["./select.component.scss"],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SelectComponent),
                        multi: true
                    },
                    DropdownService
                ],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: DropdownService }, { type: ElementRef }, { type: ChangeDetectorRef }]; }, { onBlur: [{
            type: Output
        }], change: [{
            type: Output
        }], autocompleteMode: [{
            type: Input
        }], selectLabel: [{
            type: Input
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], selected: [{
            type: Input
        }], required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], contentClass: [{
            type: Input
        }], defaultHighlightFirst: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ["input", { static: true }]
        }], dropdown: [{
            type: ViewChild,
            args: [DropdownComponent, { static: true }]
        }], options: [{
            type: ContentChildren,
            args: [OptionComponent]
        }] });

class AutocompleteFilterPipe {
    transform(items, searchTerm, labelKey) {
        if (!items || !searchTerm) {
            return items;
        }
        return items.filter(item => item[labelKey || "value"].toLowerCase().includes(searchTerm.toLowerCase()));
    }
}
/** @nocollapse */ AutocompleteFilterPipe.ngPipeDef = ɵɵdefinePipe({ name: "autocompleteFilter", type: AutocompleteFilterPipe, factory: function AutocompleteFilterPipe_Factory(t) { return new (t || AutocompleteFilterPipe)(); }, pure: true });
/*@__PURE__*/ ɵsetClassMetadata(AutocompleteFilterPipe, [{
        type: Pipe,
        args: [{
                name: "autocompleteFilter"
            }]
    }], null, null);

class ClickOutsideDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new EventEmitter();
    }
    onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(null);
        }
    }
}
/** @nocollapse */ ClickOutsideDirective.ngDirectiveDef = ɵɵdefineDirective({ type: ClickOutsideDirective, selectors: [["", "lib-click-outside", ""]], factory: function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective)(ɵɵdirectiveInject(ElementRef)); }, hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" }, exportAs: ["clickOutside"] });
/*@__PURE__*/ ɵsetClassMetadata(ClickOutsideDirective, [{
        type: Directive,
        args: [{
                selector: "[lib-click-outside]",
                exportAs: "clickOutside"
            }]
    }], function () { return [{ type: ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ["document:click", ["$event.target"]]
        }] });

class SelectModule {
}
/** @nocollapse */ SelectModule.ngModuleDef = ɵɵdefineNgModule({ type: SelectModule });
/** @nocollapse */ SelectModule.ngInjectorDef = ɵɵdefineInjector({ factory: function SelectModule_Factory(t) { return new (t || SelectModule)(); }, providers: [DropdownService], imports: [[
            FormsModule,
            CommonModule,
            OverlayModule,
            PortalModule,
            OverlayscrollbarsModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(SelectModule, { declarations: [SelectComponent, OptionComponent, DropdownComponent, AutocompleteFilterPipe, ClickOutsideDirective], imports: [FormsModule,
        CommonModule,
        OverlayModule,
        PortalModule,
        OverlayscrollbarsModule], exports: [SelectComponent, OptionComponent, AutocompleteFilterPipe, DropdownComponent, ClickOutsideDirective] });
/*@__PURE__*/ ɵsetClassMetadata(SelectModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    OverlayModule,
                    PortalModule,
                    OverlayscrollbarsModule
                ],
                providers: [DropdownService],
                declarations: [SelectComponent, OptionComponent, DropdownComponent, AutocompleteFilterPipe, ClickOutsideDirective],
                exports: [SelectComponent, OptionComponent, AutocompleteFilterPipe, DropdownComponent, ClickOutsideDirective]
            }]
    }], null, null);

class SearchWidgetModule {
}
/** @nocollapse */ SearchWidgetModule.ngModuleDef = ɵɵdefineNgModule({ type: SearchWidgetModule });
/** @nocollapse */ SearchWidgetModule.ngInjectorDef = ɵɵdefineInjector({ factory: function SearchWidgetModule_Factory(t) { return new (t || SearchWidgetModule)(); }, imports: [[CommonModule, FormsModule, ReactiveFormsModule, ProgressIndicatorsModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(SearchWidgetModule, { declarations: [SearchWidgetComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule, ProgressIndicatorsModule], exports: [SearchWidgetComponent] });
/*@__PURE__*/ ɵsetClassMetadata(SearchWidgetModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, ReactiveFormsModule, ProgressIndicatorsModule],
                declarations: [SearchWidgetComponent],
                exports: [SearchWidgetComponent]
            }]
    }], null, null);

class UniversalNavbarModule {
}
/** @nocollapse */ UniversalNavbarModule.ngModuleDef = ɵɵdefineNgModule({ type: UniversalNavbarModule });
/** @nocollapse */ UniversalNavbarModule.ngInjectorDef = ɵɵdefineInjector({ factory: function UniversalNavbarModule_Factory(t) { return new (t || UniversalNavbarModule)(); }, providers: [WindowRef], imports: [[
            CommonModule,
            RouterModule,
            IconButtonModule,
            SelectModule,
            ButtonModule,
            SearchWidgetModule,
            ProgressIndicatorsModule,
            OverlayscrollbarsModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(UniversalNavbarModule, { declarations: [UniversalNavbarComponent], imports: [CommonModule,
        RouterModule,
        IconButtonModule,
        SelectModule,
        ButtonModule,
        SearchWidgetModule,
        ProgressIndicatorsModule,
        OverlayscrollbarsModule], exports: [UniversalNavbarComponent] });
/*@__PURE__*/ ɵsetClassMetadata(UniversalNavbarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    IconButtonModule,
                    SelectModule,
                    ButtonModule,
                    SearchWidgetModule,
                    ProgressIndicatorsModule,
                    OverlayscrollbarsModule
                ],
                declarations: [UniversalNavbarComponent],
                exports: [UniversalNavbarComponent],
                providers: [WindowRef]
            }]
    }], null, null);

const _c0$h = [1, "msgs"];
const _c1$h = [4, "ngFor", "ngForOf"];
const _c2$f = ["class", "alert_message__box", 4, "ngIf"];
const _c3$f = [1, "alert_message__box"];
const _c4$e = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "alert_message__box-icon"];
const _c5$e = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#656066"];
const _c6$d = [1, "alert_message__box-text", 3, "innerHTML"];
function ErrorAlertMessageComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c3$f);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c4$e);
    ɵɵelement(2, "path", _c5$e);
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelement(3, "span", _c6$d);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r523 = ɵɵnextContext().$implicit;
    ɵɵselect(3);
    ɵɵproperty("innerHTML", msg_r523, ɵɵsanitizeHtml);
} }
function ErrorAlertMessageComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, ErrorAlertMessageComponent_div_2_div_1_Template, 4, 1, "div", _c2$f);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r523 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", msg_r523 && msg_r523.length > 0);
} }
const _c7$c = ["class", "error_message__box", 4, "ngIf"];
const _c8$c = [1, "error_message__box"];
const _c9$c = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "error_message__box-icon"];
const _c10$b = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#BF4252"];
const _c11$9 = [1, "error_message__box-text", 3, "innerHTML"];
function ErrorAlertMessageComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c8$c);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c9$c);
    ɵɵelement(2, "path", _c10$b);
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelement(3, "span", _c11$9);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r526 = ɵɵnextContext().$implicit;
    ɵɵselect(3);
    ɵɵproperty("innerHTML", msg_r526, ɵɵsanitizeHtml);
} }
function ErrorAlertMessageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, ErrorAlertMessageComponent_div_3_div_1_Template, 4, 1, "div", _c7$c);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r526 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", msg_r526 && msg_r526.length > 0);
} }
class ErrorAlertMessageComponent {
    constructor() { }
    set errorMessage(msg) {
        if (typeof msg === "string") {
            this._errorMsg = [msg];
        }
        else {
            this._errorMsg = msg;
        }
    }
    set alertMessage(msg) {
        if (typeof msg === "string") {
            this._alertMsg = [msg];
        }
        else {
            this._alertMsg = msg;
        }
    }
    // tslint:disable-next-line: adjacent-overload-signatures
    get errorMsg() {
        return this._errorMsg;
    }
    // tslint:disable-next-line: adjacent-overload-signatures
    get alertMsg() {
        return this._alertMsg;
    }
}
/** @nocollapse */ ErrorAlertMessageComponent.ngComponentDef = ɵɵdefineComponent({ type: ErrorAlertMessageComponent, selectors: [["lib-error-alert-message"]], factory: function ErrorAlertMessageComponent_Factory(t) { return new (t || ErrorAlertMessageComponent)(); }, inputs: { errorMessage: ["errorMsg", "errorMessage"], alertMessage: ["alertMsg", "alertMessage"] }, consts: 4, vars: 2, template: function ErrorAlertMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$h);
        ɵɵelementStart(1, "div");
        ɵɵtemplate(2, ErrorAlertMessageComponent_div_2_Template, 2, 1, "div", _c1$h);
        ɵɵtemplate(3, ErrorAlertMessageComponent_div_3_Template, 2, 1, "div", _c1$h);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(2);
        ɵɵproperty("ngForOf", ctx.alertMsg);
        ɵɵselect(3);
        ɵɵproperty("ngForOf", ctx.errorMsg);
    } }, directives: [NgForOf, NgIf], styles: [".alert_message__box,.alert_message__box-text a,.error_message__box,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.alert_message__box,.error_message__box{font-size:16px;letter-spacing:.4px;line-height:1.5}.alert_message__box-text a{font-size:14px;letter-spacing:.4px;line-height:1.4285714286;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;text-decoration:none}.alert_message__box,.alert_message__box-text a,.error_message__box{font-weight:500}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.msgs{margin-left:-3rem;background:#f0eff0}.alert_message__box{display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;padding:1.3rem 3rem}.alert_message__box-icon{width:2rem;height:2rem;margin-right:.6rem}.alert_message__box-text{width:90%;overflow-wrap:anywhere}.error_message__box{display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;padding:1.3rem 3rem}.error_message__box-icon{width:2rem;height:2rem;margin-right:.6rem}.error_message__box-text{width:90%;color:#bf4252;overflow-wrap:anywhere}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(ErrorAlertMessageComponent, [{
        type: Component,
        args: [{
                selector: "lib-error-alert-message",
                templateUrl: "./error-alert-message.component.html",
                styleUrls: ["./error-alert-message.component.scss"],
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return []; }, { errorMessage: [{
            type: Input,
            args: ["errorMsg"]
        }], alertMessage: [{
            type: Input,
            args: ["alertMsg"]
        }] });

const _c0$i = ["scrollContainer"];
const _c1$i = [1, "download-data"];
const _c2$g = [1, "download-data__wrapper"];
const _c3$g = [1, "download-data__wrapper--inner"];
const _c4$f = [1, "download-data__container"];
const _c5$f = [1, "download-data__content"];
const _c6$e = [1, "download-data__content--scrollable"];
const _c7$d = [1, "download-data__result"];
const _c8$d = [1, "download-data__result__heading"];
const _c9$d = ["class", "download-data__result__list", 4, "ngIf"];
const _c10$c = ["class", "download-data__content-download", 4, "ngIf"];
const _c11$a = [1, "download-data__content__file-selection"];
const _c12$9 = ["class", "download-data__content__sub-title", 4, "ngIf"];
const _c13$9 = ["class", "download-data__content__file-selection-buttons", 4, "ngIf"];
const _c14$8 = [3, "alertMsg", "errorMsg"];
const _c15$7 = [1, "download-data__result__list"];
const _c16$6 = ["class", "download-data__result__item", 4, "ngFor", "ngForOf"];
const _c17$6 = [1, "download-data__result__item"];
const _c18$6 = ["class", "download-data__result__icon", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 4, "ngIf"];
const _c19$5 = [1, "download-data__result__name", 3, "title"];
const _c20$5 = [1, "download-data__result__value", 3, "ngClass"];
const _c21$5 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "download-data__result__icon"];
const _c22$5 = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#656066"];
function DownloadDataComponent_ul_12_li_1__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c21$5);
    ɵɵelement(1, "path", _c22$5);
    ɵɵelementEnd();
} }
function DownloadDataComponent_ul_12_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", _c17$6);
    ɵɵtemplate(1, DownloadDataComponent_ul_12_li_1__svg_svg_1_Template, 2, 0, "svg", _c18$6);
    ɵɵelementStart(2, "span", _c19$5);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "span", _c20$5);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r513 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", (item_r513 == null ? null : item_r513.status) === "failed");
    ɵɵselect(2);
    ɵɵpropertyInterpolate("title", item_r513.name);
    ɵɵselect(3);
    ɵɵtextInterpolate(item_r513.name);
    ɵɵselect(4);
    ɵɵproperty("ngClass", item_r513.valueClass ? item_r513.valueClass : null);
    ɵɵselect(5);
    ɵɵtextInterpolate(item_r513.value);
} }
function DownloadDataComponent_ul_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ul", _c15$7);
    ɵɵtemplate(1, DownloadDataComponent_ul_12_li_1_Template, 6, 5, "li", _c16$6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r508 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r508.runData);
} }
const _c23$5 = [1, "download-data__content-download"];
const _c24$4 = ["class", "download-data__content-download__message", 4, "ngIf"];
const _c25$4 = ["class", "download-data__link", 3, "href", 4, "ngIf"];
const _c26$4 = [1, "download-data__content-download__message"];
function DownloadDataComponent_div_13_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", _c26$4);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r515 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r515.downloadMessage, " ");
} }
const _c27$4 = [1, "download-data__link", 3, "href"];
function DownloadDataComponent_div_13_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", _c27$4);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r516 = ɵɵnextContext(2);
    ɵɵproperty("href", ctx_r516.downloadLink, ɵɵsanitizeUrl);
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r516.downloadLinkText);
} }
function DownloadDataComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c23$5);
    ɵɵtemplate(1, DownloadDataComponent_div_13_p_1_Template, 2, 1, "p", _c24$4);
    ɵɵtemplate(2, DownloadDataComponent_div_13_a_2_Template, 2, 2, "a", _c25$4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r509 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngIf", (ctx_r509.downloadMessage == null ? null : ctx_r509.downloadMessage.length) > 0);
    ɵɵselect(2);
    ɵɵproperty("ngIf", (ctx_r509.downloadLinkText == null ? null : ctx_r509.downloadLinkText.length) > 0);
} }
const _c28$4 = [1, "download-data__content__sub-title"];
function DownloadDataComponent_h5_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h5", _c28$4);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r510 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r510.fileListHeader, " ");
} }
const _c29$3 = [1, "download-data__content__file-selection-buttons"];
const _c30$3 = ["class", "download-data__content--radio radio", 4, "ngFor", "ngForOf"];
const _c31$3 = [1, "download-data__content--radio", "radio"];
const _c32$3 = ["name", "radio-group", "value", "item.value", 3, "checked", "type", "disabled", "click"];
function DownloadDataComponent_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r520 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c31$3);
    ɵɵelementStart(1, "lib-radio-checkbox", _c32$3);
    ɵɵlistener("click", function DownloadDataComponent_div_16_div_1_Template_lib_radio_checkbox_click_1_listener($event) { ɵɵrestoreView(_r520); const item_r518 = ctx.$implicit; const ctx_r519 = ɵɵnextContext(2); return ctx_r519.onClick(item_r518); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r518 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("checked", item_r518.checked)("type", item_r518.type === "radio" ? "radio" : "checkbox")("disabled", item_r518.disabled);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", item_r518.label, " ");
} }
function DownloadDataComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c29$3);
    ɵɵtemplate(1, DownloadDataComponent_div_16_div_1_Template, 3, 4, "div", _c30$3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r511 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r511.fileListTypes);
} }
class DownloadOutputData {
    get fileTypes() {
        return this._fileTypes;
    }
    set fileTypes(fileTypes) {
        this._fileTypes = fileTypes;
    }
}
class DownloadDataComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.runName = "";
        this.runSize = "";
        this.downloadMessage = "";
        this.downloadLinkText = "";
        this.fileListHeader = "";
        this.fileListTypes = [];
        this.runData = [];
        this.downloadLink = "#";
        this.outputData = new DownloadOutputData();
        this.outputDataChange = new EventEmitter();
        this.outputData.fileTypes = this.fileListTypes;
    }
    ngOnInit() { }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
        if (this.osInstance && this.osInstance.destroy) {
            this.osInstance.destroy();
        }
    }
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
    _hasHostAttributes(...attributes) {
        return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
    }
    onClick(fileListType) {
        if (fileListType.type === 'radio') {
            this.fileListTypes.forEach(fileType => {
                if (fileType.type === 'radio') {
                    fileType.checked = false;
                }
            });
        }
        fileListType.checked = !fileListType.checked;
        this.outputData.fileTypes = this.fileListTypes;
        this.outputDataChange.emit(this.outputData);
    }
}
/** @nocollapse */ DownloadDataComponent.ngComponentDef = ɵɵdefineComponent({ type: DownloadDataComponent, selectors: [["lib-download-data"]], factory: function DownloadDataComponent_Factory(t) { return new (t || DownloadDataComponent)(ɵɵdirectiveInject(ElementRef)); }, viewQuery: function DownloadDataComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$i, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.scrollContainer = _t.first);
    } }, inputs: { runName: "runName", runSize: "runSize", downloadMessage: "downloadMessage", downloadLinkText: "downloadLinkText", fileListHeader: "fileListHeader", fileListTypes: "fileListTypes", runData: "runData", runAlert: "runAlert", runError: "runError", downloadLink: "downloadLink" }, outputs: { outputDataChange: "outputDataChange" }, consts: 18, vars: 8, template: function DownloadDataComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$i);
        ɵɵelementStart(1, "div", _c2$g);
        ɵɵelementStart(2, "div", _c3$g);
        ɵɵelementStart(3, "div", _c4$f);
        ɵɵelementStart(4, "div", _c5$f);
        ɵɵelementStart(5, "overlay-scrollbars", _c6$e);
        ɵɵelementStart(6, "section", _c7$d);
        ɵɵelementStart(7, "h5", _c8$d);
        ɵɵelementStart(8, "span");
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementStart(10, "span");
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(12, DownloadDataComponent_ul_12_Template, 2, 1, "ul", _c9$d);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(13, DownloadDataComponent_div_13_Template, 3, 2, "div", _c10$c);
        ɵɵelementStart(14, "div", _c11$a);
        ɵɵtemplate(15, DownloadDataComponent_h5_15_Template, 2, 1, "h5", _c12$9);
        ɵɵtemplate(16, DownloadDataComponent_div_16_Template, 2, 1, "div", _c13$9);
        ɵɵelementEnd();
        ɵɵelement(17, "lib-error-alert-message", _c14$8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(9);
        ɵɵtextInterpolate(ctx.runName);
        ɵɵselect(11);
        ɵɵtextInterpolate(ctx.runSize);
        ɵɵselect(12);
        ɵɵproperty("ngIf", (ctx.runData == null ? null : ctx.runData.length) > 0);
        ɵɵselect(13);
        ɵɵproperty("ngIf", (ctx.downloadMessage == null ? null : ctx.downloadMessage.length) > 0);
        ɵɵselect(15);
        ɵɵproperty("ngIf", (ctx.fileListHeader == null ? null : ctx.fileListHeader.length) > 0);
        ɵɵselect(16);
        ɵɵproperty("ngIf", (ctx.fileListTypes == null ? null : ctx.fileListTypes.length) > 0);
        ɵɵselect(17);
        ɵɵproperty("alertMsg", ctx.runAlert)("errorMsg", ctx.runError);
    } }, directives: [OverlayScrollbarsComponent, NgIf, ErrorAlertMessageComponent, NgForOf, NgClass, RadioCheckboxComponent], styles: [".download-data__collaborator-list,.download-data__content-download__message,.download-data__content__sub-title,.download-data__link,.download-data__result__heading,.download-data__result__item,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.download-data__content__sub-title{font-size:16px;letter-spacing:.4px;line-height:1.5}.download-data__collaborator-list,.download-data__content-download__message,.download-data__link,.download-data__result__heading,.download-data__result__item{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.download-data__content__sub-title{font-weight:300}.download-data__link{font-weight:500}.download-data__result__heading{font-weight:300;padding:0 0 2rem}.download-data__result__name{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.os-theme-dark>.os-scrollbar-vertical{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark>.os-scrollbar>.os-scrollbar-track{background:#f0eff0}.os-theme-dark .os-scrollbar-handle{background:#656066;width:.2rem}.download-data__container{position:relative;display:block;background-color:#f9f9f9;overflow:visible}.download-data__result{letter-spacing:.04rem;line-height:1.43}.download-data__result__heading,.download-data__result__list{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;margin:0}.download-data__result--no-header{margin-top:-1rem}.download-data__result__list{border-bottom:1px solid #f0eff0;border-top:1px solid #f0eff0;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:0;list-style:none}.download-data__result__item{display:-webkit-box;display:flex;padding:2rem 0;position:relative;width:100%}.download-data__result__item:not(:last-child){border-bottom:1px solid #f0eff0}.download-data__result__item--error .download-data__result__icon{left:0;position:absolute}.download-data__result__name{-webkit-box-flex:1;flex-grow:1;padding-right:3rem}.download-data__result__item--error .download-data__result__name{padding-left:2.6rem}.download-data__result__value{text-align:right}.download-data__result__value--bold{font-weight:700}.download-data__result__icon{width:2rem;margin-right:.5rem}.download-data__link{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;text-decoration:none;text-transform:uppercase}.download-data__share-list{margin-bottom:2.6rem;margin-top:2rem;width:66.5%}.download-data__content{min-height:39.8rem}.download-data__content__sub-title{padding:1.4rem 0;margin:.7rem 0 0}.download-data__content--radio{display:block;margin-bottom:1.4rem}.download-data__content--scrollable{max-height:23.7rem;overflow:auto;padding-right:2.6rem}.download-data__content-download{padding:4rem 0 1.9rem}.download-data__content-download__message{margin:0;width:60%;letter-spacing:.04rem;padding-bottom:1rem}.download-data__content-download-post{padding-bottom:2rem}.download-data__content__file-selection{margin:2.6rem 0 2.3rem}.download-data__content__file-selection-buttons{margin-top:-.2rem}.download-data__content__transfer-message{margin:3.9rem 0 2.1rem}.download-data__collaborator-list{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;border-top:1px solid #e5e4e5;padding:1.5rem 0;margin-top:.6rem}.download-data__collaborator-list:last-child{border-bottom:1px solid #e5e4e5}.download-data__collaborator-list__email{-webkit-box-flex:1;flex-grow:1;margin-right:3rem;overflow:hidden;text-overflow:ellipsis}.download-data__collaborator-list__status-wrap{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;margin-right:-.3rem}.download-data__collaborator-list__status{margin-right:1.9rem}.download-data__collaborator-list .select-input-field{min-width:140px}.download-data__collaborator-list .select{margin-right:1.1rem;min-width:13.8rem}.download-data__collaborator-list .select--selected{padding:.4375rem 1.09375rem}.download-data__collaborator-list .select--selected:after{top:-4px}.download-data__collaborator-list .select__item{padding:.4375rem 1.09375rem}.download-data__collaborator-list__remove{background:0;border:0;cursor:pointer;margin-top:.3rem}.download-data__collaborator-list__remove svg{height:2rem;pointer-events:none;width:2rem}.download-data__scroll{height:280px;overflow-y:scroll}.download-data__strong{font-weight:500}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(DownloadDataComponent, [{
        type: Component,
        args: [{
                selector: "lib-download-data",
                templateUrl: "./download-data.component.html",
                styleUrls: ["./download-data.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ElementRef }]; }, { runName: [{
            type: Input
        }], runSize: [{
            type: Input
        }], downloadMessage: [{
            type: Input
        }], downloadLinkText: [{
            type: Input
        }], fileListHeader: [{
            type: Input
        }], fileListTypes: [{
            type: Input
        }], runData: [{
            type: Input
        }], runAlert: [{
            type: Input
        }], runError: [{
            type: Input
        }], downloadLink: [{
            type: Input
        }], scrollContainer: [{
            type: ViewChild,
            args: ["scrollContainer", { static: true }]
        }], outputDataChange: [{
            type: Output
        }] });

class ErrorAlertMessageModule {
}
/** @nocollapse */ ErrorAlertMessageModule.ngModuleDef = ɵɵdefineNgModule({ type: ErrorAlertMessageModule });
/** @nocollapse */ ErrorAlertMessageModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ErrorAlertMessageModule_Factory(t) { return new (t || ErrorAlertMessageModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ErrorAlertMessageModule, { declarations: [ErrorAlertMessageComponent], imports: [CommonModule], exports: [ErrorAlertMessageComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ErrorAlertMessageModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ErrorAlertMessageComponent],
                exports: [ErrorAlertMessageComponent]
            }]
    }], null, null);

class DownloadDataModule {
}
/** @nocollapse */ DownloadDataModule.ngModuleDef = ɵɵdefineNgModule({ type: DownloadDataModule });
/** @nocollapse */ DownloadDataModule.ngInjectorDef = ɵɵdefineInjector({ factory: function DownloadDataModule_Factory(t) { return new (t || DownloadDataModule)(); }, imports: [[CommonModule, RadioCheckboxModule, ErrorAlertMessageModule, OverlayscrollbarsModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(DownloadDataModule, { declarations: [DownloadDataComponent], imports: [CommonModule, RadioCheckboxModule, ErrorAlertMessageModule, OverlayscrollbarsModule], exports: [DownloadDataComponent] });
/*@__PURE__*/ ɵsetClassMetadata(DownloadDataModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RadioCheckboxModule, ErrorAlertMessageModule, OverlayscrollbarsModule],
                declarations: [DownloadDataComponent],
                exports: [DownloadDataComponent]
            }]
    }], null, null);

const _c0$j = ["lib-input", ""];
const _c1$j = ["*"];
const CLASS_MAP$1 = {
    search: "input-field__text-input",
    text: "input-field__text-input",
    number: "input-field__text-input",
    email: "input-field__text-input",
    textarea: "input-field__textarea"
};
class InputComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        // tslint:disable-next-line: no-output-on-prefix
        this.onInput = new EventEmitter();
        this.onChange = new EventEmitter();
        this.inputRef = elementRef;
        const type = this.inputRef.nativeElement.type;
        this.inputRef.nativeElement.classList.add(CLASS_MAP$1[type]);
    }
    ngOnInit() {
        this._onInput();
        this._onChange();
    }
    ngAfterViewInit() {
        this.osInstance = OverlayScrollbars(this.inputRef.nativeElement, {});
    }
    ngOnDestroy() {
        if (this.osInstance && this.osInstance.destroy) {
            this.osInstance.destroy();
        }
    }
    _onInput() {
        this.elementRef.nativeElement.addEventListener("input", event => {
            setTimeout(() => {
                this.onInput.emit(event);
            }, 1000);
        });
    }
    _onChange() {
        this.elementRef.nativeElement.addEventListener("change", event => {
            setTimeout(() => {
                this.onChange.emit(event);
            }, 1000);
        });
    }
}
/** @nocollapse */ InputComponent.ngComponentDef = ɵɵdefineComponent({ type: InputComponent, selectors: [["input", "lib-input", ""], ["textarea", "lib-input", ""]], factory: function InputComponent_Factory(t) { return new (t || InputComponent)(ɵɵdirectiveInject(ElementRef)); }, outputs: { onInput: "onInput", onChange: "onChange" }, exportAs: ["libInput"], attrs: _c0$j, ngContentSelectors: _c1$j, consts: 1, vars: 0, template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵprojection(0);
    } }, styles: [".input-field__combo--input,.input-field__text-input,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.input-field__text-input{font-weight:400;font-size:16px;letter-spacing:.4px;line-height:1.5}.input-field__combo--input{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.os-theme-dark>.os-scrollbar-vertical{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark>.os-scrollbar>.os-scrollbar-track{background:#f0eff0}.os-theme-dark .os-scrollbar-handle{background:#656066;width:.2rem}.input-field{max-width:36rem;position:relative}.input-field--block{max-width:inherit}.input-field--disabled .input-field__text-input:hover{border-bottom:1px solid #d1cfd1;cursor:not-allowed}.input-field--disabled .input-field__label{color:#322d32;opacity:.4}.input-field--invalid .input-field__text-input:hover{border-bottom:1px solid #bf4252}.input-field__required{color:#656066;font-size:1.9rem;font-weight:700;margin-left:.8rem;position:absolute;top:.1rem}.input-field--invalid .input-field__text-input{border-bottom:1px solid #bf4252;padding-right:15px}.input-field__text-input{background-color:transparent;border:0;border-bottom:1px solid #bfbebf;color:#322d32;display:block;outline:0;padding:0 0 2px;width:100%}.input-field__text-input:disabled{color:#322d32;opacity:.4}.input-field--required .input-field__text-input{border-bottom:1px solid #656066}.input-field__text-input::-webkit-input-placeholder{color:#d1cfd1}.input-field__text-input::-moz-placeholder{color:#d1cfd1}.input-field__text-input:-ms-input-placeholder{color:#d1cfd1}.input-field__text-input::-ms-input-placeholder{color:#d1cfd1}.input-field__text-input::placeholder{color:#d1cfd1}.input-field__text-input:not(:disabled):focus,.input-field__text-input:not(:disabled):focus:active,.input-field__text-input:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd);border-top:0;border-left:0;border-right:0}.input-field__text-input--invalid{border-bottom:1px solid #bf4252;color:#322d32}.input-field__text-input:focus{background-color:transparent;color:#322d32;border-bottom:1px solid #656066}.input-field__combo{position:relative;width:100%}.input-field__combo--btn{display:block;padding:0;margin:0;background:0;outline:0;line-height:1.6;border:0}.input-field__combo--icon{position:absolute;width:20px;height:20px;top:50%;right:.5rem;z-index:1;margin-top:-1.1rem}.input-field__combo--input{width:100%;height:30px;padding:.3125rem .75rem;position:relative;background:#fff;box-sizing:border-box;border-style:solid;border-width:1px;border-image-slice:1}.input-field__combo--input:hover{border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field__combo--input::-webkit-input-placeholder{color:#d1cfd1}.input-field__combo--input::-moz-placeholder{color:#d1cfd1}.input-field__combo--input:-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input::-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input::placeholder{color:#d1cfd1}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: `input[lib-input], textarea[lib-input]`,
                templateUrl: "./input.component.html",
                styleUrls: ["./input.component.scss"],
                exportAs: "libInput",
                // tslint:disable-next-line: no-host-metadata-property
                host: {},
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ElementRef }]; }, { onInput: [{
            type: Output
        }], onChange: [{
            type: Output
        }] });

const _c0$k = ["class", "input-field__label", 3, "for", 4, "ngIf"];
const _c1$k = [1, "input-field__container"];
const _c2$h = ["class", "input-field__add-icon", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 4, "ngIf"];
const _c3$h = ["class", "input-field__helper input-field__helper--error", 4, "ngIf"];
const _c4$g = ["class", "input-field__helper", 4, "ngIf"];
const _c5$g = [1, "input-field__label", 3, "for"];
const _c6$f = ["class", "input-field__required", 4, "ngIf"];
const _c7$e = [1, "input-field__required"];
function FormFieldsComponent_label_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c7$e);
    ɵɵtext(1, "*");
    ɵɵelementEnd();
} }
function FormFieldsComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", _c5$g);
    ɵɵtext(1);
    ɵɵtemplate(2, FormFieldsComponent_label_0_span_2_Template, 2, 0, "span", _c6$f);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r550 = ɵɵnextContext();
    ɵɵproperty("for", ctx_r550.for);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r550.label, "");
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r550.required);
} }
const _c8$e = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "input-field__add-icon"];
const _c9$e = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#656066"];
function FormFieldsComponent__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c8$e);
    ɵɵelement(1, "path", _c9$e);
    ɵɵelementEnd();
} }
const _c10$d = [1, "input-field__helper", "input-field__helper--error"];
function FormFieldsComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c10$d);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r552 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r552.errorMessage);
} }
const _c11$b = [1, "input-field__helper"];
function FormFieldsComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c11$b);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r553 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r553.hint);
} }
const _c12$a = ["*"];
const TEXT_FIELD_HOST_ATTRIBUTES = ["required"];
const VALIDITY_CLASSES = {
    valid: "ng-valid",
    invalid: "ng-invalid"
};
class FormFieldsComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.isValidateOnTouch = false;
        this.isValidateOnInputChange = false;
        this.isValidSubject = new BehaviorSubject(true);
        this.isValid$ = this.isValidSubject.asObservable();
        this.for = "";
        this.required = false;
        this.isTextarea = false;
        for (const attr of TEXT_FIELD_HOST_ATTRIBUTES) {
            if (this._hasHostAttributes(attr)) {
                this._getHostElement().classList.add(`input-field--${attr}`);
            }
        }
        this.formFieldRef = elementRef;
        this.formFieldRef.nativeElement.classList.add("input-field");
    }
    ngOnInit() {
        // this.childComponents.forEach((childComponent: ChildComponent) => {
        //   childComponent.updated.subscribe(item => this.updateParentValue(item));
        // });
    }
    ngAfterContentInit() {
        this._setFromFieldProps(this.InputComponent);
    }
    ngAfterViewInit() {
        this.InputComponent.onInput
            .pipe(debounceTime(100)).subscribe(event => {
            this.checkValidity(event);
        });
        if (this.isValidateOnInputChange) {
            this.InputComponent.onChange
                .pipe(debounceTime(100)).subscribe(event => {
                this.checkValidity(event);
            });
        }
    }
    /**
     * Validates the form input on touch.
     * @param $event DOM event on libformfield
     */
    onTouched($event) {
        if (this.isValidateOnTouch) {
            this.checkValidity($event);
        }
    }
    _setFromFieldProps(input) {
        const elementRef = input.elementRef.nativeElement;
        const type = input.elementRef.nativeElement.type;
        if (type === "textarea") {
            this.isTextarea = true;
        }
        this.for = elementRef.id;
        this.required =
            elementRef.required === undefined ? false : elementRef.required;
        if (elementRef.disabled) {
            this.formFieldRef.nativeElement.classList.add("input-field--disabled");
        }
    }
    checkValidity(event) {
        const element = event.target;
        const classArray = Array.from(element.classList);
        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < classArray.length; index++) {
            const classItem = classArray[index];
            if (classItem === VALIDITY_CLASSES.invalid) {
                this.formFieldRef.nativeElement.classList.add("input-field--invalid");
                this.isValidSubject.next(false);
                break;
            }
            else if (classItem === VALIDITY_CLASSES.valid) {
                this.formFieldRef.nativeElement.classList.remove("input-field--invalid");
                this.isValidSubject.next(true);
                break;
            }
        }
    }
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
    _hasHostAttributes(...attributes) {
        return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
    }
}
/** @nocollapse */ FormFieldsComponent.ngComponentDef = ɵɵdefineComponent({ type: FormFieldsComponent, selectors: [["lib-form-field"]], factory: function FormFieldsComponent_Factory(t) { return new (t || FormFieldsComponent)(ɵɵdirectiveInject(ElementRef)); }, contentQueries: function FormFieldsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, InputComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadContentQuery())) && (ctx.InputComponent = _t.first);
    } }, hostBindings: function FormFieldsComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("focusout", function FormFieldsComponent_focusout_HostBindingHandler($event) { return ctx.onTouched($event); });
    } }, inputs: { label: "label", hint: "hint", errorMessage: "errorMessage", isValidateOnTouch: "isValidateOnTouch", isValidateOnInputChange: "isValidateOnInputChange" }, ngContentSelectors: _c12$a, consts: 9, vars: 10, template: function FormFieldsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, FormFieldsComponent_label_0_Template, 3, 3, "label", _c0$k);
        ɵɵelementStart(1, "div", _c1$k);
        ɵɵprojection(2);
        ɵɵtemplate(3, FormFieldsComponent__svg_svg_3_Template, 2, 0, "svg", _c2$h);
        ɵɵpipe(4, "async");
        ɵɵtemplate(5, FormFieldsComponent_span_5_Template, 2, 1, "span", _c3$h);
        ɵɵpipe(6, "async");
        ɵɵtemplate(7, FormFieldsComponent_span_7_Template, 2, 1, "span", _c4$g);
        ɵɵpipe(8, "async");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.label);
        ɵɵselect(3);
        ɵɵproperty("ngIf", !ɵɵpipeBind1(4, 4, ctx.isValid$) && !ctx.isTextarea);
        ɵɵselect(5);
        ɵɵproperty("ngIf", !ɵɵpipeBind1(6, 6, ctx.isValid$));
        ɵɵselect(7);
        ɵɵproperty("ngIf", ctx.hint && ɵɵpipeBind1(8, 8, ctx.isValid$));
    } }, directives: [NgIf], pipes: [AsyncPipe], styles: [".input-field__combo--input,.input-field__label,.input-field__text-input,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.input-field__label,.input-field__text-input{font-weight:400;font-size:16px;letter-spacing:.4px;line-height:1.5}.input-field__combo--input{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.input-field__label{font-weight:300}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.input-field{max-width:36rem;position:relative}.input-field--block{max-width:inherit}.input-field__container{position:relative}.input-field__add-icon{position:absolute;right:-.3rem;bottom:.4rem;width:2rem}.input-field--disabled .input-field__text-input:hover{border-bottom:1px solid #d1cfd1;cursor:not-allowed}.input-field--disabled .input-field__label{color:#322d32;opacity:.4}.input-field--invalid .input-field__text-input:hover{border-bottom:1px solid #bf4252}.input-field__required{color:#656066;font-size:1.9rem;font-weight:700;margin-left:.8rem;position:absolute;top:.1rem}.input-field__label{color:#322d32;display:block;position:relative}.input-field__label--checkbox{margin-bottom:1.1rem}.input-field--invalid .input-field__text-input{border-bottom:1px solid #bf4252}.input-field__text-input{background-color:transparent;border:0;border-bottom:1px solid #bfbebf;color:#322d32;display:block;outline:0;padding:0 0 2px;width:100%}.input-field__text-input:disabled{color:#322d32;opacity:.4}.input-field--required .input-field__text-input{border-bottom:1px solid #656066}.input-field__text-input::-webkit-input-placeholder{color:#d1cfd1}.input-field__text-input::-moz-placeholder{color:#d1cfd1}.input-field__text-input:-ms-input-placeholder{color:#d1cfd1}.input-field__text-input::-ms-input-placeholder{color:#d1cfd1}.input-field__text-input::placeholder{color:#d1cfd1}.input-field__text-input:not(:disabled):focus,.input-field__text-input:not(:disabled):focus:active,.input-field__text-input:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd);border-top:0;border-left:0;border-right:0}.input-field__text-input--invalid{border-bottom:1px solid #bf4252;color:#322d32}.input-field__text-input:focus{background-color:transparent;color:#322d32;border-bottom:1px solid #656066}.input-field__helper{color:#918d91;display:block;font-size:1.2rem;font-weight:400;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.04rem;margin-top:2px;position:absolute;min-width:20rem}.input-field__helper--error{font-weight:500;color:#bf4252}.input-field--disabled .input-field__helper{opacity:.4}.input-field__combo{position:relative;width:100%}.input-field__combo--btn{display:block;padding:0;margin:0;background:0;outline:0;line-height:1.6;border:0}.input-field__combo--icon{position:absolute;width:20px;height:20px;top:50%;right:.5rem;z-index:1;margin-top:-1.1rem}.input-field__combo--input{width:100%;height:30px;padding:.3125rem .75rem;position:relative;background:#fff;box-sizing:border-box;border-style:solid;border-width:1px;border-image-slice:1}.input-field__combo--input:hover{border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field__combo--input::-webkit-input-placeholder{color:#d1cfd1}.input-field__combo--input::-moz-placeholder{color:#d1cfd1}.input-field__combo--input:-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input::-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input::placeholder{color:#d1cfd1}.input-field__textarea{background-color:transparent;border:1px solid #bfbebf;box-sizing:border-box;color:#322d32;font-size:1.6rem;height:9.9rem;letter-spacing:.04rem;line-height:1.45;margin-top:.4rem;padding:.9rem 1.6rem;resize:none;width:100%}.input-field__textarea:not(:disabled):focus,.input-field__textarea:not(:disabled):focus:active,.input-field__textarea:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field--invalid .input-field__textarea{border-bottom:1px solid #bf4252}.input-field--required .input-field__textarea{border-bottom:1px solid #656066}.input-field__textarea:disabled{cursor:not-allowed;color:#d1cfd1;opacity:.4}.input-field__textarea::-webkit-input-placeholder{color:#d1cfd1}.input-field__textarea::-moz-placeholder{color:#d1cfd1}.input-field__textarea:-ms-input-placeholder{color:#d1cfd1}.input-field__textarea::-ms-input-placeholder{color:#d1cfd1}.input-field__textarea::placeholder{color:#d1cfd1}.input-field__textarea:hover:not([disabled]){border-color:#225de6}.input-field__textarea:focus{border:1px solid #bfbebf;border-bottom-color:#656066;outline:0}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(FormFieldsComponent, [{
        type: Component,
        args: [{
                selector: "lib-form-field",
                templateUrl: "./form-fields.component.html",
                styleUrls: ["./form-fields.component.scss"],
                host: {},
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ElementRef }]; }, { label: [{
            type: Input
        }], hint: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], isValidateOnTouch: [{
            type: Input
        }], isValidateOnInputChange: [{
            type: Input
        }], InputComponent: [{
            type: ContentChild,
            args: [InputComponent, { static: false }]
        }], onTouched: [{
            type: HostListener,
            args: ["focusout", ["$event"]]
        }] });

const _c0$l = [1, "share-data"];
const _c1$l = [1, "share-data__wrapper"];
const _c2$i = [1, "share-data__wrapper--inner"];
const _c3$i = [1, "share-data__container"];
const _c4$h = [1, "share-data__content"];
const _c5$h = [1, "share-data__result", "share-data__result--no-header"];
const _c6$g = [1, "share-data__result__list"];
const _c7$f = [1, "share-data__result__item"];
const _c8$f = [1, "share-data__result__name"];
const _c9$f = [1, "share-data__share-list"];
const _c10$e = [1, "input-field"];
const _c11$c = ["for", "input-01", 1, "input-field__label"];
const _c12$b = ["name", "formEmail", "novalidate", "", "autocapitalize", "off", 3, "formGroup"];
const _c13$a = ["for", "input-01", "errorMessage", "Enter valid email"];
const _c14$9 = ["id", "input-01", "lib-input", "", "type", "email", "formControlName", "Email", 3, "placeholder", "ngModel", "keydown.enter", "input"];
const _c15$8 = [1, "share-data__content__transfer-message"];
const _c16$7 = [1, "input-field", "input-field--block"];
const _c17$7 = ["for", "input-02", "class", "input-field__label", 4, "ngIf"];
const _c18$7 = ["id", "input-02", "class", "input-field__textarea", 3, "disabled", "maxLength", "ngModel", "placeholder", "ngModelChange", "change", 4, "ngIf"];
const _c19$6 = [1, "input-field__helper"];
const _c20$6 = ["class", "share-data__chk-associated-resources", 4, "ngIf"];
const _c21$6 = ["class", "share-data__error-alert-msg", 4, "ngIf"];
const _c22$6 = ["class", "share-data__add-collaborator", 4, "ngIf"];
const _c23$6 = ["class", "share-data__content__sub-title", 4, "ngIf"];
const _c24$5 = [3, "hidden"];
const _c25$5 = [1, "share-data__collaborator--container"];
const _c26$5 = ["class", "share-data__collaborator-list", 4, "ngFor", "ngForOf"];
const _c27$5 = [3, "alertMsg", "errorMsg"];
const _c28$5 = ["for", "input-02", 1, "input-field__label"];
function ShareDataComponent_label_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", _c28$5);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r529 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r529.optionalMessageLabel, "");
} }
const _c29$4 = ["id", "input-02", 1, "input-field__textarea", 3, "disabled", "maxLength", "ngModel", "placeholder", "ngModelChange", "change"];
function ShareDataComponent_textarea_20_Template(rf, ctx) { if (rf & 1) {
    const _r537 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "textarea", _c29$4);
    ɵɵlistener("ngModelChange", function ShareDataComponent_textarea_20_Template_textarea_ngModelChange_0_listener($event) { ɵɵrestoreView(_r537); const ctx_r536 = ɵɵnextContext(); return ctx_r536.optionalMessage = $event; });
    ɵɵlistener("change", function ShareDataComponent_textarea_20_Template_textarea_change_0_listener($event) { ɵɵrestoreView(_r537); const ctx_r538 = ɵɵnextContext(); return ctx_r538.onOptionalMessageChange($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r530 = ɵɵnextContext();
    ɵɵproperty("disabled", (ctx_r530.errorMsg == null ? null : ctx_r530.errorMsg.length) > 0)("maxLength", ctx_r530.optionalMessageMaxSize)("ngModel", ctx_r530.optionalMessage)("placeholder", ctx_r530.optionalMessagePlaceholder);
} }
const _c30$4 = [1, "share-data__chk-associated-resources"];
const _c31$4 = ["type", "checkbox", 3, "checked", "change"];
const _c32$4 = [3, "innerHtml", 4, "ngIf"];
const _c33$3 = [3, "innerHtml"];
function ShareDataComponent_div_23_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "p", _c33$3);
} if (rf & 2) {
    const ctx_r539 = ɵɵnextContext(2);
    ɵɵproperty("innerHtml", ctx_r539.associateResourceMessage, ɵɵsanitizeHtml);
} }
function ShareDataComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r541 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c30$4);
    ɵɵelementStart(1, "lib-radio-checkbox", _c31$4);
    ɵɵlistener("change", function ShareDataComponent_div_23_Template_lib_radio_checkbox_change_1_listener($event) { ɵɵrestoreView(_r541); const ctx_r540 = ɵɵnextContext(); return ctx_r540.onIncludeAssociatedResourceschange($event); });
    ɵɵtemplate(2, ShareDataComponent_div_23_p_2_Template, 1, 1, "p", _c32$4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r531 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("checked", ctx_r531.outputData.includeAssociatedResources);
    ɵɵselect(2);
    ɵɵproperty("ngIf", (ctx_r531.associateResourceMessage == null ? null : ctx_r531.associateResourceMessage.length) > 0);
} }
const _c34$3 = [1, "share-data__error-alert-msg"];
const _c35$3 = [3, "errorMsg"];
function ShareDataComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c34$3);
    ɵɵelement(1, "lib-error-alert-message", _c35$3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r532 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("errorMsg", ctx_r532.pendingErrorMsg);
} }
const _c36$3 = [1, "share-data__add-collaborator"];
const _c37$3 = [1, "btn", "btn--secondary", 3, "disabled", "click"];
function ShareDataComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r543 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c36$3);
    ɵɵelementStart(1, "button", _c37$3);
    ɵɵlistener("click", function ShareDataComponent_div_25_Template_button_click_1_listener($event) { ɵɵrestoreView(_r543); const ctx_r542 = ɵɵnextContext(); return ctx_r542.addUser(); });
    ɵɵtext(2, " Add Collaborator ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r533 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("disabled", ctx_r533.disableAddCollaborator);
} }
const _c38$3 = [1, "share-data__content__sub-title"];
function ShareDataComponent_h5_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h5", _c38$3);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r534 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate(ctx_r534.userListTitle);
} }
const _c39$3 = [1, "share-data__collaborator-list"];
const _c40$3 = [1, "share-data__collaborator-list__email"];
const _c41$2 = [1, "share-data__collaborator-list__status-wrap"];
const _c42$2 = [1, "share-data__collaborator-list__status"];
const _c43$2 = [1, "select"];
const _c44$2 = ["placeholder", "Select", 3, "selected", "change"];
const _c45$2 = [3, "value", "label", 4, "ngFor", "ngForOf"];
const _c46$2 = [1, "share-data__collaborator-list__remove", 3, "click"];
const _c47$2 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20"];
const _c48$2 = ["d", "M10.7 10l5.1-5.1c.2-.2.2-.5 0-.7s-.5-.2-.7 0L10 9.3 4.9 4.1c-.2-.1-.6-.1-.8 0s-.1.6 0 .8L9.3 10l-5.1 5.1c-.2.2-.2.5 0 .7 0 .2.2.2.3.2s.3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L10.7 10z", "fill", "#656066"];
const _c49$2 = [3, "value", "label"];
function ShareDataComponent_div_30_lib_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c49$2);
} if (rf & 2) {
    const option_r546 = ctx.$implicit;
    ɵɵproperty("value", option_r546.name)("label", option_r546.value);
} }
function ShareDataComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r548 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c39$3);
    ɵɵelementStart(1, "p", _c40$3);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", _c41$2);
    ɵɵelementStart(4, "p", _c42$2);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", _c43$2);
    ɵɵelementStart(7, "lib-select", _c44$2);
    ɵɵlistener("change", function ShareDataComponent_div_30_Template_lib_select_change_7_listener($event) { ɵɵrestoreView(_r548); const item_r544 = ctx.$implicit; const ctx_r547 = ɵɵnextContext(); return ctx_r547.changeUserSelectedOption(item_r544, $event); });
    ɵɵtemplate(8, ShareDataComponent_div_30_lib_option_8_Template, 1, 2, "lib-option", _c45$2);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(9, "button", _c46$2);
    ɵɵlistener("click", function ShareDataComponent_div_30_Template_button_click_9_listener($event) { ɵɵrestoreView(_r548); const item_r544 = ctx.$implicit; const ctx_r549 = ɵɵnextContext(); return ctx_r549.removeUser(item_r544); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(10, "svg", _c47$2);
    ɵɵelement(11, "path", _c48$2);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r544 = ctx.$implicit;
    const ctx_r535 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", item_r544.email, " ");
    ɵɵselect(5);
    ɵɵtextInterpolate1(" ", item_r544.status, " ");
    ɵɵselect(7);
    ɵɵproperty("selected", item_r544.permission);
    ɵɵselect(8);
    ɵɵproperty("ngForOf", ctx_r535.permissionOptions);
} }
class ShareOutputData {
    get inputValue() {
        return this._inputValue;
    }
    set inputValue(value) {
        this._inputValue = value;
    }
    get optionalMessage() {
        return this._optionalMessage;
    }
    set optionalMessage(msg) {
        this._optionalMessage = msg;
    }
    get userList() {
        return this._userList;
    }
    set userList(users) {
        this._userList = users;
    }
    get includeAssociatedResources() {
        return this._includeAssociatedResources;
    }
    set includeAssociatedResources(canincludeAssociatedResources) {
        this._includeAssociatedResources = canincludeAssociatedResources;
    }
}
class ShareDataComponent {
    constructor(elementRef, formBuilder, sanitizer) {
        this.elementRef = elementRef;
        this.formBuilder = formBuilder;
        this.sanitizer = sanitizer;
        this.projectTitle = "";
        this.inputLabel = "";
        this.inputPlaceholder = "";
        this.userListTitle = "";
        this.optionalMessageLabel = "";
        this.optionalMessagePlaceholder = "";
        this.optionalMessageHint = "";
        this.optionalMessageMaxSize = 140;
        this.userList = [];
        this.permissionOptions = [];
        this._includeAssociatedResources = false;
        this.associateResourceMessage = "";
        this.allowAddUser = true;
        this.optionalMessage = "";
        this.disableAddCollaborator = true;
        this.pendingErrorMsg = "";
        this.inputValue = "";
        // Sharing API code uses a similar Regex in Illumina.Cloud.Core, CommonRegEx.cs
        this.emailPattern = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,6}$";
        this.outputData = new ShareOutputData();
        this.outputDataChange = new EventEmitter();
        this.outputData.userList = this.userList;
        this.formEmail = this.formBuilder.group({
            Email: [
                { value: "", disabled: false },
                [Validators.pattern(this.emailPattern)],
            ],
        });
    }
    get includeAssociatedResources() {
        return this._includeAssociatedResources;
    }
    set includeAssociatedResources(includeAssociatedResources) {
        this._includeAssociatedResources = includeAssociatedResources;
        if (this._includeAssociatedResources) {
            this.outputData.includeAssociatedResources = true;
        }
    }
    ngOnInit() { }
    ngAfterViewInit() { }
    ngOnDestroy() { }
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
    addUser() {
        this.pendingErrorMsg = "";
        if (!this.allowAddUser) {
            return;
        }
        if (this.inputValue.trim() === "" || !this.formEmail.valid) {
            return;
        }
        if (this.activeUsers().some((user) => user.email === this.inputValue)) {
            this.pendingErrorMsg = this.inputValue + " already has an invite";
            return;
        }
        let optionSelected = "";
        if (this.permissionOptions.length > 0) {
            optionSelected = this.permissionOptions[0].name;
        }
        const user = {
            email: this.inputValue,
            status: "New",
            personalMessage: this.outputData.optionalMessage,
            permission: optionSelected,
        };
        this.userList.push(user);
        this.inputValue = "";
        this.disableAddCollaborator = true;
        this.optionalMessage = "";
        this.outputData.userList = this.userList;
        this.outputDataChange.emit(this.outputData);
    }
    _hasHostAttributes(...attributes) {
        return attributes.some((attribute) => this._getHostElement().hasAttribute(attribute));
    }
    onInputChange(event) {
        this.inputValue = event.target.value;
        this.disableAddCollaborator =
            !this.formEmail.valid || this.inputValue.trim() === "";
        this.outputData.userList = this.userList;
        this.outputData.inputValue = event.target.value;
        this.outputData.isInputValid = this.formEmail.valid;
        this.outputDataChange.emit(this.outputData);
    }
    onOptionalMessageChange(event) {
        this.optionalMessage = event.target.value;
        this.outputData.optionalMessage = event.target.value;
        this.outputDataChange.emit(this.outputData);
    }
    removeUser(item) {
        // it is ok to remove the newly added user from the users list.
        // For existing users just mark for deletion.
        if (item.status === "New") {
            ___default.remove(this.userList, function (user) {
                return user === item;
            });
        }
        else {
            item.markedForDeletion = true;
        }
        this.outputData.userList = this.userList;
        this.outputDataChange.emit(this.outputData);
    }
    activeUsers() {
        const activeUsers = [];
        this.userList.forEach((user) => {
            if (!user.markedForDeletion) {
                activeUsers.push(user);
            }
        });
        return activeUsers;
    }
    changeUserSelectedOption(item, $event) {
        item.permission = $event.option.label;
        this.outputData.userList = this.userList;
        this.outputDataChange.emit(this.outputData);
    }
    onIncludeAssociatedResourceschange($event) {
        this.outputData.includeAssociatedResources = $event.target.checked;
        this.outputDataChange.emit(this.outputData);
    }
}
/** @nocollapse */ ShareDataComponent.ngComponentDef = ɵɵdefineComponent({ type: ShareDataComponent, selectors: [["lib-share-data"]], factory: function ShareDataComponent_Factory(t) { return new (t || ShareDataComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(DomSanitizer)); }, inputs: { projectTitle: "projectTitle", inputLabel: "inputLabel", inputPlaceholder: "inputPlaceholder", userListTitle: "userListTitle", optionalMessageLabel: "optionalMessageLabel", optionalMessagePlaceholder: "optionalMessagePlaceholder", optionalMessageHint: "optionalMessageHint", optionalMessageMaxSize: "optionalMessageMaxSize", userList: "userList", permissionOptions: "permissionOptions", alertMsg: "alertMsg", errorMsg: "errorMsg", includeAssociatedResources: "includeAssociatedResources", associateResourceMessage: "associateResourceMessage", allowAddUser: "allowAddUser" }, outputs: { outputDataChange: "outputDataChange" }, consts: 32, vars: 18, template: function ShareDataComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$l);
        ɵɵelementStart(1, "div", _c1$l);
        ɵɵelementStart(2, "div", _c2$i);
        ɵɵelementStart(3, "div", _c3$i);
        ɵɵelementStart(4, "div", _c4$h);
        ɵɵelementStart(5, "section", _c5$h);
        ɵɵelementStart(6, "ul", _c6$g);
        ɵɵelementStart(7, "li", _c7$f);
        ɵɵelementStart(8, "span", _c8$f);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", _c9$f);
        ɵɵelementStart(11, "div", _c10$e);
        ɵɵelementStart(12, "label", _c11$c);
        ɵɵtext(13);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "form", _c12$b);
        ɵɵelementStart(15, "lib-form-field", _c13$a);
        ɵɵelementStart(16, "input", _c14$9);
        ɵɵlistener("keydown.enter", function ShareDataComponent_Template_input_keydown_enter_16_listener($event) { return ctx.addUser(); });
        ɵɵlistener("input", function ShareDataComponent_Template_input_input_16_listener($event) { return ctx.onInputChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", _c15$8);
        ɵɵelementStart(18, "div", _c16$7);
        ɵɵtemplate(19, ShareDataComponent_label_19_Template, 2, 1, "label", _c17$7);
        ɵɵtemplate(20, ShareDataComponent_textarea_20_Template, 1, 4, "textarea", _c18$7);
        ɵɵelementStart(21, "span", _c19$6);
        ɵɵtext(22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(23, ShareDataComponent_div_23_Template, 3, 2, "div", _c20$6);
        ɵɵtemplate(24, ShareDataComponent_div_24_Template, 2, 1, "div", _c21$6);
        ɵɵtemplate(25, ShareDataComponent_div_25_Template, 3, 1, "div", _c22$6);
        ɵɵtemplate(26, ShareDataComponent_h5_26_Template, 2, 1, "h5", _c23$6);
        ɵɵelementStart(27, "div", _c24$5);
        ɵɵelementStart(28, "overlay-scrollbars");
        ɵɵelementStart(29, "div", _c25$5);
        ɵɵtemplate(30, ShareDataComponent_div_30_Template, 12, 4, "div", _c26$5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(31, "lib-error-alert-message", _c27$5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(9);
        ɵɵtextInterpolate(ctx.projectTitle);
        ɵɵselect(13);
        ɵɵtextInterpolate(ctx.inputLabel);
        ɵɵselect(14);
        ɵɵproperty("formGroup", ctx.formEmail);
        ɵɵselect(16);
        ɵɵproperty("placeholder", ctx.inputPlaceholder)("ngModel", ctx.inputValue);
        ɵɵattribute("disabled", (ctx.errorMsg == null ? null : ctx.errorMsg.length) > 0 ? true : null);
        ɵɵselect(19);
        ɵɵproperty("ngIf", ctx.optionalMessageLabel.length > 0);
        ɵɵselect(20);
        ɵɵproperty("ngIf", ctx.optionalMessagePlaceholder.length > 0);
        ɵɵselect(22);
        ɵɵtextInterpolate2(" Remaining characters : ", ctx.optionalMessageMaxSize - ctx.optionalMessage.length, "/", ctx.optionalMessageMaxSize, " ");
        ɵɵselect(23);
        ɵɵproperty("ngIf", ctx.includeAssociatedResources);
        ɵɵselect(24);
        ɵɵproperty("ngIf", ctx.pendingErrorMsg.length > 0);
        ɵɵselect(25);
        ɵɵproperty("ngIf", ctx.allowAddUser);
        ɵɵselect(26);
        ɵɵproperty("ngIf", ctx.activeUsers().length > 0);
        ɵɵselect(27);
        ɵɵproperty("hidden", ctx.activeUsers().length === 0);
        ɵɵselect(30);
        ɵɵproperty("ngForOf", ctx.activeUsers());
        ɵɵselect(31);
        ɵɵproperty("alertMsg", ctx.alertMsg)("errorMsg", ctx.errorMsg);
    } }, directives: [ɵangular_packages_forms_forms_z, NgControlStatusGroup, FormGroupDirective, FormFieldsComponent, InputComponent, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf, OverlayScrollbarsComponent, NgForOf, ErrorAlertMessageComponent, NgModel, RadioCheckboxComponent, SelectComponent, OptionComponent], styles: [".input-field{max-width:36rem;position:relative}.input-field--block{max-width:inherit}.input-field__add-icon{position:absolute;right:-.3rem;bottom:.4rem;width:2rem}.input-field--disabled .input-field__text-input:hover{border-bottom:1px solid #d1cfd1;cursor:not-allowed}.input-field--disabled .input-field__label{color:#322d32;opacity:.4}.input-field--invalid .input-field__text-input:hover{border-bottom:1px solid #bf4252}.input-field__required{color:#656066;font-size:1.9rem;font-weight:700;margin-left:.8rem;position:absolute;top:.1rem}.input-field__label{color:#322d32;display:block;position:relative}.input-field__label--checkbox{margin-bottom:1.1rem}.input-field--invalid .input-field__text-input{border-bottom:1px solid #bf4252}.input-field__text-input{background-color:transparent;border:0;border-bottom:1px solid #bfbebf;color:#322d32;display:block;outline:0;padding:0 0 2px;width:100%}.input-field__text-input:disabled{color:#322d32;opacity:.4}.input-field--required .input-field__text-input{border-bottom:1px solid #656066}.input-field__text-input::-webkit-input-placeholder{color:#d1cfd1}.input-field__text-input::-moz-placeholder{color:#d1cfd1}.input-field__text-input:-ms-input-placeholder{color:#d1cfd1}.input-field__text-input::-ms-input-placeholder{color:#d1cfd1}.input-field__text-input::placeholder{color:#d1cfd1}.input-field__text-input:not(:disabled):focus,.input-field__text-input:not(:disabled):focus:active,.input-field__text-input:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd);border-top:0;border-left:0;border-right:0}.input-field__text-input--invalid{border-bottom:1px solid #bf4252;color:#322d32}.input-field__text-input:focus{background-color:transparent;color:#322d32;border-bottom:1px solid #656066}.input-field__helper{color:#918d91;display:block;font-size:1.2rem;font-weight:400;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.04rem;margin-top:2px;position:absolute}.input-field__helper--error{font-weight:500;color:#bf4252}.input-field--disabled .input-field__helper{opacity:.4}.input-field__combo{position:relative;width:100%}.input-field__combo--btn{display:block;padding:0;margin:0;background:0;outline:0;line-height:1.6;border:0}.input-field__combo--icon{position:absolute;width:20px;height:20px;top:50%;right:.5rem;z-index:1;margin-top:-1.1rem}.input-field__combo--input{width:100%;height:30px;padding:.3125rem .75rem;position:relative;background:#fff;box-sizing:border-box;border-style:solid;border-width:1px;border-image-slice:1}.input-field__combo--input:hover{border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field__combo--input::-webkit-input-placeholder{color:#d1cfd1}.input-field__combo--input::-moz-placeholder{color:#d1cfd1}.input-field__combo--input:-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input::-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input::placeholder{color:#d1cfd1}.input-field__textarea{background-color:transparent;border:1px solid #bfbebf;box-sizing:border-box;color:#322d32;font-size:1.6rem;height:9.9rem;letter-spacing:.04rem;line-height:1.45;margin-top:.4rem;padding:.9rem 1.6rem;resize:none;width:100%}.input-field__textarea:not(:disabled):focus,.input-field__textarea:not(:disabled):focus:active,.input-field__textarea:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field--invalid .input-field__textarea{border-bottom:1px solid #bf4252}.input-field--required .input-field__textarea{border-bottom:1px solid #656066}.input-field__textarea:disabled{cursor:not-allowed;color:#d1cfd1;opacity:.4}.input-field__textarea::-webkit-input-placeholder{color:#d1cfd1}.input-field__textarea::-moz-placeholder{color:#d1cfd1}.input-field__textarea:-ms-input-placeholder{color:#d1cfd1}.input-field__textarea::-ms-input-placeholder{color:#d1cfd1}.input-field__textarea::placeholder{color:#d1cfd1}.input-field__textarea:hover:not([disabled]){border-color:#225de6}.input-field__textarea:focus{border:1px solid #bfbebf;border-bottom-color:#656066;outline:0}.os-theme-dark>.os-scrollbar-vertical{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark>.os-scrollbar>.os-scrollbar-track{background:#f0eff0}.os-theme-dark .os-scrollbar-handle{background:#656066;width:.2rem}.input-field__combo--input,.input-field__label,.input-field__text-input,.share-data__collaborator-list,.share-data__content-download__message,.share-data__content__sub-title,.share-data__link,.share-data__result__alert-box__text,.share-data__result__heading,.share-data__result__item,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.input-field__label,.input-field__text-input,.share-data__content__sub-title,.share-data__result__alert-box__text{font-weight:400;font-size:16px;letter-spacing:.4px;line-height:1.5}.input-field__combo--input,.share-data__collaborator-list,.share-data__content-download__message,.share-data__link,.share-data__result__heading,.share-data__result__item{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.input-field__label,.share-data__content__sub-title{font-weight:300}.share-data__link{font-weight:500}.share-data__result__heading{font-weight:300}.share-data__result__name{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.btn{background-color:#f0eff0;border:0;border-radius:50px;cursor:pointer;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;padding:8px 24px;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn:focus{box-shadow:none;outline:#7e8bf3 solid 4px}.btn:disabled{cursor:not-allowed;opacity:.4}.btn--secondary{background:0 0;color:#4e60ee;border:1px solid #4e60ee}.btn--secondary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);border-color:transparent;color:#fff}.btn--secondary:hover:disabled{color:#4e60ee}.btn--secondary:active:not(:disabled){background:#4e60ee;border-color:transparent;color:#fff}.btn--secondary.btn--small{font-size:14px;padding:5px 19px}.btn--secondary.btn--disabled{opacity:.4}.btn--disabled{cursor:not-allowed}.btn--primary{background:linear-gradient(8.68deg,#225de6 -4.27%,#a664fd 116.09%);color:#fff}.btn--primary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn--primary:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn--primary.btn--small{padding:5px 19px}.btn--primary.btn--disabled{opacity:.4}.btn--white{background:#fff;padding:7px 24px}.btn--white.btn--small{padding:5px 19px}.btn--white.btn--disabled{opacity:.4}.btn--tertiary{background:0 0;border:1px solid transparent;color:#4e60ee}.btn--tertiary:hover:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee}.btn--tertiary:active:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee;box-shadow:inset 0 0 0 1px #4e60ee}.btn--tertiary:focus:not(:disabled){border-color:#4e60ee}.btn--tertiary.btn--small{font-size:14px}.btn--tertiary.btn--disabled{opacity:.4}.btn--link,.btn--link:not([href]){background:0 0;color:#4e60ee!important}.btn--link:hover:not(:disabled),.btn--link:not([href]):hover:not(:disabled){background:0 0;color:#4e60ee;text-decoration:underline}.btn--link:active,.btn--link:not([href]):active{background:0 0}.btn--link.btn--small,.btn--link:not([href]).btn--small{font-size:14px}.btn--link.btn--disabled,.btn--link:not([href]).btn--disabled{opacity:.4}.share-data__container{position:relative;display:block;background-color:#f9f9f9;overflow:visible}.share-data__result{letter-spacing:.04rem;line-height:1.43}.share-data__result__heading,.share-data__result__list{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;margin:0}.share-data__result__heading{padding:0 0 2rem}.share-data__result__list{border-bottom:1px solid #f0eff0;border-top:1px solid #f0eff0;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:0;list-style:none}.share-data__result__item{display:-webkit-box;display:flex;padding:2rem 0;position:relative;width:100%}.share-data__result__item:not(:last-child){border-bottom:1px solid #f0eff0}.share-data__result__item--error .share-data__result__icon{left:0;position:absolute}.share-data__result__name{-webkit-box-flex:1;flex-grow:1;padding-right:3rem}.share-data__result__item--error .share-data__result__name{padding-left:2.6rem}.share-data__result__value{text-align:right}.share-data__result__icon{width:2rem;margin-right:.5rem}.share-data__result__alert-box{display:-webkit-box;display:flex;background:#f0eff0;margin:0 0 1.7rem;padding:1.2rem 1.25rem 1.3rem 0}.share-data__result__alert-box__text{margin:0;padding:0}.share-data__result__alert-box svg#Alert{width:2.8rem;height:2.8rem;margin-right:.7rem;margin-top:-.3rem}.share-data__link{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;text-decoration:none;text-transform:uppercase}.share-data__share-list{margin-bottom:2.6rem;margin-top:2rem;width:66.5%}.share-data__content{min-height:39.8rem}.share-data__content__sub-title{padding:1.4rem 0;margin:.7rem 0 0}.share-data__content--radio{display:block;margin-bottom:1.4rem}.share-data__content--scrollable{max-height:23.7rem;overflow:auto;padding-right:44px}.share-data__content-download{padding:4rem 0 1.9rem}.share-data__content-download svg#Alert{width:2.8rem;height:2.8rem;margin-right:.5rem}.share-data__content-download__message{letter-spacing:.04rem;padding-bottom:1rem;margin:0;width:60%}.share-data__content-download-post{padding-bottom:2rem}.share-data__content__file-selection{margin:2.6rem 0 2.3rem}.share-data__content__file-selection-buttons{margin-top:-.2rem}.share-data__content__transfer-message{margin:3.9rem 0 2.1rem}.share-data__collaborator--container{max-height:40rem;padding-right:2.6rem}.share-data__collaborator-list{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;border-top:1px solid #e5e4e5;padding:1.5rem 0;margin-top:.6rem}.share-data__collaborator-list:last-child{border-bottom:1px solid #e5e4e5}.share-data__collaborator-list__email{-webkit-box-flex:1;flex-grow:1;margin-right:3rem;overflow:hidden;text-overflow:ellipsis}.share-data__collaborator-list__status-wrap{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;margin-right:-.3rem}.share-data__collaborator-list__status{margin-right:1.9rem}.share-data__collaborator-list .select-input-field{min-width:140px}.share-data__collaborator-list .select{margin-right:1.1rem;min-width:13.8rem}.share-data__collaborator-list .select--selected{padding:.4375rem 1.09375rem}.share-data__collaborator-list .select--selected:after{top:-4px}.share-data__collaborator-list .select__item{padding:.4375rem 1.09375rem}.share-data__collaborator-list__remove{background:0;border:0;cursor:pointer;margin-top:.3rem}.share-data__collaborator-list__remove svg{height:2rem;pointer-events:none;width:2rem}.share-data__scroll{height:280px;overflow-y:scroll}.share-data__strong{font-weight:500}.share-data__add-collaborator .btn.btn--secondary:disabled{cursor:not-allowed;color:#d1cfd1;background-color:#f0eff0;box-shadow:unset}.share-data__chk-associated-resources,.share-data__error-alert-msg{margin-top:3rem;margin-bottom:2rem}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(ShareDataComponent, [{
        type: Component,
        args: [{
                selector: "lib-share-data",
                templateUrl: "./share-data.component.html",
                styleUrls: ["./share-data.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.Default,
            }]
    }], function () { return [{ type: ElementRef }, { type: FormBuilder }, { type: DomSanitizer }]; }, { projectTitle: [{
            type: Input
        }], inputLabel: [{
            type: Input
        }], inputPlaceholder: [{
            type: Input
        }], userListTitle: [{
            type: Input
        }], optionalMessageLabel: [{
            type: Input
        }], optionalMessagePlaceholder: [{
            type: Input
        }], optionalMessageHint: [{
            type: Input
        }], optionalMessageMaxSize: [{
            type: Input
        }], userList: [{
            type: Input
        }], permissionOptions: [{
            type: Input
        }], alertMsg: [{
            type: Input
        }], errorMsg: [{
            type: Input
        }], includeAssociatedResources: [{
            type: Input,
            args: ["includeAssociatedResources"]
        }], associateResourceMessage: [{
            type: Input
        }], allowAddUser: [{
            type: Input
        }], outputDataChange: [{
            type: Output
        }] });

class FormFieldsModule {
}
/** @nocollapse */ FormFieldsModule.ngModuleDef = ɵɵdefineNgModule({ type: FormFieldsModule });
/** @nocollapse */ FormFieldsModule.ngInjectorDef = ɵɵdefineInjector({ factory: function FormFieldsModule_Factory(t) { return new (t || FormFieldsModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(FormFieldsModule, { declarations: [FormFieldsComponent], imports: [CommonModule], exports: [FormFieldsComponent] });
/*@__PURE__*/ ɵsetClassMetadata(FormFieldsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [FormFieldsComponent],
                exports: [FormFieldsComponent]
            }]
    }], null, null);

class InputModule {
}
/** @nocollapse */ InputModule.ngModuleDef = ɵɵdefineNgModule({ type: InputModule });
/** @nocollapse */ InputModule.ngInjectorDef = ɵɵdefineInjector({ factory: function InputModule_Factory(t) { return new (t || InputModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(InputModule, { declarations: [InputComponent], imports: [CommonModule], exports: [InputComponent] });
/*@__PURE__*/ ɵsetClassMetadata(InputModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [InputComponent],
                exports: [InputComponent]
            }]
    }], null, null);

class ShareDataModule {
}
/** @nocollapse */ ShareDataModule.ngModuleDef = ɵɵdefineNgModule({ type: ShareDataModule });
/** @nocollapse */ ShareDataModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ShareDataModule_Factory(t) { return new (t || ShareDataModule)(); }, imports: [[
            ReactiveFormsModule,
            CommonModule,
            SelectModule,
            FormsModule,
            ErrorAlertMessageModule,
            FormFieldsModule,
            InputModule,
            OverlayscrollbarsModule,
            RadioCheckboxModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ShareDataModule, { declarations: [ShareDataComponent], imports: [ReactiveFormsModule,
        CommonModule,
        SelectModule,
        FormsModule,
        ErrorAlertMessageModule,
        FormFieldsModule,
        InputModule,
        OverlayscrollbarsModule,
        RadioCheckboxModule], exports: [ShareDataComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ShareDataModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ReactiveFormsModule,
                    CommonModule,
                    SelectModule,
                    FormsModule,
                    ErrorAlertMessageModule,
                    FormFieldsModule,
                    InputModule,
                    OverlayscrollbarsModule,
                    RadioCheckboxModule
                ],
                declarations: [ShareDataComponent],
                exports: [ShareDataComponent]
            }]
    }], null, null);

class MessageService {
    constructor() {
        this.subject = new Subject();
    }
    sendMessage(message, data) {
        this.subject.next({ text: message, data });
    }
    clearMessages() {
        this.subject.next();
    }
    getMessage() {
        return this.subject.asObservable();
    }
}
/** @nocollapse */ MessageService.ngInjectableDef = ɵɵdefineInjectable({ token: MessageService, factory: function MessageService_Factory(t) { return new (t || MessageService)(); }, providedIn: 'root' });
/*@__PURE__*/ ɵsetClassMetadata(MessageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null);

const _c0$m = ["menuButton"];
const _c1$m = ["role", "presentation", 1, "ag-cell-label-container"];
const _c2$j = ["ref", "eLabel", "role", "presentation", "unselectable", "on", 1, "ag-header-cell-label"];
const _c3$j = ["ref", "eText", "role", "columnheader", "unselectable", "on", "aria-colindex", "1", 1, "ag-header-cell-text", 3, "ngClass"];
const _c4$i = ["menuButton", ""];
const _c5$i = ["class", "ag-header-cell-text__sort", 4, "ngIf"];
const _c6$h = [4, "ngIf"];
const _c7$g = [1, "ag-header-cell-text__sort-drop"];
const _c8$g = ["icon", "", "lib-icon-btn", "", "iconType", "close", 3, "click", 4, "ngIf"];
const _c9$g = ["ref", "eFilter", "aria-hidden", "true", 1, "ag-header-icon", "ag-filter-icon", "ag-hidden"];
const _c10$f = ["unselectable", "on", 1, "ag-icon", "ag-icon-filter"];
const _c11$d = [1, "ag-header-cell-text__sort"];
const _c12$c = ["icon", "", "lib-icon-btn", "", "iconType", "sort-up", 3, "ngClass", "click"];
const _c13$b = ["icon", "", "lib-icon-btn", "", "iconType", "sort-down", 3, "ngClass", "click"];
const _c14$a = function (a0, a1) { return { active: a0, show: a1 }; };
function CustomHeaderComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r561 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", _c11$d);
    ɵɵelementStart(1, "button", _c12$c);
    ɵɵlistener("click", function CustomHeaderComponent_span_4_Template_button_click_1_listener($event) { ɵɵrestoreView(_r561); const ctx_r560 = ɵɵnextContext(); return ctx_r560.onSortRequest("asc", $event); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "button", _c13$b);
    ɵɵlistener("click", function CustomHeaderComponent_span_4_Template_button_click_2_listener($event) { ɵɵrestoreView(_r561); const ctx_r562 = ɵɵnextContext(); return ctx_r562.onSortRequest("desc", $event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r556 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(2, _c14$a, ctx_r556.activeSort === "asc", ctx_r556.activeSort));
    ɵɵselect(2);
    ɵɵproperty("ngClass", ɵɵpureFunction2(5, _c14$a, ctx_r556.activeSort === "desc", ctx_r556.activeSort));
} }
const _c15$9 = [1, "ag-header-cell-text__title", 3, "ngClass", "title", "click"];
const _c16$8 = ["popoverType", "info", "popoverSize", "medium", "popoverPlacement", "right", 4, "ngIf"];
const _c17$8 = ["class", "ag-header-cell-text__filter", 3, "click", 4, "ngIf"];
const _c18$8 = ["popoverType", "info", "popoverSize", "medium", "popoverPlacement", "right"];
function CustomHeaderComponent_ng_container_5_lib_popover_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "lib-popover", _c18$8);
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r563 = ɵɵnextContext(2);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r563.params.infoPopoverContent, " ");
} }
const _c19$7 = [1, "ag-header-cell-text__filter", 3, "click"];
const _c20$7 = ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "12px", "height", "12px", "viewBox", "0 0 12 12", "version", "1.1"];
const _c21$7 = ["id", "filter", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"];
const _c22$7 = ["fill", "#FFFFFF", "x", "0", "y", "0", "width", "12", "height", "12"];
const _c23$7 = ["d", "M6.57142857,10.8571429 C6.625,10.8571429 6.68080357,10.8459821 6.73883929,10.8236607 C6.91294643,10.7477679 7,10.6160714 7,10.4285714 L7,10.4285714 L7,5.45982143 L10.3013393,2.15848214 C10.4397321,2.02901786 10.4709821,1.87276786 10.3950893,1.68973214 C10.3191964,1.515625 10.1875,1.42857143 10,1.42857143 L10,1.42857143 L1.42857143,1.42857143 C1.24107143,1.42857143 1.109375,1.515625 1.03348214,1.68973214 C0.957589286,1.87276786 0.988839286,2.02901786 1.12723214,2.15848214 L1.12723214,2.15848214 L4.42857143,5.45982143 L4.42857143,8.71428571 C4.42857143,8.83035714 4.47098214,8.93080357 4.55580357,9.015625 L4.55580357,9.015625 L6.27008929,10.7299107 C6.35044643,10.8147321 6.45089286,10.8571429 6.57142857,10.8571429 Z", "id", "\uF0B0", "fill", "#656066", "fill-rule", "nonzero"];
function CustomHeaderComponent_ng_container_5_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r566 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", _c19$7);
    ɵɵlistener("click", function CustomHeaderComponent_ng_container_5_span_4_Template_span_click_0_listener($event) { ɵɵrestoreView(_r566); const ctx_r565 = ɵɵnextContext(2); return ctx_r565.onMenuClicked($event); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c20$7);
    ɵɵelementStart(2, "title");
    ɵɵtext(3, "filter");
    ɵɵelementEnd();
    ɵɵelementStart(4, "g", _c21$7);
    ɵɵelement(5, "rect", _c22$7);
    ɵɵelement(6, "path", _c23$7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c24$6 = function (a0, a1) { return { "active-filter": a0, "has-filter": a1 }; };
function CustomHeaderComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r568 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "span", _c15$9);
    ɵɵlistener("click", function CustomHeaderComponent_ng_container_5_Template_span_click_1_listener($event) { ɵɵrestoreView(_r568); const ctx_r567 = ɵɵnextContext(); return ctx_r567.onMenuClicked($event); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, CustomHeaderComponent_ng_container_5_lib_popover_3_Template, 3, 1, "lib-popover", _c16$8);
    ɵɵtemplate(4, CustomHeaderComponent_ng_container_5_span_4_Template, 7, 0, "span", _c17$8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r557 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(5, _c24$6, ctx_r557.activeFilter || ctx_r557.activeSort, ctx_r557.colDef.sortable || ctx_r557.hasFilter))("title", ctx_r557.headerName);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r557.headerName, " ");
    ɵɵselect(3);
    ɵɵproperty("ngIf", ctx_r557.params.infoPopoverContent);
    ɵɵselect(4);
    ɵɵproperty("ngIf", ctx_r557.hasFilter);
} }
const _c25$6 = ["popoverTriggerEvents", "mouseenter:mouseleave", "popoverPlacement", "auto", "class", "ag-header-cell-text__title", 3, "popoverLabel", "ngClass", "click", 4, "ngIf"];
const _c26$6 = ["class", "ag-header-cell-text__title", 3, "ngClass", "title", "click", 4, "ngIf"];
const _c27$6 = ["popoverTriggerEvents", "mouseenter:mouseleave", "popoverPlacement", "auto", 1, "ag-header-cell-text__title", 3, "popoverLabel", "ngClass", "click"];
function CustomHeaderComponent_ng_container_6_lib_popover_1_Template(rf, ctx) { if (rf & 1) {
    const _r572 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-popover", _c27$6);
    ɵɵlistener("click", function CustomHeaderComponent_ng_container_6_lib_popover_1_Template_lib_popover_click_0_listener($event) { ɵɵrestoreView(_r572); const ctx_r571 = ɵɵnextContext(2); return ctx_r571.onMenuClicked($event); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r569 = ɵɵnextContext(2);
    ɵɵproperty("popoverLabel", ctx_r569.headerName)("ngClass", ɵɵpureFunction2(3, _c24$6, ctx_r569.activeFilter || ctx_r569.activeSort, ctx_r569.colDef.sortable || ctx_r569.hasFilter));
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r569.headerName, " ");
} }
function CustomHeaderComponent_ng_container_6_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r574 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", _c15$9);
    ɵɵlistener("click", function CustomHeaderComponent_ng_container_6_span_2_Template_span_click_0_listener($event) { ɵɵrestoreView(_r574); const ctx_r573 = ɵɵnextContext(2); return ctx_r573.onMenuClicked($event); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r570 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction2(3, _c24$6, ctx_r570.activeFilter || ctx_r570.activeSort, ctx_r570.colDef.sortable || ctx_r570.hasFilter))("title", ctx_r570.headerName);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r570.headerName, " ");
} }
function CustomHeaderComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, CustomHeaderComponent_ng_container_6_lib_popover_1_Template, 3, 6, "lib-popover", _c25$6);
    ɵɵtemplate(2, CustomHeaderComponent_ng_container_6_span_2_Template, 2, 6, "span", _c26$6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r558 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngIf", ctx_r558.overflow);
    ɵɵselect(2);
    ɵɵproperty("ngIf", !ctx_r558.overflow);
} }
const _c28$6 = ["icon", "", "lib-icon-btn", "", "iconType", "close", 3, "click"];
function CustomHeaderComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r576 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c28$6);
    ɵɵlistener("click", function CustomHeaderComponent_button_8_Template_button_click_0_listener($event) { ɵɵrestoreView(_r576); const ctx_r575 = ɵɵnextContext(); return ctx_r575.onDropFiltersSort($event); });
    ɵɵelementEnd();
} }
const _c29$5 = function (a0) { return { active: a0 }; };
class CustomHeaderComponent {
    constructor(messageService, element) {
        this.messageService = messageService;
        this.element = element;
    }
    get hasFilter() {
        return this.colDef && (this.colDef.filterActive || this.colDef.dateRangeFilterActive);
    }
    agInit(params) {
        this.params = params;
        this.colDef = params.column.getColDef();
        this.setActiveSort();
        const filterValue = get(this.params.api.getFilterModel(), `${this.params.column.getColId()}.value`);
        this.headerName = filterValue || this.params.displayName;
        this.setActiveFilter();
    }
    ngAfterViewInit() {
        this.messageServiceSubscription = this.messageService
            .getMessage()
            .subscribe(({ text, data }) => {
            if (text === "headerNameUpdated") {
                const colId = this.params.column.getColId();
                const filterModel = this.params.api.getFilterModel();
                const filterValue = get(filterModel, `${colId}.displayName`);
                const filterFromValue = get(filterModel, `${colId}.fromValue`);
                const filterToValue = get(filterModel, `${colId}.toValue`);
                if (filterValue) { // if filter value option set
                    this.headerName = filterValue;
                }
                else if (filterFromValue && filterToValue) { // if filter date range set
                    this.headerName = `${this.formatDate(filterFromValue)} - ${this.formatDate(filterToValue)}`;
                }
                else {
                    this.headerName = this.params.displayName;
                }
            }
            this.setActiveFilter();
            if (text === "orderingUpdated") {
                this.setActiveSort();
            }
            // Default overflow to false first
            this.overflow = false;
            // Wait until event cycle finishes to detect if overflow occurs
            setTimeout(() => {
                // Get the title header
                // Compare scroll width and offset width to check if text overflowed
                const headerSpan = this.element.nativeElement.querySelector("span.ag-header-cell-text__title");
                if (headerSpan) {
                    this.overflow = headerSpan.scrollWidth > headerSpan.offsetWidth;
                }
            }, 0);
        });
    }
    onMenuClicked(event) {
        if (this.colDef.sortable === true || this.hasFilter) {
            this.params.showColumnMenu(this.menuButton.nativeElement);
        }
    }
    onSortRequest(order, event) {
        // enforce single column sorting only
        const newSortModel = [
            {
                colId: this.params.column.getColId(),
                sort: order
            }
        ];
        this.params.api.setSortModel(newSortModel);
        this.setActiveSort();
    }
    onDropFiltersSort(event) {
        // only clear either sort or filter model to prevent 2 api calls
        const filterModel = this.params.api.getFilterModel();
        if (get(filterModel, this.params.column.getColId())) {
            // clear current filter
            const updatedFilterModel = omit(filterModel, this.params.column.getColId());
            this.params.api.setFilterModel(updatedFilterModel);
        }
        else if (this.activeSort) {
            // clear sort
            this.params.api.setSortModel(null);
        }
        this.headerName = this.params.displayName;
        this.setActiveSort();
        this.setActiveFilter();
    }
    ngOnDestroy() {
        if (this.messageServiceSubscription &&
            typeof this.messageServiceSubscription.unsubscribe === "function") {
            this.messageServiceSubscription.unsubscribe();
        }
    }
    setActiveSort() {
        this.activeSort = this.params.column.getSort();
    }
    setActiveFilter() {
        this.activeFilter = this.headerName !== this.params.displayName;
    }
    // Formats date as string YYYY-MM-DD
    formatDate(date) {
        let month = "" + (date.getMonth() + 1);
        let day = "" + date.getDate();
        const year = date.getFullYear();
        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }
        return [year, month, day].join("-");
    }
}
/** @nocollapse */ CustomHeaderComponent.ngComponentDef = ɵɵdefineComponent({ type: CustomHeaderComponent, selectors: [["lib-data-table-custom-header"]], factory: function CustomHeaderComponent_Factory(t) { return new (t || CustomHeaderComponent)(ɵɵdirectiveInject(MessageService), ɵɵdirectiveInject(ElementRef, 2)); }, viewQuery: function CustomHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$m, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.menuButton = _t.first);
    } }, consts: 11, vars: 7, template: function CustomHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$m);
        ɵɵelementStart(1, "div", _c2$j);
        ɵɵelementStart(2, "span", _c3$j, _c4$i);
        ɵɵtemplate(4, CustomHeaderComponent_span_4_Template, 3, 8, "span", _c5$i);
        ɵɵtemplate(5, CustomHeaderComponent_ng_container_5_Template, 5, 8, "ng-container", _c6$h);
        ɵɵtemplate(6, CustomHeaderComponent_ng_container_6_Template, 3, 2, "ng-container", _c6$h);
        ɵɵelementStart(7, "span", _c7$g);
        ɵɵtemplate(8, CustomHeaderComponent_button_8_Template, 1, 0, "button", _c8$g);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "span", _c9$g);
        ɵɵelement(10, "span", _c10$f);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(2);
        ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c29$5, ctx.activeFilter || ctx.activeSort));
        ɵɵselect(4);
        ɵɵproperty("ngIf", ctx.colDef.sortable || ctx.colDef.filterActive);
        ɵɵselect(5);
        ɵɵproperty("ngIf", !ctx.activeFilter);
        ɵɵselect(6);
        ɵɵproperty("ngIf", ctx.activeFilter);
        ɵɵselect(8);
        ɵɵproperty("ngIf", ctx.colDef.sortable || ctx.hasFilter);
    } }, directives: [NgClass, NgIf, IconButtonComponent, LibPopoverComponent], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]{width:100%}.ag-header-cell-text[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-wrap:nowrap;-webkit-box-pack:start;justify-content:flex-start;align-content:stretch;-webkit-box-align:center;align-items:center;position:relative;max-width:100%}.ag-header-cell-text__filter[_ngcontent-%COMP%]{padding-left:5px;padding-right:5px;padding-bottom:3px}.ag-header-cell-text__sort[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;left:-20px;position:absolute}.ag-header-cell-text__sort-drop[_ngcontent-%COMP%]{position:absolute;right:-20px}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon[_ngcontent-%COMP%]{height:8px;min-width:20px;visibility:hidden}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-up[_ngcontent-%COMP%]{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/arrow-down.svg);background-size:cover;background-repeat:no-repeat;background-position:center;-webkit-transform:rotate(180deg);transform:rotate(180deg);opacity:.4}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-up.active[_ngcontent-%COMP%], .ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-up[_ngcontent-%COMP%]:hover{opacity:1}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-up[_ngcontent-%COMP%]:focus{outline:0}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-down[_ngcontent-%COMP%]{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/arrow-down.svg);background-size:cover;background-repeat:no-repeat;background-position:center;opacity:.4}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-down.active[_ngcontent-%COMP%], .ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-down[_ngcontent-%COMP%]:hover{opacity:1}.ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon--sort-down[_ngcontent-%COMP%]:focus{outline:0}.ag-header-cell-text__title[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ag-header-cell-text__title.active-filter[_ngcontent-%COMP%]{text-decoration:underline;font-weight:700;color:#322d32}.ag-header-cell-text__title.active-filter[_ngcontent-%COMP%]     span{max-width:100%}.ag-header-cell-text__title.active-filter[_ngcontent-%COMP%]     span>button{max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-transform:uppercase}.ag-header-cell-text__title.active-filter[_ngcontent-%COMP%]     span>button:hover{-webkit-background-clip:unset;background-clip:unset;background-image:unset;color:unset;-webkit-text-fill-color:unset}.ag-header-cell-text__title.has-filter[_ngcontent-%COMP%]:hover{text-decoration:underline}.ag-header-cell-text__sort-drop[_ngcontent-%COMP%]   .btn--icon[_ngcontent-%COMP%]{height:20px;min-width:20px;visibility:hidden}.ag-header-cell-text__sort-drop[_ngcontent-%COMP%]   .btn--icon--close[_ngcontent-%COMP%]{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/close-small.svg);background-repeat:no-repeat;background-position:center;-webkit-transform:rotate(180deg);transform:rotate(180deg);opacity:.4}.ag-header-cell-text__sort-drop[_ngcontent-%COMP%]   .btn--icon--close.active[_ngcontent-%COMP%], .ag-header-cell-text__sort-drop[_ngcontent-%COMP%]   .btn--icon--close[_ngcontent-%COMP%]:hover{opacity:1}.ag-header-cell-text__sort-drop[_ngcontent-%COMP%]   .btn--icon--close[_ngcontent-%COMP%]:focus{outline:0}.ag-header-cell-text[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{-webkit-box-flex:0;flex:0 1 auto;-ms-grid-row-align:auto;align-self:auto}.ag-header-cell-text.active[_ngcontent-%COMP%]:hover   .ag-header-cell-text__sort[_ngcontent-%COMP%]   .btn--icon.show[_ngcontent-%COMP%], .ag-header-cell-text.active[_ngcontent-%COMP%]:hover   .ag-header-cell-text__sort-drop[_ngcontent-%COMP%]   .btn--icon[_ngcontent-%COMP%]{visibility:visible}"] });
/*@__PURE__*/ ɵsetClassMetadata(CustomHeaderComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-table-custom-header",
                templateUrl: "custom-header.component.html",
                styleUrls: ["custom-header.component.scss"]
            }]
    }], function () { return [{ type: MessageService }, { type: ElementRef, decorators: [{
                type: Self
            }] }]; }, { menuButton: [{
            type: ViewChild,
            args: ["menuButton", { read: ElementRef, static: true }]
        }] });

const _c0$n = [1, "data-table__content", 3, "title"];
class SpanCellRendererComponent {
    agInit(params) {
        this.params = params;
    }
    refresh() {
        return false;
    }
}
/** @nocollapse */ SpanCellRendererComponent.ngComponentDef = ɵɵdefineComponent({ type: SpanCellRendererComponent, selectors: [["lib-data-table-span"]], factory: function SpanCellRendererComponent_Factory(t) { return new (t || SpanCellRendererComponent)(); }, consts: 2, vars: 2, template: function SpanCellRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "span", _c0$n);
        ɵɵtext(1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("title", ctx.params.value);
        ɵɵselect(1);
        ɵɵtextInterpolate(ctx.params.value);
    } }, styles: ["[_nghost-%COMP%]{overflow:hidden;text-overflow:ellipsis}"] });
/*@__PURE__*/ ɵsetClassMetadata(SpanCellRendererComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-table-span",
                templateUrl: "./span-cell-renderer.component.html",
                styleUrls: ["./span-cell-renderer.component.scss"]
            }]
    }], null, null);

const _c0$o = [4, "ngIf", "ngIfThen", "ngIfElse"];
const _c1$n = ["routeWithHref", ""];
const _c2$k = ["routeLink", ""];
const _c3$k = ["noRoute", ""];
function LinkCellRendererComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c4$j = [1, "data-table__content"];
const _c5$j = [1, "data-table__content-link", 3, "href", "target"];
function LinkCellRendererComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c4$j);
    ɵɵelementStart(1, "a", _c5$j);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r579 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("href", ctx_r579.params.href, ɵɵsanitizeUrl)("target", ctx_r579.params.target ? ctx_r579.params.target : "_self");
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r579.params.value, " ");
} }
const _c6$i = ["href", "javascript:void(0)", 1, "data-table__content-link", 3, "routerLink", "target"];
function LinkCellRendererComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c4$j);
    ɵɵelementStart(1, "a", _c6$i);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r581 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("routerLink", ctx_r581.params.routerLinkParams)("target", ctx_r581.params.target ? ctx_r581.params.target : "_self");
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r581.params.value, " ");
} }
function LinkCellRendererComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c4$j);
    ɵɵelementStart(1, "a", _c6$i);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r583 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("routerLink", null)("target", ctx_r583.params.target ? ctx_r583.params.target : "_self");
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r583.params.value, " ");
} }
class LinkCellRendererComponent {
    agInit(params) {
        this.params = params;
    }
    refresh() {
        return false;
    }
}
/** @nocollapse */ LinkCellRendererComponent.ngComponentDef = ɵɵdefineComponent({ type: LinkCellRendererComponent, selectors: [["lib-data-table-link"]], factory: function LinkCellRendererComponent_Factory(t) { return new (t || LinkCellRendererComponent)(); }, consts: 7, vars: 3, template: function LinkCellRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, LinkCellRendererComponent_ng_container_0_Template, 1, 0, "ng-container", _c0$o);
        ɵɵtemplate(1, LinkCellRendererComponent_ng_template_1_Template, 3, 3, "ng-template", null, _c1$n, ɵɵtemplateRefExtractor);
        ɵɵtemplate(3, LinkCellRendererComponent_ng_template_3_Template, 3, 3, "ng-template", null, _c2$k, ɵɵtemplateRefExtractor);
        ɵɵtemplate(5, LinkCellRendererComponent_ng_template_5_Template, 3, 3, "ng-template", null, _c3$k, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r578 = ɵɵreference(2);
        const _r580 = ɵɵreference(4);
        const _r582 = ɵɵreference(6);
        ɵɵproperty("ngIf", ctx.params.href && ctx.params.routerLinkParams == null)("ngIfThen", _r578)("ngIfElse", ctx.params.routerLinkParams && ctx.params.href == null && _r580 || ctx.params.routerLinkParams == null && ctx.params.href == null && _r582);
    } }, directives: [NgIf, RouterLinkWithHref], styles: ["[_nghost-%COMP%]{overflow:hidden;text-overflow:ellipsis}"] });
/*@__PURE__*/ ɵsetClassMetadata(LinkCellRendererComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-table-link",
                templateUrl: "./link-cell-renderer.component.html",
                styleUrls: ["./link-cell-renderer.component.scss"]
            }]
    }], null, null);

const FILTER_DROPDOWN_POSITIONS = [{
        originX: "start",
        originY: "top",
        overlayX: "start",
        overlayY: "top"
    }, {
        originX: "start",
        originY: "top",
        overlayX: "start",
        overlayY: "bottom"
    }];

const _c0$p = ["parentDiv"];
const _c1$o = ["pickerContainer"];
const _c2$l = [1, "date-range-with-confirmation"];
const _c3$l = ["parentDiv", ""];
const _c4$k = ["type", "button", 1, "date-range-with-confirmation__toggle_button", 3, "ngClass", "click"];
const _c5$k = ["class", "date-range-with-confirmation__picker__container", 4, "ngIf"];
const _c6$j = [1, "date-range-with-confirmation__picker__container"];
const _c7$h = ["pickerContainer", ""];
const _c8$h = ["class", "date-range-with-confirmation__picker", 4, "ngIf"];
const _c9$h = [1, "date-range-with-confirmation__picker"];
const _c10$g = [1, "date-range-with-confirmation__picker__selected-dates"];
const _c11$e = [1, "date-range-with-confirmation__picker__selected-dates__from"];
const _c12$d = [1, "date-range-with-confirmation__picker__selected-dates__label"];
const _c13$c = [1, "date-range-with-confirmation__picker__selected-dates__value"];
const _c14$b = [1, "date-range-with-confirmation__picker__selected-dates__to"];
const _c15$a = [3, "bsConfig", "minDate", "maxDate", "datesDisabled", "isDisabled", "bsValue", "bsValueChange"];
const _c16$9 = [1, "date-range-with-confirmation__picker__confirmation_buttons"];
const _c17$9 = [1, "btn", "btn--secondary", 3, "click"];
const _c18$9 = [1, "btn", "btn--primary", 3, "disabled", "click"];
function DatePickerWithConfirmationComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r589 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c9$h);
    ɵɵelementStart(1, "div", _c10$g);
    ɵɵelementStart(2, "div", _c11$e);
    ɵɵelementStart(3, "span", _c12$d);
    ɵɵtext(4, "From");
    ɵɵelementEnd();
    ɵɵelementStart(5, "span", _c13$c);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", _c14$b);
    ɵɵelementStart(8, "span", _c12$d);
    ɵɵtext(9, "To");
    ɵɵelementEnd();
    ɵɵelementStart(10, "span", _c13$c);
    ɵɵtext(11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "bs-daterangepicker-inline", _c15$a);
    ɵɵlistener("bsValueChange", function DatePickerWithConfirmationComponent_div_4_div_2_Template_bs_daterangepicker_inline_bsValueChange_12_listener($event) { ɵɵrestoreView(_r589); const ctx_r588 = ɵɵnextContext(2); return ctx_r588.onValueChangeEvent($event); });
    ɵɵlistener("bsValueChange", function DatePickerWithConfirmationComponent_div_4_div_2_Template_bs_daterangepicker_inline_bsValueChange_12_listener($event) { ɵɵrestoreView(_r589); const ctx_r590 = ɵɵnextContext(2); return ctx_r590.bsRangeValue = $event; });
    ɵɵelementEnd();
    ɵɵelementStart(13, "div", _c16$9);
    ɵɵelementStart(14, "button", _c17$9);
    ɵɵlistener("click", function DatePickerWithConfirmationComponent_div_4_div_2_Template_button_click_14_listener($event) { ɵɵrestoreView(_r589); const ctx_r591 = ɵɵnextContext(2); ctx_r591.cancelDateRangeSelection(); return ctx_r591.hide(); });
    ɵɵtext(15, " Cancel ");
    ɵɵelementEnd();
    ɵɵelementStart(16, "button", _c18$9);
    ɵɵlistener("click", function DatePickerWithConfirmationComponent_div_4_div_2_Template_button_click_16_listener($event) { ɵɵrestoreView(_r589); const ctx_r592 = ɵɵnextContext(2); ctx_r592.applyDateRangeSelection(); return ctx_r592.hide(); });
    ɵɵtext(17, " Apply ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r587 = ɵɵnextContext(2);
    ɵɵselect(6);
    ɵɵtextInterpolate(ctx_r587.fromDate);
    ɵɵselect(11);
    ɵɵtextInterpolate(ctx_r587.toDate);
    ɵɵselect(12);
    ɵɵproperty("bsConfig", ctx_r587.bsConfig)("minDate", ctx_r587.minDate)("maxDate", ctx_r587.maxDate)("datesDisabled", ctx_r587.datesDisabled)("isDisabled", ctx_r587.isDisabled)("bsValue", ctx_r587.bsRangeValue);
    ɵɵattribute("id", ctx_r587.inputConfig.id)("type", ctx_r587.inputConfig.type)("placeholder", ctx_r587.inputConfig.placeholder);
    ɵɵselect(16);
    ɵɵproperty("disabled", !ctx_r587.candidateValue);
} }
function DatePickerWithConfirmationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c6$j, _c7$h);
    ɵɵtemplate(2, DatePickerWithConfirmationComponent_div_4_div_2_Template, 18, 12, "div", _c8$h);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r585 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r585.isShown);
} }
const _c19$8 = function (a0, a1) { return { "date-range-with-confirmation__toggle_button__enabled": a0, "date-range-with-confirmation__toggle_button__disabled": a1 }; };
class DatePickerWithConfirmationComponent {
    constructor(changeDetectorRef, renderer) {
        this.changeDetectorRef = changeDetectorRef;
        this.renderer = renderer;
        this.hideOnScroll = false;
        this.isDisabled = false;
        this.outsideClick = false;
        this.placement = "bottom";
        this.onShown = new EventEmitter();
        this.onHidden = new EventEmitter();
        this.bsValueChange = new EventEmitter();
        this.fromDate = "";
        this.toDate = "";
        this.addPickerContainer = false;
        this.isShown = false; // Only set to true when picker container is ready to avoid flashes
        if (!this.outsideClick) {
            this.renderer.listen("window", "click", (event) => {
                if (!this.parentDiv.nativeElement.contains(event.target) &&
                    (this.pickerContainer && !this.pickerContainer.nativeElement.contains(event.target))) {
                    this.hide();
                }
            });
        }
    }
    ngOnInit() { }
    show() {
        if (this.isShown) {
            return;
        }
        this.addPickerContainer = true;
        setTimeout(() => {
            // appending to body so the picker is seen on top of everything
            document.body.appendChild(this.pickerContainer.nativeElement);
            positionElements(this.parentDiv.nativeElement, this.pickerContainer.nativeElement, this.placement);
            this.isShown = true;
            this.changeDetectorRef.detectChanges();
        });
        this.onShown.emit();
    }
    hide() {
        if (!this.isShown) {
            return;
        }
        this.cancelDateRangeSelection();
        this.addPickerContainer = false;
        if (this.pickerContainer) {
            document.body.removeChild(this.pickerContainer.nativeElement);
        }
        this.isShown = false;
        this.onHidden.emit();
    }
    toggle() {
        if (this.isShown) {
            this.hide();
        }
        else {
            this.show();
        }
    }
    clear() {
        this.bsRangeValue = null;
        this.currentValue = null;
        this.setDateStrings(null);
    }
    onValueChangeEvent($event) {
        if ($event === undefined || $event === null) {
            return;
        }
        this.candidateValue = $event;
        this.setDateStrings($event);
    }
    cancelDateRangeSelection() {
        this.bsRangeValue = this.currentValue;
        this.setDateStrings(this.currentValue);
        this.candidateValue = null;
    }
    applyDateRangeSelection() {
        this.currentValue = this.candidateValue;
        this.candidateValue = null;
        this.bsValueChange.emit(this.currentValue);
        this.setDateStrings(this.currentValue);
    }
    setDateStrings(dates) {
        if (dates) {
            this.fromDate = this.formatDateString(dates[0]);
            this.toDate = this.formatDateString(dates[1]);
        }
        else {
            this.fromDate = this.formatDateString(null);
            this.toDate = this.formatDateString(null);
        }
    }
    formatDateString(date) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        if (date) {
            return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
        }
        return null;
    }
}
/** @nocollapse */ DatePickerWithConfirmationComponent.ngComponentDef = ɵɵdefineComponent({ type: DatePickerWithConfirmationComponent, selectors: [["date-picker-with-confirmation"]], factory: function DatePickerWithConfirmationComponent_Factory(t) { return new (t || DatePickerWithConfirmationComponent)(ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(Renderer2)); }, viewQuery: function DatePickerWithConfirmationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$p, true);
        ɵɵviewQuery(_c1$o, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.parentDiv = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.pickerContainer = _t.first);
    } }, inputs: { bsConfig: "bsConfig", hideOnScroll: "hideOnScroll", minDate: "minDate", maxDate: "maxDate", daysDisabled: "daysDisabled", datesDisabled: "datesDisabled", isDisabled: "isDisabled", outsideClick: "outsideClick", placement: "placement", inputConfig: "inputConfig" }, outputs: { onShown: "onShown", onHidden: "onHidden", bsValueChange: "bsValueChange" }, consts: 5, vars: 5, template: function DatePickerWithConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c2$l, _c3$l);
        ɵɵelementStart(2, "button", _c4$k);
        ɵɵlistener("click", function DatePickerWithConfirmationComponent_Template_button_click_2_listener($event) { return ctx.toggle(); });
        ɵɵtext(3, " SELECT DATE RANGE ");
        ɵɵelementEnd();
        ɵɵtemplate(4, DatePickerWithConfirmationComponent_div_4_Template, 3, 1, "div", _c5$k);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(2);
        ɵɵproperty("ngClass", ɵɵpureFunction2(2, _c19$8, ctx.isShown, !ctx.isShown));
        ɵɵselect(4);
        ɵɵproperty("ngIf", ctx.addPickerContainer);
    } }, directives: [NgClass, NgIf, BsDaterangepickerInlineDirective], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.btn[_ngcontent-%COMP%]{background-color:#f0eff0;border:0;border-radius:50px;cursor:pointer;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;padding:8px 24px;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn[_ngcontent-%COMP%]:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn[_ngcontent-%COMP%]:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn[_ngcontent-%COMP%]:focus{box-shadow:none;outline:#7e8bf3 solid 4px}.btn[_ngcontent-%COMP%]:disabled{cursor:not-allowed;opacity:.4}.btn--secondary[_ngcontent-%COMP%]{background:0 0;color:#4e60ee;border:1px solid #4e60ee}.btn--secondary[_ngcontent-%COMP%]:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);border-color:transparent;color:#fff}.btn--secondary[_ngcontent-%COMP%]:hover:disabled{color:#4e60ee}.btn--secondary[_ngcontent-%COMP%]:active:not(:disabled){background:#4e60ee;border-color:transparent;color:#fff}.btn--secondary.btn--small[_ngcontent-%COMP%]{font-size:14px;padding:5px 19px}.btn--secondary.btn--disabled[_ngcontent-%COMP%]{opacity:.4}.btn--disabled[_ngcontent-%COMP%]{cursor:not-allowed}.btn--primary[_ngcontent-%COMP%]{background:linear-gradient(8.68deg,#225de6 -4.27%,#a664fd 116.09%);color:#fff}.btn--primary[_ngcontent-%COMP%]:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn--primary[_ngcontent-%COMP%]:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn--primary.btn--small[_ngcontent-%COMP%]{padding:5px 19px}.btn--primary.btn--disabled[_ngcontent-%COMP%]{opacity:.4}.btn--white[_ngcontent-%COMP%]{background:#fff;padding:7px 24px}.btn--white.btn--small[_ngcontent-%COMP%]{padding:5px 19px}.btn--white.btn--disabled[_ngcontent-%COMP%]{opacity:.4}.btn--tertiary[_ngcontent-%COMP%]{background:0 0;border:1px solid transparent;color:#4e60ee}.btn--tertiary[_ngcontent-%COMP%]:hover:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee}.btn--tertiary[_ngcontent-%COMP%]:active:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee;box-shadow:inset 0 0 0 1px #4e60ee}.btn--tertiary[_ngcontent-%COMP%]:focus:not(:disabled){border-color:#4e60ee}.btn--tertiary.btn--small[_ngcontent-%COMP%]{font-size:14px}.btn--tertiary.btn--disabled[_ngcontent-%COMP%]{opacity:.4}.btn--link[_ngcontent-%COMP%], .btn--link[_ngcontent-%COMP%]:not([href]){background:0 0;color:#4e60ee!important}.btn--link[_ngcontent-%COMP%]:hover:not(:disabled), .btn--link[_ngcontent-%COMP%]:not([href]):hover:not(:disabled){background:0 0;color:#4e60ee;text-decoration:underline}.btn--link[_ngcontent-%COMP%]:active, .btn--link[_ngcontent-%COMP%]:not([href]):active{background:0 0}.btn--link.btn--small[_ngcontent-%COMP%], .btn--link[_ngcontent-%COMP%]:not([href]).btn--small{font-size:14px}.btn--link.btn--disabled[_ngcontent-%COMP%], .btn--link[_ngcontent-%COMP%]:not([href]).btn--disabled{opacity:.4}.date-range-with-confirmation[_ngcontent-%COMP%]{position:relative}.date-range-with-confirmation__toggle_button[_ngcontent-%COMP%]{font-size:12px;border:none;background:0 0;margin-bottom:12px}.date-range-with-confirmation__toggle_button__enabled[_ngcontent-%COMP%]{color:#225de6}.date-range-with-confirmation__toggle_button__disabled[_ngcontent-%COMP%]{color:#322d32}.date-range-with-confirmation__picker[_ngcontent-%COMP%]{position:relative}.date-range-with-confirmation__picker__container[_ngcontent-%COMP%]{position:absolute;z-index:9999;top:200px;right:200px}.date-range-with-confirmation__picker__selected-dates[_ngcontent-%COMP%]{position:absolute;display:-webkit-box;display:flex;top:16px;z-index:9999}.date-range-with-confirmation__picker__selected-dates__label[_ngcontent-%COMP%]{color:#656066;padding-left:10px}.date-range-with-confirmation__picker__selected-dates__value[_ngcontent-%COMP%]{border:1px solid;border-radius:4px;width:330px;height:40px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;padding-left:10px}.date-range-with-confirmation__picker__selected-dates__from[_ngcontent-%COMP%]{position:relative;display:-ms-grid;display:grid;row-gap:5px;left:20px}.date-range-with-confirmation__picker__selected-dates__to[_ngcontent-%COMP%]{position:relative;display:-ms-grid;display:grid;row-gap:5px;left:75px}.date-range-with-confirmation__picker__confirmation_buttons[_ngcontent-%COMP%]{position:absolute;display:-webkit-box;display:flex;gap:2rem;z-index:9999;bottom:16px;left:525px}"] });
/*@__PURE__*/ ɵsetClassMetadata(DatePickerWithConfirmationComponent, [{
        type: Component,
        args: [{
                selector: 'date-picker-with-confirmation',
                templateUrl: './date-picker-with-confirmation.component.html',
                styleUrls: ['./date-picker-with-confirmation.component.scss']
            }]
    }], function () { return [{ type: ChangeDetectorRef }, { type: Renderer2 }]; }, { bsConfig: [{
            type: Input
        }], hideOnScroll: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], daysDisabled: [{
            type: Input
        }], datesDisabled: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], outsideClick: [{
            type: Input
        }], placement: [{
            type: Input
        }], inputConfig: [{
            type: Input
        }], onShown: [{
            type: Output
        }], onHidden: [{
            type: Output
        }], bsValueChange: [{
            type: Output
        }], parentDiv: [{
            type: ViewChild,
            args: ["parentDiv", { static: false }]
        }], pickerContainer: [{
            type: ViewChild,
            args: ["pickerContainer", { static: false }]
        }] });

const _c0$q = [3, "formGroup"];
const _c1$p = [3, "label", "hint", "ngClass", 4, "ngIf"];
const _c2$m = [4, "ngIf"];
const _c3$m = [3, "label", "hint", "ngClass"];
const _c4$l = ["bsDatepicker", "", "lib-input", "", "formControlName", "date", "onkeydown", "return false", 3, "bsConfig", "minDate", "maxDate", "daysDisabled", "datesDisabled", "isDisabled", "outsideClick", "placement", "bsValue", "onShown", "onHidden", "bsValueChange"];
const _c5$l = ["dp", "bsDatepicker"];
const _c6$k = function (a0) { return { "date-range-select": a0 }; };
function DateRangeComponent_lib_form_field_1_Template(rf, ctx) { if (rf & 1) {
    const _r598 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-form-field", _c3$m);
    ɵɵelementStart(1, "input", _c4$l, _c5$l);
    ɵɵlistener("onShown", function DateRangeComponent_lib_form_field_1_Template_input_onShown_1_listener($event) { ɵɵrestoreView(_r598); const ctx_r597 = ɵɵnextContext(); return ctx_r597.onShownEvent($event); });
    ɵɵlistener("onHidden", function DateRangeComponent_lib_form_field_1_Template_input_onHidden_1_listener($event) { ɵɵrestoreView(_r598); const ctx_r599 = ɵɵnextContext(); return ctx_r599.onHideEvent($event); });
    ɵɵlistener("bsValueChange", function DateRangeComponent_lib_form_field_1_Template_input_bsValueChange_1_listener($event) { ɵɵrestoreView(_r598); const ctx_r600 = ɵɵnextContext(); return ctx_r600.onValueChangeEvent($event); });
    ɵɵlistener("bsValueChange", function DateRangeComponent_lib_form_field_1_Template_input_bsValueChange_1_listener($event) { ɵɵrestoreView(_r598); const ctx_r601 = ɵɵnextContext(); return ctx_r601.bsValue = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r593 = ɵɵnextContext();
    ɵɵproperty("label", ctx_r593.inputConfig.label)("hint", ctx_r593.inputConfig.hint)("ngClass", ɵɵpureFunction1(16, _c6$k, ctx_r593.selectMode));
    ɵɵattribute("for", ctx_r593.inputConfig.id);
    ɵɵselect(1);
    ɵɵproperty("bsConfig", ctx_r593.configs)("minDate", ctx_r593.minDate)("maxDate", ctx_r593.maxDate)("daysDisabled", ctx_r593.daysDisabled)("datesDisabled", ctx_r593.disabledDates)("isDisabled", ctx_r593.isDisabled)("outsideClick", ctx_r593.outsideClick)("placement", ctx_r593.placement)("bsValue", ctx_r593.bsValue);
    ɵɵattribute("id", ctx_r593.inputConfig.id)("type", ctx_r593.inputConfig.type)("placeholder", ctx_r593.inputConfig.placeholder);
} }
const _c7$i = ["bsDaterangepicker", "", "lib-input", "", "formControlName", "range", "onkeydown", "return false", 3, "bsConfig", "minDate", "maxDate", "datesDisabled", "isDisabled", "outsideClick", "placement", "bsValue", "onShown", "onHidden", "bsValueChange"];
function DateRangeComponent_lib_form_field_2_Template(rf, ctx) { if (rf & 1) {
    const _r603 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-form-field", _c3$m);
    ɵɵelementStart(1, "input", _c7$i);
    ɵɵlistener("onShown", function DateRangeComponent_lib_form_field_2_Template_input_onShown_1_listener($event) { ɵɵrestoreView(_r603); const ctx_r602 = ɵɵnextContext(); return ctx_r602.onShownEvent($event); });
    ɵɵlistener("onHidden", function DateRangeComponent_lib_form_field_2_Template_input_onHidden_1_listener($event) { ɵɵrestoreView(_r603); const ctx_r604 = ɵɵnextContext(); return ctx_r604.onHideEvent($event); });
    ɵɵlistener("bsValueChange", function DateRangeComponent_lib_form_field_2_Template_input_bsValueChange_1_listener($event) { ɵɵrestoreView(_r603); const ctx_r605 = ɵɵnextContext(); return ctx_r605.onValueChangeEvent($event); });
    ɵɵlistener("bsValueChange", function DateRangeComponent_lib_form_field_2_Template_input_bsValueChange_1_listener($event) { ɵɵrestoreView(_r603); const ctx_r606 = ɵɵnextContext(); return ctx_r606.bsRangeValue = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r594 = ɵɵnextContext();
    ɵɵproperty("label", ctx_r594.inputConfig.label)("hint", ctx_r594.inputConfig.hint)("ngClass", ɵɵpureFunction1(15, _c6$k, ctx_r594.selectMode));
    ɵɵattribute("for", ctx_r594.inputConfig.id);
    ɵɵselect(1);
    ɵɵproperty("bsConfig", ctx_r594.configs)("minDate", ctx_r594.minDate)("maxDate", ctx_r594.maxDate)("datesDisabled", ctx_r594.disabledDates)("isDisabled", ctx_r594.isDisabled)("outsideClick", ctx_r594.outsideClick)("placement", ctx_r594.placement)("bsValue", ctx_r594.bsRangeValue);
    ɵɵattribute("id", ctx_r594.inputConfig.id)("type", ctx_r594.inputConfig.type)("placeholder", ctx_r594.inputConfig.placeholder);
} }
const _c8$i = [3, "bsConfig", "minDate", "maxDate", "datesDisabled", "isDisabled", "placement", "inputConfig", "onShown", "onHidden", "bsValueChange"];
function DateRangeComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r608 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "date-picker-with-confirmation", _c8$i);
    ɵɵlistener("onShown", function DateRangeComponent_div_3_Template_date_picker_with_confirmation_onShown_1_listener($event) { ɵɵrestoreView(_r608); const ctx_r607 = ɵɵnextContext(); return ctx_r607.onShownEvent($event); });
    ɵɵlistener("onHidden", function DateRangeComponent_div_3_Template_date_picker_with_confirmation_onHidden_1_listener($event) { ɵɵrestoreView(_r608); const ctx_r609 = ɵɵnextContext(); return ctx_r609.onHideEvent($event); });
    ɵɵlistener("bsValueChange", function DateRangeComponent_div_3_Template_date_picker_with_confirmation_bsValueChange_1_listener($event) { ɵɵrestoreView(_r608); const ctx_r610 = ɵɵnextContext(); return ctx_r610.onValueChangeEvent($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r595 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("bsConfig", ctx_r595.configs)("minDate", ctx_r595.minDate)("maxDate", ctx_r595.maxDate)("datesDisabled", ctx_r595.disabledDates)("isDisabled", ctx_r595.isDisabled)("placement", ctx_r595.placement)("inputConfig", ctx_r595.inputConfig);
} }
class DateRangeComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.hideOnScroll = false;
        this.isDisabled = false;
        this.outsideClick = false;
        this.placement = "bottom";
        this.isDateRange = false;
        this.withConfirmation = false;
        this.initDatePickerValue = "";
        this.initDateRangeValue = "";
        this.selectMode = false;
        // ────────────────────────────────────────────────────────────────────────────────
        // Output
        this.shown = new EventEmitter();
        this.hidden = new EventEmitter();
        this.valueChange = new EventEmitter();
        this.dateRangeMinMode = "day";
    }
    onScrollEvent() {
        if (!this.hideOnScroll) {
            return;
        }
        this.datepicker.hide();
        this.dateRangePicker.hide();
        this.dateRangePickerWithConfirmation.hide();
    }
    ngOnInit() {
        this.configs = Object.assign(this.configs, {
            minMode: this.dateRangeMinMode,
            customTodayClass: 'custom-today-class'
        });
        this.datePickerForm = this.formBuilder.group({
            date: [this.initDatePickerValue],
            range: [this.initDateRangeValue]
        });
    }
    show() {
        if (this.isDateRange) {
            if (this.withConfirmation) {
                this.dateRangePickerWithConfirmation.show();
            }
            else {
                this.dateRangePicker.show();
            }
        }
        else {
            this.datepicker.show();
        }
    }
    hide() {
        if (this.isDateRange) {
            if (this.withConfirmation) {
                this.dateRangePickerWithConfirmation.hide();
            }
            else {
                this.dateRangePicker.hide();
            }
        }
        else {
            this.datepicker.hide();
        }
    }
    toggle() {
        if (this.isDateRange) {
            if (this.withConfirmation) {
                this.dateRangePickerWithConfirmation.toggle();
            }
            else {
                this.dateRangePicker.toggle();
            }
        }
        else {
            this.datepicker.toggle();
        }
    }
    clear() {
        this.bsValue = null;
        this.bsRangeValue = null;
        this.dateRangePickerWithConfirmation.clear();
    }
    onShownEvent($event) {
        this.shown.emit($event);
    }
    onHideEvent($event) {
        this.hidden.emit($event);
    }
    onValueChangeEvent($event) {
        this.valueChange.emit($event);
    }
}
/** @nocollapse */ DateRangeComponent.ngComponentDef = ɵɵdefineComponent({ type: DateRangeComponent, selectors: [["lib-date-range"]], factory: function DateRangeComponent_Factory(t) { return new (t || DateRangeComponent)(ɵɵdirectiveInject(FormBuilder)); }, viewQuery: function DateRangeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(BsDatepickerDirective, true);
        ɵɵviewQuery(BsDaterangepickerDirective, true);
        ɵɵviewQuery(DatePickerWithConfirmationComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.datepicker = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dateRangePicker = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dateRangePickerWithConfirmation = _t.first);
    } }, hostBindings: function DateRangeComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("scroll", function DateRangeComponent_scroll_HostBindingHandler($event) { return ctx.onScrollEvent(); }, false, ɵɵresolveWindow);
    } }, inputs: { configs: "configs", hideOnScroll: "hideOnScroll", minDate: "minDate", maxDate: "maxDate", daysDisabled: "daysDisabled", disabledDates: "disabledDates", isDisabled: "isDisabled", outsideClick: "outsideClick", placement: "placement", isDateRange: "isDateRange", withConfirmation: "withConfirmation", initDatePickerValue: "initDatePickerValue", initDateRangeValue: "initDateRangeValue", selectMode: "selectMode", inputConfig: "inputConfig" }, outputs: { shown: "shown", hidden: "hidden", valueChange: "valueChange" }, consts: 4, vars: 4, template: function DateRangeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "form", _c0$q);
        ɵɵtemplate(1, DateRangeComponent_lib_form_field_1_Template, 3, 18, "lib-form-field", _c1$p);
        ɵɵtemplate(2, DateRangeComponent_lib_form_field_2_Template, 2, 17, "lib-form-field", _c1$p);
        ɵɵtemplate(3, DateRangeComponent_div_3_Template, 2, 7, "div", _c2$m);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.datePickerForm);
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.isDateRange && !ctx.withConfirmation);
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.isDateRange && !ctx.withConfirmation);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.isDateRange && ctx.withConfirmation);
    } }, styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.bs-datepicker-body table td span.selected::after,.bs-datepicker-body table td.selected span::after,.bs-datepicker-body table.days span.in-range.is-highlighted:not(.select-end)::after,.bs-datepicker-body table.days span.in-range.select-end::after,.bs-datepicker-body table.days span.select-start::after{display:block;position:absolute;content:\"\";background-image:linear-gradient(45deg,#5487fd 0,#a664fd 121%);z-index:-1;width:3rem;height:3rem;border-radius:50%}.bs-datepicker-body table.days span.in-range:not(.select-end):not(.is-highlighted)::after{display:block;position:absolute;content:\"\";z-index:-2;width:100%;height:3rem;background-color:#d1cfd1}.bs-datepicker-body table.days span.select-start::before{background-color:#d1cfd1;display:block;position:absolute;left:50%;content:\"\";z-index:-2;width:50%;height:3rem}.bs-datepicker-body table.days span.in-range.is-highlighted:not(.select-end)::before,.bs-datepicker-body table.days span.in-range.select-end::before{background-color:#d1cfd1;display:block;position:absolute;left:0;content:\"\";z-index:-2;width:50%;height:3rem}.bs-datepicker-body table td span.is-highlighted:not(.disabled):not(.selected):not(.in-range)::before,.bs-datepicker-body table td.is-highlighted:not(.disabled):not(.selected) span::before{display:block;position:absolute;content:\"\";background-color:#918d91;z-index:-1;width:3rem;height:3rem;border-radius:50%}.date-range-select .input-field__container{border-style:solid;border-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#d1cfd1,#d1cfd1)}.date-range-select .input-field__container:hover{border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.date-range-select .input-field__container:after{content:\"\";position:absolute;width:2rem;height:2rem;background-repeat:no-repeat;background-size:contain;background-position:center;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/arrow-down.svg);top:.4rem;right:.3rem}.date-range-select .input-field__container .input-field__text-input{font-size:1.4rem;line-height:1.4285714286;padding:.4rem 3rem .4rem 1rem}.date-range-select .input-field__container .input-field__text-input::-webkit-input-placeholder{color:#322d32}.date-range-select .input-field__container .input-field__text-input::-moz-placeholder{color:#322d32}.date-range-select .input-field__container .input-field__text-input:-ms-input-placeholder{color:#322d32}.date-range-select .input-field__container .input-field__text-input::-ms-input-placeholder{color:#322d32}.date-range-select .input-field__container .input-field__text-input::placeholder{color:#322d32}.date-range-select .input-field__container .input-field__text-input,.date-range-select .input-field__container .input-field__text-input:focus,.date-range-select .input-field__container .input-field__text-input:focus:active,.date-range-select .input-field__container .input-field__text-input:hover{border-bottom:none}.bs-datepicker{display:-webkit-box;display:flex;-webkit-box-align:stretch;align-items:stretch;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-flow:row wrap;background:#fff;box-shadow:0 2rem 2rem 0 rgba(0,0,0,.2);position:relative;z-index:1}.bs-datepicker bs-datepicker-navigation-view{-webkit-box-align:center;align-items:center;display:-ms-grid;display:grid;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;position:relative;-ms-grid-columns:([col-start] 1fr)[4];grid-template-columns:repeat(4,[col-start] 1fr)}.bs-datepicker button:active,.bs-datepicker button:focus,.bs-datepicker button:hover,.bs-datepicker input:active,.bs-datepicker input:focus,.bs-datepicker input:hover,.bs-datepicker-btns button:active,.bs-datepicker-btns button:focus,.bs-datepicker-btns button:hover,.bs-datepicker-predefined-btns button:active,.bs-datepicker-predefined-btns button:focus{outline:0}.bs-datepicker-head{min-width:27rem;height:6.3rem;padding:1rem;border-radius:.3rem .3rem 0 0;text-align:justify}.bs-datepicker-head button{display:inline-block;vertical-align:top;padding:0;height:3rem;line-height:3rem;border:0;background:0 0;text-align:center;cursor:pointer;color:#000;-webkit-transition:.3s;transition:.3s}.bs-datepicker-head button.next,.bs-datepicker-head button.previous{border-radius:50%;width:1.8rem;-ms-grid-row:1;grid-row:1;height:3rem;background-repeat:no-repeat;background-size:contain;background-position:center;margin:0 .6rem}.bs-datepicker-head button.next{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/arrow-right.svg);-ms-grid-column:4;grid-column:4;position:absolute;right:0;top:0}.bs-datepicker-head button.previous{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/arrow-left.svg);-ms-grid-column:1;grid-column:1}.bs-datepicker-head button.next span,.bs-datepicker-head button.previous span{display:none;font-size:3rem;line-height:1;position:relative;height:100%;text-align:center;border-radius:50%}.bs-datepicker-head button.current{cursor:default;font-size:1.4rem;-ms-grid-row:1;grid-row:1;letter-spacing:.04rem;line-height:1.4285714286;padding:0 .15rem;pointer-events:none;-ms-grid-column:2;grid-column:2;text-align:right}.bs-datepicker-head button.current:nth-child(2){-ms-grid-column:3;grid-column:3;text-align:left}.bs-datepicker-body{padding:0;min-height:28.8rem;min-width:35rem}.bs-datepicker-body .days.weeks{position:relative;z-index:1}.bs-datepicker-body .days.weeks th{overflow:hidden}.bs-datepicker-body table{width:100%;border-collapse:separate;border-spacing:0}.bs-datepicker-body table th{border-radius:0;color:#333;font-size:1.4rem;width:3rem;max-width:3rem;max-height:3rem;letter-spacing:3rem;line-height:1.4285714286;padding-bottom:1.6rem;text-align:center;vertical-align:middle;text-indent:1.9rem;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bs-datepicker-body table td{border-radius:0;color:#322d32;font-size:1.4rem;height:4.8rem;padding:0;letter-spacing:.04rem;line-height:1.4285714286;text-align:center;vertical-align:middle}.bs-datepicker-body table td span{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;border-radius:50%;-webkit-box-pack:center;justify-content:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bs-datepicker-body table td span.custom-today-class:not(.select-start):not(.in-range)::before{border:1px solid #322d32;display:block;position:absolute;content:\"\";width:3rem;height:3rem;border-radius:50%}.bs-datepicker-body table td:not(.disabled):not(.week) span:not(.disabled):not(.is-other-month){cursor:pointer}.bs-datepicker-body table td span.is-highlighted:not(.disabled):not(.selected):not(.in-range),.bs-datepicker-body table td.is-highlighted:not(.disabled):not(.selected) span{color:#fff}.bs-datepicker-body table td span.is-active-other-month:not(.disabled):not(.selected),.bs-datepicker-body table td.is-active-other-month:not(.disabled):not(.selected) span{background-color:#e9edf0;-webkit-transition:none;transition:none;cursor:pointer}.bs-datepicker-body table td span.disabled,.bs-datepicker-body table td.disabled span{color:#9aaec1}.bs-datepicker-body table td span.selected,.bs-datepicker-body table td.selected span{color:#fff}.bs-datepicker-body table td span.is-other-month,.bs-datepicker-body table td.is-other-month span{color:rgba(0,0,0,.25)}.bs-datepicker-body table td.active{position:relative}.bs-datepicker-body table td.active.select-start:before{left:35%}.bs-datepicker-body table td.active.select-end:before{left:-85%}.bs-datepicker-body table td span.active.select-end:after,.bs-datepicker-body table td span.active.select-start:after,.bs-datepicker-body table td.active.select-end span:after,.bs-datepicker-body table td.active.select-start span:after{content:\"\";display:block;position:absolute;z-index:-1;width:100%;height:100%;-webkit-transition:.3s;transition:.3s;top:0;border-radius:50%}.bs-datepicker-body table td.active.select-start+td.active:before{left:-20%}.bs-datepicker-body table td:last-child.active:before{border-radius:0 .3rem .3rem 0;width:125%;left:-25%}.bs-datepicker-body table td span[class*=select-],.bs-datepicker-body table td[class*=select-] span{border-radius:50%;color:#fff}.bs-datepicker-body table.days td.active:not(.select-start):before,.bs-datepicker-body table.days td.in-range:not(.select-start):before{background:#e9edf0}.bs-datepicker-body table.days span{width:100%;height:100%;line-height:2.4rem}.bs-datepicker-body table.days span.in-range.is-highlighted:not(.select-end){color:#fff}.bs-datepicker-body table.days span.active:not(.select-start):before,.bs-datepicker-body table.days span.in-range:not(.select-end):before,.bs-datepicker-body table.days span.in-range:not(.select-start):before{box-shadow:inset 7.3rem 0 0 -2.2rem #d1cfd1}.bs-datepicker-body table.days span.select-start{z-index:2}.bs-datepicker-body table.days td.active+td.is-highlighted:before,.bs-datepicker-body table.days td.active+td.select-end:before,.bs-datepicker-body table.days td.in-range+td.is-highlighted:before,.bs-datepicker-body table.days td.in-range+td.select-end:before,.bs-datepicker-body table.days td.select-start+td.is-highlighted:before,.bs-datepicker-body table.days td.select-start+td.select-end:before{background:#e9edf0;width:100%}.bs-datepicker-body table.weeks tr td:nth-child(2).active:before{border-radius:.3rem 0 0 .3rem;left:0;width:100%}.bs-datepicker-body table:not(.weeks) tr td:first-child:before{border-radius:.3rem 0 0 .3rem}.bs-datepicker-body table.years td span{width:4.6rem;height:4.6rem;line-height:4.5rem;margin:0 auto}.bs-datepicker-body table.years tr:not(:last-child) td span{margin-bottom:.8rem}.bs-datepicker-body table.months td{height:5.2rem}.bs-datepicker-body table.months td span{padding:.6rem;border-radius:1.5rem}.bs-datepicker .current-timedate{color:#54708b;font-size:1.5rem;text-align:center;height:3rem;line-height:3rem;border-radius:2rem;border:1px solid #e9edf0;margin-bottom:1rem;cursor:pointer;text-transform:uppercase;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.bs-datepicker .current-timedate span:not(:empty):before{content:\"\";width:1.5rem;height:1.6rem;display:inline-block;margin-right:.4rem;vertical-align:text-bottom;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAABMklEQVQoU9VTwW3CQBCcOUgBtEBKSAukAnBKME+wFCAlYIhk8sQlxFABtJAScAsuAPBEewYcxCP8ouxrPDsza61uiVN1o6RNHD4htSCmq49RfO71BvMJqBBkITRf1kmUW49nQRC9h1I5AZlBClaL8aP1fKgOOxCx8aSLs+Q19eZuNO8QmPqJRtDFguy7OAcDbJPs+/BKVPDIPrvD2ZJgWAmVe7O0rI0Vqs1seyWUXpuJoppYCa5L+U++NpNPkr5OE2oMdARsb3gykJT5ydZcL8Z9Ww60nxg2LhjON9li9OwXZzo+xLbp3nC2s9CL2RrueGyVrgwNm8HpsCzZ9EEW6kqXlo1GQe03FzP/7W8Hl0dBtu7Bf7zt6mIwvX1RvzDCm7+q3mAW0Dl/GPdUCeXrZLT9BrDrGkm4qlPvAAAAAElFTkSuQmCC)}.bs-datepicker-multiple{border-radius:.4rem 0 0 .4rem}.bs-datepicker-multiple+.bs-datepicker-multiple{margin-left:4rem}.bs-datepicker-multiple .bs-datepicker{box-shadow:none;position:relative}.bs-datepicker-multiple .bs-datepicker:not(:last-child){padding-right:1rem}.bs-datepicker-multiple .bs-datepicker+.bs-datepicker:after{content:\"\";display:block;width:1.4rem;height:1rem;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKCAYAAABrGwT5AAAA1ElEQVQoU42RsQrCUAxF77VuDu7O4oMWW//BURBBpZvgKk4uIrjoqKOTf+DopIO4uYggtFTfw3+pkQqCW1/G5J7kJiFy4m5MxUlxAzgIPHX+lzMPzupRYlYgxiR7vqsOP8YKzsTx0yxFMCUZ+q7aZzlr+OvgoWcAFyAHgat2jLWu48252DdqAihDJGSSJNUUxYmQjs3+hPQBlAh2rG2LCOPnaw3IiGDX99TRCs7ASJsNhUOA7d/LcuHvRG22FIZvsNXw1MX6VZExCilOQKEfeLXr/10+aC9Ho7arh7oAAAAASUVORK5CYII=);position:absolute;top:2.5rem;left:-.8rem}.bs-datepicker-multiple .bs-datepicker .left{float:left}.bs-datepicker-multiple .bs-datepicker .right{float:right}.bs-datepicker-container{padding:0}.bs-datepicker .bs-media-container{display:-webkit-box;display:flex;padding:0 .6rem .6rem}@media (max-width:768px){.bs-datepicker .bs-media-container{-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}}.bs-datepicker-custom-range{padding:1.5rem;background:#eee}.bs-datepicker-predefined-btns button{width:100%;display:block;height:3rem;background-color:#9aaec1;border-radius:.4rem;color:#fff;border:0;margin-bottom:1rem;padding:0 1.8rem;text-align:left;-webkit-transition:.3s;transition:.3s}.bs-datepicker-predefined-btns button:active,.bs-datepicker-predefined-btns button:hover{background-color:#54708b}.bs-datepicker-buttons{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-flow:row wrap;-webkit-box-pack:end;justify-content:flex-end;padding-top:1rem;border-top:1px solid #e9edf0}.bs-datepicker-buttons .btn-default{margin-left:1rem}.bs-timepicker-container{padding:1rem 0}.bs-timepicker-label{color:#54708b;margin-bottom:1rem}.bs-timepicker-controls{display:inline-block;vertical-align:top;margin-right:1rem}.bs-timepicker-controls button{width:2rem;height:2rem;border-radius:50%;border:0;background-color:#e9edf0;color:#54708b;font-size:1.6rem;font-weight:700;vertical-align:middle;line-height:0;padding:0;-webkit-transition:.3s;transition:.3s}.bs-timepicker-controls button:hover{background-color:#d5dadd}.bs-timepicker-controls input{width:3.5rem;height:2.5rem;border-radius:1.3rem;text-align:center;border:1px solid #e9edf0}.bs-timepicker .switch-time-format{text-transform:uppercase;min-width:5.4rem;height:2.5rem;border-radius:2rem;border:1px solid #e9edf0;background:#fff;color:#54708b;font-size:1.3rem}.bs-timepicker .switch-time-format img{vertical-align:initial;margin-left:.4rem}bs-datepicker-container,bs-daterangepicker-container{top:1px!important;z-index:9999}@media (max-width:768px){.bs-datepicker-multiple{display:-webkit-box;display:flex}.bs-datepicker-multiple+.bs-datepicker-multiple{margin-top:1rem;margin-left:0}}.date-range-with-confirmation__picker .bs-datepicker{height:580px;align-content:center}.date-range-with-confirmation__picker .bs-datepicker-container{padding-top:24px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(DateRangeComponent, [{
        type: Component,
        args: [{
                selector: "lib-date-range",
                templateUrl: "./date-range.component.html",
                styleUrls: ["./date-range.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: FormBuilder }]; }, { configs: [{
            type: Input
        }], hideOnScroll: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], daysDisabled: [{
            type: Input
        }], disabledDates: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], outsideClick: [{
            type: Input
        }], placement: [{
            type: Input
        }], isDateRange: [{
            type: Input
        }], withConfirmation: [{
            type: Input
        }], initDatePickerValue: [{
            type: Input
        }], initDateRangeValue: [{
            type: Input
        }], selectMode: [{
            type: Input
        }], shown: [{
            type: Output
        }], hidden: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], inputConfig: [{
            type: Input
        }], datepicker: [{
            type: ViewChild,
            args: [BsDatepickerDirective, { static: false }]
        }], dateRangePicker: [{
            type: ViewChild,
            args: [BsDaterangepickerDirective, { static: false }]
        }], dateRangePickerWithConfirmation: [{
            type: ViewChild,
            args: [DatePickerWithConfirmationComponent, { static: false }]
        }], onScrollEvent: [{
            type: HostListener,
            args: ["window:scroll"]
        }] });

const _c0$r = ["filterOptionList"];
const _c1$q = ["dateRange"];
const _c2$n = ["input"];
const _c3$n = ["filterTextField"];
const _c4$m = [1, "lib-custom-filter-holder"];
const _c5$m = ["dropdown", ""];
const _c6$l = [3, "reference", "positions", "config", "customClass"];
const _c7$j = ["dropdownFilter", ""];
const _c8$j = [1, "drop-down"];
const _c9$i = [1, "drop-down__title", "text-center", "text-uppercase", 3, "click"];
const _c10$h = ["class", "drop-down__sort", 4, "ngIf"];
const _c11$f = [4, "ngIf"];
const _c12$e = ["class", "filter-user-input-box", 4, "ngIf"];
const _c13$d = ["class", "drop-down__filter-options", 3, "ngClass", 4, "ngIf"];
const _c14$c = ["class", "drop-down__filter-date-range", 4, "ngIf"];
const _c15$b = [1, "drop-down__sort"];
const _c16$a = ["icon", "", "lib-icon-btn", "", "iconType", "sort-up", 1, "mr-4", 3, "ngClass", "click"];
const _c17$a = ["icon", "", "lib-icon-btn", "", "iconType", "sort-down", 1, "ml-4", 3, "ngClass", "click"];
const _c18$a = function (a0) { return { active: a0 }; };
function CustomFilterComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r620 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c15$b);
    ɵɵelementStart(1, "button", _c16$a);
    ɵɵlistener("click", function CustomFilterComponent_div_7_Template_button_click_1_listener($event) { ɵɵrestoreView(_r620); const ctx_r619 = ɵɵnextContext(); return ctx_r619.onSortRequest("asc", $event); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "button", _c17$a);
    ɵɵlistener("click", function CustomFilterComponent_div_7_Template_button_click_2_listener($event) { ɵɵrestoreView(_r620); const ctx_r621 = ɵɵnextContext(); return ctx_r621.onSortRequest("desc", $event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r613 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c18$a, ctx_r613.activeSort === "asc"));
    ɵɵselect(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(4, _c18$a, ctx_r613.activeSort === "desc"));
} }
function CustomFilterComponent_hr_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr");
} }
const _c19$9 = [1, "filter-user-input-box"];
const _c20$8 = ["placeholder", "Filter ...", 1, "filter-user-input", 3, "ngModel", "ngModelChange"];
const _c21$8 = ["filterTextField", ""];
function CustomFilterComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r624 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c19$9);
    ɵɵelementStart(1, "input", _c20$8, _c21$8);
    ɵɵlistener("ngModelChange", function CustomFilterComponent_div_9_Template_input_ngModelChange_1_listener($event) { ɵɵrestoreView(_r624); const ctx_r623 = ɵɵnextContext(); return ctx_r623.onChangeInputValue($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r615 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngModel", ctx_r615.searchBoxInput);
} }
const _c22$8 = [1, "drop-down__filter-options", 3, "ngClass"];
const _c23$8 = ["filterOptionList", ""];
const _c24$7 = [1, "drop-down__filter-options__list"];
const _c25$7 = ["class", "drop-down__filter-options__item", 3, "title", "ngClass", "click", 4, "ngFor", "ngForOf"];
const _c26$7 = [1, "drop-down__filter-options__item", 3, "title", "ngClass", "click"];
const _c27$7 = function (a0) { return { "active-option": a0 }; };
function CustomFilterComponent_overlay_scrollbars_10_ng_container_3_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r631 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c26$7);
    ɵɵlistener("click", function CustomFilterComponent_overlay_scrollbars_10_ng_container_3_li_1_Template_li_click_0_listener($event) { ɵɵrestoreView(_r631); const filterItem_r629 = ctx.$implicit; const ctx_r630 = ɵɵnextContext(3); return ctx_r630.onChange(filterItem_r629); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const filterItem_r629 = ctx.$implicit;
    const ctx_r628 = ɵɵnextContext(3);
    ɵɵpropertyInterpolate("title", filterItem_r629.displayName);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c27$7, ctx_r628.text === filterItem_r629.displayName));
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", filterItem_r629.displayName, " ");
} }
function CustomFilterComponent_overlay_scrollbars_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, CustomFilterComponent_overlay_scrollbars_10_ng_container_3_li_1_Template, 2, 5, "li", _c25$7);
    ɵɵpipe(2, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r626 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(2, 1, ctx_r626.filterDisplayOptions$));
} }
const _c28$7 = ["title", "No results found", 1, "drop-down__filter-options__non-clickable-item"];
function CustomFilterComponent_overlay_scrollbars_10_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "li", _c28$7);
    ɵɵelementStart(2, "b");
    ɵɵtext(3, "No results found");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function CustomFilterComponent_overlay_scrollbars_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "overlay-scrollbars", _c22$8, _c23$8);
    ɵɵelementStart(2, "ul", _c24$7);
    ɵɵtemplate(3, CustomFilterComponent_overlay_scrollbars_10_ng_container_3_Template, 3, 3, "ng-container", _c11$f);
    ɵɵpipe(4, "async");
    ɵɵtemplate(5, CustomFilterComponent_overlay_scrollbars_10_ng_container_5_Template, 4, 0, "ng-container", _c11$f);
    ɵɵpipe(6, "async");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r616 = ɵɵnextContext();
    ɵɵproperty("ngClass", ctx_r616.getFilterListScrollClass());
    ɵɵselect(3);
    ɵɵproperty("ngIf", ɵɵpipeBind1(4, 3, ctx_r616.filterDisplayOptions$).length > 0);
    ɵɵselect(5);
    ɵɵproperty("ngIf", ɵɵpipeBind1(6, 5, ctx_r616.filterDisplayOptions$).length === 0);
} }
function CustomFilterComponent_hr_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr");
} }
const _c29$6 = [1, "drop-down__filter-date-range"];
const _c30$5 = [1, "drop-down__filter-date-range__picker", 3, "isDateRange", "withConfirmation", "selectMode", "isDisabled", "outsideClick", "placement", "inputConfig", "configs", "valueChange"];
const _c31$5 = ["dateRange", ""];
function CustomFilterComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r634 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c29$6);
    ɵɵelementStart(1, "lib-date-range", _c30$5, _c31$5);
    ɵɵlistener("valueChange", function CustomFilterComponent_div_12_Template_lib_date_range_valueChange_1_listener($event) { ɵɵrestoreView(_r634); const ctx_r633 = ɵɵnextContext(); return ctx_r633.onDateRangeChange($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r618 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("isDateRange", true)("withConfirmation", true)("selectMode", true)("isDisabled", false)("outsideClick", false)("placement", ctx_r618.dateRangePlacement)("inputConfig", ctx_r618.dateRangeInputConfig)("configs", ctx_r618.dateRangeConfigs);
} }
const _c32$5 = function (a4, a5) { return { minHeight: "93px", maxHeight: "340px", minWidth: "170px", maxWidth: "170px", height: a4, panelClass: a5 }; };
// https://www.ag-grid.com/javascript-grid-filter-component/#filter-component-interface-ifiltercomp
class CustomFilterComponent {
    constructor(messageService) {
        this.messageService = messageService;
        this.dropdownPositions = FILTER_DROPDOWN_POSITIONS;
        // Need to set a custom class for popups
        // https://www.ag-grid.com/angular-data-grid/component-filter/#custom-filters-containing-a-popup-element
        this.customClass = "ag-custom-component-popup";
        this.searchBoxInput = '';
        this.updatedUserInput = new Subject();
        this.text = "";
        this.selectedDateRange = null;
        this.filterAllOptions = []; // all options available
        this.filterDisplayOptions$ = new BehaviorSubject([]); // options that are actually visible to user
        this.panelClass = ["drop-down__filter"];
        this.dateRangeInputConfig = {};
        this.dateRangeConfigs = {
            showWeekNumbers: false,
            rangeInputFormat: "YYYY-MM-DD"
        };
        this._subs = new SubSink();
    }
    get dateRangePlacement() {
        // Default placement to bottom
        if (!this.colDef.dateRangeFilterOptions || !this.colDef.dateRangeFilterOptions.placement) {
            return "bottom";
        }
        return this.colDef.dateRangeFilterOptions.placement;
    }
    agInit(params) {
        this.params = params;
        this.colDef = this.params.colDef;
        this.valueGetter = params.valueGetter;
        if (this.params.rowModel.constructor.name === "ServerSideRowModel") {
            this.panelClass.push("server-side");
        }
        if (this.colDef.filterWithSearchBox) {
            // if callback provided then use it, other wise filter locally
            if (typeof this.colDef.updateFilterOptionsCallback === 'function') {
                this.debounceUserInputAndUpdateFilterOptionsAsync();
            }
            else {
                this.debounceUserInputAndUpdateFilterOptionsLocally();
            }
        }
        // Use provided filterOptions if available, otherwise collect filter options from data
        if (this.colDef.filterOptions) {
            this._subs.sink = this.colDef.filterOptions.subscribe((list) => {
                this.setFilterOptions(list);
            });
        }
        else {
            this.collectFilterOptionsFromData();
        }
        this.headerName = this.colDef.headerName;
    }
    collectFilterOptionsFromData() {
        // Note: this method only collects options available in the page when this method is called!
        const filterListItems = new Set();
        this.params.rowModel.forEachNode((rowData) => {
            const filterItem = get(rowData, `data.${this.colDef.field}`);
            if (filterItem) {
                filterListItems.add(filterItem);
            }
        });
        // Transform items from rows into filterOption objects
        const filterOptions = [...filterListItems].map(option => {
            return { displayName: option, filterValue: option };
        });
        this.setFilterOptions(filterOptions);
    }
    isFilterActive() {
        return this.text !== null && this.text !== undefined && this.text !== "";
    }
    doesFilterPass(params) {
        return this.text.toLowerCase()
            .split(" ")
            .every((filterWord) => {
            return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= 0;
        });
    }
    // Gets the filter state. If filter is not active, then should return null/undefined.
    // The grid calls getModel() on all active filters when gridApi.getFilterModel() is called.
    getModel() {
        if (this.selectedFilterOption) {
            return { value: this.selectedFilterOption.filterValue, displayName: this.selectedFilterOption.displayName };
        }
        if (this.selectedDateRange) {
            return { fromValue: this.selectedDateRange.filterFromValue, toValue: this.selectedDateRange.filterToValue };
        }
        return null;
    }
    setModel(model) {
        // model is undefined when filter is cleared or not active
        // When filter is cleared via Grid's filter api, the model is null.
        if (model == null) {
            this.text = "";
            this.selectedFilterOption = null;
            this.selectedDateRange = null;
            if (this.dateRange) {
                this.dateRange.clear();
            }
        }
        else if (model.filterValue != null) {
            this.selectedFilterOption = model;
        }
    }
    onChange(selectedFilterOption) {
        if (this.text !== selectedFilterOption.displayName) {
            this.text = selectedFilterOption.displayName;
            this.selectedFilterOption = selectedFilterOption;
            this.messageService.sendMessage("headerNameUpdated");
            this.params.filterChangedCallback({ sorting: false });
        }
        this.dropdown.hide();
    }
    onDateRangeChange($event) {
        if ($event) {
            this.selectedDateRange = {
                filterFromValue: $event[0],
                filterToValue: $event[1],
            };
            this.params.filterChangedCallback({ sorting: false });
            this.dropdown.hide();
        }
        else {
            this.selectedDateRange = null;
        }
        this.messageService.sendMessage("headerNameUpdated");
    }
    afterGuiAttached(params) {
        this.activeSort = this.params.column.getSort();
        setTimeout(() => this.dropdown.show(), 0);
        // put focus to search box
        if (this.colDef.filterWithSearchBox) {
            setTimeout(() => this.filterTextField.nativeElement.focus());
        }
    }
    onSortRequest(order, event) {
        this.activeSort = order;
        // enforce single column sorting only
        const newSortModel = [
            {
                colId: this.params.column.getColId(),
                sort: order
            }
        ];
        this.params.api.setSortModel(newSortModel);
        this.messageService.sendMessage("orderingUpdated");
        this.dropdown.hide();
    }
    ngOnDestroy() {
        this._subs.unsubscribe();
    }
    debounceUserInputAndUpdateFilterOptionsAsync() {
        this._subs.sink = this.updatedUserInput
            .pipe(debounceTime(500))
            .pipe(switchMap((updatedData) => {
            return this.colDef.updateFilterOptionsCallback(updatedData);
        }))
            .subscribe((updatedFilterOptions) => {
            this.setFilterOptions(updatedFilterOptions);
        });
    }
    debounceUserInputAndUpdateFilterOptionsLocally() {
        this._subs.sink = this.updatedUserInput
            .pipe(debounceTime(500))
            .subscribe(updatedData => {
            this.updateFilterOptions(updatedData);
        });
    }
    /* Method to update filter options locally based on user input and adjust height
     * TODO: improve logic.
     */
    updateFilterOptions(arg) {
        if (arg === '') {
            this.updateFilterDisplayOptions(this.filterAllOptions);
            return;
        }
        const filteredArray = this.filterAllOptions ?
            this.filterAllOptions.filter((item) => item.displayName.toLowerCase().includes(arg.toLowerCase()))
            : [];
        this.updateFilterDisplayOptions(filteredArray);
    }
    setFilterOptions(optionList) {
        if (isNullOrUndefined(optionList)) {
            return;
        }
        this.filterAllOptions = optionList;
        this.updateFilterDisplayOptions(optionList);
    }
    updateFilterDisplayOptions(filteredOptionList) {
        if (isNullOrUndefined(filteredOptionList)) {
            return;
        }
        this.filterDisplayOptions$.next(filteredOptionList);
    }
    onChangeInputValue(changedData) {
        this.updatedUserInput.next(changedData);
    }
    getFilterListScrollClass() {
        if (this.colDef.sortable) {
            return this.colDef.filterWithSearchBox ? 'sorting-search-filter-scroll' : 'sorting-simple-filter-scroll';
        }
        else {
            return this.colDef.filterWithSearchBox ? 'search-filter-scroll' : 'simple-filter-scroll';
        }
    }
}
/** @nocollapse */ CustomFilterComponent.ngComponentDef = ɵɵdefineComponent({ type: CustomFilterComponent, selectors: [["lib-custom-filter"]], factory: function CustomFilterComponent_Factory(t) { return new (t || CustomFilterComponent)(ɵɵdirectiveInject(MessageService)); }, viewQuery: function CustomFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(DropdownComponent, true);
        ɵɵviewQuery(_c0$r, true);
        ɵɵviewQuery(_c1$q, true);
        ɵɵstaticViewQuery(_c2$n, true, ViewContainerRef);
        ɵɵviewQuery(_c3$n, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dropdown = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.filterOptionList = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dateRange = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.input = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.filterTextField = _t.first);
    } }, consts: 13, vars: 14, template: function CustomFilterComponent_Template(rf, ctx) { if (rf & 1) {
        const _r635 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "div", _c4$m, _c5$m);
        ɵɵelementStart(2, "lib-dropdown", _c6$l, _c7$j);
        ɵɵelementStart(4, "div", _c8$j);
        ɵɵelementStart(5, "div", _c9$i);
        ɵɵlistener("click", function CustomFilterComponent_Template_div_click_5_listener($event) { ɵɵrestoreView(_r635); const _r612 = ɵɵreference(3); return _r612.hide(); });
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵtemplate(7, CustomFilterComponent_div_7_Template, 3, 6, "div", _c10$h);
        ɵɵtemplate(8, CustomFilterComponent_hr_8_Template, 1, 0, "hr", _c11$f);
        ɵɵtemplate(9, CustomFilterComponent_div_9_Template, 3, 1, "div", _c12$e);
        ɵɵtemplate(10, CustomFilterComponent_overlay_scrollbars_10_Template, 7, 7, "overlay-scrollbars", _c13$d);
        ɵɵtemplate(11, CustomFilterComponent_hr_11_Template, 1, 0, "hr", _c11$f);
        ɵɵtemplate(12, CustomFilterComponent_div_12_Template, 3, 8, "div", _c14$c);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r611 = ɵɵreference(1);
        ɵɵselect(2);
        ɵɵproperty("reference", _r611)("positions", ctx.dropdownPositions)("config", ɵɵpureFunction2(11, _c32$5, ctx.colDef.filterActive ? "auto" : ctx.colDef.dateRangeFilterActive ? "148px" : "93px", ctx.panelClass))("customClass", ctx.customClass);
        ɵɵselect(6);
        ɵɵtextInterpolate1(" ", ctx.colDef.headerName, " ");
        ɵɵselect(7);
        ɵɵproperty("ngIf", ctx.colDef.sortable);
        ɵɵselect(8);
        ɵɵproperty("ngIf", ctx.colDef.filterWithSearchBox);
        ɵɵselect(9);
        ɵɵproperty("ngIf", ctx.colDef.filterWithSearchBox);
        ɵɵselect(10);
        ɵɵproperty("ngIf", ctx.colDef.filterActive);
        ɵɵselect(11);
        ɵɵproperty("ngIf", ctx.colDef.dateRangeFilterActive);
        ɵɵselect(12);
        ɵɵproperty("ngIf", ctx.colDef.dateRangeFilterActive);
    } }, directives: [DropdownComponent, NgIf, IconButtonComponent, NgClass, DefaultValueAccessor, NgControlStatus, NgModel, OverlayScrollbarsComponent, NgForOf, DateRangeComponent], pipes: [AsyncPipe], styles: [".drop-down__filter-options__item,.drop-down__filter-options__item.active-option,.drop-down__filter-options__item:hover,.drop-down__filter-options__non-clickable-item,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.drop-down__filter-options__item,.drop-down__filter-options__item.active-option,.drop-down__filter-options__item:hover,.drop-down__filter-options__non-clickable-item{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.drop-down__filter-options__item,.drop-down__filter-options__non-clickable-item{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.container{border:2px solid #2f2;border-radius:5px;background-color:#bfb;width:200px;height:50px}.lib-custom-filter-holder{min-width:50px;min-height:50px}input{height:20px}.drop-down__filter{margin-top:-29px;left:-25%;position:relative!important}.drop-down__filter.server-side{margin-top:-9px;left:-20%}.drop-down__title{padding-top:12px;padding-bottom:12px;font-size:12px;line-height:1.17;text-align:right;font-weight:700}.drop-down__sort{padding-top:12px;padding-bottom:12px;width:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.drop-down__sort .btn--icon{height:30px;min-width:30px}.drop-down__sort .btn--icon--sort-up{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/sort-up.svg);background-repeat:no-repeat;background-position:center}.drop-down__sort .btn--icon--sort-up.active,.drop-down__sort .btn--icon--sort-up:hover{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/sort-up-gradient.svg);background-repeat:no-repeat;background-position:center}.drop-down__sort .btn--icon--sort-up:focus{outline:0}.drop-down__sort .btn--icon--sort-down{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/sort-down.svg);background-repeat:no-repeat;background-position:center}.drop-down__sort .btn--icon--sort-down.active,.drop-down__sort .btn--icon--sort-down:hover{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/sort-down-gradient.svg);background-repeat:no-repeat;background-position:center}.drop-down__sort .btn--icon--sort-down:focus{outline:0}.drop-down__filter-options{border-top-style:solid;border-top-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#d1cfd1,#d1cfd1);margin-top:0;min-height:46px}.drop-down__filter-options.sorting-search-filter-scroll{max-height:calc(100% - 150px)!important}.drop-down__filter-options.sorting-simple-filter-scroll{max-height:calc(100% - 92px)!important}.drop-down__filter-options.search-filter-scroll{max-height:calc(100% - 96px)!important}.drop-down__filter-options.simple-filter-scroll{max-height:calc(100% - 38px)!important}.drop-down__filter-options__list{padding:0 24px 0 30px;list-style:none;text-align:left}.drop-down__filter-options__item{padding-top:10px;padding-bottom:10px;position:relative;cursor:pointer}.drop-down__filter-options__item:hover{font-weight:700;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;color:transparent}.drop-down__filter-options__item.active-option:before{color:#656066;font-weight:400;content:\"L\";-webkit-transform:scaleX(-1) rotate(-39deg);transform:scaleX(-1) rotate(-39deg);position:absolute;left:-20px;display:inline-block;top:7px}.drop-down__filter-options__non-clickable-item{padding-top:10px;padding-bottom:10px;position:relative}.drop-down__filter-date-range{position:relative;text-align:center;padding:0 0 12px}.filter-user-input-box{padding:0 4% 4%}.filter-user-input{height:30px!important;padding:5%;width:100%;outline:0;border:1px solid #d3d3d3}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(CustomFilterComponent, [{
        type: Component,
        args: [{
                selector: "lib-custom-filter",
                templateUrl: "./custom-filter.component.html",
                styleUrls: ["./custom-filter.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: MessageService }]; }, { dropdown: [{
            type: ViewChild,
            args: [DropdownComponent, { static: true }]
        }], filterOptionList: [{
            type: ViewChild,
            args: ["filterOptionList", { static: false }]
        }], dateRange: [{
            type: ViewChild,
            args: ["dateRange", { static: false }]
        }], input: [{
            type: ViewChild,
            args: ["input", { read: ViewContainerRef, static: true }]
        }], filterTextField: [{
            type: ViewChild,
            args: ["filterTextField", { static: false }]
        }] });

var DataLoadingStatus;
(function (DataLoadingStatus) {
    DataLoadingStatus[DataLoadingStatus["Loading"] = 0] = "Loading";
    DataLoadingStatus[DataLoadingStatus["NoRows"] = 1] = "NoRows";
    DataLoadingStatus[DataLoadingStatus["RowsLoaded"] = 2] = "RowsLoaded";
})(DataLoadingStatus || (DataLoadingStatus = {}));
class DataTableApiService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.apiOrigin = "bssh.illumina.com";
        this.onDataChanged = new BehaviorSubject([]);
        this.dataLoadingStatus$ = new BehaviorSubject(DataLoadingStatus.Loading);
    }
    get dataChanged() {
        return this.onDataChanged.asObservable();
    }
    getData(requestOptions = {}, gridOptions = {}, api) {
        const { origin, path, params, preRequestParamsProcessing, postSuccessRequestCallback, postErrorRequestCallback, } = requestOptions;
        const { startRow, endRow, filterModel, sortModel } = gridOptions;
        const requestData = preRequestParamsProcessing(params, gridOptions, api);
        this.dataLoadingStatus$.next(DataLoadingStatus.Loading);
        return this.httpClient.get(`${origin || this.apiOrigin}/${path}`, { params: requestData }).pipe(map((response) => {
            const processedData = postSuccessRequestCallback(params, gridOptions, response, api);
            if (!processedData || !processedData.rowData || !processedData.rowData.length) {
                this.dataLoadingStatus$.next(DataLoadingStatus.NoRows);
            }
            else {
                this.dataLoadingStatus$.next(DataLoadingStatus.RowsLoaded);
            }
            this.onDataChanged.next(processedData);
            return processedData;
        }), catchError(err => {
            const error = postErrorRequestCallback(params, gridOptions, err, api);
            return throwError(error);
        }), share());
    }
}
/** @nocollapse */ DataTableApiService.ngInjectableDef = ɵɵdefineInjectable({ token: DataTableApiService, factory: function DataTableApiService_Factory(t) { return new (t || DataTableApiService)(ɵɵinject(HttpClient)); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(DataTableApiService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null);

class ServerSideDatasourceService {
    constructor() { }
    init(initOptions) {
        const { apiDriver, gridInstance, requestOptions } = initOptions;
        this.apiDriver = apiDriver;
        this.gridInstance = gridInstance;
        this.requestOptions = requestOptions;
        this.gridInstance.setServerSideDatasource(this);
    }
    getRows(params) {
        this.apiDriver.getData(this.requestOptions, params.request, this.gridInstance)
            .subscribe((data) => {
            if (Array.isArray(data.rowData)) {
                params.successCallback(data.rowData, data.lastRow);
            }
        }, (error) => {
            params.failCallback(error);
        });
        return this;
    }
}
/** @nocollapse */ ServerSideDatasourceService.ngInjectableDef = ɵɵdefineInjectable({ token: ServerSideDatasourceService, factory: function ServerSideDatasourceService_Factory(t) { return new (t || ServerSideDatasourceService)(); }, providedIn: null });
/*@__PURE__*/ ɵsetClassMetadata(ServerSideDatasourceService, [{
        type: Injectable
    }], function () { return []; }, null);

const _c0$s = ["class", "pagination", 4, "ngIf"];
const _c1$r = [1, "pagination"];
const _c2$o = [1, "pagination__button", 3, "ngClass", "click"];
const _c3$o = ["paginationFirst", ""];
const _c4$n = ["class", "pagination__button", 3, "ngClass", "click", 4, "ngIf"];
const _c5$n = ["class", "pagination__button", 3, "pagination__button--active", "click", 4, "ngFor", "ngForOf"];
const _c6$m = ["paginationLast", ""];
const _c7$k = ["paginationBack", ""];
const _c8$k = function (a0) { return { "pagination__button--disabled": a0 }; };
function PaginationComponent_div_0_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r644 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c2$o, _c7$k);
    ɵɵlistener("click", function PaginationComponent_div_0_a_4_Template_a_click_0_listener($event) { ɵɵrestoreView(_r644); const _r642 = ɵɵreference(1); const ctx_r643 = ɵɵnextContext(2); return ctx_r643.goToPrevX(_r642); });
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r638 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c8$k, ctx_r638.isPrevXDisabled));
    ɵɵselect(2);
    ɵɵtextInterpolate1(" Back ", ctx_r638.numberOfLinks, " ");
} }
const _c9$j = [1, "pagination__button", 3, "click"];
function PaginationComponent_div_0_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r647 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c9$j);
    ɵɵstyling();
    ɵɵlistener("click", function PaginationComponent_div_0_a_5_Template_a_click_0_listener($event) { ɵɵrestoreView(_r647); const number_r645 = ctx.$implicit; const ctx_r646 = ɵɵnextContext(2); return ctx_r646.goToPage(number_r645); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const number_r645 = ctx.$implicit;
    const ctx_r639 = ɵɵnextContext(2);
    ɵɵclassProp("pagination__button--active", number_r645 === ctx_r639.currentPage);
    ɵɵstylingApply();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", number_r645, " ");
} }
const _c10$i = ["paginationNext", ""];
function PaginationComponent_div_0_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r650 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c2$o, _c10$i);
    ɵɵlistener("click", function PaginationComponent_div_0_a_6_Template_a_click_0_listener($event) { ɵɵrestoreView(_r650); const _r648 = ɵɵreference(1); const ctx_r649 = ɵɵnextContext(2); return ctx_r649.goToNextX(_r648); });
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r640 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c8$k, ctx_r640.isNextXDisabled));
    ɵɵselect(2);
    ɵɵtextInterpolate1(" Next ", ctx_r640.numberOfLinks, " ");
} }
function PaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r652 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c1$r);
    ɵɵelementStart(1, "a", _c2$o, _c3$o);
    ɵɵlistener("click", function PaginationComponent_div_0_Template_a_click_1_listener($event) { ɵɵrestoreView(_r652); const _r637 = ɵɵreference(2); const ctx_r651 = ɵɵnextContext(); return ctx_r651.goToFirst(_r637); });
    ɵɵtext(3, " First ");
    ɵɵelementEnd();
    ɵɵtemplate(4, PaginationComponent_div_0_a_4_Template, 3, 4, "a", _c4$n);
    ɵɵtemplate(5, PaginationComponent_div_0_a_5_Template, 2, 2, "a", _c5$n);
    ɵɵtemplate(6, PaginationComponent_div_0_a_6_Template, 3, 4, "a", _c4$n);
    ɵɵelementStart(7, "a", _c2$o, _c6$m);
    ɵɵlistener("click", function PaginationComponent_div_0_Template_a_click_7_listener($event) { ɵɵrestoreView(_r652); const _r641 = ɵɵreference(8); const ctx_r653 = ɵɵnextContext(); return ctx_r653.goToLast(_r641); });
    ɵɵtext(9, " Last ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r636 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c8$k, ctx_r636.currentPage === 1));
    ɵɵselect(4);
    ɵɵproperty("ngIf", ctx_r636.isLong);
    ɵɵselect(5);
    ɵɵproperty("ngForOf", ctx_r636.numbers);
    ɵɵselect(6);
    ɵɵproperty("ngIf", ctx_r636.isLong);
    ɵɵselect(7);
    ɵɵproperty("ngClass", ɵɵpureFunction1(7, _c8$k, ctx_r636.currentPage === ctx_r636.totalPages));
} }
class PaginationComponent {
    constructor(ref) {
        this.ref = ref;
        this.numberOfLinks = 10;
        this.pageChanged = new EventEmitter();
    }
    marcForCheck() {
        this.ref.markForCheck();
    }
    ngOnInit() { }
    get numbers() {
        const result = [];
        const base = Math.ceil(this.currentPage / this.numberOfLinks);
        const start = (base - 1) * this.numberOfLinks + 1;
        const end = base * this.numberOfLinks > this.totalPages
            ? this.totalPages
            : base * this.numberOfLinks;
        for (let i = start; i <= end; i++) {
            result.push(i);
        }
        return result;
    }
    get isLong() {
        return this.totalPages > this.numberOfLinks;
    }
    get isPrevXDisabled() {
        return this.currentPage <= this.numberOfLinks;
    }
    get isNextXDisabled() {
        return (this.currentPage >
            (Math.ceil(this.totalPages / this.numberOfLinks) - 1) * this.numberOfLinks);
    }
    goToPage(page) {
        this.pageChanged.emit(page);
    }
    goToPrevX(element) {
        const prevPage = (Math.ceil(this.currentPage / this.numberOfLinks) - 2) *
            this.numberOfLinks +
            1;
        if (!this._isButtonDisabled(element)) {
            this.goToPage(prevPage);
        }
    }
    goToNextX(element) {
        const nextPage = Math.ceil(this.currentPage / this.numberOfLinks) * this.numberOfLinks + 1;
        if (!this._isButtonDisabled(element)) {
            this.goToPage(nextPage);
        }
    }
    goToFirst(element) {
        this.goToPage(1);
        if (!this._isButtonDisabled(element)) {
            this.goToPage(1);
        }
    }
    goToLast(element) {
        if (!this._isButtonDisabled(element)) {
            this.goToPage(this.totalPages);
        }
    }
    /**
     * Check for disabled class, used for logic checks to prevent interaction
     */
    _isButtonDisabled(element) {
        return element.classList.contains("pagination__button--disabled");
    }
}
/** @nocollapse */ PaginationComponent.ngComponentDef = ɵɵdefineComponent({ type: PaginationComponent, selectors: [["lib-pagination"]], factory: function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(ɵɵdirectiveInject(ChangeDetectorRef)); }, inputs: { numberOfLinks: "numberOfLinks", currentPage: "currentPage", totalPages: "totalPages" }, outputs: { pageChanged: "pageChanged" }, exportAs: ["libPagination"], consts: 1, vars: 1, template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, PaginationComponent_div_0_Template, 10, 9, "div", _c0$s);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.totalPages > 1);
    } }, directives: [NgIf, NgClass, NgForOf], styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.pagination{display:-webkit-box;display:flex;-webkit-box-align:stretch;align-items:stretch;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-wrap:nowrap;-webkit-box-pack:center;justify-content:center;margin-top:16px}.pagination__button{display:inline-block;font-size:16px;background:0;border:0;color:#5b575b;line-height:1.4;text-transform:capitalize;padding:5px 10px;position:relative;text-align:center;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pagination__button:not(:last-child){margin-right:8px}.pagination__button:not(.pagination__button--disabled){cursor:pointer}.pagination__button--active{color:#312d32;font-weight:500;text-decoration:none}.pagination__button--active:after{content:\"\";display:block;height:0;width:100%;left:0;border-radius:2px;border-top:2px solid #4e60ee;position:absolute;bottom:1px}.pagination__button:active:not(.pagination__button--disabled){color:#4e60ee;font-weight:500}.pagination__button--disabled:not(.pagination__button--active){color:#c1c0c2;cursor:not-allowed;pointer-events:none}.pagination__button:hover:not(.pagination__button--disabled):not(.pagination__button--active){color:#4e60ee}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: "lib-pagination",
                templateUrl: "./pagination.component.html",
                styleUrls: ["./pagination.component.scss"],
                exportAs: "libPagination",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ChangeDetectorRef }]; }, { numberOfLinks: [{
            type: Input
        }], currentPage: [{
            type: Input
        }], totalPages: [{
            type: Input
        }], pageChanged: [{
            type: Output
        }] });

const _c0$t = ["type", "text", 3, "lines"];
const _c1$s = ["loadingSpinner", ""];
// Customizing ag-grid overlay component
// https://www.ag-grid.com/javascript-grid-loading-cell-renderer/
class CustomCellLoadingRendererComponent {
    agInit(params) {
        this.params = params;
    }
    afterGuiAttached(params) {
    }
    refresh(params) {
        return true;
    }
}
/** @nocollapse */ CustomCellLoadingRendererComponent.ngComponentDef = ɵɵdefineComponent({ type: CustomCellLoadingRendererComponent, selectors: [["lib-custom-cell-loading-renderer"]], factory: function CustomCellLoadingRendererComponent_Factory(t) { return new (t || CustomCellLoadingRendererComponent)(); }, consts: 2, vars: 1, template: function CustomCellLoadingRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "lib-skeleton", _c0$t, _c1$s);
    } if (rf & 2) {
        ɵɵproperty("lines", 1);
    } }, directives: [SkeletonComponent], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(CustomCellLoadingRendererComponent, [{
        type: Component,
        args: [{
                selector: "lib-custom-cell-loading-renderer",
                template: `<lib-skeleton #loadingSpinner type="text" [lines]="1"></lib-skeleton>`,
                encapsulation: ViewEncapsulation.None
            }]
    }], null, null);

const _c0$u = ["loadingSpinner"];
const _c1$t = [3, "id", "loader", "spinner", "spinnerPosition"];
const _c2$p = ["loadingSpinner", ""];
// Customizing ag-grid overlay component
// https://www.ag-grid.com/javascript-grid-overlay-component/
class CustomLoadingOverlayComponent {
    constructor() { }
    agInit(params) {
        this.params = params;
        // start the spinnning action
        this.spinnerRef.start();
    }
}
/** @nocollapse */ CustomLoadingOverlayComponent.ngComponentDef = ɵɵdefineComponent({ type: CustomLoadingOverlayComponent, selectors: [["lib-custom-loading-overlay"]], factory: function CustomLoadingOverlayComponent_Factory(t) { return new (t || CustomLoadingOverlayComponent)(); }, viewQuery: function CustomLoadingOverlayComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$u, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.spinnerRef = _t.first);
    } }, consts: 2, vars: 4, template: function CustomLoadingOverlayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "lib-progress", _c1$t, _c2$p);
    } if (rf & 2) {
        ɵɵproperty("id", "spinner")("loader", false)("spinner", true)("spinnerPosition", "center");
    } }, directives: [ProgressComponent], styles: ["lib-progress{position:absolute;top:40%}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(CustomLoadingOverlayComponent, [{
        type: Component,
        args: [{
                selector: "lib-custom-loading-overlay",
                template: `<lib-progress
       #loadingSpinner
       [id]="'spinner'"
       [loader]="false"
       [spinner]="true"
       [spinnerPosition]="'center'">
     </lib-progress>`,
                styleUrls: ["./custom-loading-overlay.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { spinnerRef: [{
            type: ViewChild,
            args: ["loadingSpinner", { static: true }]
        }] });

// https://www.ag-grid.com/javascript-grid-column-definitions/#default-column-definitions
const defaultColumnDefs = {
    headerComponent: "headerWithSortingFilter",
    filter: "customFilter",
    menuTabs: ["filterMenuTab"],
    sortable: true,
    checkboxSelection(params) {
        // show check box if it's first displayed column
        if (!params.columnApi) {
            return false;
        }
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        return displayedColumns[0] === params.column;
    }
};
const columnTypes = {
    // No Filter or Sort menu
    nonSortFilterColumn: {
        headerComponent: "agColumnHeader",
        sortable: false,
        filterActive: false
    },
};
const defaultGridOptions = {
    // all columns has filter/sort menu by default, unless the properties are overwritten
    defaultColDef: defaultColumnDefs,
    columnTypes,
    rowSelection: "multiple",
    rowHeight: 68,
    domLayout: "autoHeight",
    suppressMovableColumns: true,
    suppressHorizontalScroll: true,
    suppressPropertyNamesCheck: true,
    suppressContextMenu: true,
    suppressPaginationPanel: true,
    //set to true to avoid column removal as the grid scrolls horizontally
    suppressColumnVirtualisation: true,
    // Cache 3 pages (next, current & previous) such that toggling between pages can be faster
    maxBlocksInCache: 3,
    loadingCellRenderer: "customLoadingCellRenderer",
    //copy - manually select the text and use the operating system copy/paste
    enableCellTextSelection: true,
    ensureDomOrder: true
};

const _c0$v = [1, "data-table__content"];
const _c1$u = [4, "ngIf"];
const _c2$q = ["popoverTemplate", ""];
const _c3$p = [1, "popover-label-margin"];
const _c4$o = [4, "ngTemplateOutlet", "ngTemplateOutletContext"];
function PopoverCellRendererComponent_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c5$o = function (a0) { return { params: a0 }; };
function PopoverCellRendererComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "span", _c3$p);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, PopoverCellRendererComponent_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", _c4$o);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r663 = ɵɵnextContext();
    const _r665 = ɵɵreference(4);
    ɵɵselect(2);
    ɵɵtextInterpolate(ctx_r663.params.popoverLabel);
    ɵɵselect(3);
    ɵɵproperty("ngTemplateOutlet", _r665)("ngTemplateOutletContext", ɵɵpureFunction1(3, _c5$o, ctx_r663.params));
} }
function PopoverCellRendererComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function PopoverCellRendererComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PopoverCellRendererComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", _c4$o);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r664 = ɵɵnextContext();
    const _r665 = ɵɵreference(4);
    ɵɵselect(1);
    ɵɵproperty("ngTemplateOutlet", _r665)("ngTemplateOutletContext", ɵɵpureFunction1(2, _c5$o, ctx_r664.params));
} }
const _c6$n = [3, "popoverLabel", "popoverTitle", "popoverType", "popoverPlacement"];
const _c7$l = [1, "popover-content-hr"];
const _c8$l = [3, "innerHtml"];
function PopoverCellRendererComponent_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", _c8$l);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const params_r669 = ɵɵnextContext().params;
    ɵɵselect(1);
    ɵɵproperty("innerHtml", params_r669.popoverContent, ɵɵsanitizeHtml);
} }
function PopoverCellRendererComponent_ng_template_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const params_r669 = ɵɵnextContext().params;
    ɵɵselect(2);
    ɵɵtextInterpolate(params_r669.popoverText);
} }
const _c9$k = ["class", "links-popover-margin", 4, "ngFor", "ngForOf"];
const _c10$j = [1, "links-popover-margin"];
const _c11$g = [3, "href"];
function PopoverCellRendererComponent_ng_template_3_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c10$j);
    ɵɵelementStart(1, "a", _c11$g);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const link_r676 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("href", link_r676.href, ɵɵsanitizeUrl);
    ɵɵselect(2);
    ɵɵtextInterpolate(link_r676.displayValue);
} }
function PopoverCellRendererComponent_ng_template_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PopoverCellRendererComponent_ng_template_3_ng_container_4_div_1_Template, 3, 2, "div", _c9$k);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const params_r669 = ɵɵnextContext().params;
    ɵɵselect(1);
    ɵɵproperty("ngForOf", params_r669.links);
} }
function PopoverCellRendererComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "lib-popover", _c6$n);
    ɵɵelement(1, "hr", _c7$l);
    ɵɵtemplate(2, PopoverCellRendererComponent_ng_template_3_ng_container_2_Template, 2, 1, "ng-container", _c1$u);
    ɵɵtemplate(3, PopoverCellRendererComponent_ng_template_3_ng_container_3_Template, 3, 1, "ng-container", _c1$u);
    ɵɵtemplate(4, PopoverCellRendererComponent_ng_template_3_ng_container_4_Template, 2, 1, "ng-container", _c1$u);
    ɵɵelementEnd();
} if (rf & 2) {
    const params_r669 = ctx.params;
    ɵɵproperty("popoverLabel", params_r669.popoverLabel)("popoverTitle", params_r669.popoverTitle)("popoverType", params_r669.popoverTriggerType)("popoverPlacement", params_r669.popoverPlacement);
    ɵɵselect(2);
    ɵɵproperty("ngIf", params_r669.popoverContent);
    ɵɵselect(3);
    ɵɵproperty("ngIf", params_r669.isTextPopover);
    ɵɵselect(4);
    ɵɵproperty("ngIf", params_r669.isLinksPopover);
} }
class PopoverCellRendererComponent {
    agInit(params) {
        this.params = params;
        if (!this.params.popoverTriggerType) {
            this.params.popoverTriggerType = 'text';
        }
        if (!this.params.popoverPlacement) {
            this.params.popoverPlacement = 'bottom';
        }
    }
    refresh() {
        return false;
    }
}
/** @nocollapse */ PopoverCellRendererComponent.ngComponentDef = ɵɵdefineComponent({ type: PopoverCellRendererComponent, selectors: [["lib-popover-cell-renderer"]], factory: function PopoverCellRendererComponent_Factory(t) { return new (t || PopoverCellRendererComponent)(); }, consts: 5, vars: 2, template: function PopoverCellRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "span", _c0$v);
        ɵɵtemplate(1, PopoverCellRendererComponent_ng_container_1_Template, 4, 5, "ng-container", _c1$u);
        ɵɵtemplate(2, PopoverCellRendererComponent_ng_container_2_Template, 2, 4, "ng-container", _c1$u);
        ɵɵtemplate(3, PopoverCellRendererComponent_ng_template_3_Template, 5, 7, "ng-template", null, _c2$q, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.params.popoverTriggerType === "ellipsis");
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.params.popoverTriggerType === "text");
    } }, directives: [NgIf, NgTemplateOutlet, LibPopoverComponent, NgForOf], styles: [".popover-label-margin[_ngcontent-%COMP%]{margin-right:4px}.popover-content-hr[_ngcontent-%COMP%]{border:0;border-bottom:1px solid #e0e0e0;margin:0 0 12px}.links-popover-margin[_ngcontent-%COMP%]{margin-bottom:10px}"] });
/*@__PURE__*/ ɵsetClassMetadata(PopoverCellRendererComponent, [{
        type: Component,
        args: [{
                selector: 'lib-popover-cell-renderer',
                templateUrl: './popover-cell-renderer.component.html',
                styleUrls: ['./popover-cell-renderer.component.scss']
            }]
    }], null, null);

const _c0$w = ["popoverPlacement", "auto", "popoverTriggerEvents", "mouseenter:mouseleave", "dataTableTooltipStyle", "true", "dataTableTooltipNoSpacing", "true", 3, "popoverLabel", "adaptivePosition", 4, "ngIf"];
const _c1$v = [1, "data-table__content", 3, "hidden"];
const _c2$r = ["popoverPlacement", "auto", "popoverTriggerEvents", "mouseenter:mouseleave", "dataTableTooltipStyle", "true", "dataTableTooltipNoSpacing", "true", 3, "popoverLabel", "adaptivePosition"];
function TooltipCellRendererComponent_lib_popover_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "lib-popover", _c2$r);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r679 = ɵɵnextContext();
    ɵɵproperty("popoverLabel", ctx_r679.params.value)("adaptivePosition", false);
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r679.params.value, "\n");
} }
class TooltipCellRendererComponent {
    constructor(element) {
        this.element = element;
        this.overflow = true;
    }
    agInit(params) {
        this.params = params;
    }
    refresh() {
        return false;
    }
    ngAfterViewInit() {
        // Wait until event cycle finishes to detect if overflow occurs
        setTimeout(() => {
            // Get the span text, which is hidden in the first place
            // Compare scrollWidth and offsetWidth to check if text overflowed as it's more reliable than button
            let headerSpan = this.element.nativeElement.querySelector('span.data-table__content');
            if (headerSpan) {
                // Clone the element to check the width
                let cln = headerSpan.cloneNode(true);
                cln.removeAttribute("hidden");
                // Append the cloned element to calculate the scrollWidth and offsetWidth
                headerSpan.parentNode.appendChild(cln);
                this.overflow = cln.scrollWidth > cln.offsetWidth;
                // Remove afterwards
                cln.remove();
            }
        }, 0);
    }
}
/** @nocollapse */ TooltipCellRendererComponent.ngComponentDef = ɵɵdefineComponent({ type: TooltipCellRendererComponent, selectors: [["lib-data-table-tooltip"]], factory: function TooltipCellRendererComponent_Factory(t) { return new (t || TooltipCellRendererComponent)(ɵɵdirectiveInject(ElementRef, 2)); }, consts: 3, vars: 3, template: function TooltipCellRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, TooltipCellRendererComponent_lib_popover_0_Template, 2, 3, "lib-popover", _c0$w);
        ɵɵelementStart(1, "span", _c1$v);
        ɵɵtext(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.params.value && ctx.overflow);
        ɵɵselect(1);
        ɵɵproperty("hidden", ctx.overflow);
        ɵɵselect(2);
        ɵɵtextInterpolate(ctx.params.value);
    } }, directives: [NgIf, LibPopoverComponent], styles: ["[_nghost-%COMP%]{overflow:hidden;text-overflow:ellipsis}.data-table__content[_ngcontent-%COMP%]{display:block;padding-right:5px}"] });
/*@__PURE__*/ ɵsetClassMetadata(TooltipCellRendererComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-table-tooltip",
                templateUrl: "./tooltip-cell-renderer.component.html",
                styleUrls: ["./tooltip-cell-renderer.component.scss"]
            }]
    }], function () { return [{ type: ElementRef, decorators: [{
                type: Self
            }] }]; }, null);

const _c0$x = ["class", "mb-5", 4, "ngIf"];
const _c1$w = ["class", "drop-down-wrapper mb-5", 4, "ngIf"];
const _c2$s = [1, "mb-5"];
function CustomPageSizeControllerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c2$s);
    ɵɵelementStart(1, "b");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r656 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵtextInterpolate(ctx_r656.pageStatus);
    ɵɵselect(3);
    ɵɵtextInterpolate1(" of ", ctx_r656.totalRows, "\n");
} }
const _c3$q = [1, "drop-down-wrapper", "mb-5"];
const _c4$p = ["droprDown", ""];
const _c5$p = ["contentClass", "no-border pagesize-controller", 3, "placeholder", "label", "defaultHighlightFirst", "change"];
const _c6$o = ["class", "grayOption", 3, "label", "value", "ngClass", 4, "ngFor", "ngForOf"];
const _c7$m = [1, "grayOption", 3, "label", "value", "ngClass"];
const _c8$m = function (a0) { return { selected: a0 }; };
function CustomPageSizeControllerComponent_div_1_lib_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c7$m);
} if (rf & 2) {
    const option_r660 = ctx.$implicit;
    const ctx_r659 = ɵɵnextContext(2);
    ɵɵproperty("label", option_r660.toString())("value", option_r660.toString())("ngClass", ɵɵpureFunction1(3, _c8$m, option_r660 === ctx_r659.pageSize));
} }
function CustomPageSizeControllerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r662 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c3$q, _c4$p);
    ɵɵelementStart(2, "lib-select", _c5$p);
    ɵɵlistener("change", function CustomPageSizeControllerComponent_div_1_Template_lib_select_change_2_listener($event) { ɵɵrestoreView(_r662); const ctx_r661 = ɵɵnextContext(); return ctx_r661.selectChangeHandler($event); });
    ɵɵtemplate(3, CustomPageSizeControllerComponent_div_1_lib_option_3_Template, 1, 5, "lib-option", _c6$o);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r657 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵproperty("placeholder", ctx_r657.pageSize.toString())("label", "Show")("defaultHighlightFirst", false);
    ɵɵselect(3);
    ɵɵproperty("ngForOf", ctx_r657.options);
} }
class CustomPageSizeControllerComponent {
    constructor(cd) {
        this.cd = cd;
        this.options = [25, 50, 100, 250];
        this.showPageSizeChangeController = "enable";
        this.onChange = new EventEmitter();
    }
    get pageStatus() {
        const fromItem = this.totalRows === 0 ? 0 : this.firstDisplayedRowIndex + 1;
        const toItem = this.lastDisplayedRowIndex + 1;
        return `${fromItem} - ${toItem}`;
    }
    ngOnInit() {
    }
    gridReady(api) {
        this.gridApi = api;
        this.gridApi.addEventListener('modelUpdated', () => {
            this.updatePageStatus();
        });
    }
    selectChangeHandler(event) {
        let selectedPagesize = (event || {}).option.value;
        this.pageSize = selectedPagesize;
        if (selectedPagesize && this.gridApi) {
            this.gridApi.paginationSetPageSize(selectedPagesize);
            this.updatePageStatus();
        }
        this.onChange.emit(selectedPagesize);
    }
    updatePageStatus() {
        if (this.gridApi) {
            this.totalRows = this.gridApi.paginationGetRowCount();
            this.firstDisplayedRowIndex = this.gridApi.getFirstDisplayedRow();
            this.lastDisplayedRowIndex = this.gridApi.getLastDisplayedRow();
            this.pageSize = this.gridApi.paginationGetPageSize();
            this.cd.detectChanges();
        }
    }
}
/** @nocollapse */ CustomPageSizeControllerComponent.ngComponentDef = ɵɵdefineComponent({ type: CustomPageSizeControllerComponent, selectors: [["lib-custom-page-size-controller"]], factory: function CustomPageSizeControllerComponent_Factory(t) { return new (t || CustomPageSizeControllerComponent)(ɵɵdirectiveInject(ChangeDetectorRef)); }, inputs: { options: "options", showPageSizeChangeController: "showPageSizeChangeController" }, outputs: { onChange: "onChange" }, consts: 2, vars: 2, template: function CustomPageSizeControllerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, CustomPageSizeControllerComponent_div_0_Template, 4, 2, "div", _c0$x);
        ɵɵtemplate(1, CustomPageSizeControllerComponent_div_1_Template, 4, 4, "div", _c1$w);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.totalRows > 0);
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.totalRows > 0 && ctx.showPageSizeChangeController != "disable");
    } }, directives: [NgIf, SelectComponent, NgForOf, OptionComponent, NgClass], styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;flex-wrap:nowrap;-webkit-box-align:center;align-items:center;margin-left:2rem}[_nghost-%COMP%]   .drop-down-wrapper[_ngcontent-%COMP%]{margin-left:2rem;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}"] });
/*@__PURE__*/ ɵsetClassMetadata(CustomPageSizeControllerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-page-size-controller',
                templateUrl: './custom-page-size-controller.component.html',
                styleUrls: ['./custom-page-size-controller.component.scss']
            }]
    }], function () { return [{ type: ChangeDetectorRef }]; }, { options: [{
            type: Input
        }], showPageSizeChangeController: [{
            type: Input
        }], onChange: [{
            type: Output
        }] });

const _c0$y = [1, "row", "mb-5"];
const _c1$x = [1, "col-2"];
const _c2$t = ["columnSwitcherDropdown", ""];
const _c3$r = ["lib-icon-btn", "", "icon", "", "iconType", "list", 3, "ngClass", "click"];
const _c4$q = [3, "reference", "startPosition", "config"];
const _c5$q = ["accountDropdownMenu", ""];
const _c6$p = [1, "drop-down"];
const _c7$n = [1, "drop-down-title", "text-center"];
const _c8$n = [1, "drop-down-content"];
const _c9$l = [1, "drop-down-content__list"];
const _c10$k = [1, "drop-down-content__item"];
const _c11$h = ["type", "checkbox", "value", "item.value", 3, "checked", "change"];
const _c12$f = ["class", "drop-down-content__item", 4, "ngFor", "ngForOf"];
function ColumnSwitcherComponent_li_16_Template(rf, ctx) { if (rf & 1) {
    const _r715 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c10$k);
    ɵɵelementStart(1, "lib-radio-checkbox", _c11$h);
    ɵɵlistener("change", function ColumnSwitcherComponent_li_16_Template_lib_radio_checkbox_change_1_listener($event) { ɵɵrestoreView(_r715); const column_r713 = ctx.$implicit; const ctx_r714 = ɵɵnextContext(); return ctx_r714.setColumnsVisibility(column_r713.colId ? column_r713.colId : column_r713.field, $event, false); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const column_r713 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("checked", !column_r713.hide);
    ɵɵselect(2);
    ɵɵtextInterpolate(column_r713.headerName);
} }
const _c13$e = function (a0) { return { "btn--icon--list--active": a0 }; };
const _c14$d = { maxHeight: "300px", minWidth: "200px" };
class ColumnSwitcherComponent {
    constructor() {
        this.title = "";
        this.selectAllTitle = "";
        this.columnDefs = [];
        // tslint:disable-next-line: no-output-on-prefix
        this.onChange = new EventEmitter();
        this.dropDownConfig = {};
        // ────────────────────────────────────────────────────────────────────────────────
        this.isAllSelected = false;
    }
    ngOnInit() {
        this.setHideValues();
    }
    // ────────────────────────────────────────────────────────────────────────────────
    // Dropdown
    dropdownToggle(dropdown) {
        if (dropdown.showing) {
            dropdown.hide();
        }
        else {
            dropdown.show();
        }
    }
    // ────────────────────────────────────────────────────────────────────────────────
    // Columns
    setHideValues(event) {
        let checked;
        if (event !== undefined) {
            checked = event.target.checked;
            this.isAllSelected = checked;
        }
        this.columnDefs.forEach((column, index, columns) => {
            if (column.hide === undefined && checked === undefined) {
                columns[index].hide = false;
            }
            else if (typeof checked === "boolean") {
                columns[index].hide = !checked;
                this.setColumnsVisibility(column.colId ? column.colId : column.field, event, true);
            }
        });
        // Emit a consolidated event.
        this.updateColumns(this.columnDefs.map(c => ({ colId: c.colId ? c.colId : c.field, state: !c.hide })));
    }
    setColumnsVisibility(field, event, isSelectAll) {
        const state = event.target.checked;
        const col = this.columnDefs.find((column) => (column.field === field || column.colId === field));
        col.hide = !state;
        this.isAllSelected = this.isAllChecked();
        // No need to emit event when "Select All" is checked or unchecked.
        if (!isSelectAll) {
            this.updateColumns([{ colId: (col.colId ? col.colId : col.field), state }]);
        }
    }
    updateColumns(update) {
        this.onChange.emit(update);
    }
    isAllChecked() {
        return this.columnDefs.every((column) => {
            return column.hide === false;
        });
    }
    isAllUnChecked() {
        return this.columnDefs.every((column) => {
            return column.hide === true;
        });
    }
}
/** @nocollapse */ ColumnSwitcherComponent.ngComponentDef = ɵɵdefineComponent({ type: ColumnSwitcherComponent, selectors: [["lib-column-switcher"]], factory: function ColumnSwitcherComponent_Factory(t) { return new (t || ColumnSwitcherComponent)(); }, viewQuery: function ColumnSwitcherComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(DropdownComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.columnSwitcherDropdown = _t.first);
    } }, inputs: { title: "title", selectAllTitle: "selectAllTitle", columnDefs: "columnDefs" }, outputs: { onChange: "onChange" }, consts: 17, vars: 12, template: function ColumnSwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        const _r716 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "div", _c0$y);
        ɵɵelementStart(1, "div", _c1$x);
        ɵɵelementStart(2, "div", null, _c2$t);
        ɵɵelementStart(4, "button", _c3$r);
        ɵɵlistener("click", function ColumnSwitcherComponent_Template_button_click_4_listener($event) { ɵɵrestoreView(_r716); const _r711 = ɵɵreference(6); return ctx.dropdownToggle(_r711); });
        ɵɵelementEnd();
        ɵɵelementStart(5, "lib-dropdown", _c4$q, _c5$q);
        ɵɵelementStart(7, "div", _c6$p);
        ɵɵelementStart(8, "div", _c7$n);
        ɵɵtext(9);
        ɵɵpipe(10, "uppercase");
        ɵɵelementEnd();
        ɵɵelementStart(11, "overlay-scrollbars", _c8$n);
        ɵɵelementStart(12, "ul", _c9$l);
        ɵɵelementStart(13, "li", _c10$k);
        ɵɵelementStart(14, "lib-radio-checkbox", _c11$h);
        ɵɵlistener("change", function ColumnSwitcherComponent_Template_lib_radio_checkbox_change_14_listener($event) { return ctx.setHideValues($event); });
        ɵɵtext(15);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(16, ColumnSwitcherComponent_li_16_Template, 3, 2, "li", _c12$f);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r710 = ɵɵreference(3);
        const _r711 = ɵɵreference(6);
        ɵɵselect(4);
        ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c13$e, _r711.showing));
        ɵɵselect(5);
        ɵɵproperty("reference", _r710)("startPosition", "bottom")("config", _c14$d);
        ɵɵselect(9);
        ɵɵtextInterpolate1(" ", ɵɵpipeBind1(10, 8, ctx.title), " ");
        ɵɵselect(14);
        ɵɵproperty("checked", ctx.isAllSelected);
        ɵɵselect(15);
        ɵɵtextInterpolate(ctx.selectAllTitle);
        ɵɵselect(16);
        ɵɵproperty("ngForOf", ctx.columnDefs);
    } }, directives: [IconButtonComponent, NgClass, DropdownComponent, OverlayScrollbarsComponent, RadioCheckboxComponent, NgForOf], pipes: [UpperCasePipe], styles: [".drop-down-wrapper-persist{margin-top:-10px}.drop-down-wrapper{text-align:center;height:60px;background-color:#fff;position:relative;z-index:1001}.drop-down-wrapper button{position:relative;z-index:1001;top:10px}.drop-down-title{font-size:1.4rem;font-weight:500;letter-spacing:.04rem;line-height:1.4285714286;padding-top:.5rem;padding-bottom:.5rem}.drop-down-content{margin-top:.65rem;height:calc(98% - 50px)}.drop-down-content__list{padding-left:3rem;list-style:none;text-align:left}.drop-down-content__list--select{padding-bottom:1rem;padding-left:2rem;padding-top:1rem}.drop-down-content__item{display:block;padding-right:3rem;padding-top:.9rem;padding-bottom:.9rem;position:relative;text-overflow:ellipsis}.drop-down-content__item.active-option{font-weight:700}.drop-down-content__item.active-option:before{color:#878288;font-weight:400;content:\"L\";-webkit-transform:scaleX(-1) rotate(-35deg);transform:scaleX(-1) rotate(-35deg);position:absolute;left:-20px;display:inline-block;top:3px}.relative{position:relative;height:100%;width:100%}.relative .drop-down-content{height:100%}.cdk-overlay-pane{width:initial}.drop-down-account{position:relative;height:100%;min-width:22rem}.btn--icon--list{background-size:85%}button:focus{outline:0}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(ColumnSwitcherComponent, [{
        type: Component,
        args: [{
                selector: "lib-column-switcher",
                templateUrl: "./column-switcher.component.html",
                styleUrls: ["./column-switcher.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], selectAllTitle: [{
            type: Input
        }], columnDefs: [{
            type: Input
        }], onChange: [{
            type: Output
        }], columnSwitcherDropdown: [{
            type: ViewChild,
            args: [DropdownComponent, { static: true }]
        }] });

const _c0$z = ["pageSizeController"];
const _c1$y = ["gridRef"];
const _c2$u = [1, "data-table-toolbar"];
const _c3$s = [1, "data-table-toolbar__items", 3, "hidden"];
const _c4$r = ["class", "data-table-toolbar__clear-selected-container", 4, "ngIf"];
const _c5$r = [3, "columnDefs", "title", "selectAllTitle", "onChange", 4, "ngIf"];
const _c6$q = [3, "hidden", "showPageSizeChangeController"];
const _c7$o = ["pageSizeController", ""];
const _c8$o = ["class", "data-table", 3, "gridOptions", "rowData", "icons", "frameworkComponents", "postProcessPopup", "defaultColDef", "gridReady", "selectionChanged", "sortChanged", "filterChanged", "filterModified", "rowDataChanged", "rowDataUpdated", "paginationChanged", "columnResized", 4, "ngIf"];
const _c9$m = ["class", "data-table", 3, "gridOptions", "icons", "frameworkComponents", "postProcessPopup", "defaultColDef", "gridReady", "selectionChanged", "sortChanged", "filterChanged", "filterModified", "rowDataChanged", "rowDataUpdated", "displayedColumnsChanged", "columnResized", 4, "ngIf"];
const _c10$l = [3, "currentPage", "totalPages", "pageChanged"];
const _c11$i = ["libPagination", ""];
const _c12$g = [1, "data-table-toolbar__clear-selected-container"];
const _c13$f = [1, "data-table-toolbar__clear-selected-btn", 3, "click"];
const _c14$e = [1, "data-table-toolbar__clear-selected-message"];
function DataTableComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r687 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c12$g);
    ɵɵelementStart(1, "button", _c13$f);
    ɵɵlistener("click", function DataTableComponent_div_2_Template_button_click_1_listener($event) { ɵɵrestoreView(_r687); const ctx_r686 = ɵɵnextContext(); return ctx_r686.clearSelected(); });
    ɵɵelementEnd();
    ɵɵelementStart(2, "span", _c14$e);
    ɵɵelementStart(3, "strong");
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵtext(5, " selected");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r680 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵtextInterpolate(ctx_r680.selectedRows.length);
} }
const _c15$c = [3, "columnDefs", "title", "selectAllTitle", "onChange"];
function DataTableComponent_lib_column_switcher_3_Template(rf, ctx) { if (rf & 1) {
    const _r689 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-column-switcher", _c15$c);
    ɵɵlistener("onChange", function DataTableComponent_lib_column_switcher_3_Template_lib_column_switcher_onChange_0_listener($event) { ɵɵrestoreView(_r689); const ctx_r688 = ɵɵnextContext(); return ctx_r688.setColumns($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r681 = ɵɵnextContext();
    ɵɵproperty("columnDefs", ctx_r681.gridOptions.columnDefs)("title", ctx_r681.columnSwitcherTitle)("selectAllTitle", ctx_r681.columnSwitcherSelectAllTitle);
} }
const _c16$b = [1, "data-table", 3, "gridOptions", "rowData", "icons", "frameworkComponents", "postProcessPopup", "defaultColDef", "gridReady", "selectionChanged", "sortChanged", "filterChanged", "filterModified", "rowDataChanged", "rowDataUpdated", "paginationChanged", "columnResized"];
function DataTableComponent_ag_grid_angular_6_Template(rf, ctx) { if (rf & 1) {
    const _r691 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ag-grid-angular", _c16$b);
    ɵɵlistener("gridReady", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_gridReady_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r690 = ɵɵnextContext(); return ctx_r690.onGridReady($event); });
    ɵɵlistener("selectionChanged", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_selectionChanged_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r692 = ɵɵnextContext(); return ctx_r692.onSelectionChanged($event); });
    ɵɵlistener("sortChanged", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_sortChanged_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r693 = ɵɵnextContext(); return ctx_r693.onSortChanged($event); });
    ɵɵlistener("filterChanged", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_filterChanged_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r694 = ɵɵnextContext(); return ctx_r694.onFilterChanged($event); });
    ɵɵlistener("filterModified", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_filterModified_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r695 = ɵɵnextContext(); return ctx_r695.onFilterModified($event); });
    ɵɵlistener("rowDataChanged", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_rowDataChanged_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r696 = ɵɵnextContext(); return ctx_r696.onRowDataChanged($event); });
    ɵɵlistener("rowDataUpdated", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_rowDataUpdated_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r697 = ɵɵnextContext(); return ctx_r697.onRowDataUpdated($event); });
    ɵɵlistener("paginationChanged", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_paginationChanged_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r698 = ɵɵnextContext(); return ctx_r698.onPaginationChanged(); });
    ɵɵlistener("columnResized", function DataTableComponent_ag_grid_angular_6_Template_ag_grid_angular_columnResized_0_listener($event) { ɵɵrestoreView(_r691); const ctx_r699 = ɵɵnextContext(); return ctx_r699.onColumnResize($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r683 = ɵɵnextContext();
    ɵɵproperty("gridOptions", ctx_r683.gridOptions)("rowData", ctx_r683.rowData)("icons", ctx_r683.icons)("frameworkComponents", ctx_r683.frameworkComponents)("postProcessPopup", ctx_r683.postProcessPopup)("defaultColDef", ctx_r683.defaultColDef);
} }
const _c17$b = [1, "data-table", 3, "gridOptions", "icons", "frameworkComponents", "postProcessPopup", "defaultColDef", "gridReady", "selectionChanged", "sortChanged", "filterChanged", "filterModified", "rowDataChanged", "rowDataUpdated", "displayedColumnsChanged", "columnResized"];
function DataTableComponent_ag_grid_angular_7_Template(rf, ctx) { if (rf & 1) {
    const _r701 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "ag-grid-angular", _c17$b);
    ɵɵlistener("gridReady", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_gridReady_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r700 = ɵɵnextContext(); return ctx_r700.onGridReady($event); });
    ɵɵlistener("selectionChanged", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_selectionChanged_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r702 = ɵɵnextContext(); return ctx_r702.debouncedSelectionChanged($event); });
    ɵɵlistener("sortChanged", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_sortChanged_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r703 = ɵɵnextContext(); return ctx_r703.onSortChanged($event); });
    ɵɵlistener("filterChanged", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_filterChanged_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r704 = ɵɵnextContext(); return ctx_r704.onFilterChanged($event); });
    ɵɵlistener("filterModified", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_filterModified_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r705 = ɵɵnextContext(); return ctx_r705.onFilterModified($event); });
    ɵɵlistener("rowDataChanged", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_rowDataChanged_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r706 = ɵɵnextContext(); return ctx_r706.onRowDataChanged($event); });
    ɵɵlistener("rowDataUpdated", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_rowDataUpdated_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r707 = ɵɵnextContext(); return ctx_r707.onRowDataUpdated($event); });
    ɵɵlistener("displayedColumnsChanged", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_displayedColumnsChanged_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r708 = ɵɵnextContext(); return ctx_r708.onDisplayedColumnsChanged($event); });
    ɵɵlistener("columnResized", function DataTableComponent_ag_grid_angular_7_Template_ag_grid_angular_columnResized_0_listener($event) { ɵɵrestoreView(_r701); const ctx_r709 = ɵɵnextContext(); return ctx_r709.onColumnResize($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r684 = ɵɵnextContext();
    ɵɵproperty("gridOptions", ctx_r684.gridOptions)("icons", ctx_r684.icons)("frameworkComponents", ctx_r684.frameworkComponents)("postProcessPopup", ctx_r684.postProcessPopup)("defaultColDef", ctx_r684.defaultColDef);
} }
class DataTableComponent {
    constructor(dataTableApiService, serverSideDatasourceService, elementRef) {
        this.dataTableApiService = dataTableApiService;
        this.serverSideDatasourceService = serverSideDatasourceService;
        this.elementRef = elementRef;
        this._requestOptions = {
            origin: "",
            path: "",
            params: {
                limit: 50,
                offset: 0,
            },
        };
        this.selectedRows = [];
        this.rowData = [];
        this.showNativePagination = false;
        this.useClassForChooser = false;
        this.selectionChanged = new EventEmitter();
        this.sortingChanged = new EventEmitter();
        this.columnVisibilityChanged = new EventEmitter();
        this.filteringChanged = new EventEmitter();
        this.filterModified = new EventEmitter();
        this.rowDataChanged = new EventEmitter();
        this.rowDataUpdated = new EventEmitter();
        this.pageChanged = new EventEmitter();
        this.gridReady = new EventEmitter();
        this.columnResized = new EventEmitter();
        this.columnSwitcherTitle = "columns";
        this.columnSwitcherSelectAllTitle = "Select All";
        // ────────────────────────────────────────────────────────────────────────────────
        this.showPageSizeController = "disable";
        this.showPageSizeChangeController = "enable";
        this.enableColumnResizing = "enable";
        this.subs = new SubSink();
        this.selectAllEventHandler = this.handlerSelection.bind(this); // used only in case of 'serverside' row model type
        this.checkboxCheckedClass = "checkbox__label--checked";
        this.serverSideSelectAllHeaderClass = "select-all-current-page";
        this.tableIsLoading = false;
        /**
         * Resize need to be rebounced
         */
        this.debounceResize = debounce$1(() => {
            // only call sizeColumnToFit when api is ready
            if (this.api) {
                this.api.sizeColumnsToFit();
            }
        }, 40);
        /**
         * When server table header checkbox (select/deselect-all rows) is checked,
         * selectionChanged event will be emitted for each row. This method debounces
         * the multiple events. Also in server-side mode, we will have to manage header
         * checkbox updates.
         */
        // tslint:disable-next-line: member-ordering
        this.debouncedSelectionChanged = debounce$1(($event) => {
            this.selectionChanged.emit($event);
            this.selectedRows = this.api.getSelectedRows();
            this.setSelectAllCheckboxStatus();
        }, 40);
        this._currentPage = 1;
        this._totalPages = 1;
        const element = this.elementRef.nativeElement;
    }
    get requestOptions() {
        return this._requestOptions;
    }
    set requestOptions(data) {
        Object.assign(this._requestOptions, data);
    }
    onResize() {
        this.debounceResize();
    }
    ngOnInit() {
        if (this.useClassForChooser) {
            this.elementRef.nativeElement.classList.add(`chooser-modal`);
        }
        // Overwrite default gridOptions with user's gridOption input
        this.gridOptions = Object.assign({}, defaultGridOptions, this.gridOptions);
        this.defaultColDef = Object.assign({}, this.gridOptions.defaultColDef, { resizable: this.enableColumnResizing === "enable" ? true : false });
        if (this.gridOptions && this.defaultColDef.resizable === false) {
            this.gridOptions.columnDefs.forEach((colDef) => {
                colDef.resizable = this.defaultColDef.resizable;
            });
        }
        if (!this.gridOptions.overlayLoadingTemplate) {
            // use default custom-loading-overlay component if user is not overriding the overlay template
            this.gridOptions.loadingOverlayComponent = "customLoadingOverlay";
        }
        if (Array.isArray(this.gridOptions.columnDefs) &&
            this.gridOptions.columnDefs.length) {
            const columnDef = this.gridOptions.columnDefs[this.gridOptions.columnDefs.length - 1];
            const { headerClass, cellClass } = columnDef;
            columnDef.headerClass = headerClass ? `${headerClass} last` : "last";
            columnDef.cellClass = cellClass ? `${cellClass} last` : "last";
        }
        this.frameworkComponents = {
            headerWithSortingFilter: CustomHeaderComponent,
            customFilter: CustomFilterComponent,
            customLoadingOverlay: CustomLoadingOverlayComponent,
            customLoadingCellRenderer: CustomCellLoadingRendererComponent,
            span: SpanCellRendererComponent,
            link: LinkCellRendererComponent,
            popover: PopoverCellRendererComponent,
            tooltip: TooltipCellRendererComponent,
        };
        const prefix = this.gridOptions.rowSelection === "single" ? "radio" : "checkbox";
        this.icons = {
            checkboxChecked: `<span class="${prefix}__label ${prefix}__label--checked"></span>`,
            checkboxUnchecked: `<span class="${prefix}__label"></span>`,
            checkboxIndeterminate: `<span class="${prefix}__label"></span>`,
        };
        this.serverSide = this.gridOptions.rowModelType === "serverSide";
        // set selectAllIsEnabled to enable/disable our custom server side headerCheckbox select all solution
        if (this.serverSide) {
            const columnDefs = this.gridOptions.columnDefs;
            if (columnDefs && columnDefs.length > 0) {
                this.selectAllIsEnabled = columnDefs[0].headerClass
                    ? columnDefs[0].headerClass.includes(this.serverSideSelectAllHeaderClass)
                    : false;
            }
        }
        if (this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
            this.tableIsLoading = false;
        }
    }
    ngAfterViewInit() {
        if (this.serverSide) {
            this.subs.sink = this.dataTableApiService.dataChanged.subscribe((data) => {
                if (this.api && data) {
                    this.libPagination.totalPages = this.totalPages;
                    this.libPagination.marcForCheck();
                }
            });
            // Need to manage server table header checkbox selection (https://stackoverflow.com/a/57891423)
            this.selectAllRefs = this.elementRef.nativeElement.querySelectorAll("." + this.serverSideSelectAllHeaderClass + " .ag-input-wrapper");
            this.selectAllRefs.forEach((element) => {
                element.addEventListener("click", this.selectAllEventHandler, false);
            });
        }
        if (this.showNativePagination) {
            setTimeout(() => {
                const element = document.querySelector(".ag-paging-panel");
                if (element === null) {
                    return;
                }
                element.setAttribute("style", "display: block");
            }, 0);
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
        if (this.selectAllRefs) {
            this.selectAllRefs.forEach((element) => {
                element.removeEventListener("click", this.selectAllEventHandler, false);
            });
        }
    }
    postProcessPopup(params) {
        const boundaries = params.eventSource && params.eventSource.getBoundingClientRect();
        if (boundaries && params.ePopup) {
            params.ePopup.style.width = `${boundaries.width}px`;
        }
    }
    setColumns(updateData) {
        // updateData only when columnApi is ready
        if (this.gridOptions.columnApi) {
            updateData.forEach((update) => {
                this.gridOptions.columnApi.setColumnVisible(update.colId, update.state);
            });
        }
        this.columnVisibilityChanged.emit(updateData);
        this.debounceResize();
    }
    setNewSelectAllCheckbox() {
        const displayedColumns = this.gridOptions != null && this.gridOptions.columnApi != null
            ? this.gridOptions.columnApi.getAllDisplayedColumns()
            : [];
        if (displayedColumns.length === 0) {
            return;
        }
        const firstDisplayedColumn = displayedColumns[0];
        const columnName = firstDisplayedColumn.colDef.headerName
            ? firstDisplayedColumn.colDef.headerName
            : firstDisplayedColumn.colDef.field;
        // To get the index of rendered <div> that represents first displayed column
        const headers = this.elementRef.nativeElement.querySelectorAll(".ag-header-row .ag-header-cell .ag-header-cell-text");
        const list = [...headers];
        const index = list.findIndex((element) => element.innerText.toUpperCase() === columnName.toUpperCase());
        // Removing the previous select-all box and the event listener attached to it
        if (this.selectAllRefs) {
            this.selectAllRefs.forEach((element) => {
                element.removeEventListener("click", this.selectAllEventHandler, false);
            });
        }
        const headerDivs = this.elementRef.nativeElement.querySelectorAll(".ag-header-row .ag-header-cell");
        headerDivs.forEach((element) => {
            const isOldSelectAllCheckbox = element.classList.contains(this.serverSideSelectAllHeaderClass);
            if (isOldSelectAllCheckbox) {
                element.classList.remove(this.serverSideSelectAllHeaderClass);
            }
        });
        // add class to new first column header to override the css and display the hidden checkbox in serverside modeltype
        if (firstDisplayedColumn.colDef.headerCheckboxSelection !== false ||
            firstDisplayedColumn.colDef.checkboxSelection !== false) {
            // Shouldn't add css class to display hidden checkbox when both row selection and header selection are disabled
            // It will cause misalignment for header and row content
            headerDivs[index].classList.add("select-all-current-page");
        }
        // add click event listener to new first column checkbox for selecting all rows
        this.selectAllRefs = this.elementRef.nativeElement.querySelectorAll("." + this.serverSideSelectAllHeaderClass + " .ag-input-wrapper");
        this.selectAllRefs.forEach((element) => {
            element.addEventListener("click", this.selectAllEventHandler, false);
        });
    }
    onGridReady({ api }) {
        this.api = api;
        this.debounceResize();
        if (this.serverSide) {
            this.serverSideDatasourceService.init({
                apiDriver: this.dataTableApiService,
                gridInstance: this.api,
                requestOptions: this.requestOptions,
            });
            // Show loading api overlay (Server table only)
            this.subs.sink = this.dataTableApiService.dataLoadingStatus$.subscribe((status) => {
                if (status === DataLoadingStatus.RowsLoaded) {
                    this.api.hideOverlay();
                }
                else if (status === DataLoadingStatus.NoRows) {
                    this.api.showNoRowsOverlay();
                }
                if (status !== DataLoadingStatus.Loading) {
                    this.tableIsLoading = false;
                    this.initializePageSizeController();
                }
            });
        }
        else if (this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
            this.initializePageSizeController();
        }
        this.updatePaginationParams();
        this.gridReady.emit(this.api);
    }
    onDisplayedColumnsChanged($event) {
        // headercheckbox selection is not supported in serverside model of ag-grid
        // so to handle that thing....when there is new header in leftmost column
        // this should work only in case of serverside
        if (!this.serverSide) {
            return;
        }
        // should not work if rowSelection is 'single' type
        // And should also not work if select all solution is not enabled (need to pass 'select-all-current-page' headerClass
        // to first column to enable)
        if (this.gridOptions.rowSelection === "single" ||
            !this.selectAllIsEnabled) {
            return;
        }
        this.setNewSelectAllCheckbox();
    }
    onSelectionChanged($event) {
        this.selectionChanged.emit($event);
        this.selectedRows = this.api.getSelectedRows();
    }
    onColumnResize($event) {
        // Only interested in the column resizing that user Initiated.
        // Grid Size to fit calls also trigger this event, but filter those out.
        if ($event && $event.source === "uiColumnDragged" && $event.finished) {
            this.columnResized.emit($event);
        }
    }
    onPageChanged(page) {
        this.api.paginationGoToPage(page - 1);
        this.updatePaginationParams();
        this.pageChanged.emit(this.api);
        // Update page size controller status
        if (this.showPageSizeController && this.pageSizeController) {
            this.pageSizeController.updatePageStatus();
        }
        if (this.serverSide) {
            this.setSelectedRows();
            this.setSelectAllCheckboxStatus();
        }
    }
    onPaginationChanged() {
        this.updatePaginationParams();
    }
    updatePaginationParams() {
        if (!this.api) {
            return;
        }
        this.currentPage = this.api.paginationGetCurrentPage() + 1;
        this.totalPages = this.api.paginationGetTotalPages();
    }
    set currentPage(value) {
        this._currentPage = value;
    }
    get currentPage() {
        return this.api
            ? this.api.paginationGetCurrentPage() + 1
            : this._currentPage;
    }
    setSelectAllCheckboxStatus() {
        // Update header checkbox to reflect 'select-all' state or not
        const renderedNodes = this.api.getRenderedNodes();
        // when single select option is specified, there is no 'Select All' check box.
        if (this.selectAllRefs[0] != null) {
            const headerCheckboxRef = this.selectAllRefs[0].querySelector(".checkbox__label");
            if (headerCheckboxRef) {
                const headerCheckboxClassList = headerCheckboxRef.classList;
                const areAllRenderedRowsSelected = renderedNodes.every((renderedNode) => {
                    return this.selectedRows.find((selectedRow) => {
                        return selectedRow === renderedNode.data;
                    });
                });
                if (areAllRenderedRowsSelected) {
                    headerCheckboxClassList.add(this.checkboxCheckedClass);
                }
                else if (headerCheckboxClassList.contains(this.checkboxCheckedClass)) {
                    headerCheckboxClassList.remove(this.checkboxCheckedClass);
                }
            }
        }
    }
    // set selected rows when page loads
    setSelectedRows() {
        if (isNullOrUndefined(this.selectedRows)) {
            this.api.forEachNode((node) => node.setSelected(false));
        }
        else {
            const renderedNodes = this.api.getRenderedNodes();
            ___default.each(renderedNodes, (node) => {
                if (___default.find(this.selectedRows, (selected) => node.data === selected)) {
                    node.setSelected(true);
                }
            });
        }
    }
    set totalPages(value) {
        this._totalPages = value;
    }
    get totalPages() {
        return this.api ? this.api.paginationGetTotalPages() : this._totalPages;
    }
    /**
     * Forces the server table to make the api call to fetch data rows.
     * This is useful for reloading the runs list when user-context changes,
     * where the api url still remains the same.
     */
    reloadServerTable() {
        if (!this.serverSide) {
            console.error("reloadServerTable() does not work when gridOption does not have `rowModelType: 'serverSide'`");
            return;
        }
        this.api.purgeServerSideCache([]);
        // Reset rows selected (uncheck all rows)
        this.api.deselectAll();
    }
    clearSelected() {
        this.api.deselectAll();
    }
    onSortChanged($event) {
        this.sortingChanged.emit($event);
        // Reset rows selected (uncheck all rows)
        this.api.deselectAll();
    }
    onFilterChanged($event) {
        if ($event.sorting) {
            delete $event.sorting;
            $event.type = "sortChanged";
            this.sortingChanged.emit($event);
        }
        else {
            this.filteringChanged.emit($event);
        }
        // Reset rows selected (uncheck all rows)
        this.api.deselectAll();
    }
    onFilterModified($event) {
        this.filterModified.emit($event);
        // Reset rows selected (uncheck all rows)
        this.api.deselectAll();
    }
    onRowDataChanged($event) {
        this.rowDataChanged.emit($event);
    }
    onRowDataUpdated($event) {
        this.rowDataUpdated.emit($event);
    }
    // selectAll selection handler
    // Only used in server-table, since header checkbox selection for server side is not managed by ag-grid.
    handlerSelection($event) {
        const nodesRefs = this.api.getRenderedNodes();
        if ($event.target.classList.contains(this.checkboxCheckedClass)) {
            nodesRefs.forEach((node) => node.setSelected(false));
        }
        else {
            nodesRefs.forEach((node) => node.setSelected(true));
        }
    }
    initializePageSizeController() {
        if (this.showPageSizeController && this.pageSizeController) {
            this.pageSizeController.gridReady(this.api);
        }
    }
}
/** @nocollapse */ DataTableComponent.ngComponentDef = ɵɵdefineComponent({ type: DataTableComponent, selectors: [["lib-data-table"]], factory: function DataTableComponent_Factory(t) { return new (t || DataTableComponent)(ɵɵdirectiveInject(DataTableApiService), ɵɵdirectiveInject(ServerSideDatasourceService), ɵɵdirectiveInject(ElementRef)); }, viewQuery: function DataTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(PaginationComponent, true);
        ɵɵviewQuery(_c0$z, true);
        ɵɵviewQuery(_c1$y, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.libPagination = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.pageSizeController = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.gridRef = _t.first);
    } }, hostBindings: function DataTableComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("resize", function DataTableComponent_resize_HostBindingHandler($event) { return ctx.onResize(); }, false, ɵɵresolveWindow);
    } }, inputs: { requestOptions: "requestOptions", gridOptions: "gridOptions", selectedRows: "selectedRows", rowData: "rowData", showNativePagination: "showNativePagination", useClassForChooser: "useClassForChooser", showColumnsSwitcher: "showColumnsSwitcher", columnSwitcherTitle: "columnSwitcherTitle", columnSwitcherSelectAllTitle: "columnSwitcherSelectAllTitle", showPageSizeController: "showPageSizeController", showPageSizeChangeController: "showPageSizeChangeController", enableColumnResizing: "enableColumnResizing" }, outputs: { selectionChanged: "selectionChanged", sortingChanged: "sortingChanged", columnVisibilityChanged: "columnVisibilityChanged", filteringChanged: "filteringChanged", filterModified: "filterModified", rowDataChanged: "rowDataChanged", rowDataUpdated: "rowDataUpdated", pageChanged: "pageChanged", gridReady: "gridReady", columnResized: "columnResized" }, exportAs: ["libDataTable"], features: [ɵɵProvidersFeature([ServerSideDatasourceService, DataTableApiService])], consts: 10, vars: 10, template: function DataTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c2$u);
        ɵɵelementStart(1, "div", _c3$s);
        ɵɵtemplate(2, DataTableComponent_div_2_Template, 6, 1, "div", _c4$r);
        ɵɵtemplate(3, DataTableComponent_lib_column_switcher_3_Template, 1, 3, "lib-column-switcher", _c5$r);
        ɵɵelement(4, "lib-custom-page-size-controller", _c6$q, _c7$o);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(6, DataTableComponent_ag_grid_angular_6_Template, 1, 6, "ag-grid-angular", _c8$o);
        ɵɵtemplate(7, DataTableComponent_ag_grid_angular_7_Template, 1, 5, "ag-grid-angular", _c9$m);
        ɵɵelementStart(8, "lib-pagination", _c10$l, _c11$i);
        ɵɵstyling();
        ɵɵlistener("pageChanged", function DataTableComponent_Template_lib_pagination_pageChanged_8_listener($event) { return ctx.onPageChanged($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("hidden", ctx.tableIsLoading);
        ɵɵselect(2);
        ɵɵproperty("ngIf", (ctx.selectedRows == null ? null : ctx.selectedRows.length) > 0);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.gridOptions.columnDefs && ctx.gridOptions.columnDefs.length > 0 && ctx.showColumnsSwitcher === "enable");
        ɵɵselect(4);
        ɵɵproperty("hidden", ctx.showPageSizeController != "enable")("showPageSizeChangeController", ctx.showPageSizeChangeController);
        ɵɵselect(6);
        ɵɵproperty("ngIf", !ctx.serverSide);
        ɵɵselect(7);
        ɵɵproperty("ngIf", ctx.serverSide);
        ɵɵselect(8);
        ɵɵclassProp("ag-hidden", !ctx.gridOptions.pagination);
        ɵɵstylingApply();
        ɵɵproperty("currentPage", ctx.currentPage)("totalPages", ctx.totalPages);
    } }, directives: [NgIf, CustomPageSizeControllerComponent, PaginationComponent, ColumnSwitcherComponent, AgGridAngular], styles: [".data-table a:link{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent}body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.data-table{width:100%}.data-table .ag-header-row,.data-table .ag-root,.data-table .ag-root-wrapper{overflow:visible}.data-table .ag-root,.data-table .ag-root-wrapper,.data-table .ag-unselectable{-webkit-user-select:text!important;-moz-user-select:text!important;-ms-user-select:text!important;user-select:text!important}.data-table .ag-center-cols-clipper{overflow:hidden;margin-top:20px}.data-table .ag-center-cols-viewport{width:calc(100% + 1px);margin-top:-20px;overflow-x:auto}.data-table .ag-header-viewport{overflow:hidden}.data-table .ag-row-drag{width:40px;height:20px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/handlebars.svg);background-repeat:no-repeat;background-position:center;cursor:-webkit-grab;cursor:grab}.data-table .ag-header{position:relative;z-index:1;overflow:visible}.data-table .ag-body-viewport{margin-top:2px}.data-table .ag-header-cell{color:#787679;display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;font-size:16px;font-weight:500;line-height:1.4;text-align:right;-webkit-box-pack:space-evenly;justify-content:space-evenly;text-transform:capitalize;overflow:visible}.data-table .ag-header-cell .ag-input-wrapper{left:5px;top:-4px}.data-table .ag-header-cell .ag-header-cell-label{padding:0 16px}.data-table--metrics .data-table .ag-header-cell .ag-header-cell-label{padding:0 20px}.data-table .ag-header-cell .ag-header-cell-text{height:20px;overflow:visible;text-overflow:unset;white-space:normal;-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex}.data-table--metrics .data-table .ag-header-cell:first-child .ag-header-cell-label{padding-left:0}.data-table .ag-header-cell-numeric .ag-header-cell-label{-webkit-box-pack:end;justify-content:flex-end}.data-table .ag-header-cell.last .ag-header-cell-label{padding-right:0}.data-table--metrics .data-table .ag-header-cell.data-table__th--two-lines{word-spacing:20px}.data-table .ag-header-cell-resize{display:block;cursor:pointer;width:12px;height:12px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/column-divider.svg);background-repeat:no-repeat;-webkit-transition:.1s;transition:.1s;top:3px}.data-table .ag-header-cell-resize:hover{background-repeat:no-repeat;cursor:col-resize}.data-table .ag-header-cell-numeric.last .ag-header-cell-label{margin-right:15px}.data-table .ag-header-cell:last-of-type .ag-header-cell-resize{margin-right:5px!important;background-position:5px}.data-table .ag-row{overflow:visible}.data-table .ag-row.ag-row-selected{background:#f9f9f9;border-top-color:#f0eff0}.data-table .ag-row:hover .ag-cell,.data-table .ag-row:hover .ag-cell--floating{background:#f9f9f9}.data-table .ag-row .ag-loading-text{display:none}.data-table .ag-cell{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;position:absolute;border-bottom:1px solid #f0eff0;border-top:1px solid transparent;color:#464247;font-size:16px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:.4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.data-table .ag-cell .ag-selection-checkbox{top:-5px;left:5px;width:14px}.data-table .ag-cell-numeric{-webkit-box-pack:end;justify-content:flex-end;text-align:right}.data-table .ag-cell-numeric .data-table__content{padding-right:16px}.data-table .ag-cell-numeric .lib-popover__datatable_tooltip-button{margin-right:22px;max-width:calc(100% - 34px)}.data-table .ag-cell-value{width:100%;padding:0 16px}.data-table .ag-cell.last .data-table .ag-cell-content{padding-right:0}.data-table .ag-cell.last .data-table__content,.data-table .ag-cell.last .lib-popover__datatable_tooltip-button{padding-right:0;margin-right:0}.data-table .ag-cell.data-table__td--floating{background:#fff;border:0!important;margin-left:11px;padding-left:8px;padding-right:8px;z-index:1}.data-table .ag-cell--totals{background:#f9f9f9;border-bottom:1px solid #f0eff0;border-top:1px solid #f0eff0;font-weight:500}.data-table .ag-cell--totals:first-child{left:-11px!important;padding-left:11px}.data-table .ag-cell--totals:last-child{right:-11px!important;padding-right:11px}.data-table .ag-cell:focus{outline:0}.data-table .ag-cell--failed{font-weight:500}.data-table__content{overflow:hidden;text-overflow:ellipsis}.data-table__content-link{color:#4e60ee!important;background:padding-box unset unset!important;-webkit-text-fill-color:#4e60ee!important;display:inline-block;position:relative}.data-table__content-link:hover{text-decoration:none!important}.data-table__content-link:hover:after{content:\"\";display:block;height:0;width:100%;border-top:1px solid #4e60ee;position:absolute;bottom:1px}.data-table--metrics .data-table__content{padding:20px}.data-table--metrics .data-table__content:first-child{padding-left:0}.data-table .ag-header-cell:first-child .ag-header-select-all.ag-checkbox.ag-hidden .radio__label,.data-table .ag-paging-panel{display:none}.data-table .ag-header-cell:first-child .ag-header-select-all .checkbox__label{top:-4px}.data-table .ag-header-cell.select-all-current-page .ag-header-select-all{display:-webkit-box!important;display:flex!important;width:14px}.data-table .ag-popup{top:0;position:absolute;overflow:visible;display:inline-block}.data-table .ag-popup .ag-menu{position:relative;overflow:hidden}.data-table .ag-popup .ag-menu-header{display:none}.data-table--metrics{border-top:1px solid #d1cfd1;padding-top:14px}.data-table--metrics .ag-grid-body-viewport{overflow:visible!important}.data-table--metrics .ag-header-row{border-bottom:1px solid #f0eff0}.data-table-toolbar{position:relative;width:100%;max-height:42px;line-height:42px;margin-bottom:10px;text-align:right}.data-table-toolbar__clear-selected-container{margin-bottom:31px;margin-right:20px}.data-table-toolbar__clear-selected-btn{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/close-small.svg) center no-repeat;border:none;height:28px;outline:0;-webkit-transform:translate(0,8px);transform:translate(0,8px);width:28px;vertical-align:top}.data-table-toolbar .data-table-toolbar__items{position:absolute;top:-80px;right:0;-webkit-box-align:center;align-items:center;height:auto;display:-webkit-box;display:flex;max-width:50%}.data-table__dnd-header{margin-left:40px}", ".ag-input-wrapper__label,.ag-selection-checkbox__label,.checkbox__label,.radio__label,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}.ag-input-wrapper__input:checked~.checkbox__label,.ag-input-wrapper__input:not([disabled]):hover~.checkbox__label,.ag-input-wrapper__input:not([disabled]):hover~.radio__label,.ag-input-wrapper__label--checked,.ag-input-wrapper__label:hover,.ag-selection-checkbox__input:checked~.checkbox__label,.ag-selection-checkbox__input:not([disabled]):hover~.checkbox__label,.ag-selection-checkbox__input:not([disabled]):hover~.radio__label,.ag-selection-checkbox__label--checked,.ag-selection-checkbox__label:hover,.checkbox__input:checked~.checkbox__label,.checkbox__input:not([disabled]):hover~.checkbox__label,.checkbox__input:not([disabled]):hover~.radio__label,.checkbox__label--checked,.checkbox__label:hover,.radio__input:checked~.checkbox__label,.radio__input:checked~.radio__label,.radio__input:hover+.radio__label,.radio__input:not([disabled]):hover~.checkbox__label,.radio__input:not([disabled]):hover~.radio__label,.radio__label--checked,.radio__label:hover{font-weight:500}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.ag-input-wrapper__label,.ag-selection-checkbox__label,.checkbox__label,.radio__label{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.ag-input-wrapper,.ag-selection-checkbox,.checkbox,.radio{cursor:pointer;display:block;line-height:1.43!important;overflow:visible!important;position:relative;white-space:normal}.ag-input-wrapper__label,.ag-selection-checkbox__label,.checkbox__label,.radio__label{color:#322d32;display:inline-block;min-width:1.4rem;min-height:1rem;text-indent:3.1rem;margin:0;position:relative}.ag-input-wrapper__label:hover,.ag-selection-checkbox__label:hover,.checkbox__label:hover,.radio__label:hover{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.ag-input-wrapper__label::after,.ag-input-wrapper__label::before,.ag-selection-checkbox__label::after,.ag-selection-checkbox__label::before,.checkbox__label::after,.checkbox__label::before,.radio__label::after,.radio__label::before{content:\"\";display:block;position:absolute;border-radius:.2rem}.ag-input-wrapper__label::before,.ag-selection-checkbox__label::before,.checkbox__label::before,.radio__label::before{background:#fff;height:1.2rem;left:.3rem;margin:.1rem;top:.3rem;width:1.2rem;z-index:1}.ag-input-wrapper__label::after,.ag-selection-checkbox__label::after,.checkbox__label::after,.radio__label::after{background-image:-webkit-gradient(linear,left top,left bottom,from(#d1cfd1),to(#928d91));background-image:linear-gradient(to bottom,#d1cfd1 0,#928d91 100%);height:1.4rem;left:0;margin:.3rem;top:0;width:1.4rem}.ag-input-wrapper__input,.ag-selection-checkbox__input,.checkbox__input,.radio__input{cursor:pointer;height:100%;left:0;opacity:0;margin:0;min-width:1rem;padding:0;position:absolute;top:0;width:100%;z-index:10}.ag-input-wrapper__input:not([disabled]):hover~.checkbox__label,.ag-input-wrapper__input:not([disabled]):hover~.radio__label,.ag-selection-checkbox__input:not([disabled]):hover~.checkbox__label,.ag-selection-checkbox__input:not([disabled]):hover~.radio__label,.checkbox__input:not([disabled]):hover~.checkbox__label,.checkbox__input:not([disabled]):hover~.radio__label,.radio__input:not([disabled]):hover~.checkbox__label,.radio__input:not([disabled]):hover~.radio__label{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.ag-input-wrapper__input[disabled],.ag-selection-checkbox__input[disabled],.checkbox__input[disabled],.radio__input[disabled]{cursor:not-allowed}.ag-input-wrapper__input[disabled]~.checkbox__label,.ag-input-wrapper__input[disabled]~.radio__label,.ag-selection-checkbox__input[disabled]~.checkbox__label,.ag-selection-checkbox__input[disabled]~.radio__label,.checkbox__input[disabled]~.checkbox__label,.checkbox__input[disabled]~.radio__label,.radio__input[disabled]~.checkbox__label,.radio__input[disabled]~.radio__label{color:#d1cfd1}.ag-input-wrapper__input[disabled]~.checkbox__label::after,.ag-input-wrapper__input[disabled]~.radio__label::after,.ag-selection-checkbox__input[disabled]~.checkbox__label::after,.ag-selection-checkbox__input[disabled]~.radio__label::after,.checkbox__input[disabled]~.checkbox__label::after,.checkbox__input[disabled]~.radio__label::after,.radio__input[disabled]~.checkbox__label::after,.radio__input[disabled]~.radio__label::after{opacity:.4}.ag-input-wrapper__input:checked~.checkbox__label::before,.ag-input-wrapper__label--checked::before,.ag-selection-checkbox__input:checked~.checkbox__label::before,.ag-selection-checkbox__label--checked::before,.checkbox__input:checked~.checkbox__label::before,.checkbox__label--checked::before,.radio__input:checked~.checkbox__label::before,.radio__label--checked::before{background:0;left:.6rem;top:.3rem;width:.6rem;height:1rem;border:solid #fff;border-width:0 2px 2px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ag-input-wrapper__input:checked~.checkbox__label::after,.ag-input-wrapper__label--checked::after,.ag-selection-checkbox__input:checked~.checkbox__label::after,.ag-selection-checkbox__label--checked::after,.checkbox__input:checked~.checkbox__label::after,.checkbox__label--checked::after,.radio__input:checked~.checkbox__label::after,.radio__label--checked::after{background-image:linear-gradient(45deg,#5487fd 0,#a664fd 121%)}.ag-input-wrapper__header-label,.ag-selection-checkbox__header-label,.checkbox__header-label,.radio__header-label{display:block;position:relative;margin-bottom:1.1rem;color:#322d32;font-weight:300;font-size:1.6rem;letter-spacing:.04rem;line-height:1.5}.ag-input-wrapper__header-label .required,.ag-selection-checkbox__header-label .required,.checkbox__header-label .required,.radio__header-label .required{color:#656066;font-size:1.9rem;font-weight:700;margin-left:.8rem;position:absolute;top:.1rem}.ag-input-wrapper__validation-text,.ag-selection-checkbox__validation-text,.checkbox__validation-text,.radio__validation-text{color:#bf4252;display:block;font-size:1.2rem;letter-spacing:.04rem;margin-top:.1rem;padding:0 3.2rem}.radio__input:checked~.radio__label::before,.radio__label--checked::before{background:#fff;left:.6rem;top:.6rem;width:.6rem;height:.6rem}.radio__input:checked~.radio__label::after,.radio__label--checked::after{background-image:linear-gradient(45deg,#5487fd 0,#a664fd 121%)}.radio__label:hover{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.radio__label::after,.radio__label::before{border-radius:.7rem}.radio__input:hover+.radio__label{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(DataTableComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-table",
                templateUrl: "./data-table.component.html",
                styleUrls: [
                    "./data-table.component.scss",
                    "../radio-checkbox/radio-checkbox.component.scss",
                ],
                exportAs: "libDataTable",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [ServerSideDatasourceService, DataTableApiService],
            }]
    }], function () { return [{ type: DataTableApiService }, { type: ServerSideDatasourceService }, { type: ElementRef }]; }, { requestOptions: [{
            type: Input,
            args: ["requestOptions"]
        }], gridOptions: [{
            type: Input
        }], selectedRows: [{
            type: Input
        }], rowData: [{
            type: Input
        }], showNativePagination: [{
            type: Input
        }], useClassForChooser: [{
            type: Input
        }], selectionChanged: [{
            type: Output
        }], sortingChanged: [{
            type: Output
        }], columnVisibilityChanged: [{
            type: Output
        }], filteringChanged: [{
            type: Output
        }], filterModified: [{
            type: Output
        }], rowDataChanged: [{
            type: Output
        }], rowDataUpdated: [{
            type: Output
        }], pageChanged: [{
            type: Output
        }], gridReady: [{
            type: Output
        }], columnResized: [{
            type: Output
        }], libPagination: [{
            type: ViewChild,
            args: [PaginationComponent, { static: true }]
        }], pageSizeController: [{
            type: ViewChild,
            args: ["pageSizeController", { static: false }]
        }], gridRef: [{
            type: ViewChild,
            args: ["gridRef", { static: false }]
        }], showColumnsSwitcher: [{
            type: Input
        }], columnSwitcherTitle: [{
            type: Input
        }], columnSwitcherSelectAllTitle: [{
            type: Input
        }], showPageSizeController: [{
            type: Input
        }], showPageSizeChangeController: [{
            type: Input
        }], enableColumnResizing: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ["window:resize"]
        }] });

class PaginationModule {
}
/** @nocollapse */ PaginationModule.ngModuleDef = ɵɵdefineNgModule({ type: PaginationModule });
/** @nocollapse */ PaginationModule.ngInjectorDef = ɵɵdefineInjector({ factory: function PaginationModule_Factory(t) { return new (t || PaginationModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(PaginationModule, { declarations: [PaginationComponent], imports: [CommonModule], exports: [PaginationComponent] });
/*@__PURE__*/ ɵsetClassMetadata(PaginationModule, [{
        type: NgModule,
        args: [{
                declarations: [PaginationComponent],
                imports: [CommonModule],
                exports: [PaginationComponent]
            }]
    }], null, null);

class ColumnSwitcherModule {
}
/** @nocollapse */ ColumnSwitcherModule.ngModuleDef = ɵɵdefineNgModule({ type: ColumnSwitcherModule });
/** @nocollapse */ ColumnSwitcherModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ColumnSwitcherModule_Factory(t) { return new (t || ColumnSwitcherModule)(); }, imports: [[CommonModule, IconButtonModule, RadioCheckboxModule, SelectModule, OverlayscrollbarsModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ColumnSwitcherModule, { declarations: [ColumnSwitcherComponent], imports: [CommonModule, IconButtonModule, RadioCheckboxModule, SelectModule, OverlayscrollbarsModule], exports: [ColumnSwitcherComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ColumnSwitcherModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, IconButtonModule, RadioCheckboxModule, SelectModule, OverlayscrollbarsModule],
                declarations: [ColumnSwitcherComponent],
                exports: [ColumnSwitcherComponent]
            }]
    }], null, null);

class CustomPageSizeControllerModule {
}
/** @nocollapse */ CustomPageSizeControllerModule.ngModuleDef = ɵɵdefineNgModule({ type: CustomPageSizeControllerModule });
/** @nocollapse */ CustomPageSizeControllerModule.ngInjectorDef = ɵɵdefineInjector({ factory: function CustomPageSizeControllerModule_Factory(t) { return new (t || CustomPageSizeControllerModule)(); }, imports: [[
            CommonModule,
            ButtonModule,
            SelectModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(CustomPageSizeControllerModule, { declarations: [CustomPageSizeControllerComponent], imports: [CommonModule,
        ButtonModule,
        SelectModule], exports: [CustomPageSizeControllerComponent] });
/*@__PURE__*/ ɵsetClassMetadata(CustomPageSizeControllerModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomPageSizeControllerComponent],
                imports: [
                    CommonModule,
                    ButtonModule,
                    SelectModule
                ],
                exports: [CustomPageSizeControllerComponent]
            }]
    }], null, null);

class DateRangeModule {
}
/** @nocollapse */ DateRangeModule.ngModuleDef = ɵɵdefineNgModule({ type: DateRangeModule });
/** @nocollapse */ DateRangeModule.ngInjectorDef = ɵɵdefineInjector({ factory: function DateRangeModule_Factory(t) { return new (t || DateRangeModule)(); }, imports: [[
            CommonModule,
            BsDatepickerModule.forRoot(),
            InputModule,
            FormFieldsModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(DateRangeModule, { declarations: [DateRangeComponent, DatePickerWithConfirmationComponent], imports: [CommonModule, BsDatepickerModule, InputModule,
        FormFieldsModule,
        FormsModule,
        ReactiveFormsModule], exports: [DateRangeComponent] });
/*@__PURE__*/ ɵsetClassMetadata(DateRangeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BsDatepickerModule.forRoot(),
                    InputModule,
                    FormFieldsModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                declarations: [DateRangeComponent, DatePickerWithConfirmationComponent],
                exports: [DateRangeComponent]
            }]
    }], null, null);
ɵɵsetComponentScope(DateRangeComponent, [DateRangeComponent, DatePickerWithConfirmationComponent, NgClass, NgComponentOutlet, NgForOf, NgIf, NgTemplateOutlet, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgPlural, NgPluralCase, BsDatepickerContainerComponent, BsDatepickerDirective, BsDatepickerInlineContainerComponent, BsDatepickerInlineDirective, BsDatepickerInputDirective, BsDaterangepickerContainerComponent, BsDaterangepickerDirective, BsDaterangepickerInlineContainerComponent, BsDaterangepickerInlineDirective, BsDaterangepickerInputDirective, InputComponent, FormFieldsComponent, ɵangular_packages_forms_forms_z, NgSelectOption, ɵangular_packages_forms_forms_y, DefaultValueAccessor, NumberValueAccessor, RangeValueAccessor, CheckboxControlValueAccessor, SelectControlValueAccessor, SelectMultipleControlValueAccessor, RadioControlValueAccessor, NgControlStatus, NgControlStatusGroup, RequiredValidator, MinLengthValidator, MaxLengthValidator, PatternValidator, CheckboxRequiredValidator, EmailValidator, NgModel, NgModelGroup, NgForm, NgFormSelectorWarning, FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName], [AsyncPipe, UpperCasePipe, LowerCasePipe, JsonPipe, SlicePipe, DecimalPipe, PercentPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nPluralPipe, I18nSelectPipe, KeyValuePipe]);

class DataTableModule {
}
/** @nocollapse */ DataTableModule.ngModuleDef = ɵɵdefineNgModule({ type: DataTableModule });
/** @nocollapse */ DataTableModule.ngInjectorDef = ɵɵdefineInjector({ factory: function DataTableModule_Factory(t) { return new (t || DataTableModule)(); }, providers: [
        MessageService,
        DataTableApiService,
        ServerSideDatasourceService,
    ], imports: [[
            CommonModule,
            RouterModule,
            PopoverModule,
            LibPopoverModule,
            SelectModule,
            IconButtonModule,
            SkeletonModule,
            ProgressModule,
            PaginationModule,
            AgGridModule.withComponents([
                CustomHeaderComponent,
                SpanCellRendererComponent,
                LinkCellRendererComponent,
                TooltipCellRendererComponent,
                CustomFilterComponent,
                CustomLoadingOverlayComponent,
                CustomCellLoadingRendererComponent,
                PopoverCellRendererComponent
            ]),
            ColumnSwitcherModule,
            CustomPageSizeControllerModule,
            OverlayscrollbarsModule,
            FormsModule,
            DateRangeModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(DataTableModule, { declarations: [DataTableComponent,
        CustomHeaderComponent,
        SpanCellRendererComponent,
        LinkCellRendererComponent,
        TooltipCellRendererComponent,
        CustomFilterComponent,
        CustomLoadingOverlayComponent,
        CustomCellLoadingRendererComponent,
        PopoverCellRendererComponent], imports: [CommonModule,
        RouterModule,
        PopoverModule,
        LibPopoverModule,
        SelectModule,
        IconButtonModule,
        SkeletonModule,
        ProgressModule,
        PaginationModule, AgGridModule, ColumnSwitcherModule,
        CustomPageSizeControllerModule,
        OverlayscrollbarsModule,
        FormsModule,
        DateRangeModule], exports: [DataTableComponent] });
/*@__PURE__*/ ɵsetClassMetadata(DataTableModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DataTableComponent,
                    CustomHeaderComponent,
                    SpanCellRendererComponent,
                    LinkCellRendererComponent,
                    TooltipCellRendererComponent,
                    CustomFilterComponent,
                    CustomLoadingOverlayComponent,
                    CustomCellLoadingRendererComponent,
                    PopoverCellRendererComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    PopoverModule,
                    LibPopoverModule,
                    SelectModule,
                    IconButtonModule,
                    SkeletonModule,
                    ProgressModule,
                    PaginationModule,
                    AgGridModule.withComponents([
                        CustomHeaderComponent,
                        SpanCellRendererComponent,
                        LinkCellRendererComponent,
                        TooltipCellRendererComponent,
                        CustomFilterComponent,
                        CustomLoadingOverlayComponent,
                        CustomCellLoadingRendererComponent,
                        PopoverCellRendererComponent
                    ]),
                    ColumnSwitcherModule,
                    CustomPageSizeControllerModule,
                    OverlayscrollbarsModule,
                    FormsModule,
                    DateRangeModule
                ],
                providers: [
                    MessageService,
                    DataTableApiService,
                    ServerSideDatasourceService,
                ],
                entryComponents: [CustomHeaderComponent, CustomFilterComponent],
                exports: [DataTableComponent]
            }]
    }], null, null);

var ActionToolbarAccessoryType;
(function (ActionToolbarAccessoryType) {
    ActionToolbarAccessoryType["DIVIDER"] = "divider";
})(ActionToolbarAccessoryType || (ActionToolbarAccessoryType = {}));

const _c0$A = ["dropdownRef"];
const _c1$z = [1, "action-toolbar", "rad-theme--light"];
const _c2$v = [4, "ngFor", "ngForOf"];
const _c3$t = ["itemTemplate", ""];
const _c4$s = [4, "ngIf"];
const _c5$s = [4, "ngTemplateOutlet", "ngTemplateOutletContext"];
function ActionToolbarComponent_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c6$r = function (a0) { return { item: a0, parent: null }; };
function ActionToolbarComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ActionToolbarComponent_ng_container_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", _c5$s);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r720 = ɵɵnextContext().$implicit;
    ɵɵnextContext();
    const _r718 = ɵɵreference(3);
    ɵɵselect(1);
    ɵɵproperty("ngTemplateOutlet", _r718)("ngTemplateOutletContext", ɵɵpureFunction1(2, _c6$r, item_r720));
} }
function ActionToolbarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ActionToolbarComponent_ng_container_1_ng_container_1_Template, 2, 4, "ng-container", _c4$s);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r720 = ctx.$implicit;
    const ctx_r717 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngIf", ctx_r717.isVisibleItem(item_r720));
} }
const _c7$p = ["itemRef", ""];
const _c8$p = ["class", "action-rad-icon-button", "size", "large", "variant", "icon", 3, "btn--active", "click", 4, "ngIf"];
const _c9$n = ["lib-icon-btn", "", "action", "", 3, "type", "disabled", "btn--active", "click", 4, "ngIf"];
const _c10$m = ["class", "action-toolbar__item-button", 3, "action-toolbar__item-button--active", "disabled", "click", "mouseenter", 4, "ngIf"];
const _c11$j = [3, "reference", "positions", "config"];
const _c12$h = ["dropdownRef", ""];
const _c13$g = [1, "drop-down", "action-toolbar__drop-down"];
const _c14$f = ["class", "action-toolbar__drop-down-header", 4, "ngIf"];
const _c15$d = ["class", "action-toolbar__drop-down-item", 4, "ngFor", "ngForOf"];
const _c16$c = ["size", "large", "variant", "icon", 1, "action-rad-icon-button", 3, "click"];
function ActionToolbarComponent_ng_template_2_rad_icon_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r736 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "rad-icon-button", _c16$c);
    ɵɵstyling();
    ɵɵlistener("click", function ActionToolbarComponent_ng_template_2_rad_icon_button_2_Template_rad_icon_button_click_0_listener($event) { ɵɵrestoreView(_r736); const ctx_r737 = ɵɵnextContext(); const item_r725 = ctx_r737.item; const parent_r724 = ctx_r737.$implicit; const _r732 = ɵɵreference(8); const ctx_r735 = ɵɵnextContext(); return ctx_r735.onItemClicked($event, item_r725, _r732, parent_r724); });
    ɵɵpipe(1, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext().item;
    const _r732 = ɵɵreference(8);
    ɵɵclassProp("btn--active", _r732.showing);
    ɵɵstylingApply();
    ɵɵattribute("icon-name", item_r725.icon)("id", item_r725.htmlElementId)("disabled", ɵɵpipeBind1(1, 4, item_r725.isEnabledObservable) ? null : true);
} }
const _c17$c = ["lib-icon-btn", "", "action", "", 3, "type", "disabled", "click"];
function ActionToolbarComponent_ng_template_2_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r740 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c17$c);
    ɵɵstyling();
    ɵɵlistener("click", function ActionToolbarComponent_ng_template_2_button_3_Template_button_click_0_listener($event) { ɵɵrestoreView(_r740); const ctx_r741 = ɵɵnextContext(); const item_r725 = ctx_r741.item; const parent_r724 = ctx_r741.$implicit; const _r732 = ɵɵreference(8); const ctx_r739 = ɵɵnextContext(); return ctx_r739.onItemClicked($event, item_r725, _r732, parent_r724); });
    ɵɵpipe(1, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext().item;
    const _r732 = ɵɵreference(8);
    ɵɵclassProp("btn--active", _r732.showing);
    ɵɵstylingApply();
    ɵɵproperty("type", item_r725.icon)("disabled", ɵɵpipeBind1(1, 4, item_r725.isEnabledObservable) ? null : "disabled");
    ɵɵattribute("id", item_r725.htmlElementId);
} }
function ActionToolbarComponent_ng_template_2_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r744 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c17$c);
    ɵɵstyling();
    ɵɵlistener("click", function ActionToolbarComponent_ng_template_2_button_4_Template_button_click_0_listener($event) { ɵɵrestoreView(_r744); const ctx_r745 = ɵɵnextContext(); const item_r725 = ctx_r745.item; const parent_r724 = ctx_r745.$implicit; const _r732 = ɵɵreference(8); const ctx_r743 = ɵɵnextContext(); return ctx_r743.onItemClicked($event, item_r725, _r732, parent_r724); });
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext().item;
    const _r732 = ɵɵreference(8);
    const ctx_r729 = ɵɵnextContext();
    ɵɵclassProp("btn--active", _r732.showing);
    ɵɵstylingApply();
    ɵɵproperty("type", item_r725.icon)("disabled", ctx_r729.disabled(item_r725));
    ɵɵattribute("id", item_r725.htmlElementId);
} }
const _c18$b = [1, "action-toolbar__item-button", 3, "disabled", "click", "mouseenter"];
const _c19$a = ["class", "action-toolbar__item-drop-icon", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 4, "ngIf"];
const _c20$9 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "action-toolbar__item-drop-icon"];
const _c21$9 = ["id", "purpleGradient", "gradientUnits", "userSpaceOnUse", "x1", "5.4", "y1", "24.6", "x2", "24.2", "y2", "5.8"];
const _c22$9 = ["offset", "0", 2, "stop-color", "#4a7cff"];
const _c23$9 = ["offset", "1", 2, "stop-color", "#743fff"];
const _c24$8 = ["d", "M12.8 10c0 .1 0 .3-.1.4l-4.5 4.5c-.2.2-.5.2-.7 0s-.2-.5 0-.7l4.1-4.1-4.2-4.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.5 4.5c.1 0 .2.2.2.3z"];
function ActionToolbarComponent_ng_template_2_button_5__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c20$9);
    ɵɵelementStart(1, "linearGradient", _c21$9);
    ɵɵelement(2, "stop", _c22$9);
    ɵɵelement(3, "stop", _c23$9);
    ɵɵelementEnd();
    ɵɵelement(4, "path", _c24$8);
    ɵɵelementEnd();
} }
function ActionToolbarComponent_ng_template_2_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r749 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c18$b);
    ɵɵstyling();
    ɵɵlistener("click", function ActionToolbarComponent_ng_template_2_button_5_Template_button_click_0_listener($event) { ɵɵrestoreView(_r749); const ctx_r750 = ɵɵnextContext(); const item_r725 = ctx_r750.item; const parent_r724 = ctx_r750.$implicit; const _r732 = ɵɵreference(8); const ctx_r748 = ɵɵnextContext(); return ctx_r748.onItemClicked($event, item_r725, _r732, parent_r724); });
    ɵɵlistener("mouseenter", function ActionToolbarComponent_ng_template_2_button_5_Template_button_mouseenter_0_listener($event) { ɵɵrestoreView(_r749); const ctx_r752 = ɵɵnextContext(); const item_r725 = ctx_r752.item; const parent_r724 = ctx_r752.$implicit; const _r732 = ɵɵreference(8); const ctx_r751 = ɵɵnextContext(); return ctx_r751.onItemHover($event, item_r725, _r732, parent_r724); });
    ɵɵpipe(1, "async");
    ɵɵtext(2);
    ɵɵtemplate(3, ActionToolbarComponent_ng_template_2_button_5__svg_svg_3_Template, 5, 0, "svg", _c19$a);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext().item;
    const _r732 = ɵɵreference(8);
    const ctx_r730 = ɵɵnextContext();
    ɵɵclassProp("action-toolbar__item-button--active", ctx_r730.isDropdownActive(_r732));
    ɵɵstylingApply();
    ɵɵproperty("disabled", ɵɵpipeBind1(1, 5, item_r725.isEnabledObservable) ? null : true);
    ɵɵattribute("id", item_r725.htmlElementId);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", item_r725.label, " ");
    ɵɵselect(3);
    ɵɵproperty("ngIf", item_r725.items);
} }
const _c25$8 = [1, "action-toolbar__divider"];
function ActionToolbarComponent_ng_template_2_button_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", _c25$8);
    ɵɵelementContainerEnd();
} }
function ActionToolbarComponent_ng_template_2_button_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext(2).item;
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", item_r725.label, " ");
} }
function ActionToolbarComponent_ng_template_2_button_6__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c20$9);
    ɵɵelementStart(1, "linearGradient", _c21$9);
    ɵɵelement(2, "stop", _c22$9);
    ɵɵelement(3, "stop", _c23$9);
    ɵɵelementEnd();
    ɵɵelement(4, "path", _c24$8);
    ɵɵelementEnd();
} }
function ActionToolbarComponent_ng_template_2_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r759 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c18$b);
    ɵɵstyling();
    ɵɵlistener("click", function ActionToolbarComponent_ng_template_2_button_6_Template_button_click_0_listener($event) { ɵɵrestoreView(_r759); const ctx_r760 = ɵɵnextContext(); const item_r725 = ctx_r760.item; const parent_r724 = ctx_r760.$implicit; const _r732 = ɵɵreference(8); const ctx_r758 = ɵɵnextContext(); return ctx_r758.onItemClicked($event, item_r725, _r732, parent_r724); });
    ɵɵlistener("mouseenter", function ActionToolbarComponent_ng_template_2_button_6_Template_button_mouseenter_0_listener($event) { ɵɵrestoreView(_r759); const ctx_r762 = ɵɵnextContext(); const item_r725 = ctx_r762.item; const parent_r724 = ctx_r762.$implicit; const _r732 = ɵɵreference(8); const ctx_r761 = ɵɵnextContext(); return ctx_r761.onItemHover($event, item_r725, _r732, parent_r724); });
    ɵɵtemplate(1, ActionToolbarComponent_ng_template_2_button_6_ng_container_1_Template, 2, 0, "ng-container", _c4$s);
    ɵɵtemplate(2, ActionToolbarComponent_ng_template_2_button_6_ng_container_2_Template, 2, 1, "ng-container", _c4$s);
    ɵɵtemplate(3, ActionToolbarComponent_ng_template_2_button_6__svg_svg_3_Template, 5, 0, "svg", _c19$a);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext().item;
    const _r732 = ɵɵreference(8);
    const ctx_r731 = ɵɵnextContext();
    ɵɵclassProp("action-toolbar__item-button--active", ctx_r731.isDropdownActive(_r732));
    ɵɵstylingApply();
    ɵɵproperty("disabled", ctx_r731.disabled(item_r725));
    ɵɵattribute("id", item_r725.htmlElementId);
    ɵɵselect(1);
    ɵɵproperty("ngIf", ctx_r731.isDividerAccessory(item_r725));
    ɵɵselect(2);
    ɵɵproperty("ngIf", !ctx_r731.isDividerAccessory(item_r725));
    ɵɵselect(3);
    ɵɵproperty("ngIf", item_r725.items);
} }
const _c26$8 = [1, "action-toolbar__drop-down-header"];
function ActionToolbarComponent_ng_template_2_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c26$8);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r725 = ɵɵnextContext().item;
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", item_r725.label, " ");
} }
const _c27$8 = [1, "action-toolbar__drop-down-item"];
function ActionToolbarComponent_ng_template_2_div_11_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c28$8 = function (a0, a1) { return { $implicit: a0, item: a1 }; };
function ActionToolbarComponent_ng_template_2_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ActionToolbarComponent_ng_template_2_div_11_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", _c5$s);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const innerItem_r765 = ɵɵnextContext().$implicit;
    ɵɵnextContext();
    const _r732 = ɵɵreference(8);
    ɵɵnextContext();
    const _r718 = ɵɵreference(3);
    ɵɵselect(1);
    ɵɵproperty("ngTemplateOutlet", _r718)("ngTemplateOutletContext", ɵɵpureFunction2(2, _c28$8, _r732, innerItem_r765));
} }
function ActionToolbarComponent_ng_template_2_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c27$8);
    ɵɵtemplate(1, ActionToolbarComponent_ng_template_2_div_11_ng_container_1_Template, 2, 5, "ng-container", _c4$s);
    ɵɵelementEnd();
} if (rf & 2) {
    const innerItem_r765 = ctx.$implicit;
    const ctx_r734 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngIf", ctx_r734.isVisibleItem(innerItem_r765));
} }
const _c29$7 = { originX: "center", originY: "bottom", overlayX: "center", overlayY: "top", offsetY: 8 };
const _c30$6 = [_c29$7];
const _c31$6 = function (a5) { return { originX: "end", originY: "top", overlayX: "start", overlayY: "top", offsetY: 8, offsetX: a5 }; };
const _c32$6 = function (a0) { return [a0]; };
const _c33$4 = { maxHeight: "auto", height: "auto", minWidth: "30rem", width: "auto", hasBackdrop: false };
function ActionToolbarComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", null, _c7$p);
    ɵɵstyling();
    ɵɵtemplate(2, ActionToolbarComponent_ng_template_2_rad_icon_button_2_Template, 2, 6, "rad-icon-button", _c8$p);
    ɵɵtemplate(3, ActionToolbarComponent_ng_template_2_button_3_Template, 2, 6, "button", _c9$n);
    ɵɵtemplate(4, ActionToolbarComponent_ng_template_2_button_4_Template, 1, 4, "button", _c9$n);
    ɵɵtemplate(5, ActionToolbarComponent_ng_template_2_button_5_Template, 4, 7, "button", _c10$m);
    ɵɵtemplate(6, ActionToolbarComponent_ng_template_2_button_6_Template, 4, 6, "button", _c10$m);
    ɵɵelementStart(7, "lib-dropdown", _c11$j, _c12$h);
    ɵɵelementStart(9, "div", _c13$g);
    ɵɵstyling();
    ɵɵtemplate(10, ActionToolbarComponent_ng_template_2_div_10_Template, 2, 1, "div", _c14$f);
    ɵɵtemplate(11, ActionToolbarComponent_ng_template_2_div_11_Template, 2, 1, "div", _c15$d);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const parent_r724 = ctx.$implicit;
    const item_r725 = ctx.item;
    const _r726 = ɵɵreference(1);
    const ctx_r719 = ɵɵnextContext();
    ɵɵclassProp("action-toolbar__top-item", !parent_r724);
    ɵɵstylingApply();
    ɵɵselect(2);
    ɵɵproperty("ngIf", !parent_r724 && item_r725.isEnabledObservable && ctx_r719.isVisibleItem(item_r725) && item_r725.isRadiance);
    ɵɵselect(3);
    ɵɵproperty("ngIf", !parent_r724 && item_r725.isEnabledObservable && ctx_r719.isVisibleItem(item_r725) && !item_r725.isRadiance);
    ɵɵselect(4);
    ɵɵproperty("ngIf", !parent_r724 && !item_r725.isEnabledObservable && !item_r725.isRadiance);
    ɵɵselect(5);
    ɵɵproperty("ngIf", parent_r724 && item_r725.isEnabledObservable && !item_r725.isRadiance);
    ɵɵselect(6);
    ɵɵproperty("ngIf", parent_r724 && !item_r725.isEnabledObservable);
    ɵɵselect(7);
    ɵɵproperty("reference", _r726)("positions", !parent_r724 ? _c30$6 : ɵɵpureFunction1(14, _c32$6, ɵɵpureFunction1(12, _c31$6, 0 - 30)))("config", _c33$4);
    ɵɵselect(9);
    ɵɵclassProp("left", parent_r724);
    ɵɵstylingApply();
    ɵɵselect(10);
    ɵɵproperty("ngIf", !parent_r724 && ctx_r719.isVisibleItem(item_r725));
    ɵɵselect(11);
    ɵɵproperty("ngForOf", item_r725.items);
} }
class ActionToolbarComponent {
    constructor() { }
    ngOnInit() { }
    // all dropdowns in list after given dropdown will be made to hide
    // if not present all the dropdowns will be made to hide
    closeDropdowns(dropdown) {
        let dropdownPosition = -1;
        if (dropdown) {
            dropdownPosition = this.dropdowns.toArray().indexOf(dropdown);
        }
        this.dropdowns.forEach((item, index) => {
            if (index >= dropdownPosition) {
                item.hide();
                item.openSubDropdown = null;
            }
        });
    }
    onItemClicked($event, item, dropdown, parent) {
        $event.stopPropagation();
        if (!this.isAccessoryType(item) && !("items" in item)) {
            item.act();
            this.closeDropdowns();
            return;
        }
        // if parent is not there.....meaning top element is clicked
        // if its dropdown is already open just close all the opened dropdowns for it
        // if not close all the opened dropdowns first and then open dropdown for the clicked top element
        if (!parent) {
            if (dropdown.showing) {
                this.closeDropdowns();
            }
            else {
                this.closeDropdowns();
                dropdown.show();
            }
            return;
        }
        // if parent dropdown exists and clicked item's dropdown is hidden, check if there is already opened sub-dropdown for that parent
        // if there is already opened sub-dropdown, hide it along with its sub-dropdowns
        if (parent.openSubDropdown) {
            this.closeDropdowns(parent.openSubDropdown);
        }
        // And then show the clicked items's dropdown
        dropdown.show();
        parent.openSubDropdown = dropdown;
    }
    onItemHover($event, item, dropdown, parent) {
        $event.stopPropagation();
        // if parent dropdown exists and hovered item's dropdown is already opened, close the dropdown along with all of its subdropdowns
        if (dropdown.showing) {
            this.closeDropdowns(dropdown); // hide this dropdown and all its subdropdowns
            parent.openSubDropdown = null;
            return;
        }
        // if parent dropdown exists and hovered item's dropdown is hidden, check if there is already opened sub-dropdown for that parent
        // if there is already opened sub-dropdown, hide it along with its subdropdowns
        if (parent.openSubDropdown) {
            this.closeDropdowns(parent.openSubDropdown);
        }
        // And then show the hovered items's dropdown
        if ("items" in item) {
            dropdown.show();
        }
        parent.openSubDropdown = dropdown;
    }
    isDropdownActive(dropdown) {
        return dropdown.showing;
    }
    isVisibleItem(item) {
        let isVisible = true;
        if (item !== null && item.visible !== undefined) {
            isVisible =
                typeof item.visible === "function"
                    ? item.visible()
                    : item.visible || false;
        }
        return isVisible;
    }
    outsideClicked() {
        this.closeDropdowns();
    }
    disabled(item) {
        if (this.isAccessoryType(item)) {
            return true;
        }
        item = item;
        const isEnabled = typeof item.isEnabled === "function"
            ? item.isEnabled()
            : item.isEnabled || false;
        /* Note: as lib-icon-button is hooked to [attr.disabled],
           assigning null to it will remove the 'disabled' attribute,
           whereas any other value (true, false, '') will generate the
           'disabled' attribute, thus disabling the icon.
           https://stackoverflow.com/a/45256344 */
        return isEnabled ? null : true;
    }
    ngOnDestroy() {
        this.closeDropdowns(); // In case component is destroyed before the outsideClicked() method execution to hide dropdowns
    }
    isAccessoryType(item) {
        return item.hasOwnProperty("accessoryType");
    }
    isDividerAccessory(item) {
        return (this.isAccessoryType(item) &&
            item["accessoryType"] === ActionToolbarAccessoryType.DIVIDER);
    }
}
/** @nocollapse */ ActionToolbarComponent.ngComponentDef = ɵɵdefineComponent({ type: ActionToolbarComponent, selectors: [["lib-action-toolbar"]], factory: function ActionToolbarComponent_Factory(t) { return new (t || ActionToolbarComponent)(); }, viewQuery: function ActionToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$A, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dropdowns = _t);
    } }, hostBindings: function ActionToolbarComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("click", function ActionToolbarComponent_click_HostBindingHandler($event) { return ctx.outsideClicked(); }, false, ɵɵresolveDocument);
    } }, inputs: { items: "items" }, exportAs: ["libActionToolbar"], consts: 4, vars: 1, template: function ActionToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$z);
        ɵɵtemplate(1, ActionToolbarComponent_ng_container_1_Template, 2, 1, "ng-container", _c2$v);
        ɵɵelementEnd();
        ɵɵtemplate(2, ActionToolbarComponent_ng_template_2_Template, 12, 16, "ng-template", null, _c3$t, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [NgForOf, NgIf, NgTemplateOutlet, DropdownComponent, IconButtonComponent], pipes: [AsyncPipe], styles: [".action-toolbar{display:-webkit-box;display:flex}.action-toolbar rad-icon-button::part(\"button\"){-webkit-filter:none;filter:none}.action-toolbar__top-item{margin-right:20px}.action-toolbar__item-button{background-color:transparent;border:none;color:#5b575b;width:100%;display:-webkit-box;display:flex;letter-spacing:0;line-height:1.4;-webkit-box-pack:justify;justify-content:space-between;padding:8px 16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;font-size:16px}.action-toolbar__item-button:first-letter{text-transform:uppercase}.action-toolbar__item-button:focus{outline:0}.action-toolbar__item-button--active:not([disabled]),.action-toolbar__item-button:hover:not([disabled]){background-color:#edeffd}.action-toolbar__item-button:disabled{color:#c1c0c2}.action-toolbar__item-drop-icon{fill:#5b575b;height:22px;position:relative;right:-4px;width:22px}.action-toolbar__drop-down{position:relative;padding:8px 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.action-toolbar__drop-down.left{top:-15px;left:30px}.action-toolbar__drop-down-header{color:#5b575b;margin-bottom:8px;font-size:16px;font-weight:500;text-align:center}.action-toolbar__drop-down-header:first-letter{text-transform:uppercase}.action-toolbar .btn--active:not([disabled])::after{-webkit-transition:none!important;transition:none!important}.action-toolbar__divider{border-bottom:1px solid #5b575b75;width:100%}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(ActionToolbarComponent, [{
        type: Component,
        args: [{
                selector: "lib-action-toolbar",
                templateUrl: "./action-toolbar.component.html",
                styleUrls: ["./action-toolbar.component.scss"],
                exportAs: "libActionToolbar",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.Default,
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }], dropdowns: [{
            type: ViewChildren,
            args: ["dropdownRef"]
        }], outsideClicked: [{
            type: HostListener,
            args: ["document:click"]
        }] });

class ActionToolbarModule {
}
/** @nocollapse */ ActionToolbarModule.ngModuleDef = ɵɵdefineNgModule({ type: ActionToolbarModule });
/** @nocollapse */ ActionToolbarModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ActionToolbarModule_Factory(t) { return new (t || ActionToolbarModule)(); }, imports: [[CommonModule, IconButtonModule, SelectModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ActionToolbarModule, { declarations: [ActionToolbarComponent], imports: [CommonModule, IconButtonModule, SelectModule], exports: [ActionToolbarComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ActionToolbarModule, [{
        type: NgModule,
        args: [{
                declarations: [ActionToolbarComponent],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [CommonModule, IconButtonModule, SelectModule],
                exports: [ActionToolbarComponent],
            }]
    }], null, null);

var MetadataTypes;
(function (MetadataTypes) {
    MetadataTypes["STRING"] = "string";
    MetadataTypes["LINK"] = "link";
    MetadataTypes["TIMESTAMP"] = "timestamp";
    MetadataTypes["TIMESPAN"] = "timespan";
    MetadataTypes["LISTOFSTRINGS"] = "listofstrings";
    MetadataTypes["FILESIZE"] = "filesize";
    MetadataTypes["GAUGE"] = "gauge";
})(MetadataTypes || (MetadataTypes = {}));

const _c0$B = [1, "metadata-list__time-elap"];
const _c1$A = [1, "metadata-list__time-elap-item"];
const _c2$w = [1, "metadata-list__time-label"];
const _c3$u = [1, "metadata-list__time-amt"];
const _c4$t = [1, "metadata-list__timespan-title", 3, "title"];
class MetadataTimespanComponent {
    constructor() {
        this.modifier = "";
    }
}
/** @nocollapse */ MetadataTimespanComponent.ngComponentDef = ɵɵdefineComponent({ type: MetadataTimespanComponent, selectors: [["lib-metadata-timespan"]], factory: function MetadataTimespanComponent_Factory(t) { return new (t || MetadataTimespanComponent)(); }, inputs: { modifier: "modifier", key: "key", value: "value" }, consts: 28, vars: 5, template: function MetadataTimespanComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$B);
        ɵɵelementStart(1, "div", _c1$A);
        ɵɵelementStart(2, "span", _c2$w);
        ɵɵtext(3, "HRS");
        ɵɵelementEnd();
        ɵɵelementStart(4, "span", _c3$u);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", _c1$A);
        ɵɵelementStart(7, "span", _c2$w);
        ɵɵtext(8, "\u00A0");
        ɵɵelementEnd();
        ɵɵelementStart(9, "span", _c3$u);
        ɵɵtext(10, ":");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", _c1$A);
        ɵɵelementStart(12, "span", _c2$w);
        ɵɵtext(13, "MIN");
        ɵɵelementEnd();
        ɵɵelementStart(14, "span", _c3$u);
        ɵɵtext(15);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(16, "div", _c1$A);
        ɵɵelementStart(17, "span", _c2$w);
        ɵɵtext(18, "\u00A0");
        ɵɵelementEnd();
        ɵɵelementStart(19, "span", _c3$u);
        ɵɵtext(20, ":");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", _c1$A);
        ɵɵelementStart(22, "span", _c2$w);
        ɵɵtext(23, "SEC");
        ɵɵelementEnd();
        ɵɵelementStart(24, "span", _c3$u);
        ɵɵtext(25);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(26, "p", _c4$t);
        ɵɵtext(27);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(5);
        ɵɵtextInterpolate(ctx.value.hours);
        ɵɵselect(15);
        ɵɵtextInterpolate(ctx.value.minutes);
        ɵɵselect(25);
        ɵɵtextInterpolate(ctx.value.seconds);
        ɵɵselect(26);
        ɵɵproperty("title", ctx.key);
        ɵɵselect(27);
        ɵɵtextInterpolate(ctx.key);
    } }, styles: [".metadata-list__chart--label[_ngcontent-%COMP%], .metadata-list__chart--percent[_ngcontent-%COMP%], .metadata-list__chart--title[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.metadata-list__chart--percent[_ngcontent-%COMP%]{font-weight:400;letter-spacing:.4px;line-height:1.5}.metadata-list__chart--label[_ngcontent-%COMP%], .metadata-list__chart--title[_ngcontent-%COMP%]{font-weight:400;font-size:12px;letter-spacing:.34px;line-height:1.1666666667}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]{background-color:#00f}.metadata-list[_ngcontent-%COMP%]{display:-ms-grid;display:grid;background-color:#fff;box-shadow:0 6.25px 12.5px 0 rgba(0,0,0,.1);grid-gap:35px;-ms-grid-columns:([col-start] 1fr)[12];grid-template-columns:repeat(12,[col-start] 1fr);padding:50px 35px;position:relative}@media (max-width:834px){.metadata-list[_ngcontent-%COMP%]{display:block}}.metadata-list--names[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.metadata-list__loader[_ngcontent-%COMP%]{font-size:30px;text-align:center;padding:31.25px 21.875px;width:100%}.metadata-list__main-data[_ngcontent-%COMP%]{display:-ms-grid;display:grid;grid-column:col-start 1/span 8;-ms-grid-columns:([main-start] minmax(80px,1fr))[3];grid-template-columns:repeat(3,[main-start] minmax(80px,1fr));font-size:2.6em;grid-gap:60px 20px}.metadata-list__main-data--wide[_ngcontent-%COMP%]{grid-column:col-start 1/span 12;-ms-grid-columns:([main-start] minmax(80px,1fr))[4];grid-template-columns:repeat(4,[main-start] minmax(80px,1fr))}.metadata-list__main-data__pair[_ngcontent-%COMP%]:not(.metadata-list__main-data__pair--guage){overflow:hidden}@media (max-width:1279px){.metadata-list__main-data[_ngcontent-%COMP%]{grid-column:col-start 1/span 12}}@media (max-width:833px){.metadata-list__main-data__pair[_ngcontent-%COMP%]{-webkit-box-ordinal-group:101;order:100}.metadata-list__main-data[_ngcontent-%COMP%]{-ms-grid-columns:1fr 1fr;grid-template-columns:1fr 1fr}}@media (max-width:480px){.metadata-list__main-data[_ngcontent-%COMP%]{-ms-grid-column:1;grid-column:1;-ms-grid-columns:1fr;grid-template-columns:1fr}}.metadata-list__sub-data[_ngcontent-%COMP%]{border-left:1px solid #f0eff0;display:-ms-grid;display:grid;font-size:16px;grid-auto-rows:-webkit-max-content;grid-auto-rows:max-content;grid-column:col-start 9/span 4;grid-gap:36px 48px;-ms-grid-columns:([sub-start] 1fr)[2];grid-template-columns:repeat(2,[sub-start] 1fr);padding-left:30px;padding-top:13px}@media (max-width:1279px){.metadata-list__sub-data[_ngcontent-%COMP%]{border-left:0;border-top:1px solid #f0eff0;padding-left:0;padding-top:39px}}@media (min-width:833px) and (max-width:1279px){.metadata-list__sub-data[_ngcontent-%COMP%]{grid-column:col-start 1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:([sub-start] 1fr)[3];grid-template-columns:repeat(3,[sub-start] 1fr);margin-top:30px}}@media (max-width:833px){.metadata-list__sub-data[_ngcontent-%COMP%]{grid-column:col-start 1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:1fr 1fr;grid-template-columns:1fr 1fr}}@media (max-width:480px){.metadata-list__sub-data[_ngcontent-%COMP%]{-ms-grid-column:1;grid-column:1;-ms-grid-columns:1fr;grid-template-columns:1fr}}.metadata-list__sub-data__pair[_ngcontent-%COMP%]{overflow:hidden;padding:0}.metadata-list__sub-data__pair--wide[_ngcontent-%COMP%]{display:-ms-grid;display:grid;grid-column:sub-start 1/span 2;grid-gap:3px 36px;-ms-grid-columns:([pair-wide-start] 1fr)[2];grid-template-columns:repeat(2,[pair-wide-start] 1fr);margin-top:-13px}@media (min-width:833px) and (max-width:1279px){.metadata-list__sub-data__pair--wide[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-column-span:12;grid-column:1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:([pair-wide-start] 1fr)[3];grid-template-columns:repeat(3,[pair-wide-start] 1fr)}}@media (max-width:833px){.metadata-list__sub-data__pair--wide[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-column-span:12;grid-column:1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:([pair-wide-start]1fr)[2];grid-template-columns:repeat(2,[pair-wide-start],1fr);-webkit-box-ordinal-group:101;order:100}}@media (max-width:480px){.metadata-list__sub-data__pair--wide[_ngcontent-%COMP%]{display:block}}.metadata-list__title[_ngcontent-%COMP%]{font-size:26px;font-weight:300;grid-column:pair-wide-start 1/span 2;line-height:1.31;letter-spacing:.1875px;color:#322d32;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@media (min-width:833px) and (max-width:1279px){.metadata-list__title[_ngcontent-%COMP%]{grid-column:pair-wide-start 1/span 3}}.metadata-list__title--list[_ngcontent-%COMP%]{margin-bottom:5px}.metadata-list__title.small[_ngcontent-%COMP%]{font-size:16px}.metadata-list__filesize-title[_ngcontent-%COMP%], .metadata-list__timespan-title[_ngcontent-%COMP%]{font-size:12px;letter-spacing:.75px;line-height:1.17;color:#656066;margin:5px 0;padding:0 25px 6.25px;text-transform:uppercase}.metadata-list__popover[_ngcontent-%COMP%]{font-size:12px;letter-spacing:.75px;line-height:1.17;color:#656066;margin:5px 0}.metadata-list__value[_ngcontent-%COMP%]{font-size:26px;line-height:1.31;color:#322d32;margin:0;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.metadata-list__value.small[_ngcontent-%COMP%]{font-size:16px;line-height:1.6}.metadata-list__value.data-not-avaliable[_ngcontent-%COMP%]{padding:0 46px}.metadata-list__value[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;line-height:1.31;letter-spacing:.125px}.metadata-list__listofstrings-item[_ngcontent-%COMP%]:nth-child(2n+1){padding-right:18.75px}.metadata-list__list[_ngcontent-%COMP%]{max-width:142px;font-size:16px;line-height:1.75;color:#322d32;list-style-type:none;padding-left:0;margin:1.875px 1.875px 0 0}.metadata-list__list-item[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.metadata-list__time-elap[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin:0 1.25px}.metadata-list__time-elap-item[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center}.metadata-list__time-label[_ngcontent-%COMP%]{color:#787679;font-size:12px;line-height:1.17;letter-spacing:.75px;padding-bottom:1.25px}.metadata-list__time-amt[_ngcontent-%COMP%]{color:#312d32;font-size:26px;line-height:1.15;letter-spacing:.325px;padding:0 3.125px}.metadata-list__filesize[_ngcontent-%COMP%]{margin:12px 0 0}.metadata-list__filesize[_ngcontent-%COMP%]   .metadata-list__value-small[_ngcontent-%COMP%]{padding:0 33px}.metadata-list__session-type[_ngcontent-%COMP%]{padding:0 5px}.metadata-list__delivery-status[_ngcontent-%COMP%]{padding:0 1.625px}.metadata-list__chart[_ngcontent-%COMP%]{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:30px;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;position:relative;width:106px}.metadata-list__chart-container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;height:80px;position:relative;-webkit-transition:visibility linear .33s,opacity .33s linear;transition:visibility linear .33s,opacity .33s linear}.metadata-list__chart--gauge[_ngcontent-%COMP%]{position:absolute;top:-32px;width:140px}.metadata-list__chart[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{will-change:auto;stroke-width:3px;stroke-miterlimit:round;-webkit-transition:stroke-dashoffset 850ms ease-in-out;transition:stroke-dashoffset 850ms ease-in-out}.metadata-list__chart--percent[_ngcontent-%COMP%]{font-size:26px;position:relative;top:20px}.metadata-list__chart--title[_ngcontent-%COMP%]{color:#656066;letter-spacing:.12px;position:relative;top:33px}.metadata-list__chart--label[_ngcontent-%COMP%]{color:#d1cfd1;position:absolute;top:55px}"] });
/*@__PURE__*/ ɵsetClassMetadata(MetadataTimespanComponent, [{
        type: Component,
        args: [{
                selector: "lib-metadata-timespan",
                templateUrl: "./metadata-timespan.component.html",
                styleUrls: ["../metadata-list.component.scss"]
            }]
    }], function () { return []; }, { modifier: [{
            type: Input
        }], key: [{
            type: Input
        }], value: [{
            type: Input
        }] });

const _c0$C = ["stringItem"];
const _c1$B = ["linkItem"];
const _c2$x = ["timestampItem"];
const _c3$v = ["timespanItem"];
const _c4$u = ["filesizeItem"];
const _c5$t = ["listofstringsItem"];
const _c6$s = ["gaugeItem"];
const _c7$q = [1, "metadata-list"];
const _c8$q = ["class", "metadata-list__content", 4, "ngIf", "ngIfElse"];
const _c9$o = ["loader", ""];
const _c10$n = ["stringItem", ""];
const _c11$k = ["linkItem", ""];
const _c12$i = ["timestampItem", ""];
const _c13$h = ["timespanItem", ""];
const _c14$g = ["filesizeItem", ""];
const _c15$e = ["listofstringsItem", ""];
const _c16$d = ["gaugeItem", ""];
const _c17$d = ["width", "0", "height", "0"];
const _c18$c = ["id", "gradient", "gradientUnits", "objectBoundingBox", "x1", "0", "y1", "1", "x2", "1", "y2", "1"];
const _c19$b = ["stop-color", "#AA69FF"];
const _c20$a = ["offset", "100%", "stop-color", "#FF85A4"];
const _c21$a = [1, "metadata-list__content"];
const _c22$a = [1, "metadata-list__main-data", 3, "ngClass"];
const _c23$a = ["class", "metadata-list__main-data__pair", 3, "ngClass", "order", 4, "ngFor", "ngForOf"];
const _c24$9 = ["class", "metadata-list__sub-data", 4, "ngIf"];
const _c25$9 = [1, "metadata-list__main-data__pair", 3, "ngClass"];
const _c26$9 = [4, "ngTemplateOutlet", "ngTemplateOutletContext"];
function MetadataListComponent_ng_container_1_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c27$9 = function (a0) { return { "metadata-list__main-data__pair--guage": a0 }; };
function MetadataListComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c25$9);
    ɵɵstyling();
    ɵɵtemplate(1, MetadataListComponent_ng_container_1_div_2_ng_container_1_Template, 1, 0, "ng-container", _c26$9);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r788 = ctx.$implicit;
    const ctx_r786 = ɵɵnextContext(2);
    ɵɵstyleProp("order", item_r788.order);
    ɵɵstylingApply();
    ɵɵproperty("ngClass", ɵɵpureFunction1(4, _c27$9, item_r788.type === ctx_r786.metadataTypes.GAUGE));
    ɵɵselect(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r786.getTemplate(item_r788))("ngTemplateOutletContext", ctx_r786.getContext(item_r788));
} }
const _c28$9 = [1, "metadata-list__sub-data"];
const _c29$8 = ["class", "metadata-list__sub-data__pair", 3, "ngClass", 4, "ngFor", "ngForOf"];
const _c30$7 = [1, "metadata-list__sub-data__pair", 3, "ngClass"];
function MetadataListComponent_ng_container_1_section_3_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c31$7 = function (a0) { return { "metadata-list__sub-data__pair--wide": a0 }; };
function MetadataListComponent_ng_container_1_section_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c30$7);
    ɵɵtemplate(1, MetadataListComponent_ng_container_1_section_3_div_1_ng_container_1_Template, 1, 0, "ng-container", _c26$9);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r791 = ctx.$implicit;
    const ctx_r790 = ɵɵnextContext(3);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c31$7, item_r791.type === "listofstrings"));
    ɵɵselect(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r790.getTemplate(item_r791))("ngTemplateOutletContext", ctx_r790.getContext(item_r791, "small"));
} }
function MetadataListComponent_ng_container_1_section_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "section", _c28$9);
    ɵɵtemplate(1, MetadataListComponent_ng_container_1_section_3_div_1_Template, 2, 5, "div", _c29$8);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r787 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r787.data.additional);
} }
const _c32$7 = function (a0) { return { "metadata-list__main-data--wide": a0 }; };
function MetadataListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, _c21$a);
    ɵɵelementStart(1, "section", _c22$a);
    ɵɵtemplate(2, MetadataListComponent_ng_container_1_div_2_Template, 2, 6, "div", _c23$a);
    ɵɵelementEnd();
    ɵɵtemplate(3, MetadataListComponent_ng_container_1_section_3_Template, 2, 1, "section", _c24$9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r769 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c32$7, !ctx_r769.data.additional));
    ɵɵselect(2);
    ɵɵproperty("ngForOf", ctx_r769.data.main);
    ɵɵselect(3);
    ɵɵproperty("ngIf", ctx_r769.data.additional);
} }
const _c33$5 = [1, "metadata-list__loader"];
function MetadataListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c33$5);
    ɵɵtext(1, "loading...");
    ɵɵelementEnd();
} }
const _c34$4 = [3, "title"];
const _c35$4 = [4, "ngIf"];
const _c36$4 = ["class", "metadata-list__popover", 4, "ngIf"];
const _c37$4 = ["popoverSize", "large", "popoverTriggerEvents", "mouseenter:mouseleave", 3, "popoverLabel", "popoverTitle", "popoverPlacement", "popoverType", "adaptivePosition"];
const _c38$4 = ["inlinePopover", ""];
const _c39$4 = [3, "innerHtml", 4, "ngFor", "ngForOf"];
const _c40$4 = [3, "innerHtml"];
function MetadataListComponent_ng_template_4_ng_container_4_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "p", _c40$4);
} if (rf & 2) {
    const item_r803 = ctx.$implicit;
    ɵɵproperty("innerHtml", item_r803.label, ɵɵsanitizeHtml);
} }
function MetadataListComponent_ng_template_4_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-popover", _c37$4, _c38$4);
    ɵɵtemplate(3, MetadataListComponent_ng_template_4_ng_container_4_p_3_Template, 1, 1, "p", _c39$4);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const additionalInfo_r798 = ɵɵnextContext().additionalInfo;
    ɵɵselect(1);
    ɵɵproperty("popoverLabel", additionalInfo_r798.headerTitle)("popoverTitle", additionalInfo_r798.title)("popoverPlacement", additionalInfo_r798 == null ? null : additionalInfo_r798.popoverPlacement ? additionalInfo_r798.popoverPlacement : "auto")("popoverType", additionalInfo_r798 == null ? null : additionalInfo_r798.popoverType ? additionalInfo_r798.popoverType : "text")("adaptivePosition", true);
    ɵɵselect(3);
    ɵɵproperty("ngForOf", additionalInfo_r798.items);
} }
const _c41$3 = [1, "metadata-list__popover"];
const _c42$3 = ["popoverSize", "large", "popoverTriggerEvents", "mouseenter:mouseleave", 3, "popoverLabel", "popoverTitle", "popoverPlacement"];
const _c43$3 = ["blockPopover", ""];
function MetadataListComponent_ng_template_4_div_5_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "p", _c40$4);
} if (rf & 2) {
    const item_r807 = ctx.$implicit;
    ɵɵproperty("innerHtml", item_r807.label, ɵɵsanitizeHtml);
} }
function MetadataListComponent_ng_template_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c41$3);
    ɵɵelementStart(1, "lib-popover", _c42$3, _c43$3);
    ɵɵtemplate(3, MetadataListComponent_ng_template_4_div_5_p_3_Template, 1, 1, "p", _c39$4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const additionalInfo_r798 = ɵɵnextContext().additionalInfo;
    ɵɵselect(1);
    ɵɵproperty("popoverLabel", additionalInfo_r798.headerTitle)("popoverTitle", additionalInfo_r798.title)("popoverPlacement", additionalInfo_r798 == null ? null : additionalInfo_r798.popoverPlacement ? additionalInfo_r798.popoverPlacement : "auto");
    ɵɵselect(3);
    ɵɵproperty("ngForOf", additionalInfo_r798.items);
} }
function MetadataListComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3", _c34$4);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵelementStart(2, "p", _c34$4);
    ɵɵstyling();
    ɵɵtext(3);
    ɵɵtemplate(4, MetadataListComponent_ng_template_4_ng_container_4_Template, 4, 6, "ng-container", _c35$4);
    ɵɵelementEnd();
    ɵɵtemplate(5, MetadataListComponent_ng_template_4_div_5_Template, 4, 4, "div", _c36$4);
} if (rf & 2) {
    const key_r793 = ctx.key;
    const label_r794 = ctx.label;
    const value_r795 = ctx.value;
    const modifier_r796 = ctx.modifier;
    const showPopover_r797 = ctx.showPopover;
    const additionalInfo_r798 = ctx.additionalInfo;
    ɵɵclassMapInterpolate1("metadata-list__title ", modifier_r796, "");
    ɵɵstylingApply();
    ɵɵproperty("title", key_r793);
    ɵɵselect(1);
    ɵɵtextInterpolate(key_r793);
    ɵɵselect(2);
    ɵɵclassMapInterpolate1("metadata-list__value ", modifier_r796, "");
    ɵɵstylingApply();
    ɵɵproperty("title", label_r794 || value_r795);
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", value_r795, " ");
    ɵɵselect(4);
    ɵɵproperty("ngIf", (additionalInfo_r798 == null ? null : additionalInfo_r798.inline) && showPopover_r797);
    ɵɵselect(5);
    ɵɵproperty("ngIf", !(additionalInfo_r798 == null ? null : additionalInfo_r798.inline) && showPopover_r797);
} }
const _c44$3 = [3, "title", "innerHTML"];
function MetadataListComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3", _c34$4);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵelementStart(2, "p", _c44$3);
    ɵɵstyling();
    ɵɵelementEnd();
} if (rf & 2) {
    const key_r809 = ctx.key;
    const label_r810 = ctx.label;
    const value_r811 = ctx.value;
    const modifier_r812 = ctx.modifier;
    ɵɵclassMapInterpolate1("metadata-list__title ", modifier_r812, "");
    ɵɵstylingApply();
    ɵɵproperty("title", key_r809);
    ɵɵselect(1);
    ɵɵtextInterpolate(key_r809);
    ɵɵselect(2);
    ɵɵclassMapInterpolate1("metadata-list__value ", modifier_r812, "");
    ɵɵstylingApply();
    ɵɵproperty("title", label_r810 || value_r811)("innerHTML", value_r811, ɵɵsanitizeHtml);
} }
function MetadataListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3", _c34$4);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵelementStart(2, "p", _c34$4);
    ɵɵstyling();
    ɵɵpipe(3, "date");
    ɵɵtext(4);
    ɵɵpipe(5, "date");
    ɵɵelementEnd();
} if (rf & 2) {
    const key_r813 = ctx.key;
    const value_r815 = ctx.value;
    const modifier_r816 = ctx.modifier;
    ɵɵclassMapInterpolate1("metadata-list__title ", modifier_r816, "");
    ɵɵstylingApply();
    ɵɵproperty("title", key_r813);
    ɵɵselect(1);
    ɵɵtextInterpolate(key_r813);
    ɵɵselect(2);
    ɵɵclassMapInterpolate1("metadata-list__value ", modifier_r816, "");
    ɵɵstylingApply();
    ɵɵproperty("title", ɵɵpipeBind2(3, 8, value_r815, "yyyy-MM-dd HH:ss"));
    ɵɵselect(4);
    ɵɵtextInterpolate(ɵɵpipeBind2(5, 11, value_r815, "yyyy-MM-dd HH:ss"));
} }
const _c45$3 = [3, "key", "value", "modifier"];
function MetadataListComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-metadata-timespan", _c45$3);
} if (rf & 2) {
    const key_r817 = ctx.key;
    const value_r818 = ctx.value;
    const modifier_r819 = ctx.modifier;
    ɵɵproperty("key", key_r817)("value", value_r818)("modifier", modifier_r819);
} }
const _c46$3 = [1, "metadata-list__filesize"];
const _c47$3 = [1, "metadata-list__value", 3, "ngClass"];
const _c48$3 = [1, "metadata-list__filesize-title", 3, "title"];
const _c49$3 = function (a0) { return { "data-not-avaliable": a0 }; };
function MetadataListComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c46$3);
    ɵɵelementStart(1, "p", _c47$3);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "h3", _c48$3);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const key_r820 = ctx.key;
    const value_r821 = ctx.value;
    const modifier_r822 = ctx.isDataAvaliable;
    ɵɵselect(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(4, _c49$3, modifier_r822 !== null && modifier_r822 === false));
    ɵɵselect(2);
    ɵɵtextInterpolate(value_r821);
    ɵɵselect(3);
    ɵɵproperty("title", key_r820);
    ɵɵselect(4);
    ɵɵtextInterpolate(key_r820);
} }
const _c50$2 = [3, "class", "title", 4, "ngFor", "ngForOf"];
function MetadataListComponent_ng_template_14_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c34$4);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r827 = ctx.$implicit;
    const modifier_r825 = ɵɵnextContext().modifier;
    ɵɵclassMapInterpolate1("metadata-list__listofstrings-item metadata-list__value ", modifier_r825, "");
    ɵɵstylingApply();
    ɵɵproperty("title", item_r827);
    ɵɵselect(1);
    ɵɵtextInterpolate(item_r827);
} }
function MetadataListComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3", _c34$4);
    ɵɵstyling();
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵtemplate(2, MetadataListComponent_ng_template_14_div_2_Template, 2, 4, "div", _c50$2);
} if (rf & 2) {
    const key_r823 = ctx.key;
    const value_r824 = ctx.value;
    const modifier_r825 = ctx.modifier;
    ɵɵclassMapInterpolate1("metadata-list__title metadata-list__title--list ", modifier_r825, "");
    ɵɵstylingApply();
    ɵɵproperty("title", key_r823);
    ɵɵselect(1);
    ɵɵtextInterpolate(key_r823);
    ɵɵselect(2);
    ɵɵproperty("ngForOf", value_r824);
} }
const _c51$2 = [1, "metadata-list__chart-container"];
const _c52$2 = [1, "metadata-list__chart"];
const _c53$2 = [1, "metadata-list__chart--percent"];
const _c54$1 = [1, "metadata-list__chart--label"];
const _c55$1 = [1, "metadata-list__chart--title"];
const _c56$1 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 200 200", 1, "metadata-list__chart--gauge"];
const _c57$1 = ["stroke", "#BEBDBE", "d", "M41 149.5a77 77 0 1 1 117.93 0", "fill", "none", 1, "bg"];
const _c58$1 = ["stroke", "url(#gradient)", "d", "M41 149.5a77 77 0 1 1 117.93 0", "fill", "none", "stroke-dasharray", "350"];
function MetadataListComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c51$2);
    ɵɵelementStart(1, "div", _c52$2);
    ɵɵelementStart(2, "span", _c53$2);
    ɵɵtext(3);
    ɵɵpipe(4, "number");
    ɵɵelementEnd();
    ɵɵelementStart(5, "span", _c54$1);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementStart(7, "span", _c55$1);
    ɵɵtext(8);
    ɵɵelementEnd();
    ɵɵnamespaceSVG();
    ɵɵelementStart(9, "svg", _c56$1);
    ɵɵelement(10, "path", _c57$1);
    ɵɵelementStart(11, "path", _c58$1);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const key_r829 = ctx.key;
    const value_r830 = ctx.value;
    const label_r831 = ctx.label;
    const ctx_r785 = ɵɵnextContext();
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(4, 4, value_r830, "2.2-2"), " ");
    ɵɵselect(6);
    ɵɵtextInterpolate1(" ", label_r831, " ");
    ɵɵselect(8);
    ɵɵtextInterpolate1(" ", key_r829, " ");
    ɵɵselect(11);
    ɵɵstyleProp("stroke-dashoffset", ctx_r785.setCirclePercent(value_r830));
    ɵɵstylingApply();
} }
class MetadataListComponent {
    constructor() {
        this._isLoading = false;
        this.doneLoading = new EventEmitter();
        this.metadataTypes = MetadataTypes;
        this.SVC_LENGTH = 350;
        this.metaDataTypes = MetadataTypes;
    }
    set isLoading(value) {
        this._isLoading = value;
        if (this._isLoading) {
            this.doneLoading.emit();
        }
    }
    ngOnInit() { }
    getTemplate(item) {
        let template;
        switch (item.type) {
            case MetadataTypes.STRING:
                template = this.stringItem;
                break;
            case MetadataTypes.LINK:
                template = this.linkItem;
                break;
            case MetadataTypes.TIMESTAMP:
                template = this.timestampItem;
                break;
            case MetadataTypes.TIMESPAN:
                template = this.timespanItem;
                break;
            case MetadataTypes.FILESIZE:
                template = this.filesizeItem;
                break;
            case MetadataTypes.LISTOFSTRINGS:
                template = this.listofstringsItem;
                break;
            case MetadataTypes.GAUGE:
                template = this.gaugeItem;
                break;
        }
        return template;
    }
    getContext(item, modifier = "") {
        return Object.assign({}, item, { modifier });
    }
    setCirclePercent(value) {
        const actualLength = this.SVC_LENGTH * ((100 - value) / 100);
        return actualLength;
    }
}
/** @nocollapse */ MetadataListComponent.ngComponentDef = ɵɵdefineComponent({ type: MetadataListComponent, selectors: [["lib-metadata-list"]], factory: function MetadataListComponent_Factory(t) { return new (t || MetadataListComponent)(); }, viewQuery: function MetadataListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$C, true);
        ɵɵstaticViewQuery(_c1$B, true);
        ɵɵstaticViewQuery(_c2$x, true);
        ɵɵstaticViewQuery(_c3$v, true);
        ɵɵstaticViewQuery(_c4$u, true);
        ɵɵstaticViewQuery(_c5$t, true);
        ɵɵstaticViewQuery(_c6$s, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.stringItem = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.linkItem = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.timestampItem = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.timespanItem = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.filesizeItem = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.listofstringsItem = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.gaugeItem = _t.first);
    } }, inputs: { isLoading: "isLoading", data: "data" }, outputs: { doneLoading: "doneLoading" }, exportAs: ["libMetadataList"], consts: 23, vars: 2, template: function MetadataListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c7$q);
        ɵɵtemplate(1, MetadataListComponent_ng_container_1_Template, 4, 5, "ng-container", _c8$q);
        ɵɵelementEnd();
        ɵɵtemplate(2, MetadataListComponent_ng_template_2_Template, 2, 0, "ng-template", null, _c9$o, ɵɵtemplateRefExtractor);
        ɵɵtemplate(4, MetadataListComponent_ng_template_4_Template, 6, 10, "ng-template", null, _c10$n, ɵɵtemplateRefExtractor);
        ɵɵtemplate(6, MetadataListComponent_ng_template_6_Template, 3, 8, "ng-template", null, _c11$k, ɵɵtemplateRefExtractor);
        ɵɵtemplate(8, MetadataListComponent_ng_template_8_Template, 6, 14, "ng-template", null, _c12$i, ɵɵtemplateRefExtractor);
        ɵɵtemplate(10, MetadataListComponent_ng_template_10_Template, 1, 3, "ng-template", null, _c13$h, ɵɵtemplateRefExtractor);
        ɵɵtemplate(12, MetadataListComponent_ng_template_12_Template, 5, 6, "ng-template", null, _c14$g, ɵɵtemplateRefExtractor);
        ɵɵtemplate(14, MetadataListComponent_ng_template_14_Template, 3, 5, "ng-template", null, _c15$e, ɵɵtemplateRefExtractor);
        ɵɵtemplate(16, MetadataListComponent_ng_template_16_Template, 12, 7, "ng-template", null, _c16$d, ɵɵtemplateRefExtractor);
        ɵɵnamespaceSVG();
        ɵɵelementStart(18, "svg", _c17$d);
        ɵɵelementStart(19, "defs");
        ɵɵelementStart(20, "linearGradient", _c18$c);
        ɵɵelement(21, "stop", _c19$b);
        ɵɵelement(22, "stop", _c20$a);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r770 = ɵɵreference(3);
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.isLoading)("ngIfElse", _r770);
    } }, directives: [NgIf, NgClass, NgForOf, NgTemplateOutlet, LibPopoverComponent, MetadataTimespanComponent], pipes: [DatePipe, DecimalPipe], styles: [".metadata-list__chart--label,.metadata-list__chart--percent,.metadata-list__chart--title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.metadata-list__chart--percent{font-weight:400;letter-spacing:.4px;line-height:1.5}.metadata-list__chart--label,.metadata-list__chart--title{font-weight:400;font-size:12px;letter-spacing:.34px;line-height:1.1666666667}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}:host{background-color:#00f}.metadata-list{display:-ms-grid;display:grid;background-color:#fff;box-shadow:0 6.25px 12.5px 0 rgba(0,0,0,.1);grid-gap:35px;-ms-grid-columns:([col-start] 1fr)[12];grid-template-columns:repeat(12,[col-start] 1fr);padding:50px 35px;position:relative}@media (max-width:834px){.metadata-list{display:block}}.metadata-list--names{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.metadata-list__loader{font-size:30px;text-align:center;padding:31.25px 21.875px;width:100%}.metadata-list__main-data{display:-ms-grid;display:grid;grid-column:col-start 1/span 8;-ms-grid-columns:([main-start] minmax(80px,1fr))[3];grid-template-columns:repeat(3,[main-start] minmax(80px,1fr));font-size:2.6em;grid-gap:60px 20px}.metadata-list__main-data--wide{grid-column:col-start 1/span 12;-ms-grid-columns:([main-start] minmax(80px,1fr))[4];grid-template-columns:repeat(4,[main-start] minmax(80px,1fr))}.metadata-list__main-data__pair:not(.metadata-list__main-data__pair--guage){overflow:hidden}@media (max-width:1279px){.metadata-list__main-data{grid-column:col-start 1/span 12}}@media (max-width:833px){.metadata-list__main-data__pair{-webkit-box-ordinal-group:101;order:100}.metadata-list__main-data{-ms-grid-columns:1fr 1fr;grid-template-columns:1fr 1fr}}@media (max-width:480px){.metadata-list__main-data{-ms-grid-column:1;grid-column:1;-ms-grid-columns:1fr;grid-template-columns:1fr}}.metadata-list__sub-data{border-left:1px solid #f0eff0;display:-ms-grid;display:grid;font-size:16px;grid-auto-rows:-webkit-max-content;grid-auto-rows:max-content;grid-column:col-start 9/span 4;grid-gap:36px 48px;-ms-grid-columns:([sub-start] 1fr)[2];grid-template-columns:repeat(2,[sub-start] 1fr);padding-left:30px;padding-top:13px}@media (max-width:1279px){.metadata-list__sub-data{border-left:0;border-top:1px solid #f0eff0;padding-left:0;padding-top:39px}}@media (min-width:833px) and (max-width:1279px){.metadata-list__sub-data{grid-column:col-start 1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:([sub-start] 1fr)[3];grid-template-columns:repeat(3,[sub-start] 1fr);margin-top:30px}}@media (max-width:833px){.metadata-list__sub-data{grid-column:col-start 1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:1fr 1fr;grid-template-columns:1fr 1fr}}@media (max-width:480px){.metadata-list__sub-data{-ms-grid-column:1;grid-column:1;-ms-grid-columns:1fr;grid-template-columns:1fr}}.metadata-list__sub-data__pair{overflow:hidden;padding:0}.metadata-list__sub-data__pair--wide{display:-ms-grid;display:grid;grid-column:sub-start 1/span 2;grid-gap:3px 36px;-ms-grid-columns:([pair-wide-start] 1fr)[2];grid-template-columns:repeat(2,[pair-wide-start] 1fr);margin-top:-13px}@media (min-width:833px) and (max-width:1279px){.metadata-list__sub-data__pair--wide{-ms-grid-column:1;-ms-grid-column-span:12;grid-column:1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:([pair-wide-start] 1fr)[3];grid-template-columns:repeat(3,[pair-wide-start] 1fr)}}@media (max-width:833px){.metadata-list__sub-data__pair--wide{-ms-grid-column:1;-ms-grid-column-span:12;grid-column:1/span 12;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;-ms-grid-columns:([pair-wide-start]1fr)[2];grid-template-columns:repeat(2,[pair-wide-start],1fr);-webkit-box-ordinal-group:101;order:100}}@media (max-width:480px){.metadata-list__sub-data__pair--wide{display:block}}.metadata-list__title{font-size:26px;font-weight:300;grid-column:pair-wide-start 1/span 2;line-height:1.31;letter-spacing:.1875px;color:#322d32;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@media (min-width:833px) and (max-width:1279px){.metadata-list__title{grid-column:pair-wide-start 1/span 3}}.metadata-list__title--list{margin-bottom:5px}.metadata-list__title.small{font-size:16px}.metadata-list__filesize-title,.metadata-list__timespan-title{font-size:12px;letter-spacing:.75px;line-height:1.17;color:#656066;margin:5px 0;padding:0 25px 6.25px;text-transform:uppercase}.metadata-list__popover{font-size:12px;letter-spacing:.75px;line-height:1.17;color:#656066;margin:5px 0}.metadata-list__value{font-size:26px;line-height:1.31;color:#322d32;margin:0;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.metadata-list__value.small{font-size:16px;line-height:1.6}.metadata-list__value.data-not-avaliable{padding:0 46px}.metadata-list__value a{text-decoration:none;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;line-height:1.31;letter-spacing:.125px}.metadata-list__listofstrings-item:nth-child(2n+1){padding-right:18.75px}.metadata-list__list{max-width:142px;font-size:16px;line-height:1.75;color:#322d32;list-style-type:none;padding-left:0;margin:1.875px 1.875px 0 0}.metadata-list__list-item{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.metadata-list__time-elap{display:-webkit-box;display:flex;margin:0 1.25px}.metadata-list__time-elap-item{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center}.metadata-list__time-label{color:#787679;font-size:12px;line-height:1.17;letter-spacing:.75px;padding-bottom:1.25px}.metadata-list__time-amt{color:#312d32;font-size:26px;line-height:1.15;letter-spacing:.325px;padding:0 3.125px}.metadata-list__filesize{margin:12px 0 0}.metadata-list__filesize .metadata-list__value-small{padding:0 33px}.metadata-list__session-type{padding:0 5px}.metadata-list__delivery-status{padding:0 1.625px}.metadata-list__chart{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:30px;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;position:relative;width:106px}.metadata-list__chart-container{display:-webkit-box;display:flex;height:80px;position:relative;-webkit-transition:visibility linear .33s,opacity .33s linear;transition:visibility linear .33s,opacity .33s linear}.metadata-list__chart--gauge{position:absolute;top:-32px;width:140px}.metadata-list__chart svg path{will-change:auto;stroke-width:3px;stroke-miterlimit:round;-webkit-transition:stroke-dashoffset 850ms ease-in-out;transition:stroke-dashoffset 850ms ease-in-out}.metadata-list__chart--percent{font-size:26px;position:relative;top:20px}.metadata-list__chart--title{color:#656066;letter-spacing:.12px;position:relative;top:33px}.metadata-list__chart--label{color:#d1cfd1;position:absolute;top:55px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(MetadataListComponent, [{
        type: Component,
        args: [{
                selector: "lib-metadata-list",
                templateUrl: "./metadata-list.component.html",
                styleUrls: ["./metadata-list.component.scss"],
                exportAs: "libMetadataList",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { isLoading: [{
            type: Input
        }], data: [{
            type: Input
        }], doneLoading: [{
            type: Output
        }], stringItem: [{
            type: ViewChild,
            args: ["stringItem", { static: true }]
        }], linkItem: [{
            type: ViewChild,
            args: ["linkItem", { static: true }]
        }], timestampItem: [{
            type: ViewChild,
            args: ["timestampItem", { static: true }]
        }], timespanItem: [{
            type: ViewChild,
            args: ["timespanItem", { static: true }]
        }], filesizeItem: [{
            type: ViewChild,
            args: ["filesizeItem", { static: true }]
        }], listofstringsItem: [{
            type: ViewChild,
            args: ["listofstringsItem", { static: true }]
        }], gaugeItem: [{
            type: ViewChild,
            args: ["gaugeItem", { static: true }]
        }] });

class MetadataListModule {
}
/** @nocollapse */ MetadataListModule.ngModuleDef = ɵɵdefineNgModule({ type: MetadataListModule });
/** @nocollapse */ MetadataListModule.ngInjectorDef = ɵɵdefineInjector({ factory: function MetadataListModule_Factory(t) { return new (t || MetadataListModule)(); }, imports: [[CommonModule,
            LibPopoverModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(MetadataListModule, { declarations: [MetadataTimespanComponent, MetadataListComponent], imports: [CommonModule,
        LibPopoverModule], exports: [MetadataListComponent] });
/*@__PURE__*/ ɵsetClassMetadata(MetadataListModule, [{
        type: NgModule,
        args: [{
                declarations: [MetadataTimespanComponent, MetadataListComponent],
                imports: [CommonModule,
                    LibPopoverModule],
                exports: [MetadataListComponent]
            }]
    }], null, null);

const _c0$D = ["contentRef"];
const _c1$C = ["contentInnerRef"];
const _c2$y = [1, "accordion"];
const _c3$w = [1, "accordion__header", 3, "click"];
const _c4$v = [1, "accordion__icon"];
const _c5$u = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20"];
const _c6$t = ["fill", "#656066", "d", "M8.5 15a.5.5 0 01-.354-.853L12.293 10 8.146 5.854a.5.5 0 01.707-.707l4.5 4.5a.5.5 0 010 .707l-4.5 4.5A.498.498 0 018.5 15z", 4, "ngIf"];
const _c7$r = ["fill", "none", "fill-rule", "evenodd", "stroke", "#656066", "stroke-linecap", "round", "stroke-linejoin", "round", "d", "M5.5 8.5L10 13l4.5-4.5", 4, "ngIf"];
const _c8$r = [1, "accordion__header-text"];
const _c9$p = [1, "accordion__content", 3, "transitionend"];
const _c10$o = ["contentRef", ""];
const _c11$l = [1, "accordion__content-inner"];
const _c12$j = ["contentInnerRef", ""];
const _c13$i = ["fill", "#656066", "d", "M8.5 15a.5.5 0 01-.354-.853L12.293 10 8.146 5.854a.5.5 0 01.707-.707l4.5 4.5a.5.5 0 010 .707l-4.5 4.5A.498.498 0 018.5 15z"];
function AccordionExpanderComponent__svg_path_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "path", _c13$i);
} }
const _c14$h = ["fill", "none", "fill-rule", "evenodd", "stroke", "#656066", "stroke-linecap", "round", "stroke-linejoin", "round", "d", "M5.5 8.5L10 13l4.5-4.5"];
function AccordionExpanderComponent__svg_path_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelement(0, "path", _c14$h);
} }
const _c15$f = ["*"];
class AccordionExpanderComponent {
    constructor() {
        this.expanded = false;
    }
    ngOnInit() {
        if (this.expanded) {
            this.contentRef.nativeElement.classList.add("expanded");
        }
        else {
            this.contentRef.nativeElement.classList.add("collapsed");
        }
    }
    toggle() {
        this.expanded = !this.expanded;
        if (this.expanded) {
            this.contentRef.nativeElement.classList.remove("collapsed");
            this.contentRef.nativeElement.style.height = `${this.contentInnerRef.nativeElement.clientHeight}px`;
        }
        else {
            this.contentRef.nativeElement.style.height = `${this.contentInnerRef.nativeElement.clientHeight}px`;
            this.contentRef.nativeElement.classList.remove("expanded");
            setTimeout(() => {
                this.contentRef.nativeElement.style.height = `0px`;
            }, 10);
        }
    }
    transitionEnd() {
        if (this.expanded) {
            this.contentRef.nativeElement.classList.add("expanded");
            this.contentRef.nativeElement.style.height = "";
        }
        else {
            this.contentRef.nativeElement.classList.add("collapsed");
        }
    }
}
/** @nocollapse */ AccordionExpanderComponent.ngComponentDef = ɵɵdefineComponent({ type: AccordionExpanderComponent, selectors: [["lib-accordion-expander"]], factory: function AccordionExpanderComponent_Factory(t) { return new (t || AccordionExpanderComponent)(); }, viewQuery: function AccordionExpanderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$D, true);
        ɵɵstaticViewQuery(_c1$C, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.contentRef = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.contentInnerRef = _t.first);
    } }, inputs: { header: "header", expanded: "expanded" }, exportAs: ["libAccordionExpander"], ngContentSelectors: _c15$f, consts: 13, vars: 3, template: function AccordionExpanderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", _c2$y);
        ɵɵelementStart(1, "div", _c3$w);
        ɵɵlistener("click", function AccordionExpanderComponent_Template_div_click_1_listener($event) { return ctx.toggle(); });
        ɵɵelementStart(2, "div", _c4$v);
        ɵɵnamespaceSVG();
        ɵɵelementStart(3, "svg", _c5$u);
        ɵɵtemplate(4, AccordionExpanderComponent__svg_path_4_Template, 1, 0, "path", _c6$t);
        ɵɵtemplate(5, AccordionExpanderComponent__svg_path_5_Template, 1, 0, "path", _c7$r);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵnamespaceHTML();
        ɵɵelementStart(6, "div", _c8$r);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", _c9$p, _c10$o);
        ɵɵlistener("transitionend", function AccordionExpanderComponent_Template_div_transitionend_8_listener($event) { return ctx.transitionEnd(); });
        ɵɵelementStart(10, "div", _c11$l, _c12$j);
        ɵɵprojection(12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(4);
        ɵɵproperty("ngIf", !ctx.expanded);
        ɵɵselect(5);
        ɵɵproperty("ngIf", ctx.expanded);
        ɵɵselect(7);
        ɵɵtextInterpolate1(" ", ctx.header, " ");
    } }, directives: [NgIf], styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.accordion{display:block}.accordion__header{display:-webkit-box;display:flex;margin:.5rem 0 1rem;font-weight:400;font-size:1.6rem;line-height:1.43;letter-spacing:.04rem;color:#322d32;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.accordion__header-text{-webkit-box-flex:1;flex-grow:1;border-bottom:1px solid #f0eff0;padding-bottom:1.5rem}.accordion__icon{-webkit-box-flex:0;flex-grow:0;padding-right:3rem}.accordion__icon svg{width:2rem;height:2rem;vertical-align:baseline}.accordion__content{margin:.5rem 0 1rem 5rem;font-size:1.4rem;font-weight:300;line-height:1.43;letter-spacing:.04rem;color:#322d32;height:0;overflow:hidden;-webkit-transition:height .3s ease-in;transition:height .3s ease-in}.accordion__content.collapsed{visibility:hidden}.accordion__content.expanded{height:auto;overflow:visible}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(AccordionExpanderComponent, [{
        type: Component,
        args: [{
                selector: "lib-accordion-expander",
                templateUrl: "./accordion-expander.component.html",
                styleUrls: ["./accordion-expander.component.scss"],
                exportAs: "libAccordionExpander",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { header: [{
            type: Input
        }], expanded: [{
            type: Input
        }], contentRef: [{
            type: ViewChild,
            args: ["contentRef", { static: true }]
        }], contentInnerRef: [{
            type: ViewChild,
            args: ["contentInnerRef", { static: true }]
        }] });

class AccordionExpanderModule {
}
/** @nocollapse */ AccordionExpanderModule.ngModuleDef = ɵɵdefineNgModule({ type: AccordionExpanderModule });
/** @nocollapse */ AccordionExpanderModule.ngInjectorDef = ɵɵdefineInjector({ factory: function AccordionExpanderModule_Factory(t) { return new (t || AccordionExpanderModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(AccordionExpanderModule, { declarations: [AccordionExpanderComponent], imports: [CommonModule], exports: [AccordionExpanderComponent] });
/*@__PURE__*/ ɵsetClassMetadata(AccordionExpanderModule, [{
        type: NgModule,
        args: [{
                declarations: [AccordionExpanderComponent],
                imports: [CommonModule],
                exports: [AccordionExpanderComponent]
            }]
    }], null, null);

const _c0$E = ["tabNavWrapper"];
const _c1$D = [1, "tab-nav__wrapper", 3, "mousemove", "mousedown", "mouseup", "mousewheel"];
const _c2$z = ["tabNavWrapper", ""];
const _c3$x = [1, "tab-nav"];
const _c4$w = ["class", "tab-nav__item", 4, "ngFor", "ngForOf"];
const _c5$v = [1, "tab-nav__item"];
const _c6$u = ["href", "javascript:void(0)", 1, "tab-nav__link", 3, "routerLink", "queryParams", "title", "routerLinkActive", "routerLinkActiveOptions"];
const _c7$s = ["tab-nav__link--selected"];
const _c8$s = { exact: true };
function TabNavigationComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", _c5$v);
    ɵɵelementStart(1, "a", _c6$u);
    ɵɵstyling();
    ɵɵtext(2);
    ɵɵpipe(3, "uppercase");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const menuItem_r839 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵclassProp("tab-nav__link--disabled", menuItem_r839.disabled);
    ɵɵstylingApply();
    ɵɵproperty("routerLink", menuItem_r839.disabled ? null : menuItem_r839.route)("queryParams", menuItem_r839.disabled ? null : menuItem_r839.queryParams)("title", menuItem_r839.title ? menuItem_r839.title : menuItem_r839.label)("routerLinkActive", _c7$s)("routerLinkActiveOptions", _c8$s);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 7, menuItem_r839.label), " ");
} }
class TabNavigationComponent {
    constructor() { }
    onMouseMove(evt) {
        if (1 === evt.which) {
            evt.preventDefault();
            this.tabWrapper.nativeElement.scrollLeft -= evt.offsetX - this.scrollInitX;
        }
    }
    onMouseDown(evt) {
        this.scrollInitX = evt.offsetX;
    }
    onMouseUp(evt) {
        this.scrollInitX = 0;
    }
    onMouseWheel(evt) {
        evt.preventDefault();
        this.tabWrapper.nativeElement.scrollLeft += (evt.deltaY + evt.deltaX);
    }
    ngOnInit() {
    }
}
/** @nocollapse */ TabNavigationComponent.ngComponentDef = ɵɵdefineComponent({ type: TabNavigationComponent, selectors: [["lib-tab-nav"]], factory: function TabNavigationComponent_Factory(t) { return new (t || TabNavigationComponent)(); }, viewQuery: function TabNavigationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$E, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.tabWrapper = _t.first);
    } }, inputs: { menuItems: "menuItems" }, consts: 4, vars: 1, template: function TabNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$D, _c2$z);
        ɵɵlistener("mousemove", function TabNavigationComponent_Template_div_mousemove_0_listener($event) { return ctx.onMouseMove($event); });
        ɵɵlistener("mousedown", function TabNavigationComponent_Template_div_mousedown_0_listener($event) { return ctx.onMouseDown($event); });
        ɵɵlistener("mouseup", function TabNavigationComponent_Template_div_mouseup_0_listener($event) { return ctx.onMouseUp($event); });
        ɵɵlistener("mousewheel", function TabNavigationComponent_Template_div_mousewheel_0_listener($event) { return ctx.onMouseWheel($event); });
        ɵɵelementStart(2, "ul", _c3$x);
        ɵɵtemplate(3, TabNavigationComponent_li_3_Template, 4, 9, "li", _c4$w);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(3);
        ɵɵproperty("ngForOf", ctx.menuItems);
    } }, directives: [NgForOf, RouterLinkWithHref, RouterLinkActive], pipes: [UpperCasePipe], styles: [".tab-nav__item[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}.tab-nav__link--selected[_ngcontent-%COMP%]:not(.tab-nav__link--disabled), .tab-nav__link[_ngcontent-%COMP%]::after, .tab-nav__link[_ngcontent-%COMP%]:active:not(.tab-nav__link--disabled), .tab-nav__link[_ngcontent-%COMP%]:hover:not(.tab-nav__link--disabled){font-weight:700}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.tab-nav[_ngcontent-%COMP%]{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;flex-wrap:nowrap;list-style-type:none;margin:0;padding:0;text-align:center;text-transform:uppercase}.tab-nav__wrapper[_ngcontent-%COMP%]{overflow:scroll;padding:1rem 0;max-width:100%;scrollbar-width:none;-ms-overflow-style:none}.tab-nav__wrapper[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.tab-nav[_ngcontent-%COMP%]:first-of-type, .tab-nav[_ngcontent-%COMP%]:last-of-type{margin-left:0}.tab-nav[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.tab-nav__item[_ngcontent-%COMP%]{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286;list-style:none;margin:0 1.5rem}.tab-nav__link[_ngcontent-%COMP%]{color:#656066;text-decoration:none;white-space:nowrap}.tab-nav__link[_ngcontent-%COMP%]:focus{outline:0}.tab-nav__link--selected[_ngcontent-%COMP%]:not(.tab-nav__link--disabled), .tab-nav__link[_ngcontent-%COMP%]:active:not(.tab-nav__link--disabled){color:#322d32}.tab-nav__link--disabled[_ngcontent-%COMP%]{color:#d1cfd1;cursor:not-allowed}.tab-nav__link[_ngcontent-%COMP%]::after{display:block;content:attr(title);height:0;overflow:hidden;visibility:hidden}.tab-nav__link[_ngcontent-%COMP%]:hover:not(.tab-nav__link--disabled){background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}.tab-nav__link[_ngcontent-%COMP%]:active:not(.tab-nav__link--disabled){background-image:none;background-color:#322d32}"] });
/*@__PURE__*/ ɵsetClassMetadata(TabNavigationComponent, [{
        type: Component,
        args: [{
                selector: "lib-tab-nav",
                templateUrl: "./tab-navigation.component.html",
                styleUrls: ["./tab-navigation.component.scss"]
            }]
    }], function () { return []; }, { menuItems: [{
            type: Input
        }], tabWrapper: [{
            type: ViewChild,
            args: ["tabNavWrapper", { static: false }]
        }] });

class TabNavigationModule {
}
/** @nocollapse */ TabNavigationModule.ngModuleDef = ɵɵdefineNgModule({ type: TabNavigationModule });
/** @nocollapse */ TabNavigationModule.ngInjectorDef = ɵɵdefineInjector({ factory: function TabNavigationModule_Factory(t) { return new (t || TabNavigationModule)(); }, imports: [[CommonModule, RouterModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(TabNavigationModule, { declarations: [TabNavigationComponent], imports: [CommonModule, RouterModule], exports: [TabNavigationComponent] });
/*@__PURE__*/ ɵsetClassMetadata(TabNavigationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                declarations: [TabNavigationComponent],
                exports: [TabNavigationComponent]
            }]
    }], null, null);

const _c0$F = [1, "inline-select"];
const _c1$E = ["class", "inline-select__item", 4, "ngFor", "ngForOf"];
const _c2$A = [1, "inline-select__item"];
const _c3$y = ["href", "javascript:void(0)", 1, "inline-select__link", 3, "title", "click"];
function InlineSelectComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r843 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c2$A);
    ɵɵelementStart(1, "a", _c3$y);
    ɵɵstyling();
    ɵɵlistener("click", function InlineSelectComponent_li_1_Template_a_click_1_listener($event) { ɵɵrestoreView(_r843); const selectItem_r841 = ctx.$implicit; const ctx_r842 = ɵɵnextContext(); return ctx_r842.setActive(selectItem_r841); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const selectItem_r841 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵclassProp("inline-select__active", selectItem_r841.active);
    ɵɵstylingApply();
    ɵɵpropertyInterpolate("title", selectItem_r841.label);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", selectItem_r841.label, " ");
} }
class InlineSelectComponent {
    constructor() {
        this.selected = new EventEmitter();
        this.currentSelection = {};
    }
    setActive(newSelection) {
        if (newSelection.value === this.currentSelection.value) {
            return;
        }
        this.currentSelection.active = false;
        newSelection.active = true;
        this.currentSelection = newSelection;
        this.selected.emit(this.currentSelection);
    }
    getSelectedItem() {
        const activeItems = this.selectItems.filter(x => x.active);
        if (activeItems.length > 1) {
            throw new Error("Inline Select component cannot have multiple active elements");
        }
        return activeItems[0];
    }
    setInitialState() {
        const selectedItem = this.getSelectedItem();
        this.setActive(selectedItem);
    }
    ngAfterViewInit() {
        this.setInitialState();
    }
}
/** @nocollapse */ InlineSelectComponent.ngComponentDef = ɵɵdefineComponent({ type: InlineSelectComponent, selectors: [["lib-inline-select"]], factory: function InlineSelectComponent_Factory(t) { return new (t || InlineSelectComponent)(); }, inputs: { selectItems: "selectItems" }, outputs: { selected: "selected" }, consts: 2, vars: 1, template: function InlineSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ul", _c0$F);
        ɵɵtemplate(1, InlineSelectComponent_li_1_Template, 3, 3, "li", _c1$E);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngForOf", ctx.selectItems);
    } }, directives: [NgForOf], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.inline-select[_ngcontent-%COMP%]{display:-webkit-inline-box;display:inline-flex;padding-left:0;list-style-type:none;margin-bottom:0}.inline-select__item[_ngcontent-%COMP%]{margin-right:25px}.inline-select__item[_ngcontent-%COMP%]:last-child{margin-right:0}.inline-select__link[_ngcontent-%COMP%]{color:#5b575b;font-size:14px;font-weight:400;letter-spacing:0;line-height:1.4;text-decoration:none}.inline-select__active[_ngcontent-%COMP%]{color:#312d32;font-size:14px;font-weight:500;letter-spacing:0;line-height:1.4}"] });
/*@__PURE__*/ ɵsetClassMetadata(InlineSelectComponent, [{
        type: Component,
        args: [{
                selector: "lib-inline-select",
                templateUrl: "./inline-select.component.html",
                styleUrls: ["./inline-select.component.scss"]
            }]
    }], function () { return []; }, { selectItems: [{
            type: Input
        }], selected: [{
            type: Output
        }] });

class InlineSelectModule {
}
/** @nocollapse */ InlineSelectModule.ngModuleDef = ɵɵdefineNgModule({ type: InlineSelectModule });
/** @nocollapse */ InlineSelectModule.ngInjectorDef = ɵɵdefineInjector({ factory: function InlineSelectModule_Factory(t) { return new (t || InlineSelectModule)(); }, imports: [[
            CommonModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(InlineSelectModule, { declarations: [InlineSelectComponent], imports: [CommonModule], exports: [InlineSelectComponent] });
/*@__PURE__*/ ɵsetClassMetadata(InlineSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [InlineSelectComponent],
                imports: [
                    CommonModule
                ],
                exports: [InlineSelectComponent]
            }]
    }], null, null);

const _c0$G = [1, "side-navigation"];
const _c1$F = ["class", "side-navigation__row side-navigation__row--heading", 3, "routerLinkActive", "routerLinkActiveOptions", "ngClass", 4, "ngIf"];
const _c2$B = ["class", "side-navigation__row", 3, "routerLinkActive", "routerLinkActiveOptions", "ngClass", 4, "ngFor", "ngForOf"];
const _c3$z = [1, "side-navigation__row", "side-navigation__row--heading", 3, "routerLinkActive", "routerLinkActiveOptions", "ngClass"];
const _c4$x = ["href", "javascript:void(0)", 1, "side-navigation__link", 3, "routerLink", "routerLinkActive", "routerLinkActiveOptions", "ngClass", "click"];
const _c5$w = { exact: true };
const _c6$v = function (a0) { return { "side-navigation__row--active": a0 }; };
const _c7$t = function (a0) { return { "side-navigation__link--active": a0 }; };
function SidebarNavigationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r847 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c3$z);
    ɵɵelementStart(1, "a", _c4$x);
    ɵɵlistener("click", function SidebarNavigationComponent_div_1_Template_a_click_1_listener($event) { ɵɵrestoreView(_r847); const ctx_r846 = ɵɵnextContext(); return ctx_r846.reports.onClick ? ctx_r846.reports.onClick($event, ctx_r846.reports) : false; });
    ɵɵtext(2, "Summary");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r844 = ɵɵnextContext();
    ɵɵproperty("routerLinkActive", !!ctx_r844.reports.isSelected ? "" : "side-navigation__row--active")("routerLinkActiveOptions", _c5$w)("ngClass", ɵɵpureFunction1(7, _c6$v, ctx_r844.reports.isSelected && ctx_r844.reports.isSelected(ctx_r844.reports)));
    ɵɵselect(1);
    ɵɵproperty("routerLink", ctx_r844.reports.summaryRoute)("routerLinkActive", !!ctx_r844.reports.isSelected ? "" : "side-navigation__link--active")("routerLinkActiveOptions", _c5$w)("ngClass", ɵɵpureFunction1(9, _c7$t, ctx_r844.reports.isSelected && ctx_r844.reports.isSelected(ctx_r844.reports)));
} }
const _c8$t = [1, "side-navigation__row", 3, "routerLinkActive", "routerLinkActiveOptions", "ngClass"];
const _c9$q = [1, "side-navigation__sub-heading"];
const _c10$p = [1, "side-navigation__list"];
const _c11$m = ["class", "side-navigation__item", 4, "ngFor", "ngForOf"];
const _c12$k = [1, "side-navigation__item"];
function SidebarNavigationComponent_div_2_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r852 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", _c12$k);
    ɵɵelementStart(1, "a", _c4$x);
    ɵɵlistener("click", function SidebarNavigationComponent_div_2_li_4_Template_a_click_1_listener($event) { ɵɵrestoreView(_r852); const subSection_r850 = ctx.$implicit; return subSection_r850.onClick ? subSection_r850.onClick($event, subSection_r850) : false; });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const subSection_r850 = ctx.$implicit;
    const ctx_r849 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("routerLink", subSection_r850.route)("routerLinkActive", !!ctx_r849.reports.isSelected ? "" : "side-navigation__link--active")("routerLinkActiveOptions", _c5$w)("ngClass", ɵɵpureFunction1(5, _c7$t, subSection_r850.isSelected && subSection_r850.isSelected(subSection_r850)));
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", subSection_r850.title, " ");
} }
function SidebarNavigationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c8$t);
    ɵɵelementStart(1, "h4", _c9$q);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "ul", _c10$p);
    ɵɵtemplate(4, SidebarNavigationComponent_div_2_li_4_Template, 3, 7, "li", _c11$m);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const reportSection_r848 = ctx.$implicit;
    const ctx_r845 = ɵɵnextContext();
    ɵɵproperty("routerLinkActive", !!ctx_r845.reports.isSelected ? "" : "side-navigation__row--active")("routerLinkActiveOptions", _c5$w)("ngClass", ɵɵpureFunction1(5, _c6$v, reportSection_r848.isSelected && reportSection_r848.isSelected(reportSection_r848)));
    ɵɵselect(2);
    ɵɵtextInterpolate(reportSection_r848.title);
    ɵɵselect(4);
    ɵɵproperty("ngForOf", reportSection_r848.subReports);
} }
class SidebarNavigationComponent {
    constructor() {
        this.activeLinkClass = "side-navigation__link--active";
    }
    ngOnInit() {
    }
}
/** @nocollapse */ SidebarNavigationComponent.ngComponentDef = ɵɵdefineComponent({ type: SidebarNavigationComponent, selectors: [["lib-sidebar-nav"]], factory: function SidebarNavigationComponent_Factory(t) { return new (t || SidebarNavigationComponent)(); }, inputs: { reports: "reports" }, consts: 3, vars: 2, template: function SidebarNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$G);
        ɵɵtemplate(1, SidebarNavigationComponent_div_1_Template, 3, 11, "div", _c1$F);
        ɵɵtemplate(2, SidebarNavigationComponent_div_2_Template, 5, 7, "div", _c2$B);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.reports.isSummaryAvailable);
        ɵɵselect(2);
        ɵɵproperty("ngForOf", ctx.reports.sections);
    } }, directives: [NgIf, NgForOf, RouterLinkActive, NgClass, RouterLinkWithHref], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.side-navigation[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;max-width:210px;color:#9f9d9f}.side-navigation__row[_ngcontent-%COMP%]{border-bottom:1px solid #d1cfd1;padding:.9375rem 0 1.5625rem}.side-navigation__row--heading[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;text-transform:uppercase;color:#322d32;border-bottom:1px solid #d1cfd1;font-size:1.4rem;line-height:1.43;letter-spacing:.075rem;padding:2.0625rem 0}.side-navigation__row--active[_ngcontent-%COMP%]{background-color:#f9f9f9}.side-navigation__link[_ngcontent-%COMP%]{text-decoration:none;text-transform:uppercase;font-size:1.4rem;line-height:1.43;letter-spacing:.11875rem;color:#656066}.side-navigation__link[_ngcontent-%COMP%]:hover{background:linear-gradient(69deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;font-weight:700}.side-navigation__link--active[_ngcontent-%COMP%]{color:#000;font-weight:700}.side-navigation__sub-heading[_ngcontent-%COMP%]{display:block;padding:1rem 0;margin:0;font-size:1.6rem;font-weight:300;line-height:1.5;letter-spacing:.0375rem;color:#322d32;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.side-navigation__list[_ngcontent-%COMP%]{display:-webkit-box;display:flex;list-style-type:none;margin:0;padding:0}.side-navigation__item[_ngcontent-%COMP%]{display:inline-block;-webkit-box-flex:1;flex:1}"], changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(SidebarNavigationComponent, [{
        type: Component,
        args: [{
                selector: "lib-sidebar-nav",
                templateUrl: "./sidebar-navigation.component.html",
                styleUrls: ["./sidebar-navigation.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { reports: [{
            type: Input
        }] });

class SidebarNavigationModule {
}
/** @nocollapse */ SidebarNavigationModule.ngModuleDef = ɵɵdefineNgModule({ type: SidebarNavigationModule });
/** @nocollapse */ SidebarNavigationModule.ngInjectorDef = ɵɵdefineInjector({ factory: function SidebarNavigationModule_Factory(t) { return new (t || SidebarNavigationModule)(); }, imports: [[CommonModule, RouterModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(SidebarNavigationModule, { declarations: [SidebarNavigationComponent], imports: [CommonModule, RouterModule], exports: [SidebarNavigationComponent] });
/*@__PURE__*/ ɵsetClassMetadata(SidebarNavigationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                declarations: [SidebarNavigationComponent],
                exports: [SidebarNavigationComponent]
            }]
    }], null, null);

const _c0$H = [3, "selectLabel", "placeholder"];
const _c1$G = [3, "disabled", "values", "selectAllLabel", "valueChange"];
class MultiSelectComponent {
    constructor(cd) {
        this.cd = cd;
        this.values = [];
        this.allChecked = false;
        this.change = new EventEmitter();
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    set value(val) {
        if (!this.disabled) {
            if (val !== undefined) {
                this.values = val;
                this.onChange(val);
                this.onTouch(val);
                this.change.emit(val);
            }
        }
    }
    get value() {
        return this.values;
    }
    // set value programmatically
    writeValue(value) {
        this.values = value;
    }
    // On UI element value changes,
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // On Touch
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onOptionsChange($event) {
        this.value = $event;
    }
    ngOnInit() {
    }
}
/** @nocollapse */ MultiSelectComponent.ngComponentDef = ɵɵdefineComponent({ type: MultiSelectComponent, selectors: [["lib-multi-select"]], factory: function MultiSelectComponent_Factory(t) { return new (t || MultiSelectComponent)(ɵɵdirectiveInject(ChangeDetectorRef)); }, inputs: { selectAllLabel: "selectAllLabel", selectLabel: "selectLabel", placeholder: "placeholder", disabled: "disabled" }, outputs: { change: "change" }, features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MultiSelectComponent),
                multi: true
            }
        ])], consts: 2, vars: 5, template: function MultiSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "lib-select", _c0$H);
        ɵɵelementStart(1, "lib-multi-select-options", _c1$G);
        ɵɵlistener("valueChange", function MultiSelectComponent_Template_lib_multi_select_options_valueChange_1_listener($event) { return ctx.onOptionsChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("selectLabel", ctx.selectLabel)("placeholder", ctx.placeholder);
        ɵɵselect(1);
        ɵɵproperty("disabled", ctx.disabled)("values", ctx.values)("selectAllLabel", ctx.selectAllLabel);
    } }, styles: [""] });
/*@__PURE__*/ ɵsetClassMetadata(MultiSelectComponent, [{
        type: Component,
        args: [{
                selector: 'lib-multi-select',
                templateUrl: './multi-select.component.html',
                styleUrls: ['./multi-select.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MultiSelectComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ChangeDetectorRef }]; }, { selectAllLabel: [{
            type: Input
        }], selectLabel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], change: [{
            type: Output
        }] });

const _c0$I = [1, "drop-down-content__list", "drop-down-content__list--select"];
const _c1$H = ["class", "drop-down-content__item", 4, "ngIf"];
const _c2$C = ["class", "drop-down-content__item", 4, "ngFor", "ngForOf"];
const _c3$A = [1, "drop-down-content__item"];
const _c4$y = ["type", "checkbox", 3, "checked", "disabled", "change"];
function MultiSelectOptionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r856 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c3$A);
    ɵɵelementStart(1, "lib-radio-checkbox", _c4$y);
    ɵɵlistener("change", function MultiSelectOptionsComponent_div_1_Template_lib_radio_checkbox_change_1_listener($event) { ɵɵrestoreView(_r856); const ctx_r855 = ɵɵnextContext(); return ctx_r855.onSelectAllChange($event); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r853 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("checked", ctx_r853.allChecked)("disabled", ctx_r853.disabled);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", ctx_r853.selectAllLabel, " ");
} }
function MultiSelectOptionsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r860 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c3$A);
    ɵɵelementStart(1, "lib-radio-checkbox", _c4$y);
    ɵɵlistener("change", function MultiSelectOptionsComponent_div_2_Template_lib_radio_checkbox_change_1_listener($event) { ɵɵrestoreView(_r860); const i_r858 = ctx.index; const ctx_r859 = ɵɵnextContext(); return ctx_r859.onCheckboxChange(i_r858, $event); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const val_r857 = ctx.$implicit;
    const ctx_r854 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("checked", val_r857.selected)("disabled", ctx_r854.disabled);
    ɵɵselect(2);
    ɵɵtextInterpolate1(" ", val_r857.label, " ");
} }
class MultiSelectOptionsComponent {
    constructor() {
        this.allChecked = false;
        this.values = [];
        this.valueChange = new EventEmitter();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onCheckboxChange(index, $event) {
        let on = $event.target.checked;
        let values = this.values;
        values[index].selected = on;
        this.updateSelectAll();
        $event.stopPropagation();
        this.valueChange.emit(values);
    }
    ngOnChanges(changes) {
        if (this.values) {
            this.updateSelectAll();
        }
    }
    updateSelectAll() {
        let allSelected = true;
        this.values.forEach(value => {
            if (!value.selected) {
                allSelected = false;
                return;
            }
        });
        this.allChecked = allSelected;
    }
    onSelectAllChange($event) {
        let on = $event.target.checked;
        let values = this.values;
        values.forEach(element => {
            element.selected = on;
        });
        this.allChecked = on;
        $event.stopPropagation();
        this.valueChange.emit(values);
    }
    ngOnInit() {
        if (!this.selectAllLabel) {
            this.selectAllLabel = "SELECT ALL";
        }
    }
}
/** @nocollapse */ MultiSelectOptionsComponent.ngComponentDef = ɵɵdefineComponent({ type: MultiSelectOptionsComponent, selectors: [["lib-multi-select-options"]], factory: function MultiSelectOptionsComponent_Factory(t) { return new (t || MultiSelectOptionsComponent)(); }, inputs: { values: "values", selectAllLabel: "selectAllLabel", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, features: [ɵɵNgOnChangesFeature()], consts: 3, vars: 2, template: function MultiSelectOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "fieldset", _c0$I);
        ɵɵtemplate(1, MultiSelectOptionsComponent_div_1_Template, 3, 3, "div", _c1$H);
        ɵɵtemplate(2, MultiSelectOptionsComponent_div_2_Template, 3, 3, "div", _c2$C);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.values && ctx.values.length > 1);
        ɵɵselect(2);
        ɵɵproperty("ngForOf", ctx.values);
    } }, directives: [NgIf, NgForOf, RadioCheckboxComponent], styles: [".drop-down-wrapper-persist[_ngcontent-%COMP%]{margin-top:-10px}.drop-down-wrapper[_ngcontent-%COMP%]{text-align:center;height:60px;background-color:#fff;position:relative;z-index:1001}.drop-down-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:relative;z-index:1001;top:10px}.drop-down-title[_ngcontent-%COMP%]{font-size:1.4rem;font-weight:500;letter-spacing:.04rem;line-height:1.4285714286;padding-top:.5rem;padding-bottom:.5rem}.drop-down-content[_ngcontent-%COMP%]{margin-top:.65rem;height:calc(98% - 50px)}.drop-down-content__list[_ngcontent-%COMP%]{padding-left:3rem;list-style:none;text-align:left}.drop-down-content__list--select[_ngcontent-%COMP%]{padding-bottom:1rem;padding-left:2rem;padding-top:1rem}.drop-down-content__item[_ngcontent-%COMP%]{display:block;padding-right:3rem;padding-top:.9rem;padding-bottom:.9rem;position:relative;text-overflow:ellipsis}.drop-down-content__item.active-option[_ngcontent-%COMP%]{font-weight:700}.drop-down-content__item.active-option[_ngcontent-%COMP%]:before{color:#878288;font-weight:400;content:\"L\";-webkit-transform:scaleX(-1) rotate(-35deg);transform:scaleX(-1) rotate(-35deg);position:absolute;left:-20px;display:inline-block;top:3px}.relative[_ngcontent-%COMP%]{position:relative;height:100%;width:100%}.relative[_ngcontent-%COMP%]   .drop-down-content[_ngcontent-%COMP%]{height:100%}.cdk-overlay-pane[_ngcontent-%COMP%]{width:initial}.drop-down-account[_ngcontent-%COMP%]{position:relative;height:100%;min-width:22rem}"] });
/*@__PURE__*/ ɵsetClassMetadata(MultiSelectOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-multi-select-options',
                templateUrl: './multi-select-options.component.html',
                styleUrls: ['./multi-select-options.component.scss']
            }]
    }], function () { return []; }, { values: [{
            type: Input
        }], selectAllLabel: [{
            type: Input
        }], disabled: [{
            type: Input
        }], valueChange: [{
            type: Output
        }] });

class MultiSelectModule {
}
/** @nocollapse */ MultiSelectModule.ngModuleDef = ɵɵdefineNgModule({ type: MultiSelectModule });
/** @nocollapse */ MultiSelectModule.ngInjectorDef = ɵɵdefineInjector({ factory: function MultiSelectModule_Factory(t) { return new (t || MultiSelectModule)(); }, imports: [[
            CommonModule,
            RadioCheckboxModule,
            SelectModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(MultiSelectModule, { declarations: [MultiSelectComponent, MultiSelectOptionsComponent], imports: [CommonModule,
        RadioCheckboxModule,
        SelectModule], exports: [MultiSelectComponent] });
/*@__PURE__*/ ɵsetClassMetadata(MultiSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [MultiSelectComponent, MultiSelectOptionsComponent],
                imports: [
                    CommonModule,
                    RadioCheckboxModule,
                    SelectModule
                ],
                exports: [MultiSelectComponent]
            }]
    }], null, null);
ɵɵsetComponentScope(MultiSelectComponent, [MultiSelectComponent, MultiSelectOptionsComponent, NgClass, NgComponentOutlet, NgForOf, NgIf, NgTemplateOutlet, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgPlural, NgPluralCase, RadioCheckboxComponent, SelectComponent, OptionComponent, DropdownComponent, ClickOutsideDirective], [AsyncPipe, UpperCasePipe, LowerCasePipe, JsonPipe, SlicePipe, DecimalPipe, PercentPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nPluralPipe, I18nSelectPipe, KeyValuePipe, AutocompleteFilterPipe]);

class ChooserMessageService {
    constructor() {
        this.subject = new Subject();
    }
    sendMessage(message, data) {
        this.subject.next({ text: message, data });
    }
    clearMessages() {
        this.subject.next();
    }
    getMessage() {
        return this.subject.asObservable();
    }
}
/** @nocollapse */ ChooserMessageService.ngInjectableDef = ɵɵdefineInjectable({ token: ChooserMessageService, factory: function ChooserMessageService_Factory(t) { return new (t || ChooserMessageService)(); }, providedIn: 'root' });
/*@__PURE__*/ ɵsetClassMetadata(ChooserMessageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null);

const _c0$J = [1, "dnd-list"];
const _c1$I = [1, "dnd-list__selections-right"];
const _c2$D = ["class", "dnd-list__selections-right-title", 4, "ngIf"];
const _c3$B = [1, "dnd-list__selections-right-row"];
const _c4$z = [1, "dnd-list__selections-pool-col", 3, "dragover", "drop"];
const _c5$x = [1, "dnd-list__selections-pool-col__header"];
const _c6$w = ["class", "dnd-list__selections-pool-col__title", 4, "ngIf"];
const _c7$u = ["class", "dnd-list__selections-pool-col__header-sort", "lib-btn", "", "small", "", "link", "", 3, "click", 4, "ngIf"];
const _c8$u = ["class", "dnd-list__selections-pool-col__header-clear", "lib-btn", "", "small", "", "link", "", 3, "click", 4, "ngIf"];
const _c9$r = [3, "ngModel", "fieldName", "itemClass", "itemActiveClass", "itemTemplate", "wrapperClass", "placeholderClass", "placeholderItem", "ngModelChange", "onChange"];
const _c10$q = ["itemTemplate", ""];
const _c11$n = [1, "dnd-list__selections-right-title"];
function DndListComponent_h5_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h5", _c11$n);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r861 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r861.componentTitle, " ");
} }
const _c12$l = [1, "dnd-list__selections-pool-col__title"];
function DndListComponent_h6_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h6", _c12$l);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r862 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r862.listTitleLeft, " ");
} }
const _c13$j = ["lib-btn", "", "small", "", "link", "", 1, "dnd-list__selections-pool-col__header-sort", 3, "click"];
function DndListComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r871 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c13$j);
    ɵɵlistener("click", function DndListComponent_a_7_Template_a_click_0_listener($event) { ɵɵrestoreView(_r871); const ctx_r870 = ɵɵnextContext(); return ctx_r870.sortItems(true); });
    ɵɵtext(1, " sort ");
    ɵɵelementEnd();
} }
const _c14$i = ["lib-btn", "", "small", "", "link", "", 1, "dnd-list__selections-pool-col__header-clear", 3, "click"];
function DndListComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r873 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c14$i);
    ɵɵlistener("click", function DndListComponent_a_8_Template_a_click_0_listener($event) { ɵɵrestoreView(_r873); const ctx_r872 = ɵɵnextContext(); return ctx_r872.clearList(true); });
    ɵɵtext(1, " clear ");
    ɵɵelementEnd();
} }
function DndListComponent_h6_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h6", _c12$l);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r865 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r865.listTitleRight, " ");
} }
function DndListComponent_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r875 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c13$j);
    ɵɵlistener("click", function DndListComponent_a_13_Template_a_click_0_listener($event) { ɵɵrestoreView(_r875); const ctx_r874 = ɵɵnextContext(); return ctx_r874.sortItems(); });
    ɵɵtext(1, " sort ");
    ɵɵelementEnd();
} }
function DndListComponent_a_14_Template(rf, ctx) { if (rf & 1) {
    const _r877 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c14$i);
    ɵɵlistener("click", function DndListComponent_a_14_Template_a_click_0_listener($event) { ɵɵrestoreView(_r877); const ctx_r876 = ɵɵnextContext(); return ctx_r876.clearList(); });
    ɵɵtext(1, " clear ");
    ɵɵelementEnd();
} }
const _c15$g = [1, "dnd-list__selections-pool-col__item-name"];
const _c16$e = ["lib-icon-btn", "", "icon", "", "iconType", "ellipsis", 1, "dnd-list__selections-pool-col__item-button-more"];
const _c17$e = ["lib-icon-btn", "", "icon", "", "iconType", "close-small", 1, "dnd-list__selections-pool-col__item-button-close", 3, "click"];
function DndListComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    const _r881 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "p", _c15$g);
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵelement(2, "button", _c16$e);
    ɵɵelementStart(3, "button", _c17$e);
    ɵɵlistener("click", function DndListComponent_ng_template_16_Template_button_click_3_listener($event) { ɵɵrestoreView(_r881); const item_r878 = ctx.item; const ctx_r880 = ɵɵnextContext(); return ctx_r880.removeItem(item_r878); });
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r878 = ctx.item;
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", item_r878.initData.biosample, " ");
} }
class DndListComponent {
    constructor(messageService) {
        this.messageService = messageService;
        // ────────────────────────────────────────────────────────────────────────────────
        // Titles
        this.componentTitle = "Create Pairs";
        this.listTitleLeft = "POOL A SAMPLES";
        this.listTitleRight = "POOL B SAMPLES";
        this.firstListData = [];
        this.secondListData = [];
        // ────────────────────────────────────────────────────────────────────────────────
        // Drag & drop configs
        /** field name if input array consists of objects */
        this.fieldName = "biosample";
        /** class name for items wrapper */
        this.wrapperClass = "dnd-list__selections-pool-col__list";
        /** style object for items wrapper */
        this.wrapperStyle = {};
        /** class name for item */
        this.itemClass = "dnd-list__selections-pool-col__item";
        /** style object for item */
        this.itemStyle = {};
        /** class name for active item */
        this.itemActiveClass = "dnd-list__selections-pool-col__item-active";
        /** style object for active item */
        this.itemActiveStyle = {};
        /** class name for placeholder */
        this.placeholderClass = "dnd-list__selections-pool-col__drag-item";
        /** style object for placeholder */
        this.placeholderStyle = {};
        /** placeholder item which will be shown if collection is empty */
        this.placeholderItem = "DRAG & DROP ITEMS HERE";
        /** fired on array change (reordering, insert, remove), same as <code>ngModelChange</code>.
         *  Returns new items collection as a payload.
         */
        /* tslint:disable-next-line: no-any */
        // tslint:disable-next-line: no-output-on-prefix
        this.onChange = new EventEmitter();
        this.rowsForDeselect = new EventEmitter();
        this.initialCollectionLength = 0;
        this.initialFirstCollectionState = [];
        this.initialSecondCollectionState = [];
        this.dataFromTable = [];
        this.isFirstListAscOrder = true;
        this.isSecondListAscOrder = true;
        this.messageSubscription = this.messageService
            .getMessage()
            .subscribe((message) => {
            this.dataFromTable = [];
            message.data = this.prepareData(message.data);
            this.dataFromTable = this.dataFromTable.concat(message.data);
        });
    }
    ngOnInit() {
        this.initialCollectionLength = this.firstListData.length;
        this.initialFirstCollectionState = [...this.firstListData];
        this.initialSecondCollectionState = [...this.secondListData];
    }
    ngOnChanges(changes) { }
    onDragOver(event) {
        const dragSupported = event.dataTransfer.length;
        if (dragSupported) {
            event.dataTransfer.dropEffect = "move";
        }
        event.preventDefault();
    }
    onDrop(event, isLeft = true) {
        if (this.dataFromTable.length > 0) {
            const listKey = this.getList(isLeft);
            this[listKey] = this[listKey].concat(this.dataFromTable);
            this.dataFromTable = [];
            return;
        }
        const userAgent = window.navigator.userAgent;
        const isIE = userAgent.indexOf("Trident/") >= 0;
        let jsonData = event.dataTransfer.getData(isIE ? "text" : "application/json");
        try {
            jsonData = JSON.parse(jsonData);
        }
        catch (error) {
            return;
        }
        if (!Array.isArray(jsonData)) {
            this.putDataIntoList([jsonData], isLeft);
        }
        event.preventDefault();
    }
    onChangeLeft(data) { }
    onChangeRight(data) { }
    removeItem(item) {
        if (this.firstListData.includes(item.initData)) {
            this.rowsForDeselect.emit([item.initData]);
            this.firstListData = this.firstListData.filter(x => x._id !== item.initData._id);
        }
        else {
            this.rowsForDeselect.emit([item.initData]);
            this.secondListData = this.secondListData.filter(x => x._id !== item.initData._id);
        }
    }
    sortItems(isLeft) {
        if (!!isLeft) {
            if (this.isFirstListAscOrder) {
                this.firstListData = [
                    ...this.firstListData.sort(this.compareValues("biosample", "asc"))
                ];
                this.isFirstListAscOrder = false;
            }
            else {
                this.firstListData = [
                    ...this.firstListData.sort(this.compareValues("biosample", "desc"))
                ];
                this.isFirstListAscOrder = true;
            }
            return;
        }
        if (this.isSecondListAscOrder) {
            this.secondListData = [
                ...this.secondListData.sort(this.compareValues("biosample", "asc"))
            ];
            this.isSecondListAscOrder = false;
        }
        else {
            this.secondListData = [
                ...this.secondListData.sort(this.compareValues("biosample", "desc"))
            ];
            this.isSecondListAscOrder = true;
        }
    }
    clearList(isLeft) {
        if (!!isLeft) {
            this.rowsForDeselect.emit(this.firstListData);
            this.firstListData = [];
            return;
        }
        this.rowsForDeselect.emit(this.secondListData);
        this.secondListData = [];
    }
    putDataIntoList(items, isLeft = true) {
        const column = this.getList(isLeft);
        items = this.prepareData(items);
        this[column] = this[column].concat(items);
    }
    getList(isLeft) {
        return isLeft ? "firstListData" : "secondListData";
    }
    prepareData(data) {
        data = data.map((item) => {
            if (item._id !== undefined) {
                return item;
            }
            return Object.assign({}, item, { _id: "_" +
                    Math.random()
                        .toString(36)
                        .substr(2, 9) });
        });
        return data;
    }
    compareValues(key, order = "asc") {
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                return 0;
            }
            const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
            const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            }
            else if (varA < varB) {
                comparison = -1;
            }
            return order === "desc" ? comparison * -1 : comparison;
        };
    }
}
/** @nocollapse */ DndListComponent.ngComponentDef = ɵɵdefineComponent({ type: DndListComponent, selectors: [["lib-dnd-list"]], factory: function DndListComponent_Factory(t) { return new (t || DndListComponent)(ɵɵdirectiveInject(ChooserMessageService)); }, inputs: { componentTitle: "componentTitle", listTitleLeft: "listTitleLeft", listTitleRight: "listTitleRight", firstListData: "firstListData", secondListData: "secondListData", fieldName: "fieldName", wrapperClass: "wrapperClass", wrapperStyle: "wrapperStyle", itemClass: "itemClass", itemStyle: "itemStyle", itemActiveClass: "itemActiveClass", itemActiveStyle: "itemActiveStyle", placeholderClass: "placeholderClass", placeholderStyle: "placeholderStyle", placeholderItem: "placeholderItem" }, outputs: { onChange: "onChange", rowsForDeselect: "rowsForDeselect" }, features: [ɵɵNgOnChangesFeature()], consts: 18, vars: 23, template: function DndListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$J);
        ɵɵelementStart(1, "div", _c1$I);
        ɵɵtemplate(2, DndListComponent_h5_2_Template, 2, 1, "h5", _c2$D);
        ɵɵelementStart(3, "div", _c3$B);
        ɵɵelementStart(4, "div", _c4$z);
        ɵɵlistener("dragover", function DndListComponent_Template_div_dragover_4_listener($event) { return ctx.onDragOver($event); });
        ɵɵlistener("drop", function DndListComponent_Template_div_drop_4_listener($event) { return ctx.onDrop($event, true); });
        ɵɵelementStart(5, "div", _c5$x);
        ɵɵtemplate(6, DndListComponent_h6_6_Template, 2, 1, "h6", _c6$w);
        ɵɵtemplate(7, DndListComponent_a_7_Template, 2, 0, "a", _c7$u);
        ɵɵtemplate(8, DndListComponent_a_8_Template, 2, 0, "a", _c8$u);
        ɵɵelementEnd();
        ɵɵelementStart(9, "bs-sortable", _c9$r);
        ɵɵlistener("ngModelChange", function DndListComponent_Template_bs_sortable_ngModelChange_9_listener($event) { return ctx.firstListData = $event; });
        ɵɵlistener("onChange", function DndListComponent_Template_bs_sortable_onChange_9_listener($event) { return ctx.onChangeLeft($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", _c4$z);
        ɵɵlistener("dragover", function DndListComponent_Template_div_dragover_10_listener($event) { return ctx.onDragOver($event); });
        ɵɵlistener("drop", function DndListComponent_Template_div_drop_10_listener($event) { return ctx.onDrop($event, false); });
        ɵɵelementStart(11, "div", _c5$x);
        ɵɵtemplate(12, DndListComponent_h6_12_Template, 2, 1, "h6", _c6$w);
        ɵɵtemplate(13, DndListComponent_a_13_Template, 2, 0, "a", _c7$u);
        ɵɵtemplate(14, DndListComponent_a_14_Template, 2, 0, "a", _c8$u);
        ɵɵelementEnd();
        ɵɵelementStart(15, "bs-sortable", _c9$r);
        ɵɵlistener("ngModelChange", function DndListComponent_Template_bs_sortable_ngModelChange_15_listener($event) { return ctx.secondListData = $event; });
        ɵɵlistener("onChange", function DndListComponent_Template_bs_sortable_onChange_15_listener($event) { return ctx.onChangeRight($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(16, DndListComponent_ng_template_16_Template, 4, 1, "ng-template", null, _c10$q, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r868 = ɵɵreference(17);
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.componentTitle);
        ɵɵselect(6);
        ɵɵproperty("ngIf", ctx.listTitleLeft);
        ɵɵselect(7);
        ɵɵproperty("ngIf", ctx.firstListData.length > 0);
        ɵɵselect(8);
        ɵɵproperty("ngIf", ctx.firstListData.length > 0);
        ɵɵselect(9);
        ɵɵproperty("ngModel", ctx.firstListData)("fieldName", ctx.fieldName)("itemClass", ctx.itemClass)("itemActiveClass", ctx.itemActiveClass)("itemTemplate", _r868)("wrapperClass", ctx.wrapperClass)("placeholderClass", ctx.placeholderClass)("placeholderItem", ctx.placeholderItem);
        ɵɵselect(12);
        ɵɵproperty("ngIf", ctx.listTitleRight);
        ɵɵselect(13);
        ɵɵproperty("ngIf", ctx.secondListData.length > 0);
        ɵɵselect(14);
        ɵɵproperty("ngIf", ctx.secondListData.length > 0);
        ɵɵselect(15);
        ɵɵproperty("ngModel", ctx.secondListData)("fieldName", ctx.fieldName)("itemClass", ctx.itemClass)("itemActiveClass", ctx.itemActiveClass)("itemTemplate", _r868)("wrapperClass", ctx.wrapperClass)("placeholderClass", ctx.placeholderClass)("placeholderItem", ctx.placeholderItem);
    } }, directives: [NgIf, SortableComponent, NgControlStatus, NgModel, ButtonComponent, IconButtonComponent], styles: [".dnd-list .dnd-list__selections-pool-col__item-name,.dnd-list .dnd-list__selections-right-title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.dnd-list .dnd-list__selections-right-title{font-size:16px;letter-spacing:.4px;line-height:1.5}.dnd-list .dnd-list__selections-pool-col__item-name{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.dnd-list .dnd-list__title{margin-right:5rem}.dnd-list .dnd-list__selections-right{border-left:1px solid #e9e9e9;-webkit-box-flex:1;flex-grow:1;height:40rem;padding:1.2rem .3rem}.dnd-list .dnd-list__selections-right:last-child{padding-right:5rem}.dnd-list .dnd-list__selections-right-title{font-weight:300;padding:1.6rem 2rem 1.4rem;cursor:pointer}.dnd-list .dnd-list__selections-right-row{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-basis:100%;-webkit-box-flex:1;flex:1}.dnd-list .dnd-list .action-toolbar{margin:2.6rem 0}.dnd-list .dnd-list__selections-pool-col{counter-reset:section;padding:2rem .5rem 2rem 2rem}.dnd-list .dnd-list__selections-pool-col:last-child{padding:2rem .1rem 2rem 2.5rem}.dnd-list .dnd-list__selections-pool-col__ellipsis{margin-right:-.6rem;margin-top:-.3rem;width:2rem}.dnd-list .dnd-list__selections-pool-col__remove{margin-right:-.6rem;margin-top:-.2rem;width:3.2rem}.dnd-list .dnd-list__selections-pool-col__title{cursor:pointer;text-transform:uppercase;line-height:1;color:#656066;font-size:1.2rem}.dnd-list .dnd-list__selections-pool-col__drag-item{text-transform:uppercase;text-align:center;border:1px dashed #656066;padding:1.5rem 3rem;margin-top:3.2rem;color:#656066;font-size:1.2rem;line-height:1.17;letter-spacing:1.2px}.dnd-list .dnd-list__selections-pool-col__item{-webkit-box-align:center;align-items:center;border-bottom:1px solid #f0eff0;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;padding:.6rem 0}.dnd-list .dnd-list__selections-pool-col__item-name{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;-webkit-box-flex:1;flex-grow:1;max-width:10.8rem}.dnd-list .dnd-list__selections-pool-col__item-button-more{height:24px}.dnd-list .dnd-list__selections-pool-col__item-button-close{height:27px}.dnd-list .dnd-list__selections-pool-col__item-active{font-weight:bolder;box-shadow:0 1rem 2rem 0 rgba(0,0,0,.1)}.dnd-list .dnd-list__selections-pool-col__item::before{counter-increment:section;content:counter(section) \". \"}.dnd-list .dnd-list__selections-pool-col__list{padding:0;font-size:1.4rem;color:#322d32;line-height:1.43;letter-spacing:.4px;list-style-position:inside;margin-top:1rem}.dnd-list .dnd-list__selections-pool-col__header{position:relative}.dnd-list .dnd-list__selections-pool-col__header-clear{top:-.8rem;right:-1.3rem}.dnd-list .dnd-list__selections-pool-col__header-sort{top:-.8rem;right:3.6rem}.dnd-list .dnd-list__selections-pool-col__header a{display:inline-block;-webkit-transform:scale(.7);transform:scale(.7);position:absolute;padding:.5rem 1rem}.dnd-list .dnd-list__selections-pool-col__header a:hover{-webkit-transform:scale(.7);transform:scale(.7)}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(DndListComponent, [{
        type: Component,
        args: [{
                selector: "lib-dnd-list",
                templateUrl: "./dnd-list.component.html",
                styleUrls: ["./dnd-list.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ChooserMessageService }]; }, { componentTitle: [{
            type: Input
        }], listTitleLeft: [{
            type: Input
        }], listTitleRight: [{
            type: Input
        }], firstListData: [{
            type: Input
        }], secondListData: [{
            type: Input
        }], fieldName: [{
            type: Input
        }], wrapperClass: [{
            type: Input
        }], wrapperStyle: [{
            type: Input
        }], itemClass: [{
            type: Input
        }], itemStyle: [{
            type: Input
        }], itemActiveClass: [{
            type: Input
        }], itemActiveStyle: [{
            type: Input
        }], placeholderClass: [{
            type: Input
        }], placeholderStyle: [{
            type: Input
        }], placeholderItem: [{
            type: Input
        }], onChange: [{
            type: Output
        }], rowsForDeselect: [{
            type: Output
        }] });

const _c0$K = ["search"];
const _c1$J = ["dndListInstance"];
const _c2$E = ["dataTable"];
const _c3$C = [1, "chooser__wrapper"];
const _c4$A = [1, "chooser__header"];
const _c5$y = [1, "chooser__header__search"];
const _c6$x = ["for", "chooser__header__search-id"];
const _c7$v = ["id", "chooser__header__search-id", "lib-input", "", "type", "search", 3, "placeholder"];
const _c8$v = ["search", ""];
const _c9$s = [1, "chooser__header__title", 3, "title"];
const _c10$r = ["class", "chooser__header__title--selected-count", 4, "ngIf"];
const _c11$o = [1, "chooser__body"];
const _c12$m = [1, "chooser__body-table-wrapper", 3, "ngClass"];
const _c13$k = ["useClassForChooser", "true", "showPageSizeController", "enable", "showColumnsSwitcher", "disable", 3, "gridOptions", "requestOptions", "selectionChanged", "gridReady"];
const _c14$j = ["dataTable", ""];
const _c15$h = [1, "chooser__body-dnd", 3, "options", "hidden"];
const _c16$f = [3, "componentTitle", "listTitleLeft", "listTitleRight", "fieldName", "placeholderItem", "rowsForDeselect"];
const _c17$f = [1, "chooser__header__title--selected-count"];
function ChooserComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", _c17$f);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r883 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1("", ctx_r883.selectedItems, " selected ");
} }
const _c18$d = function (a0) { return { "chooser__body-table-wrapper-has-dnd": a0 }; };
const _c19$c = { x: "hidden", y: "scroll" };
const _c20$b = { overflowBehavior: _c19$c };
class ChooserComponent {
    constructor(ref, messageService) {
        this.ref = ref;
        this.messageService = messageService;
        this.titleToolTip = "";
        this.searchPlaceHolderText = "";
        this.columnDefs = [];
        this.rowData = [];
        // search configs
        this.debounceTime = "300";
        // ────────────────────────────────────────────────────────────────────────────────
        // Matcher logic
        this.hasMatcher = false;
        this.hasMatcherConfigs = {
            componentTitle: "Create Pairs",
            listTitleLeft: "POOL A SAMPLES",
            listTitleRight: "POOL B SAMPLES",
            fieldName: "name",
            placeholderItem: "DRAG & DROP ITEMS HERE"
        };
        /**
         * To support server side row model in the data table.
         * If this is set, then the server side model will be used to fetch data in the chooser.
         * If Static row data(client side model) needs to be used, set `rowData` param instead
         */
        this.chooserServerSideDataParams = null;
        // Selected count
        this.selectedItems = 0;
        // Titles
        this.firstListData = [];
        this.secondListData = [];
        // ────────────────────────────────────────────────────────────────────────────────
        // Outputs
        this.itemsSelected = new EventEmitter();
        // Private fields.
        this.defaultSearchPlaceHolderText = "Search ...";
    }
    ngOnInit() {
        // tslint:disable-next-line: max-line-length
        this.serverSideRequestOptions = this.chooserServerSideDataParams != null ? this.chooserServerSideDataParams.serverSideRequestOptions : null;
        this.titleToolTip = ___default.isEmpty(this.titleToolTip) ? this.title : this.titleToolTip;
        this.searchPlaceHolderText = ___default.isEmpty(this.searchPlaceHolderText) ? this.defaultSearchPlaceHolderText : this.searchPlaceHolderText;
    }
    ngAfterViewInit() {
        if (this.hasMatcher) {
            this.addHeaderClass();
        }
        fromEvent(this.search.nativeElement, "input")
            .pipe(debounceTime(parseInt(this.debounceTime, 10)), distinctUntilChanged(), tap(() => {
            // Ag grid quick filtering only(for the most part) works with Client side row model.
            // If a server side row model is used, the data source should handle it.
            if (this.chooserServerSideDataParams) {
                // Invoke the call back function supplied in the server side request params.
                this.chooserServerSideDataParams.rawTextFilterProcessing(this.search.nativeElement.value, this.gridOptions);
            }
            else {
                this.gridApi.setQuickFilter(this.search.nativeElement.value);
            }
        }))
            .subscribe();
    }
    sizeColumnsToFit() {
        this.gridApi.sizeColumnsToFit();
    }
    setPageSize(data) {
        this.gridApi.paginationSetPageSize(Number(data.option.value));
    }
    // api for callback takes from https://www.ag-grid.com/javascript-grid-events/#miscellaneous
    onSelectionChanged($event) {
        this.itemsSelected.emit($event.api.getSelectedRows());
        this.messageService.sendMessage("updateColumn", $event.api.getSelectedRows());
    }
    rowsForDeselect(data) {
        // loop through each node when it is filtered out
        this.gridApi.forEachNode(node => {
            const currentNodeData = node.data;
            const matchWithDndList = data.filter((x) => x._id === currentNodeData._id);
            if (matchWithDndList.length === 1) {
                node.setSelected(false);
            }
        });
    }
    addHeaderClass() {
        const headerSelector = ".ag-header-cell";
        const classToAdd = "data-table__dnd-header";
        const dataTaleElement = this
            .dataTable.elementRef.nativeElement.querySelector(headerSelector);
        if (dataTaleElement && !dataTaleElement.classList.contains(classToAdd)) {
            dataTaleElement.classList.add(classToAdd);
        }
    }
    onGridReady(gridApi) {
        this.gridApi = gridApi;
        gridApi.sizeColumnsToFit();
    }
    ngOnDestroy() { }
}
/** @nocollapse */ ChooserComponent.ngComponentDef = ɵɵdefineComponent({ type: ChooserComponent, selectors: [["lib-chooser"]], factory: function ChooserComponent_Factory(t) { return new (t || ChooserComponent)(ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(ChooserMessageService)); }, viewQuery: function ChooserComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$K, true, ElementRef);
        ɵɵviewQuery(_c1$J, true);
        ɵɵviewQuery(_c2$E, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.search = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dndListInstance = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dataTable = _t.first);
    } }, inputs: { title: "title", titleToolTip: "titleToolTip", searchPlaceHolderText: "searchPlaceHolderText", rowSelection: "rowSelection", columnDefs: "columnDefs", rowData: "rowData", debounceTime: "debounceTime", gridOptions: "gridOptions", hasMatcher: "hasMatcher", hasMatcherConfigs: "hasMatcherConfigs", chooserServerSideDataParams: "chooserServerSideDataParams" }, outputs: { itemsSelected: "itemsSelected" }, consts: 15, vars: 17, template: function ChooserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c3$C);
        ɵɵelementStart(1, "div", _c4$A);
        ɵɵelementStart(2, "div", _c5$y);
        ɵɵelementStart(3, "lib-form-field", _c6$x);
        ɵɵelement(4, "input", _c7$v, _c8$v);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "h2", _c9$s);
        ɵɵtext(7);
        ɵɵtemplate(8, ChooserComponent_span_8_Template, 2, 1, "span", _c10$r);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", _c11$o);
        ɵɵelementStart(10, "overlay-scrollbars", _c12$m);
        ɵɵstyling();
        ɵɵelementStart(11, "lib-data-table", _c13$k, _c14$j);
        ɵɵlistener("selectionChanged", function ChooserComponent_Template_lib_data_table_selectionChanged_11_listener($event) { return ctx.onSelectionChanged($event); });
        ɵɵlistener("gridReady", function ChooserComponent_Template_lib_data_table_gridReady_11_listener($event) { return ctx.onGridReady($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "overlay-scrollbars", _c15$h);
        ɵɵelementStart(14, "lib-dnd-list", _c16$f);
        ɵɵlistener("rowsForDeselect", function ChooserComponent_Template_lib_dnd_list_rowsForDeselect_14_listener($event) { return ctx.rowsForDeselect($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(4);
        ɵɵpropertyInterpolate("placeholder", ctx.searchPlaceHolderText);
        ɵɵselect(6);
        ɵɵpropertyInterpolate("title", ctx.titleToolTip);
        ɵɵselect(7);
        ɵɵtextInterpolate1("", ctx.title, " ");
        ɵɵselect(8);
        ɵɵproperty("ngIf", ctx.selectedItems > 0);
        ɵɵselect(10);
        ɵɵclassProp("wide", !ctx.hasMatcher);
        ɵɵstylingApply();
        ɵɵproperty("ngClass", ɵɵpureFunction1(15, _c18$d, ctx.hasMatcher));
        ɵɵselect(11);
        ɵɵproperty("gridOptions", ctx.gridOptions)("requestOptions", ctx.serverSideRequestOptions);
        ɵɵselect(13);
        ɵɵproperty("options", _c20$b)("hidden", !ctx.hasMatcher);
        ɵɵselect(14);
        ɵɵproperty("componentTitle", ctx.hasMatcherConfigs.componentTitle)("listTitleLeft", ctx.hasMatcherConfigs.listTitleLeft)("listTitleRight", ctx.hasMatcherConfigs.listTitleRight)("fieldName", ctx.hasMatcherConfigs.fieldName)("placeholderItem", ctx.hasMatcherConfigs.placeholderItem);
    } }, directives: [FormFieldsComponent, InputComponent, NgIf, OverlayScrollbarsComponent, NgClass, DataTableComponent, DndListComponent], styles: [".data-table a:link{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent}.chooser__header__title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.chooser__header__title{font-size:26px;letter-spacing:.3px;line-height:1.3076923077;font-weight:300}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.data-table{width:100%}.data-table .ag-header-row,.data-table .ag-root,.data-table .ag-root-wrapper{overflow:visible}.data-table .ag-root,.data-table .ag-root-wrapper,.data-table .ag-unselectable{-webkit-user-select:text!important;-moz-user-select:text!important;-ms-user-select:text!important;user-select:text!important}.data-table .ag-center-cols-clipper{overflow:hidden;margin-top:20px}.data-table .ag-center-cols-viewport{width:calc(100% + 1px);margin-top:-20px;overflow-x:auto}.data-table .ag-header-viewport{overflow:hidden}.data-table .ag-row-drag{width:40px;height:20px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/handlebars.svg);background-repeat:no-repeat;background-position:center;cursor:-webkit-grab;cursor:grab}.data-table .ag-header{position:relative;z-index:1;overflow:visible}.data-table .ag-body-viewport{margin-top:2px}.data-table .ag-header-cell{color:#787679;display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;font-size:16px;font-weight:500;line-height:1.4;text-align:right;-webkit-box-pack:space-evenly;justify-content:space-evenly;text-transform:capitalize;overflow:visible}.data-table .ag-header-cell .ag-input-wrapper{left:5px;top:-4px}.data-table .ag-header-cell .ag-header-cell-label{padding:0 16px}.data-table--metrics .data-table .ag-header-cell .ag-header-cell-label{padding:0 20px}.data-table .ag-header-cell .ag-header-cell-text{height:20px;overflow:visible;text-overflow:unset;white-space:normal;-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex}.data-table--metrics .data-table .ag-header-cell:first-child .ag-header-cell-label{padding-left:0}.data-table .ag-header-cell-numeric .ag-header-cell-label{-webkit-box-pack:end;justify-content:flex-end}.data-table .ag-header-cell.last .ag-header-cell-label{padding-right:0}.data-table--metrics .data-table .ag-header-cell.data-table__th--two-lines{word-spacing:20px}.data-table .ag-header-cell-resize{display:block;cursor:pointer;width:12px;height:12px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/column-divider.svg);background-repeat:no-repeat;-webkit-transition:.1s;transition:.1s;top:3px}.data-table .ag-header-cell-resize:hover{background-repeat:no-repeat;cursor:col-resize}.data-table .ag-header-cell-numeric.last .ag-header-cell-label{margin-right:15px}.data-table .ag-header-cell:last-of-type .ag-header-cell-resize{margin-right:5px!important;background-position:5px}.data-table .ag-row{overflow:visible}.data-table .ag-row.ag-row-selected{background:#f9f9f9;border-top-color:#f0eff0}.data-table .ag-row:hover .ag-cell,.data-table .ag-row:hover .ag-cell--floating{background:#f9f9f9}.data-table .ag-row .ag-loading-text{display:none}.data-table .ag-cell{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;position:absolute;border-bottom:1px solid #f0eff0;border-top:1px solid transparent;color:#464247;font-size:16px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:.4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.data-table .ag-cell .ag-selection-checkbox{top:-5px;left:5px;width:14px}.data-table .ag-cell-numeric{-webkit-box-pack:end;justify-content:flex-end;text-align:right}.data-table .ag-cell-numeric .data-table__content{padding-right:16px}.data-table .ag-cell-numeric .lib-popover__datatable_tooltip-button{margin-right:22px;max-width:calc(100% - 34px)}.data-table .ag-cell-value{width:100%;padding:0 16px}.data-table .ag-cell.last .data-table .ag-cell-content{padding-right:0}.data-table .ag-cell.last .data-table__content,.data-table .ag-cell.last .lib-popover__datatable_tooltip-button{padding-right:0;margin-right:0}.data-table .ag-cell.data-table__td--floating{background:#fff;border:0!important;margin-left:11px;padding-left:8px;padding-right:8px;z-index:1}.data-table .ag-cell--totals{background:#f9f9f9;border-bottom:1px solid #f0eff0;border-top:1px solid #f0eff0;font-weight:500}.data-table .ag-cell--totals:first-child{left:-11px!important;padding-left:11px}.data-table .ag-cell--totals:last-child{right:-11px!important;padding-right:11px}.data-table .ag-cell:focus{outline:0}.data-table .ag-cell--failed{font-weight:500}.data-table__content{overflow:hidden;text-overflow:ellipsis}.data-table__content-link{color:#4e60ee!important;background:padding-box unset unset!important;-webkit-text-fill-color:#4e60ee!important;display:inline-block;position:relative}.data-table__content-link:hover{text-decoration:none!important}.data-table__content-link:hover:after{content:\"\";display:block;height:0;width:100%;border-top:1px solid #4e60ee;position:absolute;bottom:1px}.data-table--metrics .data-table__content{padding:20px}.data-table--metrics .data-table__content:first-child{padding-left:0}.data-table .ag-header-cell:first-child .ag-header-select-all.ag-checkbox.ag-hidden .radio__label,.data-table .ag-paging-panel{display:none}.data-table .ag-header-cell:first-child .ag-header-select-all .checkbox__label{top:-4px}.data-table .ag-header-cell.select-all-current-page .ag-header-select-all{display:-webkit-box!important;display:flex!important;width:14px}.data-table .ag-popup{top:0;position:absolute;overflow:visible;display:inline-block}.data-table .ag-popup .ag-menu{position:relative;overflow:hidden}.data-table .ag-popup .ag-menu-header{display:none}.data-table--metrics{border-top:1px solid #d1cfd1;padding-top:14px}.data-table--metrics .ag-grid-body-viewport{overflow:visible!important}.data-table--metrics .ag-header-row{border-bottom:1px solid #f0eff0}.data-table-toolbar{position:relative;width:100%;max-height:42px;line-height:42px;margin-bottom:10px;text-align:right}.data-table-toolbar__clear-selected-container{margin-bottom:31px;margin-right:20px}.data-table-toolbar__clear-selected-btn{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/close-small.svg) center no-repeat;border:none;height:28px;outline:0;-webkit-transform:translate(0,8px);transform:translate(0,8px);width:28px;vertical-align:top}.data-table-toolbar .data-table-toolbar__items{position:absolute;top:-80px;right:0;-webkit-box-align:center;align-items:center;height:auto;display:-webkit-box;display:flex;max-width:50%}.data-table__dnd-header{margin-left:40px}.os-theme-dark>.os-scrollbar-vertical{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark>.os-scrollbar>.os-scrollbar-track{background:#f0eff0}.os-theme-dark .os-scrollbar-handle{background:#656066;width:.2rem}.chooser__wrapper .ag-center-cols-viewport{overflow:hidden}.chooser__wrapper .input-wrapper select{width:100px}.chooser__header__search{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;margin-bottom:2rem}.chooser__header__search::before{content:\"\";display:block;position:static;width:32px;height:32px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/search-in-line.svg);background-repeat:no-repeat;background-position:center;background-size:cover;margin-right:.5rem}.chooser__header__search .input-field__text-input{border-bottom-width:0!important}.chooser__header__search .input-field{width:100%}.chooser__header__title{display:-webkit-box;display:flex;position:relative;-webkit-box-align:center;align-items:center;border-bottom:1px solid #d1cfd1;padding-bottom:1rem}.chooser__header__title::after{content:\"\";display:block;position:relative;top:.2rem;width:20px;height:20px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/info.svg);background-repeat:no-repeat;background-position:center;background-size:cover;margin-left:.5rem}.chooser__header__title--selected-count{font-size:1.2rem;text-indent:3rem}.chooser__body{display:-webkit-box;display:flex;margin-top:1rem}.chooser__body::after{content:\"\";display:block;position:absolute;background-image:radial-gradient(70% 70% at center bottom,rgba(0,0,0,.04),rgba(255,255,255,0));bottom:0;height:2rem;width:100%}.chooser__body-table-wrapper{-webkit-box-flex:0;flex:0 0 55%;max-width:55%;min-height:40rem;max-height:40rem;overflow-y:scroll;overflow-x:hidden}.chooser__body-table-wrapper-has-dnd .ag-cell-wrapper{display:-webkit-box}.chooser__body-table-wrapper-has-dnd .ag-cell-wrapper lib-data-table-link{display:block;max-width:16.5rem}.chooser__body-table-wrapper-has-dnd .ag-cell-wrapper .checkbox__label{top:-1px}.chooser__body-table-wrapper.wide{flex-basis:100%;max-width:100%}.chooser__body-dnd{-webkit-box-flex:0;flex:0 0 45%;max-width:45%;min-height:40rem;max-height:40rem;overflow:auto}.chooser-modal{max-width:123.6rem;display:block;margin-top:8rem}.chooser-modal .modal-dialog__container--inner{padding-bottom:0}.chooser-modal .modal-dialog__footer{-webkit-box-pack:end;justify-content:flex-end;padding-top:1.7rem;padding-bottom:2.3rem}.chooser-modal .data-table-toolbar .data-table-toolbar__items{right:2rem}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(ChooserComponent, [{
        type: Component,
        args: [{
                selector: "lib-chooser",
                templateUrl: "./chooser.component.html",
                styleUrls: ["./chooser.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ChangeDetectorRef }, { type: ChooserMessageService }]; }, { title: [{
            type: Input
        }], titleToolTip: [{
            type: Input
        }], searchPlaceHolderText: [{
            type: Input
        }], rowSelection: [{
            type: Input
        }], columnDefs: [{
            type: Input
        }], rowData: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], gridOptions: [{
            type: Input
        }], search: [{
            type: ViewChild,
            args: ["search", { read: ElementRef, static: false }]
        }], hasMatcher: [{
            type: Input
        }], dndListInstance: [{
            type: ViewChild,
            args: ["dndListInstance", { static: false }]
        }], hasMatcherConfigs: [{
            type: Input
        }], chooserServerSideDataParams: [{
            type: Input
        }], dataTable: [{
            type: ViewChild,
            args: ["dataTable", { static: false }]
        }], itemsSelected: [{
            type: Output
        }] });

class DndListModule {
}
/** @nocollapse */ DndListModule.ngModuleDef = ɵɵdefineNgModule({ type: DndListModule });
/** @nocollapse */ DndListModule.ngInjectorDef = ɵɵdefineInjector({ factory: function DndListModule_Factory(t) { return new (t || DndListModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            SortableModule.forRoot(),
            IconButtonModule,
            ButtonModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(DndListModule, { declarations: [DndListComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule, SortableModule, IconButtonModule,
        ButtonModule], exports: [DndListComponent] });
/*@__PURE__*/ ɵsetClassMetadata(DndListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    SortableModule.forRoot(),
                    IconButtonModule,
                    ButtonModule
                ],
                declarations: [DndListComponent],
                exports: [DndListComponent]
            }]
    }], null, null);

class ChooserModule {
}
/** @nocollapse */ ChooserModule.ngModuleDef = ɵɵdefineNgModule({ type: ChooserModule });
/** @nocollapse */ ChooserModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ChooserModule_Factory(t) { return new (t || ChooserModule)(); }, providers: [ChooserMessageService], imports: [[
            CommonModule,
            DataTableModule,
            FormFieldsModule,
            InputModule,
            DndListModule,
            SelectModule,
            FormsModule,
            ReactiveFormsModule,
            OverlayscrollbarsModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ChooserModule, { declarations: [ChooserComponent], imports: [CommonModule,
        DataTableModule,
        FormFieldsModule,
        InputModule,
        DndListModule,
        SelectModule,
        FormsModule,
        ReactiveFormsModule,
        OverlayscrollbarsModule], exports: [ChooserComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ChooserModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DataTableModule,
                    FormFieldsModule,
                    InputModule,
                    DndListModule,
                    SelectModule,
                    FormsModule,
                    ReactiveFormsModule,
                    OverlayscrollbarsModule
                ],
                declarations: [ChooserComponent],
                exports: [ChooserComponent],
                providers: [ChooserMessageService]
            }]
    }], null, null);

class ImgFallbackDirective {
    constructor(eRef) {
        this.eRef = eRef;
    }
    loadFallbackOnError() {
        const element = this.eRef
            .nativeElement;
        // tslint:disable-next-line: max-line-length
        element.src =
            this.appImgFallback ||
                "data:image/png;base64,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";
        element.classList.add("broken-image");
    }
}
/** @nocollapse */ ImgFallbackDirective.ngDirectiveDef = ɵɵdefineDirective({ type: ImgFallbackDirective, selectors: [["img", "appImgFallback", ""]], factory: function ImgFallbackDirective_Factory(t) { return new (t || ImgFallbackDirective)(ɵɵdirectiveInject(ElementRef)); }, hostBindings: function ImgFallbackDirective_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("error", function ImgFallbackDirective_error_HostBindingHandler($event) { return ctx.loadFallbackOnError(); });
    } }, inputs: { appImgFallback: "appImgFallback" } });
/*@__PURE__*/ ɵsetClassMetadata(ImgFallbackDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: "img[appImgFallback]"
            }]
    }], function () { return [{ type: ElementRef }]; }, { appImgFallback: [{
            type: Input
        }], loadFallbackOnError: [{
            type: HostListener,
            args: ["error"]
        }] });

const _c0$L = [1, "app-launcher__launcher-card", 3, "href"];
const _c1$K = [1, "app-launcher__launcher-card__image"];
const _c2$F = ["appImgFallback", "", "loading", "lazy", "alt", "App logo"];
const _c3$D = [1, "app-launcher__launcher-card__content"];
const _c4$B = [1, "app-launcher__launcher-card-app-name"];
const _c5$z = [1, "app-launcher__launcher-card-company"];
const _c6$y = [1, "app-launcher__content__subtitle__first-text__post"];
const _c7$w = ["class", "app-launcher__launch-link", 3, "mouseenter", "mouseout", 4, "ngIf"];
const _c8$w = [1, "app-launcher__launch-link", 3, "mouseenter", "mouseout"];
function AppLauncherCardComponent_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r902 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", _c8$w);
    ɵɵlistener("mouseenter", function AppLauncherCardComponent_a_9_Template_a_mouseenter_0_listener($event) { ɵɵrestoreView(_r902); const ctx_r901 = ɵɵnextContext(); return ctx_r901.changeAppCardNavigationLink(true); });
    ɵɵlistener("mouseout", function AppLauncherCardComponent_a_9_Template_a_mouseout_0_listener($event) { ɵɵrestoreView(_r902); const ctx_r903 = ɵɵnextContext(); return ctx_r903.changeAppCardNavigationLink(false); });
    ɵɵtext(1, "LAUNCH");
    ɵɵelementEnd();
} }
class AppLauncherCardComponent {
    constructor(router) {
        this.router = router;
        this.displayLaunch = true;
        this.versions = [];
        this.REGEX_NON_WORDS = /[^\w]+/g;
    }
    ngOnInit() {
        this.prepareVersions();
        this.appDetailsPath = `/apps/${this.appData.Id}/${this.toSlug(this.appData.Name)}?preferredversion`;
        this.appCardNavigationLink = this.appDetailsPath;
    }
    defaultCreateUrl(appData) {
        return `/apps/${appData.Id}/start?redirectToPreferredVersion=true`;
    }
    toSlug(str) {
        return encodeURIComponent(str.replace(this.REGEX_NON_WORDS, "-"));
    }
    changeAppCardNavigationLink(launchOptionEnabled) {
        if (launchOptionEnabled) {
            const redirectLink = this.createUrl ? this.createUrl(this.appData) : this.defaultCreateUrl(this.appData);
            this.appCardNavigationLink = redirectLink;
        }
        else {
            this.appCardNavigationLink = this.appDetailsPath;
        }
    }
    // Not currently in use but could be used on next iteration of app launcher
    prepareVersions() {
        let versions = this.appData.VersionNumber;
        if (typeof versions === 'string') {
            versions = [versions];
        }
        this.versions = versions.map((version, index) => {
            if (this.appData.PreferredVersion === version) {
                this.selectedVersion = index;
            }
            return {
                id: index,
                value: version
            };
        });
    }
}
/** @nocollapse */ AppLauncherCardComponent.ngComponentDef = ɵɵdefineComponent({ type: AppLauncherCardComponent, selectors: [["lib-app-launcher-card"]], factory: function AppLauncherCardComponent_Factory(t) { return new (t || AppLauncherCardComponent)(ɵɵdirectiveInject(Router)); }, inputs: { appData: "appData", createUrl: "createUrl", displayLaunch: "displayLaunch" }, outputs: { selectedVersion: "selectedVersion" }, consts: 10, vars: 5, template: function AppLauncherCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "a", _c0$L);
        ɵɵelementStart(1, "div", _c1$K);
        ɵɵelement(2, "img", _c2$F);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", _c3$D);
        ɵɵelementStart(4, "h4", _c4$B);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "h5", _c5$z);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", _c6$y);
        ɵɵtemplate(9, AppLauncherCardComponent_a_9_Template, 2, 0, "a", _c7$w);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("href", ctx.appCardNavigationLink, ɵɵsanitizeUrl);
        ɵɵselect(2);
        ɵɵattribute("src", ctx.appData.HrefLogo, ɵɵsanitizeUrl);
        ɵɵselect(5);
        ɵɵtextInterpolate1(" ", ctx.appData.Name, " ");
        ɵɵselect(7);
        ɵɵtextInterpolate1(" ", ctx.appData.CompanyName, " ");
        ɵɵselect(9);
        ɵɵproperty("ngIf", ctx.displayLaunch);
    } }, directives: [ImgFallbackDirective, NgIf], styles: [".app-launcher__content__subtitle__first-text__post__title,.app-launcher__launcher-card-app-name,.app-launcher__launcher-card-company,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.app-launcher__launcher-card-app-name,.app-launcher__launcher-card-company{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.app-launcher__content__subtitle__first-text__post__title{font-size:12px;letter-spacing:.34px;line-height:1.1666666667;font-weight:700}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.app-launcher__launcher-card{box-shadow:0 .4rem 2rem 0 rgba(0,0,0,.05);background-color:#fff;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;cursor:pointer;min-width:34.1rem;vertical-align:middle;-webkit-transform:perspective(1px) translateZ(0);transform:perspective(1px) translateZ(0);-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-property:-webkit-transform;transition-property:transform,-webkit-transform;text-decoration:none!important}.app-launcher__launcher-card__image{box-shadow:0 .5rem 3rem 0 rgba(0,0,0,.1);background-image:linear-gradient(146deg,#fff 2%,#fff 180%);-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:9rem;-webkit-box-pack:center;justify-content:center;position:relative;width:9rem}.app-launcher__launcher-card__image img{width:7.5rem;height:7.5rem}.app-launcher__launcher-card__image::after{content:\"\";display:block;position:absolute;background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.1)),color-stop(55%,#000),to(rgba(0,0,0,.1)));background-image:linear-gradient(180deg,rgba(0,0,0,.1) 0,#000 55%,rgba(0,0,0,.1) 100%);height:8rem;opacity:.11;right:0;width:1px}.app-launcher__launcher-card__image__post{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;padding-right:1rem}.app-launcher__launcher-card__image__post svg{width:2rem}.app-launcher__launcher-card__image__post svg:hover{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPHBhdGggZD0iTTUgMTdsNS0zIDUgM3YtNi40VjNINXYxNHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjYmZiZWJmIi8+Cjwvc3ZnPgo=)}.app-launcher__launcher-card__content{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex-grow:1;-webkit-box-pack:center;justify-content:center;padding-left:1.5rem;position:relative}.app-launcher__launcher-card-app-name{text-overflow:ellipsis;overflow:hidden;max-width:24rem;min-width:12rem}.app-launcher__launcher-card-company{color:#918d91;text-overflow:ellipsis;overflow:hidden;max-width:24rem;min-width:12rem}.app-launcher__launcher-card__bookmark{position:absolute;right:1.6rem;width:2rem;height:3rem;background-repeat:no-repeat;background-size:contain;background-position:center;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/bookmark-off.svg);vertical-align:middle;-webkit-transform:perspective(1px) translateZ(0);transform:perspective(1px) translateZ(0);-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-property:-webkit-transform;transition-property:transform,-webkit-transform}.app-launcher__launcher-card__bookmark:hover{-webkit-transform:scale(1.066667);transform:scale(1.066667);background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/bookmark-off-gradient.svg)}.app-launcher__launcher-card__bookmark.bookmarked{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/bookmark-on.svg)}.app-launcher__launcher-card__bookmark.bookmarked:hover{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/bookmark-on-gradient.svg)}.app-launcher__launch-link{color:#007bff!important}.app-launcher__launch-link:hover{color:inherit!important}.app-launcher__inner-content{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;width:70%}.app-launcher__content__title{margin:2rem 0;font-size:2.4rem;font-weight:100;color:#121212}.app-launcher__content__subtitle{display:-webkit-box;display:flex;width:100%;white-space:normal;margin:0 auto}.app-launcher__content__subtitle__first{width:100%;box-shadow:0 .4rem 2rem 0 rgba(0,0,0,.05);background-color:#fff;margin:.5rem 1.5rem .5rem 0;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;cursor:pointer}.app-launcher__content__subtitle__first__img{width:9rem;height:9rem;box-shadow:0 .4rem 3rem 0 rgba(0,0,0,.1);background-image:linear-gradient(146deg,#fff 2%,#fff 180%);-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.app-launcher__content__subtitle__first__img img{width:8rem;height:9rem;-webkit-transform:translateY(-1px);transform:translateY(-1px);box-shadow:0 .5rem 3rem 0 rgba(0,0,0,.1)}.app-launcher__content__subtitle__first__img__post{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;padding-right:1rem}.app-launcher__content__subtitle__first__img__post svg{width:2rem}.app-launcher__content__subtitle__first__img__post svg:hover{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPHBhdGggZD0iTTUgMTdsNS0zIDUgM3YtNi40VjNINXYxNHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjYmZiZWJmIi8+Cjwvc3ZnPgo=)}.app-launcher__content__subtitle__first-text{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding-left:1rem;padding-top:1rem;line-height:1.5}.app-launcher__content__subtitle__first-text__title{color:#322d32;font-size:1.4rem}.app-launcher__content__subtitle__first-text__subtitle{color:#918d91;font-size:1.4rem}.app-launcher__content__subtitle__first-text__post{display:-webkit-box;display:flex;height:3rem}.app-launcher__content__subtitle__first-text__post lib-select{margin-left:0}.app-launcher__content__subtitle__first-text__post .select__input-text{font-size:1.2rem;font-weight:700;letter-spacing:.1rem;line-height:1;padding:0;text-transform:uppercase;width:8.2rem}.app-launcher__content__subtitle__first-text__post .dropdown{margin-left:-2rem;width:22rem}.app-launcher__content__subtitle__first-text__post .select__dropdown-arrow{top:.1rem}.app-launcher__content__subtitle__first-text__post .select__dropdown-arrow i{border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.app-launcher__content__subtitle__first-text__post lib-option{padding-left:1rem}.app-launcher__content__subtitle__first-text__post-img svg{width:2rem}.app-launcher__content__subtitle__first-text__post__title{background:linear-gradient(79deg,#225de6 0,#7723e6 121%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;padding:.5rem .6rem 0 0;text-transform:uppercase}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(AppLauncherCardComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-launcher-card",
                templateUrl: "./app-launcher-card.component.html",
                styleUrls: ["./app-launcher-card.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: Router }]; }, { appData: [{
            type: Input
        }], createUrl: [{
            type: Input
        }], displayLaunch: [{
            type: Input
        }], selectedVersion: [{
            type: Output
        }] });

class AbstractAppLauncherService extends ObservableStore {
    constructor() {
        super({
            trackStateHistory: true,
            logStateChanges: true
        });
    }
    ngOnDestroy() { }
}

const _c0$M = ["classificationDropdown"];
const _c1$L = [1, "app-launcher-wrapper"];
const _c2$G = [1, "app-launcher-header"];
const _c3$E = [4, "ngIf"];
const _c4$C = [3, "hidden"];
const _c5$A = [1, "app-launcher-header__search"];
const _c6$z = ["for", "app-launcher-search"];
const _c7$x = ["id", "app-launcher-search", "lib-input", "", "type", "text", "placeholder", "Search Apps ...", 1, "app-launcher-search", 3, "formControl", "keydown.enter"];
const _c8$x = [1, "app-launcher-header__classifications-select"];
const _c9$t = [3, "formControl"];
const _c10$s = ["classificationDropdown", ""];
const _c11$p = [3, "value", "label", 4, "ngFor", "ngForOf"];
const _c12$n = [3, "value", "label"];
function AppLauncherComponent_ng_container_2_ng_container_5_lib_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c12$n);
} if (rf & 2) {
    const classification_r891 = ctx.$implicit;
    ɵɵproperty("value", classification_r891.Id)("label", classification_r891.Description);
} }
function AppLauncherComponent_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-select", _c9$t, _c10$s);
    ɵɵtemplate(3, AppLauncherComponent_ng_container_2_ng_container_5_lib_option_3_Template, 1, 2, "lib-option", _c11$p);
    ɵɵpipe(4, "async");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r888 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("formControl", ctx_r888.appClassificationControl);
    ɵɵselect(3);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(4, 2, ctx_r888.displayedClassifications));
} }
function AppLauncherComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r893 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", _c5$A);
    ɵɵelementStart(2, "lib-form-field", _c6$z);
    ɵɵelementStart(3, "input", _c7$x);
    ɵɵlistener("keydown.enter", function AppLauncherComponent_ng_container_2_Template_input_keydown_enter_3_listener($event) { ɵɵrestoreView(_r893); const ctx_r892 = ɵɵnextContext(); return ctx_r892.triggerUpdateDisplayedApps(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", _c8$x);
    ɵɵtemplate(5, AppLauncherComponent_ng_container_2_ng_container_5_Template, 5, 4, "ng-container", _c3$E);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r885 = ɵɵnextContext();
    ɵɵselect(3);
    ɵɵproperty("formControl", ctx_r885.appSearchControl);
    ɵɵselect(5);
    ɵɵproperty("ngIf", !ctx_r885.loading);
} }
const _c13$l = [1, "app-launcher__launcher-title--loading"];
const _c14$k = ["type", "text", 3, "lines"];
const _c15$i = [1, "app-launcher__launcher-list"];
const _c16$g = ["class", "app-launcher__launcher-card", 4, "ngFor", "ngForOf"];
const _c17$g = [1, "app-launcher__launcher-card"];
const _c18$e = [1, "app-launcher__launcher-card__image"];
const _c19$d = ["type", "rect"];
const _c20$c = [1, "app-launcher__launcher-card__content"];
function AppLauncherComponent_ng_container_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c17$g);
    ɵɵelementStart(1, "div", _c18$e);
    ɵɵelement(2, "lib-skeleton", _c19$d);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", _c20$c);
    ɵɵelement(4, "lib-skeleton", _c14$k);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(4);
    ɵɵproperty("lines", 2);
} }
function AppLauncherComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", _c13$l);
    ɵɵelement(2, "lib-skeleton", _c14$k);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", _c15$i);
    ɵɵtemplate(4, AppLauncherComponent_ng_container_5_div_4_Template, 5, 1, "div", _c16$g);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r886 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵproperty("lines", 1);
    ɵɵselect(4);
    ɵɵproperty("ngForOf", ctx_r886.skeletonCards);
} }
const _c21$b = [1, "app-launcher__launcher-title"];
const _c22$b = ["class", "app-launcher__launcher-list", 4, "ngIf"];
const _c23$b = [3, "appData", "createUrl", "displayLaunch", 4, "ngFor", "ngForOf"];
const _c24$a = [3, "appData", "createUrl", "displayLaunch"];
function AppLauncherComponent_ng_container_6_div_3_lib_app_launcher_card_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-app-launcher-card", _c24$a);
} if (rf & 2) {
    const app_r899 = ctx.$implicit;
    const ctx_r898 = ɵɵnextContext(3);
    ɵɵproperty("appData", app_r899)("createUrl", ctx_r898.createUrl)("displayLaunch", ctx_r898.displayLaunch);
} }
function AppLauncherComponent_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c15$i);
    ɵɵtemplate(1, AppLauncherComponent_ng_container_6_div_3_lib_app_launcher_card_1_Template, 1, 3, "lib-app-launcher-card", _c23$b);
    ɵɵpipe(2, "async");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r896 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(2, 1, ctx_r896.displayedApplications));
} }
function AppLauncherComponent_ng_container_6_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c15$i);
    ɵɵtext(1, " No Apps Found ");
    ɵɵelementEnd();
} }
function AppLauncherComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "h3", _c21$b);
    ɵɵtext(2, " All Apps ");
    ɵɵelementEnd();
    ɵɵtemplate(3, AppLauncherComponent_ng_container_6_div_3_Template, 3, 3, "div", _c22$b);
    ɵɵpipe(4, "async");
    ɵɵtemplate(5, AppLauncherComponent_ng_container_6_div_5_Template, 2, 0, "div", _c22$b);
    ɵɵpipe(6, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r887 = ɵɵnextContext();
    var tmp_0_0 = null;
    const currVal_0 = ((tmp_0_0 = ɵɵpipeBind1(4, 2, ctx_r887.displayedApplications)) == null ? null : tmp_0_0.length) > 0;
    var tmp_1_0 = null;
    const currVal_1 = ((tmp_1_0 = ɵɵpipeBind1(6, 4, ctx_r887.displayedApplications)) == null ? null : tmp_1_0.length) == 0;
    ɵɵselect(3);
    ɵɵproperty("ngIf", currVal_0);
    ɵɵselect(5);
    ɵɵproperty("ngIf", currVal_1);
} }
class AppLauncherComponent {
    constructor(appLauncherService, elementRef) {
        this.appLauncherService = appLauncherService;
        this.elementRef = elementRef;
        this.canFilter = true;
        this.appPropertiesToSearch = ["Name", "CompanyName", "ShortDescription"];
        this.displayLaunch = true;
        this.versionSelected = new EventEmitter();
        this.appSearchControl = new FormControl("");
        this.appClassificationControl = new FormControl("0");
        this.searchResults = [];
        this.searchTitle = "Search results";
        this.subs = new SubSink();
        this.applications = new BehaviorSubject(null);
        this.classifications = new BehaviorSubject(null);
        this.displayedApplications = new BehaviorSubject(null);
        this.displayedClassifications = new BehaviorSubject(null);
        this.updateDisplayedApplications$ = new ReplaySubject(1);
        this.showSearchSection = false;
        this.loading = true;
        this.skeletonCards = Array(5).fill(4);
        this.subs.sink = this.appLauncherService.getApps().subscribe(this.applications);
        this.subs.sink = this.appLauncherService.getAppClassifications().subscribe(this.classifications);
    }
    ngOnInit() {
        // To get the loaded apps to display first time
        this.triggerUpdateDisplayedApps();
        this.appClassificationControl.valueChanges.subscribe((value) => {
            const classification = this.displayedClassifications.value.find((appClass) => appClass.Id === value);
            if (classification && this.classificationDropdown) {
                this.classificationDropdown.selectLabel = classification.Description;
                this.triggerUpdateDisplayedApps();
            }
        });
        this.subs.sink = combineLatest(this.applications.pipe(filter((value) => !!value)), this.classifications.pipe(filter((value) => !!value))).pipe(tap(([applications, classifications]) => {
            const initialDisplayedClassifications = classifications.map((classification, index) => {
                const classificationCount = this.getClassificationAppCount(classification);
                return {
                    Name: classification.Name,
                    Description: `${classification.Description} (${classificationCount})`,
                    Id: `${index + 1}`
                };
            });
            initialDisplayedClassifications.splice(0, 0, { Name: "", Description: "All Categories", Id: "0" });
            this.displayedClassifications.next(initialDisplayedClassifications);
            this.loading = false;
        }), 
        // The selector/dropdown component seems to oscillate between using the "Description" as the value
        // and using the "Id" as the value and/or the label. It struggles to differentiate "value" and "label" and does not abide by normal dropdown best practices.
        // I tried a variety of strategies to separate the label and id for the classifications. Using the strategy I have in place
        // with the 100 ms delay was the only strategy that worked so here it stays.
        delay(100), tap(() => {
            // This is necessary because as soon as the classification dropdown/selector is rendered
            // it has a weird side effect of setting the value of appClassificationControl to the "Description"
            // of the first app rather than the Id so we need to set it to the Id
            let initialClassification;
            if (this.initialAppClassificationName) {
                initialClassification = this.displayedClassifications.value.find((appClass) => appClass.Name === this.initialAppClassificationName);
            }
            if (initialClassification) {
                this.appClassificationControl.setValue(initialClassification.Id);
            }
            else {
                this.appClassificationControl.setValue(this.displayedClassifications.value[0].Id);
            }
        }), switchMap(() => this.updateDisplayedApplications$), debounceTime(100)).subscribe(() => {
            this.updateDisplayedApplications();
        });
    }
    triggerUpdateDisplayedApps() {
        this.updateDisplayedApplications$.next(true);
    }
    updateDisplayedApplications() {
        const searchText = this.appSearchControl.value;
        const classificationId = this.appClassificationControl.value;
        const classification = this.displayedClassifications.value.find((appClass) => appClass.Id === classificationId);
        if (classification) {
            const searchParams = { text: searchText, classification: classification };
            this.displayedApplications.next(this.searchApps(this.applications.value, searchParams));
        }
    }
    getClassificationAppCount(classification) {
        let appCount = 0;
        this.applications.value
            .forEach((a) => {
            if (a.Classifications.indexOf(classification.Name) > -1) {
                appCount++;
            }
        });
        return appCount;
    }
    ;
    appMatchesSearchText(app, searchText) {
        return this.appPropertiesToSearch.some((propertyName) => {
            return app[propertyName] && app[propertyName].toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        });
    }
    appMatchesClassification(app, searchClassification) {
        return app.Classifications.indexOf(searchClassification.Name) > -1;
    }
    ;
    searchApps(applications, searchParams) {
        let output = applications;
        if (searchParams.text && searchParams.classification.Name) {
            const filterTextToMatch = searchParams.text.toLowerCase();
            output = applications.filter((application) => {
                const textMatch = this.appMatchesSearchText(application, filterTextToMatch);
                const classificationMatch = this.appMatchesClassification(application, searchParams.classification);
                return textMatch && classificationMatch;
            });
        }
        else if (searchParams.text) {
            const filterTextToMatch = searchParams.text.toLowerCase();
            output = applications.filter((application) => {
                return this.appMatchesSearchText(application, filterTextToMatch);
            });
        }
        else if (searchParams.classification.Name) {
            output = applications.filter((application) => {
                return this.appMatchesClassification(application, searchParams.classification);
            });
        }
        return output;
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
/** @nocollapse */ AppLauncherComponent.ngComponentDef = ɵɵdefineComponent({ type: AppLauncherComponent, selectors: [["lib-app-launcher"]], factory: function AppLauncherComponent_Factory(t) { return new (t || AppLauncherComponent)(ɵɵdirectiveInject("AppLauncherService"), ɵɵdirectiveInject(ElementRef)); }, viewQuery: function AppLauncherComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$M, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.classificationDropdown = _t.first);
    } }, inputs: { createUrl: "createUrl", canFilter: "canFilter", appPropertiesToSearch: "appPropertiesToSearch", displayLaunch: "displayLaunch", initialAppClassificationName: "initialAppClassificationName" }, outputs: { versionSelected: "versionSelected" }, consts: 7, vars: 4, template: function AppLauncherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$L);
        ɵɵelementStart(1, "div", _c2$G);
        ɵɵtemplate(2, AppLauncherComponent_ng_container_2_Template, 6, 2, "ng-container", _c3$E);
        ɵɵelementEnd();
        ɵɵelementStart(3, "section");
        ɵɵelementStart(4, "div", _c4$C);
        ɵɵtemplate(5, AppLauncherComponent_ng_container_5_Template, 5, 2, "ng-container", _c3$E);
        ɵɵtemplate(6, AppLauncherComponent_ng_container_6_Template, 7, 6, "ng-container", _c3$E);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.canFilter);
        ɵɵselect(4);
        ɵɵproperty("hidden", ctx.showSearchSection);
        ɵɵselect(5);
        ɵɵproperty("ngIf", ctx.loading);
        ɵɵselect(6);
        ɵɵproperty("ngIf", !ctx.loading);
    } }, directives: [NgIf, FormFieldsComponent, InputComponent, DefaultValueAccessor, NgControlStatus, FormControlDirective, SelectComponent, NgForOf, OptionComponent, SkeletonComponent, AppLauncherCardComponent], pipes: [AsyncPipe], styles: [".app-launcher__launcher-title,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.app-launcher__launcher-title{font-size:20px;letter-spacing:.4px;line-height:1.5;font-weight:300;margin-top:1.6rem}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.app-launcher__launcher-card{box-shadow:0 .4rem 2rem 0 rgba(0,0,0,.05);background-color:#fff;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;min-width:34.1rem;vertical-align:middle;-webkit-transform:perspective(1px) translateZ(0);transform:perspective(1px) translateZ(0);-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-property:-webkit-transform;transition-property:transform,-webkit-transform}.app-launcher__launcher-card__image{box-shadow:0 .5rem 3rem 0 rgba(0,0,0,.1);background-image:linear-gradient(146deg,#fff 2%,#fff 180%);-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:9rem;-webkit-box-pack:center;justify-content:center;position:relative;width:9rem}.app-launcher__launcher-card::after{content:\"\";display:block;position:absolute;background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.1)),color-stop(55%,#000),to(rgba(0,0,0,.1)));background-image:linear-gradient(180deg,rgba(0,0,0,.1) 0,#000 55%,rgba(0,0,0,.1) 100%);height:8rem;opacity:.11;right:0;width:1px}.app-launcher__launcher-card__content{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex-grow:1;-webkit-box-pack:center;justify-content:center;padding-left:1.5rem;position:relative}.app-launcher__launcher-title--loading{margin-top:3rem;margin-bottom:10px}.app-launcher__launcher-list{display:-ms-grid;display:grid;-ms-grid-columns:([col-start] 1fr)[3];grid-template-columns:repeat(3,[col-start] 1fr);grid-gap:1rem 3rem;padding-top:.8rem;padding-bottom:1rem;position:relative;z-index:1}.app-launcher-header{display:-ms-grid;display:grid;padding:1.6rem 0;-ms-grid-columns:([col-start] 1fr)[3];grid-template-columns:repeat(3,[col-start] 1fr);grid-gap:1rem 3rem}.app-launcher-header__classifications-select{-ms-grid-column:3;-ms-grid-column-span:1;grid-column:3/span 1;align-content:flex-end}.app-launcher-header__search{grid-column:col-start/span 1;height:100%;margin-top:1.6rem}.app-launcher-header__search input{border:0;padding-left:3.8rem}.app-launcher-header__search .input-field__container:before{content:\"\";width:3rem;height:3rem;position:absolute;background-repeat:no-repeat;background-size:contain;background-position:center;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/search-in-line.svg);left:.3rem;top:-.3rem}.app-launcher-header__category{margin-top:1.3rem}.app-launcher-content.scroll-area{max-height:calc(100vh - 19.1rem);padding:0 5.4rem 0 2.2rem}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(AppLauncherComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-launcher",
                templateUrl: "./app-launcher.component.html",
                styleUrls: ["./app-launcher.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.Default
            }]
    }], function () { return [{ type: AbstractAppLauncherService, decorators: [{
                type: Inject,
                args: ["AppLauncherService"]
            }] }, { type: ElementRef }]; }, { createUrl: [{
            type: Input
        }], canFilter: [{
            type: Input
        }], appPropertiesToSearch: [{
            type: Input
        }], displayLaunch: [{
            type: Input
        }], initialAppClassificationName: [{
            type: Input
        }], versionSelected: [{
            type: Output
        }], classificationDropdown: [{
            type: ViewChild,
            args: ['classificationDropdown', { static: false }]
        }] });

class AppLauncherModule {
    // tslint:disable-next-line: variable-name
    static forRoot(appLauncherService) {
        return {
            ngModule: AppLauncherModule,
            providers: [
                {
                    provide: "AppLauncherService",
                    useClass: appLauncherService
                }
            ]
        };
    }
}
/** @nocollapse */ AppLauncherModule.ngModuleDef = ɵɵdefineNgModule({ type: AppLauncherModule });
/** @nocollapse */ AppLauncherModule.ngInjectorDef = ɵɵdefineInjector({ factory: function AppLauncherModule_Factory(t) { return new (t || AppLauncherModule)(); }, providers: [WindowRef], imports: [[
            CommonModule,
            SelectModule,
            ReactiveFormsModule,
            FormsModule,
            FormFieldsModule,
            InputModule,
            SelectModule,
            IconButtonModule,
            ButtonModule,
            OverlayscrollbarsModule,
            RouterModule,
            ProgressIndicatorsModule,
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(AppLauncherModule, { declarations: [AppLauncherComponent,
        AppLauncherCardComponent,
        ImgFallbackDirective], imports: [CommonModule,
        SelectModule,
        ReactiveFormsModule,
        FormsModule,
        FormFieldsModule,
        InputModule,
        SelectModule,
        IconButtonModule,
        ButtonModule,
        OverlayscrollbarsModule,
        RouterModule,
        ProgressIndicatorsModule], exports: [AppLauncherComponent] });
/*@__PURE__*/ ɵsetClassMetadata(AppLauncherModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SelectModule,
                    ReactiveFormsModule,
                    FormsModule,
                    FormFieldsModule,
                    InputModule,
                    SelectModule,
                    IconButtonModule,
                    ButtonModule,
                    OverlayscrollbarsModule,
                    RouterModule,
                    ProgressIndicatorsModule,
                ],
                declarations: [
                    AppLauncherComponent,
                    AppLauncherCardComponent,
                    ImgFallbackDirective
                ],
                exports: [AppLauncherComponent],
                providers: [WindowRef]
            }]
    }], null, null);

const _c0$N = ["data-cy", "activity", 1, "activity"];
const _c1$M = ["class", "activity__header", "data-cy", "activity-header", 4, "ngIf", "ngIfElse"];
const _c2$H = [4, "ngIf", "ngIfElse"];
const _c3$F = ["titleLoader", ""];
const _c4$D = ["loader", ""];
const _c5$B = ["width", "0", "height", "0"];
const _c6$A = ["id", "gradient", "gradientUnits", "objectBoundingBox", "x1", "0", "y1", "1", "x2", "1", "y2", "1"];
const _c7$y = ["stop-color", "#FF85A4"];
const _c8$y = ["offset", "100%", "stop-color", "#AA69FF"];
const _c9$u = ["data-cy", "activity-header", 1, "activity__header"];
function ActivityCardListComponent_h1_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h1", _c9$u);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r904 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵtextInterpolate1(" ", ctx_r904.data.title, " ");
} }
const _c10$t = [1, "activity__list", 3, "ngSwitch"];
const _c11$q = [4, "ngSwitchCase"];
const _c12$o = ["class", "activity__card", 4, "ngFor", "ngForOf"];
const _c13$m = [1, "activity__card"];
const _c14$l = [1, "activity__card__info"];
const _c15$j = [1, "activity__card__info-name"];
const _c16$h = ["href", "javascript:void(0)", "data-cy", "activity-card-link", 1, "activity__card__info-link", 3, "routerLink"];
const _c17$h = [1, "activity__card__info-status"];
const _c18$f = ["data-cy", "activity-card-info-status", 1, "activity__card__info-status-text"];
const _c19$e = ["data-cy", "activity-card-info-date", 1, "activity__card__info-status-modified"];
const _c20$d = [1, "activity__card__chart-container"];
const _c21$c = [1, "activity__card__chart", "activity__card__chart--pf"];
const _c22$c = ["data-cy", "activity-card-chart-pf", 1, "activity__card__chart--percent"];
const _c23$c = [1, "activity__card__chart--title"];
const _c24$b = ["xmlns", "http://www.w3.org/2000/svg", "height", "86", "width", "86", "viewBox", "0 0 220 220", 1, "activity__card__chart--gauge"];
const _c25$a = ["stroke", "#d6d5d6", "d", "M41 149.5a 77 77 0 1 1 117.93 0", "fill", "none", 1, "bg"];
const _c26$a = ["stroke", "#5487FD", "d", "M41 149.5a 77 77 0 1 1 117.93 0", "fill", "none", "stroke-dasharray", "350"];
const _c27$a = [1, "activity__card__chart", "activity__card__chart--avg"];
const _c28$a = ["data-cy", "activity-card-chart-gtq", 1, "activity__card__chart--percent"];
function ActivityCardListComponent_div_2_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c13$m);
    ɵɵelementStart(1, "div", _c14$l);
    ɵɵelementStart(2, "h2", _c15$j);
    ɵɵelementStart(3, "a", _c16$h);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "h4", _c17$h);
    ɵɵelementStart(6, "span", _c18$f);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementStart(8, "span", _c19$e);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", _c20$d);
    ɵɵelementStart(11, "div", _c21$c);
    ɵɵelementStart(12, "span", _c22$c);
    ɵɵtext(13);
    ɵɵpipe(14, "number");
    ɵɵelementEnd();
    ɵɵelementStart(15, "span", _c23$c);
    ɵɵtext(16);
    ɵɵelementEnd();
    ɵɵnamespaceSVG();
    ɵɵelementStart(17, "svg", _c24$b);
    ɵɵelement(18, "path", _c25$a);
    ɵɵelementStart(19, "path", _c26$a);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelementStart(20, "div", _c27$a);
    ɵɵelementStart(21, "span", _c28$a);
    ɵɵtext(22);
    ɵɵpipe(23, "number");
    ɵɵelementEnd();
    ɵɵelementStart(24, "span", _c23$c);
    ɵɵtext(25);
    ɵɵelementEnd();
    ɵɵnamespaceSVG();
    ɵɵelementStart(26, "svg", _c24$b);
    ɵɵelement(27, "path", _c25$a);
    ɵɵelementStart(28, "path", _c26$a);
    ɵɵstyling();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r913 = ctx.$implicit;
    const ctx_r912 = ɵɵnextContext(3);
    ɵɵselect(3);
    ɵɵproperty("routerLink", card_r913.route);
    ɵɵselect(4);
    ɵɵtextInterpolate(card_r913.name);
    ɵɵselect(7);
    ɵɵtextInterpolate1("", card_r913.status, " ");
    ɵɵselect(9);
    ɵɵtextInterpolate1(" ", card_r913.date, "");
    ɵɵselect(13);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(14, 11, card_r913.percentPF.percent, "2.2-2"), " ");
    ɵɵselect(16);
    ɵɵtextInterpolate1(" ", card_r913.percentPF.title, " ");
    ɵɵselect(19);
    ɵɵstyleProp("stroke-dashoffset", ctx_r912.setCirclePercent(card_r913.percentPF.percent));
    ɵɵstylingApply();
    ɵɵselect(22);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind2(23, 14, card_r913.percentGtQ30.percent, "2.2-2"), " ");
    ɵɵselect(25);
    ɵɵtextInterpolate2(" ", card_r913.percentGtQ30.label, " ", card_r913.percentGtQ30.title, " ");
    ɵɵselect(28);
    ɵɵstyleProp("stroke-dashoffset", ctx_r912.setCirclePercent(card_r913.percentGtQ30.percent));
    ɵɵstylingApply();
} }
function ActivityCardListComponent_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ActivityCardListComponent_div_2_ng_container_2_div_1_Template, 29, 17, "div", _c12$o);
    ɵɵpipe(2, "slice");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r910 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind3(2, 1, ctx_r910.data.cards, 0, ctx_r910.showCards));
} }
const _c29$9 = ["href", "javascript:void(0)", "routerLinkActive", "router-link-active", "data-cy", "activity-card-link", 1, "activity__card__info-link", 3, "routerLink"];
const _c30$8 = [1, "activity__card__time-elapsed"];
const _c31$8 = ["data-cy", "activity-card-time-elapsed", 1, "data-list__time-elap"];
const _c32$8 = [1, "data-list__time-elap-item"];
const _c33$6 = [1, "data-list__time-label"];
const _c34$5 = [1, "data-list__time-amt"];
const _c35$5 = [1, "data-list__value-small"];
function ActivityCardListComponent_div_2_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c13$m);
    ɵɵelementStart(1, "div", _c14$l);
    ɵɵelementStart(2, "h2", _c15$j);
    ɵɵelementStart(3, "a", _c29$9);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "h4", _c17$h);
    ɵɵelementStart(6, "span", _c18$f);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementStart(8, "span", _c19$e);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", _c30$8);
    ɵɵelementStart(11, "div", _c31$8);
    ɵɵelementStart(12, "div", _c32$8);
    ɵɵelementStart(13, "span", _c33$6);
    ɵɵtext(14, "HRS");
    ɵɵelementEnd();
    ɵɵelementStart(15, "span", _c34$5);
    ɵɵtext(16);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(17, "div", _c32$8);
    ɵɵelementStart(18, "span", _c33$6);
    ɵɵtext(19, "\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(20, "span", _c34$5);
    ɵɵtext(21, ":");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(22, "div", _c32$8);
    ɵɵelementStart(23, "span", _c33$6);
    ɵɵtext(24, "MIN");
    ɵɵelementEnd();
    ɵɵelementStart(25, "span", _c34$5);
    ɵɵtext(26);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(27, "div", _c32$8);
    ɵɵelementStart(28, "span", _c33$6);
    ɵɵtext(29, "\u00A0");
    ɵɵelementEnd();
    ɵɵelementStart(30, "span", _c34$5);
    ɵɵtext(31, ":");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(32, "div", _c32$8);
    ɵɵelementStart(33, "span", _c33$6);
    ɵɵtext(34, "SEC");
    ɵɵelementEnd();
    ɵɵelementStart(35, "span", _c34$5);
    ɵɵtext(36);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(37, "p", _c35$5);
    ɵɵtext(38, "TIME ELAPSED");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r916 = ctx.$implicit;
    ɵɵselect(3);
    ɵɵproperty("routerLink", card_r916.route);
    ɵɵselect(4);
    ɵɵtextInterpolate(card_r916.name);
    ɵɵselect(7);
    ɵɵtextInterpolate1("", card_r916.status, " ");
    ɵɵselect(9);
    ɵɵtextInterpolate1(" ", card_r916.date, "");
    ɵɵselect(16);
    ɵɵtextInterpolate(card_r916.time.hours);
    ɵɵselect(26);
    ɵɵtextInterpolate(card_r916.time.minutes);
    ɵɵselect(36);
    ɵɵtextInterpolate(card_r916.time.seconds);
} }
function ActivityCardListComponent_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ActivityCardListComponent_div_2_ng_container_3_div_1_Template, 39, 7, "div", _c12$o);
    ɵɵpipe(2, "slice");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r911 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind3(2, 1, ctx_r911.data.cards, 0, ctx_r911.showCards));
} }
function ActivityCardListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c10$t);
    ɵɵtemplate(2, ActivityCardListComponent_div_2_ng_container_2_Template, 3, 5, "ng-container", _c11$q);
    ɵɵtemplate(3, ActivityCardListComponent_div_2_ng_container_3_Template, 3, 5, "ng-container", _c11$q);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r905 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngSwitch", ctx_r905.data.type);
    ɵɵattribute("data-cy", "activity-list-" + ctx_r905.data.type);
    ɵɵselect(2);
    ɵɵproperty("ngSwitchCase", "run");
    ɵɵselect(3);
    ɵɵproperty("ngSwitchCase", "analysis");
} }
const _c36$5 = ["data-cy", "activity-card-title-loader", 1, "activity__card__title-loader", "skltn-card__title"];
const _c37$5 = ["type", "text", 3, "lines"];
function ActivityCardListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c36$5);
    ɵɵelement(1, "lib-skeleton", _c37$5);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("lines", 1);
} }
const _c38$5 = [4, "ngIf"];
const _c39$5 = ["class", "activity__card activity__card--loading", 4, "ngFor", "ngForOf"];
const _c40$5 = [1, "activity__card", "activity__card--loading"];
const _c41$4 = [1, "skltn-card__line"];
const _c42$4 = [3, "ngSwitch"];
const _c43$4 = ["class", "activity__card__chart-container", 4, "ngSwitchCase"];
const _c44$4 = ["class", "activity__card__time-elapsed activity__card__time-elapsed--loading", 4, "ngSwitchCase"];
const _c45$4 = [1, "activity__card__chart--percent-loading"];
const _c46$4 = ["type", "circle"];
const _c47$4 = [1, "activity__card__chart--percent"];
function ActivityCardListComponent_ng_template_5_div_0_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c20$d);
    ɵɵelementStart(1, "div", _c45$4);
    ɵɵelement(2, "lib-skeleton", _c46$4);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", _c47$4);
    ɵɵelement(4, "lib-skeleton", _c46$4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c48$4 = [1, "activity__card__time-elapsed", "activity__card__time-elapsed--loading"];
const _c49$4 = ["type", "rect"];
function ActivityCardListComponent_ng_template_5_div_0_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c48$4);
    ɵɵelementStart(1, "div", _c41$4);
    ɵɵelement(2, "lib-skeleton", _c49$4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function ActivityCardListComponent_ng_template_5_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c40$5);
    ɵɵelementStart(1, "div", _c14$l);
    ɵɵelementStart(2, "div", _c41$4);
    ɵɵelement(3, "lib-skeleton", _c37$5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerStart(4, _c42$4);
    ɵɵtemplate(5, ActivityCardListComponent_ng_template_5_div_0_div_1_div_5_Template, 5, 0, "div", _c43$4);
    ɵɵtemplate(6, ActivityCardListComponent_ng_template_5_div_0_div_1_div_6_Template, 3, 0, "div", _c44$4);
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r919 = ɵɵnextContext(3);
    ɵɵselect(3);
    ɵɵproperty("lines", 2);
    ɵɵselect(4);
    ɵɵproperty("ngSwitch", ctx_r919.data.type);
    ɵɵselect(5);
    ɵɵproperty("ngSwitchCase", "run");
    ɵɵselect(6);
    ɵɵproperty("ngSwitchCase", "analysis");
} }
function ActivityCardListComponent_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, ActivityCardListComponent_ng_template_5_div_0_div_1_Template, 7, 4, "div", _c39$5);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r918 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r918.skeletonCards);
} }
function ActivityCardListComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, ActivityCardListComponent_ng_template_5_div_0_Template, 2, 1, "div", _c38$5);
} if (rf & 2) {
    const ctx_r909 = ɵɵnextContext();
    ɵɵproperty("ngIf", ctx_r909.isLoading);
} }
class ActivityCardListComponent {
    constructor() {
        this.skeletonCards = Array(5).fill(4);
    }
    setCirclePercent(value) {
        const svgLength = 350;
        const actualLength = svgLength * ((100 - value) / 100);
        return actualLength;
    }
}
/** @nocollapse */ ActivityCardListComponent.ngComponentDef = ɵɵdefineComponent({ type: ActivityCardListComponent, selectors: [["lib-activity-card-list"]], factory: function ActivityCardListComponent_Factory(t) { return new (t || ActivityCardListComponent)(); }, inputs: { data: "data", showCards: "showCards", isLoading: "isLoading" }, consts: 12, vars: 4, template: function ActivityCardListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "section", _c0$N);
        ɵɵtemplate(1, ActivityCardListComponent_h1_1_Template, 2, 1, "h1", _c1$M);
        ɵɵtemplate(2, ActivityCardListComponent_div_2_Template, 4, 4, "div", _c2$H);
        ɵɵtemplate(3, ActivityCardListComponent_ng_template_3_Template, 2, 1, "ng-template", null, _c3$F, ɵɵtemplateRefExtractor);
        ɵɵtemplate(5, ActivityCardListComponent_ng_template_5_Template, 1, 1, "ng-template", null, _c4$D, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵnamespaceSVG();
        ɵɵelementStart(7, "svg", _c5$B);
        ɵɵelementStart(8, "defs");
        ɵɵelementStart(9, "linearGradient", _c6$A);
        ɵɵelement(10, "stop", _c7$y);
        ɵɵelement(11, "stop", _c8$y);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r906 = ɵɵreference(4);
        const _r908 = ɵɵreference(6);
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.isLoading)("ngIfElse", _r906);
        ɵɵselect(2);
        ɵɵproperty("ngIf", !ctx.isLoading)("ngIfElse", _r908);
    } }, directives: [NgIf, NgSwitch, NgSwitchCase, NgForOf, RouterLinkWithHref, RouterLinkActive, SkeletonComponent], pipes: [SlicePipe, DecimalPipe], styles: [".data-list{display:block;box-shadow:0 10px 20px 0 rgba(0,0,0,.1);background-color:#fff;position:relative}.data-list--names{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.data-list__title{font-size:26px;font-weight:300;line-height:1.31;letter-spacing:.1875px;color:#322d32;margin:0}.data-list__value{font-size:26px;line-height:1.31;color:#322d32;margin:0;font-weight:400}.data-list__value-small{font-size:12px;letter-spacing:.75px;line-height:1.17;color:#656066;margin:5px 0}.data-list__content{padding:50px 15px 50px 35px;display:-webkit-box;display:flex}.data-list__row{width:100%}.data-list__col-left .data-list__row{padding:8px 0 42px}.data-list__col-right .data-list__row{padding-bottom:30px}.data-list__col-left{-webkit-box-flex:70%;flex:70%;display:-webkit-box;display:flex;font-size:2.6em;border-right:1px solid #f0eff0;flex-wrap:wrap}.data-list__col-right{-webkit-box-flex:30%;flex:30%;display:-webkit-box;display:flex;font-size:16px;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:15px 10px 10px 30px}.data-list__col-right-title{font-size:16px;font-weight:300;line-height:1.31;letter-spacing:.1875px;color:#322d32;margin:0}.data-list__list{max-width:142px;font-size:16px;line-height:1.75;color:#322d32;list-style-type:none;padding-left:0;margin:3px 30px 0 0}.data-list__list-item{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.data-list__time-elap{display:-webkit-box;display:flex;margin:0 2px}.data-list__time-elap-item{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center}.data-list__time-label{color:#787679;font-size:12px;line-height:1.17;letter-spacing:.75px;padding-bottom:1.25px}.data-list__time-amt{color:#312d32;line-height:1.15;letter-spacing:.325px;padding:0 3.125px}.data-list__link{text-decoration:none;background:linear-gradient(79deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;line-height:1.31;letter-spacing:.2px}.data-list__filesize{margin:14px 0 0 17px}.data-list__filesize .data-list__value-small{padding:0 52.8px}.data-list__session-type{padding:0 8px}.data-list__delivery-status{padding:0 17px}.activity__card__chart--label,.activity__card__chart--percent,.activity__card__chart--title,.activity__card__info-name,.activity__card__info-status,body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.activity__card__info-name{font-weight:400;font-size:20px;letter-spacing:.4px;line-height:1.5}.activity__card__chart--percent,.activity__card__info-status{font-weight:400;font-size:16px;letter-spacing:.4px;line-height:1.5}.activity__card__chart--label,.activity__card__chart--title{font-weight:400;font-size:12px;letter-spacing:.34px;line-height:1.1666666667}.activity__card__info,.activity__card__info-name,.activity__card__info-status,.activity__card__info-status-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.btn{background-color:#f0eff0;border:0;border-radius:50px;cursor:pointer;font-size:16px;font-weight:400;letter-spacing:0;line-height:1.4;padding:8px 24px;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn:focus{box-shadow:none;outline:#7e8bf3 solid 4px}.btn:disabled{cursor:not-allowed;opacity:.4}.btn--secondary{background:0 0;color:#4e60ee;border:1px solid #4e60ee}.btn--secondary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);border-color:transparent;color:#fff}.btn--secondary:hover:disabled{color:#4e60ee}.btn--secondary:active:not(:disabled){background:#4e60ee;border-color:transparent;color:#fff}.btn--secondary.btn--small{font-size:14px;padding:5px 19px}.btn--secondary.btn--disabled{opacity:.4}.btn--disabled{cursor:not-allowed}.btn--primary{background:linear-gradient(8.68deg,#225de6 -4.27%,#a664fd 116.09%);color:#fff}.btn--primary:hover:not(:disabled){background:linear-gradient(8.62deg,#0045e6 10%,#8a33fd 100%);color:#fff}.btn--primary:active:not(:disabled){background:#4e60ee;color:#fff;outline:0}.btn--primary.btn--small{padding:5px 19px}.btn--primary.btn--disabled{opacity:.4}.btn--white{background:#fff;padding:7px 24px}.btn--white.btn--small{padding:5px 19px}.btn--white.btn--disabled{opacity:.4}.btn--tertiary{background:0 0;border:1px solid transparent;color:#4e60ee}.btn--tertiary:hover:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee}.btn--tertiary:active:not(:disabled){background:0 0;border-color:#4e60ee;color:#4e60ee;box-shadow:inset 0 0 0 1px #4e60ee}.btn--tertiary:focus:not(:disabled){border-color:#4e60ee}.btn--tertiary.btn--small{font-size:14px}.btn--tertiary.btn--disabled{opacity:.4}.btn--link,.btn--link:not([href]){background:0 0;color:#4e60ee!important}.btn--link:hover:not(:disabled),.btn--link:not([href]):hover:not(:disabled){background:0 0;color:#4e60ee;text-decoration:underline}.btn--link:active,.btn--link:not([href]):active{background:0 0}.btn--link.btn--small,.btn--link:not([href]).btn--small{font-size:14px}.btn--link.btn--disabled,.btn--link:not([href]).btn--disabled{opacity:.4}.data-list__time-amt{font-size:20px}.data-list__value-small{padding:0}.activity__header{color:#312d32;font-size:24px;font-weight:300;line-height:1.3;margin-bottom:10px;text-align:left}.activity__card{border-bottom:1px solid #d6d5d6;border-top:1px solid #d6d5d6;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;min-height:114px;padding:26px 0 15px;position:relative}.activity__card:not(:first-child){border-top:0}.activity__card__title-loader{margin:12px 0 20px;width:35%}.activity__card--loading{padding:24px 0 7px}.activity__card__info{-webkit-box-flex:1;flex-grow:1;margin-right:20px}.activity__card__info-name{margin-bottom:2px}.activity__card__info-link{color:#4e60ee}.activity__card__info-status{display:-webkit-box;display:flex;margin:0}.activity__card__info-status-text{color:#312d32;margin-right:16px}.activity__card__info-status-modified{color:#5b575b}.activity__card__chart{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding-top:16px;position:relative;width:80px}.activity__card__chart-container{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;position:relative;right:-6px;width:160px;-webkit-transition:visibility linear .33s,opacity .33s linear;transition:visibility linear .33s,opacity .33s linear}.activity__card__chart svg path{will-change:auto;stroke-width:5px;stroke-miterlimit:round;-webkit-transition:stroke-dashoffset 850ms ease-in-out;transition:stroke-dashoffset 850ms ease-in-out}.activity__card__chart--percent-loading{margin:0 20px 0 10px}.activity__card__chart--title{color:#5b575b;letter-spacing:1.2px;position:relative;top:8px}.activity__card__chart--label{color:#d1cfd1;letter-spacing:1.2px;position:relative;top:-5px}.activity__card__chart--gauge{left:0;position:absolute;top:-11px}.activity__card__time-elapsed{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;min-width:160px;padding-bottom:9px;width:160px;-webkit-transition:visibility linear .33s,opacity .33s linear;transition:visibility linear .33s,opacity .33s linear}.activity__card__time-elapsed--loading{position:relative;top:-5px}.activity__card__time-elapsed .skltn-card__line{width:100px}.skltn-card{margin:80px 0 48px}.skltn-card__activity-card{border-bottom:1px solid #d6d5d6;border-top:1px solid #d6d5d6;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;padding:26px 0 15px;position:relative}.skltn-card__activity-card:not(:first-child){border-top:0}.skltn-card__line{padding:11px 0}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(ActivityCardListComponent, [{
        type: Component,
        args: [{
                selector: "lib-activity-card-list",
                templateUrl: "./activity-card-list.component.html",
                styleUrls: ["./activity-card-list.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }], showCards: [{
            type: Input
        }], isLoading: [{
            type: Input
        }] });

class ActivityCardListModule {
}
/** @nocollapse */ ActivityCardListModule.ngModuleDef = ɵɵdefineNgModule({ type: ActivityCardListModule });
/** @nocollapse */ ActivityCardListModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ActivityCardListModule_Factory(t) { return new (t || ActivityCardListModule)(); }, imports: [[CommonModule,
            ProgressIndicatorsModule, RouterModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ActivityCardListModule, { declarations: [ActivityCardListComponent], imports: [CommonModule,
        ProgressIndicatorsModule, RouterModule], exports: [ActivityCardListComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ActivityCardListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule,
                    ProgressIndicatorsModule, RouterModule],
                declarations: [ActivityCardListComponent],
                exports: [ActivityCardListComponent]
            }]
    }], null, null);

const _c0$O = ["search"];
const _c1$N = ["dataTableContainer"];
const _c2$I = [1, "matcher-wrapper"];
const _c3$G = [1, "matcher-header"];
const _c4$E = [1, "matcher-header__search"];
const _c5$C = ["for", "matcher-header__search_id"];
const _c6$B = ["id", "matcher-header__search_id", "lib-input", "", "type", "text", "placeholder", "Search ..."];
const _c7$z = ["search", ""];
const _c8$z = [1, "matcher-header__title"];
const _c9$v = [1, "matcher-body"];
class MatcherComponent {
    constructor() {
        this.rowData = [
            {
                biosample: "HM07_BioChain_Jurkat_1b_A004",
                project: "NovaSeq6000SPXp:SureCellRNASing",
                owner: "Illumina, Inc.",
                dateCreated: "2019-08-08 05:45"
            },
            {
                biosample: "HM07_HCC1187BL_2b_Combined",
                project: "NovaSeq 6000 SP Xp:SureCell RNA",
                owner: "Illumina, Inc.",
                dateCreated: "2019-08-08 05:45"
            },
            {
                biosample: "HM07_HCC1187C_2c_A013",
                project: "MiniSeq:TruSeqAmpliconsomaticpanel ",
                owner: "Illumina, Inc.",
                dateCreated: "2019-08-08 05:45"
            },
            {
                biosample: "HM07_HCC1187C_2d_Combined",
                project: "HiSeq2500:TruSeqMethylCapture-EPIC",
                owner: "Illumina, Inc.",
                dateCreated: "2019-08-08 05:45"
            },
            {
                biosample: "NA12878-rep2",
                project: "NovaSeq 6000 SP Xp:SureCell RNA",
                owner: "Illumina, Inc.",
                dateCreated: "2019-08-08 05:45"
            },
            {
                biosample: "NA12878_AmpliSeqExome_v25",
                project: "NovaSeq 6000 SP Xp:SureCell RNA",
                owner: "Illumina, Inc.",
                dateCreated: "2019-08-08 05:45"
            }
        ];
        this.columnDefs = [
            {
                headerName: "Biosample",
                field: "biosample",
                headerCheckboxSelection: true,
                checkboxSelection: true,
                cellRenderer: "link"
            },
            {
                headerName: "Project",
                field: "project",
                cellRenderer: "link",
                width: 140
            },
            {
                headerName: "Owner",
                field: "owner",
                cellRenderer: "span",
                width: 80
            },
            {
                headerName: "Created",
                field: "dateCreated",
                cellRenderer: "span",
                suppressSizeToFit: true
            }
        ];
        this.gridOptions = {
            columnDefs: this.columnDefs,
            pagination: true,
            paginationAutoPageSize: true,
            domLayout: "autoHeight"
            // onGridReady: ({ api }: AgGridEvent) => {
            //   api.sizeColumnsToFit();
            // }
        };
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this.osInstanceDataTable = OverlayScrollbars(this.dataTableContainer.nativeElement, {});
        fromEvent(this.search.nativeElement, "keyup")
            .pipe(debounceTime(500), distinctUntilChanged(), tap(() => {
            //gridOptions.api.setQuickFilter(this.search.nativeElement.value);
        }))
            .subscribe();
    }
    ngOnDestroy() {
        if (this.osInstanceDataTable && this.osInstanceDataTable.destroy) {
            this.osInstanceDataTable.destroy();
        }
    }
}
/** @nocollapse */ MatcherComponent.ngComponentDef = ɵɵdefineComponent({ type: MatcherComponent, selectors: [["lib-matcher"]], factory: function MatcherComponent_Factory(t) { return new (t || MatcherComponent)(); }, viewQuery: function MatcherComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$O, true, ElementRef);
        ɵɵstaticViewQuery(_c1$N, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.search = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dataTableContainer = _t.first);
    } }, inputs: { title: "title" }, consts: 9, vars: 1, template: function MatcherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c2$I);
        ɵɵelementStart(1, "div", _c3$G);
        ɵɵelementStart(2, "div", _c4$E);
        ɵɵelementStart(3, "lib-form-field", _c5$C);
        ɵɵelement(4, "input", _c6$B, _c7$z);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", _c8$z);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(8, "div", _c9$v);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(7);
        ɵɵtextInterpolate1(" ", ctx.title, " ");
    } }, directives: [FormFieldsComponent, InputComponent], styles: [".data-table a:link{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(46deg,#225de6 0,#7723e6 121%);color:transparent;-webkit-text-fill-color:transparent}body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.data-table{width:100%}.data-table .ag-header-row,.data-table .ag-root,.data-table .ag-root-wrapper{overflow:visible}.data-table .ag-root,.data-table .ag-root-wrapper,.data-table .ag-unselectable{-webkit-user-select:text!important;-moz-user-select:text!important;-ms-user-select:text!important;user-select:text!important}.data-table .ag-center-cols-clipper{overflow:hidden;margin-top:20px}.data-table .ag-center-cols-viewport{width:calc(100% + 1px);margin-top:-20px;overflow-x:auto}.data-table .ag-header-viewport{overflow:hidden}.data-table .ag-row-drag{width:40px;height:20px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/handlebars.svg);background-repeat:no-repeat;background-position:center;cursor:-webkit-grab;cursor:grab}.data-table .ag-header{position:relative;z-index:1;overflow:visible}.data-table .ag-body-viewport{margin-top:2px}.data-table .ag-header-cell{color:#787679;display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;font-size:16px;font-weight:500;line-height:1.4;text-align:right;-webkit-box-pack:space-evenly;justify-content:space-evenly;text-transform:capitalize;overflow:visible}.data-table .ag-header-cell .ag-input-wrapper{left:5px;top:-4px}.data-table .ag-header-cell .ag-header-cell-label{padding:0 16px}.data-table--metrics .data-table .ag-header-cell .ag-header-cell-label{padding:0 20px}.data-table .ag-header-cell .ag-header-cell-text{height:20px;overflow:visible;text-overflow:unset;white-space:normal;-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex}.data-table--metrics .data-table .ag-header-cell:first-child .ag-header-cell-label{padding-left:0}.data-table .ag-header-cell-numeric .ag-header-cell-label{-webkit-box-pack:end;justify-content:flex-end}.data-table .ag-header-cell.last .ag-header-cell-label{padding-right:0}.data-table--metrics .data-table .ag-header-cell.data-table__th--two-lines{word-spacing:20px}.data-table .ag-header-cell-resize{display:block;cursor:pointer;width:12px;height:12px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/column-divider.svg);background-repeat:no-repeat;-webkit-transition:.1s;transition:.1s;top:3px}.data-table .ag-header-cell-resize:hover{background-repeat:no-repeat;cursor:col-resize}.data-table .ag-header-cell-numeric.last .ag-header-cell-label{margin-right:15px}.data-table .ag-header-cell:last-of-type .ag-header-cell-resize{margin-right:5px!important;background-position:5px}.data-table .ag-row{overflow:visible}.data-table .ag-row.ag-row-selected{background:#f9f9f9;border-top-color:#f0eff0}.data-table .ag-row:hover .ag-cell,.data-table .ag-row:hover .ag-cell--floating{background:#f9f9f9}.data-table .ag-row .ag-loading-text{display:none}.data-table .ag-cell{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;position:absolute;border-bottom:1px solid #f0eff0;border-top:1px solid transparent;color:#464247;font-size:16px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:.4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.data-table .ag-cell .ag-selection-checkbox{top:-5px;left:5px;width:14px}.data-table .ag-cell-numeric{-webkit-box-pack:end;justify-content:flex-end;text-align:right}.data-table .ag-cell-numeric .data-table__content{padding-right:16px}.data-table .ag-cell-numeric .lib-popover__datatable_tooltip-button{margin-right:22px;max-width:calc(100% - 34px)}.data-table .ag-cell-value{width:100%;padding:0 16px}.data-table .ag-cell.last .data-table .ag-cell-content{padding-right:0}.data-table .ag-cell.last .data-table__content,.data-table .ag-cell.last .lib-popover__datatable_tooltip-button{padding-right:0;margin-right:0}.data-table .ag-cell.data-table__td--floating{background:#fff;border:0!important;margin-left:11px;padding-left:8px;padding-right:8px;z-index:1}.data-table .ag-cell--totals{background:#f9f9f9;border-bottom:1px solid #f0eff0;border-top:1px solid #f0eff0;font-weight:500}.data-table .ag-cell--totals:first-child{left:-11px!important;padding-left:11px}.data-table .ag-cell--totals:last-child{right:-11px!important;padding-right:11px}.data-table .ag-cell:focus{outline:0}.data-table .ag-cell--failed{font-weight:500}.data-table__content{overflow:hidden;text-overflow:ellipsis}.data-table__content-link{color:#4e60ee!important;background:padding-box unset unset!important;-webkit-text-fill-color:#4e60ee!important;display:inline-block;position:relative}.data-table__content-link:hover{text-decoration:none!important}.data-table__content-link:hover:after{content:\"\";display:block;height:0;width:100%;border-top:1px solid #4e60ee;position:absolute;bottom:1px}.data-table--metrics .data-table__content{padding:20px}.data-table--metrics .data-table__content:first-child{padding-left:0}.data-table .ag-header-cell:first-child .ag-header-select-all.ag-checkbox.ag-hidden .radio__label,.data-table .ag-paging-panel{display:none}.data-table .ag-header-cell:first-child .ag-header-select-all .checkbox__label{top:-4px}.data-table .ag-header-cell.select-all-current-page .ag-header-select-all{display:-webkit-box!important;display:flex!important;width:14px}.data-table .ag-popup{top:0;position:absolute;overflow:visible;display:inline-block}.data-table .ag-popup .ag-menu{position:relative;overflow:hidden}.data-table .ag-popup .ag-menu-header{display:none}.data-table--metrics{border-top:1px solid #d1cfd1;padding-top:14px}.data-table--metrics .ag-grid-body-viewport{overflow:visible!important}.data-table--metrics .ag-header-row{border-bottom:1px solid #f0eff0}.data-table-toolbar{position:relative;width:100%;max-height:42px;line-height:42px;margin-bottom:10px;text-align:right}.data-table-toolbar__clear-selected-container{margin-bottom:31px;margin-right:20px}.data-table-toolbar__clear-selected-btn{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/close-small.svg) center no-repeat;border:none;height:28px;outline:0;-webkit-transform:translate(0,8px);transform:translate(0,8px);width:28px;vertical-align:top}.data-table-toolbar .data-table-toolbar__items{position:absolute;top:-80px;right:0;-webkit-box-align:center;align-items:center;height:auto;display:-webkit-box;display:flex;max-width:50%}.data-table__dnd-header{margin-left:40px}.os-theme-dark>.os-scrollbar-vertical{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark>.os-scrollbar>.os-scrollbar-track{background:#f0eff0}.os-theme-dark .os-scrollbar-handle{background:#656066;width:.2rem}.matcher-wrapper{position:relative;width:90%;margin:0 auto}.matcher-header__search{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;margin-bottom:2rem}.matcher-header__search::before{display:block;content:\"\";width:32px;height:32px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/search-in-line.svg);background-repeat:no-repeat;background-position:center;background-size:cover;margin-right:.5rem}.matcher-header__search .input-field__text-input{border-bottom-width:0!important}.matcher-header__title{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;border-bottom:1px solid #d1cfd1;padding-bottom:1rem;font-weight:300;font-size:2.6rem;letter-spacing:.03rem;line-height:1.3}.matcher-header__title::after{display:block;content:\"\";width:20px;height:20px;background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/20/info.svg);background-repeat:no-repeat;background-position:center;background-size:cover;margin-left:.5rem}.matcher-body{margin-top:1rem;max-height:50rem}.matcher-body-item{overflow-y:hidden;max-height:500px}.matcher-modal{width:127rem;max-width:127rem}.matcher-modal .modal-dialog__content{margin-top:0}.matcher-modal .modal-dialog__footer{-webkit-box-pack:end;justify-content:flex-end}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ ɵsetClassMetadata(MatcherComponent, [{
        type: Component,
        args: [{
                selector: "lib-matcher",
                templateUrl: "./matcher.component.html",
                styleUrls: ["./matcher.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], search: [{
            type: ViewChild,
            args: ["search", { read: ElementRef, static: false }]
        }], dataTableContainer: [{
            type: ViewChild,
            args: ["dataTableContainer", { static: true }]
        }] });

class MatcherModule {
}
/** @nocollapse */ MatcherModule.ngModuleDef = ɵɵdefineNgModule({ type: MatcherModule });
/** @nocollapse */ MatcherModule.ngInjectorDef = ɵɵdefineInjector({ factory: function MatcherModule_Factory(t) { return new (t || MatcherModule)(); }, imports: [[
            CommonModule,
            DataTableModule,
            FormFieldsModule,
            InputModule,
            DndListModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(MatcherModule, { declarations: [MatcherComponent], imports: [CommonModule,
        DataTableModule,
        FormFieldsModule,
        InputModule,
        DndListModule], exports: [MatcherComponent] });
/*@__PURE__*/ ɵsetClassMetadata(MatcherModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DataTableModule,
                    FormFieldsModule,
                    InputModule,
                    DndListModule
                ],
                declarations: [MatcherComponent],
                exports: [MatcherComponent]
            }]
    }], null, null);

const _c0$P = [1, "table-content"];
const _c1$O = [1, "table-row", "table-row__th"];
const _c2$J = [1, "table-cell"];
const _c3$H = ["class", "table-row", 4, "ngIf"];
const _c4$F = ["class", "table-row", 3, "ngClass", 4, "ngFor", "ngForOf"];
const _c5$D = [1, "table-row"];
function MetricsTableComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c5$D);
    ɵɵtext(1, " No data available ");
    ɵɵelementEnd();
} }
const _c6$C = [1, "table-row", 3, "ngClass"];
const _c7$A = function (a0) { return { "table-row__summary": a0 }; };
function MetricsTableComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c6$C);
    ɵɵelementStart(1, "div", _c2$J);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", _c2$J);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", _c2$J);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", _c2$J);
    ɵɵtext(8);
    ɵɵelementEnd();
    ɵɵelementStart(9, "div", _c2$J);
    ɵɵtext(10);
    ɵɵelementEnd();
    ɵɵelementStart(11, "div", _c2$J);
    ɵɵtext(12);
    ɵɵelementEnd();
    ɵɵelementStart(13, "div", _c2$J);
    ɵɵtext(14);
    ɵɵelementEnd();
    ɵɵelementStart(15, "div", _c2$J);
    ɵɵtext(16);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r926 = ctx.$implicit;
    ɵɵproperty("ngClass", ɵɵpureFunction1(9, _c7$A, rowData_r926.isSummary));
    ɵɵselect(2);
    ɵɵtextInterpolate(rowData_r926.rowName);
    ɵɵselect(4);
    ɵɵtextInterpolate(rowData_r926.TotalCycles);
    ɵɵselect(6);
    ɵɵtextInterpolate(rowData_r926.YieldTotal);
    ɵɵselect(8);
    ɵɵtextInterpolate(rowData_r926.ProjectedTotalYield);
    ɵɵselect(10);
    ɵɵtextInterpolate(rowData_r926.PercentAligned.toFixed(2));
    ɵɵselect(12);
    ɵɵtextInterpolate(rowData_r926.ErrorRate.toFixed(2));
    ɵɵselect(14);
    ɵɵtextInterpolate(rowData_r926.IntensityCycle1.toFixed(2));
    ɵɵselect(16);
    ɵɵtextInterpolate(rowData_r926.PercentGtQ30.toFixed(2));
} }
class MetricsTableComponent {
    constructor() { }
    ngOnInit() {
        this.indexMark = this.indexMark || "(I)";
        this.rowName = this.rowName || "Read";
        this.totalsTitles = this.totalsTitles || ["Non-index Reads Total", "Total"];
        this.preparedData = this.prepareData(this.metricsData, this.totalsData);
    }
    prepareData(initData, totalsData) {
        const that = this;
        let tableRows;
        tableRows = initData.map((currentRowData) => {
            return prepareTableRowData(currentRowData, false);
        });
        if (totalsData && 0 < totalsData.length) {
            tableRows = tableRows.concat(totalsData.map((currentRowData, idx) => {
                return prepareTableRowData(currentRowData, true, this.totalsTitles[idx]);
            }));
        }
        return tableRows;
        function prepareTableRowData(rowData, isSummaryRow, rowTitle) {
            let nameOfTheRow = `${that.rowName} ${1 > rowData.ReadNumber ? "" : rowData.ReadNumber} ${rowData.IsIndexed ? that.indexMark : ""}`;
            if (rowTitle) {
                nameOfTheRow = rowTitle;
            }
            else if (isSummaryRow) {
                nameOfTheRow = "Total";
            }
            return {
                rowName: nameOfTheRow,
                isSummary: (isSummaryRow && nameOfTheRow === "Total"),
                ReadNumber: rowData.ReadNumber,
                IsIndexed: rowData.IsIndexed,
                TotalCycles: rowData.TotalCycles,
                YieldTotal: rowData.YieldTotal,
                ProjectedTotalYield: rowData.ProjectedTotalYield,
                PercentAligned: rowData.PercentAligned,
                ErrorRate: rowData.ErrorRate,
                IntensityCycle1: rowData.IntensityCycle1,
                PercentGtQ30: rowData.PercentGtQ30,
                PercentGtQ30Last10Cycles: rowData.PercentGtQ30Last10Cycles
            };
        }
    }
}
/** @nocollapse */ MetricsTableComponent.ngComponentDef = ɵɵdefineComponent({ type: MetricsTableComponent, selectors: [["lib-metrics-table"]], factory: function MetricsTableComponent_Factory(t) { return new (t || MetricsTableComponent)(); }, inputs: { metricsData: "metricsData", totalsData: "totalsData", totalsTitles: "totalsTitles", tableName: "tableName", rowName: "rowName", indexMark: "indexMark" }, consts: 27, vars: 3, template: function MetricsTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "article");
        ɵɵelementStart(1, "header");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", _c0$P);
        ɵɵelementStart(4, "div", _c1$O);
        ɵɵelementStart(5, "div", _c2$J);
        ɵɵtext(6, "Read");
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", _c2$J);
        ɵɵtext(8, "Cycles");
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", _c2$J);
        ɵɵtext(10, "Yield");
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", _c2$J);
        ɵɵtext(12, "Projected yield");
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", _c2$J);
        ɵɵtext(14, "Aligned");
        ɵɵelement(15, "br");
        ɵɵtext(16, "(%)");
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", _c2$J);
        ɵɵtext(18, "Error rate");
        ɵɵelement(19, "br");
        ɵɵtext(20, "(%)");
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", _c2$J);
        ɵɵtext(22, "Intensity cycle 1");
        ɵɵelementEnd();
        ɵɵelementStart(23, "div", _c2$J);
        ɵɵtext(24, "%>Q30");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(25, MetricsTableComponent_div_25_Template, 2, 0, "div", _c3$H);
        ɵɵtemplate(26, MetricsTableComponent_div_26_Template, 17, 11, "div", _c4$F);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(2);
        ɵɵtextInterpolate(ctx.tableName);
        ɵɵselect(25);
        ɵɵproperty("ngIf", 1 > ctx.preparedData.length);
        ɵɵselect(26);
        ɵɵproperty("ngForOf", ctx.preparedData);
    } }, directives: [NgIf, NgForOf, NgClass], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}header[_ngcontent-%COMP%]{font-size:26px;font-weight:300;font-stretch:normal;font-style:normal;line-height:1.31;letter-spacing:.3px;color:#322d32;margin-bottom:7px}.table-content[_ngcontent-%COMP%]{width:100%;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;border-top:1px solid #d5d3d5}.table-cell[_ngcontent-%COMP%]{width:12.5%;padding:1.5rem 1rem;text-align:right;font-size:14px;font-weight:400;line-height:1.43;white-space:nowrap}.table-cell[_ngcontent-%COMP%]:first-child{width:12%;padding-left:0;text-align:left;white-space:normal}.table-cell[_ngcontent-%COMP%]:nth-child(2), .table-cell[_ngcontent-%COMP%]:nth-child(3){width:13%}.table-row[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;border-bottom:1px solid #f0eff0}.table-row__th[_ngcontent-%COMP%]   .table-cell[_ngcontent-%COMP%]{font-size:12px;line-height:1.17;text-transform:uppercase;color:#656167;white-space:normal}.table-row__summary[_ngcontent-%COMP%]{background:#f9f9f9}.table-row__summary[_ngcontent-%COMP%]   .table-cell[_ngcontent-%COMP%]{font-weight:700}.table-row[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #d5d3d5}"] });
/*@__PURE__*/ ɵsetClassMetadata(MetricsTableComponent, [{
        type: Component,
        args: [{
                selector: "lib-metrics-table",
                templateUrl: "./metrics-table.component.html",
                styleUrls: ["./metrics-table.component.scss"]
            }]
    }], function () { return []; }, { metricsData: [{
            type: Input
        }], totalsData: [{
            type: Input
        }], totalsTitles: [{
            type: Input
        }], tableName: [{
            type: Input
        }], rowName: [{
            type: Input
        }], indexMark: [{
            type: Input
        }] });

class MetricsTableModule {
}
/** @nocollapse */ MetricsTableModule.ngModuleDef = ɵɵdefineNgModule({ type: MetricsTableModule });
/** @nocollapse */ MetricsTableModule.ngInjectorDef = ɵɵdefineInjector({ factory: function MetricsTableModule_Factory(t) { return new (t || MetricsTableModule)(); }, imports: [[
            CommonModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(MetricsTableModule, { declarations: [MetricsTableComponent], imports: [CommonModule], exports: [MetricsTableComponent] });
/*@__PURE__*/ ɵsetClassMetadata(MetricsTableModule, [{
        type: NgModule,
        args: [{
                declarations: [MetricsTableComponent],
                imports: [
                    CommonModule
                ],
                exports: [MetricsTableComponent]
            }]
    }], null, null);

const _c0$Q = ["ref", "eLabel", "role", "presentation", "unselectable", "on", 1, "ag-header-cell-label", 2, "display", "block"];
const _c1$P = ["ref", "eText", "role", "columnheader", "unselectable", "on", "aria-colindex", "1", 1, "ag-header-cell-text", 2, "float", "right"];
const _c2$K = [1, "ag-header-cell-text__title"];
class RightAlignedHeaderComponent {
    constructor() {
        this.headerName = null;
    }
    agInit(params) {
        this.headerName = params.displayName;
    }
}
/** @nocollapse */ RightAlignedHeaderComponent.ngComponentDef = ɵɵdefineComponent({ type: RightAlignedHeaderComponent, selectors: [["lib-right-aligned-header"]], factory: function RightAlignedHeaderComponent_Factory(t) { return new (t || RightAlignedHeaderComponent)(); }, consts: 5, vars: 1, template: function RightAlignedHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$Q);
        ɵɵelementStart(1, "span", _c1$P);
        ɵɵelementContainerStart(2);
        ɵɵelementStart(3, "span", _c2$K);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementContainerEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(4);
        ɵɵtextInterpolate1(" ", ctx.headerName, " ");
    } }, styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]{width:100%}.ag-header-cell-text[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-wrap:nowrap;-webkit-box-pack:start;justify-content:flex-start;align-content:stretch;-webkit-box-align:center;align-items:center;position:relative;max-width:100%}.ag-header-cell-text__title[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ag-header-cell-text[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{-webkit-box-flex:0;flex:0 1 auto;-ms-grid-row-align:auto;align-self:auto}"] });
/*@__PURE__*/ ɵsetClassMetadata(RightAlignedHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-right-aligned-header',
                templateUrl: './right-aligned-header.component.html',
                styleUrls: ['./right-aligned-header.component.scss']
            }]
    }], function () { return []; }, null);

const _c0$R = [1, "file-browser"];
const _c1$Q = ["style", "min-height: 300px; width: 100%", 4, "ngIf"];
const _c2$L = [2, "min-height", "300px", "width", "100%"];
const _c3$I = ["id", "myGrid", 1, "ag-theme-alpine", 2, "width", "100%", "height", "100%", 3, "rowData", "getRowHeight", "columnDefs", "defaultColDef", "frameworkComponents", "suppressContextMenu", "autoGroupColumnDef", "components", "treeData", "animateRows", "groupDefaultExpanded", "getDataPath", "getRowNodeId", "cellClicked", "gridReady"];
const _c4$G = ["agGrid", ""];
function FileBrowserComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r930 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c2$L);
    ɵɵelementStart(1, "ag-grid-angular", _c3$I, _c4$G);
    ɵɵlistener("cellClicked", function FileBrowserComponent_div_1_Template_ag_grid_angular_cellClicked_1_listener($event) { ɵɵrestoreView(_r930); const ctx_r929 = ɵɵnextContext(); return ctx_r929.cellClickProcessor($event); });
    ɵɵlistener("gridReady", function FileBrowserComponent_div_1_Template_ag_grid_angular_gridReady_1_listener($event) { ɵɵrestoreView(_r930); const ctx_r931 = ɵɵnextContext(); return ctx_r931.onGridReady($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r927 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("rowData", ctx_r927.rowData)("getRowHeight", ctx_r927.getRowHeight)("columnDefs", ctx_r927.fileBrowserColumnDefs)("defaultColDef", ctx_r927.defaultColDef)("frameworkComponents", ctx_r927.frameworkComponents)("suppressContextMenu", true)("autoGroupColumnDef", ctx_r927.autoGroupColumnDef)("components", ctx_r927.components)("treeData", true)("animateRows", true)("groupDefaultExpanded", ctx_r927.groupDefaultExpanded)("getDataPath", ctx_r927.getDataPath)("getRowNodeId", ctx_r927.getRowNodeId);
} }
class FileBrowserComponent {
    constructor() {
        this.updateNode = new EventEmitter();
        this.onFileSelected = new EventEmitter();
        this.rowData = [];
        this.frameworkComponents = {
            rightAlignedHeader: RightAlignedHeaderComponent
        };
        this.defaultColDef = {
            flex: 1,
            filter: false,
            sortable: false,
            resizable: true,
        };
        this.autoGroupColumnDef = {
            field: "grouper",
            headerName: "Name",
            minWidth: 300,
            cellRendererParams: {
                checkbox: false,
                suppressCount: true,
                suppressDoubleClickExpand: true,
                innerRenderer: "fileCellRenderer",
            },
        };
        this.groupDefaultExpanded = -1;
        this.components = {
            fileCellRenderer: getFileCellRenderer(),
            pathColumnRenderer: CustomPathColumnRenderer,
            dateColumnRenderer: CustomDateColumnRenderer,
            sizeCellRenderer: CustomSizeColumnRenderer,
            link: CustomLinkColumnRenderer
        };
        this.getDataPath = (data) => {
            return data.grouper;
        };
        this.getRowNodeId = (data) => {
            return data.id;
        };
    }
    // nodeToUpdate is one particular node (folder), it can extend from  ITreeFolder with additonal fields
    // grouper(array of hashIds) and hasUpdated(boolean)
    mapDirectoryToTree(inputTreeLevel, nodeToUpdate) {
        const resultRowData = []; // array of nodes
        if (nodeToUpdate) {
            nodeToUpdate.hasUpdated = true;
        }
        if (!inputTreeLevel || !inputTreeLevel.subDirectories) {
            return resultRowData;
        }
        inputTreeLevel.subDirectories.map((directory) => {
            resultRowData.push(Object.assign({}, directory, {
                grouper: nodeToUpdate ? nodeToUpdate.grouper.concat([directory.hashID]) : [directory.hashID],
                hasUpdated: false
            }));
        });
        inputTreeLevel.items.map((file) => {
            resultRowData.push(Object.assign({}, file, {
                grouper: nodeToUpdate ? nodeToUpdate.grouper.concat([file.hashID]) : [file.hashID]
            }));
        });
        return resultRowData;
    }
    getRowHeight(params) {
        return 70;
    }
    // nodeData is data returned by ag-grid on cell click
    cellClickProcessor(nodeData) {
        const node = nodeData.node;
        const data = nodeData.data; // data is of type INode
        if (node.allChildrenCount) {
            node.setExpanded(!node.expanded);
        }
        // if data is of type ITreeFIleNode
        if (data.isFile) {
            this.onFileSelected.emit(data.apiData);
            return;
        }
        // if data is of type ITreeFolderNode
        if (data.hasUpdated) {
            return;
        }
        else {
            data.hasUpdated = true;
        }
        const iTreeItem = {
            id: data.id,
            name: data.name,
            hashID: data.hashID,
            path: data.path,
            folderType: data.folderType,
            type: data.type //file type
        };
        const iDirectoryItem = iTreeItem;
        iDirectoryItem.subDirectories = [];
        iDirectoryItem.items = [];
        this.updateNode.emit(iDirectoryItem);
    }
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
    }
    ngOnInit() {
        this.fileBrowserColumnDefs = (!this.columnDefs || this.columnDefs.length == 0) ? [
            {
                field: "type",
                minWidth: 50,
                maxWidth: 150,
                resizable: false,
                valueFormatter: (params) => {
                    if (params.data.isFile) {
                        return params.data.type; // file type
                    }
                    else if (!isNullOrUndefined(params.data.folderType)) {
                        return params.data.folderType; // AppResult or Dataset
                    }
                    else {
                        return "Folder";
                    }
                }
            },
            {
                field: "size",
                minWidth: 110,
                maxWidth: 120,
                resizable: false,
                headerComponent: "rightAlignedHeader",
                cellRenderer: "sizeCellRenderer"
            },
            {
                field: "path",
                minWidth: 190,
                cellRenderer: "pathColumnRenderer"
            },
            {
                field: "created",
                minWidth: 140,
                maxWidth: 170,
                resizable: false,
                headerComponent: "rightAlignedHeader",
                cellRenderer: "dateColumnRenderer"
            }
        ] : this.columnDefs;
        this.components = {
            fileCellRenderer: getFileCellRenderer(),
            pathColumnRenderer: CustomPathColumnRenderer,
            dateColumnRenderer: CustomDateColumnRenderer,
            sizeCellRenderer: CustomSizeColumnRenderer,
            link: CustomLinkColumnRenderer
        };
        this.groupDefaultExpanded = -1;
        if (!this.treeData) {
            this.rowData = this.mapDirectoryToTree(this.treeData ? this.treeData.nodeData : null);
        }
        this.isReady = "ready";
    }
    ngOnChanges(changes) {
        if (changes.treeData && changes.treeData.currentValue) {
            if ("undefined" === typeof changes.treeData.currentValue.nodeId || !changes.treeData.currentValue.nodeId) {
                const initTree = this.mapDirectoryToTree(changes.treeData.currentValue.nodeData);
                this.completeTree = initTree;
                this.rowData = initTree;
            }
            else {
                const node = this.completeTree.find((val) => {
                    return "" + val.hashID === "" + changes.treeData.currentValue.nodeId;
                });
                if (node) {
                    const newNodes = this.mapDirectoryToTree(changes.treeData.currentValue.nodeData, node);
                    this.completeTree = this.completeTree.concat(newNodes);
                    this.gridApi.updateRowData({
                        add: newNodes
                    });
                }
            }
        }
    }
}
/** @nocollapse */ FileBrowserComponent.ngComponentDef = ɵɵdefineComponent({ type: FileBrowserComponent, selectors: [["lib-file-browser"]], factory: function FileBrowserComponent_Factory(t) { return new (t || FileBrowserComponent)(); }, inputs: { treeData: "treeData", columnDefs: "columnDefs" }, outputs: { updateNode: "updateNode", onFileSelected: "onFileSelected" }, features: [ɵɵNgOnChangesFeature()], consts: 2, vars: 1, template: function FileBrowserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$R);
        ɵɵtemplate(1, FileBrowserComponent_div_1_Template, 3, 13, "div", _c1$Q);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", !!ctx.isReady);
    } }, directives: [NgIf, AgGridAngular], styles: ["body,h1,h2,h3,h4,h5,h6,p{font-family:Inter,sans-serif}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:root{font-size:62.5%}:root body{font-size:1.6rem}h1,h2,h3,h4,h5,h6,p{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable{pointer-events:none;cursor:not-allowed}.file-browser{font-family:Roboto,sans-serif}.file-browser .ag-theme-alpine{color:#322d32;font-size:1.6rem}.file-browser .ag-theme-alpine .ag-root-wrapper{border:0}.file-browser .ag-theme-alpine .ag-header{background:0 0;border:0}.file-browser .ag-theme-alpine .ag-header-row{font-size:12px;font-weight:400;line-height:1.17;text-align:right;color:#656066}.file-browser .ag-theme-alpine .ag-header-cell{padding-left:2.7rem;padding-right:2.7rem}.file-browser .ag-theme-alpine .ag-header-cell:first-child{padding-left:.6rem}.file-browser .ag-theme-alpine .ag-header-cell:last-child{padding-right:0}.file-browser .ag-theme-alpine .ag-header-cell-menu-button{display:none!important;visibility:hidden!important}.file-browser .ag-theme-alpine .ag-header-cell-text{text-transform:uppercase}.file-browser .ag-theme-alpine .ag-row{color:#322d32;border:0}.file-browser .ag-theme-alpine .ag-row:after{content:\"\";display:block;position:absolute;height:1px;border-bottom:1px solid #f0eff0;bottom:0;left:4.2rem;right:0}.file-browser .ag-theme-alpine .ag-row-odd{background:#fff}.file-browser .ag-theme-alpine .ag-row-hover{background:#f9f9f9;border-top:1px solid #f9f9f9;margin-top:-1px}.file-browser .ag-theme-alpine .ag-row-hover>div:first-child{background:#f9f9f9}.file-browser .ag-theme-alpine .ag-cell{font-size:1.6rem;font-weight:400;font-stretch:normal;font-style:normal;line-height:4rem;letter-spacing:.04rem}.file-browser .ag-theme-alpine .ag-cell-value{padding:1.4rem 2.8rem}.file-browser .ag-theme-alpine .ag-cell:first-child{padding-left:0}.file-browser .ag-theme-alpine .ag-cell:last-child{padding-right:0}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-leaf-indent{margin-left:0}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-0{padding-left:0}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-1{padding-left:3.5rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-2{padding-left:7rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-3{padding-left:10.5rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-4{padding-left:14rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-5{padding-left:17.5rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-6{padding-left:21rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-7{padding-left:24.5rem}.file-browser .ag-theme-alpine .ag-ltr .ag-row-group-indent-8{padding-left:28rem}.file-browser .ag-theme-alpine .ag-ltr .ag-group-contracted,.file-browser .ag-theme-alpine .ag-ltr .ag-group-expanded{display:none!important;visibility:hidden!important}.file-browser .ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected){border:1px solid transparent}.file-browser .ag-theme-alpine .ag-pinned-left-header{border:0}.file-browser .ag-theme-alpine a,.file-browser .ag-theme-alpine a:hover{text-decoration:none}.file-browser .ag-theme-alpine a.filename{background-image:linear-gradient(85deg,#225de6 0,#7723e6 121%);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}.file-browser .ag-theme-alpine .filename{padding-left:4rem}.file-browser .ag-theme-alpine .far:before{content:\"\";display:block;width:3rem;height:3rem;background:green;position:absolute;top:1.9rem}.file-browser .ag-theme-alpine .far.fa-file:before{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/files.svg) center center no-repeat}.file-browser .ag-theme-alpine .ag-group-expanded~.ag-group-value .far.fa-folder:before{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/folders-open.svg) center center no-repeat}.file-browser .ag-theme-alpine .ag-group-expanded.ag-hidden~.ag-group-value .far.fa-folder:before{background:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/30/folders.svg) center center no-repeat}.file-browser .fa-folder{color:#ff8c00}.file-browser .fa-file-pdf{color:red}.file-browser .fa-file-excel{color:green}.file-browser .fa-file-audio{color:#00f}"], encapsulation: 2 });
/*@__PURE__*/ ɵsetClassMetadata(FileBrowserComponent, [{
        type: Component,
        args: [{
                selector: "lib-file-browser",
                templateUrl: "./file-browser.component.html",
                styleUrls: [
                    "./file-browser.component.scss"
                ],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { treeData: [{
            type: Input
        }], columnDefs: [{
            type: Input
        }], updateNode: [{
            type: Output
        }], onFileSelected: [{
            type: Output
        }] });
function getFileCellRenderer() {
    function FileCellRenderer() { }
    FileCellRenderer.prototype.init = function (params) {
        const tempDiv = document.createElement("div");
        const value = params.data.name;
        const icon = params.data.isFile ? "far fa-file" : "far fa-folder";
        const filename = params.data.isFile ?
            `<a class="filename" href="javascript:void(0)" title="${value}">${value}</a>`
            : `<span class="filename">${value}</span>`;
        tempDiv.innerHTML = icon
            ? `<span><i class="${icon}"></i>${filename}</span>`
            : value;
        this.eGui = tempDiv.firstChild;
    };
    FileCellRenderer.prototype.getGui = function () {
        return this.eGui;
    };
    return FileCellRenderer;
}
class CustomPathColumnRenderer {
    init(params) {
        this.eGui = document.createElement('span');
        if (params.data !== null && params.data.path !== null) {
            const inputData = params.data;
            if (inputData.isFile) {
                this.eGui.innerHTML = inputData.path;
                this.eGui.title = inputData.path;
            }
            else {
                this.eGui.innerHTML = '';
            }
        }
        else {
            this.eGui.innerHTML = '';
        }
    }
    getGui() {
        return this.eGui;
    }
}
class CustomDateColumnRenderer {
    init(params) {
        this.eGui = document.createElement('span');
        this.eGui.style.cssFloat = 'right';
        if (params.data !== null && params.data.created !== undefined && params.data.created !== null) {
            const inputData = params.data;
            if (inputData.isFile) {
                const date = new Date(params.data.created);
                const displayValue = `${date.getFullYear()}-${this.leadZero(date.getMonth() + 1)}-${this.leadZero(date.getDate())}
          ${this.leadZero(date.getHours())}:${this.leadZero(date.getMinutes())}`;
                this.eGui.innerHTML = displayValue;
                this.eGui.title = displayValue;
            }
            else {
                this.eGui.innerHTML = '';
            }
        }
        else {
            this.eGui.innerHTML = '';
        }
    }
    leadZero(val) {
        return ((val < 10) ? "0" : "") + val;
    }
    getGui() {
        return this.eGui;
    }
}
class CustomSizeColumnRenderer {
    init(params) {
        this.eGui = document.createElement('span');
        this.eGui.style.cssFloat = 'right';
        if (params.data !== null && params.data.size !== undefined && params.data.size !== null) {
            const inputData = params.data.size;
            const size = this.defineFileSize(inputData);
            this.eGui.innerHTML = size;
        }
        else {
            this.eGui.innerHTML = '';
        }
    }
    getGui() {
        return this.eGui;
    }
    defineFileSize(sizeInBytes) {
        let i = 0;
        let multiplier = 1024;
        const sizeNames = [" B", " KB", " MB", " GB", " TB"];
        while (sizeInBytes >= multiplier) {
            i++;
            multiplier *= 1024;
        }
        return Math.round(((1024 * sizeInBytes / multiplier) + Number.EPSILON) * 100) / 100 + sizeNames[i];
    }
}
class CustomLinkColumnRenderer {
    init(params) {
        this.eGui = document.createElement('span');
        this.eGui.style.cssFloat = 'left';
        if (params.value !== null && params.value !== undefined) {
            const text = params.value;
            const href = params.href || "javascript:void(0)";
            const anchorLink = document.createElement('a');
            anchorLink.href = href;
            anchorLink.innerHTML = text;
            anchorLink.target = params.target ? params.target : '_self';
            this.eGui.appendChild(anchorLink);
        }
        else {
            this.eGui.innerHTML = '';
        }
    }
    getGui() {
        return this.eGui;
    }
}

class FileBrowserModule {
}
/** @nocollapse */ FileBrowserModule.ngModuleDef = ɵɵdefineNgModule({ type: FileBrowserModule });
/** @nocollapse */ FileBrowserModule.ngInjectorDef = ɵɵdefineInjector({ factory: function FileBrowserModule_Factory(t) { return new (t || FileBrowserModule)(); }, imports: [[CommonModule, FormsModule, AgGridModule.withComponents([])]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(FileBrowserModule, { declarations: [FileBrowserComponent, RightAlignedHeaderComponent], imports: [CommonModule, FormsModule, AgGridModule], exports: [FileBrowserComponent] });
/*@__PURE__*/ ɵsetClassMetadata(FileBrowserModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, AgGridModule.withComponents([])],
                declarations: [FileBrowserComponent, RightAlignedHeaderComponent],
                exports: [FileBrowserComponent],
                entryComponents: [RightAlignedHeaderComponent]
            }]
    }], null, null);

var SUPPORTED_FILE_TYPES;
(function (SUPPORTED_FILE_TYPES) {
    SUPPORTED_FILE_TYPES["TEXT_FILE"] = "TEXT_FILE";
    SUPPORTED_FILE_TYPES["IMAGE_FILE"] = "IMAGE_FILE";
    SUPPORTED_FILE_TYPES["PDF_FILE"] = "PDF_FILE";
})(SUPPORTED_FILE_TYPES || (SUPPORTED_FILE_TYPES = {}));
const TEXT_FILE_EXTENSIONS = "txt,asc,bed,gff,gff3,fastq,vcf,csv,xml,tab,tsv,html,xml,xhtml,log,json,sql,yaml";
const IMAGE_FILE_EXTENSIONS = "jpg,jpeg,gif,png";
const PDF_FILE_EXTENSIONS = "pdf";
const PREVIEW_BYTE_MAX = 5242880;

class SafeUrlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
    }
}
/** @nocollapse */ SafeUrlPipe.ngPipeDef = ɵɵdefinePipe({ name: "safeUrl", type: SafeUrlPipe, factory: function SafeUrlPipe_Factory(t) { return new (t || SafeUrlPipe)(ɵɵdirectiveInject(DomSanitizer)); }, pure: true });
/*@__PURE__*/ ɵsetClassMetadata(SafeUrlPipe, [{
        type: Pipe,
        args: [{ name: "safeUrl" }]
    }], function () { return [{ type: DomSanitizer }]; }, null);

const _c0$S = ["filePreviewProgressBar"];
const _c1$R = [1, "file-preview"];
const _c2$M = [1, "file-preview__wrapper"];
const _c3$J = [1, "file-preview__wrapper--inner"];
const _c4$H = [3, "hidden"];
const _c5$E = [1, "file-preview__container"];
const _c6$D = [1, "file-preview__content"];
const _c7$B = [3, "id", "loader", "spinner", "spinnerPosition"];
const _c8$A = ["filePreviewProgressBar", ""];
const _c9$w = [4, "ngIf"];
const _c10$u = [3, "alertMsg"];
function FilePreviewComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-error-alert-message", _c10$u);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r934 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("alertMsg", ctx_r934.FILE_TOO_LARGE_ALERT);
} }
const _c11$r = [3, "ngSwitch"];
const _c12$p = [4, "ngSwitchCase"];
const _c13$n = ["class", "bs-modal-file-preview-img", 4, "ngSwitchCase"];
const _c14$m = [4, "ngSwitchDefault"];
const _c15$k = [1, "file-preview__content--scrollable"];
function FilePreviewComponent_div_8_div_3_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c5$E);
    ɵɵelementStart(2, "div", _c6$D);
    ɵɵelementStart(3, "div", _c15$k);
    ɵɵelementStart(4, "pre");
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r938 = ɵɵnextContext(4);
    ɵɵselect(5);
    ɵɵtextInterpolate(ctx_r938.hrefContent);
} }
const _c16$i = [1, "file-preview__container", "file-preview__container--pdf"];
const _c17$i = [1, "file-preview__content", "file-preview__content--pdf"];
const _c18$g = [1, "file-preview__content--pdf--scrollable"];
const _c19$f = ["type", "application/pdf", "width", "100%", "height", "100%"];
const _c20$e = ["filePreviewPdfObject", ""];
const _c21$d = [1, "alert", "alert-info"];
const _c22$d = ["href", "http://get.adobe.com/reader/"];
function FilePreviewComponent_div_8_div_3_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c16$i);
    ɵɵelementStart(2, "div", _c17$i);
    ɵɵelementStart(3, "div", _c18$g);
    ɵɵelementStart(4, "iframe", _c19$f, _c20$e);
    ɵɵpipe(6, "safeUrl");
    ɵɵelementStart(7, "p", _c21$d);
    ɵɵtext(8, " You don't seem to have a PDF reader installed. ");
    ɵɵelementStart(9, "a", _c22$d);
    ɵɵtext(10, "Get Adobe Reader");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r939 = ɵɵnextContext(4);
    ɵɵselect(4);
    ɵɵattribute("src", ɵɵpipeBind1(6, 1, ctx_r939.hrefUrl), ɵɵsanitizeResourceUrl);
} }
const _c23$d = [1, "bs-modal-file-preview-img"];
const _c24$c = [1, "file-preview__content--img"];
const _c25$b = [1, "file-preview__content--img--scrollable"];
const _c26$b = ["target", "_blank", 3, "href"];
const _c27$b = [1, "file-preview__img", 3, "src"];
function FilePreviewComponent_div_8_div_3_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c23$d);
    ɵɵelementStart(1, "div", _c5$E);
    ɵɵelementStart(2, "div", _c24$c);
    ɵɵelementStart(3, "div", _c25$b);
    ɵɵelementStart(4, "a", _c26$b);
    ɵɵelement(5, "img", _c27$b);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r940 = ɵɵnextContext(4);
    ɵɵselect(4);
    ɵɵpropertyInterpolate("href", ctx_r940.hrefUrl, ɵɵsanitizeUrl);
    ɵɵselect(5);
    ɵɵpropertyInterpolate("src", ctx_r940.hrefUrl, ɵɵsanitizeUrl);
} }
function FilePreviewComponent_div_8_div_3_div_1_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-error-alert-message", _c10$u);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r943 = ɵɵnextContext(5);
    ɵɵselect(1);
    ɵɵpropertyInterpolate1("alertMsg", "BaseSpace Sequence Hub doesn't support previewing this type of file\n                                        (.", ctx_r943.requestedFile.extension, ").\n                                        Download the file instead to view its contents.");
} }
function FilePreviewComponent_div_8_div_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, FilePreviewComponent_div_8_div_3_div_1_div_5_div_1_Template, 2, 1, "div", _c9$w);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r941 = ɵɵnextContext(4);
    ɵɵselect(1);
    ɵɵproperty("ngIf", !ctx_r941.errorMessage);
} }
function FilePreviewComponent_div_8_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", _c11$r);
    ɵɵtemplate(2, FilePreviewComponent_div_8_div_3_div_1_div_2_Template, 6, 1, "div", _c12$p);
    ɵɵtemplate(3, FilePreviewComponent_div_8_div_3_div_1_div_3_Template, 11, 3, "div", _c12$p);
    ɵɵtemplate(4, FilePreviewComponent_div_8_div_3_div_1_div_4_Template, 6, 2, "div", _c13$n);
    ɵɵtemplate(5, FilePreviewComponent_div_8_div_3_div_1_div_5_Template, 2, 1, "div", _c14$m);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r937 = ɵɵnextContext(3);
    ɵɵselect(1);
    ɵɵproperty("ngSwitch", ctx_r937.fileType == null ? null : ctx_r937.fileType.toString());
    ɵɵselect(2);
    ɵɵproperty("ngSwitchCase", ctx_r937.ALL_SUPPORTED_FILE_TYPES.TEXT_FILE.toString());
    ɵɵselect(3);
    ɵɵproperty("ngSwitchCase", ctx_r937.ALL_SUPPORTED_FILE_TYPES.PDF_FILE.toString());
    ɵɵselect(4);
    ɵɵproperty("ngSwitchCase", ctx_r937.ALL_SUPPORTED_FILE_TYPES.IMAGE_FILE.toString());
} }
function FilePreviewComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, FilePreviewComponent_div_8_div_3_div_1_Template, 6, 4, "div", _c9$w);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r935 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngIf", (ctx_r935.requestedFile == null ? null : ctx_r935.requestedFile.Size) <= ctx_r935.PREVIEW_BYTE_MAX_LIMIT && !ctx_r935.errorMessage);
} }
const _c28$b = [3, "errorMsg"];
function FilePreviewComponent_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-error-alert-message", _c28$b);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r936 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("errorMsg", ctx_r936.errorMessage);
} }
function FilePreviewComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div");
    ɵɵtemplate(2, FilePreviewComponent_div_8_div_2_Template, 2, 1, "div", _c9$w);
    ɵɵtemplate(3, FilePreviewComponent_div_8_div_3_Template, 2, 1, "div", _c9$w);
    ɵɵtemplate(4, FilePreviewComponent_div_8_div_4_Template, 2, 1, "div", _c9$w);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r933 = ɵɵnextContext();
    ɵɵselect(2);
    ɵɵproperty("ngIf", ctx_r933.requestedFile && (ctx_r933.requestedFile == null ? null : ctx_r933.requestedFile.Size) > ctx_r933.PREVIEW_BYTE_MAX_LIMIT);
    ɵɵselect(3);
    ɵɵproperty("ngIf", ctx_r933.requestedFile);
    ɵɵselect(4);
    ɵɵproperty("ngIf", ctx_r933.errorMessage);
} }
class FilePreviewComponent {
    constructor(http) {
        this.http = http;
        this.requestedFile = null; // content requested to preview/download
        this.data = new EventEmitter();
        this.subs = new SubSink();
        this.isLoading = true;
        this.errorMessage = null;
        this.ALL_SUPPORTED_FILE_TYPES = SUPPORTED_FILE_TYPES;
        this.fileType = null;
        this.downloadLink = null;
        this.hrefUrl = null;
        this.hrefContent = null;
        this.PREVIEW_BYTE_MAX_LIMIT = PREVIEW_BYTE_MAX;
        this.FILE_TOO_LARGE_ALERT = 'This file is too large for a preview';
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    ngAfterViewInit() {
        this.createFilePreviewAndDownload();
    }
    ngOnChanges(changes) {
        if (changes.requestedFile && changes.requestedFile.currentValue) {
            if (changes.isPreviewableTextFile && changes.isPreviewableTextFile.currentValue) {
                this.setFileType(changes.requestedFile.currentValue.extension, changes.isPreviewableTextFile.currentValue);
            }
            else {
                this.setFileType(changes.requestedFile.currentValue.extension);
            }
            if (!changes.requestedFile.isFirstChange()) { // using first change to let loader component get initialized
                this.createFilePreviewAndDownload();
            }
        }
    }
    createFilePreviewAndDownload() {
        if (!this.requestedFile) {
            return;
        }
        this.startLoading();
        this.createDownloadLink();
        if (this.requestedFile.Size < this.PREVIEW_BYTE_MAX_LIMIT) {
            this.fetchFileContent();
        }
        else {
            this.stopLoading();
        }
    }
    startLoading() {
        this.isLoading = true;
        this.filePreviewProgressBar.start();
    }
    stopLoading() {
        this.filePreviewProgressBar.complete();
        this.isLoading = false;
    }
    setFileType(extension, isPreviewableTextFile) {
        if (TEXT_FILE_EXTENSIONS.indexOf(extension) > -1 || isPreviewableTextFile === true) {
            this.fileType = this.ALL_SUPPORTED_FILE_TYPES.TEXT_FILE;
        }
        else if (IMAGE_FILE_EXTENSIONS.indexOf(extension) > -1) {
            this.fileType = this.ALL_SUPPORTED_FILE_TYPES.IMAGE_FILE;
        }
        else if (PDF_FILE_EXTENSIONS.indexOf(extension) > -1) {
            this.fileType = this.ALL_SUPPORTED_FILE_TYPES.PDF_FILE;
        }
    }
    createDownloadLink() {
        // empty string is also evaluated as null
        if (this.apiBaseUrl === null || this.apiBaseUrl === undefined || !this.requestedFile) {
            this.downloadLink = null;
            return;
        }
        this.updateBaseUrl();
        this.downloadLink = this.apiBaseUrl + this.requestedFile.HrefContent + "?responsecontentdisposition=attachment";
        if (this.downloadLink) {
            // using promise to defer event emission till component(parent/wrapper) is completely mounted
            Promise.resolve(null).then(() => this.data.emit({ downloadLink: this.downloadLink }));
        }
    }
    fetchFileContent() {
        // empty string is also evaluated as null
        if (this.apiBaseUrl === null || this.apiBaseUrl === undefined || !this.requestedFile) {
            return;
        }
        this.updateBaseUrl();
        // proxy to prevent s3 redirect where we lose the CORS header
        const contentUrl = this.apiBaseUrl + this.requestedFile.HrefContent + '?redirect=proxy';
        // PDF / image files are loaded inline on the template
        if (this.fileType === this.ALL_SUPPORTED_FILE_TYPES.PDF_FILE || this.fileType === this.ALL_SUPPORTED_FILE_TYPES.IMAGE_FILE) {
            this.hrefUrl = contentUrl;
            this.stopLoading();
        }
        else { // for other file types
            const request = this.http.get(contentUrl, { withCredentials: true, responseType: 'text' });
            this.subs.sink = request.subscribe({
                next: (response) => {
                    const responseData = response;
                    this.hrefContent = responseData; // .toString();
                    this.stopLoading();
                },
                error: (err) => {
                    this.errorMessage = "Error loading preview";
                    this.stopLoading();
                }
            });
        }
    }
    updateBaseUrl() {
        if (this.requestedFile.HrefContent.indexOf('https') > -1 || this.requestedFile.HrefContent.indexOf('http') > -1) {
            this.apiBaseUrl = '';
        }
    }
}
/** @nocollapse */ FilePreviewComponent.ngComponentDef = ɵɵdefineComponent({ type: FilePreviewComponent, selectors: [["lib-file-preview"]], factory: function FilePreviewComponent_Factory(t) { return new (t || FilePreviewComponent)(ɵɵdirectiveInject(HttpClient)); }, viewQuery: function FilePreviewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$S, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.filePreviewProgressBar = _t.first);
    } }, inputs: { apiBaseUrl: "apiBaseUrl", requestedFile: "requestedFile", isPreviewableTextFile: "isPreviewableTextFile" }, outputs: { data: "data" }, features: [ɵɵNgOnChangesFeature()], consts: 9, vars: 6, template: function FilePreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$R);
        ɵɵelementStart(1, "div", _c2$M);
        ɵɵelementStart(2, "div", _c3$J);
        ɵɵelementStart(3, "div", _c4$H);
        ɵɵelementStart(4, "div", _c5$E);
        ɵɵelementStart(5, "div", _c6$D);
        ɵɵelement(6, "lib-progress", _c7$B, _c8$A);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(8, FilePreviewComponent_div_8_Template, 5, 3, "div", _c9$w);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(3);
        ɵɵproperty("hidden", !ctx.isLoading);
        ɵɵselect(6);
        ɵɵproperty("id", "file-preview-progress-bar")("loader", true)("spinner", false)("spinnerPosition", "center");
        ɵɵselect(8);
        ɵɵproperty("ngIf", !ctx.isLoading);
    } }, directives: [ProgressComponent, NgIf, ErrorAlertMessageComponent, NgSwitch, NgSwitchCase, NgSwitchDefault], pipes: [SafeUrlPipe], styles: [".file-preview__alert-box[_ngcontent-%COMP%], .file-preview__content__sub-title[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.file-preview__alert-box[_ngcontent-%COMP%], .file-preview__content__sub-title[_ngcontent-%COMP%]{font-size:16px;letter-spacing:.4px;line-height:1.5}.file-preview__alert-box[_ngcontent-%COMP%]{font-weight:500}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.os-theme-dark[_ngcontent-%COMP%] > .os-scrollbar-vertical[_ngcontent-%COMP%]{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark[_ngcontent-%COMP%] > .os-scrollbar[_ngcontent-%COMP%] > .os-scrollbar-track[_ngcontent-%COMP%]{background:#f0eff0}.os-theme-dark[_ngcontent-%COMP%]   .os-scrollbar-handle[_ngcontent-%COMP%]{background:#656066;width:.2rem}.file-preview__container[_ngcontent-%COMP%]{position:relative;display:block;background-color:#fff;overflow:hidden;border:1px solid #d3d3d3}.file-preview__container--pdf[_ngcontent-%COMP%]{height:352px;margin:0}.file-preview__content[_ngcontent-%COMP%]{min-height:6.8rem;padding:.8rem}.file-preview__content__sub-title[_ngcontent-%COMP%]{font-weight:300;padding:1.4rem 0;margin:.7rem 0 0}.file-preview__content--radio[_ngcontent-%COMP%]{display:block;margin-bottom:1.4rem}.file-preview__content--pdf[_ngcontent-%COMP%]{display:block;width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.file-preview__content--pdf--scrollable[_ngcontent-%COMP%]{height:100%;overflow:hidden}.file-preview__content--scrollable[_ngcontent-%COMP%]{max-height:23.7rem;overflow:auto;padding-right:44px}.file-preview__content--img[_ngcontent-%COMP%]{padding:.8rem}.file-preview__content--img--scrollable[_ngcontent-%COMP%]{height:10rem;overflow:hidden}.file-preview__img[_ngcontent-%COMP%]{display:block;width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.file-preview__alert-box[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;background:#f0eff0;padding:1.3rem 4rem;margin:3.6rem -4rem 1.2rem}.file-preview__alert-box-icon[_ngcontent-%COMP%]{width:2rem;height:2rem;margin-right:.6rem}.file-preview__alert-box-message[_ngcontent-%COMP%]{width:90%}.file-preview__scroll[_ngcontent-%COMP%]{height:280px;overflow-y:scroll}.file-preview__strong[_ngcontent-%COMP%]{font-weight:500}"] });
/*@__PURE__*/ ɵsetClassMetadata(FilePreviewComponent, [{
        type: Component,
        args: [{
                selector: 'lib-file-preview',
                templateUrl: './file-preview.component.html',
                styleUrls: ['./file-preview.component.scss']
            }]
    }], function () { return [{ type: HttpClient }]; }, { apiBaseUrl: [{
            type: Input
        }], requestedFile: [{
            type: Input
        }], isPreviewableTextFile: [{
            type: Input
        }], data: [{
            type: Output
        }], filePreviewProgressBar: [{
            type: ViewChild,
            args: ['filePreviewProgressBar', { static: false }]
        }] });

class FilePreviewModule {
}
/** @nocollapse */ FilePreviewModule.ngModuleDef = ɵɵdefineNgModule({ type: FilePreviewModule });
/** @nocollapse */ FilePreviewModule.ngInjectorDef = ɵɵdefineInjector({ factory: function FilePreviewModule_Factory(t) { return new (t || FilePreviewModule)(); }, imports: [[
            CommonModule,
            HttpClientModule,
            ProgressIndicatorsModule,
            ErrorAlertMessageModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(FilePreviewModule, { declarations: [FilePreviewComponent, SafeUrlPipe], imports: [CommonModule,
        HttpClientModule,
        ProgressIndicatorsModule,
        ErrorAlertMessageModule], exports: [FilePreviewComponent] });
/*@__PURE__*/ ɵsetClassMetadata(FilePreviewModule, [{
        type: NgModule,
        args: [{
                declarations: [FilePreviewComponent, SafeUrlPipe],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    ProgressIndicatorsModule,
                    ErrorAlertMessageModule
                ],
                exports: [FilePreviewComponent]
            }]
    }], null, null);

const _c0$T = [1, "switcher"];
const _c1$S = [1, "switcher__label", 3, "ngClass"];
const _c2$N = [1, "switcher__toggle"];
const _c3$K = ["type", "checkbox", 1, "switcher__toggle__checkbox", "switcher__toggle-hidden", 3, "name", "ngModel", "ngModelChange"];
const _c4$I = [1, "switcher__toggle__click-label", 3, "for", "click"];
const _c5$F = function (a0) { return { "switcher__label-off": a0 }; };
class SwitcherComponent {
    constructor() {
        /** Label names to be displayed for on/off */
        this.toggleLabels = {
            on: "On",
            off: "Off"
        };
        /** Unique input and label name */
        this.name = uniqueId("switcher_");
        /** True if switcher is on */
        this.isSwitcherOn = true;
        this.toggled = new EventEmitter();
        this.onChangeFn = (_) => { };
    }
    ngOnInit() {
    }
    writeValue(value) {
        this.isSwitcherOn = value;
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) { }
    onToggle() {
        this.isSwitcherOn = !this.isSwitcherOn;
        this.onChangeFn(this.isSwitcherOn);
        this.toggled.emit(this.isSwitcherOn);
    }
}
/** @nocollapse */ SwitcherComponent.ngComponentDef = ɵɵdefineComponent({ type: SwitcherComponent, selectors: [["lib-switcher"]], factory: function SwitcherComponent_Factory(t) { return new (t || SwitcherComponent)(); }, inputs: { toggleLabels: "toggleLabels", name: "name", isSwitcherOn: "isSwitcherOn" }, outputs: { toggled: "toggled" }, features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SwitcherComponent),
                multi: true
            },
        ])], consts: 8, vars: 11, template: function SwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$T);
        ɵɵelementStart(1, "span", _c1$S);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", _c2$N);
        ɵɵelementStart(4, "input", _c3$K);
        ɵɵlistener("ngModelChange", function SwitcherComponent_Template_input_ngModelChange_4_listener($event) { return ctx.isSwitcherOn = $event; });
        ɵɵelementEnd();
        ɵɵelementStart(5, "label", _c4$I);
        ɵɵlistener("click", function SwitcherComponent_Template_label_click_5_listener($event) { return ctx.onToggle(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "span", _c1$S);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngClass", ɵɵpureFunction1(7, _c5$F, ctx.isSwitcherOn));
        ɵɵselect(2);
        ɵɵtextInterpolate(ctx.toggleLabels.off);
        ɵɵselect(4);
        ɵɵpropertyInterpolate("name", ctx.name);
        ɵɵproperty("ngModel", ctx.isSwitcherOn);
        ɵɵselect(5);
        ɵɵpropertyInterpolate("for", ctx.name);
        ɵɵselect(6);
        ɵɵproperty("ngClass", ɵɵpureFunction1(9, _c5$F, !ctx.isSwitcherOn));
        ɵɵselect(7);
        ɵɵtextInterpolate(ctx.toggleLabels.on);
    } }, directives: [NgClass, CheckboxControlValueAccessor, NgControlStatus, NgModel], styles: [".switcher[_ngcontent-%COMP%]{display:inline-block;height:2rem;position:relative}.switcher__label[_ngcontent-%COMP%]{color:#322d32;display:inline-block;font-size:1.8rem;position:relative;text-transform:uppercase;top:-.5rem;font-weight:600;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.switcher__label[_ngcontent-%COMP%]:first-of-type{padding-right:.8rem}.switcher__label[_ngcontent-%COMP%]:last-of-type{padding-left:.8rem}.switcher__label-off[_ngcontent-%COMP%]{font-weight:400;opacity:.55}.switcher__toggle[_ngcontent-%COMP%]{display:inline-block}.switcher__toggle-hidden[_ngcontent-%COMP%]{display:none}.switcher__toggle__checkbox[_ngcontent-%COMP%]:checked ~ label[_ngcontent-%COMP%]{background-image:linear-gradient(79deg,#225de6 0,#7723e6 121%)}.switcher__toggle__checkbox[_ngcontent-%COMP%]:checked ~ label[_ngcontent-%COMP%]:after{left:2.1rem;background:#fff}.switcher__toggle__checkbox[_ngcontent-%COMP%]:disabled ~ label[_ngcontent-%COMP%]{background:#d5d5d5;pointer-events:none}.switcher__toggle__checkbox[_ngcontent-%COMP%]:disabled ~ label[_ngcontent-%COMP%]:after{background:#bcbdbc}.switcher__toggle__click-label[_ngcontent-%COMP%]{background:#d1cfd1;border-radius:10rem;cursor:pointer;display:inline-block;height:3rem;margin-bottom:0;position:relative;top:.2rem;-webkit-transition:.3s;transition:.3s;width:5rem}.switcher__toggle__click-label[_ngcontent-%COMP%]:after{background:#fff;border-radius:10rem;box-shadow:0 3px 3px rgba(0,0,0,.05);content:\"\";display:block;height:2.8rem;width:2.8rem;position:absolute;top:.1rem;left:.13rem;-webkit-transition:.3s;transition:.3s}"] });
/*@__PURE__*/ ɵsetClassMetadata(SwitcherComponent, [{
        type: Component,
        args: [{
                selector: "lib-switcher",
                templateUrl: "./switcher.component.html",
                styleUrls: ["./switcher.component.scss"],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SwitcherComponent),
                        multi: true
                    },
                ]
            }]
    }], function () { return []; }, { toggleLabels: [{
            type: Input
        }], name: [{
            type: Input
        }], isSwitcherOn: [{
            type: Input
        }], toggled: [{
            type: Output
        }] });

class SwitcherModule {
}
/** @nocollapse */ SwitcherModule.ngModuleDef = ɵɵdefineNgModule({ type: SwitcherModule });
/** @nocollapse */ SwitcherModule.ngInjectorDef = ɵɵdefineInjector({ factory: function SwitcherModule_Factory(t) { return new (t || SwitcherModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(SwitcherModule, { declarations: [SwitcherComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule], exports: [SwitcherComponent] });
/*@__PURE__*/ ɵsetClassMetadata(SwitcherModule, [{
        type: NgModule,
        args: [{
                declarations: [SwitcherComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                exports: [SwitcherComponent]
            }]
    }], null, null);

class OverlayScrollbarsService {
    constructor() {
        /**
         *  Required overlay scrollbar 'options' config to be used across all components
         *  Can add other parameters also for which default value needs to be changed
         */
        this.defaultOptions = {
            overflowBehavior: {
                x: "hidden",
                y: "scroll"
            }
        };
        this.setOverlayScrollbarConfigs();
    }
    /**
     * Sets default 'OverlayScrollbars.Options' configs which will be used in each new Plugin initialisations
     * NOTE: we are not using OverlayScrollbars instance directly in components,
     *       its wrapper component is used.That will also use these configs.
     */
    setOverlayScrollbarConfigs() {
        OverlayScrollbars.defaultOptions(this.defaultOptions);
    }
}
/** @nocollapse */ OverlayScrollbarsService.ngInjectableDef = ɵɵdefineInjectable({ token: OverlayScrollbarsService, factory: function OverlayScrollbarsService_Factory(t) { return new (t || OverlayScrollbarsService)(); }, providedIn: "root" });
/*@__PURE__*/ ɵsetClassMetadata(OverlayScrollbarsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null);

const _c0$U = [1, "status-change"];
const _c1$T = [1, "status-change__wrapper"];
const _c2$O = [1, "status-change__wrapper--inner"];
const _c3$L = [1, "status-change__container"];
const _c4$J = [1, "status-change__content"];
const _c5$G = ["scrollContainer", ""];
const _c6$E = [1, "status-change__result"];
const _c7$C = [1, "status-change__result__heading"];
const _c8$B = [1, "resourceIdentifierTitle"];
const _c9$x = [1, "statusTitle"];
const _c10$v = ["class", "status-change__content--scrollable", 4, "ngIf"];
const _c11$s = [1, "user-input-section"];
const _c12$q = [1, "input-field"];
const _c13$o = ["for", "Status", 1, "input-field__label"];
const _c14$n = [1, "select", 2, "width", "50%"];
const _c15$l = [3, "placeholder", "change"];
const _c16$j = [3, "value", "label", 4, "ngFor", "ngForOf"];
const _c17$j = [1, "input-field", "input-field--block", "description"];
const _c18$h = ["for", "Description", 1, "input-field__label"];
const _c19$g = ["id", "Description", 1, "input-field__textarea", 3, "ngModel", "maxLength", "placeholder", "ngModelChange"];
const _c20$f = [1, "input-field__helper"];
const _c21$e = [3, "alertMsg", "errorMsg"];
const _c22$e = [1, "status-change__content--scrollable"];
const _c23$e = ["class", "status-change__result__list", 4, "ngIf"];
const _c24$d = [1, "status-change__result__list"];
const _c25$c = ["class", "status-change__result__item", 4, "ngFor", "ngForOf"];
const _c26$c = [1, "status-change__result__item"];
const _c27$c = ["class", "status-change__result__icon", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 4, "ngIf"];
const _c28$c = [1, "status-change__result__name"];
const _c29$a = [1, "status-change__result__value", 3, "ngClass"];
const _c30$9 = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "status-change__result__icon"];
const _c31$9 = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#656066"];
function StatusChangeComponent_overlay_scrollbars_13_ul_1_li_1__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c30$9);
    ɵɵelement(1, "path", _c31$9);
    ɵɵelementEnd();
} }
function StatusChangeComponent_overlay_scrollbars_13_ul_1_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", _c26$c);
    ɵɵtemplate(1, StatusChangeComponent_overlay_scrollbars_13_ul_1_li_1__svg_svg_1_Template, 2, 0, "svg", _c27$c);
    ɵɵelementStart(2, "span", _c28$c);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "span", _c29$a);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r949 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", item_r949.hasIssues === true);
    ɵɵselect(3);
    ɵɵtextInterpolate1(" ", item_r949.resourceName, " ");
    ɵɵselect(4);
    ɵɵproperty("ngClass", item_r949.statusClass ? item_r949.statusClass : null);
    ɵɵselect(5);
    ɵɵtextInterpolate1(" ", item_r949.displayStatus != null ? item_r949.displayStatus : item_r949.currentStatus, " ");
} }
function StatusChangeComponent_overlay_scrollbars_13_ul_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "ul", _c24$d);
    ɵɵtemplate(1, StatusChangeComponent_overlay_scrollbars_13_ul_1_li_1_Template, 6, 4, "li", _c25$c);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r947 = ɵɵnextContext(2);
    ɵɵselect(1);
    ɵɵproperty("ngForOf", ctx_r947.statusChangeResourceList);
} }
function StatusChangeComponent_overlay_scrollbars_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "overlay-scrollbars", _c22$e);
    ɵɵtemplate(1, StatusChangeComponent_overlay_scrollbars_13_ul_1_Template, 2, 1, "ul", _c23$e);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r945 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngIf", (ctx_r945.statusChangeResourceList == null ? null : ctx_r945.statusChangeResourceList.length) > 0);
} }
const _c32$9 = [3, "value", "label"];
function StatusChangeComponent_lib_option_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c32$9);
} if (rf & 2) {
    const option_r951 = ctx.$implicit;
    ɵɵproperty("value", option_r951.value)("label", option_r951.label);
} }
class StatusChangeComponent {
    constructor() {
        // @Input() public resourceType: ResourceType = null; // Any resource like Run, Projects - for which the info can be edited
        this.statusChangeResourceList = []; // List of all fields which can be edited
        this.allowedStatuses = []; // all possible statuses
        this.resourceIdentifierTitle = ""; // resource idetifier header in resource list
        this.statusTitle = ""; // status header in resource list
        this.alertMsg = null; // Any alert message
        this.errorMsg = null;
        this.commentMaxLength = 140; // default is 140
        this.commentFieldIdentifier = "Description"; // name for the comment field, any name can be given
        this.confirm = new EventEmitter();
        this.updatedUserInput = new Subject();
        this.defaultDropDownOption = "Please Select";
        this.userInput = {
            newStatus: null,
            comments: null,
        };
    }
    ngOnInit() {
        this.debounceUserInput();
    }
    debounceUserInput() {
        this.updatedUserInput.pipe(debounceTime(200)).subscribe((updatedFields) => {
            this.confirm.emit(updatedFields);
        });
    }
    onChangeUserSelectedOption(event) {
        this.userInput.newStatus = event.option.value;
        const statusChangeOutput = {
            newStatus: this.userInput.newStatus,
            comments: this.userInput.comments,
        };
        this.updatedUserInput.next(statusChangeOutput);
    }
    onChangeInputValue(changedData) {
        this.userInput.comments = changedData;
        const statusChangeOutput = {
            newStatus: this.userInput.newStatus,
            comments: this.userInput.comments,
        };
        this.updatedUserInput.next(statusChangeOutput);
    }
}
/** @nocollapse */ StatusChangeComponent.ngComponentDef = ɵɵdefineComponent({ type: StatusChangeComponent, selectors: [["lib-status-change"]], factory: function StatusChangeComponent_Factory(t) { return new (t || StatusChangeComponent)(); }, inputs: { statusChangeResourceList: "statusChangeResourceList", allowedStatuses: "allowedStatuses", resourceIdentifierTitle: "resourceIdentifierTitle", statusTitle: "statusTitle", alertMsg: "alertMsg", errorMsg: "errorMsg", commentMaxLength: "commentMaxLength", commentFieldIdentifier: "commentFieldIdentifier" }, outputs: { confirm: "confirm" }, consts: 29, vars: 12, template: function StatusChangeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$U);
        ɵɵelementStart(1, "div", _c1$T);
        ɵɵelementStart(2, "div", _c2$O);
        ɵɵelementStart(3, "div", _c3$L);
        ɵɵelementStart(4, "div", _c4$J);
        ɵɵelementStart(5, "div", null, _c5$G);
        ɵɵelementStart(7, "section", _c6$E);
        ɵɵelementStart(8, "h5", _c7$C);
        ɵɵelementStart(9, "span", _c8$B);
        ɵɵtext(10);
        ɵɵelementEnd();
        ɵɵelementStart(11, "span", _c9$x);
        ɵɵtext(12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(13, StatusChangeComponent_overlay_scrollbars_13_Template, 2, 1, "overlay-scrollbars", _c10$v);
        ɵɵelementEnd();
        ɵɵelementStart(14, "section", _c11$s);
        ɵɵelementStart(15, "div", _c12$q);
        ɵɵelementStart(16, "label", _c13$o);
        ɵɵtext(17, " Change Status To ");
        ɵɵelementEnd();
        ɵɵelementStart(18, "div", _c14$n);
        ɵɵelementStart(19, "lib-select", _c15$l);
        ɵɵlistener("change", function StatusChangeComponent_Template_lib_select_change_19_listener($event) { return ctx.onChangeUserSelectedOption($event); });
        ɵɵtemplate(20, StatusChangeComponent_lib_option_20_Template, 1, 2, "lib-option", _c16$j);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", _c17$j);
        ɵɵelementStart(22, "label", _c18$h);
        ɵɵtext(23);
        ɵɵelementEnd();
        ɵɵelementStart(24, "textarea", _c19$g);
        ɵɵlistener("ngModelChange", function StatusChangeComponent_Template_textarea_ngModelChange_24_listener($event) { return ctx.onChangeInputValue($event); });
        ɵɵelementEnd();
        ɵɵelementStart(25, "span", _c20$f);
        ɵɵtext(26);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(27, "div");
        ɵɵelement(28, "lib-error-alert-message", _c21$e);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(10);
        ɵɵtextInterpolate(ctx.resourceIdentifierTitle);
        ɵɵselect(12);
        ɵɵtextInterpolate(ctx.statusTitle);
        ɵɵselect(13);
        ɵɵproperty("ngIf", (ctx.statusChangeResourceList == null ? null : ctx.statusChangeResourceList.length) > 0);
        ɵɵselect(19);
        ɵɵproperty("placeholder", ctx.defaultDropDownOption);
        ɵɵselect(20);
        ɵɵproperty("ngForOf", ctx.allowedStatuses);
        ɵɵselect(23);
        ɵɵtextInterpolate1(" ", ctx.commentFieldIdentifier, " ");
        ɵɵselect(24);
        ɵɵproperty("ngModel", ctx.userInput.comments)("maxLength", ctx.commentMaxLength)("placeholder", ctx.commentFieldIdentifier);
        ɵɵselect(26);
        ɵɵtextInterpolate1(" Remaining characters : ", ctx.commentMaxLength - (ctx.userInput.comments == null ? null : ctx.userInput.comments.length), " ");
        ɵɵselect(28);
        ɵɵproperty("alertMsg", ctx.alertMsg)("errorMsg", ctx.errorMsg);
    } }, directives: [NgIf, SelectComponent, NgForOf, DefaultValueAccessor, NgControlStatus, NgModel, ErrorAlertMessageComponent, OverlayScrollbarsComponent, NgClass, OptionComponent], styles: [".input-field__combo--input[_ngcontent-%COMP%], .input-field__label[_ngcontent-%COMP%], .input-field__text-input[_ngcontent-%COMP%], .status-change__alert-box[_ngcontent-%COMP%], .status-change__content__sub-title[_ngcontent-%COMP%], .status-change__result__alert-box__text[_ngcontent-%COMP%], .status-change__result__heading[_ngcontent-%COMP%], .status-change__result__item[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.input-field__label[_ngcontent-%COMP%], .input-field__text-input[_ngcontent-%COMP%], .status-change__alert-box[_ngcontent-%COMP%], .status-change__content__sub-title[_ngcontent-%COMP%], .status-change__result__alert-box__text[_ngcontent-%COMP%]{font-weight:400;font-size:16px;letter-spacing:.4px;line-height:1.5}.input-field__combo--input[_ngcontent-%COMP%], .status-change__result__heading[_ngcontent-%COMP%], .status-change__result__item[_ngcontent-%COMP%]{font-weight:400;font-size:14px;letter-spacing:.4px;line-height:1.4285714286}.status-change__alert-box[_ngcontent-%COMP%]{font-weight:500}.input-field__label[_ngcontent-%COMP%], .status-change__content__sub-title[_ngcontent-%COMP%], .status-change__result__heading[_ngcontent-%COMP%]{font-weight:300}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.os-theme-dark[_ngcontent-%COMP%] > .os-scrollbar-vertical[_ngcontent-%COMP%]{bottom:.4rem!important;right:.8rem;top:.4rem!important;width:.6rem}.os-theme-dark[_ngcontent-%COMP%] > .os-scrollbar[_ngcontent-%COMP%] > .os-scrollbar-track[_ngcontent-%COMP%]{background:#f0eff0}.os-theme-dark[_ngcontent-%COMP%]   .os-scrollbar-handle[_ngcontent-%COMP%]{background:#656066;width:.2rem}.input-field[_ngcontent-%COMP%]{max-width:36rem;position:relative}.input-field--block[_ngcontent-%COMP%]{max-width:inherit}.input-field__add-icon[_ngcontent-%COMP%]{position:absolute;right:-.3rem;bottom:.4rem;width:2rem}.input-field--disabled[_ngcontent-%COMP%]   .input-field__text-input[_ngcontent-%COMP%]:hover{border-bottom:1px solid #d1cfd1;cursor:not-allowed}.input-field--disabled[_ngcontent-%COMP%]   .input-field__label[_ngcontent-%COMP%]{color:#322d32;opacity:.4}.input-field--invalid[_ngcontent-%COMP%]   .input-field__text-input[_ngcontent-%COMP%]:hover{border-bottom:1px solid #bf4252}.input-field__required[_ngcontent-%COMP%]{color:#656066;font-size:1.9rem;font-weight:700;margin-left:.8rem;position:absolute;top:.1rem}.input-field__label[_ngcontent-%COMP%]{color:#322d32;display:block;position:relative}.input-field__label--checkbox[_ngcontent-%COMP%]{margin-bottom:1.1rem}.input-field--invalid[_ngcontent-%COMP%]   .input-field__text-input[_ngcontent-%COMP%]{border-bottom:1px solid #bf4252}.input-field__text-input[_ngcontent-%COMP%]{background-color:transparent;border:0;border-bottom:1px solid #bfbebf;color:#322d32;display:block;outline:0;padding:0 0 2px;width:100%}.input-field__text-input[_ngcontent-%COMP%]:disabled{color:#322d32;opacity:.4}.input-field--required[_ngcontent-%COMP%]   .input-field__text-input[_ngcontent-%COMP%]{border-bottom:1px solid #656066}.input-field__text-input[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#d1cfd1}.input-field__text-input[_ngcontent-%COMP%]::-moz-placeholder{color:#d1cfd1}.input-field__text-input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#d1cfd1}.input-field__text-input[_ngcontent-%COMP%]::-ms-input-placeholder{color:#d1cfd1}.input-field__text-input[_ngcontent-%COMP%]::placeholder{color:#d1cfd1}.input-field__text-input[_ngcontent-%COMP%]:not(:disabled):focus, .input-field__text-input[_ngcontent-%COMP%]:not(:disabled):focus:active, .input-field__text-input[_ngcontent-%COMP%]:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd);border-top:0;border-left:0;border-right:0}.input-field__text-input--invalid[_ngcontent-%COMP%]{border-bottom:1px solid #bf4252;color:#322d32}.input-field__text-input[_ngcontent-%COMP%]:focus{background-color:transparent;color:#322d32;border-bottom:1px solid #656066}.input-field__helper[_ngcontent-%COMP%]{color:#918d91;display:block;font-size:1.2rem;font-weight:400;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.04rem;margin-top:2px;position:absolute}.input-field__helper--error[_ngcontent-%COMP%]{font-weight:500;color:#bf4252}.input-field--disabled[_ngcontent-%COMP%]   .input-field__helper[_ngcontent-%COMP%]{opacity:.4}.input-field__combo[_ngcontent-%COMP%]{position:relative;width:100%}.input-field__combo--btn[_ngcontent-%COMP%]{display:block;padding:0;margin:0;background:0;outline:0;line-height:1.6;border:0}.input-field__combo--icon[_ngcontent-%COMP%]{position:absolute;width:20px;height:20px;top:50%;right:.5rem;z-index:1;margin-top:-1.1rem}.input-field__combo--input[_ngcontent-%COMP%]{width:100%;height:30px;padding:.3125rem .75rem;position:relative;background:#fff;box-sizing:border-box;border-style:solid;border-width:1px;border-image-slice:1}.input-field__combo--input[_ngcontent-%COMP%]:hover{border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field__combo--input[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#d1cfd1}.input-field__combo--input[_ngcontent-%COMP%]::-moz-placeholder{color:#d1cfd1}.input-field__combo--input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input[_ngcontent-%COMP%]::-ms-input-placeholder{color:#d1cfd1}.input-field__combo--input[_ngcontent-%COMP%]::placeholder{color:#d1cfd1}.input-field__textarea[_ngcontent-%COMP%]{background-color:transparent;border:1px solid #bfbebf;box-sizing:border-box;color:#322d32;font-size:1.6rem;height:9.9rem;letter-spacing:.04rem;line-height:1.45;margin-top:.4rem;padding:.9rem 1.6rem;resize:none;width:100%}.input-field__textarea[_ngcontent-%COMP%]:not(:disabled):focus, .input-field__textarea[_ngcontent-%COMP%]:not(:disabled):focus:active, .input-field__textarea[_ngcontent-%COMP%]:not(:disabled):hover{border-bottom-style:solid;border-bottom-width:1px;border-image-slice:1;border-image-source:linear-gradient(83deg,#5487fd,#a664fd)}.input-field--invalid[_ngcontent-%COMP%]   .input-field__textarea[_ngcontent-%COMP%]{border-bottom:1px solid #bf4252}.input-field--required[_ngcontent-%COMP%]   .input-field__textarea[_ngcontent-%COMP%]{border-bottom:1px solid #656066}.input-field__textarea[_ngcontent-%COMP%]:disabled{cursor:not-allowed;color:#d1cfd1;opacity:.4}.input-field__textarea[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#d1cfd1}.input-field__textarea[_ngcontent-%COMP%]::-moz-placeholder{color:#d1cfd1}.input-field__textarea[_ngcontent-%COMP%]:-ms-input-placeholder{color:#d1cfd1}.input-field__textarea[_ngcontent-%COMP%]::-ms-input-placeholder{color:#d1cfd1}.input-field__textarea[_ngcontent-%COMP%]::placeholder{color:#d1cfd1}.input-field__textarea[_ngcontent-%COMP%]:hover:not([disabled]){border-color:#225de6}.input-field__textarea[_ngcontent-%COMP%]:focus{border:1px solid #bfbebf;border-bottom-color:#656066;outline:0}.status-change__container[_ngcontent-%COMP%]{position:relative;display:block;background-color:#f9f9f9;overflow:hidden}.status-change__result[_ngcontent-%COMP%]{letter-spacing:.04rem;line-height:1.43}.status-change__result__heading[_ngcontent-%COMP%], .status-change__result__list[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;margin:0}.status-change__result__heading[_ngcontent-%COMP%]{padding:0 0 2rem}.status-change__result__list[_ngcontent-%COMP%]{border-bottom:1px solid #f0eff0;border-top:1px solid #f0eff0;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:0;list-style:none}.status-change__result__item[_ngcontent-%COMP%]{display:-webkit-box;display:flex;padding:2rem 0;position:relative;width:100%}.status-change__result__item[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #f0eff0}.status-change__result__item--error[_ngcontent-%COMP%]   .status-change__result__icon[_ngcontent-%COMP%]{left:0;position:absolute}.status-change__result__name[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;-webkit-box-flex:1;flex-grow:1;padding-right:3rem}.status-change__result__item--error[_ngcontent-%COMP%]   .status-change__result__name[_ngcontent-%COMP%]{padding-left:2.6rem}.status-change__result__value[_ngcontent-%COMP%]{text-align:right}.status-change__result__value--bold[_ngcontent-%COMP%]{font-weight:700}.status-change__result__icon[_ngcontent-%COMP%]{width:2rem;margin-right:.5rem}.status-change__result__alert-box[_ngcontent-%COMP%]{display:-webkit-box;display:flex;background:#f0eff0;margin:0 0 1.7rem;padding:1.2rem 1.25rem 1.3rem 0}.status-change__result__alert-box__text[_ngcontent-%COMP%]{margin:0;padding:0}.status-change__content[_ngcontent-%COMP%]{min-height:32.8rem}.status-change__content__sub-title[_ngcontent-%COMP%]{padding:1.4rem 0;margin:.7rem 0 0}.status-change__content__transfer-message[_ngcontent-%COMP%]{margin:3.9rem 0 2.1rem}.status-change__content--scrollable[_ngcontent-%COMP%]{max-height:23.7rem;overflow:auto;padding-right:2.6rem}.status-change__alert-box[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;background:#f0eff0;padding:1.3rem 4rem;margin:3.6rem -4rem 1.2rem}.status-change__alert-box-icon[_ngcontent-%COMP%]{width:2rem;height:2rem;margin-right:.6rem}.status-change__alert-box-message[_ngcontent-%COMP%]{width:90%}.status-change__strong[_ngcontent-%COMP%]{font-weight:500}.input-field[_ngcontent-%COMP%]{max-width:100%;width:98%}.input-field__helper[_ngcontent-%COMP%]{display:contents}.input-field__helper--warning[_ngcontent-%COMP%]{font-weight:500;color:#8a6d3b}.error[_ngcontent-%COMP%]{color:#bf4252}.description[_ngcontent-%COMP%]{margin-top:2rem}.select-input-field[_ngcontent-%COMP%]{min-width:14rem}.select[_ngcontent-%COMP%]{margin-right:1.1rem;min-width:13.8rem}.select--selected[_ngcontent-%COMP%]{padding:.7rem 1.7rem}.select--selected[_ngcontent-%COMP%]:after{top:-.4rem}.select__item[_ngcontent-%COMP%]{padding:.7rem 1.7rem}.user-input-section[_ngcontent-%COMP%]{margin-top:1.6rem}"] });
/*@__PURE__*/ ɵsetClassMetadata(StatusChangeComponent, [{
        type: Component,
        args: [{
                selector: "lib-status-change",
                templateUrl: "./status-change.component.html",
                styleUrls: ["./status-change.component.scss"],
            }]
    }], function () { return []; }, { statusChangeResourceList: [{
            type: Input
        }], allowedStatuses: [{
            type: Input
        }], resourceIdentifierTitle: [{
            type: Input
        }], statusTitle: [{
            type: Input
        }], alertMsg: [{
            type: Input
        }], errorMsg: [{
            type: Input
        }], commentMaxLength: [{
            type: Input
        }], commentFieldIdentifier: [{
            type: Input
        }], confirm: [{
            type: Output
        }] });

class StatusChangeModule {
}
/** @nocollapse */ StatusChangeModule.ngModuleDef = ɵɵdefineNgModule({ type: StatusChangeModule });
/** @nocollapse */ StatusChangeModule.ngInjectorDef = ɵɵdefineInjector({ factory: function StatusChangeModule_Factory(t) { return new (t || StatusChangeModule)(); }, imports: [[CommonModule, SelectModule, FormsModule, ErrorAlertMessageModule, OverlayscrollbarsModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(StatusChangeModule, { declarations: [StatusChangeComponent], imports: [CommonModule, SelectModule, FormsModule, ErrorAlertMessageModule, OverlayscrollbarsModule], exports: [StatusChangeComponent] });
/*@__PURE__*/ ɵsetClassMetadata(StatusChangeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, SelectModule, FormsModule, ErrorAlertMessageModule, OverlayscrollbarsModule],
                declarations: [StatusChangeComponent],
                exports: [StatusChangeComponent]
            }]
    }], null, null);

class FileValidator {
    constructor(options) {
        Object.assign(this, options);
    }
    isValidFileExtension(file) {
        return this.validExtensionsPattern.test(file.name);
    }
    getFileErrors(file) {
        const errors = [];
        if (!this.isValidFileExtension(file)) {
            const errorMessage = new Error(`Invalid file extension - ${file.name}`);
            errors.push(errorMessage);
        }
        return errors;
    }
    getFilesErrors(files) {
        const errors = [];
        // Global file errors
        const errorMessage = `Only ${this.numberOfFilesAllowed} file(s) can be selected at once.`;
        if (files.length > this.numberOfFilesAllowed) {
            errors.push(new Error(errorMessage));
        }
        // Individual file errors
        for (const file of files) {
            errors.push(...this.getFileErrors(file));
        }
        return errors;
    }
}

const _c0$V = ["for", "comp-lib-file-picker", 1, "btn", "btn--tertiary"];
const _c1$U = ["id", "comp-lib-file-picker", "type", "file", 2, "visibility", "hidden", 3, "change"];
const _c2$P = ["fileInput", ""];
const _c3$M = ["class", "dropzone container", "libDragAndDrop", "", 3, "numberOfFilesAllowed", "validExtensionsPattern", "filesDropped", 4, "ngIf"];
const _c4$K = ["libDragAndDrop", "", 1, "dropzone", "container", 3, "numberOfFilesAllowed", "validExtensionsPattern", "filesDropped"];
const _c5$H = [1, "row", "dropzone__text"];
const _c6$F = [1, "col-3", "center-align"];
const _c7$D = [1, "upload-icon"];
const _c8$C = [1, "col-9", "center-align"];
const _c9$y = [1, "drag-drop-text"];
function FilePickerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r955 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", _c4$K);
    ɵɵlistener("filesDropped", function FilePickerComponent_div_6_Template_div_filesDropped_0_listener($event) { ɵɵrestoreView(_r955); const ctx_r954 = ɵɵnextContext(); return ctx_r954.onFilesDropped($event); });
    ɵɵelementStart(1, "div", _c5$H);
    ɵɵelementStart(2, "div", _c6$F);
    ɵɵelement(3, "div", _c7$D);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", _c8$C);
    ɵɵelementStart(5, "span", _c9$y);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r953 = ɵɵnextContext();
    ɵɵproperty("numberOfFilesAllowed", ctx_r953.numberOfFilesAllowed)("validExtensionsPattern", ctx_r953.validExtensionsPattern);
    ɵɵselect(6);
    ɵɵtextInterpolate(ctx_r953.dragAndDropLabelText);
} }
class FilePickerComponent {
    constructor() {
        this.dragAndDropAllowed = true; // set to false if drag and drop feature not needed
        this.numberOfFilesAllowed = 1;
        this.validExtensionsPattern = /.*/;
        /* It does not preserve previous files selected/drag-and-dropped. It always emits the new ones only. */
        this.filesSelected = new EventEmitter();
        this.areMultipleFilesAllowed = false;
        this.labelText = 'BROWSE FILE';
        this.dragAndDropLabelText = 'DRAG & DROP YOUR FILE HERE';
        this.fileValidator = new FileValidator({
            numberOfFilesAllowed: this.numberOfFilesAllowed,
            validExtensionsPattern: this.validExtensionsPattern
        });
    }
    ngOnChanges(changes) {
        if (changes.numberOfFilesAllowed !== null && changes.numberOfFilesAllowed.currentValue > 1) {
            this.areMultipleFilesAllowed = true;
            this.labelText = 'BROWSE FILES';
            this.dragAndDropLabelText = 'DRAG & DROP YOUR FILES HERE';
        }
        else if (changes.numberOfFilesAllowed !== null && changes.numberOfFilesAllowed.currentValue === 1) {
            this.areMultipleFilesAllowed = false;
            this.labelText = 'BROWSE FILE';
            this.dragAndDropLabelText = 'DRAG & DROP YOUR FILE HERE';
        }
        this.fileValidator = new FileValidator({
            numberOfFilesAllowed: this.numberOfFilesAllowed,
            validExtensionsPattern: this.validExtensionsPattern
        });
    }
    onFilesDropped(data) {
        this.filesSelected.emit(data);
    }
    onFilesSelected(files) {
        const errors = this.fileValidator.getFilesErrors(files);
        this.filesSelected.emit({ selectedFiles: files, errors: errors });
    }
}
/** @nocollapse */ FilePickerComponent.ngComponentDef = ɵɵdefineComponent({ type: FilePickerComponent, selectors: [["lib-file-picker"]], factory: function FilePickerComponent_Factory(t) { return new (t || FilePickerComponent)(); }, inputs: { dragAndDropAllowed: "dragAndDropAllowed", numberOfFilesAllowed: "numberOfFilesAllowed", validExtensionsPattern: "validExtensionsPattern" }, outputs: { filesSelected: "filesSelected" }, features: [ɵɵNgOnChangesFeature()], consts: 7, vars: 3, template: function FilePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainerStart(0);
        ɵɵelementStart(1, "label", _c0$V);
        ɵɵelementStart(2, "b");
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "input", _c1$U, _c2$P);
        ɵɵlistener("change", function FilePickerComponent_Template_input_change_4_listener($event) { return ctx.onFilesSelected($event.target.files); });
        ɵɵelementEnd();
        ɵɵelementContainerEnd();
        ɵɵtemplate(6, FilePickerComponent_div_6_Template, 7, 3, "div", _c3$M);
    } if (rf & 2) {
        ɵɵselect(3);
        ɵɵtextInterpolate(ctx.labelText);
        ɵɵselect(4);
        ɵɵattribute("multiple", ctx.areMultipleFilesAllowed ? "multiple" : null);
        ɵɵselect(6);
        ɵɵproperty("ngIf", ctx.dragAndDropAllowed);
    } }, styles: [".dropzone[_ngcontent-%COMP%]{background-color:#f9f9f9;border:2px dotted #c7c7c7;width:100%;height:10rem;padding:1rem;position:relative;-webkit-transition:border-color .25s ease-in;transition:border-color .25s ease-in}.dropzone__text[_ngcontent-%COMP%]{margin-top:2.5rem}.drag-drop-text[_ngcontent-%COMP%]{font-size:small;color:#656066;font-weight:400}.center-align[_ngcontent-%COMP%]{-webkit-box-align:center;align-items:center}.upload-icon[_ngcontent-%COMP%]{background-image:url(https://static.basespace.illumina.com/sites/basespace-ui/1.56.7062/assets/icons/cloud-upload-icon.svg);background-size:contain;background-repeat:no-repeat;background-position:center;opacity:.4;height:100%}"] });
/*@__PURE__*/ ɵsetClassMetadata(FilePickerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-file-picker',
                templateUrl: './file-picker.component.html',
                styleUrls: ['./file-picker.component.scss']
            }]
    }], function () { return []; }, { dragAndDropAllowed: [{
            type: Input
        }], numberOfFilesAllowed: [{
            type: Input
        }], validExtensionsPattern: [{
            type: Input
        }], filesSelected: [{
            type: Output
        }] });

class DragAndDropDirective {
    constructor() {
        this.numberOfFilesAllowed = 1;
        this.validExtensionsPattern = /.*/;
        this.filesDropped = new EventEmitter();
        this.fileValidator = new FileValidator({
            numberOfFilesAllowed: this.numberOfFilesAllowed,
            validExtensionsPattern: this.validExtensionsPattern
        });
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    // Drop listener
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const files = evt.dataTransfer.files;
        const errors = this.fileValidator.getFilesErrors(files);
        this.filesDropped.emit({ selectedFiles: files, errors: errors });
    }
    ngOnChanges(changes) {
        this.fileValidator = new FileValidator({
            numberOfFilesAllowed: this.numberOfFilesAllowed,
            validExtensionsPattern: this.validExtensionsPattern
        });
    }
}
/** @nocollapse */ DragAndDropDirective.ngDirectiveDef = ɵɵdefineDirective({ type: DragAndDropDirective, selectors: [["", "libDragAndDrop", ""]], factory: function DragAndDropDirective_Factory(t) { return new (t || DragAndDropDirective)(); }, hostBindings: function DragAndDropDirective_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵɵlistener("dragover", function DragAndDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); });
        ɵɵlistener("dragleave", function DragAndDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); });
        ɵɵlistener("drop", function DragAndDropDirective_drop_HostBindingHandler($event) { return ctx.ondrop($event); });
    } }, inputs: { numberOfFilesAllowed: "numberOfFilesAllowed", validExtensionsPattern: "validExtensionsPattern" }, outputs: { filesDropped: "filesDropped" }, features: [ɵɵNgOnChangesFeature()] });
/*@__PURE__*/ ɵsetClassMetadata(DragAndDropDirective, [{
        type: Directive,
        args: [{
                selector: '[libDragAndDrop]'
            }]
    }], function () { return []; }, { numberOfFilesAllowed: [{
            type: Input
        }], validExtensionsPattern: [{
            type: Input
        }], filesDropped: [{
            type: Output
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], ondrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] });

class FilePickerModule {
}
/** @nocollapse */ FilePickerModule.ngModuleDef = ɵɵdefineNgModule({ type: FilePickerModule });
/** @nocollapse */ FilePickerModule.ngInjectorDef = ɵɵdefineInjector({ factory: function FilePickerModule_Factory(t) { return new (t || FilePickerModule)(); }, imports: [[
            CommonModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(FilePickerModule, { declarations: [FilePickerComponent, DragAndDropDirective], imports: [CommonModule], exports: [FilePickerComponent, DragAndDropDirective] });
/*@__PURE__*/ ɵsetClassMetadata(FilePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [FilePickerComponent, DragAndDropDirective],
                imports: [
                    CommonModule
                ],
                exports: [FilePickerComponent, DragAndDropDirective]
            }]
    }], null, null);
ɵɵsetComponentScope(FilePickerComponent, [FilePickerComponent, DragAndDropDirective, NgClass, NgComponentOutlet, NgForOf, NgIf, NgTemplateOutlet, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgPlural, NgPluralCase], [AsyncPipe, UpperCasePipe, LowerCasePipe, JsonPipe, SlicePipe, DecimalPipe, PercentPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nPluralPipe, I18nSelectPipe, KeyValuePipe]);

const _c0$W = [1, "container"];
const _c1$V = [1, "row"];
const _c2$Q = [1, "col-12"];
const _c3$N = [1, "msgs"];
const _c4$L = [4, "ngFor", "ngForOf"];
const _c5$I = ["class", "info_message__box", 4, "ngIf"];
const _c6$G = [1, "info_message__box"];
const _c7$E = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "info_message__box-icon"];
const _c8$D = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#656066"];
const _c9$z = [1, "info_message__box-text", 3, "innerHtml"];
function SuccessInfoMessageComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c6$G);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c7$E);
    ɵɵelement(2, "path", _c8$D);
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelement(3, "span", _c9$z);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r959 = ɵɵnextContext(2);
    ɵɵselect(3);
    ɵɵproperty("innerHtml", ctx_r959.infoMessage, ɵɵsanitizeHtml);
} }
function SuccessInfoMessageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, SuccessInfoMessageComponent_div_4_div_1_Template, 4, 1, "div", _c5$I);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r958 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", msg_r958 && msg_r958.length > 0);
} }
const _c10$w = ["class", "success_message__box", 4, "ngIf"];
const _c11$t = [1, "success_message__box"];
const _c12$r = ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", 1, "success_message__box-icon"];
const _c13$p = ["d", "M10 17.5c-4.1 0-7.5-3.4-7.5-7.5S5.9 2.5 10 2.5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zm0-14c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm.5-2V6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5z", "fill", "#BF4252"];
const _c14$o = [1, "success_message__box-text", 3, "innerHtml"];
function SuccessInfoMessageComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", _c11$t);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", _c12$r);
    ɵɵelement(2, "path", _c13$p);
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelement(3, "span", _c14$o);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r960 = ɵɵnextContext().$implicit;
    ɵɵselect(3);
    ɵɵproperty("innerHtml", msg_r960, ɵɵsanitizeHtml);
} }
function SuccessInfoMessageComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, SuccessInfoMessageComponent_div_5_div_1_Template, 4, 1, "div", _c10$w);
    ɵɵelementEnd();
} if (rf & 2) {
    const msg_r960 = ctx.$implicit;
    ɵɵselect(1);
    ɵɵproperty("ngIf", msg_r960 && msg_r960.length > 0);
} }
class SuccessInfoMessageComponent {
    constructor() { }
    ngOnInit() {
    }
    set successMsg(msg) {
        if (typeof msg === "string") {
            this._successMsg = [msg];
        }
        else {
            this._successMsg = msg;
        }
    }
    set infoMessage(msg) {
        if (typeof msg === "string") {
            this._infoMsg = [msg];
        }
        else {
            this._infoMsg = msg;
        }
    }
    // tslint:disable-next-line: adjacent-overload-signatures
    get successMsg() {
        return this._successMsg;
    }
    // tslint:disable-next-line: adjacent-overload-signatures
    get infoMsg() {
        return this._infoMsg;
    }
}
/** @nocollapse */ SuccessInfoMessageComponent.ngComponentDef = ɵɵdefineComponent({ type: SuccessInfoMessageComponent, selectors: [["lib-success-info-message"]], factory: function SuccessInfoMessageComponent_Factory(t) { return new (t || SuccessInfoMessageComponent)(); }, inputs: { successMsg: "successMsg", infoMessage: ["infoMsg", "infoMessage"] }, consts: 6, vars: 2, template: function SuccessInfoMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c0$W);
        ɵɵelementStart(1, "div", _c1$V);
        ɵɵelementStart(2, "div", _c2$Q);
        ɵɵelementStart(3, "div", _c3$N);
        ɵɵtemplate(4, SuccessInfoMessageComponent_div_4_Template, 2, 1, "div", _c4$L);
        ɵɵtemplate(5, SuccessInfoMessageComponent_div_5_Template, 2, 1, "div", _c4$L);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(4);
        ɵɵproperty("ngForOf", ctx.infoMessage);
        ɵɵselect(5);
        ɵɵproperty("ngForOf", ctx.successMsg);
    } }, directives: [NgForOf, NgIf], styles: [".info_message__box[_ngcontent-%COMP%], .success_message__box[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.info_message__box[_ngcontent-%COMP%], .success_message__box[_ngcontent-%COMP%]{font-size:16px;letter-spacing:.4px;line-height:1.5;font-weight:500}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.msgs[_ngcontent-%COMP%]{background:#f0eff0}.info_message__box[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;padding:1.3rem 3rem}.info_message__box-icon[_ngcontent-%COMP%]{width:2rem;height:2rem;margin-right:.6rem}.info_message__box-text[_ngcontent-%COMP%]{width:90%}.success_message__box[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;padding:1.3rem 3rem}.success_message__box-icon[_ngcontent-%COMP%]{width:2rem;height:2rem;margin-right:.6rem}.success_message__box-text[_ngcontent-%COMP%]{width:90%;color:#bf4252}"] });
/*@__PURE__*/ ɵsetClassMetadata(SuccessInfoMessageComponent, [{
        type: Component,
        args: [{
                selector: 'lib-success-info-message',
                templateUrl: './success-info-message.component.html',
                styleUrls: ['./success-info-message.component.scss']
            }]
    }], function () { return []; }, { successMsg: [{
            type: Input,
            args: ["successMsg"]
        }], infoMessage: [{
            type: Input,
            args: ["infoMsg"]
        }] });

class SuccessInfoMessageModule {
}
/** @nocollapse */ SuccessInfoMessageModule.ngModuleDef = ɵɵdefineNgModule({ type: SuccessInfoMessageModule });
/** @nocollapse */ SuccessInfoMessageModule.ngInjectorDef = ɵɵdefineInjector({ factory: function SuccessInfoMessageModule_Factory(t) { return new (t || SuccessInfoMessageModule)(); }, imports: [[
            CommonModule
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(SuccessInfoMessageModule, { declarations: [SuccessInfoMessageComponent], imports: [CommonModule], exports: [SuccessInfoMessageComponent] });
/*@__PURE__*/ ɵsetClassMetadata(SuccessInfoMessageModule, [{
        type: NgModule,
        args: [{
                declarations: [SuccessInfoMessageComponent],
                imports: [
                    CommonModule
                ],
                exports: [SuccessInfoMessageComponent]
            }]
    }], null, null);

class ChartsService {
    constructor() { }
    buildNewFormControlObj() {
        return {
            Metric: null,
            SurfaceIndex: null,
            ReadIndex: null,
            CycleIndex: null,
            BaseIndex: null,
            LaneIndex: null,
            ChannelIndex: null,
            Cumulative: null,
            FixScale: null,
        };
    }
    getSvgContainerWidth(containerWidth, hideOptions = false) {
        // column container for chart details page with options column
        var columnChartWidthPercent = 0.75;
        // column container for chart on run details page without options column
        if (hideOptions) {
            columnChartWidthPercent = 1;
        }
        var paddingLeft = 15;
        var paddingRight = 15;
        var panelBorderSizeLeft = 1;
        var panelBorderSizeRight = 1;
        return (Math.round(containerWidth * columnChartWidthPercent) -
            paddingLeft -
            paddingRight -
            panelBorderSizeLeft -
            panelBorderSizeRight);
    }
    getSvgContainerHeight(containerHeight) {
        var svgContainerHeightPadding = 75;
        return containerHeight - svgContainerHeightPadding;
    }
    updateChart(chart, containerWidth, containerHeight, chartData = null, hideOptions = false) {
        // if no chart to redraw or no svg container width, then abort
        if (!chart || !containerWidth)
            return;
        chart.update(chartData, {
            width: containerWidth,
            height: containerHeight,
        });
    }
    getQscoreDistributionBuildCycleOptions(minCycle, maxCycle) {
        var options = [{ Name: "All Cycles", Value: "0" }];
        // create range of options
        for (var i = minCycle; i <= maxCycle; i++) {
            options.push({ Name: "Cycle " + i, Value: i + "" });
        }
        return options;
    }
}
/** @nocollapse */ ChartsService.ngInjectableDef = ɵɵdefineInjectable({ token: ChartsService, factory: function ChartsService_Factory(t) { return new (t || ChartsService)(); }, providedIn: "root" });
/*@__PURE__*/ ɵsetClassMetadata(ChartsService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return []; }, null);

const _c0$X = ["laneIndex"];
const _c1$W = ["surfIndex"];
const _c2$R = ["readIndex"];
const _c3$O = ["cycleIndex"];
const _c4$M = ["metricsType"];
const _c5$J = ["baseIndex"];
const _c6$H = ["channelIndex"];
const _c7$F = [1, "chart-options__selections"];
const _c8$E = [4, "ngIf"];
const _c9$A = [1, "chart-options__checkbox-list"];
const _c10$x = ["type", "checkbox", 3, "checked", "disabled", "change", 4, "ngIf"];
const _c11$u = ["for", "metricsType", 1, "chart-options__label"];
const _c12$s = ["placeholder", "Loading...", 3, "ngModel", "disabled", "ngModelChange", "change"];
const _c13$q = ["metricsType", "", "model", "ngModel"];
const _c14$p = [3, "value", "label", 4, "ngFor", "ngForOf"];
const _c15$m = [3, "value", "label"];
function ChartOptionsComponent_ng_container_1_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1002 = ctx.$implicit;
    ɵɵproperty("value", option_r1002.Value)("label", option_r1002.Name);
} }
function ChartOptionsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r1004 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c11$u);
    ɵɵtext(3, "Chart");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c13$q);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_1_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1004); const ctx_r1003 = ɵɵnextContext(); return ctx_r1003.formControlInputValues.Metric = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_1_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1004); const ctx_r1005 = ɵɵnextContext(); return ctx_r1005.onMetricsTypeChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_1_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r990 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r990.formControlInputValues.Metric)("disabled", ctx_r990.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r990.controls.MetricsType.Options);
} }
const _c16$k = ["for", "surfIndex", 1, "chart-options__label"];
const _c17$k = ["surfIndex", "", "model", "ngModel"];
function ChartOptionsComponent_ng_container_2_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1009 = ctx.$implicit;
    ɵɵproperty("value", option_r1009.Value)("label", option_r1009.Name);
} }
function ChartOptionsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r1011 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c16$k);
    ɵɵtext(3, "Surface");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c17$k);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_2_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1011); const ctx_r1010 = ɵɵnextContext(); return ctx_r1010.formControlInputValues.SurfaceIndex = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_2_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1011); const ctx_r1012 = ɵɵnextContext(); return ctx_r1012.onOptionChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_2_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r991 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r991.formControlInputValues.SurfaceIndex)("disabled", ctx_r991.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r991.controls.SurfIndex.Options);
} }
const _c18$i = ["for", "laneIndex", 1, "chart-options__label"];
const _c19$h = ["laneIndex", "", "model", "ngModel"];
function ChartOptionsComponent_ng_container_3_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1016 = ctx.$implicit;
    ɵɵproperty("value", option_r1016.Value)("label", option_r1016.Name);
} }
function ChartOptionsComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r1018 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c18$i);
    ɵɵtext(3, "Lane");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c19$h);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_3_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1018); const ctx_r1017 = ɵɵnextContext(); return ctx_r1017.formControlInputValues.LaneIndex = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_3_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1018); const ctx_r1019 = ɵɵnextContext(); return ctx_r1019.onOptionChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_3_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r992 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r992.formControlInputValues.LaneIndex)("disabled", ctx_r992.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r992.controls.LaneIndex.Options);
} }
const _c20$g = ["for", "readIndex", 1, "chart-options__label"];
const _c21$f = ["readIndex", "", "model", "ngModel"];
function ChartOptionsComponent_ng_container_4_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1023 = ctx.$implicit;
    ɵɵproperty("value", option_r1023.Value)("label", option_r1023.Name);
} }
function ChartOptionsComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r1025 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c20$g);
    ɵɵtext(3, "Read");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c21$f);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_4_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1025); const ctx_r1024 = ɵɵnextContext(); return ctx_r1024.formControlInputValues.ReadIndex = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_4_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1025); const ctx_r1026 = ɵɵnextContext(); return ctx_r1026.onReadIndexChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_4_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r993 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r993.formControlInputValues.ReadIndex)("disabled", ctx_r993.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r993.controls.ReadIndex.Options);
} }
const _c22$f = ["for", "cycleIndex", 1, "chart-options__label"];
const _c23$f = ["cycleIndex", "", "model", "ngModel"];
function ChartOptionsComponent_ng_container_5_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1030 = ctx.$implicit;
    ɵɵproperty("value", option_r1030.Value)("label", option_r1030.Name);
} }
function ChartOptionsComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r1032 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c22$f);
    ɵɵtext(3, "Cycle");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c23$f);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_5_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1032); const ctx_r1031 = ɵɵnextContext(); return ctx_r1031.formControlInputValues.CycleIndex = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_5_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1032); const ctx_r1033 = ɵɵnextContext(); return ctx_r1033.onOptionChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_5_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r994 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r994.formControlInputValues.CycleIndex)("disabled", ctx_r994.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r994.controls.CycleIndex.Options);
} }
const _c24$e = ["for", "baseIndex", 1, "chart-options__label"];
const _c25$d = ["baseIndex", "", "model", "ngModel"];
function ChartOptionsComponent_ng_container_6_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1037 = ctx.$implicit;
    ɵɵproperty("value", option_r1037.Value)("label", option_r1037.Name);
} }
function ChartOptionsComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r1039 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c24$e);
    ɵɵtext(3, "Base");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c25$d);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_6_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1039); const ctx_r1038 = ɵɵnextContext(); return ctx_r1038.formControlInputValues.BaseIndex = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_6_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1039); const ctx_r1040 = ɵɵnextContext(); return ctx_r1040.onOptionChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_6_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r995 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r995.formControlInputValues.BaseIndex)("disabled", ctx_r995.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r995.controls.BaseIndex.Options);
} }
const _c26$d = ["for", "channelIndex", 1, "chart-options__label"];
const _c27$d = ["channelIndex", "", "model", "ngModel"];
function ChartOptionsComponent_ng_container_7_lib_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "lib-option", _c15$m);
} if (rf & 2) {
    const option_r1044 = ctx.$implicit;
    ɵɵproperty("value", option_r1044.Value)("label", option_r1044.Name);
} }
function ChartOptionsComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r1046 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "section");
    ɵɵelementStart(2, "label", _c26$d);
    ɵɵtext(3, "Channel");
    ɵɵelementEnd();
    ɵɵelementStart(4, "lib-select", _c12$s, _c27$d);
    ɵɵlistener("ngModelChange", function ChartOptionsComponent_ng_container_7_Template_lib_select_ngModelChange_4_listener($event) { ɵɵrestoreView(_r1046); const ctx_r1045 = ɵɵnextContext(); return ctx_r1045.formControlInputValues.ChannelIndex = $event; });
    ɵɵlistener("change", function ChartOptionsComponent_ng_container_7_Template_lib_select_change_4_listener($event) { ɵɵrestoreView(_r1046); const ctx_r1047 = ɵɵnextContext(); return ctx_r1047.onOptionChange($event); });
    ɵɵtemplate(7, ChartOptionsComponent_ng_container_7_lib_option_7_Template, 1, 2, "lib-option", _c14$p);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r996 = ɵɵnextContext();
    ɵɵselect(4);
    ɵɵproperty("ngModel", ctx_r996.formControlInputValues.ChannelIndex)("disabled", ctx_r996.disabled);
    ɵɵselect(7);
    ɵɵproperty("ngForOf", ctx_r996.controls.ChannelIndex.Options);
} }
const _c28$d = ["type", "checkbox", 3, "checked", "disabled", "change"];
function ChartOptionsComponent_lib_radio_checkbox_9_Template(rf, ctx) { if (rf & 1) {
    const _r1049 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-radio-checkbox", _c28$d);
    ɵɵlistener("change", function ChartOptionsComponent_lib_radio_checkbox_9_Template_lib_radio_checkbox_change_0_listener($event) { ɵɵrestoreView(_r1049); const ctx_r1048 = ɵɵnextContext(); return ctx_r1048.onFixScaleValueChange($event); });
    ɵɵtext(1, " Fix Scale ");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r997 = ɵɵnextContext();
    ɵɵproperty("checked", ctx_r997.formControlInputValues.FixScale)("disabled", ctx_r997.disabled || !ctx_r997.controls.FixScale.IsVisible);
} }
function ChartOptionsComponent_lib_radio_checkbox_10_Template(rf, ctx) { if (rf & 1) {
    const _r1051 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-radio-checkbox", _c28$d);
    ɵɵlistener("change", function ChartOptionsComponent_lib_radio_checkbox_10_Template_lib_radio_checkbox_change_0_listener($event) { ɵɵrestoreView(_r1051); const ctx_r1050 = ɵɵnextContext(); return ctx_r1050.onCumulativeAccumValueChange($event); });
    ɵɵtext(1, " Accum ");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r998 = ɵɵnextContext();
    ɵɵproperty("checked", ctx_r998.formControlInputValues.Cumulative)("disabled", ctx_r998.disabled || !ctx_r998.controls.MetricsType.IsVisible);
} }
class ChartOptionsComponent {
    constructor(chartsService, changeDetectorRef) {
        this.chartsService = chartsService;
        this.changeDetectorRef = changeDetectorRef;
        this.controls = null;
        this.selectedMetricsHasCumQScore = false;
        this.chartFormControls = null;
        this.isReadIndexVisible = false;
        this.isCycleIndexVisible = false;
        this.isBaseIndexVisible = false;
        this.isChannelIndexVisible = false;
        //using to suppress the plot data load emit call while  chart options default values are being set 
        this.suppressUpdatingChartData = false;
        this.disabled = false;
        this.loadChartData = new EventEmitter();
        this.fixScaleValueChanged = new EventEmitter();
        this.formControlInputValues = this.chartsService.buildNewFormControlObj();
        this.chartFormControls = {
            selectedMetrics: null,
            selectedCycleIndex: null,
            selectedChannelIndex: null,
            selectedSurfaceIndex: null,
            selectedReadIndex: null,
            selectedBaseIndex: null,
            selectedLaneIndex: null,
            selectedCumulative: false,
        };
    }
    set laneIndexContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.laneIndex = content;
        }
    }
    set surfIndexContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.surfIndex = content;
        }
    }
    set readIndexContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.readIndex = content;
        }
    }
    set cycleIndexContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.cycleIndex = content;
        }
    }
    set metricsTypeContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.metricsType = content;
        }
    }
    set baseIndexContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.baseIndex = content;
        }
    }
    set channelIndexContent(content) {
        if (content) {
            // initially setter gets called with undefined
            this.channelIndex = content;
        }
    }
    ngOnInit() {
        if (this.plotOptions !== null) {
            this.controls = this.plotOptions.Controls;
        }
    }
    ngAfterViewInit() {
        if (this.controls !== null) {
            this.setPlotDefaultOptions();
        }
    }
    setPlotDefaultOptions() {
        setTimeout(() => {
            this.suppressUpdatingChartData = true;
            if (this.controls.MetricsType &&
                this.controls.MetricsType.Options.length > 0) {
                this.chartFormControls.selectedMetrics = this.controls.MetricsType.Options[0];
                this.formControlInputValues.Metric = this.chartFormControls.selectedMetrics.Value;
                if (typeof this.metricsType !== "undefined") {
                    this.metricsType.selectOption(this.metricsType.options.first, false);
                    this.formControlInputValues.Metric = this.metricsType.selectedOption.value;
                    this.selectedMetricsHasCumQScore = this.chartFormControls.selectedMetrics.HasCumQScore;
                    this.formControlInputValues.Cumulative = false;
                }
            }
            if (this.controls.SurfIndex &&
                this.controls.SurfIndex.Options.length > 0) {
                this.chartFormControls.selectedSurfaceIndex = this.controls.SurfIndex.Options[0];
                this.formControlInputValues.SurfaceIndex = parseInt(this.chartFormControls.selectedSurfaceIndex.Value);
                if (typeof this.surfIndex !== "undefined") {
                    this.surfIndex.selectOption(this.surfIndex.options.first, false);
                    this.formControlInputValues.SurfaceIndex = parseInt(this.surfIndex.selectedOption.value);
                }
            }
            if (this.controls.LaneIndex &&
                this.controls.LaneIndex.Options.length > 0) {
                this.chartFormControls.selectedLaneIndex = this.controls.LaneIndex.Options[0];
                this.formControlInputValues.LaneIndex = parseInt(this.chartFormControls.selectedLaneIndex.Value);
                if (typeof this.laneIndex !== "undefined") {
                    this.laneIndex.selectOption(this.laneIndex.options.first, false);
                    this.formControlInputValues.LaneIndex = parseInt(this.laneIndex.selectedOption.value);
                }
            }
            if (this.controls.ReadIndex &&
                this.controls.ReadIndex.Options.length > 0) {
                this.chartFormControls.selectedReadIndex = this.controls.ReadIndex.Options[0];
                this.formControlInputValues.ReadIndex = parseInt(this.chartFormControls.selectedReadIndex.Value);
                if ((this.controls.ReadIndex.IsVisible &&
                    this.chartFormControls.selectedMetrics == null) ||
                    (this.chartFormControls.selectedMetrics != null &&
                        this.chartFormControls.selectedMetrics.IsReadMetric)) {
                    this.isReadIndexVisible = true;
                }
                this.changeDetectorRef.detectChanges();
                if (typeof this.readIndex !== "undefined") {
                    this.readIndex.selectOption(this.readIndex.options.first, false);
                    this.formControlInputValues.ReadIndex = parseInt(this.readIndex.selectedOption.value);
                }
            }
            if (this.controls.CycleIndex &&
                this.controls.CycleIndex.Options.length > 0) {
                this.chartFormControls.selectedCycleIndex = this.controls.CycleIndex.Options[0];
                this.formControlInputValues.CycleIndex = parseInt(this.chartFormControls.selectedCycleIndex.Value);
                if ((this.controls.CycleIndex.IsVisible &&
                    this.chartFormControls.selectedMetrics == null) ||
                    (this.chartFormControls.selectedMetrics != null &&
                        this.chartFormControls.selectedMetrics.IsCycleMetric)) {
                    this.isCycleIndexVisible = true;
                }
                this.changeDetectorRef.detectChanges();
                if (typeof this.cycleIndex !== "undefined") {
                    this.cycleIndex.selectOption(this.cycleIndex.options.first, false);
                    this.formControlInputValues.CycleIndex = parseInt(this.cycleIndex.selectedOption.value);
                }
            }
            if (this.controls.BaseIndex &&
                this.controls.BaseIndex.Options.length > 0) {
                this.chartFormControls.selectedBaseIndex = this.controls.BaseIndex.Options[0];
                this.formControlInputValues.BaseIndex = parseInt(this.chartFormControls.selectedBaseIndex.Value);
                if ((this.controls.BaseIndex.IsVisible &&
                    this.chartFormControls.selectedMetrics == null) ||
                    (this.chartFormControls.selectedMetrics != null &&
                        this.chartFormControls.selectedMetrics.IsBaseMetric)) {
                    this.isBaseIndexVisible = true;
                }
                this.changeDetectorRef.detectChanges();
                if (typeof this.baseIndex !== "undefined") {
                    this.baseIndex.selectOption(this.baseIndex.options.first, false);
                    this.formControlInputValues.BaseIndex = parseInt(this.baseIndex.selectedOption.value);
                }
            }
            if (this.controls.ChannelIndex &&
                this.controls.ChannelIndex.Options.length > 0) {
                this.chartFormControls.selectedChannelIndex = this.controls.ChannelIndex.Options[0];
                this.formControlInputValues.ChannelIndex = parseInt(this.chartFormControls.selectedChannelIndex.Value);
                if ((this.controls.ChannelIndex.IsVisible &&
                    this.chartFormControls.selectedMetrics == null) ||
                    (this.chartFormControls.selectedMetrics != null &&
                        this.chartFormControls.selectedMetrics.IsChannelMetric)) {
                    this.isChannelIndexVisible = true;
                }
                this.changeDetectorRef.detectChanges();
                if (typeof this.channelIndex !== "undefined") {
                    this.channelIndex.selectOption(this.channelIndex.options.first, false);
                    this.formControlInputValues.ChannelIndex = parseInt(this.channelIndex.selectedOption.value);
                }
            }
            this.suppressUpdatingChartData = false;
            this.onloadChartData();
        }, 300);
    }
    onOptionChange($event) {
        this.onloadChartData();
    }
    onloadChartData() {
        if (!this.suppressUpdatingChartData) {
            this.loadChartData.emit(this.formControlInputValues);
        }
    }
    onCumulativeAccumValueChange($event) {
        this.formControlInputValues.Cumulative = $event.target.checked;
        this.onloadChartData();
    }
    onFixScaleValueChange($event) {
        this.formControlInputValues.FixScale = $event.target.checked;
        this.fixScaleValueChanged.emit(this.formControlInputValues);
    }
    onReadIndexChange($event) {
        if (this.chartId === "qscore-histogram") {
            // get the selected option
            const selectedOption = this.controls.ReadIndex.Options.find((x) => x.Value == this.formControlInputValues.ReadIndex.toString());
            // generate Cycle options (from MinCycle to MaxCycle, inclusive)
            this.controls.CycleIndex.Options = this.chartsService.getQscoreDistributionBuildCycleOptions(selectedOption.MinCycle, selectedOption.MaxCycle);
            // select first Cycle option as default
            if (this.controls.CycleIndex &&
                this.controls.CycleIndex.Options.length > 0) {
                if (typeof this.cycleIndex !== "undefined") {
                    this.cycleIndex.selectOption(this.cycleIndex.options.first, false);
                    this.formControlInputValues.CycleIndex = parseInt(this.cycleIndex.selectedOption.value);
                }
            }
        }
        // hit up server for new chart data
        this.onloadChartData();
    }
    onMetricsTypeChange($event) {
        if (this.chartId === "data-by-lane") {
            this.onDataByLaneMetricsTypeChange($event);
        }
        if (this.chartId === "data-by-cycle") {
            this.onDataByCycleMetricsTypeChange($event);
        }
        if (this.chartId === "flowcell-chart") {
            this.onFlowCellMetricsTypeChange($event);
        }
    }
    onDataByLaneMetricsTypeChange($event) {
        const selectedOption = this.controls.MetricsType.Options.find((x) => x.Value == this.formControlInputValues.Metric);
        this.suppressUpdatingChartData = true;
        this.setPlotOptionsByMetricsType(selectedOption);
        this.suppressUpdatingChartData = false;
        // hit up server for new chart data
        this.onloadChartData();
    }
    onDataByCycleMetricsTypeChange($event) {
        const selectedOption = this.controls.MetricsType.Options.find((x) => x.Value == this.formControlInputValues.Metric);
        this.suppressUpdatingChartData = true;
        this.selectedMetricsHasCumQScore = selectedOption.HasCumQScore;
        //deselect cumulative checkbox when switching metrics
        this.formControlInputValues.Cumulative = false;
        this.setPlotOptionsByMetricsType(selectedOption);
        this.suppressUpdatingChartData = false;
        // hit up server for new chart data
        this.onloadChartData();
    }
    onFlowCellMetricsTypeChange($event) {
        //if flowcell - get the selected metrics option
        const selectedOption = this.controls.MetricsType.Options.find((x) => x.Value == this.formControlInputValues.Metric);
        this.suppressUpdatingChartData = true;
        this.selectedMetricsHasCumQScore = selectedOption.HasCumQScore;
        this.formControlInputValues.Cumulative = false;
        this.setPlotOptionsByMetricsType(selectedOption);
        if (this.controls.CycleIndex &&
            this.controls.CycleIndex.IsVisible &&
            this.controls.CycleIndex.Options.length > 0) {
            var maxCycle = selectedOption.MaxCycle;
            // Get the cycles valid for the selected metric
            const cycleIndexOptions = this.controls.CycleIndex.Options.slice(0, maxCycle);
            // If the maxcycle for the selected metric is not a valid option, reset dropdown to the default.
            if (cycleIndexOptions != null &&
                cycleIndexOptions.length > 0 &&
                maxCycle < this.formControlInputValues.CycleIndex) {
                this.cycleIndex.selectOption(this.cycleIndex.options.first, false);
                this.formControlInputValues.CycleIndex = parseInt(this.cycleIndex.selectedOption.value);
            }
        }
        this.suppressUpdatingChartData = false;
        // hit up server for new chart data
        this.onloadChartData();
    }
    setPlotOptionsByMetricsType(selectedOption) {
        if (this.controls.ReadIndex && this.controls.ReadIndex.Options.length > 0) {
            this.chartFormControls.selectedReadIndex = this.controls.ReadIndex.Options[0];
            this.formControlInputValues.ReadIndex = parseInt(this.chartFormControls.selectedReadIndex.Value);
            if (selectedOption.IsReadMetric) {
                this.isReadIndexVisible = true;
            }
            else {
                this.isReadIndexVisible = false;
            }
            this.changeDetectorRef.detectChanges();
            if (typeof this.readIndex !== "undefined") {
                this.readIndex.selectOption(this.readIndex.options.first, false);
                this.formControlInputValues.ReadIndex = parseInt(this.readIndex.selectedOption.value);
            }
        }
        if (this.controls.CycleIndex &&
            this.controls.CycleIndex.Options.length > 0) {
            this.chartFormControls.selectedCycleIndex = this.controls.CycleIndex.Options[0];
            this.formControlInputValues.CycleIndex = parseInt(this.chartFormControls.selectedCycleIndex.Value);
            if (selectedOption.IsCycleMetric) {
                this.isCycleIndexVisible = true;
            }
            else {
                this.isCycleIndexVisible = false;
            }
            this.changeDetectorRef.detectChanges();
            if (typeof this.cycleIndex !== "undefined") {
                this.cycleIndex.selectOption(this.cycleIndex.options.first, false);
                this.formControlInputValues.CycleIndex = parseInt(this.cycleIndex.selectedOption.value);
            }
        }
        if (this.controls.BaseIndex && this.controls.BaseIndex.Options.length > 0) {
            this.chartFormControls.selectedBaseIndex = this.controls.BaseIndex.Options[0];
            this.formControlInputValues.BaseIndex = parseInt(this.chartFormControls.selectedBaseIndex.Value);
            if (selectedOption.IsBaseMetric) {
                this.isBaseIndexVisible = true;
            }
            else {
                this.isBaseIndexVisible = false;
            }
            this.changeDetectorRef.detectChanges();
            if (typeof this.baseIndex !== "undefined") {
                this.baseIndex.selectOption(this.baseIndex.options.first, false);
                this.formControlInputValues.BaseIndex = parseInt(this.baseIndex.selectedOption.value);
            }
        }
        if (this.controls.ChannelIndex &&
            this.controls.ChannelIndex.Options.length > 0) {
            this.chartFormControls.selectedChannelIndex = this.controls.ChannelIndex.Options[0];
            this.formControlInputValues.ChannelIndex = parseInt(this.chartFormControls.selectedChannelIndex.Value);
            if (selectedOption.IsChannelMetric) {
                this.isChannelIndexVisible = true;
            }
            else {
                this.isChannelIndexVisible = false;
            }
            this.changeDetectorRef.detectChanges();
            if (typeof this.channelIndex !== "undefined") {
                this.channelIndex.selectOption(this.channelIndex.options.first, false);
                this.formControlInputValues.ChannelIndex = parseInt(this.channelIndex.selectedOption.value);
            }
        }
    }
}
/** @nocollapse */ ChartOptionsComponent.ngComponentDef = ɵɵdefineComponent({ type: ChartOptionsComponent, selectors: [["lib-chart-options"]], factory: function ChartOptionsComponent_Factory(t) { return new (t || ChartOptionsComponent)(ɵɵdirectiveInject(ChartsService), ɵɵdirectiveInject(ChangeDetectorRef)); }, viewQuery: function ChartOptionsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$X, true);
        ɵɵviewQuery(_c1$W, true);
        ɵɵviewQuery(_c2$R, true);
        ɵɵviewQuery(_c3$O, true);
        ɵɵviewQuery(_c4$M, true);
        ɵɵviewQuery(_c5$J, true);
        ɵɵviewQuery(_c6$H, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.laneIndexContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.surfIndexContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.readIndexContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.cycleIndexContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.metricsTypeContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.baseIndexContent = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.channelIndexContent = _t.first);
    } }, inputs: { disabled: "disabled", plotOptions: "plotOptions", chartId: "chartId" }, outputs: { loadChartData: "loadChartData", fixScaleValueChanged: "fixScaleValueChanged" }, consts: 11, vars: 9, template: function ChartOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c7$F);
        ɵɵtemplate(1, ChartOptionsComponent_ng_container_1_Template, 8, 3, "ng-container", _c8$E);
        ɵɵtemplate(2, ChartOptionsComponent_ng_container_2_Template, 8, 3, "ng-container", _c8$E);
        ɵɵtemplate(3, ChartOptionsComponent_ng_container_3_Template, 8, 3, "ng-container", _c8$E);
        ɵɵtemplate(4, ChartOptionsComponent_ng_container_4_Template, 8, 3, "ng-container", _c8$E);
        ɵɵtemplate(5, ChartOptionsComponent_ng_container_5_Template, 8, 3, "ng-container", _c8$E);
        ɵɵtemplate(6, ChartOptionsComponent_ng_container_6_Template, 8, 3, "ng-container", _c8$E);
        ɵɵtemplate(7, ChartOptionsComponent_ng_container_7_Template, 8, 3, "ng-container", _c8$E);
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", _c9$A);
        ɵɵtemplate(9, ChartOptionsComponent_lib_radio_checkbox_9_Template, 2, 2, "lib-radio-checkbox", _c10$x);
        ɵɵtemplate(10, ChartOptionsComponent_lib_radio_checkbox_10_Template, 2, 2, "lib-radio-checkbox", _c10$x);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.controls && ctx.controls.MetricsType && ctx.controls.MetricsType.IsVisible && ctx.controls.MetricsType.Options.length > 1);
        ɵɵselect(2);
        ɵɵproperty("ngIf", ctx.controls && ctx.controls.SurfIndex && ctx.controls.SurfIndex.IsVisible);
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.controls && ctx.controls.LaneIndex && ctx.controls.LaneIndex.IsVisible && ctx.controls.LaneIndex.Options.length > 1);
        ɵɵselect(4);
        ɵɵproperty("ngIf", ctx.isReadIndexVisible);
        ɵɵselect(5);
        ɵɵproperty("ngIf", ctx.isCycleIndexVisible);
        ɵɵselect(6);
        ɵɵproperty("ngIf", ctx.isBaseIndexVisible);
        ɵɵselect(7);
        ɵɵproperty("ngIf", ctx.isChannelIndexVisible);
        ɵɵselect(9);
        ɵɵproperty("ngIf", ctx.controls && ctx.controls.FixScale && ctx.controls.FixScale.IsVisible);
        ɵɵselect(10);
        ɵɵproperty("ngIf", ctx.selectedMetricsHasCumQScore);
    } }, directives: [NgIf, SelectComponent, NgControlStatus, NgModel, NgForOf, OptionComponent, RadioCheckboxComponent], styles: [".chart-options__label[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.chart-options__label[_ngcontent-%COMP%]{font-size:14px;letter-spacing:.4px;line-height:1.4285714286;font-weight:300}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.chart-options__selections[_ngcontent-%COMP%]{display:-ms-grid;display:grid;gap:1rem;-ms-grid-columns:(minmax(6rem,50vmin))[3];grid-template-columns:repeat(3,minmax(6rem,50vmin))}@media (max-width:834px){.chart-options__selections[_ngcontent-%COMP%]{-ms-grid-columns:(minmax(6rem,50vmin))[2];grid-template-columns:repeat(2,minmax(6rem,50vmin))}}.chart-options__checkbox-list[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;margin-top:1rem}.chart-options__checkbox-list[_ngcontent-%COMP%]   lib-radio-checkbox[_ngcontent-%COMP%]:not(:last-child){margin-right:3rem}"] });
/*@__PURE__*/ ɵsetClassMetadata(ChartOptionsComponent, [{
        type: Component,
        args: [{
                selector: "lib-chart-options",
                templateUrl: "./chart-options.component.html",
                styleUrls: ["./chart-options.component.scss"],
            }]
    }], function () { return [{ type: ChartsService }, { type: ChangeDetectorRef }]; }, { disabled: [{
            type: Input
        }], plotOptions: [{
            type: Input
        }], chartId: [{
            type: Input
        }], loadChartData: [{
            type: Output
        }], fixScaleValueChanged: [{
            type: Output
        }], laneIndexContent: [{
            type: ViewChild,
            args: ["laneIndex", { static: false }]
        }], surfIndexContent: [{
            type: ViewChild,
            args: ["surfIndex", { static: false }]
        }], readIndexContent: [{
            type: ViewChild,
            args: ["readIndex", { static: false }]
        }], cycleIndexContent: [{
            type: ViewChild,
            args: ["cycleIndex", { static: false }]
        }], metricsTypeContent: [{
            type: ViewChild,
            args: ["metricsType", { static: false }]
        }], baseIndexContent: [{
            type: ViewChild,
            args: ["baseIndex", { static: false }]
        }], channelIndexContent: [{
            type: ViewChild,
            args: ["channelIndex", { static: false }]
        }] });

class Util {
    static uniquifySelector(selector) {
        if (document.querySelectorAll(selector).length < 1) {
            return selector;
        }
        else {
            let i = 1;
            let newSelector;
            do {
                newSelector = selector + '-' + (i++);
            } while (document.querySelectorAll(newSelector).length > 0);
            return newSelector;
        }
    }
    static formatNumberWithCommas(x) {
        if (x.toString().indexOf('.') < 0)
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return x.toString();
    }
    static trimAndAddUnits(str) {
        const realStr = str.toString();
        if (this.endsWith(realStr, "000000000"))
            return realStr.replace(new RegExp('000000000$'), ' G');
        if (this.endsWith(realStr, "000000"))
            return realStr.replace(new RegExp('000000$'), ' M');
        if (this.endsWith(realStr, "000"))
            return realStr.replace(new RegExp('000$'), ' K');
        return realStr;
    }
    static trimAndAddUnitsV2(str) {
        const realStr = str.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,").replace(/,\d\d\d/g, ",000");
        if (this.endsWith(realStr, ",000,000,000"))
            return realStr.replace(new RegExp(',000,000,000$'), ' G');
        if (this.endsWith(realStr, ",000,000"))
            return realStr.replace(new RegExp(',000,000$'), ' M');
        if (this.endsWith(realStr, ",000"))
            return realStr.replace(new RegExp(',000$'), ' K');
        return realStr;
    }
    static formatThreeDigitPercision(str) {
        const realStr = str.toString();
        if (realStr.indexOf(".") < 0) {
            return str;
        }
        else {
            return parseFloat(realStr).toPrecision(3).replace("0.", ".");
        }
    }
    static endsWith(str, key) {
        const realStr = str.toString();
        return realStr.indexOf(key, realStr.length - key.length) !== -1;
    }
}

class Chart {
    constructor(responseData, customConfig) {
        this.legendItemHeight = 10;
        this.TOOLTIP_CLASS = "chart-tooltip";
        this.baseGradientDefinitions = [];
        this.config = {
            chartContainerSelector: null,
            fontSize: 10,
            height: 320,
            width: 480,
            svgHeight: '100%',
            svgWidth: '100%',
            margins: {
                top: 30,
                left: 80,
                right: 30,
                bottom: 50
            },
            strokeWidth: 1,
            preserveAspectRatio: 'xMidYMax',
            transitionSpeed: 250,
            contentType: '',
            labelBarValues: false,
            labelBarPostfix: '',
            color: '#98cc78',
            legend: true,
            svgLegend: false,
            xAxis: {
                orient: null,
                tickFormat: x => Util.trimAndAddUnits(x),
                tickSize: null,
                tickValues: null,
                ticks: 10,
                scale: null,
                tickSubdivide: 1
            },
            yAxis: {
                orient: 'left',
                tickFormat: y => Util.trimAndAddUnits(y),
                tickSize: null,
                tickValues: null,
                ticks: 8,
                scale: null,
                tickSubdivide: 1
            },
            scaleXMaxPadding: 0,
            scaleYMaxPadding: 0,
            scaleXMinPadding: 0,
            scaleYMinPadding: 0,
            scaleY: d3.scale.linear,
            scaleX: d3.scale.linear,
            gradientDefinitions: [],
            stepSize: 20
        };
        this.config = merge({}, this.config, customConfig);
        this.responseData = responseData;
        if (this.responseData.Series != null && this.responseData.Series.length > 0) {
            this.allSeries = this.responseData.Series;
            this.allData = this.flattenData();
            this.dataLookupIndex = this.allSeries[0].Fields;
        }
        this.svg = d3.select(this.config.chartContainerSelector).append('svg');
    }
    flattenData() {
        var flat = [];
        this.allSeries.forEach((series, index, allSeries) => {
            series.Data.forEach((d, j, data) => {
                flat.push(d);
            });
        });
        return flat;
    }
    refreshAxes() {
        this.svg.select('.axis-y').call(this.yAxis);
        this.svg.select('.axis-x').call(this.xAxis);
        if (this.responseData.Axes) {
            if (this.scaleX) {
                this.responseData.Axes.X.Min = this.scaleX.domain()[0];
                this.responseData.Axes.X.Max = this.scaleX.domain()[1];
            }
            if (this.scaleY) {
                this.responseData.Axes.Y.Min = this.scaleY.domain()[0];
                this.responseData.Axes.Y.Max = this.scaleY.domain()[1];
            }
        }
    }
    refreshChart() { } // implemented by subclasses
    update(updatedData, updatedSettings) {
        if (updatedData != null) {
            this.responseData = updatedData;
            // new data will reset scale domain for zoom
            this.initialScaleDomainX = null;
            this.initialScaleDomainY = null;
        }
        if (updatedSettings != null) {
            merge(this.config, updatedSettings);
        }
        this.svg.attr('viewBox', '0 0 ' + this.config.width + ' ' + this.config.height)
            .attr('width', this.config.svgWidth)
            .attr('height', this.config.svgHeight)
            .attr('preserveAspectRatio', this.config.preserveAspectRatio);
        this.updateScales();
        this.updateAxes();
        this.updateGradients();
    }
    updateScales() { } // implemented by subclasses
    // configures the axis by calling the corresponding function
    // for each key in the params hash
    configureAxis(axis, params) {
        for (var key in params) {
            var paramValue = params[key];
            if (paramValue === undefined || paramValue === null)
                continue;
            axis[key](paramValue);
        }
    }
    updateAxes() {
        this.updateClipPathIfExists();
        this.svg.selectAll('.axis-x, .axis-y').remove();
        this.yAxis = d3.svg.axis();
        this.yAxis.scale(this.scaleY);
        this.yAxis.tickSize(-(this.config.width - ((this.config.margins.left) + this.config.margins.right)), 3, 0);
        this.configureAxis(this.yAxis, this.config.yAxis);
        this.svg.append('g')
            .attr('class', 'axis-y')
            .attr('transform', 'translate(' + this.config.margins.left + ', 0)')
            .call(this.yAxis);
        this.xAxis = d3.svg.axis();
        this.xAxis.scale(this.scaleX);
        this.xAxis.orient('bottom');
        this.xAxis.tickSize(-(this.config.height - ((this.config.margins.top + this.config.margins.bottom))), 3, 0);
        this.configureAxis(this.xAxis, this.config.xAxis);
        var xRange = d3.max(this.scaleX.domain()) - d3.min(this.scaleX.domain());
        if (xRange < 10) {
            this.xAxis.ticks(xRange);
        }
        this.svg.append('g')
            .attr('class', 'axis-x')
            .attr('transform', 'translate(0, ' + (this.config.height - this.config.margins.bottom) + ')')
            .call(this.xAxis);
        this.svg.select('.axis-y')
            .append('text')
            .attr('class', 'label')
            .attr('y', 0)
            .attr('x', 0)
            .attr('text-anchor', 'middle')
            // translate to the center of the y-axis not the svg
            .attr('transform', 'rotate(-90 0 0), translate(' + (-(this.config.height - this.config.margins.top - this.config.margins.bottom) / 2 - this.config.margins.top) + ', ' + (-this.config.margins.left + 20) + ')')
            .text(this.responseData.Axes.Y.Title);
        this.svg.select('.axis-x')
            .append('text')
            .attr('class', 'label')
            .attr('y', 0)
            .attr('x', 0)
            .attr('text-anchor', 'middle') // so long x label will be properly centered
            // translate to the center of the x-axis not the svg
            .attr('transform', 'translate(' + ((this.config.width - this.config.margins.left - this.config.margins.right) / 2 + this.config.margins.left) + ', ' + (this.config.margins.bottom - 20) + ')')
            .text(this.responseData.Axes.X.Title);
        this.zoom = d3.behavior.zoom()
            .x(this.scaleX)
            .y(this.scaleY)
            .scaleExtent([1, 30])
            .on("zoom", () => {
            this.refreshAxes();
            this.refreshChart();
        });
        // enable zooming with clip path present
        if (this.config.chartClipPathIdSelector)
            this.svg.call(this.zoom);
    }
    updateClipPathIfExists() {
        if (this.config.chartClipPathIdSelector) {
            var clipPathId = this.config.chartClipPathIdSelector;
            this.svg.selectAll(clipPathId).remove();
            this.svg.append('clipPath')
                .attr('id', clipPathId.replace(/#/, ''))
                .append('rect')
                .attr('x', this.config.margins.left)
                .attr('y', this.config.margins.top)
                .attr('width', this.config.width - this.config.margins.right - this.config.margins.left)
                .attr('height', this.config.height - this.config.margins.bottom - this.config.margins.top);
        }
    }
    updateGradients() {
        var allGradients = this.baseGradientDefinitions;
        if ("gradientDefinitions" in this.config) {
            allGradients = allGradients.concat(this.config.gradientDefinitions);
        }
        if (allGradients.length == 0)
            return;
        var defs = this.svg.selectAll('defs.gradients').data([allGradients]);
        defs.enter().append('defs').attr('class', 'gradients');
        defs.exit().remove();
        var gradients = defs.selectAll('linearGradient').data((gradientDef) => gradientDef);
        gradients.enter().append('linearGradient');
        gradients.exit().remove();
        gradients
            .attr('id', (gradientDef) => gradientDef.id)
            .attr('x1', (gradientDef) => gradientDef.direction.toLowerCase() === Chart.GRADIENT_DIRECTION_HORIZONTAL ? '100%' : '0%')
            .attr('x2', '0%')
            .attr('y1', (gradientDef) => gradientDef.direction.toLowerCase() === Chart.GRADIENT_DIRECTION_VERTICAL ? '100%' : '0%')
            .attr('y2', '0%');
        var stops = gradients.selectAll('stop').data((gradientOption) => gradientOption.stops);
        stops.enter().append('stop');
        stops.exit().remove();
        stops
            .attr('offset', (stop) => stop.offset)
            .attr('style', (stop) => 'stop-color: ' + stop.color + '; stop-opacity: ' + stop.opacity + ';');
    }
    addAxisLabels() { }
    addLegend() {
        var that = this;
        var legendWidth = 50;
        var legendHeight = 50;
        this.legend = d3.select(this.config.chartContainerSelector)
            .append('div')
            .attr('class', 'legend');
        this.legend.append('ul');
        this.svgLegend = this.svg.append('g')
            .attr('class', 'legend')
            .attr('transform', 'translate(' + (this.config.width - this.config.margins.right + 5) + ')');
    }
    postRender() {
        if (this.config.fontSize != null) {
            // this.svg.selectAll('text').style('font-size', this.config.fontSize+"px");
            //this.svg.selectAll('text').attr('vector-effect', 'non-scaling-stroke');
        }
    }
    callTooltips(tooltipSelector) {
        if (tooltipSelector === void 0) {
            tooltipSelector = "." + this.TOOLTIP_CLASS;
        }
        if ("powerTip" in $.fn) {
            $(this.config.chartContainerSelector + " " + tooltipSelector).powerTip({
                smartPlacement: true,
                mouseOnToPopup: true,
                followMouse: true,
                placement: "n",
                popupId: 'ilmn-tooltip-pop'
            });
        }
    }
}
Chart.TOOLTIP_TEMPLATE = "<div class='bs-tooltip-content dark'><%= content %></div>";
Chart.GRADIENT_DIRECTION_HORIZONTAL = "h";
Chart.GRADIENT_DIRECTION_VERTICAL = "v";
Chart.MIN_LOG_INPUT = 1;

class HistogramChart extends Chart {
    // *****************************************************
    constructor(responseData, customConfig) {
        super(responseData, customConfig);
        if (this.config.contentType == '') {
            this.config.contentType = 'qscore';
        }
        var labelIndex = this.responseData.Series[0].Fields.label;
        if (!this.config.xAxis.tickFormat && this.responseData.Series[0].Data.length > 0 &&
            this.responseData.Series[0].Data[0][labelIndex]) {
            this.config.xAxis.tickFormat = (d) => this.formatXAxis(d);
        }
        this.gradientPfId = Util.uniquifySelector('#gradient-passing-filter');
        this.gradientBelowId = Util.uniquifySelector('#gradient-below-filter');
        this.addGradients(this.config.color);
        this.update(responseData);
    }
    refreshChart() {
        var histogram = this.svg.selectAll('g.histogram');
        var series = histogram.selectAll('g.series');
        var rect = series.selectAll('rect.bar');
        rect.attr('x', (d) => { var areBarsCentered = d[d.length - 1]; return this.scaleX(d[this.dataLookupIndex.x]) - (areBarsCentered ? this.scaleBarWidth(d[this.dataLookupIndex.width]) / 2 : 0); })
            .attr('width', (d) => { return d3.event.scale * this.scaleBarWidth(d[this.dataLookupIndex.width]); })
            .attr('y', (d) => { return this.scaleY(d[this.dataLookupIndex.height]); })
            .attr('height', (d) => { return Math.max(d3.event.scale * this.scaleBarHeight(d[this.dataLookupIndex.height]), 1); });
        if (this.config.labelBarValues) {
            var label = series.selectAll('text.bar-label');
            label.attr('x', (d) => {
                var areBarsCentered = d[d.length - 1];
                return this.scaleX(d[this.dataLookupIndex.x]) + (!areBarsCentered ? this.scaleBarWidth(d[this.dataLookupIndex.width]) / 2 : 0);
            })
                .attr('y', (d) => {
                return this.scaleY(d[this.dataLookupIndex.height]) - 3;
            });
        }
    }
    update(updatedData, updatedSettings) {
        super.update(updatedData, updatedSettings);
        if (this.legend == null)
            this.legend = d3.select(this.config.chartContainerSelector).append('div').attr('class', 'legend');
        this.dataLookupIndex = this.responseData.Series[0].Fields;
        var histogram = this.svg.selectAll('g.histogram').data([this.responseData]);
        histogram.enter().append('g')
            .attr('class', 'histogram')
            .attr('clip-path', 'url(' + this.config.chartClipPathIdSelector + ')');
        histogram.exit().remove();
        var series = histogram.selectAll('g.series').data((d, i) => {
            return d.Series;
        });
        series.enter().append('g')
            .attr('class', 'series');
        var setTitle = (d) => {
            // inline style for powertip
            var title = "";
            title += "<div style=\"padding: 5px; background: rgba(25, 25, 25, .8); color: white;\">";
            title += d[this.dataLookupIndex.label] || (this.responseData.Axes.X.Title + ": " + d[this.dataLookupIndex.x]);
            title += "<br />" + this.responseData.Axes.Y.Title + ": " + Util.formatNumberWithCommas(d[this.dataLookupIndex.height]);
            title += "</div>";
            return title;
        };
        var rect = series.selectAll('rect.bar').data((d) => {
            var areBarsCentered = false;
            if (d.Options)
                areBarsCentered = (d.Options.indexOf("Centered") > -1) ? true : false;
            for (var j = 0; j < d.Data.length; j++)
                d.Data[j].push(areBarsCentered);
            return d.Data;
        });
        var setRectFill = (d) => {
            if (this.config.contentType == 'qscore')
                return "url(" + (d[this.dataLookupIndex.x] >= HistogramChart.PASSING_FILTER_THRESHOLD ? this.gradientPfId : this.gradientBelowId) + ")";
            else {
                return "url(" + this.gradientPfId + ")";
            }
        };
        rect.enter().append('rect')
            .attr('class', 'bar')
            .attr('x', (d) => {
            var areBarsCentered = d[d.length - 1];
            return this.scaleX(d[this.dataLookupIndex.x]) - (areBarsCentered ? this.scaleBarWidth(d[this.dataLookupIndex.width]) / 2 : 0);
        })
            .attr('y', (d) => { return d3.max(this.scaleY.range()) - this.scaleBarHeight(d[this.dataLookupIndex.height]); })
            .attr('width', (d) => { return this.scaleBarWidth(d[this.dataLookupIndex.width]); })
            .attr('height', (d) => { return Math.max(this.scaleBarHeight(d[this.dataLookupIndex.height]), 1); });
        rect.attr('x', (d) => {
            var areBarsCentered = d[d.length - 1];
            return this.scaleX(d[this.dataLookupIndex.x]) - (areBarsCentered ? this.scaleBarWidth(d[this.dataLookupIndex.width]) / 2 : 0);
        })
            .attr('y', (d) => { return d3.max(this.scaleY.range()) - this.scaleBarHeight(d[this.dataLookupIndex.height]); })
            .attr('width', (d) => { return this.scaleBarWidth(d[this.dataLookupIndex.width]); })
            .attr('height', (d) => { return Math.max(this.scaleBarHeight(d[this.dataLookupIndex.height]), 1); })
            .transition().duration(this.config.transitionSpeed)
            .attr('fill', setRectFill)
            .style('fill', function (d) {
            var parentData = d3.select(this.parentNode).datum();
            if ("Accessors" in parentData && "fill" in parentData.Accessors) {
                return parentData.Accessors.fill(d);
            }
            else {
                return setRectFill(d);
            }
        })
            .attr('data-powertip', (d, i) => {
            // set data attribute through jquery since jquery caches the data attribute
            // updating d3 data attribute alone won't update the changes in the tooltip :(
            $(this.config.chartContainerSelector + ' .bar:eq(' + i + ')').data('powertip', setTitle(d));
            this.callTooltips('.bar:eq(' + i + ')');
        });
        rect.exit().remove();
        if (this.config.labelBarValues) {
            var label = series.selectAll('text.bar-label').data((d) => {
                var areBarsCentered = false;
                if (d.Options)
                    areBarsCentered = (d.Options.indexOf("Centered") > -1) ? true : false;
                for (var j = 0; j < d.Data.length; j++)
                    d.Data[j].push(areBarsCentered);
                return d.Data;
            });
            var postFix = this.config.labelBarPostfix || '';
            label.enter().append('text')
                .attr('class', 'bar-label')
                .attr('x', (d) => { var areBarsCentered = d[d.length - 1]; return this.scaleX(d[this.dataLookupIndex.x]) + (!areBarsCentered ? this.scaleBarWidth(d[this.dataLookupIndex.width]) / 2 : 0); })
                .attr('y', (d) => { return d3.max(this.scaleY.range()) - this.scaleBarHeight(d[this.dataLookupIndex.height]) - 3; })
                .text((d) => { return Util.formatThreeDigitPercision(d[this.dataLookupIndex.height]) + postFix; })
                .style("text-anchor", "middle");
            label.attr('x', (d) => { var areBarsCentered = d[d.length - 1]; return this.scaleX(d[this.dataLookupIndex.x]) + (!areBarsCentered ? this.scaleBarWidth(d[this.dataLookupIndex.width]) / 2 : 0); })
                .attr('y', (d) => { return d3.max(this.scaleY.range()) - this.scaleBarHeight(d[this.dataLookupIndex.height]) - 3; })
                .text((d) => { return Util.formatThreeDigitPercision(d[this.dataLookupIndex.height]) + postFix; })
                .style("text-anchor", "middle")
                .transition().duration(this.config.transitionSpeed);
            label.exit().remove();
        }
        if (this.config.contentType == 'qscore')
            this.updateLegend();
        else if (this.legend) {
            this.legend.remove();
        }
    }
    addGradients(color = '#98cc78') {
        var gradientPassingFilter = this.svg.append('defs')
            .append('linearGradient')
            .attr('id', this.gradientPfId.replace('#', ''))
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('y1', '100%')
            .attr('y2', '0%');
        gradientPassingFilter.append('stop')
            .attr('offset', '0%')
            .attr('style', 'stop-color: ' + color + '; stop-opacity: .5;');
        gradientPassingFilter.append('stop')
            .attr('offset', '50%')
            .attr('style', 'stop-color: ' + color + '; stop-opacity: 1');
        var gradientBelowFilter = this.svg.append('defs')
            .append('linearGradient')
            .attr('id', this.gradientBelowId.replace('#', ''))
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('y1', '100%')
            .attr('y2', '0%');
        gradientBelowFilter.append('stop')
            .attr('offset', '0%')
            .attr('style', 'stop-color: #2c53a1; stop-opacity: .5;');
        gradientBelowFilter.append('stop')
            .attr('offset', '50%')
            .attr('style', 'stop-color: #2c53a1; stop-opacity: 1');
    }
    updateLegend() {
        var legendList = this.legend.selectAll('ul').data([this.responseData]);
        legendList.enter().append('ul')
            .append('li')
            .text('% >= Q30')
            .style('color', 'green')
            .style('font-weight', 'bold');
        legendList.exit().remove();
        var sumAboveQ30 = 0;
        var sumAll = 0;
        var liSize = legendList.selectAll('li.size').data((d) => {
            for (var i = 0; i < this.responseData.Series.length; i++) {
                var series = this.responseData.Series[i];
                for (var k = 0; k < series.Data.length; k++) {
                    var height = series.Data[k][this.dataLookupIndex.height];
                    var x = series.Data[k][this.dataLookupIndex.x];
                    sumAll += height;
                    if (x >= 30) {
                        sumAboveQ30 += height;
                    }
                }
            }
            var isUnitsInBillions = this.responseData.Axes.Y.Title.toLowerCase().indexOf("billion") !== -1;
            var sumMultiplied = parseFloat((sumAboveQ30 / 100).toFixed(1)) ? parseFloat(sumAboveQ30.toFixed(1)) + (isUnitsInBillions ? "G" : "M") : parseFloat((sumAboveQ30 / 1000).toFixed(1)) + (isUnitsInBillions ? "T" : "G");
            return [sumMultiplied];
        });
        liSize.enter().append('li')
            .attr('class', 'size')
            .text((size) => { return size; });
        liSize.exit().remove();
        liSize
            .attr('class', 'size')
            .text((size) => { return size; });
        var percentAboveQ30 = sumAboveQ30 / sumAll;
        var liSumAboveQ30 = legendList.selectAll('li.sum').data([(percentAboveQ30 * 100).toFixed(1) + '%']);
        liSumAboveQ30.enter().append('li')
            .attr('class', 'sum')
            .text((sum) => { return sum; });
        liSumAboveQ30.exit().remove();
        liSumAboveQ30
            .attr('class', 'sum')
            .text((sum) => { return sum; });
    }
    formatXAxis(d) {
        var labelIndex = this.responseData.Series[0].Fields.label;
        var data = this.responseData.Series[0].Data[d];
        return data ? this.trim(data[labelIndex], 10) : null;
    }
    trim(str, cnt) {
        str = str || '';
        return str.substring(0, Math.min(cnt, str.length));
    }
    updateScales() {
        var that = this;
        var xAxisMin = this.responseData.Axes.X.Min;
        var xAxisMax = this.responseData.Axes.X.Max;
        var yAxisMin = 0; // lock min axis to 0. Histogram doesn't go negative.
        var yAxisMax = this.responseData.Axes.Y.Max;
        this.scaleX = d3.scale.linear();
        this.scaleX.domain([xAxisMin + this.config.scaleXMinPadding, xAxisMax + this.config.scaleXMaxPadding]);
        this.scaleX.range([that.config.margins.left, that.config.width - that.config.margins.right]);
        this.scaleY = d3.scale.linear();
        this.scaleY.domain([yAxisMin, yAxisMax]);
        this.scaleY.range([that.config.height - that.config.margins.bottom, that.config.margins.top]);
        this.scaleBarWidth = d3.scale.linear();
        this.scaleBarWidth.domain([0, Math.abs((xAxisMax + this.config.scaleXMaxPadding) - (xAxisMin + this.config.scaleXMinPadding))]);
        this.scaleBarWidth.range([0, that.config.width - (that.config.margins.left + that.config.margins.right)]);
        this.scaleBarHeight = d3.scale.linear();
        this.scaleBarHeight.domain([yAxisMin, yAxisMax]);
        this.scaleBarHeight.range([0, that.config.height - (that.config.margins.top + that.config.margins.bottom)]);
        this.setInitialDomainScaleForZoom();
    }
    setInitialDomainScaleForZoom() {
        // reset bar width and height for zoom
        if (this.initialScaleDomainX === null && this.initialScaleDomainY === null) {
            this.initialScaleBarWidth = null;
            this.initialScaleBarHeight = null;
        }
        // resets the domain scale for zoom (level x1) when chart resizes or when fixed scale option is selected
        if (!this.initialScaleDomainX) {
            this.initialScaleDomainX = this.scaleX.domain();
        }
        else {
            this.scaleX.domain(this.initialScaleDomainX);
        }
        if (!this.initialScaleDomainY) {
            this.initialScaleDomainY = this.scaleY.domain();
        }
        else {
            this.scaleY.domain(this.initialScaleDomainY);
        }
        if (!this.initialScaleBarWidth) {
            this.initialScaleBarWidth = this.scaleBarWidth.domain();
        }
        else {
            this.scaleBarWidth.domain(this.initialScaleBarWidth);
        }
        if (!this.initialScaleBarHeight) {
            this.initialScaleBarHeight = this.scaleBarHeight.domain();
        }
        else {
            this.scaleBarHeight.domain(this.initialScaleBarHeight);
        }
    }
}
HistogramChart.CHART_NAME = "Histogram";
HistogramChart.PASSING_FILTER_THRESHOLD = 30;

const _c0$Y = [1, "card-chart__svg-container", 3, "hidden", "id"];
const _c1$X = [4, "ngIf"];
const _c2$S = ["type", "bar-chart"];
const _c3$P = {};
function HistogramChartComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-skeleton", _c2$S);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("@fadeIn", _c3$P);
} }
class HistogramChartComponent {
    constructor(chartsService) {
        this.chartsService = chartsService;
        this.hideOptions = false;
        this.isLoading = false;
    }
    get containerWidth() {
        return this._containerWidth;
    }
    set containerWidth(containerWidth) {
        const originalValue = this._containerWidth;
        this._containerWidth = containerWidth;
        if (this._containerWidth != null && originalValue != containerWidth) {
            this.onUpdateChartData(this.containerWidth);
        }
    }
    get fixScale() {
        return this._fixScale;
    }
    /*
    bellow will get called when ever the fix Scale value is
    passed in by the parent component
    */
    set fixScaleSeleted(fixScaleSeleted) {
        this.fixScaleAxes = this.currentChartAxes;
        this._fixScale = fixScaleSeleted;
        if (!this._fixScale) {
            this.fixScaleAxes = null;
        }
    }
    get chartData() {
        return this._chartData;
    }
    /*
    bellow will get called when ever the Chart Response is
    passed in by the parent component
    */
    set chartData(data) {
        this._chartData = data;
        if (this._chartData != null) {
            this.onloadChartData();
        }
    }
    ngOnInit() { }
    createChart() {
        const chartConfig = {
            chartContainerSelector: `#${this.chartId}`,
            chartClipPathIdSelector: `#${this.chartId}-clip-path`,
            preserveAspectRatio: "none",
            transitionSpeed: 250,
            width: this.containerWidth,
            height: this.containerHeight,
            legend: false,
            contentType: this.contentType,
            xAxis: {
                tickFormat: d3.format("d"),
            },
            yAxis: {
                tickFormat: d3.format(".2f"),
            },
        };
        // create (d3) chart
        this.chart = new HistogramChart(this._chartData, chartConfig);
    }
    //Expand chart subpane
    onUpdateChartData(containerWidth) {
        if (this.chart) {
            this.chartsService.updateChart(this.chart, containerWidth, this.containerHeight, this._chartData, this.hideOptions);
        }
    }
    onloadChartData() {
        const chartData = this._chartData;
        const chartExist = !!this.chart;
        this.currentChartAxes = chartData.Axes;
        chartData.Axes = this.fixScaleAxes
            ? this.fixScaleAxes
            : this.currentChartAxes;
        if (chartExist) {
            this.chartsService.updateChart(this.chart, this.containerWidth, this.containerHeight, chartData, this.hideOptions);
        }
        else {
            this.createChart();
        }
    }
}
/** @nocollapse */ HistogramChartComponent.ngComponentDef = ɵɵdefineComponent({ type: HistogramChartComponent, selectors: [["lib-histogram-chart"]], factory: function HistogramChartComponent_Factory(t) { return new (t || HistogramChartComponent)(ɵɵdirectiveInject(ChartsService)); }, inputs: { containerHeight: "containerHeight", hideOptions: "hideOptions", contentType: "contentType", chartId: "chartId", isLoading: "isLoading", containerWidth: "containerWidth", fixScaleSeleted: ["fixScale", "fixScaleSeleted"], chartData: "chartData" }, consts: 2, vars: 3, template: function HistogramChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "div", _c0$Y);
        ɵɵtemplate(1, HistogramChartComponent_div_1_Template, 2, 1, "div", _c1$X);
    } if (rf & 2) {
        ɵɵpropertyInterpolate("id", ctx.chartId);
        ɵɵproperty("hidden", ctx.isLoading);
        ɵɵselect(1);
        ɵɵproperty("ngIf", ctx.isLoading);
    } }, directives: [NgIf, SkeletonComponent], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]     .chart-container{padding:0}[_nghost-%COMP%]     .chart-container.tall{height:530px}[_nghost-%COMP%]     .svg-chart-container{width:auto;height:600px}[_nghost-%COMP%]     .svg-chart-container-vertical{height:600px;width:350px}[_nghost-%COMP%]     .flowcell-chart-container .loading{width:auto;height:auto}[_nghost-%COMP%]     rect{-webkit-transition:opacity .25s;transition:opacity .25s;opacity:1}[_nghost-%COMP%]     .axis line{fill:none;stroke:#666;stroke-width:1}[_nghost-%COMP%]     .axis text{font-family:sans-serif;font-size:11px}[_nghost-%COMP%]     .axis .domain{fill:none;stroke:#666}[_nghost-%COMP%]     .heat-axis g:last-of-type text{content:\"% of Max\";font-weight:700}[_nghost-%COMP%]     line.center{fill:#fff;stroke:#4a4a4a;stroke-width:1}[_nghost-%COMP%]     line.p50{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ul{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ll{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     rect.box{stroke:#4a4a4a;stroke-width:.33px;cursor:pointer;fill:rgba(132,205,236,.75)}[_nghost-%COMP%]     rect.bar{stroke:#fff;stroke-width:.33px;opacity:.9}[_nghost-%COMP%]     rect.bar:hover{opacity:1;stroke:#000}[_nghost-%COMP%]     rect.lane-cell{stroke:#000;stroke-width:.5}[_nghost-%COMP%]     rect.lane-cell:hover{stroke-width:2}[_nghost-%COMP%]     rect.lane-cell.no-data{opacity:.25}[_nghost-%COMP%]     text{font-family:Helvetica,Arial,sans-serif;fill:#666}[_nghost-%COMP%]     g.black circle{fill:#fff;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.black path{stroke:#333;stroke-width:1}[_nghost-%COMP%]     g.red circle{fill:red;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.red path{stroke:red;stroke-width:1}[_nghost-%COMP%]     g.green circle{fill:green;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.green path{stroke:green;stroke-width:1}[_nghost-%COMP%]     g.blue circle{fill:#00f;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.blue path{stroke:#00f;stroke-width:1}[_nghost-%COMP%]     .linechart path{cursor:pointer;opacity:.66}[_nghost-%COMP%]     .linechart path:hover{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .linechart path.highlighted{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .legend{position:absolute;top:10px;right:15px;background-color:rgba(255,255,255,.75);border:1px solid #efefef;padding:3px;border-radius:10px;min-width:75px;font-size:10px;-webkit-transition:opacity .25s linear;transition:opacity .25s linear}[_nghost-%COMP%]     .legend ul{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     .legend li{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     ul.bases li{float:left;width:14px;height:14px;line-height:12px;text-align:center;list-style:none;margin:0 0 0 10px;padding-left:0;font-weight:700;font-family:monospace}[_nghost-%COMP%]     ul.bases li.red{color:red}[_nghost-%COMP%]     ul.bases li.red:hover{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.red.highlighted{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.green{color:green}[_nghost-%COMP%]     ul.bases li.green:hover{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.green.highlighted{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.black{color:#000}[_nghost-%COMP%]     ul.bases li.black:hover{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.black.highlighted{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.blue{color:#00f}[_nghost-%COMP%]     ul.bases li.blue:hover{background-color:#00f;color:#fff}[_nghost-%COMP%]     ul.bases li.blue.highlighted{background-color:#00f;color:#fff}[_nghost-%COMP%]     .tick text{font-size:10px}[_nghost-%COMP%]     text.label{font-size:13px;color:#333}[_nghost-%COMP%]     .tick{stroke:#ccc;stroke-width:.25}[_nghost-%COMP%]     .tick line{stroke:#ccc;stroke-width:.5}[_nghost-%COMP%]     g.axis-x>.tick.major text{font-size:7px}[_nghost-%COMP%]     .bar-label{font-size:9px}[_nghost-%COMP%]     .loading-icon:before{content:url(/public/images/loading-icon.gif);vertical-align:middle}[_nghost-%COMP%]     .chart-image .loading-message{position:absolute;top:50%;left:50%;margin-top:-10px;margin-left:-50px;width:100px;text-align:center;background:rgba(255,255,255,.9);border:1px solid #ccc;box-shadow:0 0 10px #999;padding:3px 6px;border-radius:4px;font-size:10px}[_nghost-%COMP%]     .charts-thumb{height:245px;width:auto;position:relative}[_nghost-%COMP%]     .widget.maximized{position:absolute;left:0;top:0;z-index:1}@media all and (max-width:960px){[_nghost-%COMP%]     .chart-controls select{width:65px}[_nghost-%COMP%]     .chart-controls label{width:65px}[_nghost-%COMP%]     .chart-container{margin-left:75px}}[_nghost-%COMP%]     #ilmn-tooltip-pop{background-color:#fff;box-shadow:0 .2rem 1.4rem .2rem rgba(0,0,0,.2);color:#464646;cursor:default;display:none;font-size:1.3rem;margin-bottom:-.7rem;min-width:300px;padding:1.5rem;position:absolute;text-align:left;z-index:2147483647}[_nghost-%COMP%]     #ilmn-tooltip-pop ::before{content:\"\";position:absolute}[_nghost-%COMP%]     #ilmn-tooltip-pop .bs-tooltip-heading{max-width:60rem;word-break:break-all}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-content{max-width:60rem;max-height:275px;overflow:auto;padding-right:1rem}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table{table-layout:fixed}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table td.result{overflow:hidden;text-overflow:ellipsis;white-space:pre}[_nghost-%COMP%]     #ilmn-tooltip-pop.biosample-search-fastq-tooltip .tooltip-content{max-width:inherit}", "[_nghost-%COMP%]{display:block;position:relative}.card-chart__svg-container[_ngcontent-%COMP%]{left:-.8rem;position:relative}"], data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] } });
/*@__PURE__*/ ɵsetClassMetadata(HistogramChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-histogram-chart",
                templateUrl: "./histogram-chart.component.html",
                styleUrls: [
                    "../../../../charts/basespace.charts.scss",
                    "./histogram-chart.component.scss",
                ],
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: ChartsService }]; }, { containerHeight: [{
            type: Input
        }], hideOptions: [{
            type: Input
        }], contentType: [{
            type: Input
        }], chartId: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], containerWidth: [{
            type: Input,
            args: ["containerWidth"]
        }], fixScaleSeleted: [{
            type: Input,
            args: ["fixScale"]
        }], chartData: [{
            type: Input,
            args: ["chartData"]
        }] });

const _c0$Z = ["qScoreDistributionChartDataLoadingSpinner"];
const _c1$Y = [1, "card-chart"];
const _c2$T = [4, "ngIf"];
const _c3$Q = [3, "plotOptions", "chartId", "disabled", "loadChartData", "fixScaleValueChanged"];
const _c4$N = [3, "containerHeight", "containerWidth", "hideOptions", "contentType", "chartData", "chartId", "fixScale", "isLoading"];
function QScoreDistributionChartComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r965 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-chart-options", _c3$Q);
    ɵɵlistener("loadChartData", function QScoreDistributionChartComponent_ng_container_1_Template_lib_chart_options_loadChartData_1_listener($event) { ɵɵrestoreView(_r965); const ctx_r964 = ɵɵnextContext(); return ctx_r964.onloadChartData($event); });
    ɵɵlistener("fixScaleValueChanged", function QScoreDistributionChartComponent_ng_container_1_Template_lib_chart_options_fixScaleValueChanged_1_listener($event) { ɵɵrestoreView(_r965); const ctx_r966 = ɵɵnextContext(); return ctx_r966.onFixScaleChanged($event); });
    ɵɵelementEnd();
    ɵɵelement(2, "lib-histogram-chart", _c4$N);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r963 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("plotOptions", ctx_r963.plotOptions)("chartId", ctx_r963.chartId)("disabled", ctx_r963.chartDataLoading);
    ɵɵselect(2);
    ɵɵproperty("containerHeight", ctx_r963.containerHeight)("containerWidth", ctx_r963.containerWidth)("hideOptions", ctx_r963.hideOptions)("contentType", ctx_r963.contentType)("chartData", ctx_r963.chartData)("chartId", ctx_r963.chartId)("fixScale", ctx_r963.fixScale)("isLoading", ctx_r963.chartDataLoading);
} }
class QScoreDistributionChartComponent {
    constructor() {
        this.contentType = "qscore";
        this.chartId = "qscore-histogram";
        this.subs = new SubSink();
        this.activeWrapper = false;
        this.hideOptions = false;
        this.chartData = null;
        this.plotOptions = null;
        this.fixScale = false;
        this.isLoadingOptions = false;
        this.loadChartData = new EventEmitter();
    }
    get chartDataLoading() {
        return this._chartDataLoading;
    }
    set chartDataLoading(data) {
        this._chartDataLoading = data;
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    onloadChartData(selectedFormInputValues) {
        this.loadChartData.emit(selectedFormInputValues);
    }
    onFixScaleChanged(selectedFormInputValues) {
        this.fixScale = selectedFormInputValues.FixScale;
        this.onloadChartData(selectedFormInputValues);
    }
}
/** @nocollapse */ QScoreDistributionChartComponent.ngComponentDef = ɵɵdefineComponent({ type: QScoreDistributionChartComponent, selectors: [["lib-qscore-distribution-chart"]], factory: function QScoreDistributionChartComponent_Factory(t) { return new (t || QScoreDistributionChartComponent)(); }, viewQuery: function QScoreDistributionChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$Z, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.qScoreDistributionChartDataLoadingSpinner = _t.first);
    } }, inputs: { hideOptions: "hideOptions", containerWidth: "containerWidth", containerHeight: "containerHeight", chartData: "chartData", plotOptions: "plotOptions", fixScale: "fixScale", isLoadingOptions: "isLoadingOptions", chartDataLoading: ["isLoadingChart", "chartDataLoading"] }, outputs: { loadChartData: "loadChartData" }, consts: 2, vars: 1, template: function QScoreDistributionChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$Y);
        ɵɵtemplate(1, QScoreDistributionChartComponent_ng_container_1_Template, 3, 11, "ng-container", _c2$T);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.hideOptions && !ctx.isLoadingOptions);
    } }, directives: [NgIf, ChartOptionsComponent, HistogramChartComponent], styles: ["[_nghost-%COMP%]{display:block;min-height:30rem;position:relative}.card-chart[_ngcontent-%COMP%]{margin-top:2rem;min-height:30rem;position:relative}.card-chart__loader[_ngcontent-%COMP%]{position:absolute;min-width:100%;top:0;bottom:0}.card-chart__svg-container[_ngcontent-%COMP%]{left:-.8rem;position:relative}"] });
/*@__PURE__*/ ɵsetClassMetadata(QScoreDistributionChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-qscore-distribution-chart',
                templateUrl: './qscore-distribution-chart.component.html',
                styleUrls: ['./qscore-distribution-chart.component.scss']
            }]
    }], function () { return []; }, { hideOptions: [{
            type: Input
        }], containerWidth: [{
            type: Input
        }], containerHeight: [{
            type: Input
        }], chartData: [{
            type: Input
        }], plotOptions: [{
            type: Input
        }], fixScale: [{
            type: Input
        }], isLoadingOptions: [{
            type: Input
        }], chartDataLoading: [{
            type: Input,
            args: ["isLoadingChart"]
        }], loadChartData: [{
            type: Output
        }], qScoreDistributionChartDataLoadingSpinner: [{
            type: ViewChild,
            args: ['qScoreDistributionChartDataLoadingSpinner', { static: true }]
        }] });

const _c0$_ = ["sampleQCChartLoadingSpinner"];
const _c1$Z = [1, "card-chart"];
const _c2$U = [3, "containerHeight", "containerWidth", "hideOptions", "contentType", "chartData", "chartId", "isLoading"];
class SampleQCChartComponent {
    constructor(chartsService) {
        this.chartsService = chartsService;
        this.subs = new SubSink();
        this.contentType = "sampleqc";
        this.chartId = "sampleqc-histogram";
        this.activeWrapper = false;
        this.hideOptions = true;
        this.chartData = null;
        this.formControlInputValues = this.chartsService.buildNewFormControlObj();
    }
    get chartDataLoading() {
        return this._chartDataLoading;
    }
    set chartDataLoading(data) {
        this._chartDataLoading = data;
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
/** @nocollapse */ SampleQCChartComponent.ngComponentDef = ɵɵdefineComponent({ type: SampleQCChartComponent, selectors: [["lib-sampleQC-chart"]], factory: function SampleQCChartComponent_Factory(t) { return new (t || SampleQCChartComponent)(ɵɵdirectiveInject(ChartsService)); }, viewQuery: function SampleQCChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$_, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.sampleQCChartLoadingSpinner = _t.first);
    } }, inputs: { hideOptions: "hideOptions", containerWidth: "containerWidth", containerHeight: "containerHeight", chartData: "chartData", chartDataLoading: ["isLoadingChart", "chartDataLoading"] }, consts: 2, vars: 7, template: function SampleQCChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$Z);
        ɵɵelement(1, "lib-histogram-chart", _c2$U);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("containerHeight", ctx.containerHeight)("containerWidth", ctx.containerWidth)("hideOptions", ctx.hideOptions)("contentType", ctx.contentType)("chartData", ctx.chartData)("chartId", ctx.chartId)("isLoading", ctx.chartDataLoading);
    } }, directives: [HistogramChartComponent], styles: ["[_nghost-%COMP%]{display:block;min-height:30rem;position:relative}.card-chart[_ngcontent-%COMP%]{margin-top:2rem;min-height:30rem;position:relative}.card-chart__loader[_ngcontent-%COMP%]{position:absolute;min-width:100%;top:0;bottom:0}.card-chart__svg-container[_ngcontent-%COMP%]{left:-.8rem;position:relative}"] });
/*@__PURE__*/ ɵsetClassMetadata(SampleQCChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-sampleQC-chart',
                templateUrl: './sampleQC-chart.component.html',
                styleUrls: ['./sampleQC-chart.component.scss']
            }]
    }], function () { return [{ type: ChartsService }]; }, { hideOptions: [{
            type: Input
        }], containerWidth: [{
            type: Input
        }], containerHeight: [{
            type: Input
        }], chartData: [{
            type: Input
        }], chartDataLoading: [{
            type: Input,
            args: ["isLoadingChart"]
        }], sampleQCChartLoadingSpinner: [{
            type: ViewChild,
            args: ['sampleQCChartLoadingSpinner', { static: true }]
        }] });

class FlowcellChart extends Chart {
    // *****************************************************
    constructor(responseData, customConfig) {
        super(responseData, merge({}, {
            margins: { right: 60, left: 15, top: 15, bottom: 15 }
        }, customConfig));
        this.showDefaultAxes = false;
        //this.initScales();
        //this.addGradients();
        //this.addAxes();
        this.update(responseData);
        //this.postRender();
    }
    update(updatedData, updatedSettings) {
        super.update(updatedData, updatedSettings);
        // gradients
        if (this.defs == null) {
            this.defs = this.svg.append('defs');
            var gradient = this.defs.append('linearGradient')
                .attr('id', 'flowcell-color-scale-gradient')
                .attr('x1', '0%')
                .attr('x2', '0%')
                .attr('y1', '100%')
                .attr('y2', '0%');
            gradient.selectAll('stop').data(this.colorScaleDomain, (d) => {
                return d;
            }).enter()
                .append('stop')
                .attr('offset', function (d, i) {
                var percent = "";
                percent = (d * 100) + "%";
                return percent;
            })
                .attr('style', (d, i) => {
                var color = this.colorScaleRange[i];
                return "stop-color:" + color + ";stop-opacity: 1;";
            });
        }
        var g = this.svg.selectAll('g.flowcell').data([this.responseData]);
        g.enter().append('g')
            .attr('class', 'flowcell')
            .attr('transform', 'translate(' + (this.config.margins.right) + ', 0)');
        g.exit().remove();
        // lanes
        var lanes = g.selectAll('g.lane').data((d) => {
            return d.TileValuesByLane;
        });
        lanes.enter().append('g')
            .attr('class', 'lane');
        lanes.exit().remove();
        var setRectX = (laneIndex, index) => {
            var positionWithinLane = Math.floor(index / this.responseData.RowCount) * this.laneColumnWidth;
            var rectX = (positionWithinLane + ((laneIndex) * this.laneWidth + (laneIndex * this.laneHorizontalSpacing)));
            return rectX + this.config.margins.left;
        };
        var setRectY = (index) => {
            var rectY = (index == 0) ? 0 : (index % this.responseData.RowCount) * this.laneHeight;
            return rectY + this.config.margins.top;
        };
        // fill color
        var setRectFill = (d, i) => {
            var fillColor;
            if (d[1] == -1)
                fillColor = "#666";
            else
                fillColor = this.colorScale(d[1]);
            return fillColor;
        };
        var setRectTitle = (d, i) => {
            var data = d[1] != -1 ? d[1] : "No Data";
            var title = "";
            var lane = d[0];
            var tileNameByLane = this.responseData.TileNamesByLane[lane][i];
            var tileName = tileNameByLane ? tileNameByLane : "";
            title += "<div style=\"padding: 5px; background: rgba(25, 25, 25, .8); color: white;\">";
            title += "\n" + "Lane: " + (lane + 1) + " Tile: " + tileName + " " + data;
            title += "</div>";
            return title;
        };
        var setRectClass = (d, i) => {
            var className = "lane-cell " + "lane-" + (d[0] + 1) + "-cell-" + i;
            if (d[1] == -1)
                className = className + " no-data " + "lane-" + (d[0] + 1) + "-cell-" + i;
            return className;
        };
        var cells = lanes.selectAll('rect.lane-cell').data((d, index) => {
            var arr = [];
            for (var i = 0; i < d.length; i++) {
                // check against TileNames vs TileValue since data comes back as 0 
                // even when cell does exist. Checking against title value ensures we know
                // which cell exists
                var titleName = this.responseData.TileNamesByLane[index][i];
                arr.push([index, titleName !== null ? d[i] : -1]);
            }
            return arr;
        });
        cells.enter().append('rect')
            .attr('class', setRectClass)
            .attr('rel', 'tooltip')
            .attr('width', this.laneColumnWidth)
            .attr('height', this.laneHeight)
            .attr('fill', setRectFill)
            .attr('rel', 'tooltip')
            .attr('x', (d, i) => { return setRectX(d[0], i); })
            .attr('y', (d, i) => { return setRectY(i); });
        cells.exit().remove();
        cells
            .attr('class', setRectClass)
            .transition().duration(this.config.transitionSpeed)
            .attr('width', this.laneColumnWidth)
            .attr('height', this.laneHeight)
            .attr('fill', setRectFill)
            .attr('data-powertip', (d, i) => {
            var lane = d[0] + 1;
            var laneClassName = '.lane-' + lane + '-cell-' + i;
            // set data attribute through jquery since jquery caches the data attribute
            // updating d3 data attribute alone won't update the changes in the toolip :(
            $(this.config.chartContainerSelector + ' ' + laneClassName).data('powertip', setRectTitle(d, i));
            this.callTooltips(laneClassName);
        })
            .attr('x', (d, i) => { return setRectX(d[0], i); })
            .attr('y', (d, i) => { return setRectY(i); });
    }
    addGradients() {
        var gradient = this.svg.append('defs')
            .append('linearGradient')
            .attr('id', 'flowcell-color-scale-gradient')
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('y1', '100%')
            .attr('y2', '0%');
        gradient.selectAll('stop').data(this.colorScaleDomain, (d) => {
            return d;
        }).enter()
            .append('stop')
            .attr('offset', function (d, i) {
            var percent = "";
            percent = (d * 100) + "%";
            return percent;
        })
            .attr('style', (d, i) => {
            var color = this.colorScaleRange[i];
            return "stop-color:" + color + ";stop-opacity: 1;";
        });
    }
    updateAxes() {
        this.svg.selectAll('.axis').remove();
        this.yAxis = d3.svg.axis();
        this.yAxis.scale(this.scaleY);
        this.yAxis.orient('right');
        this.yAxis.tickSize(0, 0, 0);
        this.yAxis.tickSubdivide(1);
        var axisWidth = Math.min(30, this.config.width / 15);
        var axisGroup = this.svg
            .append('g')
            .attr('transform', 'translate(' + FlowcellChart.AxisGroup_Translate_Position + ', 0)')
            .attr('class', 'axis');
        this.svg.select('flowcell').attr('transform', 'translate(' + (this.config.width - FlowcellChart.AxisGroup_Translate_Position) + ', 0)');
        var setAxisFill = (d) => {
            return 'url(#flowcell-color-scale-gradient)';
        };
        axisGroup.insert('rect', ':first-child')
            .attr('x', -axisWidth)
            .attr('y', this.config.margins.top)
            .attr('width', axisWidth)
            .attr('height', (this.config.height - (this.config.margins.top + this.config.margins.bottom)))
            .attr('fill', setAxisFill)
            .attr('fill-opacity', '1');
        axisGroup.call(this.yAxis);
    }
    axisExists(axis) {
        if (!axis || (axis.Min == 0 && axis.Max == 0))
            return false;
        else
            return true;
    }
    updateScales() {
        var that = this;
        this.colorScaleDomain = [0, 0.33, 0.66, 1];
        this.colorScaleRange = ["blue", "cyan", "yellow", "orange"];
        this.laneHorizontalSpacing = this.config.width * .015;
        this.laneWidth = ((this.config.width - (this.config.margins.left + this.config.margins.right)) / this.responseData.LaneCount) - this.laneHorizontalSpacing;
        this.laneColumnWidth = this.laneWidth / this.responseData.ColumnCount;
        this.laneHeight = ((this.config.height - (this.config.margins.top + this.config.margins.bottom)) / this.responseData.RowCount);
        var domainMin = this.responseData.Axis.Min;
        var domainMax = this.responseData.Axis.Max;
        // temporary fix since server sometimes sets Min = Max
        if (domainMin == domainMax) {
            ++domainMax;
            --domainMin;
        }
        this.colorScale = d3.scale.linear().domain([domainMin, domainMax]);
        this.colorScale.domain(this.colorScaleDomain.map(this.colorScale.invert));
        this.colorScale.range(this.colorScaleRange);
        this.scaleY = d3.scale.linear();
        this.scaleY.domain([domainMin, domainMax]);
        this.scaleY.range([this.config.height - this.config.margins.bottom, 0 + this.config.margins.top]);
    }
}
FlowcellChart.CHART_NAME = "Flowcell";
FlowcellChart.AxisGroup_Translate_Position = 20;

const _c0$$ = ["flowCellChartDataLoadingSpinner"];
const _c1$_ = [1, "card-chart"];
const _c2$V = [4, "ngIf"];
const _c3$R = [3, "plotOptions", "chartId", "disabled", "loadChartData", "fixScaleValueChanged"];
const _c4$O = ["id", "flowcell-chart", 1, "card-chart__svg-container", 3, "hidden"];
const _c5$K = ["type", "bar-chart"];
const _c6$I = {};
function FlowCellChartComponent_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-skeleton", _c5$K);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("@fadeIn", _c6$I);
} }
function FlowCellChartComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r970 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-chart-options", _c3$R);
    ɵɵlistener("loadChartData", function FlowCellChartComponent_ng_container_1_Template_lib_chart_options_loadChartData_1_listener($event) { ɵɵrestoreView(_r970); const ctx_r969 = ɵɵnextContext(); return ctx_r969.onloadChartData($event); });
    ɵɵlistener("fixScaleValueChanged", function FlowCellChartComponent_ng_container_1_Template_lib_chart_options_fixScaleValueChanged_1_listener($event) { ɵɵrestoreView(_r970); const ctx_r971 = ɵɵnextContext(); return ctx_r971.onFixScaleChanged($event); });
    ɵɵelementEnd();
    ɵɵelement(2, "div", _c4$O);
    ɵɵtemplate(3, FlowCellChartComponent_ng_container_1_div_3_Template, 2, 1, "div", _c2$V);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r967 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("plotOptions", ctx_r967.plotOptions)("chartId", ctx_r967.chartId)("disabled", ctx_r967.chartDataLoading);
    ɵɵselect(2);
    ɵɵproperty("hidden", ctx_r967.chartDataLoading);
    ɵɵselect(3);
    ɵɵproperty("ngIf", ctx_r967.chartDataLoading);
} }
class FlowCellChartComponent {
    constructor(chartsService) {
        this.chartsService = chartsService;
        this.contentType = "flowcell";
        this.chartId = "flowcell-chart";
        this.subs = new SubSink();
        this.activeWrapper = false;
        this.hideOptions = false;
        this.plotOptions = null;
        this.fixScale = false;
        this.loadChartData = new EventEmitter();
        this.isLoadingOptions = false;
        this.formControlInputValues = this.chartsService.buildNewFormControlObj();
    }
    get chartDataLoading() {
        return this._chartDataLoading;
    }
    set chartDataLoading(data) {
        this._chartDataLoading = data;
    }
    get chartData() {
        return this._chartData;
    }
    /*
    bellow will get called when ever the Chart Response is
    passed in by the parent component
    */
    set chartData(data) {
        this._chartData = data;
        if (this._chartData != null) {
            this.loadFlowCellChartData();
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
        this.chart = null;
    }
    ngOnInit() { }
    onloadChartData(selectedFormInputValues) {
        this.loadChartData.emit(selectedFormInputValues);
    }
    onFixScaleChanged(selectedFormInputValues) {
        this.fixScale = selectedFormInputValues.FixScale;
        this.fixScaleAxes = this.currentChartAxes;
        if (!this.fixScale) {
            this.fixScaleAxes = null;
        }
        this.onloadChartData(selectedFormInputValues);
    }
    loadFlowCellChartData() {
        const chartData = this._chartData;
        const chartExist = !!this.chart;
        this.currentChartAxes = chartData.Axis;
        chartData.Axis = this.fixScaleAxes
            ? this.fixScaleAxes
            : this.currentChartAxes;
        if (chartExist) {
            this.chartsService.updateChart(this.chart, this.containerWidth, this.containerHeight, chartData, this.hideOptions);
        }
        else {
            this.createChart();
        }
    }
    createChart() {
        const chartConfig = {
            chartContainerSelector: `#${this.chartId}`,
            preserveAspectRatio: "none",
            transitionSpeed: 250,
            width: this.containerWidth,
            height: this.containerHeight,
            svgWidth: this.containerWidth.toString(),
            svgHeight: this.containerHeight.toString(),
        };
        // create (d3) chart
        this.chart = new FlowcellChart(this._chartData, chartConfig);
    }
    showChartLoadingSpinner() {
        this.activeWrapper = true;
        this.flowCellChartDataLoadingSpinner.start();
    }
    hideChartLoadingSpinner() {
        if (this.activeWrapper) {
            setTimeout(() => (this.activeWrapper = false), 250);
            this.flowCellChartDataLoadingSpinner.complete();
        }
    }
}
/** @nocollapse */ FlowCellChartComponent.ngComponentDef = ɵɵdefineComponent({ type: FlowCellChartComponent, selectors: [["lib-flow-cell-chart"]], factory: function FlowCellChartComponent_Factory(t) { return new (t || FlowCellChartComponent)(ɵɵdirectiveInject(ChartsService)); }, viewQuery: function FlowCellChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$$, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.flowCellChartDataLoadingSpinner = _t.first);
    } }, inputs: { hideOptions: "hideOptions", containerWidth: "containerWidth", containerHeight: "containerHeight", plotOptions: "plotOptions", fixScale: "fixScale", isLoadingOptions: "isLoadingOptions", chartDataLoading: ["isLoadingChart", "chartDataLoading"], chartData: "chartData" }, outputs: { loadChartData: "loadChartData" }, consts: 2, vars: 1, template: function FlowCellChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$_);
        ɵɵtemplate(1, FlowCellChartComponent_ng_container_1_Template, 4, 5, "ng-container", _c2$V);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.hideOptions && !ctx.isLoadingOptions);
    } }, directives: [NgIf, ChartOptionsComponent, SkeletonComponent], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]     .chart-container{padding:0}[_nghost-%COMP%]     .chart-container.tall{height:530px}[_nghost-%COMP%]     .svg-chart-container{width:auto;height:600px}[_nghost-%COMP%]     .svg-chart-container-vertical{height:600px;width:350px}[_nghost-%COMP%]     .flowcell-chart-container .loading{width:auto;height:auto}[_nghost-%COMP%]     rect{-webkit-transition:opacity .25s;transition:opacity .25s;opacity:1}[_nghost-%COMP%]     .axis line{fill:none;stroke:#666;stroke-width:1}[_nghost-%COMP%]     .axis text{font-family:sans-serif;font-size:11px}[_nghost-%COMP%]     .axis .domain{fill:none;stroke:#666}[_nghost-%COMP%]     .heat-axis g:last-of-type text{content:\"% of Max\";font-weight:700}[_nghost-%COMP%]     line.center{fill:#fff;stroke:#4a4a4a;stroke-width:1}[_nghost-%COMP%]     line.p50{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ul{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ll{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     rect.box{stroke:#4a4a4a;stroke-width:.33px;cursor:pointer;fill:rgba(132,205,236,.75)}[_nghost-%COMP%]     rect.bar{stroke:#fff;stroke-width:.33px;opacity:.9}[_nghost-%COMP%]     rect.bar:hover{opacity:1;stroke:#000}[_nghost-%COMP%]     rect.lane-cell{stroke:#000;stroke-width:.5}[_nghost-%COMP%]     rect.lane-cell:hover{stroke-width:2}[_nghost-%COMP%]     rect.lane-cell.no-data{opacity:.25}[_nghost-%COMP%]     text{font-family:Helvetica,Arial,sans-serif;fill:#666}[_nghost-%COMP%]     g.black circle{fill:#fff;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.black path{stroke:#333;stroke-width:1}[_nghost-%COMP%]     g.red circle{fill:red;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.red path{stroke:red;stroke-width:1}[_nghost-%COMP%]     g.green circle{fill:green;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.green path{stroke:green;stroke-width:1}[_nghost-%COMP%]     g.blue circle{fill:#00f;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.blue path{stroke:#00f;stroke-width:1}[_nghost-%COMP%]     .linechart path{cursor:pointer;opacity:.66}[_nghost-%COMP%]     .linechart path:hover{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .linechart path.highlighted{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .legend{position:absolute;top:10px;right:15px;background-color:rgba(255,255,255,.75);border:1px solid #efefef;padding:3px;border-radius:10px;min-width:75px;font-size:10px;-webkit-transition:opacity .25s linear;transition:opacity .25s linear}[_nghost-%COMP%]     .legend ul{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     .legend li{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     ul.bases li{float:left;width:14px;height:14px;line-height:12px;text-align:center;list-style:none;margin:0 0 0 10px;padding-left:0;font-weight:700;font-family:monospace}[_nghost-%COMP%]     ul.bases li.red{color:red}[_nghost-%COMP%]     ul.bases li.red:hover{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.red.highlighted{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.green{color:green}[_nghost-%COMP%]     ul.bases li.green:hover{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.green.highlighted{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.black{color:#000}[_nghost-%COMP%]     ul.bases li.black:hover{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.black.highlighted{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.blue{color:#00f}[_nghost-%COMP%]     ul.bases li.blue:hover{background-color:#00f;color:#fff}[_nghost-%COMP%]     ul.bases li.blue.highlighted{background-color:#00f;color:#fff}[_nghost-%COMP%]     .tick text{font-size:10px}[_nghost-%COMP%]     text.label{font-size:13px;color:#333}[_nghost-%COMP%]     .tick{stroke:#ccc;stroke-width:.25}[_nghost-%COMP%]     .tick line{stroke:#ccc;stroke-width:.5}[_nghost-%COMP%]     g.axis-x>.tick.major text{font-size:7px}[_nghost-%COMP%]     .bar-label{font-size:9px}[_nghost-%COMP%]     .loading-icon:before{content:url(/public/images/loading-icon.gif);vertical-align:middle}[_nghost-%COMP%]     .chart-image .loading-message{position:absolute;top:50%;left:50%;margin-top:-10px;margin-left:-50px;width:100px;text-align:center;background:rgba(255,255,255,.9);border:1px solid #ccc;box-shadow:0 0 10px #999;padding:3px 6px;border-radius:4px;font-size:10px}[_nghost-%COMP%]     .charts-thumb{height:245px;width:auto;position:relative}[_nghost-%COMP%]     .widget.maximized{position:absolute;left:0;top:0;z-index:1}@media all and (max-width:960px){[_nghost-%COMP%]     .chart-controls select{width:65px}[_nghost-%COMP%]     .chart-controls label{width:65px}[_nghost-%COMP%]     .chart-container{margin-left:75px}}[_nghost-%COMP%]     #ilmn-tooltip-pop{background-color:#fff;box-shadow:0 .2rem 1.4rem .2rem rgba(0,0,0,.2);color:#464646;cursor:default;display:none;font-size:1.3rem;margin-bottom:-.7rem;min-width:300px;padding:1.5rem;position:absolute;text-align:left;z-index:2147483647}[_nghost-%COMP%]     #ilmn-tooltip-pop ::before{content:\"\";position:absolute}[_nghost-%COMP%]     #ilmn-tooltip-pop .bs-tooltip-heading{max-width:60rem;word-break:break-all}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-content{max-width:60rem;max-height:275px;overflow:auto;padding-right:1rem}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table{table-layout:fixed}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table td.result{overflow:hidden;text-overflow:ellipsis;white-space:pre}[_nghost-%COMP%]     #ilmn-tooltip-pop.biosample-search-fastq-tooltip .tooltip-content{max-width:inherit}", "[_nghost-%COMP%]{display:block;min-height:30rem;position:relative}.card-chart[_ngcontent-%COMP%]{margin-top:2rem;min-height:30rem;position:relative}.card-chart__loader[_ngcontent-%COMP%]{position:absolute;min-width:100%;top:0;bottom:0}.card-chart__svg-container[_ngcontent-%COMP%]{position:relative;left:-.4rem}[_nghost-%COMP%]{min-height:57rem}"], data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] } });
/*@__PURE__*/ ɵsetClassMetadata(FlowCellChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-flow-cell-chart",
                templateUrl: "./flow-cell-chart.component.html",
                styleUrls: [
                    "../../../charts/basespace.charts.scss",
                    "./flow-cell-chart.component.scss",
                ],
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: ChartsService }]; }, { hideOptions: [{
            type: Input
        }], containerWidth: [{
            type: Input
        }], containerHeight: [{
            type: Input
        }], plotOptions: [{
            type: Input
        }], fixScale: [{
            type: Input
        }], loadChartData: [{
            type: Output
        }], isLoadingOptions: [{
            type: Input
        }], chartDataLoading: [{
            type: Input,
            args: ["isLoadingChart"]
        }], chartData: [{
            type: Input,
            args: ["chartData"]
        }], flowCellChartDataLoadingSpinner: [{
            type: ViewChild,
            args: ["flowCellChartDataLoadingSpinner", { static: true }]
        }] });

class CandleStickChart extends Chart {
    // *****************************************************
    constructor(responseData, customConfig) {
        super(responseData, customConfig);
        this.transitionSpeed = 250;
        this.update(responseData, customConfig);
    }
    update(updatedData, updatedSettings) {
        super.update(updatedData, updatedSettings);
        this.updateDataJoins();
    }
    refreshChart() {
        var candlestickData = this.svg.selectAll('g.candlestick');
        var seriesData = candlestickData.selectAll('g.series');
        var centerLineData = seriesData.selectAll('line.center');
        centerLineData.attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        var boxData = seriesData.selectAll('rect.box');
        var rectWidth = Math.max(2, ((this.config.width - (this.config.margins.left + this.config.margins.right)) / this.allData.length) - 2) * d3.event.scale;
        boxData.attr('x', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('y', (d) => { return this.scaleY(d[this.dataLookupIndex.p75]); })
            .attr('height', (d) => { return this.scaleY(d[this.dataLookupIndex.p25]) - this.scaleY(d[this.dataLookupIndex.p75]); })
            .attr('width', rectWidth);
        var ulLineData = seriesData.selectAll('line.ul');
        ulLineData.attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); });
        var llLineData = seriesData.selectAll('line.ll');
        llLineData.attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        var p50LineData = seriesData.selectAll('line.p50');
        p50LineData.attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.p50]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.p50]); });
    }
    updateDataJoins() {
        this.candlestickData = this.svg.selectAll('g.candlestick').data([this.responseData]);
        this.candlestickData.enter().append('g')
            .attr('class', 'candlestick')
            .attr('clip-path', 'url(' + this.config.chartClipPathIdSelector + ')');
        this.candlestickData.exit().remove();
        this.seriesData = this.candlestickData.selectAll('g.series').data((d, i) => { return d.Series; });
        this.seriesData.enter().append('g')
            .attr('class', function (d) { return 'series ' + d.Color; });
        this.seriesData.exit().remove();
        this.centerLineData = this.seriesData.selectAll('line.center').data((d, i) => { return d.Data; });
        this.centerLineData.enter().append('line')
            .attr('class', 'center')
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 2'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        this.centerLineData.exit().remove();
        this.centerLineData
            .transition().duration(this.config.transitionSpeed)
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 2'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        var color = "";
        this.boxData = this.seriesData.selectAll('rect.box').data((d, i) => {
            color = d.Color;
            return d.Data.map((item) => {
                item.push(color);
                this.colorIndex = item.length - 1;
                return item;
            });
        });
        var rectWidth = Math.max(2, ((this.config.width - (this.config.margins.left + this.config.margins.right)) / this.allData.length) - 2);
        var setBoxTitle = (d) => {
            // inline style for powertip
            var title = "";
            title += "<div style=\"padding: 5px; background: rgba(25, 25, 25, .8); color: white;\">";
            title += this.responseData.Axes.X.Title + ": " + d[this.dataLookupIndex.x] + "<br />";
            title += "Upper Limit: " + d[this.dataLookupIndex.ul] + "<br />";
            title += "P75: " + d[this.dataLookupIndex.p75] + "<br />";
            title += "P50: " + d[this.dataLookupIndex.p50] + "<br />";
            title += "P25: " + d[this.dataLookupIndex.p25] + "<br />";
            title += "Lower Limit: " + d[this.dataLookupIndex.ll] + "<br />";
            title += "</div>";
            return title;
        };
        // draw the p75 - p25 box.
        this.boxData.enter().append('rect')
            .attr('class', 'box')
            .attr('x', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('y', (d) => { return this.scaleY(d[this.dataLookupIndex.p75]); })
            .attr('height', (d) => { return this.scaleY(d[this.dataLookupIndex.p25]) - this.scaleY(d[this.dataLookupIndex.p75]); })
            .attr('width', rectWidth)
            .attr('style', (d) => { return 'fill:' + d[this.colorIndex] + '; fill-opacity: .075; stroke: ' + d[this.colorIndex] + '; stroke-width: 1'; });
        this.boxData.exit().remove();
        this.boxData.attr('data-powertip', (d, i) => {
            // set data attribute through jquery since jquery caches the data attribute
            // updating d3 data attribute alone won't update the changes in the toolip :(
            $(this.config.chartContainerSelector + ' .box:eq(' + i + ')').data('powertip', setBoxTitle(d));
            this.callTooltips('.box:eq(' + i + ')');
        });
        this.boxData
            .transition().duration(this.config.transitionSpeed)
            .attr('x', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('y', (d) => { return this.scaleY(d[this.dataLookupIndex.p75]); })
            .attr('height', (d) => { return this.scaleY(d[this.dataLookupIndex.p25]) - this.scaleY(d[this.dataLookupIndex.p75]); })
            .attr('width', rectWidth);
        this.centerLineData.enter().append('line')
            .attr('class', 'center')
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 2'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        this.centerLineData.exit().remove();
        this.centerLineData
            .transition().duration(this.config.transitionSpeed)
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 2'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        this.ulLineData = this.seriesData.selectAll('line.ul').data((d, i) => {
            return d.Data;
        });
        this.ulLineData.enter().append('line')
            .attr('class', 'ul')
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 1'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); });
        this.ulLineData.exit().remove();
        this.ulLineData
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 1'; })
            .transition().duration(this.config.transitionSpeed)
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ul]); });
        this.llLineData = this.seriesData.selectAll('line.ll').data((d, i) => {
            return d.Data;
        });
        this.llLineData.enter().append('line')
            .attr('class', 'll')
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 1'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        this.llLineData.exit().remove();
        this.llLineData
            .attr('style', (d) => { return 'stroke: ' + d[this.colorIndex] + '; stroke-width: 1'; })
            .transition().duration(this.config.transitionSpeed)
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.ll]); });
        this.p50LineData = this.seriesData.selectAll('line.p50').data((d, i) => {
            return d.Data;
        });
        // *****
        this.p50LineData.enter().append('line')
            .attr('class', 'p50')
            .attr('style', (d) => { return 'stroke: red; stroke-width: 1'; })
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.p50]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.p50]); });
        this.p50LineData.exit().remove();
        this.p50LineData
            .attr('style', (d) => { return 'stroke: red; stroke-width: 1'; })
            .transition().duration(this.config.transitionSpeed)
            .attr('x1', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) - (rectWidth / 2); })
            .attr('x2', (d) => { return this.scaleX(d[this.dataLookupIndex.x]) + (rectWidth / 2); })
            .attr('y1', (d) => { return this.scaleY(d[this.dataLookupIndex.p50]); })
            .attr('y2', (d) => { return this.scaleY(d[this.dataLookupIndex.p50]); });
    }
    updateScales() {
        this.scaleX = d3.scale.linear();
        this.scaleX.domain([this.responseData.Axes.X.Min, this.responseData.Axes.X.Max]);
        this.scaleX.rangeRound([this.config.margins.left, this.config.width - this.config.margins.right]);
        this.scaleY = d3.scale.linear();
        this.scaleY.domain([this.responseData.Axes.Y.Min, this.responseData.Axes.Y.Max]);
        this.scaleY.rangeRound([this.config.height - this.config.margins.bottom, this.config.margins.top]);
        this.setInitialDomainScaleForZoom();
    }
    setInitialDomainScaleForZoom() {
        // resets the domain scale for zoom (level x1) when chart resizes
        if (!this.initialScaleDomainX) {
            this.initialScaleDomainX = this.scaleX.domain();
        }
        else {
            this.scaleX.domain(this.initialScaleDomainX);
        }
        if (!this.initialScaleDomainY) {
            this.initialScaleDomainY = this.scaleY.domain();
        }
        else {
            this.scaleY.domain(this.initialScaleDomainY);
        }
    }
}
CandleStickChart.CHART_NAME = "CandleStick";

class LineChart extends Chart {
    /**
    * Chart that can plot both line- and scatter-type series
    **/
    constructor(responseData, customConfig) {
        super(responseData, customConfig);
        this.scatterPlotFillOpacity = .75;
        this.scatterPlotStrokeWidth = 0.75;
        this.newScatterSeriesCount = 0;
        this.baseGradientDefinitions = [LineChart.DEFAULT_SCATTER_FILL_GRADIENT];
        this.update(responseData, customConfig);
        this.bindMouseEvents();
    }
    update(updatedData, updatedSettings) {
        super.update(updatedData, updatedSettings);
        // render series differently depending on type: line vs. scatter.
        var lineSeries = [], scatterSeries = [];
        ___default.each(this.responseData.Series, (series) => {
            switch (series.Type.toLowerCase()) {
                case LineChart.SERIES_TYPE_LINE:
                    lineSeries.push(series);
                    break;
                case LineChart.SERIES_TYPE_SCATTER:
                    scatterSeries.push(series);
                    break;
                default: break;
            }
        });
        var linechart = this.svg.selectAll('g.linechart').data([this.responseData]);
        linechart.enter()
            .append('g')
            .attr('class', 'linechart')
            .attr('clip-path', 'url(' + this.config.chartClipPathIdSelector + ')');
        linechart.exit().remove();
        this.updateLineSeries(linechart, lineSeries);
        this.updateScatterSeries(linechart, scatterSeries);
        this.updateLegend();
        // this.callTooltips("[title]");
    }
    refreshChart() {
        var lineSeries = [], scatterSeries = [];
        ___default.each(this.responseData.Series, (series) => {
            switch (series.Type.toLowerCase()) {
                case LineChart.SERIES_TYPE_LINE:
                    lineSeries.push(series);
                    break;
                case LineChart.SERIES_TYPE_SCATTER:
                    scatterSeries.push(series);
                    break;
                default: break;
            }
        });
        // update line chart
        var linechart = this.svg.selectAll('g.linechart').data([this.responseData]);
        var series = linechart.selectAll('g.series.line').data(lineSeries);
        var lookupIndex;
        series.datum((d) => {
            lookupIndex = d.Fields;
            return d;
        });
        var lineFn = d3.svg.line()
            .x((d) => {
            return this.scaleX(d[lookupIndex.x]);
        })
            .y((d) => {
            return this.scaleY(d[lookupIndex.y]);
        });
        var line = series.selectAll('path').data((d) => [d]);
        line.attr('d', (d) => {
            return lineFn(d.Data);
        });
        // update scatter
        series = linechart.selectAll('g.series.scatter').data(scatterSeries);
        series.datum((d) => {
            lookupIndex = d.Fields;
            return d;
        });
        var circle = series.selectAll('circle');
        circle.attr('cx', (d) => this.scaleX(d[lookupIndex.x]))
            .attr('cy', (d) => this.scaleY(d[lookupIndex.y]));
    }
    updateLineSeries(linechart, lineSeries) {
        var lookupIndex;
        var series = linechart.selectAll('g.series.line').data(lineSeries);
        series.enter().append('g');
        series.exit().remove();
        series
            .datum((d) => {
            lookupIndex = d.Fields;
            return d;
        })
            .attr('class', (d) => 'series line ' + d.Color.toLowerCase().replace('#', '_'));
        var lineFn = d3.svg.line()
            .x((d) => {
            return this.scaleX(d[lookupIndex.x]);
        })
            .y((d) => {
            return this.scaleY(d[lookupIndex.y]);
        });
        var line = series.selectAll('path').data((d) => [d]);
        line.enter().append('path');
        line.exit().remove();
        line
            .each(function (d) {
            var tooltip = "";
            var parentData = d3.select(this.parentNode).datum();
            if ("Accessors" in parentData && "powertip" in parentData.Accessors) {
                tooltip = parentData.Accessors.powertip(d);
            }
            else {
                tooltip = d.Title;
            }
            $(this).data("powertip", tooltip);
        });
        line
            .attr('title', (d) => d.Title)
            .transition().duration(this.config.transitionSpeed)
            .attr('d', (d) => lineFn(d.Data))
            .style('fill', 'none')
            .style('stroke', (d) => d.Color.toLowerCase())
            .style('stroke-width', this.config.strokeWidth);
    }
    styleScatterSeriesCircle(circle) {
        var chart = this;
        circle
            .each(function (d) {
            var tooltip = "";
            var parentData = d3.select(this.parentNode).datum();
            if ("Accessors" in parentData && "powertip" in parentData.Accessors) {
                tooltip = parentData.Accessors.powertip(d);
            }
            else {
                tooltip = d.Title;
            }
            $(this).data("powertip", tooltip);
        });
        circle
            .attr('title', function (d) {
            var lookupIndex = d3.select(this.parentNode).datum().Fields;
            return d[lookupIndex.tooltipTitle] + "\n" + d[lookupIndex.y];
        })
            .transition().duration(this.config.transitionSpeed)
            .attr('cx', function (d) {
            var lookupIndex = d3.select(this.parentNode).datum().Fields;
            return chart.scaleX(d[lookupIndex.x]);
        })
            .attr('cy', function (d) {
            var lookupIndex = d3.select(this.parentNode).datum().Fields;
            return chart.scaleY(d[lookupIndex.y]);
        })
            .style('fill', function (d) {
            var parentData = d3.select(this.parentNode).datum();
            if ("Accessors" in parentData && "fill" in parentData.Accessors) {
                return parentData.Accessors.fill(d);
            }
            else {
                return parentData.Color.toLowerCase();
            }
        })
            .style('fill-opacity', this.scatterPlotFillOpacity)
            .style('stroke-width', this.scatterPlotStrokeWidth)
            .attr('r', function (d) {
            var parentData = d3.select(this.parentNode).datum();
            var scatterPlotCircleRadius = (parentData.PointSize === undefined ? LineChart.DEFAULT_SCATTER_CIRCLE_RADIUS : Math.round(parentData.PointSize) / 2);
            return scatterPlotCircleRadius;
        });
    }
    addScatterSeries(scatterSeries) {
        this.newScatterSeriesCount++;
        var chart = this;
        scatterSeries.forEach(function (s) {
            chart.allSeries.push(s);
            s.Data.forEach(function (d) {
                chart.allData.push(d);
            });
        });
        var linechart = this.svg.selectAll('g.linechart');
        var series = linechart.selectAll('g.series.scatter.new' + this.newScatterSeriesCount).data(scatterSeries);
        series.enter().append('g');
        series.exit();
        series.attr('class', (d) => 'series scatter new' + this.newScatterSeriesCount);
        var circle = series.selectAll('circle').data((d) => d.Data);
        circle.enter().append('circle');
        circle.exit();
        this.styleScatterSeriesCircle(circle);
        this.callTooltips('g.series.scatter.new' + this.newScatterSeriesCount + ' [title]');
    }
    updateScatterSeries(linechart, scatterSeries) {
        var series = linechart.selectAll('g.series.scatter').data(scatterSeries);
        series.enter().append('g');
        series.exit().remove();
        series.attr('class', (d) => 'series scatter');
        var circle = series.selectAll('circle').data((d) => d.Data);
        circle.enter().append('circle');
        circle.exit().remove();
        this.styleScatterSeriesCircle(circle);
    }
    updateLegend() {
        if (this.legend == null)
            this.legend = d3.select(this.config.chartContainerSelector).append('div').attr('class', 'legend');
        if (this.svgLegend == null) {
            this.svgLegend = this.svg.append('g').attr('class', 'legend');
        }
        if (!this.config.legend) {
            this.legend.style('display', 'none'); // hide the legend
            this.svgLegend.style('display', 'none'); // hide the legend
        }
        else {
            this.legend.style('display', this.config.svgLegend ? 'none' : 'block'); // show the legend
            this.svgLegend.style('display', this.config.svgLegend ? 'block' : 'none'); // show the legend
        }
        var filterBases = (seriesArr, includeOrExclude) => {
            var arr = seriesArr.filter(series => {
                if (!("Title" in series))
                    return !includeOrExclude;
                else if ((series.Title.toLowerCase() == "a") || (series.Title.toLowerCase() == "c") || (series.Title.toLowerCase() == "g") || (series.Title.toLowerCase() == "t") || (series.Title.toLowerCase() == "u"))
                    return includeOrExclude;
                else
                    return !includeOrExclude;
            });
            return arr;
        };
        // html legend
        var legendList = this.legend.selectAll('ul.bases').data([this.responseData]);
        legendList.enter().append('ul')
            .attr('class', 'bases');
        legendList.exit().remove();
        var baseLi = legendList.selectAll('li').data((d) => filterBases(d.Series, true));
        baseLi.enter().append('li');
        baseLi.exit().remove();
        baseLi
            .text((d) => { return d.Title; })
            .attr('class', (d) => d.Color.toLowerCase().replace('#', '_'))
            .style('color', (d) => d.Color.toLowerCase());
        var extraList = this.legend.selectAll('ul.extra').data([this.responseData]);
        extraList.enter().append('ul');
        extraList.exit().remove();
        extraList
            .attr('class', 'extra');
        var extraItems = extraList.selectAll('li').data((d) => filterBases(d.Series, false));
        extraItems.enter().append('li');
        extraItems.exit().remove();
        extraItems
            .text((d) => { return d.Title; })
            .attr('class', (d) => d.Color.toLowerCase().replace('#', '_'))
            .style('color', (d) => d.Color.toLowerCase());
        // svg legend
        var that = this;
        var baseSeries = filterBases(this.responseData.Series, true);
        var extraSeries = filterBases(this.responseData.Series, false);
        this.svgLegend.attr('transform', 'translate(' + (this.config.width - this.config.margins.right + 5) + ')');
        var fontSize = this.config.fontSize != null ? this.config.fontSize : 10;
        var maxTitleLength = Math.max.apply(null, this.responseData.Series.map(series => series.Title.length));
        maxTitleLength = Math.max(maxTitleLength, baseSeries.length * 2);
        var svgLegendData = {
            x: 0, y: 0, rx: 10, ry: 10,
            width: Math.min(this.config.margins.right - 5, maxTitleLength * fontSize + fontSize / 2),
            height: Math.min(this.config.height, (extraSeries.length + (baseSeries.length > 0 ? 1 : 0) + 1) * fontSize),
        };
        var svgLegendBox = this.svgLegend.selectAll('rect').data([svgLegendData]);
        svgLegendBox.enter().append('rect');
        svgLegendBox.exit().remove();
        svgLegendBox
            .attr('x', d => d.x)
            .attr('y', d => d.y)
            .attr('rx', d => d.rx)
            .attr('ry', d => d.ry)
            .attr('width', d => d.width)
            .attr('height', d => d.height)
            .style('stroke', 'black')
            .style('stroke-width', 1)
            .style('opacity', 0.5)
            .style('fill', 'none');
        var svgBaseLegendList = this.svgLegend.selectAll('g.bases').data([baseSeries]);
        svgBaseLegendList.enter().append('g');
        svgBaseLegendList.exit().remove();
        svgBaseLegendList
            .attr('class', 'bases')
            .attr('transform', 'translate(' + fontSize + ', ' + fontSize + ')');
        var svgBaseItems = svgBaseLegendList.selectAll('text').data((d) => {
            return d.map(series => {
                return { title: series.Title, color: series.Color, fontSize: fontSize };
            });
        });
        svgBaseItems.enter().append('text');
        svgBaseItems.exit().remove();
        svgBaseItems
            .text(d => d.title)
            .attr('x', (d, i) => i * d.fontSize * 2)
            .attr('y', 0)
            .attr('alignment-baseline', 'middle')
            .style('font-size', d => d.fontSize + 'px')
            .style('fill', d => d.color);
        svgBaseItems.append("title")
            .text(function (d) { return d.title; });
        var svgExtraLegendList = this.svgLegend.selectAll('g.extra').data([extraSeries]);
        svgExtraLegendList.enter().append('g');
        svgExtraLegendList.exit().remove();
        svgExtraLegendList
            .attr('class', 'extra')
            .attr('transform', 'translate(' + fontSize / 2 + ', ' + fontSize * (baseSeries.length > 0 ? 2 : 1) + ')');
        var svgExtraItems = svgExtraLegendList.selectAll('text').data((d) => {
            return d.map(series => {
                return { title: series.Title, color: series.Color, fontSize: fontSize };
            });
        });
        svgExtraItems.enter().append('text');
        svgExtraItems.exit().remove();
        svgExtraItems
            .text(d => d.title)
            .attr('x', 0)
            .attr('y', (d, i) => i * d.fontSize)
            .attr('alignment-baseline', 'middle')
            .style('font-size', d => d.fontSize + 'px')
            .style('fill', d => d.color);
        svgExtraItems.append("title")
            .text(function (d) { return d.title; });
    }
    addLegend() {
        super.addLegend();
        var legendList = this.legend.select('ul');
        for (var i = 0; i < this.responseData.Series.length; i++) {
            var currentSeries = this.responseData.Series[i];
            var title = currentSeries.Title;
            var colorClass = currentSeries.Color.toLowerCase().replace('#', '_');
            legendList.append('li')
                .text(title + ' (' + currentSeries.Color + ')')
                .attr('style', 'color: ' + currentSeries.Color.toLowerCase());
        }
    }
    updateScales() {
        this.scaleX = this.config.scaleX();
        if (this.config.scaleX === d3.scale.log) { // log scale
            this.scaleX.clamp(true);
            var domainXMin = this.responseData.Axes.X.Min == 0 ? Chart.MIN_LOG_INPUT : this.responseData.Axes.X.Min;
            this.scaleX.domain([domainXMin, this.responseData.Axes.X.Max]);
        }
        else {
            this.scaleX.domain([this.responseData.Axes.X.Min, this.responseData.Axes.X.Max]);
        }
        this.scaleX.range([this.config.margins.left, this.config.width - this.config.margins.right]);
        if (this.config.scaleX && this.config.scaleX.nice === true) {
            this.scaleX.nice();
        }
        this.scaleY = this.config.scaleY();
        if (this.config.scaleY === d3.scale.log) { // log scale
            this.scaleY.clamp(true);
            var domainYMin = this.responseData.Axes.Y.Min == 0 ? Chart.MIN_LOG_INPUT : this.responseData.Axes.Y.Min;
            this.scaleY.domain([domainYMin, this.responseData.Axes.Y.Max]);
        }
        else {
            this.scaleY.domain([this.responseData.Axes.Y.Min, this.responseData.Axes.Y.Max]);
        }
        this.scaleY.range([this.config.height - this.config.margins.bottom, this.config.margins.top]);
        if (this.config.scaleY && this.config.scaleY.nice === true) {
            this.scaleY.nice();
        }
        this.setInitialDomainScaleForZoom();
    }
    setInitialDomainScaleForZoom() {
        // resets the domain scale for zoom (level x1) when chart resizes
        if (!this.initialScaleDomainX) {
            this.initialScaleDomainX = this.scaleX.domain();
        }
        else {
            this.scaleX.domain(this.initialScaleDomainX);
        }
        if (!this.initialScaleDomainY) {
            this.initialScaleDomainY = this.scaleY.domain();
        }
        else {
            this.scaleY.domain(this.initialScaleDomainY);
        }
    }
    bindMouseEvents() {
        const chartContainerSelector = document.querySelector(this.config.chartContainerSelector);
        ___default.each(chartContainerSelector.querySelectorAll('div.legend ul li'), (legendElement) => {
            legendElement.addEventListener('mouseenter', (e) => {
                const title = e.target.textContent;
                let color = window.getComputedStyle(e.target).color;
                if (color == 'white' || color == 'rgb(255, 255, 255)') {
                    color = window.getComputedStyle(e.target).backgroundColor;
                }
                e.target.style.backgroundColor = color;
                e.target.style.color = 'white';
                ___default.each(chartContainerSelector.querySelectorAll(' path'), (pathElement) => {
                    if (title == pathElement.getAttribute('title')) {
                        pathElement.setAttribute('class', 'highlighted');
                    }
                    else {
                        pathElement.setAttribute('class', '');
                    }
                });
                e.target.style.cursor = 'pointer';
            });
            legendElement.addEventListener('mouseleave', (e) => {
                const title = e.target.textContent;
                let color = window.getComputedStyle(e.target).color;
                if (color == 'white' || color == 'rgb(255, 255, 255)') {
                    color = window.getComputedStyle(e.target).backgroundColor;
                }
                e.target.style.backgroundColor = 'white';
                e.target.style.color = color;
                ___default.each(chartContainerSelector.querySelectorAll(' path'), (pathElement) => {
                    if (title == pathElement.getAttribute('title')) {
                        pathElement.setAttribute('class', '');
                    }
                });
                e.target.style.cursor = 'auto';
            });
        });
        ___default.each(chartContainerSelector.querySelectorAll('path'), (pathElement) => {
            pathElement.addEventListener('mouseenter', (e) => {
                const title = e.target.getAttribute('title');
                // html legend
                ___default.each(chartContainerSelector.querySelectorAll('div.legend ul li'), (legendElement) => {
                    let color = window.getComputedStyle(legendElement).color;
                    if (color == 'white' || color == 'rgb(255, 255, 255)') {
                        color = window.getComputedStyle(legendElement).backgroundColor;
                    }
                    if (title == legendElement.textContent) {
                        legendElement.style.backgroundColor = color;
                        legendElement.style.color = 'white';
                    }
                    else {
                        legendElement.style.backgroundColor = 'white';
                        legendElement.style.color = color;
                    }
                });
                // svg legend - we are not showing svg legend
                ___default.each(chartContainerSelector.querySelectorAll('g.legend text'), (svgLegendElement) => {
                    var legendText = svgLegendElement.childNodes[0].nodeValue;
                    if (title == legendText) {
                        svgLegendElement.style.textDecoration = 'underline';
                    }
                    else {
                        svgLegendElement.style.textDecoration = '';
                    }
                });
            });
            pathElement.addEventListener('mouseleave', (e) => {
                ___default.each(chartContainerSelector.querySelectorAll('div.legend ul li'), (legendElement) => {
                    let color = window.getComputedStyle(legendElement).color;
                    if (color == 'white' || color == 'rgb(255, 255, 255)') {
                        color = window.getComputedStyle(legendElement).backgroundColor;
                    }
                    legendElement.style.backgroundColor = 'white';
                    legendElement.style.color = color;
                });
                ___default.each(chartContainerSelector.querySelectorAll('g.legend text'), (svgLegendElement) => {
                    svgLegendElement.style.textDecoration = '';
                });
            });
        });
    }
}
LineChart.CHART_NAME = "LineChart";
LineChart.SERIES_TYPE_LINE = "line";
LineChart.SERIES_TYPE_SCATTER = "scatter";
LineChart.DEFAULT_SCATTER_CIRCLE_RADIUS = 3.5;
LineChart.DEFAULT_SCATTER_CIRCLE_COLOR = "#98cc78";
LineChart.DEFAULT_LINE_VERTEX_FIELD_INDICES = {
    x: 0,
    y: 1
};
LineChart.DEFAULT_SCATTER_CIRCLE_FIELD_INDICES = {
    x: 0,
    tooltipTitle: 1,
    y: 2
};
LineChart.DEFAULT_SCATTER_FILL_GRADIENT = {
    id: "scatter-main",
    stops: [
        {
            color: "#2c53a1",
            offset: "0%",
            opacity: .5
        },
        {
            color: "#2c53a1",
            offset: "50%",
            opacity: 1
        }
    ],
    direction: Chart.GRADIENT_DIRECTION_VERTICAL
};

class AbbreviateLargeNumberPipe {
    constructor() { }
    transform(num, precision = 2) {
        if ((num >= 0) && (num < AbbreviateLargeNumberPipe.thousand)) {
            return num.toString();
        }
        else if ((num >= AbbreviateLargeNumberPipe.thousand) && (num < AbbreviateLargeNumberPipe.million)) {
            return (num / AbbreviateLargeNumberPipe.thousand).toFixed(precision) + "K";
        }
        else if ((num >= AbbreviateLargeNumberPipe.million) && (num < AbbreviateLargeNumberPipe.billion)) {
            return (num / AbbreviateLargeNumberPipe.million).toFixed(precision) + "M";
        }
        else if ((num >= AbbreviateLargeNumberPipe.billion) && (num < AbbreviateLargeNumberPipe.trillion)) {
            return (num / AbbreviateLargeNumberPipe.billion).toFixed(precision) + "B";
        }
        else if ((num >= AbbreviateLargeNumberPipe.trillion)) {
            return (num / AbbreviateLargeNumberPipe.trillion).toFixed(precision) + "T";
        }
        else {
            return num.toString();
        }
    }
}
AbbreviateLargeNumberPipe.thousand = 1000;
AbbreviateLargeNumberPipe.million = Math.pow(AbbreviateLargeNumberPipe.thousand, 2);
AbbreviateLargeNumberPipe.billion = Math.pow(AbbreviateLargeNumberPipe.thousand, 3);
AbbreviateLargeNumberPipe.trillion = Math.pow(AbbreviateLargeNumberPipe.thousand, 4);
/** @nocollapse */ AbbreviateLargeNumberPipe.ngPipeDef = ɵɵdefinePipe({ name: "abbreviateLargeNumberPipe", type: AbbreviateLargeNumberPipe, factory: function AbbreviateLargeNumberPipe_Factory(t) { return new (t || AbbreviateLargeNumberPipe)(); }, pure: true });
/*@__PURE__*/ ɵsetClassMetadata(AbbreviateLargeNumberPipe, [{
        type: Pipe,
        args: [{ name: "abbreviateLargeNumberPipe" }]
    }], function () { return []; }, null);

const _c0$10 = ["dateByCycleDataLoadingSpinner"];
const _c1$$ = ["chartContainer"];
const _c2$W = [1, "card-chart"];
const _c3$S = [4, "ngIf"];
const _c4$P = [3, "plotOptions", "chartId", "disabled", "loadChartData", "fixScaleValueChanged"];
const _c5$L = [1, "card-chart__svg-container", 3, "hidden", "id"];
const _c6$J = ["chartContainer", ""];
const _c7$G = ["type", "bar-chart"];
const _c8$F = {};
function DataByCycleChartComponent_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-skeleton", _c7$G);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("@fadeIn", _c8$F);
} }
function DataByCycleChartComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r976 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-chart-options", _c4$P);
    ɵɵlistener("loadChartData", function DataByCycleChartComponent_ng_container_1_Template_lib_chart_options_loadChartData_1_listener($event) { ɵɵrestoreView(_r976); const ctx_r975 = ɵɵnextContext(); return ctx_r975.onloadChartData($event); });
    ɵɵlistener("fixScaleValueChanged", function DataByCycleChartComponent_ng_container_1_Template_lib_chart_options_fixScaleValueChanged_1_listener($event) { ɵɵrestoreView(_r976); const ctx_r977 = ɵɵnextContext(); return ctx_r977.onFixScaleChanged($event); });
    ɵɵelementEnd();
    ɵɵelement(2, "div", _c5$L, _c6$J);
    ɵɵtemplate(4, DataByCycleChartComponent_ng_container_1_div_4_Template, 2, 1, "div", _c3$S);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r972 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("plotOptions", ctx_r972.plotOptions)("chartId", ctx_r972.chartId)("disabled", ctx_r972.chartDataLoading);
    ɵɵselect(2);
    ɵɵpropertyInterpolate("id", ctx_r972.chartId);
    ɵɵproperty("hidden", ctx_r972.chartDataLoading);
    ɵɵselect(4);
    ɵɵproperty("ngIf", ctx_r972.chartDataLoading);
} }
class DataByCycleChartComponent {
    constructor(chartsService, abbreviateLargeNumberPipe) {
        this.chartsService = chartsService;
        this.abbreviateLargeNumberPipe = abbreviateLargeNumberPipe;
        this.chartId = "data-by-cycle";
        this.subs = new SubSink();
        this.activeWrapper = false;
        this.hideOptions = false;
        this.plotOptions = null;
        this.fixScale = false;
        this.loadChartData = new EventEmitter();
        this.isLoadingOptions = false;
        this.formControlInputValues = this.chartsService.buildNewFormControlObj();
    }
    get containerWidth() {
        return this._containerWidth;
    }
    set containerWidth(containerWidth) {
        const originalValue = this._containerWidth;
        this._containerWidth = containerWidth;
        if (this._containerWidth != null && originalValue != containerWidth) {
            this.onUpdateChartData(this.containerWidth);
        }
    }
    get chartDataLoading() {
        return this._chartDataLoading;
    }
    set chartDataLoading(data) {
        this._chartDataLoading = data;
    }
    get chartData() {
        return this._chartData;
    }
    /*
    bellow will get called when ever the Chart Response is
    passed in by the parent component
    */
    set chartData(data) {
        this._chartData = data;
        if (this._chartData != null) {
            this.loadChart();
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    ngOnInit() { }
    onloadChartData(selectedFormInputValues) {
        this.loadChartData.emit(selectedFormInputValues);
    }
    onFixScaleChanged(selectedFormInputValues) {
        this.fixScale = selectedFormInputValues.FixScale;
        this.fixScaleAxes = this.currentChartAxes;
        if (!this.fixScale) {
            this.fixScaleAxes = null;
        }
        this.onloadChartData(selectedFormInputValues);
    }
    //Expand chart subpane
    onUpdateChartData(containerWidth) {
        if (this.chart) {
            this.chartsService.updateChart(this.chart, containerWidth, this.containerHeight, this._chartData, this.hideOptions);
        }
    }
    loadChart() {
        const chartData = this._chartData;
        const chartExist = !!this.chart;
        this.currentChartAxes = chartData.Axes;
        chartData.Axes = this.fixScaleAxes
            ? this.fixScaleAxes
            : this.currentChartAxes;
        const chartType = this.getChartType();
        const existingChartIsDifferent = chartExist && chartType !== this.chart.constructor;
        if (chartExist) {
            // if chart exists and is not different type, then update chart
            if (!existingChartIsDifferent) {
                this.chartsService.updateChart(this.chart, this.containerWidth, this.containerHeight, chartData, this.hideOptions);
            }
            else {
                // if chart exists but new chart is different type, then cleanup previous
                this.chart = null;
                this.removeSVGChart();
                this.createChart(chartType);
            }
        }
        else {
            this.createChart(chartType);
        }
    }
    removeSVGChart() {
        this.chartContainerRef.nativeElement.innerHTML = "";
    }
    createChart(chartType) {
        const yAxisFormat = (value) => {
            return this.abbreviateLargeNumberPipe.transform(value);
        };
        const chartConfig = {
            chartContainerSelector: `#${this.chartId}`,
            chartClipPathIdSelector: `#${this.chartId}-clip-path`,
            preserveAspectRatio: "none",
            transitionSpeed: 250,
            width: this.containerWidth,
            height: this.containerHeight,
            xAxis: {
                tickFormat: d3.format("d"),
            },
            yAxis: {
                tickFormat(value, axisNth, mysteryNumber) {
                    return yAxisFormat(value);
                },
            },
            margins: {
                left: 70,
            },
        };
        // create (d3) chart
        this.chart = new chartType(this._chartData, chartConfig);
    }
    getChartType() {
        if (this._chartData == null ||
            this._chartData.Series == null ||
            this._chartData.Series.length <= 0) {
            return null;
        }
        return this._chartData.Series[0].Type.toLowerCase() === "candlestick"
            ? CandleStickChart
            : LineChart;
    }
    yAxisFormat(value) {
        return this.abbreviateLargeNumberPipe.transform(value);
    }
}
/** @nocollapse */ DataByCycleChartComponent.ngComponentDef = ɵɵdefineComponent({ type: DataByCycleChartComponent, selectors: [["lib-data-by-cycle-chart"]], factory: function DataByCycleChartComponent_Factory(t) { return new (t || DataByCycleChartComponent)(ɵɵdirectiveInject(ChartsService), ɵɵdirectiveInject(AbbreviateLargeNumberPipe)); }, viewQuery: function DataByCycleChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$10, true);
        ɵɵviewQuery(_c1$$, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dateByCycleDataLoadingSpinner = _t.first);
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.chartContainerRef = _t.first);
    } }, inputs: { hideOptions: "hideOptions", containerHeight: "containerHeight", plotOptions: "plotOptions", fixScale: "fixScale", containerWidth: "containerWidth", isLoadingOptions: "isLoadingOptions", chartDataLoading: ["isLoadingChart", "chartDataLoading"], chartData: "chartData" }, outputs: { loadChartData: "loadChartData" }, consts: 2, vars: 1, template: function DataByCycleChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c2$W);
        ɵɵtemplate(1, DataByCycleChartComponent_ng_container_1_Template, 5, 6, "ng-container", _c3$S);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.hideOptions && !ctx.isLoadingOptions);
    } }, directives: [NgIf, ChartOptionsComponent, SkeletonComponent], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]     .chart-container{padding:0}[_nghost-%COMP%]     .chart-container.tall{height:530px}[_nghost-%COMP%]     .svg-chart-container{width:auto;height:600px}[_nghost-%COMP%]     .svg-chart-container-vertical{height:600px;width:350px}[_nghost-%COMP%]     .flowcell-chart-container .loading{width:auto;height:auto}[_nghost-%COMP%]     rect{-webkit-transition:opacity .25s;transition:opacity .25s;opacity:1}[_nghost-%COMP%]     .axis line{fill:none;stroke:#666;stroke-width:1}[_nghost-%COMP%]     .axis text{font-family:sans-serif;font-size:11px}[_nghost-%COMP%]     .axis .domain{fill:none;stroke:#666}[_nghost-%COMP%]     .heat-axis g:last-of-type text{content:\"% of Max\";font-weight:700}[_nghost-%COMP%]     line.center{fill:#fff;stroke:#4a4a4a;stroke-width:1}[_nghost-%COMP%]     line.p50{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ul{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ll{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     rect.box{stroke:#4a4a4a;stroke-width:.33px;cursor:pointer;fill:rgba(132,205,236,.75)}[_nghost-%COMP%]     rect.bar{stroke:#fff;stroke-width:.33px;opacity:.9}[_nghost-%COMP%]     rect.bar:hover{opacity:1;stroke:#000}[_nghost-%COMP%]     rect.lane-cell{stroke:#000;stroke-width:.5}[_nghost-%COMP%]     rect.lane-cell:hover{stroke-width:2}[_nghost-%COMP%]     rect.lane-cell.no-data{opacity:.25}[_nghost-%COMP%]     text{font-family:Helvetica,Arial,sans-serif;fill:#666}[_nghost-%COMP%]     g.black circle{fill:#fff;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.black path{stroke:#333;stroke-width:1}[_nghost-%COMP%]     g.red circle{fill:red;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.red path{stroke:red;stroke-width:1}[_nghost-%COMP%]     g.green circle{fill:green;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.green path{stroke:green;stroke-width:1}[_nghost-%COMP%]     g.blue circle{fill:#00f;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.blue path{stroke:#00f;stroke-width:1}[_nghost-%COMP%]     .linechart path{cursor:pointer;opacity:.66}[_nghost-%COMP%]     .linechart path:hover{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .linechart path.highlighted{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .legend{position:absolute;top:10px;right:15px;background-color:rgba(255,255,255,.75);border:1px solid #efefef;padding:3px;border-radius:10px;min-width:75px;font-size:10px;-webkit-transition:opacity .25s linear;transition:opacity .25s linear}[_nghost-%COMP%]     .legend ul{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     .legend li{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     ul.bases li{float:left;width:14px;height:14px;line-height:12px;text-align:center;list-style:none;margin:0 0 0 10px;padding-left:0;font-weight:700;font-family:monospace}[_nghost-%COMP%]     ul.bases li.red{color:red}[_nghost-%COMP%]     ul.bases li.red:hover{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.red.highlighted{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.green{color:green}[_nghost-%COMP%]     ul.bases li.green:hover{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.green.highlighted{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.black{color:#000}[_nghost-%COMP%]     ul.bases li.black:hover{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.black.highlighted{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.blue{color:#00f}[_nghost-%COMP%]     ul.bases li.blue:hover{background-color:#00f;color:#fff}[_nghost-%COMP%]     ul.bases li.blue.highlighted{background-color:#00f;color:#fff}[_nghost-%COMP%]     .tick text{font-size:10px}[_nghost-%COMP%]     text.label{font-size:13px;color:#333}[_nghost-%COMP%]     .tick{stroke:#ccc;stroke-width:.25}[_nghost-%COMP%]     .tick line{stroke:#ccc;stroke-width:.5}[_nghost-%COMP%]     g.axis-x>.tick.major text{font-size:7px}[_nghost-%COMP%]     .bar-label{font-size:9px}[_nghost-%COMP%]     .loading-icon:before{content:url(/public/images/loading-icon.gif);vertical-align:middle}[_nghost-%COMP%]     .chart-image .loading-message{position:absolute;top:50%;left:50%;margin-top:-10px;margin-left:-50px;width:100px;text-align:center;background:rgba(255,255,255,.9);border:1px solid #ccc;box-shadow:0 0 10px #999;padding:3px 6px;border-radius:4px;font-size:10px}[_nghost-%COMP%]     .charts-thumb{height:245px;width:auto;position:relative}[_nghost-%COMP%]     .widget.maximized{position:absolute;left:0;top:0;z-index:1}@media all and (max-width:960px){[_nghost-%COMP%]     .chart-controls select{width:65px}[_nghost-%COMP%]     .chart-controls label{width:65px}[_nghost-%COMP%]     .chart-container{margin-left:75px}}[_nghost-%COMP%]     #ilmn-tooltip-pop{background-color:#fff;box-shadow:0 .2rem 1.4rem .2rem rgba(0,0,0,.2);color:#464646;cursor:default;display:none;font-size:1.3rem;margin-bottom:-.7rem;min-width:300px;padding:1.5rem;position:absolute;text-align:left;z-index:2147483647}[_nghost-%COMP%]     #ilmn-tooltip-pop ::before{content:\"\";position:absolute}[_nghost-%COMP%]     #ilmn-tooltip-pop .bs-tooltip-heading{max-width:60rem;word-break:break-all}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-content{max-width:60rem;max-height:275px;overflow:auto;padding-right:1rem}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table{table-layout:fixed}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table td.result{overflow:hidden;text-overflow:ellipsis;white-space:pre}[_nghost-%COMP%]     #ilmn-tooltip-pop.biosample-search-fastq-tooltip .tooltip-content{max-width:inherit}", "[_nghost-%COMP%]{display:block;min-height:30rem;position:relative}.card-chart[_ngcontent-%COMP%]{margin-top:2rem;min-height:30rem;position:relative}.card-chart__loader[_ngcontent-%COMP%]{position:absolute;min-width:100%;top:0;bottom:0}.card-chart__svg-container[_ngcontent-%COMP%]{left:-.8rem;position:relative}"], data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] } });
/*@__PURE__*/ ɵsetClassMetadata(DataByCycleChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-by-cycle-chart",
                templateUrl: "./data-by-cycle-chart.component.html",
                styleUrls: [
                    "../../../charts/basespace.charts.scss",
                    "./data-by-cycle-chart.component.scss",
                ],
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: ChartsService }, { type: AbbreviateLargeNumberPipe }]; }, { hideOptions: [{
            type: Input
        }], containerHeight: [{
            type: Input
        }], plotOptions: [{
            type: Input
        }], fixScale: [{
            type: Input
        }], loadChartData: [{
            type: Output
        }], containerWidth: [{
            type: Input,
            args: ["containerWidth"]
        }], isLoadingOptions: [{
            type: Input
        }], chartDataLoading: [{
            type: Input,
            args: ["isLoadingChart"]
        }], chartData: [{
            type: Input,
            args: ["chartData"]
        }], dateByCycleDataLoadingSpinner: [{
            type: ViewChild,
            args: ["dateByCycleDataLoadingSpinner", { static: true }]
        }], chartContainerRef: [{
            type: ViewChild,
            args: ["chartContainer", { static: false }]
        }] });

const _c0$11 = ["dateByLaneDataLoadingSpinner"];
const _c1$10 = [1, "card-chart"];
const _c2$X = [4, "ngIf"];
const _c3$T = [3, "plotOptions", "chartId", "disabled", "loadChartData", "fixScaleValueChanged"];
const _c4$Q = [1, "card-chart__svg-container", 3, "hidden", "id"];
const _c5$M = ["type", "bar-chart"];
const _c6$K = {};
function DataByLaneChartComponent_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-skeleton", _c5$M);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("@fadeIn", _c6$K);
} }
function DataByLaneChartComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r981 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-chart-options", _c3$T);
    ɵɵlistener("loadChartData", function DataByLaneChartComponent_ng_container_1_Template_lib_chart_options_loadChartData_1_listener($event) { ɵɵrestoreView(_r981); const ctx_r980 = ɵɵnextContext(); return ctx_r980.onloadChartData($event); });
    ɵɵlistener("fixScaleValueChanged", function DataByLaneChartComponent_ng_container_1_Template_lib_chart_options_fixScaleValueChanged_1_listener($event) { ɵɵrestoreView(_r981); const ctx_r982 = ɵɵnextContext(); return ctx_r982.onFixScaleChanged($event); });
    ɵɵelementEnd();
    ɵɵelement(2, "div", _c4$Q);
    ɵɵtemplate(3, DataByLaneChartComponent_ng_container_1_div_3_Template, 2, 1, "div", _c2$X);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r978 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("plotOptions", ctx_r978.plotOptions)("chartId", ctx_r978.chartId)("disabled", ctx_r978.chartDataLoading);
    ɵɵselect(2);
    ɵɵpropertyInterpolate("id", ctx_r978.chartId);
    ɵɵproperty("hidden", ctx_r978.chartDataLoading);
    ɵɵselect(3);
    ɵɵproperty("ngIf", ctx_r978.chartDataLoading);
} }
class DataByLaneChartComponent {
    constructor(chartsService) {
        this.chartsService = chartsService;
        this.chartId = "data-by-lane";
        this.subs = new SubSink();
        this.activeWrapper = false;
        this.hideOptions = false;
        this.plotOptions = null;
        this.fixScale = false;
        this.loadChartData = new EventEmitter();
        this.isLoadingOptions = false;
        this.formControlInputValues = this.chartsService.buildNewFormControlObj();
    }
    get containerWidth() {
        return this._containerWidth;
    }
    set containerWidth(containerWidth) {
        const originalValue = this._containerWidth;
        this._containerWidth = containerWidth;
        if (this._containerWidth != null && originalValue != containerWidth) {
            this.onUpdateChartData(this.containerWidth);
        }
    }
    get chartDataLoading() {
        return this._chartDataLoading;
    }
    set chartDataLoading(data) {
        this._chartDataLoading = data;
    }
    get chartData() {
        return this._chartData;
    }
    /*
    below will get called when ever the Chart Response is
    passed in by the parent component
    */
    set chartData(data) {
        this._chartData = data;
        if (this._chartData != null) {
            this.loadChart();
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    ngOnInit() { }
    onloadChartData(selectedFormInputValues) {
        this.loadChartData.emit(selectedFormInputValues);
    }
    onFixScaleChanged(selectedFormInputValues) {
        this.fixScale = selectedFormInputValues.FixScale;
        this.fixScaleAxes = this.currentChartAxes;
        if (!this.fixScale) {
            this.fixScaleAxes = null;
        }
        this.onloadChartData(selectedFormInputValues);
    }
    //Expand chart subpane
    onUpdateChartData(containerWidth) {
        if (this.chart) {
            this.chartsService.updateChart(this.chart, containerWidth, this.containerHeight, this._chartData, this.hideOptions);
        }
    }
    loadChart() {
        const chartData = this._chartData;
        const chartExist = !!this.chart;
        this.currentChartAxes = chartData.Axes;
        chartData.Axes = this.fixScaleAxes
            ? this.fixScaleAxes
            : this.currentChartAxes;
        if (chartExist) {
            this.chartsService.updateChart(this.chart, this.containerWidth, this.containerHeight, chartData, this.hideOptions);
        }
        else {
            this.createChart();
        }
    }
    createChart() {
        const chartConfig = {
            chartContainerSelector: `#${this.chartId}`,
            chartClipPathIdSelector: `#${this.chartId}-clip-path`,
            preserveAspectRatio: "none",
            transitionSpeed: 250,
            width: this.containerWidth,
            height: this.containerHeight,
            xAxis: {
                tickFormat: d3.format("d"),
            },
            yAxis: {
                tickFormat: d3.format(".2f"),
            },
        };
        // create (d3) chart
        this.chart = new CandleStickChart(this._chartData, chartConfig);
    }
}
/** @nocollapse */ DataByLaneChartComponent.ngComponentDef = ɵɵdefineComponent({ type: DataByLaneChartComponent, selectors: [["lib-data-by-lane-chart"]], factory: function DataByLaneChartComponent_Factory(t) { return new (t || DataByLaneChartComponent)(ɵɵdirectiveInject(ChartsService)); }, viewQuery: function DataByLaneChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$11, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.dateByLaneDataLoadingSpinner = _t.first);
    } }, inputs: { hideOptions: "hideOptions", containerHeight: "containerHeight", plotOptions: "plotOptions", fixScale: "fixScale", containerWidth: "containerWidth", isLoadingOptions: "isLoadingOptions", chartDataLoading: ["isLoadingChart", "chartDataLoading"], chartData: "chartData" }, outputs: { loadChartData: "loadChartData" }, consts: 2, vars: 1, template: function DataByLaneChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$10);
        ɵɵtemplate(1, DataByLaneChartComponent_ng_container_1_Template, 4, 6, "ng-container", _c2$X);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.hideOptions && !ctx.isLoadingOptions);
    } }, directives: [NgIf, ChartOptionsComponent, SkeletonComponent], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]     .chart-container{padding:0}[_nghost-%COMP%]     .chart-container.tall{height:530px}[_nghost-%COMP%]     .svg-chart-container{width:auto;height:600px}[_nghost-%COMP%]     .svg-chart-container-vertical{height:600px;width:350px}[_nghost-%COMP%]     .flowcell-chart-container .loading{width:auto;height:auto}[_nghost-%COMP%]     rect{-webkit-transition:opacity .25s;transition:opacity .25s;opacity:1}[_nghost-%COMP%]     .axis line{fill:none;stroke:#666;stroke-width:1}[_nghost-%COMP%]     .axis text{font-family:sans-serif;font-size:11px}[_nghost-%COMP%]     .axis .domain{fill:none;stroke:#666}[_nghost-%COMP%]     .heat-axis g:last-of-type text{content:\"% of Max\";font-weight:700}[_nghost-%COMP%]     line.center{fill:#fff;stroke:#4a4a4a;stroke-width:1}[_nghost-%COMP%]     line.p50{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ul{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ll{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     rect.box{stroke:#4a4a4a;stroke-width:.33px;cursor:pointer;fill:rgba(132,205,236,.75)}[_nghost-%COMP%]     rect.bar{stroke:#fff;stroke-width:.33px;opacity:.9}[_nghost-%COMP%]     rect.bar:hover{opacity:1;stroke:#000}[_nghost-%COMP%]     rect.lane-cell{stroke:#000;stroke-width:.5}[_nghost-%COMP%]     rect.lane-cell:hover{stroke-width:2}[_nghost-%COMP%]     rect.lane-cell.no-data{opacity:.25}[_nghost-%COMP%]     text{font-family:Helvetica,Arial,sans-serif;fill:#666}[_nghost-%COMP%]     g.black circle{fill:#fff;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.black path{stroke:#333;stroke-width:1}[_nghost-%COMP%]     g.red circle{fill:red;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.red path{stroke:red;stroke-width:1}[_nghost-%COMP%]     g.green circle{fill:green;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.green path{stroke:green;stroke-width:1}[_nghost-%COMP%]     g.blue circle{fill:#00f;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.blue path{stroke:#00f;stroke-width:1}[_nghost-%COMP%]     .linechart path{cursor:pointer;opacity:.66}[_nghost-%COMP%]     .linechart path:hover{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .linechart path.highlighted{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .legend{position:absolute;top:10px;right:15px;background-color:rgba(255,255,255,.75);border:1px solid #efefef;padding:3px;border-radius:10px;min-width:75px;font-size:10px;-webkit-transition:opacity .25s linear;transition:opacity .25s linear}[_nghost-%COMP%]     .legend ul{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     .legend li{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     ul.bases li{float:left;width:14px;height:14px;line-height:12px;text-align:center;list-style:none;margin:0 0 0 10px;padding-left:0;font-weight:700;font-family:monospace}[_nghost-%COMP%]     ul.bases li.red{color:red}[_nghost-%COMP%]     ul.bases li.red:hover{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.red.highlighted{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.green{color:green}[_nghost-%COMP%]     ul.bases li.green:hover{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.green.highlighted{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.black{color:#000}[_nghost-%COMP%]     ul.bases li.black:hover{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.black.highlighted{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.blue{color:#00f}[_nghost-%COMP%]     ul.bases li.blue:hover{background-color:#00f;color:#fff}[_nghost-%COMP%]     ul.bases li.blue.highlighted{background-color:#00f;color:#fff}[_nghost-%COMP%]     .tick text{font-size:10px}[_nghost-%COMP%]     text.label{font-size:13px;color:#333}[_nghost-%COMP%]     .tick{stroke:#ccc;stroke-width:.25}[_nghost-%COMP%]     .tick line{stroke:#ccc;stroke-width:.5}[_nghost-%COMP%]     g.axis-x>.tick.major text{font-size:7px}[_nghost-%COMP%]     .bar-label{font-size:9px}[_nghost-%COMP%]     .loading-icon:before{content:url(/public/images/loading-icon.gif);vertical-align:middle}[_nghost-%COMP%]     .chart-image .loading-message{position:absolute;top:50%;left:50%;margin-top:-10px;margin-left:-50px;width:100px;text-align:center;background:rgba(255,255,255,.9);border:1px solid #ccc;box-shadow:0 0 10px #999;padding:3px 6px;border-radius:4px;font-size:10px}[_nghost-%COMP%]     .charts-thumb{height:245px;width:auto;position:relative}[_nghost-%COMP%]     .widget.maximized{position:absolute;left:0;top:0;z-index:1}@media all and (max-width:960px){[_nghost-%COMP%]     .chart-controls select{width:65px}[_nghost-%COMP%]     .chart-controls label{width:65px}[_nghost-%COMP%]     .chart-container{margin-left:75px}}[_nghost-%COMP%]     #ilmn-tooltip-pop{background-color:#fff;box-shadow:0 .2rem 1.4rem .2rem rgba(0,0,0,.2);color:#464646;cursor:default;display:none;font-size:1.3rem;margin-bottom:-.7rem;min-width:300px;padding:1.5rem;position:absolute;text-align:left;z-index:2147483647}[_nghost-%COMP%]     #ilmn-tooltip-pop ::before{content:\"\";position:absolute}[_nghost-%COMP%]     #ilmn-tooltip-pop .bs-tooltip-heading{max-width:60rem;word-break:break-all}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-content{max-width:60rem;max-height:275px;overflow:auto;padding-right:1rem}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table{table-layout:fixed}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table td.result{overflow:hidden;text-overflow:ellipsis;white-space:pre}[_nghost-%COMP%]     #ilmn-tooltip-pop.biosample-search-fastq-tooltip .tooltip-content{max-width:inherit}", "[_nghost-%COMP%]{display:block;min-height:30rem;position:relative}.card-chart[_ngcontent-%COMP%]{margin-top:2rem;min-height:30rem;position:relative}.card-chart__loader[_ngcontent-%COMP%]{position:absolute;min-width:100%;top:0;bottom:0}.card-chart__svg-container[_ngcontent-%COMP%]{left:-.8rem;position:relative}"], data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] } });
/*@__PURE__*/ ɵsetClassMetadata(DataByLaneChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-data-by-lane-chart",
                templateUrl: "./data-by-lane-chart.component.html",
                styleUrls: [
                    "../../../charts/basespace.charts.scss",
                    "./data-by-lane-chart.component.scss",
                ],
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: ChartsService }]; }, { hideOptions: [{
            type: Input
        }], containerHeight: [{
            type: Input
        }], plotOptions: [{
            type: Input
        }], fixScale: [{
            type: Input
        }], loadChartData: [{
            type: Output
        }], containerWidth: [{
            type: Input,
            args: ["containerWidth"]
        }], isLoadingOptions: [{
            type: Input
        }], chartDataLoading: [{
            type: Input,
            args: ["isLoadingChart"]
        }], chartData: [{
            type: Input,
            args: ["chartData"]
        }], dateByLaneDataLoadingSpinner: [{
            type: ViewChild,
            args: ["dateByLaneDataLoadingSpinner", { static: true }]
        }] });

class HeatmapChart extends Chart {
    // *****************************************************
    constructor(responseData, customConfig) {
        super(responseData, merge({}, {
            margins: { right: 15, left: 100 }
        }, customConfig));
        this.showDefaultAxes = true;
        this.laneHorizontalSpacing = 7;
        //this.initScales();
        ////this.addGradients();
        //this.render();
        //this.addAxes();
        this.update(responseData);
        //this.postRender();
    }
    update(updatedData, updatedSettings) {
        super.update(updatedData, updatedSettings);
        if (this.defs == null) {
            this.defs = this.svg.append('defs');
            var referenceGradient = this.defs.append('linearGradient')
                .attr('id', 'reference-gradient')
                .attr('x1', '0%')
                .attr('x2', '0%')
                .attr('y1', '100%')
                .attr('y2', '0%');
            referenceGradient.selectAll('stop').data(this.colorScaleDomain)
                .enter()
                .append('stop')
                .attr('offset', (d, i) => { return d * 100 + "%"; })
                .attr('style', (d, i) => { return "stop-color: " + this.colorScaleRange[i] + "; stop-opacity:1"; });
        }
        var gradients = this.defs.selectAll('.heatmap-gradient').data(this.responseData.Data);
        gradients.enter().append('linearGradient')
            .attr('class', 'heatmap-gradient')
            .attr('id', (d, i) => { return 'heatmap-gradient-' + i; })
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('y1', '100%')
            .attr('y2', '0%');
        gradients
            .attr('class', 'heatmap-gradient')
            .attr('id', (d, i) => { return 'heatmap-gradient-' + i; })
            .transition().duration(this.config.transitionSpeed)
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('y1', '100%')
            .attr('y2', '0%');
        gradients.exit().remove();
        var getColorStops = (data, index) => {
            var lastVal = -1;
            var colorStopArr = [];
            for (var i = 0; i < data.length; i++) {
                var val = data[i];
                if (val != lastVal) {
                    //if (lastVal != -1) {
                    //   colorStopArr.push([i-1, lastVal]);
                    //}
                    colorStopArr.push([i, val]);
                }
                lastVal = val;
            }
            return colorStopArr;
        };
        var setColorStyle = (data, index) => {
            var color = this.colorScale(data);
            return "stop-color:" + color + ";stop-opacity: 1;";
        };
        var setColorOffset = (data, index) => {
            var offset = this.gradientOffsetScale(index);
            return offset + "%";
        };
        var stops = gradients.selectAll('stop').data(getColorStops);
        stops.enter().append('stop')
            .attr('offset', (d, i) => { return setColorOffset(d[1], d[0]); })
            .attr('style', (d, i) => { return setColorStyle(d[1], d[0]); });
        stops.exit().remove();
        stops
            .attr('offset', (d, i) => { return setColorOffset(d[1], d[0]); })
            .attr('style', (d, i) => { return setColorStyle(d[1], d[0]); });
        // ****************************
        var colWidth = (this.config.width - (this.config.margins.left + this.config.margins.right)) / this.responseData.Data.length;
        var colHeight = Math.floor(this.config.height - (this.config.margins.top + this.config.margins.bottom));
        var g = this.svg.selectAll('g.heatmap').data([this.responseData.Data]);
        g.enter().insert('g', ':first-child')
            .attr('class', 'heatmap');
        g.exit().remove();
        var rects = g.selectAll('rect').data((d) => { return d; });
        rects.enter()
            .append('rect')
            .attr('fill', (d, i) => { return "url(#heatmap-gradient-" + i + ")"; })
            .attr('stroke', '0')
            .attr('stroke-width', '0')
            .attr('x', (d, i) => { return this.scaleX(i); })
            .attr('width', colWidth)
            .attr('y', this.config.margins.top)
            .attr('height', colHeight);
        rects.exit().remove();
        rects
            .attr('fill', (d, i) => { return "url(#heatmap-gradient-" + i + ")"; })
            .attr('x', (d, i) => { return this.scaleX(i); })
            .attr('width', colWidth)
            .attr('y', this.config.margins.top)
            .attr('height', colHeight);
    }
    /** Override chart core's update axes  */
    updateAxes() {
        this.svg.selectAll('.axis-x, .axis-y, .heat-axis').remove();
        this.yAxis = d3.svg.axis();
        this.yAxis.scale(this.scaleY);
        this.yAxis.orient('left');
        this.yAxis.tickSize(-(this.config.width - (this.config.margins.left + this.config.margins.right)), 0, -(this.config.width - (this.config.margins.left + this.config.margins.right)));
        this.yAxis.tickSubdivide(1);
        this.svg.append('g').attr('transform', 'translate(' + (this.config.margins.left) + ', 0)').attr('class', 'axis-y').call(this.yAxis);
        this.xAxis = d3.svg.axis();
        this.xAxis.scale(this.scaleX);
        this.xAxis.orient('bottom');
        this.xAxis.tickSubdivide(1);
        this.xAxis.tickSize(-(this.config.height - (this.config.margins.top + this.config.margins.bottom)), 0, -(this.config.height - (this.config.margins.top + this.config.margins.bottom)));
        this.svg.append('g').attr('transform', 'translate(0, ' + (this.config.height - this.config.margins.bottom) + ')').attr('class', 'axis-x').call(this.xAxis);
        this.heatAxis = d3.svg.axis();
        this.heatAxis.scale(this.heatScale);
        this.heatAxis.orient('right');
        this.heatAxis.ticks(4);
        var heatAxisGroup = this.svg.append('g')
            .attr('class', 'heat-axis')
            .attr('transform', 'translate(' + HeatmapChart.HeatxAxis_Translate_Position + ', 0)');
        this.svg.select('heatmap').attr('transform', 'translate(' + (this.config.width - HeatmapChart.HeatxAxis_Translate_Position) + ', 0)');
        heatAxisGroup.call(this.heatAxis);
        document.querySelector('.heat-axis g:last-of-type text').textContent = '% of Max';
        heatAxisGroup.insert('rect', ':first-child')
            .attr('class', 'axis-reference-gradient')
            .attr('x', -10)
            .attr('y', this.config.margins.top)
            .attr('width', 15)
            .attr('height', (this.config.height - (this.config.margins.top + this.config.margins.bottom)))
            .attr('fill', 'url(#reference-gradient)');
        this.svg.selectAll('.axis-x .domain, .axis-y .domain, .heat-axis .domain').remove();
        this.svg.select('.axis-y')
            .append('text')
            .attr('class', 'label')
            .attr('y', 0)
            .attr('x', 0)
            .attr('text-anchor', 'middle')
            // translate to the center of the y-axis not the svg
            .attr('transform', 'rotate(-90 0 0), translate(' + (-(this.config.height - this.config.margins.top - this.config.margins.bottom) / 2 - this.config.margins.top) + ', ' + (-this.config.margins.left + 65) + ')')
            .text(this.responseData.Axes.Y.Title);
        this.svg.select('.axis-x')
            .append('text')
            .attr('class', 'label')
            .attr('y', 0)
            .attr('x', 0)
            .attr('text-anchor', 'middle') // so long x label will be properly centered
            // translate to the center of the x-axis not the svg
            .attr('transform', 'translate(' + ((this.config.width - this.config.margins.left - this.config.margins.right) / 2 + this.config.margins.left) + ', ' + (this.config.margins.bottom - 20) + ')')
            .text(this.responseData.Axes.X.Title);
    }
    updateScales() {
        this.colorScaleRange = ["white", "green", "yellow", "red"];
        this.colorScaleDomain = [0, 0.33, 0.66, 1];
        this.scaleX = d3.scale.linear();
        this.scaleX.domain([this.responseData.Axes.X.Min, this.responseData.Axes.X.Max]);
        this.scaleX.range([0 + this.config.margins.left, this.config.width - this.config.margins.right]);
        this.scaleY = d3.scale.linear();
        this.scaleY.domain([this.responseData.Axes.Y.Min, this.responseData.Axes.Y.Max]);
        this.scaleY.range([this.config.height - this.config.margins.bottom, this.config.margins.top]);
        this.heatScale = d3.scale.linear();
        this.heatScale.domain([0, 100]);
        this.heatScale.range([this.config.height - this.config.margins.bottom, this.config.margins.top]);
        this.gradientOffsetScale = d3.scale.linear();
        this.gradientOffsetScale.domain([0, this.responseData.Data.length ? this.responseData.Data[0].length : 0]);
        this.gradientOffsetScale.range([0, 100]);
        this.colorScale = d3.scale.linear().domain([0, 100]);
        this.colorScale.domain(this.colorScaleDomain.map(this.colorScale.invert));
        this.colorScale.range(this.colorScaleRange);
    }
}
HeatmapChart.CHART_NAME = "Heatmap";
HeatmapChart.HeatxAxis_Translate_Position = 20;

const _c0$12 = ["qscoreHeatmapDataLoadingSpinner"];
const _c1$11 = [1, "card-chart"];
const _c2$Y = [4, "ngIf"];
const _c3$U = [3, "plotOptions", "chartId", "disabled", "loadChartData", "fixScaleValueChanged"];
const _c4$R = [1, "card-chart__svg-container", 3, "hidden", "id"];
const _c5$N = ["chartContainer", ""];
const _c6$L = ["type", "bar-chart"];
const _c7$H = {};
function QscoreHeatmapChartComponent_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "lib-skeleton", _c6$L);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵselect(1);
    ɵɵproperty("@fadeIn", _c7$H);
} }
function QscoreHeatmapChartComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r987 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "lib-chart-options", _c3$U);
    ɵɵlistener("loadChartData", function QscoreHeatmapChartComponent_ng_container_1_Template_lib_chart_options_loadChartData_1_listener($event) { ɵɵrestoreView(_r987); const ctx_r986 = ɵɵnextContext(); return ctx_r986.onloadChartData($event); });
    ɵɵlistener("fixScaleValueChanged", function QscoreHeatmapChartComponent_ng_container_1_Template_lib_chart_options_fixScaleValueChanged_1_listener($event) { ɵɵrestoreView(_r987); const ctx_r988 = ɵɵnextContext(); return ctx_r988.onFixScaleChanged($event); });
    ɵɵelementEnd();
    ɵɵelement(2, "div", _c4$R, _c5$N);
    ɵɵtemplate(4, QscoreHeatmapChartComponent_ng_container_1_div_4_Template, 2, 1, "div", _c2$Y);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r983 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("plotOptions", ctx_r983.plotOptions)("chartId", ctx_r983.chartId)("disabled", ctx_r983.chartDataLoading);
    ɵɵselect(2);
    ɵɵpropertyInterpolate("id", ctx_r983.chartId);
    ɵɵproperty("hidden", ctx_r983.chartDataLoading);
    ɵɵselect(4);
    ɵɵproperty("ngIf", ctx_r983.chartDataLoading);
} }
class QscoreHeatmapChartComponent {
    constructor(chartsService) {
        this.chartsService = chartsService;
        this.chartId = "qscore-heatmap";
        this.subs = new SubSink();
        this.activeWrapper = false;
        this.hideOptions = false;
        this.plotOptions = null;
        this.fixScale = false;
        this.loadChartData = new EventEmitter();
        this.isLoadingOptions = false;
        this.formControlInputValues = this.chartsService.buildNewFormControlObj();
    }
    get containerWidth() {
        return this._containerWidth;
    }
    set containerWidth(containerWidth) {
        const originalValue = this._containerWidth;
        this._containerWidth = containerWidth;
        if (this._containerWidth != null && originalValue != containerWidth) {
            this.onUpdateChartData(this.containerWidth);
        }
    }
    get chartDataLoading() {
        return this._chartDataLoading;
    }
    set chartDataLoading(data) {
        this._chartDataLoading = data;
    }
    get chartData() {
        return this._chartData;
    }
    /*
    bellow will get called when ever the Chart Response is
    passed in by the parent component
    */
    set chartData(data) {
        this._chartData = data;
        if (this._chartData != null) {
            this.loadChart();
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    ngOnInit() { }
    onloadChartData(selectedFormInputValues) {
        this.loadChartData.emit(selectedFormInputValues);
    }
    onFixScaleChanged(selectedFormInputValues) {
        this.fixScale = selectedFormInputValues.FixScale;
        this.fixScaleAxes = this.currentChartAxes;
        if (!this.fixScale) {
            this.fixScaleAxes = null;
        }
        this.onloadChartData(selectedFormInputValues);
    }
    //Expand chart subpane
    onUpdateChartData(containerWidth) {
        if (this.chart) {
            this.chartsService.updateChart(this.chart, containerWidth, this.containerHeight, this._chartData, this.hideOptions);
        }
    }
    loadChart() {
        const chartData = this._chartData;
        const chartExist = !!this.chart;
        this.currentChartAxes = chartData.Axes;
        chartData.Axes = this.fixScaleAxes
            ? this.fixScaleAxes
            : this.currentChartAxes;
        if (chartExist) {
            this.chartsService.updateChart(this.chart, this.containerWidth, this.containerHeight, chartData, this.hideOptions);
        }
        else {
            this.createChart();
        }
    }
    createChart() {
        // format x tick values to be whole numbers
        let xTickValues = [];
        for (var i = 0; i <= this._chartData.Axes.X.Max; i++) {
            xTickValues[i] = i;
        }
        const chartConfig = {
            chartContainerSelector: `#${this.chartId}`,
            preserveAspectRatio: "none",
            transitionSpeed: 250,
            width: this.containerWidth,
            height: this.containerHeight,
            xAxis: { tickValues: xTickValues },
        };
        // create (d3) chart
        this.chart = new HeatmapChart(this._chartData, chartConfig);
    }
}
/** @nocollapse */ QscoreHeatmapChartComponent.ngComponentDef = ɵɵdefineComponent({ type: QscoreHeatmapChartComponent, selectors: [["lib-qscore-heatmap-chart"]], factory: function QscoreHeatmapChartComponent_Factory(t) { return new (t || QscoreHeatmapChartComponent)(ɵɵdirectiveInject(ChartsService)); }, viewQuery: function QscoreHeatmapChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$12, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh((_t = ɵɵloadViewQuery())) && (ctx.qscoreHeatmapDataLoadingSpinner = _t.first);
    } }, inputs: { hideOptions: "hideOptions", containerHeight: "containerHeight", plotOptions: "plotOptions", fixScale: "fixScale", containerWidth: "containerWidth", isLoadingOptions: "isLoadingOptions", chartDataLoading: ["isLoadingChart", "chartDataLoading"], chartData: "chartData" }, outputs: { loadChartData: "loadChartData" }, consts: 2, vars: 1, template: function QscoreHeatmapChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", _c1$11);
        ɵɵtemplate(1, QscoreHeatmapChartComponent_ng_container_1_Template, 5, 6, "ng-container", _c2$Y);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(1);
        ɵɵproperty("ngIf", !ctx.hideOptions && !ctx.isLoadingOptions);
    } }, directives: [NgIf, ChartOptionsComponent, SkeletonComponent], styles: ["body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}[_nghost-%COMP%]     .chart-container{padding:0}[_nghost-%COMP%]     .chart-container.tall{height:530px}[_nghost-%COMP%]     .svg-chart-container{width:auto;height:600px}[_nghost-%COMP%]     .svg-chart-container-vertical{height:600px;width:350px}[_nghost-%COMP%]     .flowcell-chart-container .loading{width:auto;height:auto}[_nghost-%COMP%]     rect{-webkit-transition:opacity .25s;transition:opacity .25s;opacity:1}[_nghost-%COMP%]     .axis line{fill:none;stroke:#666;stroke-width:1}[_nghost-%COMP%]     .axis text{font-family:sans-serif;font-size:11px}[_nghost-%COMP%]     .axis .domain{fill:none;stroke:#666}[_nghost-%COMP%]     .heat-axis g:last-of-type text{content:\"% of Max\";font-weight:700}[_nghost-%COMP%]     line.center{fill:#fff;stroke:#4a4a4a;stroke-width:1}[_nghost-%COMP%]     line.p50{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ul{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     line.ll{fill:#fff;stroke:#4a4a4a;stroke-width:2}[_nghost-%COMP%]     rect.box{stroke:#4a4a4a;stroke-width:.33px;cursor:pointer;fill:rgba(132,205,236,.75)}[_nghost-%COMP%]     rect.bar{stroke:#fff;stroke-width:.33px;opacity:.9}[_nghost-%COMP%]     rect.bar:hover{opacity:1;stroke:#000}[_nghost-%COMP%]     rect.lane-cell{stroke:#000;stroke-width:.5}[_nghost-%COMP%]     rect.lane-cell:hover{stroke-width:2}[_nghost-%COMP%]     rect.lane-cell.no-data{opacity:.25}[_nghost-%COMP%]     text{font-family:Helvetica,Arial,sans-serif;fill:#666}[_nghost-%COMP%]     g.black circle{fill:#fff;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.black path{stroke:#333;stroke-width:1}[_nghost-%COMP%]     g.red circle{fill:red;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.red path{stroke:red;stroke-width:1}[_nghost-%COMP%]     g.green circle{fill:green;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.green path{stroke:green;stroke-width:1}[_nghost-%COMP%]     g.blue circle{fill:#00f;stroke-width:.5;stroke:#333}[_nghost-%COMP%]     g.blue path{stroke:#00f;stroke-width:1}[_nghost-%COMP%]     .linechart path{cursor:pointer;opacity:.66}[_nghost-%COMP%]     .linechart path:hover{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .linechart path.highlighted{opacity:1;stroke-width:1.5}[_nghost-%COMP%]     .legend{position:absolute;top:10px;right:15px;background-color:rgba(255,255,255,.75);border:1px solid #efefef;padding:3px;border-radius:10px;min-width:75px;font-size:10px;-webkit-transition:opacity .25s linear;transition:opacity .25s linear}[_nghost-%COMP%]     .legend ul{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     .legend li{list-style:none;padding:0;margin:0}[_nghost-%COMP%]     ul.bases li{float:left;width:14px;height:14px;line-height:12px;text-align:center;list-style:none;margin:0 0 0 10px;padding-left:0;font-weight:700;font-family:monospace}[_nghost-%COMP%]     ul.bases li.red{color:red}[_nghost-%COMP%]     ul.bases li.red:hover{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.red.highlighted{background-color:red;color:#fff}[_nghost-%COMP%]     ul.bases li.green{color:green}[_nghost-%COMP%]     ul.bases li.green:hover{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.green.highlighted{background-color:green;color:#fff}[_nghost-%COMP%]     ul.bases li.black{color:#000}[_nghost-%COMP%]     ul.bases li.black:hover{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.black.highlighted{background-color:#000;color:#fff}[_nghost-%COMP%]     ul.bases li.blue{color:#00f}[_nghost-%COMP%]     ul.bases li.blue:hover{background-color:#00f;color:#fff}[_nghost-%COMP%]     ul.bases li.blue.highlighted{background-color:#00f;color:#fff}[_nghost-%COMP%]     .tick text{font-size:10px}[_nghost-%COMP%]     text.label{font-size:13px;color:#333}[_nghost-%COMP%]     .tick{stroke:#ccc;stroke-width:.25}[_nghost-%COMP%]     .tick line{stroke:#ccc;stroke-width:.5}[_nghost-%COMP%]     g.axis-x>.tick.major text{font-size:7px}[_nghost-%COMP%]     .bar-label{font-size:9px}[_nghost-%COMP%]     .loading-icon:before{content:url(/public/images/loading-icon.gif);vertical-align:middle}[_nghost-%COMP%]     .chart-image .loading-message{position:absolute;top:50%;left:50%;margin-top:-10px;margin-left:-50px;width:100px;text-align:center;background:rgba(255,255,255,.9);border:1px solid #ccc;box-shadow:0 0 10px #999;padding:3px 6px;border-radius:4px;font-size:10px}[_nghost-%COMP%]     .charts-thumb{height:245px;width:auto;position:relative}[_nghost-%COMP%]     .widget.maximized{position:absolute;left:0;top:0;z-index:1}@media all and (max-width:960px){[_nghost-%COMP%]     .chart-controls select{width:65px}[_nghost-%COMP%]     .chart-controls label{width:65px}[_nghost-%COMP%]     .chart-container{margin-left:75px}}[_nghost-%COMP%]     #ilmn-tooltip-pop{background-color:#fff;box-shadow:0 .2rem 1.4rem .2rem rgba(0,0,0,.2);color:#464646;cursor:default;display:none;font-size:1.3rem;margin-bottom:-.7rem;min-width:300px;padding:1.5rem;position:absolute;text-align:left;z-index:2147483647}[_nghost-%COMP%]     #ilmn-tooltip-pop ::before{content:\"\";position:absolute}[_nghost-%COMP%]     #ilmn-tooltip-pop .bs-tooltip-heading{max-width:60rem;word-break:break-all}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-content{max-width:60rem;max-height:275px;overflow:auto;padding-right:1rem}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table{table-layout:fixed}[_nghost-%COMP%]     #ilmn-tooltip-pop .tooltip-table td.result{overflow:hidden;text-overflow:ellipsis;white-space:pre}[_nghost-%COMP%]     #ilmn-tooltip-pop.biosample-search-fastq-tooltip .tooltip-content{max-width:inherit}", "[_nghost-%COMP%]{display:block;min-height:30rem;position:relative}.card-chart[_ngcontent-%COMP%]{margin-top:2rem;min-height:30rem;position:relative}.card-chart__loader[_ngcontent-%COMP%]{position:absolute;min-width:100%;top:0;bottom:0}.card-chart__svg-container[_ngcontent-%COMP%]{left:-.8rem;position:relative}"], data: { animation: [
            trigger("fadeIn", fadeIn()),
            trigger("fadeOut", fadeOut())
        ] } });
/*@__PURE__*/ ɵsetClassMetadata(QscoreHeatmapChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-qscore-heatmap-chart",
                templateUrl: "./qscore-heatmap-chart.component.html",
                styleUrls: [
                    "../../../charts/basespace.charts.scss",
                    "./qscore-heatmap-chart.component.scss",
                ],
                animations: [
                    trigger("fadeIn", fadeIn()),
                    trigger("fadeOut", fadeOut())
                ]
            }]
    }], function () { return [{ type: ChartsService }]; }, { hideOptions: [{
            type: Input
        }], containerHeight: [{
            type: Input
        }], plotOptions: [{
            type: Input
        }], fixScale: [{
            type: Input
        }], containerWidth: [{
            type: Input,
            args: ["containerWidth"]
        }], loadChartData: [{
            type: Output
        }], isLoadingOptions: [{
            type: Input
        }], chartDataLoading: [{
            type: Input,
            args: ["isLoadingChart"]
        }], chartData: [{
            type: Input,
            args: ["chartData"]
        }], qscoreHeatmapDataLoadingSpinner: [{
            type: ViewChild,
            args: ["qscoreHeatmapDataLoadingSpinner", { static: true }]
        }] });

const _c0$13 = [1, "chart-card"];
const _c1$12 = [1, "chart-card__header"];
const _c2$Z = ["lib-btn", "", "tertiary", "", "class", "chart-card__expand", 3, "click", 4, "ngIf"];
const _c3$V = ["lib-btn", "", "tertiary", "", 1, "chart-card__expand", 3, "click"];
const _c4$S = ["version", "1.1", "class", "icon-expand__svg", "xmlns", "http://www.w3.org/2000/svg", ":xmlns:xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 16 16", "width", "16", "height", "16", "style", "enable-background: new 0 0 16 16", ":xml:space", "preserve", 4, "ngIf", "ngIfElse"];
const _c5$O = ["expandState", ""];
const _c6$M = ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 16 16", "width", "16", "height", "16", 0, "xml", "space", "preserve", 1, "icon-expand__svg", 2, "enable-background", "new 0 0 16 16"];
const _c7$I = ["id", "purpleGradient", "gradientUnits", "userSpaceOnUse", "x1", "5.4", "y1", "24.6", "x2", "24.2", "y2", "5.8"];
const _c8$G = ["offset", "0", 2, "stop-color", "#4a7cff"];
const _c9$B = ["offset", "1", 2, "stop-color", "#743fff"];
const _c10$y = ["d", "M15,1.3c-0.1-0.1-0.1-0.2-0.3-0.3c-0.1,0-0.1,0-0.2,0h-6C8.2,1,8,1.2,8,1.5S8.2,2,8.5,2h4.8L9.1,6.1C9,6.3,9,6.7,9.1,6.9\n\tC9.2,7,9.4,7,9.5,7s0.3,0,0.4-0.1L14,2.7v4.8C14,7.8,14.2,8,14.5,8S15,7.8,15,7.5v-6C15,1.4,15,1.4,15,1.3z", 1, "icon-expand__path"];
const _c11$v = ["d", "M7.5,14H2.7l4.1-4.1C7,9.7,7,9.3,6.9,9.1S6.3,9,6.1,9.1L2,13.3V8.5C2,8.2,1.8,8,1.5,8S1,8.2,1,8.5v6c0,0.1,0,0.1,0,0.2\n\tc0.1,0.1,0.1,0.2,0.3,0.3c0.1,0,0.1,0,0.2,0h6C7.8,15,8,14.8,8,14.5S7.8,14,7.5,14z", 1, "icon-expand__path"];
function ChartCardComponent_button_3__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c6$M);
    ɵɵelementStart(1, "linearGradient", _c7$I);
    ɵɵelement(2, "stop", _c8$G);
    ɵɵelement(3, "stop", _c9$B);
    ɵɵelementEnd();
    ɵɵelement(4, "path", _c10$y);
    ɵɵelement(5, "path", _c11$v);
    ɵɵelementEnd();
} }
const _c12$t = ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 24 24", "width", "16", "height", "16", 0, "xml", "space", "preserve", 1, "icon-expand__svg", 2, "enable-background", "new 0 0 24 24"];
const _c13$r = ["d", "M22.7,1.3c-0.4-0.4-1-0.4-1.4,0L15,7.6V3c0-0.6-0.4-1-1-1s-1,0.4-1,1v7c0,0.1,0,0.3,0.1,0.4\n\tc0.1,0.2,0.3,0.4,0.5,0.5C13.7,11,13.9,11,14,11h7c0.6,0,1-0.4,1-1s-0.4-1-1-1h-4.6l6.3-6.3C23.1,2.3,23.1,1.7,22.7,1.3z", 1, "icon-expand__path"];
const _c14$q = ["d", "M10.9,13.6c-0.1-0.2-0.3-0.4-0.5-0.5C10.3,13,10.1,13,10,13H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.6l-6.3,6.3\n\tc-0.4,0.4-0.4,1,0,1.4C1.5,22.9,1.7,23,2,23s0.5-0.1,0.7-0.3L9,16.4V21c0,0.6,0.4,1,1,1s1-0.4,1-1v-7C11,13.9,11,13.7,10.9,13.6z", 1, "icon-expand__path"];
function ChartCardComponent_button_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", _c12$t);
    ɵɵelementStart(1, "linearGradient", _c7$I);
    ɵɵelement(2, "stop", _c8$G);
    ɵɵelement(3, "stop", _c9$B);
    ɵɵelementEnd();
    ɵɵelement(4, "path", _c13$r);
    ɵɵelement(5, "path", _c14$q);
    ɵɵelementEnd();
} }
function ChartCardComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r1057 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", _c3$V);
    ɵɵlistener("click", function ChartCardComponent_button_3_Template_button_click_0_listener($event) { ɵɵrestoreView(_r1057); const ctx_r1056 = ɵɵnextContext(); return ctx_r1056.expandChart(); });
    ɵɵtemplate(1, ChartCardComponent_button_3__svg_svg_1_Template, 6, 0, "svg", _c4$S);
    ɵɵtemplate(2, ChartCardComponent_button_3_ng_template_2_Template, 6, 0, "ng-template", null, _c5$O, ɵɵtemplateRefExtractor);
    ɵɵelementEnd();
} if (rf & 2) {
    const _r1054 = ɵɵreference(3);
    const ctx_r1052 = ɵɵnextContext();
    ɵɵselect(1);
    ɵɵproperty("ngIf", !ctx_r1052.isCardExpanded)("ngIfElse", _r1054);
} }
const _c15$n = [[["slot-header"]], [["slot-chart"]]];
const _c16$l = ["slot-header", "slot-chart"];
class ChartCardComponent {
    constructor() {
        this.isCardExpanded = false;
        this.expandable = false;
        this.expand = new EventEmitter();
    }
    expandChart() {
        // Toggle state and emit state
        this.isCardExpanded = !this.isCardExpanded;
        this.expand.emit(this.isCardExpanded);
    }
}
/** @nocollapse */ ChartCardComponent.ngComponentDef = ɵɵdefineComponent({ type: ChartCardComponent, selectors: [["lib-chart-card"]], factory: function ChartCardComponent_Factory(t) { return new (t || ChartCardComponent)(); }, inputs: { expandable: "expandable" }, outputs: { expand: "expand" }, ngContentSelectors: _c16$l, consts: 5, vars: 1, template: function ChartCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef(_c15$n);
        ɵɵelementStart(0, "div", _c0$13);
        ɵɵelementStart(1, "h2", _c1$12);
        ɵɵprojection(2);
        ɵɵtemplate(3, ChartCardComponent_button_3_Template, 4, 2, "button", _c2$Z);
        ɵɵelementEnd();
        ɵɵprojection(4, 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵselect(3);
        ɵɵproperty("ngIf", ctx.expandable);
    } }, directives: [NgIf, ButtonComponent], styles: [".chart-card__header[_ngcontent-%COMP%], body[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Inter,sans-serif}body[_ngcontent-%COMP%]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[_ngcontent-%COMP%]:root{font-size:62.5%}[_ngcontent-%COMP%]:root   body[_ngcontent-%COMP%]{font-size:1.6rem}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-weight:400;color:#322d32;margin:0}.u-link-not-clickable[_ngcontent-%COMP%]{pointer-events:none;cursor:not-allowed}.chart-card[_ngcontent-%COMP%]{background:#fff;padding:3.5rem;min-width:50rem}.chart-card__header[_ngcontent-%COMP%]{font-size:26px;letter-spacing:.3px;line-height:1.3076923077;font-weight:300;border-bottom:1px solid #d1cfd1;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;padding-bottom:1.2rem}.chart-card__expand[_ngcontent-%COMP%]{padding:1rem}.chart-card__expand[_ngcontent-%COMP%]   .icon-expand__path[_ngcontent-%COMP%]{fill:#656066}.chart-card__expand[_ngcontent-%COMP%]:hover{-webkit-transform:inherit!important;transform:inherit!important}.chart-card__expand[_ngcontent-%COMP%]:hover   .icon-expand__svg[_ngcontent-%COMP%]{height:1.8rem;width:1.8rem}.chart-card__expand[_ngcontent-%COMP%]:hover   .icon-expand__path[_ngcontent-%COMP%]{fill:url(#purpleGradient) #4141ef}"] });
/*@__PURE__*/ ɵsetClassMetadata(ChartCardComponent, [{
        type: Component,
        args: [{
                selector: "lib-chart-card",
                templateUrl: "./chart-card.component.html",
                styleUrls: ["./chart-card.component.scss"],
            }]
    }], function () { return []; }, { expandable: [{
            type: Input
        }], expand: [{
            type: Output
        }] });

class ChartCardModule {
}
/** @nocollapse */ ChartCardModule.ngModuleDef = ɵɵdefineNgModule({ type: ChartCardModule });
/** @nocollapse */ ChartCardModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ChartCardModule_Factory(t) { return new (t || ChartCardModule)(); }, imports: [[CommonModule, ButtonModule]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ChartCardModule, { declarations: [ChartCardComponent], imports: [CommonModule, ButtonModule], exports: [ChartCardComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ChartCardModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ButtonModule],
                declarations: [ChartCardComponent],
                exports: [ChartCardComponent],
            }]
    }], null, null);

class ChartsModule {
}
/** @nocollapse */ ChartsModule.ngModuleDef = ɵɵdefineNgModule({ type: ChartsModule });
/** @nocollapse */ ChartsModule.ngInjectorDef = ɵɵdefineInjector({ factory: function ChartsModule_Factory(t) { return new (t || ChartsModule)(); }, providers: [AbbreviateLargeNumberPipe], imports: [[
            CommonModule,
            SelectModule,
            ButtonModule,
            FormsModule,
            RadioCheckboxModule,
            ProgressIndicatorsModule,
            ChartCardModule,
        ]] });
/*@__PURE__*/ ɵɵsetNgModuleScope(ChartsModule, { declarations: [HistogramChartComponent,
        QScoreDistributionChartComponent,
        ChartOptionsComponent,
        SampleQCChartComponent,
        FlowCellChartComponent,
        DataByCycleChartComponent,
        AbbreviateLargeNumberPipe,
        DataByLaneChartComponent,
        QscoreHeatmapChartComponent], imports: [CommonModule,
        SelectModule,
        ButtonModule,
        FormsModule,
        RadioCheckboxModule,
        ProgressIndicatorsModule,
        ChartCardModule], exports: [HistogramChartComponent,
        QScoreDistributionChartComponent,
        ChartOptionsComponent,
        SampleQCChartComponent,
        FlowCellChartComponent,
        DataByCycleChartComponent,
        DataByLaneChartComponent,
        QscoreHeatmapChartComponent] });
/*@__PURE__*/ ɵsetClassMetadata(ChartsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SelectModule,
                    ButtonModule,
                    FormsModule,
                    RadioCheckboxModule,
                    ProgressIndicatorsModule,
                    ChartCardModule,
                ],
                declarations: [
                    HistogramChartComponent,
                    QScoreDistributionChartComponent,
                    ChartOptionsComponent,
                    SampleQCChartComponent,
                    FlowCellChartComponent,
                    DataByCycleChartComponent,
                    AbbreviateLargeNumberPipe,
                    DataByLaneChartComponent,
                    QscoreHeatmapChartComponent,
                ],
                exports: [
                    HistogramChartComponent,
                    QScoreDistributionChartComponent,
                    ChartOptionsComponent,
                    SampleQCChartComponent,
                    FlowCellChartComponent,
                    DataByCycleChartComponent,
                    DataByLaneChartComponent,
                    QscoreHeatmapChartComponent,
                ],
                providers: [AbbreviateLargeNumberPipe],
            }]
    }], null, null);

/*
 * Public API Surface of comp-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractAppLauncherService, AccordionExpanderComponent, AccordionExpanderModule, ActionToolbarAccessoryType, ActionToolbarComponent, ActionToolbarModule, ActivityCardListComponent, ActivityCardListModule, AppLauncherComponent, AppLauncherModule, AutocompleteFilterPipe, Toast as BannerNotificationsComponent, ToastContainerDirective$1 as BannerNotificationsContainerDirective, ToastContainerModule$1 as BannerNotificationsContainerModule, ToastrModule$1 as BannerNotificationsModule, ToastrService$1 as BannerNotificationsService, BasePortalHost, ButtonComponent, ButtonModule, ChartCardComponent, ChartCardModule, ChartOptionsComponent, ChartsModule, ChooserComponent, ChooserMessageService, ChooserModule, ClickOutsideDirective, ColumnSwitcherComponent, ColumnSwitcherModule, ComponentPortal, DataByCycleChartComponent, DataByLaneChartComponent, DataLoadingStatus, DataTableApiService, DataTableComponent, DataTableModule, DateRangeComponent, DateRangeModule, DefaultGlobalConfig, DefaultNoAnimationsGlobalConfig, DefaultNoComponentGlobalConfig, DndListComponent, DndListModule, DownloadDataComponent, DownloadDataModule, DownloadOutputData, DragAndDropDirective, DropdownComponent, DropdownService, ErrorAlertMessageComponent, ErrorAlertMessageModule, FileBrowserComponent, FileBrowserModule, FilePickerComponent, FilePickerModule, FilePreviewComponent, FilePreviewModule, FlowCellChartComponent, FormFieldsComponent, FormFieldsModule, HistogramChartComponent, HttpProgressModule, IMAGE_FILE_EXTENSIONS, IconButtonComponent, IconButtonModule, InlineSelectComponent, InlineSelectModule, InputComponent, InputModule, KEY_CODE, LibPopoverComponent, LibPopoverModule, MatcherComponent, MatcherModule, MetadataListComponent, MetadataListModule, MetadataTypes, MetricsTableComponent, MetricsTableModule, MultiSelectComponent, MultiSelectModule, NgxSmartModalComponent, NgxSmartModalConfig, NgxSmartModalModule, NgxSmartModalService, NotificationCardComponent, NotificationCardModule, NotificationTypeEnum, NotificationTypeEnumMapping, OptionComponent, Overlay, OverlayContainer, OverlayRef, OverlayScrollbarsService, PDF_FILE_EXTENSIONS, PREVIEW_BYTE_MAX, PROGRESS_CONFIG, PROGRESS_HTTP_CONFIG, PROGRESS_ROUTER_CONFIG, PaginationComponent, PaginationModule, PopoverCellRendererComponent, PopoverCustomTriggerComponent, ProgressComponent, ProgressIndicatorsModule, ProgressModule, ProgressRef, ProgressService, QScoreDistributionChartComponent, QscoreHeatmapChartComponent, RadioCheckboxComponent, RadioCheckboxListComponent, RadioCheckboxListModule, RadioCheckboxModule, RouterProgressModule, SUPPORTED_FILE_TYPES, SampleQCChartComponent, SearchWidgetComponent, SearchWidgetModule, SelectComponent, SelectModule, ShareDataComponent, ShareDataModule, ShareOutputData, SidebarNavigationComponent, SidebarNavigationModule, SkeletonComponent, SkeletonModule, StatusChangeComponent, StatusChangeModule, SuccessInfoMessageComponent, SuccessInfoMessageModule, SwitcherComponent, SwitcherModule, TEXT_FILE_EXTENSIONS, TOAST_CONFIG, TabNavigationComponent, TabNavigationModule, ToastComponent, ToastContainerDirective, ToastContainerModule, ToastInjector, ToastNoAnimation, ToastNoAnimationModule, ToastPackage, ToastRef, ToastrComponentlessModule, ToastrModule, ToastrService, UniversalNavbarComponent, UniversalNavbarModule, fadeIn, fadeOut, getPopoverConfig };
//# sourceMappingURL=bssh-comp-lib.js.map
